/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 174);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(181);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return breakpoints; });
/* unused harmony export FamilyRelationship */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PaymentStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BouncedEmailStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PickListType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PolicyStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BeneficiaryStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BeneficiaryTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ReferralStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdjudicationStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return B2CConfiguration; });
/* unused harmony export emailRegex */
/* unused harmony export postalCodeRegex */
/* unused harmony export NumInchesInFeet */
/* unused harmony export NumCmInInches */
/* unused harmony export ReferralHealthScoreMin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Validation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UtilsBeneficiaries; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_papaparse__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(125);




var breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600
};
var FamilyRelationship = {
    Child: '52866e41fdfae711b9c80028f80bded3',
    Spouse: '53866e41fdfae711b9c80028f80bded3',
    Partner: '54866e41fdfae711b9c80028f80bded3',
    Parent: '55866e41fdfae711b9c80028f80bded3',
    Other: '56866e41fdfae711b9c80028f80bded3'
};
var PaymentStatus = {
    Created: '56b11e964101e811b9c9005056c00008',
    PaymentFailed: '57b11e964101e811b9c9005056c00008',
    PaymentSucceeded: '58b11e964101e811b9c9005056c00008'
};
var BouncedEmailStatus = {
    Resolved: '6ca02d682d17e811b9d20028f80bded3',
    Unresolved: '6da02d682d17e811b9d20028f80bded3'
};
var PickListType = {
    Countries: '122884bda5f1e711b9c70028f80bded3',
    ForeignCountries: '10f482f2a73ee811b9dc0028f80bded3',
    Provinces: 'f52f6166a4f1e711b9c70028f80bded3',
};
var PolicyStatus = {
    Active: '39e9315ede02e811b9c9005056c00008',
    Inactive: '3ae9315ede02e811b9c9005056c00008',
    Canceled: '3be9315ede02e811b9c9005056c00008',
};
var BeneficiaryStatus = {
    Confirmed: 'a7830d925f08e811b9cd0028f80bded3',
    Unconfirmed: 'a8830d925f08e811b9cd0028f80bded3',
    PendingPaperwork: 'a9830d925f08e811b9cd0028f80bded3',
    PendingReceipt: 'aa830d925f08e811b9cd0028f80bded3'
};
var BeneficiaryTypes = {
    Primary: 'ea0bdce7b30e41f48ffbdce43d437497',
    Contingent: 'eb0bdce7b30e41f48ffbdce43d437497',
    Trustee: 'ec0bdce7b30e41f48ffbdce43d437497'
};
var ReferralStatus = {
    ReferralPending: '3a8a89ecb99a42009a59f1c63824a63a',
    PolicyCancelled: '3b8a89ecb99a42009a59f1c63824a63a',
    ReferralApproved: '3c8a89ecb99a42009a59f1c63824a63a'
};
var AdjudicationStatus = {
    Unreviewed: '5a37027166774fd69d20a8790986980e',
    InProcess: '5b37027166774fd69d20a8790986980e',
    Rejected: '5c37027166774fd69d20a8790986980e'
};
var B2CConfiguration = {
    clientID: "8cc382b4-6f39-4c45-a668-f1c66c0d6944",
    authoritySignIn: "https://termlifeb2c.b2clogin.com/tfp/termlifeb2c.onmicrosoft.com/" + "B2C_1_term-life-SiUpIn",
    authoritySignInMultiFactor: "https://termlifeb2c.b2clogin.com/tfp/termlifeb2c.onmicrosoft.com/" + "B2C_1_term-life-SiIn-Multi",
    authoritySignUp: "https://termlifeb2c.b2clogin.com/tfp/termlifeb2c.onmicrosoft.com/" + "B2C_1_term-life-SiUp",
    b2cScopes: "openid".split(','),
    policyNameSignUp: Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://www.insuredbymosaic.ca/api","REACT_APP_B2C_Authority_Reset":"https://termlifeb2c.b2clogin.com/termlifeb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_term-life-PR","REACT_APP_B2C_Authority_Url_Part":"https://termlifeb2c.b2clogin.com/tfp/termlifeb2c.onmicrosoft.com/","REACT_APP_B2C_ClientID":"8cc382b4-6f39-4c45-a668-f1c66c0d6944","REACT_APP_B2C_ResetPwd_PolicyName":"B2C_1_term-life-PR ","REACT_APP_B2C_Scopes":"openid","REACT_APP_B2C_SignIn_MultiFactor_PolicyName":"B2C_1_term-life-SiIn-Multi","REACT_APP_B2C_SignIn_PolicyName":"B2C_1_term-life-SiUpIn","REACT_APP_B2C_SignUp_PolicyName":"B2C_1_term-life-SiUp","REACT_APP_FB_PIXEL_IMG":"https://www.facebook.com/tr?id=2178104785555892&ev=PageView&noscript=1","REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID":"UA-69603114-5","REACT_APP_GOOGLE_OPTIMIZE_ID":"GTM-T7N3DDF","REACT_APP_GOOGLE_TAG_MANAGER_ID":"GTM-5ZFPKPD","REACT_APP_INTERCOM_APP_ID":"vylmnfbs","REACT_APP_STRIPE_PUBLISHABLE_KEY":"pk_live_BvgJpYGyQaqyiqsf8yokDOUd","REACT_APP_TRACK_ANALYTICS":"true","REACT_APP_Version":"1.10.9"}).REACT_APP_B2C_SignUpPolicyName,
    policyNameMultiFactor: "B2C_1_term-life-SiIn-Multi",
    policyNameResetPwd: "B2C_1_term-life-PR ",
};
// tslint:disable
var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var postalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
// tslint:enable
var NumInchesInFeet = 12;
var NumCmInInches = 2.54;
var ReferralHealthScoreMin = 54;
var Validation = /** @class */ (function () {
    function Validation() {
    }
    Validation.validateAge = function (birthDate, isAuthenticated) {
        var d = __WEBPACK_IMPORTED_MODULE_0_moment__(birthDate);
        if (!d.isValid()) {
            return {
                hasError: true,
                message: 'Date is invalid.'
            };
        }
        var age = Utils.getAgeFromBirthdate(birthDate);
        if (isAuthenticated) {
            return {
                hasError: age !== '' && age != null && (age < 18 || age > 54),
                message: 'Age must be 18-54.'
            };
        }
        else {
            return {
                hasError: age !== '' && age != null && (age < 18 || age > 54),
                message: 'Age must be 18-54.'
            };
        }
    };
    Validation.validateEmail = function (email) {
        return {
            hasError: email && !email.match(emailRegex),
            message: 'Email is not valid.'
        };
    };
    Validation.validatePostalCode = function (postalCode, message) {
        return {
            hasError: postalCode && !postalCode.match(postalCodeRegex),
            message: message || 'Postal code is not valid.'
        };
    };
    Validation.validateDate = function (date, format, strict) {
        var d = __WEBPACK_IMPORTED_MODULE_0_moment__(date, format, strict);
        return {
            hasError: !d.isValid(),
            message: !d.isValid() ? 'Date is invalid.' : ''
        };
    };
    Validation.validateRequired = function (fieldName, value) {
        if (value) {
            return {
                hasError: false,
                message: ''
            };
        }
        else {
            return {
                hasError: true,
                message: fieldName + " is required"
            };
        }
    };
    Validation.validateTerm = function (termLength) {
        var isError = termLength === undefined || !(termLength >= 1 && termLength <= 47);
        return {
            hasError: isError,
            // due to some strange CSS causing the rows to shift.
            // this is getting left as ''
            message: '',
        };
    };
    return Validation;
}());

var Utils = /** @class */ (function () {
    function Utils() {
    }
    // tslint:enable
    Utils.formatDate = function (d, format) {
        if (!d) {
            return '';
        }
        return __WEBPACK_IMPORTED_MODULE_0_moment__(d).format(format || 'YYYY-MM-DD');
    };
    Utils.formatDateAsUTC = function (d, format) {
        // this formats a date as utc.  
        // we can use this to ensure that a date only value from the server isn't converted to local time
        if (!d) {
            return '';
        }
        return __WEBPACK_IMPORTED_MODULE_0_moment__(d).utc().format(format || 'YYYY-MM-DD');
    };
    Utils.isValidDate = function (d, format) {
        return __WEBPACK_IMPORTED_MODULE_0_moment__(d, 'YYYY-MM-DD', true).isValid();
    };
    Utils.formatUnixDate = function (d, format) {
        if (!d) {
            return '';
        }
        return __WEBPACK_IMPORTED_MODULE_0_moment__["unix"](d).format(format || 'YYYY-MM-DD');
    };
    Utils.getAgeRoundedFromBirthdate = function (d) {
        if (!d || d.length < 6) {
            return '';
        }
        var ageInDays = __WEBPACK_IMPORTED_MODULE_0_moment__().utc().diff(__WEBPACK_IMPORTED_MODULE_0_moment__(d, 'YYYYMMDD'), 'days', true);
        var daysInYear = 365.2425; // statistical value for 400 years
        var ageInYears = (ageInDays / daysInYear);
        // const momentYear = moment().diff(moment(d, 'YYYYMMDD'), 'years', true);
        return Math.round(ageInYears);
    };
    Utils.getAgeFromBirthdate = function (d) {
        if (!d || d.length < 6) {
            return '';
        }
        return Math.floor(__WEBPACK_IMPORTED_MODULE_0_moment__().diff(__WEBPACK_IMPORTED_MODULE_0_moment__(d, 'YYYYMMDD'), 'years', true));
    };
    Utils.dateStringToDate = function (d) {
        if (__WEBPACK_IMPORTED_MODULE_0_moment__(d, 'YYYY-MM-DD').isValid()) {
            return __WEBPACK_IMPORTED_MODULE_0_moment__(d, 'YYYY-MM-DD').toDate();
        }
        else {
            return null;
        }
    };
    // Note: For datetime passed from server we have to use toDate() when compare dates
    Utils.getDayFromCreatedDate = function (d) {
        if (!d || d.length < 6) {
            return '';
        }
        var createdDate = __WEBPACK_IMPORTED_MODULE_0_moment__(d).toDate();
        return (__WEBPACK_IMPORTED_MODULE_0_moment__().diff(createdDate, 'days'));
    };
    Utils.getPickListItemDescription = function (pickListItemId) {
        if (pickListItemId) {
            var storeState = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState();
            var storePickListItems = storeState.pickList.items;
            var match = storePickListItems.find(function (p) { return p.id === pickListItemId; });
            if (match) {
                return match.description;
            }
        }
        return '';
    };
    Utils.getCategoryInfoByNoteAnswerId = function (answerId) {
        if (answerId) {
            var storeState = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState();
            var storeAnswers = storeState.policy.answers.answerList;
            var storePolicies = storeState.policy.policies;
            var match_1 = storeAnswers.find(function (a) { return a.id === answerId; });
            if (match_1) {
                var matchPolicy = storePolicies.find(function (p) { return p.id === match_1.policyId; });
                if (matchPolicy) {
                    return matchPolicy.number + ' Q' + match_1.categoryId + '.' + match_1.subCategoryId;
                }
            }
        }
        return '';
    };
    Utils.getQuestionTextByAnswer = function (answer) {
        var storeState = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState();
        var storeQuestions = storeState.question.questions;
        var key, keys = Object.keys(storeQuestions);
        var n = keys.length;
        var questionsWithLowercaseNames = {};
        var regex = /<.*?>/gi;
        while (n--) {
            key = keys[n];
            questionsWithLowercaseNames[key.toLowerCase()] = storeQuestions[key].replace(regex, '');
        }
        var match = questionsWithLowercaseNames[answer.replace(/ /g, '').toLowerCase()];
        if (match) {
            return match;
        }
        return '';
    };
    Utils.verifyAnswerHasNotes = function (answerId) {
        if (answerId) {
            var storeState = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState();
            var storeNotes = storeState.user.notes;
            var hasNotes = storeNotes.find(function (n) { return n.answerId === answerId; });
            if (hasNotes) {
                return true;
            }
        }
        return false;
    };
    Utils.forEachPromise = function (items, fn) {
        return items.reduce(function (promise, item) {
            return promise.then(function () {
                return fn(item);
            });
        }, Promise.resolve());
    };
    Utils.isAuthorized = function (hasRoles, rolesRequired) {
        var authorized = false;
        if (hasRoles.indexOf('admin') >= 0 || rolesRequired == null || rolesRequired.length === 0) {
            authorized = true;
        }
        else {
            authorized = hasRoles.some(function (role) {
                return rolesRequired.indexOf(role) >= 0;
            });
        }
        return authorized;
    };
    Utils.parseValueFromEvent = function (e) {
        var value = e.target.value;
        if (e.target.type === 'radio') {
            if (value === 'true') {
                value = true;
            }
            else if (value === 'false') {
                value = false;
            }
        }
        else if (e.target.type === 'checkbox') {
            value = e.target.checked;
        }
        if (e.target.min) {
            value = Math.max(value, e.target.min).toString();
        }
        if (e.target.max) {
            value = Math.min(value, e.target.max).toString();
        }
        return value;
    };
    Utils.downloadCsv = function (data, filename, isCsvFormat) {
        var csv;
        if (isCsvFormat) {
            csv = data;
        }
        else {
            csv = __WEBPACK_IMPORTED_MODULE_2_papaparse__["unparse"](data);
        }
        var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        // IE11 & Edge
        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(csvData, filename);
        }
        else {
            // In FF link must be added to DOM to be clicked
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(csvData);
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };
    // Works similar to C#'s String.Format(). str takes the form of "Hello {0}".
    Utils.formatString = function (str) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return str.replace(/{(\d+)}/g, function (match, num) {
            return typeof args[num] !== 'undefined'
                ? args[num]
                : match;
        });
    };
    Utils.formatFirstUpperCase = function (str) {
        return str.replace(/^\w/, function (c) { return c.toUpperCase(); });
    };
    Utils.toPercent = function (num) {
        var r;
        if (num) {
            r = (num * 100).toFixed(2).toString();
        }
        else {
            r = '0';
        }
        return r + '%';
    };
    Utils.getABTestOptimizeIndex = function () {
        var workflowIndex = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["random"])(0, 1);
        return workflowIndex;
    };
    Utils.getABTestWorkflowUrl = function (optimzeIndex, age, gender) {
        var code = 'A';
        switch (optimzeIndex) {
            case 0:
                code = 'A';
                break;
            case 1:
                code = 'C';
                break;
            default:
                code = 'A';
                break;
        }
        var page = 'select-your-policy';
        if (!age || !gender || age > 54 || age < 18) {
            page = 'about-you';
        }
        else if (code === 'B') {
            page = 'your-needs';
        }
        return "/quote/" + code + "/" + page;
    };
    // tslint:disable
    Utils.generateUUID = function () {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = ((d + Math.random() * 16) % 16) | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
        return uuid;
    };
    Utils.generateCode = function () {
        // Generates a random alphanumeric string of length 6
        return Math.random()
            .toString(36)
            .substr(2, 6);
    };
    // https://gist.github.com/bsara/c60dd6bbb04e0969221f607f0df68716
    Utils.getScrollbarWidth = function () {
        var outer = document.createElement('div');
        var inner = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.width = '100px';
        inner.style.width = '100%';
        outer.appendChild(inner);
        document.body.appendChild(outer);
        var widthWithoutScrollbar = outer.offsetWidth;
        outer.style.overflow = 'scroll';
        var widthWithScrollbar = inner.offsetWidth;
        document.body.removeChild(outer);
        return widthWithoutScrollbar - widthWithScrollbar;
    };
    Utils.debounce = function (fn, delay) {
        if (delay === void 0) { delay = 50; }
        var timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(function () { return fn(); }, delay);
        };
    };
    Utils.disableBodyScrolling = function (args) {
        if (args === void 0) { args = {}; }
        var className = args.className || 'disable-scroll';
        var allBreakpoints = args.allBreakpoints || false;
        document.body.classList.add(className);
        var fixedEls = document.querySelectorAll('[data-adjust-fixed-scrollbar]');
        if ((allBreakpoints || window.innerWidth < breakpoints.xl) && (window.innerHeight < document.body.offsetHeight)) {
            for (var i = 0; i < fixedEls.length; i++) {
                fixedEls[i].style.paddingRight = Utils.getScrollbarWidth() + "px";
            }
        }
    };
    Utils.enableBodyScrolling = function (args) {
        if (args === void 0) { args = {}; }
        var className = args.className || 'disable-scroll';
        document.body.classList.remove(className);
        var fixedEls = document.querySelectorAll('[data-adjust-fixed-scrollbar]');
        for (var i = 0; i < fixedEls.length; i++) {
            fixedEls[i].style.paddingRight = '';
        }
    };
    Utils.formatCurrency = function (value, decimals) {
        if (value == null) {
            return '';
        }
        var formatter = new Intl.NumberFormat('en-CA', {
            style: 'currency',
            currency: 'CAD',
            minimumFractionDigits: decimals === undefined ? 2 : decimals,
            maximumFractionDigits: decimals === undefined ? 2 : decimals,
        });
        return formatter.format(value);
    };
    Utils.formatNumberWithCommas = function (value) {
        if (value == null) {
            return '';
        }
        value = value.toString();
        // Replace all non-digits and non-periods with empty string.
        value = value.replace(/[^\.\d]/g, '');
        // Insert a comma after every 3 digits.
        value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        // Only allow 1 decimal and limit the input to 2 decimal spaces.
        value = value.replace(/^([\d|\,]+\.?\d?\d?)?.*/, '$1');
        return value;
    };
    Utils.getAbbreviatedNumber = function (value) {
        if (value >= 1000000) {
            return value / 1000000 + ' million';
        }
        else if (value >= 1000) {
            return value / 1000 + 'k';
        }
        return value.toString();
    };
    Utils.setDocTitle = function (value) {
        var titleSuffix = 'Mosaic Life';
        if (value) {
            document.title = value + " | " + titleSuffix;
        }
        else {
            document.title = titleSuffix;
        }
    };
    Utils.shouldMarkError = function (error, touched) {
        var hasError = error.hasError;
        var shouldShow = touched;
        return hasError ? shouldShow : false;
    };
    Utils.extractIdToken = function (encodedIdToken) {
        // id token will be decoded to get the username
        var decodedToken = Utils.decodeJwt(encodedIdToken);
        if (!decodedToken) {
            return null;
        }
        try {
            var base64IdToken = decodedToken.JWSPayload;
            var base64Decoded = Utils.base64DecodeStringUrlSafe(base64IdToken);
            if (!base64Decoded) {
                // this._requestContext.logger.info('The returned id_token could not be base64 url safe decoded.');
                return null;
            }
            // ECMA script has JSON built-in support
            return JSON.parse(base64Decoded);
        }
        catch (err) {
            // this._requestContext.logger.error('The returned id_token could not be decoded' + err);
        }
        return null;
    };
    Utils.decodeJwt = function (jwtToken) {
        if (Utils.isEmpty(jwtToken)) {
            return null;
        }
        var idTokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
        var matches = idTokenPartsRegex.exec(jwtToken);
        if (!matches || matches.length < 4) {
            // this._requestContext.logger.warn('The returned id_token is not parseable.');
            return null;
        }
        var crackedToken = {
            header: matches[1],
            JWSPayload: matches[2],
            JWSSig: matches[3]
        };
        return crackedToken;
    };
    Utils.base64DecodeStringUrlSafe = function (base64IdToken) {
        // html5 should support atob function for decoding
        base64IdToken = base64IdToken.replace(/-/g, '+').replace(/_/g, '/');
        if (window.atob) {
            return decodeURIComponent(window.atob(base64IdToken)); // jshint ignore:line
        }
        else {
            return decodeURIComponent(Utils.decode(base64IdToken));
        }
    };
    Utils.decode = function (base64IdToken) {
        var codes = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        base64IdToken = String(base64IdToken).replace(/=+$/, '');
        var length = base64IdToken.length;
        if (length % 4 === 1) {
            throw new Error('The token to be decoded is not correctly encoded.');
        }
        var h1, h2, h3, h4, bits, c1, c2, c3, decoded = '';
        for (var i = 0; i < length; i += 4) {
            // Every 4 base64 encoded character will be converted to 3 byte string, which is 24 bits
            // then 6 bits per base64 encoded character
            h1 = codes.indexOf(base64IdToken.charAt(i));
            h2 = codes.indexOf(base64IdToken.charAt(i + 1));
            h3 = codes.indexOf(base64IdToken.charAt(i + 2));
            h4 = codes.indexOf(base64IdToken.charAt(i + 3));
            // tslint:disable
            // For padding, if last two are '='
            if (i + 2 === length - 1) {
                bits = (h1 << 18) | (h2 << 12) | (h3 << 6);
                c1 = (bits >> 16) & 255;
                c2 = (bits >> 8) & 255;
                decoded += String.fromCharCode(c1, c2);
                break;
            }
            else if (i + 1 === length - 1) {
                bits = (h1 << 18) | (h2 << 12);
                c1 = (bits >> 16) & 255;
                decoded += String.fromCharCode(c1);
                break;
            }
            bits = (h1 << 18) | (h2 << 12) | (h3 << 6) | h4;
            // then convert to 3 byte chars
            c1 = (bits >> 16) & 255;
            c2 = (bits >> 8) & 255;
            c3 = bits & 255;
            // tslint:enable
            decoded += String.fromCharCode(c1, c2, c3);
        }
        return decoded;
    };
    Utils.isEmpty = function (str) {
        return typeof str === 'undefined' || !str || 0 === str.length;
    };
    Utils.getHeightInInches = function (inputHeight, heightUnit, inputHeightft) {
        // inputHeight is either cm/in depending on heightUnit
        // inputHeightft is a separate input field if heightUnit is in
        var height = parseInt(inputHeight, 10);
        // Convert height to inches regardless of whether it is in ft/in or cm
        // to make calculations and conditional checking easier
        if (heightUnit === 'in') {
            var heightft = Math.round(inputHeightft);
            if (heightft) {
                height += heightft * NumInchesInFeet;
            }
        }
        else {
            height /= NumCmInInches;
        }
        return Math.round(height);
    };
    return Utils;
}());
/* harmony default export */ __webpack_exports__["m"] = (Utils);
var UtilsBeneficiaries = /** @class */ (function () {
    function UtilsBeneficiaries() {
    }
    UtilsBeneficiaries.isDisbursementValid = function (beneficiaries) {
        var primaryBeneficiaries = beneficiaries.filter(function (b) { return b.typeId === BeneficiaryTypes.Primary; });
        var primaryDisbursementTotal = primaryBeneficiaries
            .reduce(function (a, b) { return a + parseFloat(b.disbursementPercent || 0); }, 0);
        primaryDisbursementTotal = Math.round(primaryDisbursementTotal * 100) / 100;
        var isPrimariesValid = primaryDisbursementTotal === 1
            || (primaryDisbursementTotal === 0 && primaryBeneficiaries.length === 0);
        var contingentBeneficiaries = beneficiaries.filter(function (b) { return b.typeId === BeneficiaryTypes.Contingent; });
        var contingentDisbursmentTotal = contingentBeneficiaries
            .reduce(function (a, b) { return a + parseFloat(b.disbursementPercent || 0); }, 0);
        contingentDisbursmentTotal = Math.round(contingentDisbursmentTotal * 100) / 100;
        var isContingentValid = contingentDisbursmentTotal === 1
            || (contingentDisbursmentTotal === 0 && contingentBeneficiaries.length === 0);
        return isPrimariesValid && isContingentValid;
    };
    UtilsBeneficiaries.sortPrimaryThenByName = function (a, b) {
        var comparePrimary = function (a1, b1) {
            if (a1.typeId === BeneficiaryTypes.Primary && b1.typeId === BeneficiaryTypes.Contingent) {
                return -1;
            }
            if (b1.typeId === BeneficiaryTypes.Primary && a1.typeId === BeneficiaryTypes.Contingent) {
                return 1;
            }
            return 0;
        };
        var compareFirstName = function (a1, b1) {
            return ('' + a1.firstName).localeCompare('' + b1.firstName);
        };
        return comparePrimary(a, b) || compareFirstName(a, b);
    };
    return UtilsBeneficiaries;
}());



/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable__ = __webpack_require__(245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DataTable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoadingPage__ = __webpack_require__(301);
/* unused harmony reexport LoadingPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Page__ = __webpack_require__(123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Page__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageContent__ = __webpack_require__(348);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__PageContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PageFooter__ = __webpack_require__(135);
/* unused harmony reexport PageFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PageHeader__ = __webpack_require__(353);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__PageHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PageHeaderFullWidth__ = __webpack_require__(354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__PageHeaderFullWidth__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ScrollToTop__ = __webpack_require__(136);
/* unused harmony reexport ScrollToTop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Spinner__ = __webpack_require__(122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__Spinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(355);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9__Table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Tabs__ = __webpack_require__(356);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_10__Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Tooltip__ = __webpack_require__(82);
/* unused harmony reexport Tooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TooltipModal__ = __webpack_require__(362);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__TooltipModal__["a"]; });















/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BirthDatePicker__ = __webpack_require__(423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BirthDatePicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Checkbox__ = __webpack_require__(96);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CheckboxGroup__ = __webpack_require__(435);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__CheckboxGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CheckboxGroupSerialize__ = __webpack_require__(436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__CheckboxGroupSerialize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CountryDropdown__ = __webpack_require__(154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__CountryDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DatePicker__ = __webpack_require__(150);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__DatePicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DropdownInput__ = __webpack_require__(61);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__DropdownInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FamilyRelationshipDropdown__ = __webpack_require__(437);
/* unused harmony reexport FamilyRelationshipDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ForeignCountryDropdown__ = __webpack_require__(438);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__ForeignCountryDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormCheckConditional__ = __webpack_require__(439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__FormCheckConditional__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Label__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__Label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProvinceDropdown__ = __webpack_require__(440);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_11__ProvinceDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RadioGroup__ = __webpack_require__(441);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_12__RadioGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RequiredLabel__ = __webpack_require__(153);
/* unused harmony reexport RequiredLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TableTextInput__ = __webpack_require__(442);
/* unused harmony reexport TableTextInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TextInput__ = __webpack_require__(443);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_15__TextInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TextArea__ = __webpack_require__(444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_16__TextArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ToggleSwitch__ = __webpack_require__(445);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_17__ToggleSwitch__["a"]; });




















/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(16);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IconButton__ = __webpack_require__(357);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__IconButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IconLinkButton__ = __webpack_require__(361);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__IconLinkButton__["a"]; });





/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_react_loader_name_Icon_icon_add_svg__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_react_loader_name_Icon_icon_add_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__svg_react_loader_name_Icon_icon_add_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__svg_react_loader_name_Icon_icon_add_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_react_loader_name_Icon_icon_arrow_down_svg__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_react_loader_name_Icon_icon_arrow_down_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__svg_react_loader_name_Icon_icon_arrow_down_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__svg_react_loader_name_Icon_icon_arrow_down_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_react_loader_name_Icon_icon_arrow_right_svg__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_react_loader_name_Icon_icon_arrow_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_react_loader_name_Icon_icon_arrow_right_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__svg_react_loader_name_Icon_icon_arrow_right_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_react_loader_name_Icon_icon_block_svg__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_react_loader_name_Icon_icon_block_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_react_loader_name_Icon_icon_block_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_3__svg_react_loader_name_Icon_icon_block_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_react_loader_name_Icon_icon_brand_svg__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_react_loader_name_Icon_icon_brand_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_react_loader_name_Icon_icon_brand_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_4__svg_react_loader_name_Icon_icon_brand_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_react_loader_name_Icon_icon_cancel_svg__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_react_loader_name_Icon_icon_cancel_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_react_loader_name_Icon_icon_cancel_svg__);
/* unused harmony reexport IconCancel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_react_loader_name_Icon_icon_check_svg__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_react_loader_name_Icon_icon_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_react_loader_name_Icon_icon_check_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__svg_react_loader_name_Icon_icon_check_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_react_loader_name_Icon_icon_check_circle_svg__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_react_loader_name_Icon_icon_check_circle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_react_loader_name_Icon_icon_check_circle_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__svg_react_loader_name_Icon_icon_check_circle_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_react_loader_name_Icon_icon_chevron_down_svg__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_react_loader_name_Icon_icon_chevron_down_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_react_loader_name_Icon_icon_chevron_down_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_8__svg_react_loader_name_Icon_icon_chevron_down_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_react_loader_name_Icon_icon_chevron_left_svg__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_react_loader_name_Icon_icon_chevron_left_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__svg_react_loader_name_Icon_icon_chevron_left_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_9__svg_react_loader_name_Icon_icon_chevron_left_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_react_loader_name_Icon_icon_chevron_right_svg__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_react_loader_name_Icon_icon_chevron_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__svg_react_loader_name_Icon_icon_chevron_right_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_10__svg_react_loader_name_Icon_icon_chevron_right_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_react_loader_name_Icon_icon_chevron_up_svg__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_react_loader_name_Icon_icon_chevron_up_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__svg_react_loader_name_Icon_icon_chevron_up_svg__);
/* unused harmony reexport IconChevronUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_react_loader_name_Icon_icon_clock_circle_svg__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_react_loader_name_Icon_icon_clock_circle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__svg_react_loader_name_Icon_icon_clock_circle_svg__);
/* unused harmony reexport IconClockCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_react_loader_name_Icon_icon_close_svg__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_react_loader_name_Icon_icon_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__svg_react_loader_name_Icon_icon_close_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_13__svg_react_loader_name_Icon_icon_close_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__svg_react_loader_name_Icon_icon_delete_svg__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__svg_react_loader_name_Icon_icon_delete_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__svg_react_loader_name_Icon_icon_delete_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_14__svg_react_loader_name_Icon_icon_delete_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_react_loader_name_Icon_icon_download_svg__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_react_loader_name_Icon_icon_download_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__svg_react_loader_name_Icon_icon_download_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_15__svg_react_loader_name_Icon_icon_download_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__svg_react_loader_name_Icon_icon_equal_svg__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__svg_react_loader_name_Icon_icon_equal_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__svg_react_loader_name_Icon_icon_equal_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_16__svg_react_loader_name_Icon_icon_equal_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__svg_react_loader_name_Icon_icon_error_outline_svg__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__svg_react_loader_name_Icon_icon_error_outline_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__svg_react_loader_name_Icon_icon_error_outline_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_17__svg_react_loader_name_Icon_icon_error_outline_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__svg_react_loader_name_Icon_icon_facebook_svg__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__svg_react_loader_name_Icon_icon_facebook_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__svg_react_loader_name_Icon_icon_facebook_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_18__svg_react_loader_name_Icon_icon_facebook_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__svg_react_loader_name_Icon_icon_favorite_svg__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__svg_react_loader_name_Icon_icon_favorite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__svg_react_loader_name_Icon_icon_favorite_svg__);
/* unused harmony reexport IconFavorite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__svg_react_loader_name_Icon_icon_flair_square_svg__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__svg_react_loader_name_Icon_icon_flair_square_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__svg_react_loader_name_Icon_icon_flair_square_svg__);
/* unused harmony reexport IconFlairSquare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__svg_react_loader_name_Icon_icon_flair_triangle_outline_svg__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__svg_react_loader_name_Icon_icon_flair_triangle_outline_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__svg_react_loader_name_Icon_icon_flair_triangle_outline_svg__);
/* unused harmony reexport IconFlairTriangleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__svg_react_loader_name_Icon_icon_flip_svg__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__svg_react_loader_name_Icon_icon_flip_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__svg_react_loader_name_Icon_icon_flip_svg__);
/* unused harmony reexport IconFlip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__svg_react_loader_name_Icon_icon_edit_svg__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__svg_react_loader_name_Icon_icon_edit_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__svg_react_loader_name_Icon_icon_edit_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_23__svg_react_loader_name_Icon_icon_edit_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__svg_react_loader_name_Icon_icon_help_circle_svg__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__svg_react_loader_name_Icon_icon_help_circle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__svg_react_loader_name_Icon_icon_help_circle_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_24__svg_react_loader_name_Icon_icon_help_circle_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__svg_react_loader_name_Icon_icon_mail_outline_svg__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__svg_react_loader_name_Icon_icon_mail_outline_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__svg_react_loader_name_Icon_icon_mail_outline_svg__);
/* unused harmony reexport IconMailOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__svg_react_loader_name_Icon_icon_menu_svg__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__svg_react_loader_name_Icon_icon_menu_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__svg_react_loader_name_Icon_icon_menu_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_26__svg_react_loader_name_Icon_icon_menu_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__svg_react_loader_name_Icon_icon_message_svg__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__svg_react_loader_name_Icon_icon_message_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__svg_react_loader_name_Icon_icon_message_svg__);
/* unused harmony reexport IconMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__svg_react_loader_name_Icon_icon_remove_svg__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__svg_react_loader_name_Icon_icon_remove_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__svg_react_loader_name_Icon_icon_remove_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_28__svg_react_loader_name_Icon_icon_remove_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__svg_react_loader_name_Icon_icon_running_shoes_svg__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__svg_react_loader_name_Icon_icon_running_shoes_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__svg_react_loader_name_Icon_icon_running_shoes_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_29__svg_react_loader_name_Icon_icon_running_shoes_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__svg_react_loader_name_Icon_icon_twitter_svg__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__svg_react_loader_name_Icon_icon_twitter_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__svg_react_loader_name_Icon_icon_twitter_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_30__svg_react_loader_name_Icon_icon_twitter_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__svg_react_loader_name_Icon_icon_triangle_left_svg__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__svg_react_loader_name_Icon_icon_triangle_left_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__svg_react_loader_name_Icon_icon_triangle_left_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_31__svg_react_loader_name_Icon_icon_triangle_left_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__svg_react_loader_name_Icon_icon_triangle_right_svg__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__svg_react_loader_name_Icon_icon_triangle_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__svg_react_loader_name_Icon_icon_triangle_right_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_32__svg_react_loader_name_Icon_icon_triangle_right_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__svg_react_loader_name_Icon_icon_view_svg__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__svg_react_loader_name_Icon_icon_view_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__svg_react_loader_name_Icon_icon_view_svg__);
/* unused harmony reexport IconView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__svg_react_loader_name_Icon_icon_instagram_svg__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__svg_react_loader_name_Icon_icon_instagram_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__svg_react_loader_name_Icon_icon_instagram_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_34__svg_react_loader_name_Icon_icon_instagram_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__svg_react_loader_name_Icon_icon_linkedin_svg__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__svg_react_loader_name_Icon_icon_linkedin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__svg_react_loader_name_Icon_icon_linkedin_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_35__svg_react_loader_name_Icon_icon_linkedin_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__svg_react_loader_name_Icon_homeowners_icon_fixed_amount_svg__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__svg_react_loader_name_Icon_homeowners_icon_fixed_amount_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__svg_react_loader_name_Icon_homeowners_icon_fixed_amount_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_36__svg_react_loader_name_Icon_homeowners_icon_fixed_amount_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__svg_react_loader_name_Icon_homeowners_icon_flexible_svg__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__svg_react_loader_name_Icon_homeowners_icon_flexible_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__svg_react_loader_name_Icon_homeowners_icon_flexible_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_37__svg_react_loader_name_Icon_homeowners_icon_flexible_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__svg_react_loader_name_Icon_homeowners_icon_lower_rates_svg__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__svg_react_loader_name_Icon_homeowners_icon_lower_rates_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__svg_react_loader_name_Icon_homeowners_icon_lower_rates_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_38__svg_react_loader_name_Icon_homeowners_icon_lower_rates_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__svg_react_loader_name_Icon_homeowners_icon_pick_beneficiaries_svg__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__svg_react_loader_name_Icon_homeowners_icon_pick_beneficiaries_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__svg_react_loader_name_Icon_homeowners_icon_pick_beneficiaries_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_39__svg_react_loader_name_Icon_homeowners_icon_pick_beneficiaries_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__svg_react_loader_name_Icon_homeowners_icon_portable_svg__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__svg_react_loader_name_Icon_homeowners_icon_portable_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__svg_react_loader_name_Icon_homeowners_icon_portable_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_40__svg_react_loader_name_Icon_homeowners_icon_portable_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__svg_react_loader_name_Icon_homeowners_icon_quick_svg__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__svg_react_loader_name_Icon_homeowners_icon_quick_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__svg_react_loader_name_Icon_homeowners_icon_quick_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_41__svg_react_loader_name_Icon_homeowners_icon_quick_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__svg_react_loader_name_Icon_homeowners_icon_check_outline_svg__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__svg_react_loader_name_Icon_homeowners_icon_check_outline_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__svg_react_loader_name_Icon_homeowners_icon_check_outline_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_42__svg_react_loader_name_Icon_homeowners_icon_check_outline_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__svg_react_loader_name_Icon_homeowners_icon_cross_outline_svg__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__svg_react_loader_name_Icon_homeowners_icon_cross_outline_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__svg_react_loader_name_Icon_homeowners_icon_cross_outline_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_43__svg_react_loader_name_Icon_homeowners_icon_cross_outline_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__svg_react_loader_name_Icon_homeowners_icon_flip_down_svg__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__svg_react_loader_name_Icon_homeowners_icon_flip_down_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__svg_react_loader_name_Icon_homeowners_icon_flip_down_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_44__svg_react_loader_name_Icon_homeowners_icon_flip_down_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__svg_react_loader_name_Icon_homeowners_icon_flip_up_svg__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__svg_react_loader_name_Icon_homeowners_icon_flip_up_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__svg_react_loader_name_Icon_homeowners_icon_flip_up_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_45__svg_react_loader_name_Icon_homeowners_icon_flip_up_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__svg_react_loader_name_Icon_logo_first_canadian_svg__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__svg_react_loader_name_Icon_logo_first_canadian_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__svg_react_loader_name_Icon_logo_first_canadian_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_46__svg_react_loader_name_Icon_logo_first_canadian_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__svg_react_loader_name_Icon_logo_running_room_svg__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__svg_react_loader_name_Icon_logo_running_room_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__svg_react_loader_name_Icon_logo_running_room_svg__);
/* unused harmony reexport LogoRunningRoom */
// Icons














































// Logos




/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(192)();
}


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ensureUserHasRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ensureUserHasRoleAdminSite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return userIsNotAuthenticatedRedir; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_redirect__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_redirect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_redirect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_locationHelper__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_locationHelper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_locationHelper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(1);




var locationHelper = __WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_locationHelper___default()({});
var userIsAuthenticatedRedir = Object(__WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_redirect__["connectedRouterRedirect"])({
    authenticatedSelector: function (state) { return state.auth.currentUser.isAuthenticated === true; },
    wrapperDisplayName: 'UserIsAuthenticated',
    redirectPath: '/fourohone'
});
var userHasRoleRedir = function (component, roles) {
    var config = {
        authenticatedSelector: function (state) { return __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].isAuthorized(state.auth.currentUser.role, roles); },
        redirectPath: '/fourohthree',
        wrapperDisplayName: 'UserHasRole',
        allowRedirectBack: false
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_redirect__["connectedRouterRedirect"])(config)(component);
};
var ensureUserHasRole = Object(__WEBPACK_IMPORTED_MODULE_2_redux__["compose"])(userIsAuthenticatedRedir, userHasRoleRedir);
var userIsAuthenticatedRedirAdminSite = Object(__WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_redirect__["connectedRouterRedirect"])({
    authenticatedSelector: function (state) { return state.auth.currentUser.isAuthenticated === true; },
    wrapperDisplayName: 'UserIsAuthenticated',
    redirectPath: '/admin/fourohone'
});
var userHasRoleRedirAdminSite = function (component, roles) {
    var config = {
        authenticatedSelector: function (state) { return __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].isAuthorized(state.auth.currentUser.role, roles); },
        redirectPath: '/admin/fourohthree',
        wrapperDisplayName: 'UserHasRole',
        allowRedirectBack: false
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_redirect__["connectedRouterRedirect"])(config)(component);
};
var ensureUserHasRoleAdminSite = Object(__WEBPACK_IMPORTED_MODULE_2_redux__["compose"])(userIsAuthenticatedRedirAdminSite, userHasRoleRedirAdminSite);
var userIsNotAuthenticatedRedir = Object(__WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_redirect__["connectedRouterRedirect"])({
    // Want to redirect the user when they are done loading and authenticated
    authenticatedSelector: function (state) { return state.auth.currentUser.isAuthenticated !== true; },
    wrapperDisplayName: 'UserIsNotAuthenticated',
    redirectPath: function (state, ownProps) {
        return locationHelper.getRedirectQueryParam(ownProps) || '/';
    },
    allowRedirectBack: false
});


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__userAPI__ = __webpack_require__(81);


var userActions = {
    resetUser: function () {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_USER };
    },
    setUser: function (user) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_USER, user: user };
    },
    fetchUser: function (userId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].fetchUser(userId)
            .then(function (user) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_USER, user: user });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchUserByPolicyId: function (policyId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].fetchUserByPolicyId(policyId)
            .then(function (user) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_USER, user: user });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchReferrerNameByReferralCode: function (referralCode) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].fetchReferrerNameByReferralCode(referralCode)
            .then(function (referrerName) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_REFERRER_NAME_BY_REFERRAL_CODE_SUCCESS, referrerName: referrerName });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchReferrerNameBySpousalReferralCode: function (spousalReferralCode) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].fetchReferrerNameBySpousalReferralCode(spousalReferralCode)
            .then(function (referrerName) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_REFERRER_NAME_BY_SPOUSAL_REFERRAL_CODE_SUCCESS, referrerName: referrerName });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    saveUser: function (user) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].saveUser(user)
            .then(function (savedUser) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_USER, user: savedUser });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    adminSaveUser: function (user) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].adminSaveUser(user)
            .then(function (savedUser) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_USER, user: savedUser });
        })
            .catch(function (err) {
            throw err; // where does this go?
        });
    }; },
    updateSoftDeclinedUser: function (user, policyId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].updateSoftDeclinedUser(user, policyId)
            .then(function (updatedUser) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_USER, user: updatedUser });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    saveStaff: function (user) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].saveStaff(user)
            .then(function (savedUser) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_USER, user: savedUser });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchAdmins: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].fetchAdmins()
            .then(function (admins) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_ADMINS, admins: admins });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchCustomers: function (filterProspects) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].fetchCustomers(filterProspects)
            .then(function (customers) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMERS, customers: customers });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchSoftDeclinedCustomers: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].fetchSoftDeclinedCustomers()
            .then(function (softDeclinedCustomers) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_SOFT_DECLINED_CUSTOMERS, customers: softDeclinedCustomers });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    clearAdjudicationQueue: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].clearAdjudicationQueue()
            .then(function () {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].CLEAR_ADJUDICATION_QUEUE });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    setCustomerNote: function (note) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_NOTE, note: note };
    },
    fetchCustomerNote: function (customerId, noteId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].fetchCustomerNote(customerId, noteId)
            .then(function (note) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_NOTE, note: note });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchCustomerNotes: function (customerId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].fetchCustomerNotes(customerId)
            .then(function (notes) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_NOTES, notes: notes });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    resetCustomerNote: function (customerId) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_CUSTOMER_NOTES, customerId: customerId };
    },
    resetCustomerAnswerNote: function (customerId, answerId) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_CUSTOMER_ANSWER_NOTES, customerId: customerId, answerId: answerId };
    },
    saveCustomerNote: function (note) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].saveCustomerNote(note)
            .then(function (savedNote) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_CUSTOMER_NOTE, note: savedNote });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    resetPassword: function (userId, resetUrl) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].resetPassword(userId, resetUrl)
            .then(function (success) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_PASSWORD, success: success });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    saveRole: function (userId, roles) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].saveRole(userId, roles)
            .then(function (test) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_USER_ROLE_SUCCESS, test: test });
        });
    }; },
    clearReferrals: function (customerId) { return function (dispatch) {
        return dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_CUSTOMER_REFERRALS });
    }; },
    fetchReferrals: function (customerId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].fetchReferrals(customerId)
            .then(function (referrals) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_REFERRALS_SUCCESS, referrals: referrals });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    generateNewReferralCode: function (customerId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].generateNewReferralCode(customerId)
            .then(function (referralCode) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].GENERATE_NEW_REFERRALCODE_SUCCESS, referralCode: referralCode });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    setReferralCode: function (referralCode) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_REFERRALCODE_SUCCESS, referralCode: referralCode };
    },
    setSpousalReferralCode: function (spousalReferralCode) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_SPOUSALREFERRALCODE_SUCCESS, spousalReferralCode: spousalReferralCode };
    },
    updateReferralBalance: function (customerId, referralBalance) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].updateReferralBalance(customerId, referralBalance)
            .then(function (referralBalanceResponse) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_REFERAL_BALANCE_SUCCESS, referralBalance: referralBalanceResponse });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    updateRemainingReferrals: function (customerId, remainingReferrals) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].updateRemainingReferrals(customerId, remainingReferrals)
            .then(function (remainingReferralsResponse) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_REMAINING_REFERRALS_SUCCESS, remainingReferrals: remainingReferralsResponse });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    updateCustomerReferralEnabled: function (customerId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].updateCustomerReferralEnabled(customerId)
            .then(function (referralEnabledResponse) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_REFERRAL_ENABLED_SUCCESS, referralEnabled: referralEnabledResponse });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    setCustomerReferralBalance: function (referralBalance) {
        return function (dispatch) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_REFERRAL_BALANCE, referralBalance: referralBalance });
            return Promise.resolve();
        };
    },
    setCustomerRemainingReferrals: function (remainingReferrals) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_REMAINING_REFERRALS, remainingReferrals: remainingReferrals };
    },
    sendReferralInviteEmail: function (userId, name, email) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].sendReferralInviteEmail(userId, name, email)
            .then(function (success) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SEND_REFERRAL_INVITE_EMAIL_SUCCESS, success: success });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    sendSpousalReferralInviteEmail: function (userId, name, email) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].sendSpousalReferralInviteEmail(userId, name, email)
            .then(function (success) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SEND_REFERRAL_INVITE_EMAIL_SUCCESS, success: success });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    sendSoftDeclinedEmail: function (userId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].sendSoftDeclinedEmail(userId)
            .then(function (success) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SEND_SOFT_DECLINED_EMAIL_SUCCESS, success: success });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    updateStripeCustomerEmail: function (customerId, email) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__userAPI__["a" /* default */].updateStripeCustomerEmail(customerId, email)
            .then(function (updatedCustomerResponse) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_CUSTOMER_EMAIL, user: updatedCustomerResponse });
        })
            .catch(function (err) {
            if (err.responseStatus) {
                toastr.error(err.responseStatus.message);
            }
        });
    }; },
};
/* harmony default export */ __webpack_exports__["a"] = (userActions);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__policyAPI__ = __webpack_require__(35);


var policyActions = {
    setDevQuestionnaire: function () {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_DEV_QUESTIONNAIRE };
    },
    resetCustomerPolicy: function () {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_CUSTOMER_POLICY };
    },
    resetCustomerPolicyBeneficiary: function () {
        return function (dispatch) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_CUSTOMER_POLICY_BENEFICIARY });
            return Promise.resolve();
        };
    },
    resetCustomerPolicyAnswer: function () {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_POLICY_ANSWER };
    },
    setCustomerPolicy: function (customerPolicy) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_POLICY, customerPolicy: customerPolicy };
    },
    setCustomerPolicies: function (customerPolicy) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_POLICIES, customerPolicy: customerPolicy };
    },
    setCustomerPolicyBeneficiary: function (customerPolicyBeneficiary) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_POLICY_BENEFICIARY, customerPolicyBeneficiary: customerPolicyBeneficiary };
    },
    setTrustee: function (trustee) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_TRUSTEE, trustee: trustee };
    },
    setCustomerPolicyBeneficiaries: function (beneficiaries) {
        return function (dispatch) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_POLICY_BENEFICIARIES, beneficiaries: beneficiaries });
            Promise.resolve();
        };
    },
    setQuestionnaire: function (questionnaire) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_QUESTIONNAIRE, questionnaire: questionnaire };
    },
    resetQuestionnaire: function () {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_QUESTIONNAIRE };
    },
    setPremiumChanged: function (premiumChanged) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_PREMIUM_CHANGED, premiumChanged: premiumChanged };
    },
    fetchCustomerPolicyDocumentUrl: function (userId, policyId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchCustomerPolicyDocumentUrl(userId, policyId)
            .then(function (url) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_POLICY_DOCUMENT_URL, url: url });
        });
    }; },
    fetchCustomerPolicy: function (userId, policyId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchCustomerPolicy(userId, policyId)
            .then(function (customerPolicy) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_POLICY, customerPolicy: customerPolicy });
        })
            .catch(function (err) {
            if (err.responseStatus) {
                toastr.error(err.responseStatus.message);
            }
        });
    }; },
    fetchCustomerPolicyFreeTrialMonths: function (userId, policyId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchCustomerPolicyFreeTrialMonths(userId, policyId)
            .then(function (months) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_POLICY_FREE_TRIAL_MONTHS, months: months });
        })
            .catch(function (err) {
            if (err.responseStatus) {
                toastr.error(err.responseStatus.message);
            }
        });
    }; },
    fetchCustomerPolicies: function (userId, includeInactive) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchCustomerPolicies(userId, includeInactive)
            .then(function (policies) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_POLICIES, policies: policies });
        })
            .catch(function (err) {
            if (err.responseStatus) {
                toastr.error(err.responseStatus.message);
            }
        });
    }; },
    fetchCustomerPolicyBeneficiary: function (userId, beneficiaryId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchCustomerPolicyBeneficiary(userId, beneficiaryId)
            .then(function (customerPolicyBeneficiary) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_POLICY_BENEFICIARY, customerPolicyBeneficiary: customerPolicyBeneficiary });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchCustomerPolicyBeneficiaries: function (userId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchCustomerPolicyBeneficiaries(userId)
            .then(function (beneficiaries) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_POLICY_BENEFICIARIES, beneficiaries: beneficiaries });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchCustomerPolicyBeneficiaryForm: function (userId, policyId, formId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchCustomerPolicyBeneficiaryForm(userId, policyId, formId)
            .then(function () {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_POLICY_BENEFICIARY_FORM });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchPlanOptions: function (workflow) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchPlanOptions(workflow)
            .then(function (planOptions) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_PLAN_OPTIONS, planOptions: planOptions });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchSimplePlanOptions: function (params) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchSimplePlanOptions(params)
            .then(function (planOptions) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_PLAN_OPTIONS, planOptions: planOptions });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchAdvisoryPlanOptions: function (params) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchAdvisoryPlanOptions(params)
            .then(function (planOptions) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_PLAN_OPTIONS, planOptions: planOptions });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchBespokePlanOptions: function (params) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchBespokePlanOptions(params)
            .then(function (planOptions) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_PLAN_OPTIONS, planOptions: planOptions });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchRatePlusMinus: function (policyId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchRatePlusMinus(policyId)
            .then(function (ratePlusMinus) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_RATE_PLUS_MINUS_SUCCESS, ratePlusMinus: ratePlusMinus });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchIsHardDeclined: function (userId, policyId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchIsHardDeclined(userId, policyId)
            .then(function (isHardDeclined) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_IS_HARD_DECLINED_SUCCESS, isHardDeclined: isHardDeclined });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchIsSoftDeclined: function (userId, policyId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchIsSoftDeclined(userId, policyId)
            .then(function (isSoftDeclined) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_IS_SOFT_DECLINED_SUCCESS, isSoftDeclined: isSoftDeclined });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchQuestionnaireReport: function (userId, policyId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchQuestionnaireReport(userId, policyId)
            .then(function (questionnaireReport) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_QUESTIONNAIRE_REPORT_SUCCESS, questionnaireReport: questionnaireReport });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchPolicyAnswer: function (policyId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].fetchPolicyAnswer(policyId)
            .then(function (answers) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_POLICY_ANSWER_SUCCESS, answers: answers });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    saveCustomerPolicy: function (customerPolicy) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].saveCustomerPolicy(customerPolicy)
            .then(function (savedCustomerPolicy) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_CUSTOMER_POLICY, customerPolicy: savedCustomerPolicy });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    updatePolicyPaperCopyStatus: function (policyId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].updatePolicyPaperCopyStatus(policyId)
            .then(function () {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_POLICY_PAPER_STATUS });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    saveCustomerPolicyBeneficiary: function (customerPolicyBeneficiary) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].saveCustomerPolicyBeneficiary(customerPolicyBeneficiary)
            .then(function (savedBeneficiary) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_CUSTOMER_POLICY_BENEFICIARY, customerPolicyBeneficiary: savedBeneficiary });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    saveCustomerPolicyCurrentBeneficiary: function (customerPolicyCurrentBeneficiary) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].saveCustomerPolicyCurrentBeneficiary(customerPolicyCurrentBeneficiary)
            .then(function (savedBeneficiary) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_CUSTOMER_POLICY_CURRENT_BENEFICIARY, customerPolicyBeneficiary: savedBeneficiary });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    approveAllBeneficiariesForCustomer: function (request) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].approveAllBeneficiariesForCustomer(request)
            .then(function () {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].APPROVE_ALL_BENEFICIARIES });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    saveCustomerPolicyAnswer: function (policyId, questionName, value) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].saveCustomerPolicyAnswer(policyId, questionName, value)
            .then(function (answer) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_CUSTOMER_POLICY_ANSWER, answer: answer });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    updatePolicy: function (policyId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].updatePolicy(policyId)
            .then(function (updatedCustomerPolicy) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_CUSTOMER_POLICY, customerPolicy: updatedCustomerPolicy });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    deleteCustomerPolicy: function (customer, customerPolicy) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].deleteCustomerPolicy(customer.stripeCustomerId, customerPolicy.stripePlanId)
            .then(function (cancelledCustomerPolicy) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].DELETE_CUSTOMER_POLICY, customerPolicy: cancelledCustomerPolicy });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    deleteCustomerPolicyBeneficiary: function (beneficiaryId, statusId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].deleteCustomerPolicyBeneficiary(beneficiaryId, statusId)
            .then(function (deleteSucceed) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].DELETE_CUSTOMER_POLICY_BENEFICIARY, deleteSucceed: deleteSucceed });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    deleteBeneficiaryDuringSignUp: function (beneficiaryId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].deleteBeneficiaryDuringSignUp(beneficiaryId)
            .then(function () {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].DELETE_BENEFICIARY_DURING_SIGN_UP });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    rebuildCustomerPolicyPdf: function (customer, customerPolicy) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].rebuildCustomerPolicyPdf(customer.id, customerPolicy.id)
            .catch(function (err) {
            throw err;
        });
    }; },
    sendBeneficiaryNotification: function (userId, beneficiaryId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].sendBeneficiaryNotification(userId, beneficiaryId)
            .catch(function (err) {
            throw err;
        });
    }; },
    sendBeneficiaryUploadedConfirmation: function (userId, policyId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].sendBeneficiaryUploadedConfirmation(userId, policyId)
            .catch(function (err) {
            throw err;
        });
    }; },
    saveAdminCustomerPolicy: function (customerPolicy) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].saveAdminCustomerPolicy(customerPolicy)
            .then(function (savedCustomerPolicy) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_CUSTOMER_POLICY, customerPolicy: savedCustomerPolicy });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    sendCancelPolicyEmail: function (userId, policyId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__policyAPI__["a" /* default */].sendCancelPolicyEmail(userId, policyId)
            .catch(function (err) {
            throw err;
        });
    }; },
    setRedirectFromAdjudication: function (redirect) {
        return function (dispatch) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].REDIRECT_FROM_ADJUDICATION, redirectFromAdjudication: redirect });
        };
    },
};
/* harmony default export */ __webpack_exports__["a"] = (policyActions);


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Toastr
 * Copyright 2012-2015
 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
 * All Rights Reserved.
 * Use, reproduction, distribution, and modification of this code is subject to the terms and
 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
 *
 * ARIA Support: Greta Krafsig
 *
 * Project: https://github.com/CodeSeven/toastr
 */
/* global define */
; (function (define) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(345)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
        return (function () {
            var $container;
            var listener;
            var toastId = 0;
            var toastType = {
                error: 'error',
                info: 'info',
                success: 'success',
                warning: 'warning'
            };

            var toastr = {
                clear: clear,
                remove: remove,
                error: error,
                getContainer: getContainer,
                info: info,
                options: {},
                subscribe: subscribe,
                success: success,
                version: '2.1.2',
                warning: warning
            };

            var previousToast;

            return toastr;

            ////////////////

            function error(message, title, optionsOverride) {
                return notify({
                    type: toastType.error,
                    iconClass: getOptions().iconClasses.error,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function getContainer(options, create) {
                if (!options) { options = getOptions(); }
                $container = $('#' + options.containerId);
                if ($container.length) {
                    return $container;
                }
                if (create) {
                    $container = createContainer(options);
                }
                return $container;
            }

            function info(message, title, optionsOverride) {
                return notify({
                    type: toastType.info,
                    iconClass: getOptions().iconClasses.info,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function subscribe(callback) {
                listener = callback;
            }

            function success(message, title, optionsOverride) {
                return notify({
                    type: toastType.success,
                    iconClass: getOptions().iconClasses.success,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function warning(message, title, optionsOverride) {
                return notify({
                    type: toastType.warning,
                    iconClass: getOptions().iconClasses.warning,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function clear($toastElement, clearOptions) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if (!clearToast($toastElement, options, clearOptions)) {
                    clearContainer(options);
                }
            }

            function remove($toastElement) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if ($toastElement && $(':focus', $toastElement).length === 0) {
                    removeToast($toastElement);
                    return;
                }
                if ($container.children().length) {
                    $container.remove();
                }
            }

            // internal functions

            function clearContainer (options) {
                var toastsToClear = $container.children();
                for (var i = toastsToClear.length - 1; i >= 0; i--) {
                    clearToast($(toastsToClear[i]), options);
                }
            }

            function clearToast ($toastElement, options, clearOptions) {
                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
                    $toastElement[options.hideMethod]({
                        duration: options.hideDuration,
                        easing: options.hideEasing,
                        complete: function () { removeToast($toastElement); }
                    });
                    return true;
                }
                return false;
            }

            function createContainer(options) {
                $container = $('<div/>')
                    .attr('id', options.containerId)
                    .addClass(options.positionClass)
                    .attr('aria-live', 'polite')
                    .attr('role', 'alert');

                $container.appendTo($(options.target));
                return $container;
            }

            function getDefaults() {
                return {
                    tapToDismiss: true,
                    toastClass: 'toast',
                    containerId: 'toast-container',
                    debug: false,

                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
                    showDuration: 300,
                    showEasing: 'swing', //swing and linear are built into jQuery
                    onShown: undefined,
                    hideMethod: 'fadeOut',
                    hideDuration: 1000,
                    hideEasing: 'swing',
                    onHidden: undefined,
                    closeMethod: false,
                    closeDuration: false,
                    closeEasing: false,

                    extendedTimeOut: 1000,
                    iconClasses: {
                        error: 'toast-error',
                        info: 'toast-info',
                        success: 'toast-success',
                        warning: 'toast-warning'
                    },
                    iconClass: 'toast-info',
                    positionClass: 'toast-top-right',
                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
                    titleClass: 'toast-title',
                    messageClass: 'toast-message',
                    escapeHtml: false,
                    target: 'body',
                    closeHtml: '<button type="button">&times;</button>',
                    newestOnTop: true,
                    preventDuplicates: false,
                    progressBar: false
                };
            }

            function publish(args) {
                if (!listener) { return; }
                listener(args);
            }

            function notify(map) {
                var options = getOptions();
                var iconClass = map.iconClass || options.iconClass;

                if (typeof (map.optionsOverride) !== 'undefined') {
                    options = $.extend(options, map.optionsOverride);
                    iconClass = map.optionsOverride.iconClass || iconClass;
                }

                if (shouldExit(options, map)) { return; }

                toastId++;

                $container = getContainer(options, true);

                var intervalId = null;
                var $toastElement = $('<div/>');
                var $titleElement = $('<div/>');
                var $messageElement = $('<div/>');
                var $progressElement = $('<div/>');
                var $closeElement = $(options.closeHtml);
                var progressBar = {
                    intervalId: null,
                    hideEta: null,
                    maxHideTime: null
                };
                var response = {
                    toastId: toastId,
                    state: 'visible',
                    startTime: new Date(),
                    options: options,
                    map: map
                };

                personalizeToast();

                displayToast();

                handleEvents();

                publish(response);

                if (options.debug && console) {
                    console.log(response);
                }

                return $toastElement;

                function escapeHtml(source) {
                    if (source == null)
                        source = "";

                    return new String(source)
                        .replace(/&/g, '&amp;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#39;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;');
                }

                function personalizeToast() {
                    setIcon();
                    setTitle();
                    setMessage();
                    setCloseButton();
                    setProgressBar();
                    setSequence();
                }

                function handleEvents() {
                    $toastElement.hover(stickAround, delayedHideToast);
                    if (!options.onclick && options.tapToDismiss) {
                        $toastElement.click(hideToast);
                    }

                    if (options.closeButton && $closeElement) {
                        $closeElement.click(function (event) {
                            if (event.stopPropagation) {
                                event.stopPropagation();
                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
                                event.cancelBubble = true;
                            }
                            hideToast(true);
                        });
                    }

                    if (options.onclick) {
                        $toastElement.click(function (event) {
                            options.onclick(event);
                            hideToast();
                        });
                    }
                }

                function displayToast() {
                    $toastElement.hide();

                    $toastElement[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
                    );

                    if (options.timeOut > 0) {
                        intervalId = setTimeout(hideToast, options.timeOut);
                        progressBar.maxHideTime = parseFloat(options.timeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                        if (options.progressBar) {
                            progressBar.intervalId = setInterval(updateProgress, 10);
                        }
                    }
                }

                function setIcon() {
                    if (map.iconClass) {
                        $toastElement.addClass(options.toastClass).addClass(iconClass);
                    }
                }

                function setSequence() {
                    if (options.newestOnTop) {
                        $container.prepend($toastElement);
                    } else {
                        $container.append($toastElement);
                    }
                }

                function setTitle() {
                    if (map.title) {
                        $titleElement.append(!options.escapeHtml ? map.title : escapeHtml(map.title)).addClass(options.titleClass);
                        $toastElement.append($titleElement);
                    }
                }

                function setMessage() {
                    if (map.message) {
                        $messageElement.append(!options.escapeHtml ? map.message : escapeHtml(map.message)).addClass(options.messageClass);
                        $toastElement.append($messageElement);
                    }
                }

                function setCloseButton() {
                    if (options.closeButton) {
                        $closeElement.addClass('toast-close-button').attr('role', 'button');
                        $toastElement.prepend($closeElement);
                    }
                }

                function setProgressBar() {
                    if (options.progressBar) {
                        $progressElement.addClass('toast-progress');
                        $toastElement.prepend($progressElement);
                    }
                }

                function shouldExit(options, map) {
                    if (options.preventDuplicates) {
                        if (map.message === previousToast) {
                            return true;
                        } else {
                            previousToast = map.message;
                        }
                    }
                    return false;
                }

                function hideToast(override) {
                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
                    var duration = override && options.closeDuration !== false ?
                        options.closeDuration : options.hideDuration;
                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
                    if ($(':focus', $toastElement).length && !override) {
                        return;
                    }
                    clearTimeout(progressBar.intervalId);
                    return $toastElement[method]({
                        duration: duration,
                        easing: easing,
                        complete: function () {
                            removeToast($toastElement);
                            if (options.onHidden && response.state !== 'hidden') {
                                options.onHidden();
                            }
                            response.state = 'hidden';
                            response.endTime = new Date();
                            publish(response);
                        }
                    });
                }

                function delayedHideToast() {
                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                    }
                }

                function stickAround() {
                    clearTimeout(intervalId);
                    progressBar.hideEta = 0;
                    $toastElement.stop(true, true)[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing}
                    );
                }

                function updateProgress() {
                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
                    $progressElement.width(percentage + '%');
                }
            }

            function getOptions() {
                return $.extend({}, getDefaults(), toastr.options);
            }

            function removeToast($toastElement) {
                if (!$container) { $container = getContainer(); }
                if ($toastElement.is(':visible')) {
                    return;
                }
                $toastElement.remove();
                $toastElement = null;
                if ($container.children().length === 0) {
                    $container.remove();
                    previousToast = undefined;
                }
            }

        })();
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(134)));


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);





var NextPreviousButtons = function (props) {
    var onClick = function (callback) {
        // TODO: Animate scroll
        window.scrollTo(0, 0);
        callback();
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["a" /* Button */], { onClick: function () { return onClick(props.prevStep); }, className: "btn-outline-primary workflow-progress-action", disabled: !props.navigationEnabled },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["s" /* IconChevronLeft */], null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2 d-none d-sm-inline-block" }, "Back")),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["a" /* Button */], { onClick: function () { return onClick(props.nextStep); }, className: "btn-primary workflow-progress-action", disabled: !props.navigationEnabled || props.isNextDisabled() },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Next"),
            !props.isLoading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["t" /* IconChevronRight */], null),
            props.isLoading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["f" /* Spinner */], null))));
};
function mapStateToProps(state) {
    return {
        navigationEnabled: state.settings.questionnaireNavigationEnabled,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps)(NextPreviousButtons));


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actionTypes = {
    SET_DEV_QUESTIONNAIRE: 'SET_DEV_QUESTIONNAIRE',
    TOGGLE_NAV_MENU: 'TOGGLE_NAV_MENU',
    SET_PICKLIST_TYPE_SUCCESS: 'SET_PICKLIST_TYPE_SUCCESS',
    SET_PICKLIST_ITEM_SUCCESS: 'SET_PICKLIST_ITEM_SUCCESS',
    GET_PICKLIST_TYPE_SUCCESS: 'GET_PICKLIST_TYPE_SUCCESS',
    GET_PICKLIST_TYPES_SUCCESS: 'GET_PICKLIST_TYPES_SUCCESS',
    GET_PICKLIST_ITEM_SUCCESS: 'GET_PICKLIST_ITEM_SUCCESS',
    GET_PICKLIST_ITEMS_SUCCESS: 'GET_PICKLIST_ITEMS_SUCCESS',
    SAVE_PICKLIST_TYPE_SUCCESS: 'SAVE_PICKLIST_TYPE_SUCCESS',
    SAVE_PICKLIST_ITEM_SUCCESS: 'SAVE_PICKLIST_ITEM_SUCCESS',
    FETCH_HEIGHT_WEIGHT_TABLE: 'FETCH_HEIGHT_WEIGHT_TABLE',
    DELETE_BENEFICIARY_DURING_SIGN_UP: 'DELETE_BENEFICIARY_DURING_SIGN_UP',
    RESET_USER: 'RESET_USER',
    RESET_CUSTOMER_DETAILS: 'RESET_CUSTOMER_DETAILS',
    RESET_CUSTOMER_POLICY: 'RESET_CUSTOMER_POLICY',
    RESET_CUSTOMER_POLICY_BENEFICIARY: 'RESET_CUSTOMER_POLICY_BENEFICIARY',
    SET_CUSTOMER_DETAILS: 'SET_CUSTOMER_DETAILS',
    SET_CUSTOMER_FAMILY_LIST: 'SET_CUSTOMER_FAMILY_LIST',
    SET_CUSTOMER_POLICY: 'SET_CUSTOMER_POLICY',
    SET_CUSTOMER_POLICIES: 'SET_CUSTOMER_POLICIES',
    SET_CUSTOMER_POLICY_BENEFICIARY: 'SET_CUSTOMER_POLICY_BENEFICIARY',
    SET_TRUSTEE: 'SET_TRUSTEE',
    SET_CUSTOMER_POLICY_BENEFICIARIES: 'SET_CUSTOMER_POLICY_BENEFICIARIES',
    SET_QUESTIONNAIRE: 'SET_QUESTIONNAIRE',
    RESET_QUESTIONNAIRE: 'RESET_QUESTIONNAIRE',
    SET_QUOTING_ASSESSMENT: 'SET_QUOTING_ASSESSMENT',
    FETCH_CUSTOMER_DETAILS: 'FETCH_CUSTOMER_DETAILS',
    FETCH_CUSTOMER_FAMILY_LIST: 'FETCH_CUSTOMER_FAMILY_LIST',
    SAVE_CUSTOMER_DETAILS: 'SAVE_CUSTOMER_DETAILS',
    SAVE_CUSTOMER_FAMILY_LIST: 'SAVE_CUSTOMER_FAMILY_LIST',
    FETCH_PLAN_OPTIONS: 'FETCH_PLAN_OPTIONS',
    FETCH_ADMINS: 'FETCH_ADMINS',
    SET_USER: 'SET_USER',
    SET_CUSTOMER_NOTE: 'SET_CUSTOMER_NOTE',
    FETCH_USER: 'FETCH_USER',
    SAVE_USER: 'SAVE_USER',
    SAVE_USER_ROLE_SUCCESS: 'SAVE_USER_ROLE',
    FETCH_CUSTOMER_PAYMENT: 'FETCH_CUSTOMER_PAYMENT',
    FETCH_CUSTOMER_PAYMENTS: 'FETCH_CUSTOMER_PAYMENTS',
    FETCH_CUSTOMER_UPCOMING_INVOICE: 'FETCH_CUSTOMER_UPCOMING_INVOICE',
    FETCH_CUSTOMER_POLICY: 'FETCH_CUSTOMER_POLICY',
    FETCH_CUSTOMER_POLICY_FREE_TRIAL_MONTHS: 'FETCH_CUSTOMER_POLICY_FREE_TRIAL_MONTHS',
    FETCH_CUSTOMER_POLICY_DOCUMENT_URL: 'FETCH_CUSTOMER_POLICY_DOCUMENT_URL',
    FETCH_CUSTOMER_POLICIES: 'FETCH_CUSTOMER_POLICIES',
    FETCH_UNMAILED_POLICIES: 'FETCH_UNMAILED_POLICIES',
    FETCH_UNMAILED_POLICIES_COUNT: 'FETCH_UNMAILED_POLICIES_COUNT',
    FETCH_CUSTOMER_POLICY_BENEFICIARY: 'FETCH_CUSTOMER_POLICY_BENEFICIARY',
    FETCH_CUSTOMER_POLICY_BENEFICIARIES: 'FETCH_CUSTOMER_POLICY_BENEFICIARIES',
    FETCH_CUSTOMER_POLICY_BENEFICIARY_FORM: 'FETCH_CUSTOMER_POLICY_BENEFICIARY_FORM',
    FETCH_CUSTOMERS: 'FETCH_CUSTOMERS',
    FETCH_SOFT_DECLINED_CUSTOMERS: 'FETCH_SOFT_DECLINED_CUSTOMERS',
    CLEAR_ADJUDICATION_QUEUE: 'CLEAR_ADJUDICATION_QUEUE',
    FETCH_CUSTOMER_CARD: 'FETCH_CUSTOMER_CARD',
    FETCH_INVOICE_CARD: 'FETCH_INVOICE_CARD',
    FETCH_CUSTOMER_NOTE: 'FETCH_CUSTOMER_NOTE',
    FETCH_CUSTOMER_NOTES: 'FETCH_CUSTOMER_NOTES',
    SAVE_CUSTOMER_POLICY: 'SAVE_CUSTOMER_POLICY',
    SAVE_CUSTOMER_POLICY_ANSWER: 'SAVE_CUSTOMER_POLICY_ANSWER',
    SAVE_CUSTOMER_POLICY_BENEFICIARY: 'SAVE_CUSTOMER_POLICY_BENEFICIARY',
    SAVE_CUSTOMER_POLICY_CURRENT_BENEFICIARY: 'SAVE_CUSTOMER_POLICY_CURRENT_BENEFICIARY',
    SAVE_CUSTOMER_NOTE: 'SAVE_CUSTOMER_NOTE',
    UPDATE_CUSTOMER_POLICY: 'UPDATE_CUSTOMER_POLICY',
    DELETE_CUSTOMER_POLICY: 'DELETE_CUSTOMER_POLICY',
    DELETE_CUSTOMER_POLICY_BENEFICIARY: 'DELETE_CUSTOMER_POLICY_BENEFICIARY',
    UPDATE_POLICY_PAPER_STATUS: 'UPDATE_POLICY_PAPER_STATUS',
    RESET_PASSWORD: 'RESET_PASSWORD',
    RESET_CUSTOMER_NOTES: 'RESET_CUSTOMER_NOTES',
    RESET_CUSTOMER_ANSWER_NOTES: 'RESET_CUSTOMER_ANSWER_NOTES',
    SET_PREMIUM_CHANGED: 'SET_PREMIUM_CHANGED',
    FETCH_REFERRER_NAME_BY_REFERRAL_CODE_SUCCESS: 'FETCH_REFERRER_NAME_BY_REFERRAL_CODE_SUCCESS',
    FETCH_REFERRER_NAME_BY_SPOUSAL_REFERRAL_CODE_SUCCESS: 'FETCH_REFERRER_NAME_BY_SPOUSAL_REFERRAL_CODE_SUCCESS',
    SET_QUESTIONNAIRE_NAVIGATION_ENABLED: 'SET_QUESTIONNAIRE_NAVIGATION_ENABLED',
    SET_SELECT_POLICY_OPTIONS_ENABLED: 'SET_SELECT_POLICY_OPTIONS_ENABLED',
    SET_STRIPE: 'SET_STRIPE',
    SET_PAYMENT_DETAILS: 'SET_PAYMENT_DETAILS',
    CREATE_SUBSCRIPTION: 'CREATE_SUBSCRIPTION',
    CREATE_CHARGE: 'CREATE_CHARGE',
    PAY_INVOICE: 'PAY_INVOICE',
    UPDATE_CUSTOMER_EMAIL: 'UPDATE_CUSTOMER_EMAIL',
    UPDATE_CUSTOMER_CARD: 'UPDATE_CUSTOMER_CARD',
    UPDATE_CUSTOMER_PLAN: 'UPDATE_CUSTOMER_PLAN',
    APPROVE_ALL_BENEFICIARIES: 'APPROVE_ALL_BENEFICIARIES',
    FETCH_CUSTOMERS_COUNT: 'FETCH_CUSTOMERS_COUNT',
    FETCH_USER_ACTIVITIES: 'FETCH_USER_ACTIVITIES',
    FETCH_POLICIES_COUNT: 'FETCH_POLICIES_COUNT',
    FETCH_POLICIES: 'FETCH_POLICIES',
    FETCH_FAILED_PAYMENTS_COUNT: 'FETCH_FAILED_PAYMENTS_COUNT',
    FETCH_FAILED_PAYMENTS: 'FETCH_FAILED_PAYMENTS',
    FETCH_EXPIRING_POLICIES_COUNT: 'FETCH_EXPIRING_POLICIES_COUNT',
    FETCH_EXPIRING_POLICIES: 'FETCH_EXPIRING_POLICIES',
    FETCH_MISSING_BENEFICIARY_FORMS_COUNT: 'FETCH_MISSING_BENEFICIARY_FORMS_COUNT',
    FETCH_CUSTOMERS_MISSING_BENEFICIARY_FORMS: 'FETCH_CUSTOMERS_MISSING_BENEFICIARY_FORMS',
    FETCH_BOUNCED_EMAILS_COUNT: 'FETCH_BOUNCED_EMAILS_COUNT',
    FETCH_BOUNCED_EMAILS: 'FETCH_BOUNCED_EMAILS',
    RESOLVE_BOUNCED_EMAIL: 'RESOLVE_BOUNCED_EMAIL',
    FETCH_FINANCIAL_REPORT: 'FETCH_FINANCIAL_REPORT',
    FETCH_REFERRALS: 'FETCH_REFERRALS',
    FETCH_USER_AUTH_SUCCESS: 'FETCH_USER_AUTH_SUCCESS',
    FETCH_USER_AUTH_FAILURE: 'FETCH_USER_AUTH_FAILURE',
    USER_AUTH_LOGOUT: 'USER_AUTH_LOGOUT',
    SET_DIRECT_STATUS_SUCCESS: 'SET_DIRECT_STATUS_SUCCESS',
    SET_CURRENTUSER_HAS_SIGNED_IN: 'SET_CURRENTUSER_HAS_SIGNED_IN',
    FETCH_QUESTION_SUCCESS: 'FETCH_QUESTION_SUCCESS',
    FETCH_RATE_PLUS_MINUS_SUCCESS: 'FETCH_RATE_PLUS_MINUS_SUCCESS',
    VALIDATE_REFERRALCODE_SUCCESS: 'VALIDATE_REFERRALCODE_SUCCESS',
    RESET_CUSTOMER_REFERRALS: 'RESET_CUSTOMER_REFERRALS',
    FETCH_CUSTOMER_REFERRALS_SUCCESS: 'FETCH_CUSTOMER_REFERRALS_SUCCESS',
    GENERATE_NEW_REFERRALCODE_SUCCESS: 'GENERATE_NEW_REFERRALCODE_SUCCESS',
    SET_REFERRALCODE_SUCCESS: 'SET_REFERRALCODE_SUCCESS',
    SET_SPOUSALREFERRALCODE_SUCCESS: 'SET_SPOUSALREFERRALCODE_SUCCESS',
    UPDATE_REMAINING_REFERRALS_SUCCESS: 'UPDATE_REMAINING_REFERRASL_SUCCESS',
    SET_CUSTOMER_REMAINING_REFERRALS: 'SET_CUSTOMER_REMAINING_REFERRALS',
    UPDATE_REFERAL_BALANCE_SUCCESS: 'UPDATE_REFERAL_BALANCE_SUCCESS',
    UPDATE_REFERRAL_ENABLED_SUCCESS: 'UPDATE_REFERRAL_ENABLED_SUCCESS',
    SET_CUSTOMER_REFERRAL_BALANCE: 'SET_CUSTOMER_REFERRAL_BALANCE',
    SEND_REFERRAL_INVITE_EMAIL_SUCCESS: 'SEND_REFERRAL_INVITE_EMAIL_SUCCESS',
    UPDATE_CUSTOMER_REFERREDBY_SUCCESS: 'UPDATE_CUSTOMER_REFERREDBY_SUCCESS',
    FETCH_IS_HARD_DECLINED_SUCCESS: 'FETCH_IS_HARD_DECLINED_SUCCESS',
    FETCH_IS_SOFT_DECLINED_SUCCESS: 'FETCH_IS_SOFT_DECLINED_SUCCESS',
    SEND_SOFT_DECLINED_EMAIL_SUCCESS: 'SEND_SOFT_DECLINED_EMAIL_SUCCESS',
    FETCH_QUESTIONNAIRE_REPORT_SUCCESS: 'FETCH_QUESTIONNAIRE_REPORT_SUCCESS',
    FETCH_POLICY_ANSWER_SUCCESS: 'FETCH_POLICY_ANSWER_SUCCESS',
    RESET_POLICY_ANSWER: 'RESET_POLICY_ANSWER',
    REDIRECT_FROM_ADJUDICATION: 'REDIRECT_FROM_ADJUDICATION',
    CONTACT_US_SUCCESS: 'CONTACT_US_SUCCESS',
    FILE_A_CLAIM_SUCCESS: 'FILE_A_CLAIM_SUCCESS'
};
/* harmony default export */ __webpack_exports__["a"] = (actionTypes);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(21);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var classNames = __webpack_require__(8);
var Button = function (_a) {
    var to = _a.to, onClick = _a.onClick, className = _a.className, type = _a.type, disabled = _a.disabled, children = _a.children, tabIndex = _a.tabIndex, props = __rest(_a, ["to", "onClick", "className", "type", "disabled", "children", "tabIndex"]);
    if (to) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], __assign({ onClick: onClick, to: to, className: classNames('btn', className), tabIndex: tabIndex }, props), children));
    }
    else {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", __assign({ onClick: onClick, className: classNames('btn', className), type: type, disabled: disabled, tabIndex: tabIndex }, props), children));
    }
};
/* harmony default export */ __webpack_exports__["a"] = (Button);


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_msal__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_msal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_msal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_actionTypes__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authAPI__ = __webpack_require__(384);





var authActions = {
    fetchUserSuccess: function (user) {
        return { type: __WEBPACK_IMPORTED_MODULE_3__common_actionTypes__["a" /* default */].FETCH_USER_AUTH_SUCCESS, user: user };
    },
    fetchAuthenticatedUser: function () {
        // Utils.B2CConfiguration throws an error if called from the store during startup.
        // if we call this from a page on a button push it works just fine.
        return function (dispatch, getState) {
            return fetchSignUpUser()
                .catch(function () {
                // because b2c signs tokens differently with different policies 
                // we need to try each to see if the user is logged in  (STUPID)
                return fetchSignUpInUser();
            })
                .catch(function () {
                return fetchSignInUserMultiFactor();
            })
                .then(handleIdToken)
                .then(function (user) {
                // the user record comes from b2c and we don't yet have the yolo user id. 
                // get it from the policy as that is what we are linking to.
                var customerPolicy = getState().policy.customerPolicy;
                user.id = customerPolicy.customerId;
                return linkUserAndAuthRecords(user);
            })
                .then(function (user) {
                return dispatch(authActions.fetchUserSuccess(user));
            })
                .then(__WEBPACK_IMPORTED_MODULE_4__authAPI__["a" /* default */].getCurrentUserData)
                .then(function (user) {
                return dispatch(authActions.fetchUserSuccess(user));
            })
                .catch(function (error) {
                if (error !== 'user_login_error:User login is required') {
                    dispatch({ type: __WEBPACK_IMPORTED_MODULE_3__common_actionTypes__["a" /* default */].FETCH_USER_AUTH_FAILURE, error: error });
                    // tslint:disable-next-line
                    console.error('failed to fetch loggedin user', error);
                }
            });
        };
    },
    logout: function () {
        return function (dispatch) {
            var clientApplication = setupAuthClient();
            clientApplication.logout();
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_3__common_actionTypes__["a" /* default */].USER_AUTH_LOGOUT });
            return Promise.resolve();
        };
    },
    login: function () {
        return function (dispatch) {
            clearMSALSession();
            var clientApplication = setupAuthClient();
            return clientApplication.loginRedirect(__WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].b2cScopes);
        };
    },
    loginAdmin: function () {
        return function (dispatch) {
            clearMSALSession();
            var clientApplication = setupAuthClient(__WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].authoritySignInMultiFactor);
            return clientApplication.loginRedirect(__WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].b2cScopes);
        };
    },
    signUp: function (redirectUrl) {
        return function (dispatch) {
            var authClient = setupAuthClient(__WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].authoritySignUp, redirectUrl);
            return authClient.loginRedirect(__WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].b2cScopes);
        };
    },
    doneDirect: function (currentUser) {
        return { type: __WEBPACK_IMPORTED_MODULE_3__common_actionTypes__["a" /* default */].SET_DIRECT_STATUS_SUCCESS, currentUser: currentUser };
    },
    setCurrentUserhasSignedIn: function (hasSignedIn) {
        return { type: __WEBPACK_IMPORTED_MODULE_3__common_actionTypes__["a" /* default */].SET_CURRENTUSER_HAS_SIGNED_IN, hasSignedIn: hasSignedIn };
    },
    getResetPasswordUrlForEmail: function () {
        return function (dispatch) {
            var url = generateResetPasswordUrl();
            return url;
        };
    }
};
var clearMSALSession = function () {
    var msalKeys = [];
    for (var index = 0; index < window.sessionStorage.length; index++) {
        var key = window.sessionStorage.key(index);
        if (key && key.startsWith('msal')) {
            msalKeys.push(key);
        }
    }
    msalKeys.forEach(function (key) { return window.sessionStorage.removeItem(key); });
};
var fetchSignUpInUser = function () {
    var authClient = setupAuthClient();
    return authClient.acquireTokenSilent(__WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].b2cScopes);
};
var fetchSignUpUser = function () {
    var authClient = setupAuthClient(__WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].authoritySignUp);
    return authClient.acquireTokenSilent(__WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].b2cScopes);
};
var fetchSignInUserMultiFactor = function () {
    var authClient = setupAuthClient(__WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].authoritySignInMultiFactor);
    return authClient.acquireTokenSilent(__WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].b2cScopes);
};
var handleIdToken = function (accessToken) {
    // tslint:disable-next-line
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Authorization'] = "Bearer " + accessToken;
    // msal doesn't currently support custom tokens like the role
    // so we handle it. future version should do this for us
    var claims = __WEBPACK_IMPORTED_MODULE_1__common_utils__["m" /* default */].extractIdToken(accessToken);
    // if no roles add the customer role
    var role = claims.extension_Role ? JSON.parse(claims.extension_Role) : ["Customer" /* Customer */];
    var user = {
        role: role,
        fullName: claims.name,
        userId: claims.sub,
        tfp: claims.tfp,
    };
    return user;
};
var linkUserAndAuthRecords = function (user) {
    // if this is a sign up request link the records
    if (user.tfp === __WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].policyNameSignUp) {
        return __WEBPACK_IMPORTED_MODULE_4__authAPI__["a" /* default */].linkUserAndAuthRecords(user.id)
            .then(function () { return user; });
    }
    else {
        return user;
    }
};
var setupAuthClient = function (authority, redirect) {
    var logger = undefined;
    function loggerCallback(logLevel, message, piiLoggingEnabled) {
        // tslint:disable-next-line
        console.log('[msal]', message);
    }
    if (false) {
        logger = new Msal.Logger(loggerCallback, { level: Msal.LogLevel.Verbose });
    }
    var msalAuthority = authority ? authority : __WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].authoritySignIn;
    var options = {
        postLogoutRedirectUri: window.location.origin,
        redirectUri: redirect ? "" + window.location.origin + redirect : window.location.origin + "/login",
        navigateToLoginRequestUrl: redirect ? false : true,
        logger: logger
    };
    function SignUpInCallback(errorDesc, token, error, tokenType) {
        // Called after loginRedirect or acquireTokenPopup
        // authActions.fetchAuthenticatedUser();
        if (errorDesc && errorDesc.startsWith('AADB2C90118')) {
            var resetUrl = "" + "https://termlifeb2c.b2clogin.com/termlifeb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_term-life-PR"
                + ("&client_id=" + "8cc382b4-6f39-4c45-a668-f1c66c0d6944")
                + '&nonce=defaultNonce'
                + ("&redirect_uri=" + window.location.origin + "/login")
                + '&scope=openid'
                + '&response_type=id_token'
                + '&prompt=login';
            window.location.href = resetUrl;
        }
        else if (token) {
            var claims = __WEBPACK_IMPORTED_MODULE_1__common_utils__["m" /* default */].extractIdToken(token);
            if (claims.tfp === __WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].policyNameResetPwd) {
                var clientAppLoginAfterPasswordReset = setupAuthClient();
                return clientAppLoginAfterPasswordReset.loginRedirect(__WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].b2cScopes);
            }
            else if (claims.tfp !== __WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].policyNameMultiFactor && claims.extension_Role &&
                !JSON.parse(claims.extension_Role).some(function (r) { return r === 'Customer'; })) {
                clearMSALSession();
                authActions.logout();
                window.location.href = window.location.origin + "/require-multi-factor-login";
            }
        }
        // tslint:disable-next-line
        console.info('signupin callback ');
    }
    var clientApplication = new __WEBPACK_IMPORTED_MODULE_0__common_msal__["UserAgentApplication"](__WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* B2CConfiguration */].clientID, msalAuthority, SignUpInCallback, options);
    return clientApplication;
};
var generateResetPasswordUrl = function () {
    var resetUrl = "" + "https://termlifeb2c.b2clogin.com/termlifeb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_term-life-PR"
        + ("&client_id=" + "8cc382b4-6f39-4c45-a668-f1c66c0d6944")
        + '&nonce=defaultNonce'
        + ("&redirect_uri=" + window.location.origin + "/login")
        + '&scope=openid'
        + '&response_type=id_token'
        + '&prompt=login';
    return resetUrl;
};
/* harmony default export */ __webpack_exports__["a"] = (authActions);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var classNames = __webpack_require__(8);
var WorkflowStep = function (_a) {
    var className = _a.className, title = _a.title, description = _a.description, children = _a.children, hidden = _a.hidden;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('workflow-step content-set', className), hidden: hidden },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-8 mx-auto mb-2" },
                title && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("header", { className: classNames('page-header text-md-center', className) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "h3 page-header-title" + (description ? '' : ' mb-0') }, title),
                    description && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "max-read-width mx-auto strong" }, description))),
                !title && description && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mx-auto text-center strong" }, description))),
        children));
};
/* harmony default export */ __webpack_exports__["a"] = (WorkflowStep);


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var classNames = __webpack_require__(8);
var WorkflowFieldset = function (_a) {
    var className = _a.className, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('row', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg-10 col-xl-8 offset-lg-1 offset-xl-2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset content-set" }, children))));
};
/* harmony default export */ __webpack_exports__["a"] = (WorkflowFieldset);


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(227);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(229);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(234);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(73);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(240);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(242);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(243);
/* unused harmony reexport withRouter */



























/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Section__ = __webpack_require__(349);
/* unused harmony reexport Section */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SectionLeft__ = __webpack_require__(350);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__SectionLeft__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SectionMain__ = __webpack_require__(351);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__SectionMain__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SectionRight__ = __webpack_require__(352);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__SectionRight__["a"]; });






/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(319);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(129);
var isBuffer = __webpack_require__(320);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(417);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(419);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__(422);

var _HelmetConstants = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


function handleNoneOptionAndValidationHOC(WrappedComponent, config) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.onChange = function (e) {
                var customEvent = _this.createCustomQuestionEvent(e);
                _this.props.onQuestionnaireChange(customEvent);
            };
            _this.onBlur = function (e) {
                var customEvent = _this.createCustomQuestionEvent(e);
                _this.props.onQuestionnaireBlur(customEvent);
            };
            _this.createCustomQuestionEvent = function (e) {
                var value = __WEBPACK_IMPORTED_MODULE_1__common_utils__["m" /* default */].parseValueFromEvent(e);
                var answer = __assign({}, _this.props.questionnaire[config.questionName], (_a = {}, _a[e.target.name] = value, _a));
                if (e.target.name === config.questionName + "None" && value) {
                    // user clicked none option, remove all other options
                    answer = (_b = {},
                        _b[e.target.name] = value,
                        _b);
                }
                else {
                    answer[config.questionName + "None"] = false;
                }
                _this.addValidationToAnswer(answer);
                var questionnaireEvent = {
                    target: {
                        name: config.questionName,
                        value: answer,
                        type: 'custom',
                    }
                };
                return questionnaireEvent;
                var _a, _b;
            };
            _this.addValidationToAnswer = function (answer) {
                // add an isValid prop to the answer
                // if any of the answers in the answer object are true return valid.
                var isValid = Object.keys(answer).some(function (key) {
                    // if Other is true check if the details have been entered.
                    if (key === config.otherName && answer[key]) {
                        return answer[config.otherDetailsName];
                    }
                    else if (key === 'isValid') {
                        return false;
                    }
                    return answer[key];
                });
                answer.isValid = isValid;
                return answer;
            };
            return _this;
        }
        class_1.prototype.render = function () {
            if (this.props.questionnaire[config.questionName] === undefined) {
                this.props.questionnaire[config.questionName] = {};
            }
            var _a = this.props, onQuestionnaireBlur = _a.onQuestionnaireBlur, onQuestionnaireChange = _a.onQuestionnaireChange, passThroughProps = __rest(_a, ["onQuestionnaireBlur", "onQuestionnaireChange"]);
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrappedComponent, __assign({ onQuestionnaireBlur: this.onBlur, onQuestionnaireChange: this.onChange }, passThroughProps)));
        };
        return class_1;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
}
/* harmony default export */ __webpack_exports__["a"] = (handleNoneOptionAndValidationHOC);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reportAPI__ = __webpack_require__(524);


var reportActions = {
    fetchCustomersCount: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchCustomersCount()
            .then(function (customersCount) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMERS_COUNT, customersCount: customersCount });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchUserActivities: function (fromDate, toDate) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchUserActivities(fromDate, toDate)
            .then(function (users) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_USER_ACTIVITIES, users: users });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchPoliciesCount: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchPoliciesCount()
            .then(function (policiesCount) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_POLICIES_COUNT, policiesCount: policiesCount });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchPolicies: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchPolicies()
            .then(function (policies) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_POLICIES, policies: policies });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchUnmailedPoliciesCount: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchUnmailedPoliciesCount()
            .then(function (unmailedPoliciesCount) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_UNMAILED_POLICIES_COUNT, unmailedPoliciesCount: unmailedPoliciesCount });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchUnmailedPolicies: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchUnmailedPolicies()
            .then(function (unmailedPolicies) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_UNMAILED_POLICIES, unmailedPolicies: unmailedPolicies });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchFailedPaymentsCount: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchFailedPaymentsCount()
            .then(function (failedPaymentsCount) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_FAILED_PAYMENTS_COUNT, failedPaymentsCount: failedPaymentsCount });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchFailedPayments: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchFailedPayments()
            .then(function (failedPayments) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_FAILED_PAYMENTS, failedPayments: failedPayments });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchExpiringPoliciesCount: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchExpiringPoliciesCount()
            .then(function (expiringPoliciesCount) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_EXPIRING_POLICIES_COUNT, expiringPoliciesCount: expiringPoliciesCount });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchExpiringPolicies: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchExpiringPolicies()
            .then(function (expiringPolicies) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_EXPIRING_POLICIES, expiringPolicies: expiringPolicies });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchMissingBeneficiaryFormsCount: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchMissingBeneficiaryFormsCount()
            .then(function (missingBeneficiaryFormsCount) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_MISSING_BENEFICIARY_FORMS_COUNT, missingBeneficiaryFormsCount: missingBeneficiaryFormsCount });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchCustomersMissingBeneficiaryForms: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchCustomersMissingBeneficiaryForms()
            .then(function (customers) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMERS_MISSING_BENEFICIARY_FORMS, customers: customers });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchBouncedEmailsCount: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchBouncedEmailsCount()
            .then(function (bouncedEmailsCount) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_BOUNCED_EMAILS_COUNT, bouncedEmailsCount: bouncedEmailsCount });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchBouncedEmails: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchBouncedEmails()
            .then(function (bouncedEmails) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_BOUNCED_EMAILS, bouncedEmails: bouncedEmails });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    resolveBouncedEmail: function (id) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].resolveBouncedEmail(id)
            .then(function (bouncedEmail) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESOLVE_BOUNCED_EMAIL, bouncedEmail: bouncedEmail });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchFinancialExport: function (fromDate, toDate) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchFinancialExport(fromDate, toDate)
            .then(function (financials) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_FINANCIAL_REPORT, financials: financials });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchReferralReport: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__reportAPI__["a" /* default */].fetchReferralReport()
            .then(function (referrals) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_REFERRALS, referrals: referrals });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
};
/* harmony default export */ __webpack_exports__["a"] = (reportActions);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__quotingAPI__ = __webpack_require__(80);


var quotingActions = {
    fetchHeightWeightTable: function () { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__quotingAPI__["a" /* default */].fetchHeightWeightTable()
            .then(function (hwTable) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_HEIGHT_WEIGHT_TABLE, hwTable: hwTable });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchCustomerDetails: function (customerId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__quotingAPI__["a" /* default */].fetchCustomerDetails(customerId)
            .then(function (customerDetails) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_DETAILS, customerDetails: customerDetails });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchCustomerFamilyList: function (customerId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__quotingAPI__["a" /* default */].fetchCustomerFamilyList(customerId)
            .then(function (customerFamilyList) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_FAMILY_LIST, customerFamilyList: customerFamilyList });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    resetCustomerDetails: function () {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_CUSTOMER_DETAILS };
    },
    setCustomerDetails: function (customerDetails) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_DETAILS, customerDetails: customerDetails };
    },
    setCustomerFamilyList: function (customerFamilyList) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_FAMILY_LIST, customerFamilyList: customerFamilyList };
    },
    setQuotingAssessment: function (assessment) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_QUOTING_ASSESSMENT, assessment: assessment };
    },
    saveCustomerDetails: function (customerDetails) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__quotingAPI__["a" /* default */].saveCustomerDetails(customerDetails)
            .then(function (savedCustomerDetails) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_CUSTOMER_DETAILS, customerDetails: savedCustomerDetails });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    saveCustomerFamilyList: function (customerId, customerFamilyList) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__quotingAPI__["a" /* default */].saveCustomerFamilyList(customerId, customerFamilyList)
            .then(function (savedCustomerFamilyList) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_CUSTOMER_FAMILY_LIST, customerFamilyList: savedCustomerFamilyList });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    validateReferralCode: function (referralCode, userId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__quotingAPI__["a" /* default */].validateReferralCode(referralCode, userId)
            .then(function (validReferral) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].VALIDATE_REFERRALCODE_SUCCESS, validReferral: validReferral });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
};
/* harmony default export */ __webpack_exports__["a"] = (quotingActions);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RequiredLabel__ = __webpack_require__(153);


var Label = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: props.className, htmlFor: props.htmlFor },
        props.children && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "label-title" + (props.required ? ' label-title-required' : ''), dangerouslySetInnerHTML: { __html: props.children } })),
        props.required && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__RequiredLabel__["a" /* default */], null, "Required")));
};
/* harmony default export */ __webpack_exports__["a"] = (Label);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__paymentAPI__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_toastr__);



var paymentActions = {
    setStripe: function (stripe) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_STRIPE, stripe: stripe };
    },
    setPaymentDetails: function (details) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_PAYMENT_DETAILS, details: details };
    },
    createNewCustomerSubscription: function (userId, policyId, tokenId, referralCode, skipDeclineChecker, resetPasswordUrl) {
        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1__paymentAPI__["a" /* default */]
                .createNewCustomerSubscription(userId, policyId, tokenId, referralCode, skipDeclineChecker, resetPasswordUrl)
                .then(function (subscriptionResponse) {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].CREATE_SUBSCRIPTION, subscriptionResponse: subscriptionResponse });
            })
                .catch(function (err) {
                if (err.responseStatus) {
                    throw err.responseStatus.message;
                }
                throw err;
            });
        };
    },
    fetchPayment: function (invoiceNumber) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__paymentAPI__["a" /* default */].fetchPayment(invoiceNumber)
            .then(function (payment) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_PAYMENT, payment: payment });
        })
            .catch(function (err) {
            if (err.responseStatus) {
                __WEBPACK_IMPORTED_MODULE_2_toastr__["error"](err.responseStatus.message);
            }
        });
    }; },
    fetchCustomerPayment: function (userId, invoiceNumber) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__paymentAPI__["a" /* default */].fetchCustomerPayment(userId, invoiceNumber)
            .then(function (payment) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_PAYMENT, payment: payment });
        })
            .catch(function (err) {
            if (err.responseStatus) {
                __WEBPACK_IMPORTED_MODULE_2_toastr__["error"](err.responseStatus.message);
            }
        });
    }; },
    fetchCustomerPayments: function (userId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__paymentAPI__["a" /* default */].fetchCustomerPayments(userId)
            .then(function (payments) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_PAYMENTS, payments: payments });
        })
            .catch(function (err) {
            if (err.responseStatus) {
                __WEBPACK_IMPORTED_MODULE_2_toastr__["error"](err.responseStatus.message);
            }
        });
    }; },
    fetchCustomerUpcomingInvoice: function (userId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__paymentAPI__["a" /* default */].fetchCustomerUpcomingInvoice(userId)
            .then(function (invoice) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_UPCOMING_INVOICE, invoice: invoice });
        })
            .catch(function (err) {
            if (err.responseStatus) {
                __WEBPACK_IMPORTED_MODULE_2_toastr__["error"](err.responseStatus.message);
            }
        });
    }; },
    fetchCustomerCard: function (userId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__paymentAPI__["a" /* default */].fetchCustomerCard(userId)
            .then(function (card) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_CARD, card: card });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    fetchInvoiceCard: function (invoiceId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__paymentAPI__["a" /* default */].fetchInvoiceCard(invoiceId)
            .then(function (invoiceCard) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_INVOICE_CARD, invoiceCard: invoiceCard });
        })
            .catch(function (err) {
            throw err;
        });
    }; },
    payInvoice: function (invoiceId, token, customerId) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__paymentAPI__["a" /* default */].payInvoice(invoiceId, token, customerId)
            .then(function (paidInvoice) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].PAY_INVOICE, invoice: paidInvoice });
            __WEBPACK_IMPORTED_MODULE_2_toastr__["success"]('Payment successful!');
        })
            .catch(function (err) {
            if (err.responseStatus) {
                __WEBPACK_IMPORTED_MODULE_2_toastr__["error"](err.responseStatus.message);
            }
        });
    }; },
    updateCustomerCard: function (customerId, token) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__paymentAPI__["a" /* default */].updateCustomerCard(customerId, token)
            .then(function (updatedCustomerResponse) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_CUSTOMER_CARD, user: updatedCustomerResponse });
        })
            .catch(function (err) {
            if (err.responseStatus) {
                __WEBPACK_IMPORTED_MODULE_2_toastr__["error"](err.responseStatus.message);
            }
        });
    }; },
    updateCustomerPlan: function (policy, overwriteRate) { return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1__paymentAPI__["a" /* default */].updateCustomerPlan(policy, overwriteRate)
            .then(function (newPlan) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_CUSTOMER_PLAN, customerPolicy: newPlan });
        })
            .catch(function (err) {
            if (err.responseStatus) {
                __WEBPACK_IMPORTED_MODULE_2_toastr__["error"](err.responseStatus.message);
            }
        });
    }; },
};
/* harmony default export */ __webpack_exports__["a"] = (paymentActions);


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.19.2
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.19.2';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module)))

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultCustomerPolicy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultCustomerPolicyBeneficiary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return defaultTrustee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return defaultPlanOptions; });
/* unused harmony export defaultDeletedPlan */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return devQuestionnaire; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return defaultForeignTravel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return defaultDeclineChecker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var defaultCustomerPolicy = {
    coverageAmount: undefined,
    rate: undefined,
    term: undefined,
    statusId: '',
    effectiveDate: '',
    stripePlanId: '',
};
var defaultCustomerPolicyBeneficiary = {
    customerPolicyId: '',
    disbursementPercent: undefined,
    statusId: '',
    relationship: '',
    isRevocable: true,
    typeId: 'ea0bdce7b30e41f48ffbdce43d437497',
    shouldSendNotification: false,
};
var defaultTrustee = {
    customerPolicyId: '',
    disbursementPercent: undefined,
    firstName: '',
    lastName: '',
    email: '',
    statusId: '',
    typeId: 'ec0bdce7b30e41f48ffbdce43d437497'
};
var defaultPlanOptions = [{}];
var defaultDeletedPlan = {
    id: '',
    deleted: false
};
var devQuestionnaire = {
    heightUnit: 'in',
    weightUnit: 'lbs',
    maxWeightLoss: 8,
    ownPetsTypes: {},
    foreignTravelList: [],
    cancer: {
        cancerNone: true,
        isValid: true
    },
    heartCirculatory: {
        heartCirculatoryNone: true,
        isValid: true
    },
    psychological: {
        psychologicalNone: true,
        isValid: true
    },
    reproductive: {
        reproductiveNone: true,
        isValid: true
    },
    head: {
        headNone: true,
        isValid: true
    },
    immuno: {
        immunoNone: true,
        isValid: true
    },
    blood: {
        bloodNone: true,
        isValid: true
    },
    liver: {
        liverNone: true,
        isValid: true
    },
    respiratory: {
        respiratoryNone: true,
        isValid: true
    },
    neurological: {
        neurologicalNone: true,
        isValid: true
    },
    declareTrue: true,
    isCanadian: true,
    hasBeenCancelled: false,
    pendingCoverage: false,
    heightft: '6',
    height: '0',
    weight: '193',
    lostWeight: false,
    occupation: 'Employed',
    specificJob: 'occupationNoneOfTheAbove',
    jobDescription: 'Other',
    annualIncome: '55,555',
    householdIncome: '55,555',
    exerciseFrequentlyHours: '1',
    exerciseFrequentlyMinutes: '0',
    ownPets: false,
    driversLicense: false,
    speedingViolations: false,
    impairedViolations: false,
    otherViolations: false,
    revokedLicense: false,
    criminalOffense: false,
    activities: {
        activitiesNoneOfTheAbove: true
    },
    abroad: false,
    consumedAlcohol: false,
    usedTobacco: false,
    cannabis: false,
    controlledSubstances: false,
    substanceCounseling: false,
    furtherExamination: false,
    notConsultedDoctor: false,
    prescriptionPainkillers: false,
    familyDiagnosis: false,
    familyKidneyDisease: false
};
var defaultForeignTravel = {
    abroadLocation: '',
    abroadDuration: ''
};
var defaultDeclineChecker = {
    isDeclined: false
};
var mockAdvisoryOptions = [
    {
        rate: 23,
        coverageAmount: 350000,
        term: 15
    },
    {},
    {}
];
var mockBespokeOptions = [
    {
        rate: 10,
        term: 15
    },
    {
        rate: 15,
        term: 15
    },
    {
        rate: 23,
        term: 15
    }
];
var mockSimpleOptions = [
    {
        rate: 10,
        coverageAmount: 220000,
        term: 15
    },
    {
        rate: 15,
        coverageAmount: 220000,
        term: 15
    },
    {
        rate: 23,
        coverageAmount: 350000,
        term: 15
    }
];
var apiUrl = "https://www.insuredbymosaic.ca/api";
var policyAPI = {
    fetchPlanOptions: function (workflow) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                switch (workflow) {
                    case 'advisory':
                        resolve(mockAdvisoryOptions);
                        break;
                    case 'bespoke':
                        resolve(mockBespokeOptions);
                        break;
                    case 'simple':
                        resolve(mockSimpleOptions);
                        break;
                    default:
                        resolve(mockSimpleOptions);
                        break;
                }
            }, 1000);
        });
    },
    fetchSimplePlanOptions: function (params) {
        var data = { params: params };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/rates-simple.json", data)
            .then(function (resp) { return resp.data; });
    },
    fetchAdvisoryPlanOptions: function (params) {
        var data = { params: params };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/rates-advisory.json", data)
            .then(function (resp) { return resp.data; });
    },
    fetchBespokePlanOptions: function (params) {
        var data = { params: params };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/rates-bespoke.json", data)
            .then(function (resp) { return resp.data; });
    },
    fetchCustomerPolicy: function (userId, policyId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + userId + "/policies/" + policyId + ".json")
            .then(function (resp) { return resp.data; });
    },
    fetchCustomerPolicyFreeTrialMonths: function (userId, policyId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + userId + "/policies/" + policyId + "/free-trial-month.json")
            .then(function (resp) { return resp.data; });
    },
    fetchCustomerPolicyDocumentUrl: function (userId, policyId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + userId + "/policies/" + policyId + "/pdf")
            .then(function (resp) { return resp.data; });
    },
    fetchCustomerPolicies: function (userId, includeInactive) {
        var data = {
            params: { includeInactive: includeInactive || false }
        };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + userId + "/policies.json", data)
            .then(function (resp) { return resp.data; });
    },
    sendBeneficiaryUploadedConfirmation: function (userId, policyId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/emails/beneficiary-uploaded-confirmation", { userId: userId, policyId: policyId })
            .then(function (resp) { return resp.data; });
    },
    fetchRatePlusMinus: function (policyId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/rate-plus-minus/" + policyId + ".json")
            .then(function (resp) { return resp.data; });
    },
    fetchIsHardDeclined: function (userId, policyId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + userId + "/policies/" + policyId + "/isHardDeclined.json")
            .then(function (resp) { return resp.data; });
    },
    fetchIsSoftDeclined: function (userId, policyId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + userId + "/policies/" + policyId + "/isSoftDeclined.json")
            .then(function (resp) { return resp.data; });
    },
    fetchQuestionnaireReport: function (userId, policyId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + userId + "/policies/" + policyId + "/questionnaire-report.csv")
            .then(function (resp) { return resp.data; });
    },
    fetchPolicyAnswer: function (policyId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/policies/" + policyId + "/questionnaire-answers.json")
            .then(function (resp) { return resp.data; });
    },
    updatePolicyPaperCopyStatus: function (policyId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/policies/" + policyId + "/mailed-copy.json")
            .then(function (resp) { return resp.data; });
    },
    saveCustomerPolicy: function (customerPolicy) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/customers/policy", customerPolicy)
            .then(function (resp) { return resp.data; });
    },
    saveCustomerPolicyAnswer: function (policyId, questionName, value) {
        var data = { policyId: policyId, questionName: questionName, value: value };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/customers/policy/answer", data)
            .then(function (resp) { return resp.data; });
    },
    updatePolicy: function (policyId) {
        var data = { policyId: policyId };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/update-policy", data)
            .then(function (resp) { return resp.data; });
    },
    deleteCustomerPolicy: function (stripeCustomerId, stripePlanId) {
        var data = { stripeCustomerId: stripeCustomerId, stripePlanId: stripePlanId };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/customers/policy/delete", data)
            .then(function (resp) { return resp.data; });
    },
    rebuildCustomerPolicyPdf: function (customerId, policyId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/customers/" + customerId + "/policies/" + policyId + "/update-pdf.json")
            .then(function (resp) { return resp.data; });
    },
    saveAdminCustomerPolicy: function (customerPolicy) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/admin/customers/policy", customerPolicy)
            .then(function (resp) { return resp.data; });
    },
    fetchCustomerPolicyBeneficiary: function (userId, beneficiaryId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + userId + "/beneficiaries/" + beneficiaryId + ".json")
            .then(function (resp) { return resp.data; });
    },
    fetchCustomerPolicyBeneficiaries: function (userId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + userId + "/beneficiaries.json")
            .then(function (resp) { return resp.data; });
    },
    fetchCustomerPolicyBeneficiaryForm: function (userId, policyId, formId) {
        // TODO: the process of updating policy status probably should be separated into another method
        return new Promise(function (resolve) {
            window.location.href = apiUrl + "/customers/" + userId + "/policies/" + policyId + "/beneficiaryform/" + formId;
            setTimeout(function () { return resolve(true); }, 3000);
        });
    },
    saveCustomerPolicyBeneficiary: function (customerPolicyBeneficiary) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/customers/beneficiary", customerPolicyBeneficiary)
            .then(function (resp) { return resp.data; });
    },
    saveCustomerPolicyCurrentBeneficiary: function (customerPolicyCurrentBeneficiary) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/customers/confirmed-beneficiary", customerPolicyCurrentBeneficiary)
            .then(function (resp) { return resp.data; });
    },
    approveAllBeneficiariesForCustomer: function (request) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/customers/" + request.id + "/policies/" + request.policyId + "/approve-all-beneficiaries", request)
            .then(function (resp) { return resp.data; });
    },
    deleteCustomerPolicyBeneficiary: function (beneficiaryId, statusId) {
        var data = { beneficiaryId: beneficiaryId, statusId: statusId };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/customers/beneficiary/delete", data)
            .then(function (resp) { return resp.data; });
    },
    deleteBeneficiaryDuringSignUp: function (beneficiaryId) {
        var data = { beneficiaryId: beneficiaryId };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/beneficiaries/delete", data)
            .then(function (resp) { return resp.data; });
    },
    sendBeneficiaryNotification: function (userId, beneficiaryId) {
        var data = { userId: userId, beneficiaryId: beneficiaryId };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/emails/beneficiary-notification", data)
            .then(function (resp) { return resp.data; });
    },
    uploadSignedBeneficiaryDocumentUrl: function (customerId, policyId, file) {
        var url = apiUrl + "/admin/customers/" + customerId + "/policies/" + policyId + "/beneficiaries/upload-signed-form";
        var data = new FormData();
        data.append('file', file);
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, data)
            .then(function (resp) { return resp.data; });
    },
    fetchSignedBeneficiaryDocumentUrl: function (customerId, policyId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + customerId + "/policies/" + policyId + "/beneficiaries/get-signed-form-url")
            .then(function (resp) { return resp.data; });
    },
    sendCancelPolicyEmail: function (userId, policyId) {
        var data = {
            userId: userId,
            policyId: policyId,
        };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/emails/cancelpolicy-notification", data)
            .then(function (resp) { return resp.data; });
    },
};
/* harmony default export */ __webpack_exports__["a"] = (policyAPI);


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(378), __webpack_require__(9));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().

function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.testModeAPI = exports.OutboundLink = exports.plugin = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.initialize = initialize;
exports.ga = ga;
exports.set = set;
exports.send = send;
exports.pageview = pageview;
exports.modalview = modalview;
exports.timing = timing;
exports.event = event;
exports.exception = exception;
exports.outboundLink = outboundLink;

var _format2 = __webpack_require__(3);

var _format3 = _interopRequireDefault(_format2);

var _removeLeadingSlash = __webpack_require__(6);

var _removeLeadingSlash2 = _interopRequireDefault(_removeLeadingSlash);

var _trim = __webpack_require__(1);

var _trim2 = _interopRequireDefault(_trim);

var _loadGA = __webpack_require__(7);

var _loadGA2 = _interopRequireDefault(_loadGA);

var _warn = __webpack_require__(0);

var _warn2 = _interopRequireDefault(_warn);

var _log = __webpack_require__(8);

var _log2 = _interopRequireDefault(_log);

var _testModeAPI = __webpack_require__(9);

var _testModeAPI2 = _interopRequireDefault(_testModeAPI);

var _OutboundLink = __webpack_require__(10);

var _OutboundLink2 = _interopRequireDefault(_OutboundLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
                                                                                                                                                                                                     * React Google Analytics Module
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * @package react-ga
                                                                                                                                                                                                     * @author  Adam Lofting <adam@mozillafoundation.org>
                                                                                                                                                                                                     *          Atul Varma <atul@mozillafoundation.org>
                                                                                                                                                                                                     */

/**
 * Utilities
 */


var _debug = false;
var _titleCase = true;
var _testMode = false;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return _testModeAPI2.default.ga.apply(_testModeAPI2.default, arguments);
  if (!window.ga) return (0, _warn2.default)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return (0, _format3.default)(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];
  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      (0, _warn2.default)('ga command must be a string');
      return;
    }

    internalGa.apply(undefined, args);
    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(undefined, _toConsumableArray([name + '.' + command].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    (0, _warn2.default)('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (typeof window === 'undefined') {
      return false;
    }

    (0, _loadGA2.default)(options);
  }

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
        (0, _warn2.default)('All configs must be an object');
        return;
      }
      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }
  return true;
}

/**
 * ga:
 * Returns the original GA object.
 */
function ga() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(undefined, args);
    if (_debug) {
      (0, _log2.default)('called ga(\'arguments\');');
      (0, _log2.default)('with arguments: ' + JSON.stringify(args));
    }
  }

  return window.ga;
}

/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    (0, _warn2.default)('`fieldsObject` is required in .set()');
    return;
  }

  if ((typeof fieldsObject === 'undefined' ? 'undefined' : _typeof(fieldsObject)) !== 'object') {
    (0, _warn2.default)('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    (0, _warn2.default)('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    (0, _log2.default)('called ga(\'set\', fieldsObject);');
    (0, _log2.default)('with fieldsObject: ' + JSON.stringify(fieldsObject));
  }
}

/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);
  if (_debug) {
    (0, _log2.default)('called ga(\'send\', fieldObject);');
    (0, _log2.default)('with fieldObject: ' + JSON.stringify(fieldObject));
    (0, _log2.default)('with trackers: ' + JSON.stringify(trackerNames));
  }
}

/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */
function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    (0, _warn2.default)('path is required in .pageview()');
    return;
  }

  var path = (0, _trim2.default)(rawPath);
  if (path === '') {
    (0, _warn2.default)('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};
  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _extends({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';
      if (title) {
        extraLog = ' and title: ' + title;
      }
      (0, _log2.default)('with path: ' + path + extraLog);
    }
  }
}

/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    (0, _warn2.default)('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = (0, _removeLeadingSlash2.default)((0, _trim2.default)(rawModalName));

  if (modalName === '') {
    (0, _warn2.default)('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = '/modal/' + modalName;
    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
      (0, _log2.default)('with path: ' + path);
    }
  }
}

/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments[1];

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      (0, _warn2.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    }

    // Required Fields
    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}

/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var trackerNames = arguments[1];

  var category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ['category', 'action', 'label', 'value', 'nonInteraction', 'transport']);

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      (0, _warn2.default)('args.category AND args.action are required in event()');
      return;
    }

    // Required Fields
    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    };

    // Optional Fields
    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        (0, _warn2.default)('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        (0, _warn2.default)('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        (0, _warn2.default)('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          (0, _warn2.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });

    // Send to GA
    send(fieldObject, trackerNames);
  }
}

/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    };

    // Optional Fields
    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        (0, _warn2.default)('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    }

    // Send to GA
    send(fieldObject, trackerNames);
  }
}

var plugin = exports.plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   */
  require: function require(rawName, options) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        (0, _warn2.default)('`name` is required in .require()');
        return;
      }

      var name = (0, _trim2.default)(rawName);
      if (name === '') {
        (0, _warn2.default)('`name` cannot be an empty string in .require()');
        return;
      }

      // Optional Fields
      if (options) {
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
          (0, _warn2.default)('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          (0, _warn2.default)('Empty `options` given to .require()');
        }

        ga('require', name, options);

        if (_debug) {
          (0, _log2.default)('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options));
        }
      } else {
        ga('require', name);

        if (_debug) {
          (0, _log2.default)('called ga(\'require\', \'' + name + '\');');
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload = void 0;
    var actionType = void 0;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        (0, _warn2.default)('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        (0, _warn2.default)('Expected `action` arg to be a String.');
      } else {
        var command = pluginName + ':' + action;
        payload = payload || null;
        if (actionType && payload) {
          ga(command, actionType, payload);
          if (_debug) {
            (0, _log2.default)('called ga(\'' + command + '\');');
            (0, _log2.default)('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
          }
        } else if (payload) {
          ga(command, payload);
          if (_debug) {
            (0, _log2.default)('called ga(\'' + command + '\');');
            (0, _log2.default)('with payload: ' + JSON.stringify(payload));
          }
        } else {
          ga(command);
          if (_debug) {
            (0, _log2.default)('called ga(\'' + command + '\');');
          }
        }
      }
    }
  }
};

/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */
function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    (0, _warn2.default)('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      (0, _warn2.default)('args.label is required in outboundLink()');
      return;
    }

    // Required Fields
    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };

    var safetyCallbackCalled = false;
    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;

      hitCallback();
    };

    // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data

    // register safety net timeout:
    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);
      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA;

    // Send to GA
    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}

_OutboundLink2.default.origTrackLink = _OutboundLink2.default.trackLink;
_OutboundLink2.default.trackLink = outboundLink;
var OutboundLink = exports.OutboundLink = _OutboundLink2.default;
var testModeAPI = exports.testModeAPI = _testModeAPI2.default;

exports.default = {
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  OutboundLink: OutboundLink,
  testModeAPI: _testModeAPI2.default
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = format;

var _mightBeEmail = __webpack_require__(4);

var _mightBeEmail2 = _interopRequireDefault(_mightBeEmail);

var _toTitleCase = __webpack_require__(5);

var _toTitleCase2 = _interopRequireDefault(_toTitleCase);

var _warn = __webpack_require__(0);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var redacted = 'REDACTED (Potential Email Address)';

function format(s, titleCase) {
  if ((0, _mightBeEmail2.default)(s)) {
    (0, _warn2.default)('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return (0, _toTitleCase2.default)(s);
  }

  return s;
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return (/[^@]+@[^@]+/.test(s)
  );
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toTitleCase;

var _trim = __webpack_require__(1);

var _trim2 = _interopRequireDefault(_trim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; /**
                                                                                                * To Title Case 2.1 - http://individed.com/code/to-title-case/
                                                                                                * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
                                                                                                * https://github.com/gouch/to-title-case
                                                                                                */

function toTitleCase(string) {
  return (0, _trim2.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (options) {
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/
  /* eslint-disable */
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', options && options.gaAddress ? options.gaAddress : 'https://www.google-analytics.com/analytics.js', 'ga');
  /* eslint-enable */
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var gaCalls = exports.gaCalls = [];

exports.default = {
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  }
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warn = __webpack_require__(0);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink = function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutboundLink.__proto__ || Object.getPrototypeOf(OutboundLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick;

      var eventMeta = { label: eventLabel };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        });
      } else {
        OutboundLink.trackLink(eventMeta, function () {});
      }

      if (onClick) {
        onClick(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OutboundLink, [{
    key: 'render',
    value: function render() {
      var props = _extends({}, this.props, {
        href: this.props.to,
        onClick: this.handleClick
      });
      delete props.eventLabel;
      return _react2.default.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(_react.Component);

OutboundLink.propTypes = {
  eventLabel: _propTypes2.default.string.isRequired,
  target: _propTypes2.default.string,
  to: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
OutboundLink.defaultProps = {
  target: null,
  to: null,
  onClick: null
};

OutboundLink.trackLink = function () {
  (0, _warn2.default)('ga tracking not enabled');
};

exports.default = OutboundLink;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ })
/******/ ]);
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(114);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(116);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(74);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(51);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(119);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(120);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(52);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__withRouter__["a"]; });



















/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(182);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var pushHash = function pushHash(hash) {
  hash = hash ? hash.indexOf('#') === 0 ? hash : '#' + hash : '';

  if (history.pushState) {
    var loc = window.location;
    history.pushState(null, null, hash ? loc.pathname + loc.search + hash
    // remove hash
    : loc.pathname + loc.search);
  } else {
    location.hash = hash;
  }
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, '');
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var scrollOffset = function scrollOffset(c, t) {
  return c === document ? t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) : getComputedStyle(c).position === "relative" ? t.offsetTop : t.getBoundingClientRect().top + c.scrollTop;
};

exports.default = {
  pushHash: pushHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_ga__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__quoting_quotingActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_authActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__policy_policyActions__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};













var HomePageAssessment = /** @class */ (function (_super) {
    __extends(HomePageAssessment, _super);
    function HomePageAssessment(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = { age: {} };
        _this.onUserChange = function (e) {
            var user = __assign({}, _this.props.user, (_a = {}, _a[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value, _a));
            _this.props.actions.setUser(user);
            // Set user's age based on birthdate
            if (e.target.name === 'birthDate') {
                var age = __WEBPACK_IMPORTED_MODULE_11__common_utils__["m" /* default */].getAgeRoundedFromBirthdate(e.target.value);
                var customerDetails = __assign({}, _this.props.customerDetails, { age: age });
                _this.props.actions.setCustomerDetails(customerDetails);
            }
            var _a;
        };
        _this.onCustomerDetailsChange = function (e) {
            var value = e.target.value;
            if (e.target.type === 'radio') {
                if (value === 'true') {
                    value = true;
                }
                else if (value === 'false') {
                    value = false;
                }
            }
            else if (e.target.type === 'checkbox') {
                value = e.target.checked;
            }
            var customerDetails = __assign({}, _this.props.customerDetails, (_a = {}, _a[e.target.name] = value, _a));
            _this.props.actions.setCustomerDetails(customerDetails);
            var _a;
        };
        _this.getQuote = function () {
            var abTestIndex = __WEBPACK_IMPORTED_MODULE_11__common_utils__["m" /* default */].getABTestOptimizeIndex();
            __WEBPACK_IMPORTED_MODULE_4_react_ga__["set"]({ 'exp': "Szj9gW87RKe5Yo5GErN82A." + abTestIndex });
            var url = __WEBPACK_IMPORTED_MODULE_11__common_utils__["m" /* default */].getABTestWorkflowUrl(abTestIndex, _this.props.customerDetails.age, _this.props.user.gender);
            _this.props.history.push(url);
        };
        _this.handleBlur = function (field) { return function (evt) {
            _this.setState({
                touched: __assign({}, _this.state.touched, (_a = {}, _a[field] = true, _a))
            });
            var _a;
        }; };
        _this.validate = function () {
            // true means invalid
            return {
                age: __WEBPACK_IMPORTED_MODULE_11__common_utils__["k" /* Validation */].validateAge(_this.props.user.birthDate, _this.props.currentUser.isAuthenticated)
            };
        };
        _this.isGetQuoteDisabled = function () {
            // Allow user to click get quote even if inputs aren't filled. They will be redirected to the About You page.
            return _this.errors.age.hasError;
        };
        _this.state = {
            touched: {
                age: false
            }
        };
        return _this;
    }
    HomePageAssessment.prototype.componentDidMount = function () {
        // Only resetUser if not authenticated.
        // Otherwise, additional policies will be attached to new users and not the logged in user.
        if (!this.props.currentUser.isAuthenticated) {
            this.props.actions.resetUser();
            this.props.actions.resetCustomerDetails();
        }
        else {
            // Set user's age based on birthdate
            if (this.props.user.birthDate) {
                var age = __WEBPACK_IMPORTED_MODULE_11__common_utils__["m" /* default */].getAgeRoundedFromBirthdate(this.props.user.birthDate);
                var customerDetails = __assign({}, this.props.customerDetails, { age: age });
                this.props.actions.setCustomerDetails(customerDetails);
            }
        }
        this.props.actions.resetQuestionnaire();
        if (this.errors.age.hasError) {
            this.setState({
                touched: __assign({}, this.state.touched, { age: true })
            });
        }
    };
    HomePageAssessment.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "home-page-assessment" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 text-secondary mb-3" }, "Get covered and get your first two months free!"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "My birthdate is"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-daypicker-responsive form-daypicker-responsive-right" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_forms__["a" /* BirthDatePicker */]
                        // Age is set in the onChange handler based on birthdate
                        , { 
                            // Age is set in the onChange handler based on birthdate
                            className: "text-dark fixed-width", name: "birthDate", onBlur: this.handleBlur('age'), onChange: this.onUserChange, value: this.props.user.birthDate, error: __WEBPACK_IMPORTED_MODULE_11__common_utils__["m" /* default */].shouldMarkError(this.errors.age, this.state.touched.age) ? this.errors.age : undefined })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text ml-0" }, ","))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "my sex at birth is"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_forms__["g" /* DropdownInput */], { name: "gender", defaultOption: 'Select', options: [{ text: 'Male', value: 'male' }, { text: 'Female', value: 'female' }], onChange: this.onUserChange, value: this.props.user.gender }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text ml-0" }, ","))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-1" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "and I"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_forms__["o" /* ToggleSwitch */], { name: "isSmoker", onChildren: "Do", offChildren: "Do not", onChange: this.onCustomerDetailsChange, checked: this.props.customerDetails.isSmoker, className: "toggle-do-donot" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "use tobacco."))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_buttons_Button__["a" /* default */], { id: "getQuoteBtn", onClick: this.getQuote, className: "btn-primary mt-2 mt-lg-3", disabled: this.isGetQuoteDisabled() },
                "Get my quote! ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_icons__["m" /* IconArrowRight */], null))));
    };
    return HomePageAssessment;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        user: state.user.user,
        customerDetails: state.quoting.customerDetails,
        currentUser: state.auth.currentUser
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_5__quoting_quotingActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__user_userActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__policy_policyActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__auth_authActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(HomePageAssessment)));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.addMonths = addMonths;
exports.isSameDay = isSameDay;
exports.isDayBefore = isDayBefore;
exports.isDayAfter = isDayAfter;
exports.isPastDay = isPastDay;
exports.isFutureDay = isFutureDay;
exports.isDayBetween = isDayBetween;
exports.addDayToRange = addDayToRange;
exports.isDayInRange = isDayInRange;
exports.getWeekNumber = getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */
function clone(d) {
  return new Date(d.getTime());
}

/**
 * Return `d` as a new date with `n` months added.
 * 
 * @export
 * @param {[type]} d
 * @param {[type]} n
 */
function addMonths(d, n) {
  var newDate = clone(d);
  newDate.setMonth(d.getMonth() + n);
  return newDate;
}

/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameDay(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Returns `true` if the first day is before the second day.
 * 
 * @export
 * @param {Date} d1 
 * @param {Date} d2 
 * @returns {Boolean}
 */
function isDayBefore(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 < day2;
}

/**
 * Returns `true` if the first day is after the second day.
 * 
 * @export
 * @param {Date} d1 
 * @param {Date} d2 
 * @returns {Boolean}
 */
function isDayAfter(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 > day2;
}

/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isPastDay(d) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return isDayBefore(d, today);
}

/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isFutureDay(d) {
  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  tomorrow.setHours(0, 0, 0, 0);
  return d >= tomorrow;
}

/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isDayBetween(d, d1, d2) {
  var date = clone(d);
  date.setHours(0, 0, 0, 0);
  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
}

/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */
function addDayToRange(day) {
  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
  var from = range.from,
      to = range.to;

  if (!from) {
    from = day;
  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
    from = null;
    to = null;
  } else if (to && isDayBefore(day, from)) {
    from = day;
  } else if (to && isSameDay(day, to)) {
    from = day;
    to = day;
  } else {
    to = day;
    if (isDayBefore(to, from)) {
      to = from;
      from = day;
    }
  }

  return { from: from, to: to };
}

/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */
function isDayInRange(day, range) {
  var from = range.from,
      to = range.to;

  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
}

/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 * 
 * @export
 * @param {Date} day 
 * @returns {Number}
 */
function getWeekNumber(day) {
  var date = clone(day);
  date.setHours(0, 0, 0);
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}

exports.default = {
  addDayToRange: addDayToRange,
  addMonths: addMonths,
  clone: clone,
  getWeekNumber: getWeekNumber,
  isDayAfter: isDayAfter,
  isDayBefore: isDayBefore,
  isDayBetween: isDayBetween,
  isDayInRange: isDayInRange,
  isFutureDay: isFutureDay,
  isPastDay: isPastDay,
  isSameDay: isSameDay
};
//# sourceMappingURL=DateUtils.js.map

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var classNames = __webpack_require__(8);


var WorkflowProgress = /** @class */ (function (_super) {
    __extends(WorkflowProgress, _super);
    function WorkflowProgress(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            maxStepIndex: 0
        };
        return _this;
    }
    WorkflowProgress.prototype.componentDidMount = function () {
        this.setState({
            maxStepIndex: this.props.maxStepIndex || this.props.activeStep
        });
        __WEBPACK_IMPORTED_MODULE_1__common_utils__["m" /* default */].setDocTitle(this.props.steps[this.props.activeStep].label);
    };
    WorkflowProgress.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.activeStep > this.state.maxStepIndex) {
            this.setState({
                maxStepIndex: nextProps.activeStep
            });
        }
        if (nextProps.activeStep !== this.props.activeStep) {
            __WEBPACK_IMPORTED_MODULE_1__common_utils__["m" /* default */].setDocTitle(nextProps.steps[nextProps.activeStep].label);
        }
    };
    WorkflowProgress.prototype.render = function () {
        var _this = this;
        var _a = this.props, wrapperClassName = _a.wrapperClassName, buttonClassName = _a.buttonClassName, steps = _a.steps, activeStep = _a.activeStep;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('workflow-progress', wrapperClassName) }, steps.map(function (step, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('workflow-progress-item', {
                active: index === activeStep,
                disabled: step.incomplete || index > _this.state.maxStepIndex
            }), key: index },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["a" /* Button */], { onClick: step.onClick, to: step.to, tabIndex: step.incomplete || index > _this.state.maxStepIndex ? -1 : undefined, className: classNames('workflow-progress-link', buttonClassName, {
                    active: index === activeStep,
                    disabled: step.incomplete || index > _this.state.maxStepIndex,
                    'disable-click': step.disableClick
                }) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "mx-1 d-inline-block d-lg-none font-weight-normal" },
                    "Step ",
                    index + 1,
                    " of ",
                    steps.length,
                    ":"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "mx-1 d-inline-block" }, step.label)))); })));
    };
    return WorkflowProgress;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (WorkflowProgress);


/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(217)();
}


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementContextTypes = exports.injectContextTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(49);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Provider = __webpack_require__(70);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var injectContextTypes = exports.injectContextTypes = {
  getRegisteredElements: _propTypes2.default.func.isRequired,
  elements: _propTypes2.default.object
};

var elementContextTypes = exports.elementContextTypes = {
  addElementsLoadListener: _propTypes2.default.func.isRequired,
  registerElement: _propTypes2.default.func.isRequired,
  unregisterElement: _propTypes2.default.func.isRequired
};

var Elements = function (_React$Component) {
  _inherits(Elements, _React$Component);

  function Elements(props, context) {
    _classCallCheck(this, Elements);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this._elements = null;

    _this.handleRegisterElement = function (element, impliedTokenType, impliedSourceType, impliedPaymentMethodType) {
      _this.setState(function (prevState) {
        return {
          registeredElements: [].concat(_toConsumableArray(prevState.registeredElements), [_extends({
            element: element
          }, impliedTokenType ? { impliedTokenType: impliedTokenType } : {}, impliedSourceType ? { impliedSourceType: impliedSourceType } : {}, impliedPaymentMethodType ? { impliedPaymentMethodType: impliedPaymentMethodType } : {})])
        };
      });
    };

    _this.handleUnregisterElement = function (el) {
      _this.setState(function (prevState) {
        return {
          registeredElements: prevState.registeredElements.filter(function (_ref) {
            var element = _ref.element;
            return element !== el;
          })
        };
      });
    };

    var _this$props = _this.props,
        children = _this$props.children,
        options = _objectWithoutProperties(_this$props, ['children']);

    if (_this.context.tag === 'sync') {
      _this._elements = _this.context.stripe.elements(options);
    }

    _this.state = {
      registeredElements: []
    };
    return _this;
  }

  Elements.prototype.getChildContext = function getChildContext() {
    var _this2 = this;

    return {
      addElementsLoadListener: function addElementsLoadListener(fn) {
        // Return the existing elements instance if we already have one.
        if (_this2.context.tag === 'sync') {
          // This is impossible, but we need to make flow happy.
          if (!_this2._elements) {
            throw new Error('Expected elements to be instantiated but it was not.');
          }

          fn(_this2._elements);
        } else {
          _this2.context.addStripeLoadListener(function (stripe) {
            if (_this2._elements) {
              fn(_this2._elements);
            } else {
              var _props = _this2.props,
                  _children = _props.children,
                  options = _objectWithoutProperties(_props, ['children']);

              _this2._elements = stripe.elements(options);
              fn(_this2._elements);
            }
          });
        }
      },
      registerElement: this.handleRegisterElement,
      unregisterElement: this.handleUnregisterElement,
      getRegisteredElements: function getRegisteredElements() {
        return _this2.state.registeredElements;
      },
      elements: this._elements
    };
  };

  Elements.prototype.render = function render() {
    return _react2.default.Children.only(this.props.children);
  };

  return Elements;
}(_react2.default.Component);

Elements.childContextTypes = _extends({}, injectContextTypes, elementContextTypes);
Elements.contextTypes = _Provider.providerContextTypes;
Elements.defaultProps = {
  children: null
};
exports.default = Elements;

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(41);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pickListAPI__ = __webpack_require__(347);


var pickListActions = {
    setPickListType: function (pickListType) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_PICKLIST_TYPE_SUCCESS, pickListType: pickListType };
    },
    setPickListItem: function (pickListItem) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_PICKLIST_ITEM_SUCCESS, pickListItem: pickListItem };
    },
    getPickListType: function (id) {
        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1__pickListAPI__["a" /* default */].getPickListType(id)
                .then(function (pickListType) {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].GET_PICKLIST_TYPE_SUCCESS, pickListType: pickListType });
            })
                .catch(function (error) {
                throw (error);
            });
        };
    },
    getPickListTypes: function () {
        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1__pickListAPI__["a" /* default */].getPickListTypes()
                .then(function (pickListTypes) {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].GET_PICKLIST_TYPES_SUCCESS, pickListTypes: pickListTypes });
            })
                .catch(function (error) {
                throw (error);
            });
        };
    },
    getPickListItem: function (itemId) {
        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1__pickListAPI__["a" /* default */].getPickListItem(itemId)
                .then(function (pickListItem) {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].GET_PICKLIST_ITEM_SUCCESS, pickListItem: pickListItem });
            })
                .catch(function (error) {
                throw (error);
            });
        };
    },
    getPickListItems: function () {
        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1__pickListAPI__["a" /* default */].getPickListItems()
                .then(function (pickListItems) {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].GET_PICKLIST_ITEMS_SUCCESS, pickListItems: pickListItems });
            })
                .catch(function (error) {
                throw (error);
            });
        };
    },
    savePickListType: function (type) {
        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1__pickListAPI__["a" /* default */].savePickListType(type)
                .then(function (pickListType) {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_PICKLIST_TYPE_SUCCESS, pickListType: pickListType });
            });
        };
    },
    savePickListItem: function (item) {
        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1__pickListAPI__["a" /* default */].savePickListItem(item)
                .then(function (pickListItem) {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_PICKLIST_ITEM_SUCCESS, pickListItem: pickListItem });
            });
        };
    }
};
/* harmony default export */ __webpack_exports__["a"] = (pickListActions);


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(363);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(21);


var classNames = __webpack_require__(8);
var NavItem = function (originalProps) {
    var to = originalProps.to, onClick = originalProps.onClick, onFocus = originalProps.onFocus, onBlur = originalProps.onBlur, className = originalProps.className, linkClassName = originalProps.linkClassName, linkDataFlyout = originalProps.linkDataFlyout, linkExactActive = originalProps.linkExactActive, children = originalProps.children, rolesRequired = originalProps.rolesRequired, currentRoles = originalProps.currentRoles;
    // authorized if current roles contains 1 or more required roles
    // or if no roles are required, or if no roles required and no current roles
    var isAuthorized = !Array.isArray(rolesRequired) ||
        rolesRequired.length === 0 ||
        rolesRequired.some(function (role) { return Array.isArray(currentRoles) && currentRoles.indexOf(role) >= 0; });
    return isAuthorized ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: classNames('nav-item', className) }, to && onClick ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */], { to: to, onClick: onClick, onFocus: onFocus, onBlur: onBlur, activeClassName: "active", className: classNames('nav-link', linkClassName), "data-flyout": linkDataFlyout, exact: linkExactActive },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "nav-link-label" }, children))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "nav-heading" }, children)))) : null;
};
/* harmony default export */ __webpack_exports__["a"] = (NavItem);


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(42);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(146);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(94);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports.default = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    if (_scrollEvents2.default.registered.begin) {
      _scrollEvents2.default.registered.begin(to, target);
    }

    props.absolute = true;

    var scrollOffset = _utils2.default.scrollOffset(containerElement, target) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (containerElement === document) {
        window.scrollTo(0, scrollOffset);
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Proxy object to map classnames when css modules are not used

exports.default = {
  container: 'DayPicker',
  wrapper: 'DayPicker-wrapper',
  interactionDisabled: 'DayPicker--interactionDisabled',
  month: 'DayPicker-Month',

  navBar: 'DayPicker-NavBar',
  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',

  caption: 'DayPicker-Caption',
  weekdays: 'DayPicker-Weekdays',
  weekdaysRow: 'DayPicker-WeekdaysRow',
  weekday: 'DayPicker-Weekday',
  body: 'DayPicker-Body',
  week: 'DayPicker-Week',
  weekNumber: 'DayPicker-WeekNumber',
  day: 'DayPicker-Day',
  footer: 'DayPicker-Footer',
  todayButton: 'DayPicker-TodayButton',

  // default modifiers
  today: 'today',
  selected: 'selected',
  disabled: 'disabled',
  outside: 'outside'
};
//# sourceMappingURL=classNames.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.cancelEvent = cancelEvent;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getDaysInMonth = getDaysInMonth;
exports.getModifiersFromProps = getModifiersFromProps;
exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
exports.isRangeOfDates = isRangeOfDates;
exports.getMonthsDiff = getMonthsDiff;
exports.getWeekArray = getWeekArray;
exports.startOfMonth = startOfMonth;
exports.getDayNodes = getDayNodes;
exports.nodeListToArray = nodeListToArray;
exports.hasOwnProp = hasOwnProp;

var _DateUtils = __webpack_require__(44);

var _LocaleUtils = __webpack_require__(151);

var _classNames = __webpack_require__(59);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cancelEvent(e) {
  e.preventDefault();
  e.stopPropagation();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getModifiersFromProps(props) {
  var modifiers = _extends({}, props.modifiers);
  if (props.selectedDays) {
    modifiers[props.classNames.selected] = props.selectedDays;
  }
  if (props.disabledDays) {
    modifiers[props.classNames.disabled] = props.disabledDays;
  }
  return modifiers;
}

function getFirstDayOfWeekFromProps(props) {
  var firstDayOfWeek = props.firstDayOfWeek,
      _props$locale = props.locale,
      locale = _props$locale === undefined ? 'en' : _props$locale,
      _props$localeUtils = props.localeUtils,
      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;

  if (!isNaN(firstDayOfWeek)) {
    return firstDayOfWeek;
  }
  if (localeUtils.getFirstDayOfWeek) {
    return localeUtils.getFirstDayOfWeek(locale);
  }
  return 0;
}

function isRangeOfDates(value) {
  return !!(value && value.from && value.to);
}

function getMonthsDiff(d1, d2) {
  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}

function getWeekArray(d) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _LocaleUtils.getFirstDayOfWeek)();
  var fixedWeeks = arguments[2];

  var daysInMonth = getDaysInMonth(d);
  var dayArray = [];

  var week = [];
  var weekArray = [];

  for (var i = 1; i <= daysInMonth; i += 1) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
  }

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      weekArray.push(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      weekArray.push(week);
    }
  });

  // unshift days to start the first week
  var firstWeek = weekArray[0];
  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
    var outsideDate = (0, _DateUtils.clone)(firstWeek[0]);
    outsideDate.setDate(firstWeek[0].getDate() - 1);
    firstWeek.unshift(outsideDate);
  }

  // push days until the end of the last week
  var lastWeek = weekArray[weekArray.length - 1];
  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
    var _outsideDate = (0, _DateUtils.clone)(lastWeek[lastWeek.length - 1]);
    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
    lastWeek.push(_outsideDate);
  }

  // add extra weeks to reach 6 weeks
  if (fixedWeeks && weekArray.length < 6) {
    var lastExtraWeek = void 0;

    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
      lastExtraWeek = weekArray[weekArray.length - 1];
      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
      var extraWeek = [];

      for (var j = 0; j < 7; j += 1) {
        var _outsideDate2 = (0, _DateUtils.clone)(lastDay);
        _outsideDate2.setDate(lastDay.getDate() + j + 1);
        extraWeek.push(_outsideDate2);
      }

      weekArray.push(extraWeek);
    }
  }

  return weekArray;
}

function startOfMonth(d) {
  var newDate = (0, _DateUtils.clone)(d);
  newDate.setDate(1);
  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
  return newDate;
}

function getDayNodes(node, classNames) {
  var outsideClassName = void 0;
  if (classNames === _classNames2.default) {
    // When using CSS modules prefix the modifier as required by the BEM syntax
    outsideClassName = classNames.day + '--' + classNames.outside;
  } else {
    outsideClassName = '' + classNames.outside;
  }
  var dayQuery = classNames.day.replace(/ /g, '.');
  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
  return node.querySelectorAll(selector);
}

function nodeListToArray(nodeList) {
  return Array.prototype.slice.call(nodeList, 0);
}

function hasOwnProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
//# sourceMappingURL=Helpers.js.map

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Label__ = __webpack_require__(31);

var classNames = __webpack_require__(8);

var DropdownInput = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-group', props.className) },
        props.labelText ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Label__["a" /* default */], { htmlFor: props.name, required: props.required }, props.labelText)) : null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("select", { className: classNames('form-control', props.controlClassName), id: props.id || props.name, name: props.name, value: props.value, defaultValue: '', onBlur: props.onBlur, onChange: props.onChange, required: true, disabled: props.disabled },
                props.defaultOption && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option", { value: "", disabled: true }, props.defaultOption)),
                props.options.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option", { key: option.value, value: option.value }, option.text)); })))));
};
/* harmony default export */ __webpack_exports__["a"] = (DropdownInput);


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




var AboutYou = /** @class */ (function (_super) {
    __extends(AboutYou, _super);
    function AboutYou(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBlur = function (field) { return function (evt) {
            _this.setState({
                touched: __assign({}, _this.state.touched, (_a = {}, _a[field] = true, _a))
            });
            var _a;
        }; };
        _this.state = {
            touched: {
                age: false
            }
        };
        return _this;
    }
    AboutYou.prototype.componentDidMount = function () {
        if (this.props.errors.age.hasError) {
            this.setState({
                touched: __assign({}, this.state.touched, { age: true })
            });
        }
    };
    AboutYou.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("fieldset", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_helmet__["Helmet"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { charSet: "utf-8" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "Get a quote from life insurance from Mosaic life by filling out some details about yourself." }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Get a Quote - About You | Mosaic Life ")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text form-inline-text-full" }, "My birthdate is"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-daypicker-responsive" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["a" /* BirthDatePicker */]
                        // Age is set in the onChange handler based on birthdate
                        , { 
                            // Age is set in the onChange handler based on birthdate
                            className: "fixed-width", name: "birthDate", onBlur: this.handleBlur('age'), onChange: this.props.onUserChange, value: this.props.user.birthDate, error: __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].shouldMarkError(this.props.errors.age, this.state.touched.age)
                                ? this.props.errors.age
                                : undefined })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text ml-0" }, "."))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text form-inline-text-full" }, "My sex at birth is"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["g" /* DropdownInput */], { name: "gender", defaultOption: "Select", options: [{ text: 'Male', value: 'male' }, { text: 'Female', value: 'female' }], onChange: this.props.onUserChange, value: this.props.user.gender }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text ml-0" }, "."))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text form-inline-text-full" }, "I"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { name: "isSmoker", onChildren: "Do", offChildren: "Do not", onChange: this.props.onCustomerDetailsChange, checked: this.props.customerDetails.isSmoker, className: "toggle-do-donot" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text form-inline-text-full" }, "use tobacco.")))));
    };
    return AboutYou;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AboutYou);


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnrollmentWorkflow__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var EnrollmentPage = /** @class */ (function (_super) {
    __extends(EnrollmentPage, _super);
    function EnrollmentPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setDevQuestionnaire = function () {
            _this.props.actions.setDevQuestionnaire();
            _this.props.history.push("/quote/A/enrollment/review");
        };
        _this.redirectIfInvalidData = function () {
            if (_this.props.customerPolicy.id == null || _this.props.user.id == null) {
                _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/about-you");
            }
        };
        return _this;
    }
    EnrollmentPage.prototype.componentDidMount = function () {
        this.redirectIfInvalidData();
    };
    EnrollmentPage.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.match.params.page !== this.props.match.params.page ||
            nextProps.match.params.enrollmentPage !== this.props.match.params.enrollmentPage) {
            this.redirectIfInvalidData();
        }
    };
    EnrollmentPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__EnrollmentWorkflow__["a" /* default */], __assign({}, this.props)),
            "production" !== 'production' && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["a" /* Button */], { className: "btn-outline-secondary mt-3", onClick: this.setDevQuestionnaire }, "Auto-fill questionnaire (dev)")))));
    };
    return EnrollmentPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (EnrollmentPage);


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InjectedPaymentDetailsForm__ = __webpack_require__(502);



var PaymentDetailsForm = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { hidden: props.hidden },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__["Elements"], { fonts: [
                {
                    cssSrc: 'https://fonts.googleapis.com/css?family=Nunito+Sans:400'
                }
            ] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__InjectedPaymentDetailsForm__["a" /* default */], { details: props.details, actions: props.actions, onStripeElementChange: props.onStripeElementChange }))));
};
/* harmony default export */ __webpack_exports__["a"] = (PaymentDetailsForm);


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SliderConstants = __webpack_require__(508);

var SliderConstants = _interopRequireWildcard(_SliderConstants);

var _linear = __webpack_require__(509);

var _linear2 = _interopRequireDefault(_linear);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* globals document */
/* eslint react/no-array-index-key: 1 */

function getClassName(props) {
  var orientation = props.orientation === 'vertical' ? 'rheostat-vertical' : 'rheostat-horizontal';

  return ['rheostat', orientation].concat(props.className.split(' ')).join(' ');
}

var has = Object.prototype.hasOwnProperty;

var PropTypeArrOfNumber = _propTypes2['default'].arrayOf(_propTypes2['default'].number);
var PropTypeReactComponent = _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].string]);

function getHandleFor(ev) {
  return Number(ev.currentTarget.getAttribute('data-handle-key'));
}

function killEvent(ev) {
  ev.stopPropagation();
  ev.preventDefault();
}

var Button = function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement('button', _extends({}, this.props, { type: 'button' }));
      }

      return render;
    }()
  }]);

  return Button;
}(_react2['default'].Component);

var propTypes = {
  // the algorithm to use
  algorithm: _propTypes2['default'].shape({
    getValue: _propTypes2['default'].func,
    getPosition: _propTypes2['default'].func
  }),
  // any children you pass in
  children: _propTypes2['default'].any,
  // standard class name you'd like to apply to the root element
  className: _propTypes2['default'].string,
  // prevent the slider from moving when clicked
  disabled: _propTypes2['default'].bool,
  // a custom handle you can pass in
  handle: PropTypeReactComponent,
  // the maximum possible value
  max: _propTypes2['default'].number,
  // the minimum possible value
  min: _propTypes2['default'].number,
  // called on click
  onClick: _propTypes2['default'].func,
  // called whenever the user is done changing values on the slider
  onChange: _propTypes2['default'].func,
  // called on key press
  onKeyPress: _propTypes2['default'].func,
  // called when you finish dragging a handle
  onSliderDragEnd: _propTypes2['default'].func,
  // called every time the slider is dragged and the value changes
  onSliderDragMove: _propTypes2['default'].func,
  // called when you start dragging a handle
  onSliderDragStart: _propTypes2['default'].func,
  // called whenever the user is actively changing the values on the slider
  // (dragging, clicked, keypress)
  onValuesUpdated: _propTypes2['default'].func,
  // the orientation
  orientation: _propTypes2['default'].oneOf(['horizontal', 'vertical']),
  // a component for rendering the pits
  pitComponent: PropTypeReactComponent,
  // the points that pits are rendered on
  pitPoints: PropTypeArrOfNumber,
  // a custom progress bar you can pass in
  progressBar: PropTypeReactComponent,
  // should we snap?
  snap: _propTypes2['default'].bool,
  // the points we should snap to
  snapPoints: PropTypeArrOfNumber,
  // the values
  values: PropTypeArrOfNumber
};

var defaultProps = {
  algorithm: _linear2['default'],
  className: '',
  disabled: false,
  handle: Button,
  max: SliderConstants.PERCENT_FULL,
  min: SliderConstants.PERCENT_EMPTY,
  orientation: 'horizontal',
  pitPoints: [],
  progressBar: 'div',
  snap: false,
  snapPoints: [],
  values: [SliderConstants.PERCENT_EMPTY]
};

var Rheostat = function (_React$Component2) {
  _inherits(Rheostat, _React$Component2);

  function Rheostat(props) {
    _classCallCheck(this, Rheostat);

    var _this2 = _possibleConstructorReturn(this, (Rheostat.__proto__ || Object.getPrototypeOf(Rheostat)).call(this, props));

    var _this2$props = _this2.props,
        max = _this2$props.max,
        min = _this2$props.min,
        values = _this2$props.values;

    _this2.state = {
      className: getClassName(_this2.props),
      handlePos: values.map(function (value) {
        return _this2.props.algorithm.getPosition(value, min, max);
      }),
      handleDimensions: 0,
      mousePos: null,
      sliderBox: {},
      slidingIndex: null,
      values: values
    };
    _this2.getPublicState = _this2.getPublicState.bind(_this2);
    _this2.getSliderBoundingBox = _this2.getSliderBoundingBox.bind(_this2);
    _this2.getProgressStyle = _this2.getProgressStyle.bind(_this2);
    _this2.getMinValue = _this2.getMinValue.bind(_this2);
    _this2.getMaxValue = _this2.getMaxValue.bind(_this2);
    _this2.getHandleDimensions = _this2.getHandleDimensions.bind(_this2);
    _this2.getClosestSnapPoint = _this2.getClosestSnapPoint.bind(_this2);
    _this2.getSnapPosition = _this2.getSnapPosition.bind(_this2);
    _this2.getNextPositionForKey = _this2.getNextPositionForKey.bind(_this2);
    _this2.getNextState = _this2.getNextState.bind(_this2);
    _this2.handleClick = _this2.handleClick.bind(_this2);
    _this2.getClosestHandle = _this2.getClosestHandle.bind(_this2);
    _this2.setStartSlide = _this2.setStartSlide.bind(_this2);
    _this2.startMouseSlide = _this2.startMouseSlide.bind(_this2);
    _this2.startTouchSlide = _this2.startTouchSlide.bind(_this2);
    _this2.handleMouseSlide = _this2.handleMouseSlide.bind(_this2);
    _this2.handleTouchSlide = _this2.handleTouchSlide.bind(_this2);
    _this2.handleSlide = _this2.handleSlide.bind(_this2);
    _this2.endSlide = _this2.endSlide.bind(_this2);
    _this2.handleKeydown = _this2.handleKeydown.bind(_this2);
    _this2.validatePosition = _this2.validatePosition.bind(_this2);
    _this2.validateValues = _this2.validateValues.bind(_this2);
    _this2.canMove = _this2.canMove.bind(_this2);
    _this2.fireChangeEvent = _this2.fireChangeEvent.bind(_this2);
    _this2.slideTo = _this2.slideTo.bind(_this2);
    _this2.updateNewValues = _this2.updateNewValues.bind(_this2);
    return _this2;
  }

  _createClass(Rheostat, [{
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var minMaxChanged = nextProps.min !== this.props.min || nextProps.max !== this.props.max;

        var valuesChanged = this.state.values.length !== nextProps.values.length || this.state.values.some(function (value, idx) {
          return nextProps.values[idx] !== value;
        });

        var orientationChanged = nextProps.className !== this.props.className || nextProps.orientation !== this.props.orientation;

        var willBeDisabled = nextProps.disabled && !this.props.disabled;

        if (orientationChanged) {
          this.setState({
            className: getClassName(nextProps)
          });
        }

        if (minMaxChanged || valuesChanged) this.updateNewValues(nextProps);

        if (willBeDisabled && this.state.slidingIndex !== null) {
          this.endSlide();
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'getPublicState',
    value: function () {
      function getPublicState() {
        return {
          max: this.props.max,
          min: this.props.min,
          values: this.state.values
        };
      }

      return getPublicState;
    }()

    // istanbul ignore next

  }, {
    key: 'getSliderBoundingBox',
    value: function () {
      function getSliderBoundingBox() {
        var rheostat = this.refs.rheostat;

        var node = rheostat.getDOMNode ? rheostat.getDOMNode() : rheostat;
        var rect = node.getBoundingClientRect();

        return {
          height: rect.height || node.clientHeight,
          left: rect.left,
          top: rect.top,
          width: rect.width || node.clientWidth
        };
      }

      return getSliderBoundingBox;
    }()
  }, {
    key: 'getProgressStyle',
    value: function () {
      function getProgressStyle(idx) {
        var handlePos = this.state.handlePos;


        var value = handlePos[idx];

        if (idx === 0) {
          return this.props.orientation === 'vertical' ? { height: String(value) + '%', top: 0 } : { left: 0, width: String(value) + '%' };
        }

        var prevValue = handlePos[idx - 1];
        var diffValue = value - prevValue;

        return this.props.orientation === 'vertical' ? { height: diffValue + '%', top: String(prevValue) + '%' } : { left: String(prevValue) + '%', width: diffValue + '%' };
      }

      return getProgressStyle;
    }()
  }, {
    key: 'getMinValue',
    value: function () {
      function getMinValue(idx) {
        return this.state.values[idx - 1] ? Math.max(this.props.min, this.state.values[idx - 1]) : this.props.min;
      }

      return getMinValue;
    }()
  }, {
    key: 'getMaxValue',
    value: function () {
      function getMaxValue(idx) {
        return this.state.values[idx + 1] ? Math.min(this.props.max, this.state.values[idx + 1]) : this.props.max;
      }

      return getMaxValue;
    }()

    // istanbul ignore next

  }, {
    key: 'getHandleDimensions',
    value: function () {
      function getHandleDimensions(ev, sliderBox) {
        var handleNode = ev.currentTarget || null;

        if (!handleNode) return 0;

        return this.props.orientation === 'vertical' ? handleNode.clientHeight / sliderBox.height * SliderConstants.PERCENT_FULL / 2 : handleNode.clientWidth / sliderBox.width * SliderConstants.PERCENT_FULL / 2;
      }

      return getHandleDimensions;
    }()
  }, {
    key: 'getClosestSnapPoint',
    value: function () {
      function getClosestSnapPoint(value) {
        if (!this.props.snapPoints.length) return value;

        return this.props.snapPoints.reduce(function (snapTo, snap) {
          return Math.abs(snapTo - value) < Math.abs(snap - value) ? snapTo : snap;
        });
      }

      return getClosestSnapPoint;
    }()
  }, {
    key: 'getSnapPosition',
    value: function () {
      function getSnapPosition(positionPercent) {
        if (!this.props.snap) return positionPercent;

        var _props = this.props,
            algorithm = _props.algorithm,
            max = _props.max,
            min = _props.min;


        var value = algorithm.getValue(positionPercent, min, max);

        var snapValue = this.getClosestSnapPoint(value);

        return algorithm.getPosition(snapValue, min, max);
      }

      return getSnapPosition;
    }()
  }, {
    key: 'getNextPositionForKey',
    value: function () {
      function getNextPositionForKey(idx, keyCode) {
        var _stepMultiplier;

        var _state = this.state,
            handlePos = _state.handlePos,
            values = _state.values;
        var _props2 = this.props,
            algorithm = _props2.algorithm,
            max = _props2.max,
            min = _props2.min,
            snapPoints = _props2.snapPoints;


        var shouldSnap = this.props.snap;

        var proposedValue = values[idx];
        var proposedPercentage = handlePos[idx];
        var originalPercentage = proposedPercentage;
        var stepValue = 1;

        if (max >= 100) {
          proposedPercentage = Math.round(proposedPercentage);
        } else {
          stepValue = 100 / (max - min);
        }

        var currentIndex = null;

        if (shouldSnap) {
          currentIndex = snapPoints.indexOf(this.getClosestSnapPoint(values[idx]));
        }

        var stepMultiplier = (_stepMultiplier = {}, _defineProperty(_stepMultiplier, SliderConstants.KEYS.LEFT, function (v) {
          return v * -1;
        }), _defineProperty(_stepMultiplier, SliderConstants.KEYS.RIGHT, function (v) {
          return v * 1;
        }), _defineProperty(_stepMultiplier, SliderConstants.KEYS.UP, function (v) {
          return v * 1;
        }), _defineProperty(_stepMultiplier, SliderConstants.KEYS.DOWN, function (v) {
          return v * -1;
        }), _defineProperty(_stepMultiplier, SliderConstants.KEYS.PAGE_DOWN, function (v) {
          return v > 1 ? -v : v * -10;
        }), _defineProperty(_stepMultiplier, SliderConstants.KEYS.PAGE_UP, function (v) {
          return v > 1 ? v : v * 10;
        }), _stepMultiplier);

        if (has.call(stepMultiplier, keyCode)) {
          proposedPercentage += stepMultiplier[keyCode](stepValue);

          if (shouldSnap) {
            if (proposedPercentage > originalPercentage) {
              // move cursor right unless overflow
              if (currentIndex < snapPoints.length - 1) {
                proposedValue = snapPoints[currentIndex + 1];
              }
              // move cursor left unless there is overflow
            } else if (currentIndex > 0) {
              proposedValue = snapPoints[currentIndex - 1];
            }
          }
        } else if (keyCode === SliderConstants.KEYS.HOME) {
          proposedPercentage = SliderConstants.PERCENT_EMPTY;

          if (shouldSnap) {
            proposedValue = snapPoints[0];
          }
        } else if (keyCode === SliderConstants.KEYS.END) {
          proposedPercentage = SliderConstants.PERCENT_FULL;

          if (shouldSnap) {
            proposedValue = snapPoints[snapPoints.length - 1];
          }
        } else {
          return null;
        }

        return shouldSnap ? algorithm.getPosition(proposedValue, min, max) : proposedPercentage;
      }

      return getNextPositionForKey;
    }()
  }, {
    key: 'getNextState',
    value: function () {
      function getNextState(idx, proposedPosition) {
        var _this3 = this;

        var handlePos = this.state.handlePos;
        var _props3 = this.props,
            max = _props3.max,
            min = _props3.min;


        var actualPosition = this.validatePosition(idx, proposedPosition);

        var nextHandlePos = handlePos.map(function (pos, index) {
          return index === idx ? actualPosition : pos;
        });

        return {
          handlePos: nextHandlePos,
          values: nextHandlePos.map(function (pos) {
            return _this3.props.algorithm.getValue(pos, min, max);
          })
        };
      }

      return getNextState;
    }()
  }, {
    key: 'getClosestHandle',
    value: function () {
      function getClosestHandle(positionPercent) {
        var handlePos = this.state.handlePos;


        return handlePos.reduce(function (closestIdx, node, idx) {
          var challenger = Math.abs(handlePos[idx] - positionPercent);
          var current = Math.abs(handlePos[closestIdx] - positionPercent);
          return challenger < current ? idx : closestIdx;
        }, 0);
      }

      return getClosestHandle;
    }()

    // istanbul ignore next

  }, {
    key: 'setStartSlide',
    value: function () {
      function setStartSlide(ev, x, y) {
        var sliderBox = this.getSliderBoundingBox();

        this.setState({
          handleDimensions: this.getHandleDimensions(ev, sliderBox),
          mousePos: { x: x, y: y },
          sliderBox: sliderBox,
          slidingIndex: getHandleFor(ev)
        });
      }

      return setStartSlide;
    }()

    // istanbul ignore next

  }, {
    key: 'startMouseSlide',
    value: function () {
      function startMouseSlide(ev) {
        this.setStartSlide(ev, ev.clientX, ev.clientY);

        if (typeof document.addEventListener === 'function') {
          document.addEventListener('mousemove', this.handleMouseSlide, false);
          document.addEventListener('mouseup', this.endSlide, false);
        } else {
          document.attachEvent('onmousemove', this.handleMouseSlide);
          document.attachEvent('onmouseup', this.endSlide);
        }

        killEvent(ev);
      }

      return startMouseSlide;
    }()

    // istanbul ignore next

  }, {
    key: 'startTouchSlide',
    value: function () {
      function startTouchSlide(ev) {
        if (ev.changedTouches.length > 1) return;

        var touch = ev.changedTouches[0];

        this.setStartSlide(ev, touch.clientX, touch.clientY);

        document.addEventListener('touchmove', this.handleTouchSlide, false);
        document.addEventListener('touchend', this.endSlide, false);

        if (this.props.onSliderDragStart) this.props.onSliderDragStart();

        killEvent(ev);
      }

      return startTouchSlide;
    }()

    // istanbul ignore next

  }, {
    key: 'handleMouseSlide',
    value: function () {
      function handleMouseSlide(ev) {
        if (this.state.slidingIndex === null) return;
        this.handleSlide(ev.clientX, ev.clientY);
        killEvent(ev);
      }

      return handleMouseSlide;
    }()

    // istanbul ignore next

  }, {
    key: 'handleTouchSlide',
    value: function () {
      function handleTouchSlide(ev) {
        if (this.state.slidingIndex === null) return;

        if (ev.changedTouches.length > 1) {
          this.endSlide();
          return;
        }

        var touch = ev.changedTouches[0];

        this.handleSlide(touch.clientX, touch.clientY);
        killEvent(ev);
      }

      return handleTouchSlide;
    }()

    // istanbul ignore next

  }, {
    key: 'handleSlide',
    value: function () {
      function handleSlide(x, y) {
        var _state2 = this.state,
            idx = _state2.slidingIndex,
            sliderBox = _state2.sliderBox;


        var positionPercent = this.props.orientation === 'vertical' ? (y - sliderBox.top) / sliderBox.height * SliderConstants.PERCENT_FULL : (x - sliderBox.left) / sliderBox.width * SliderConstants.PERCENT_FULL;

        this.slideTo(idx, positionPercent);

        if (this.canMove(idx, positionPercent)) {
          // update mouse positions
          this.setState({ x: x, y: y });
          if (this.props.onSliderDragMove) this.props.onSliderDragMove();
        }
      }

      return handleSlide;
    }()

    // istanbul ignore next

  }, {
    key: 'endSlide',
    value: function () {
      function endSlide() {
        var _this4 = this;

        var idx = this.state.slidingIndex;

        this.setState({ slidingIndex: null });

        if (typeof document.removeEventListener === 'function') {
          document.removeEventListener('mouseup', this.endSlide, false);
          document.removeEventListener('touchend', this.endSlide, false);
          document.removeEventListener('touchmove', this.handleTouchSlide, false);
          document.removeEventListener('mousemove', this.handleMouseSlide, false);
        } else {
          document.detachEvent('onmousemove', this.handleMouseSlide);
          document.detachEvent('onmouseup', this.endSlide);
        }

        if (this.props.onSliderDragEnd) this.props.onSliderDragEnd();
        if (this.props.snap) {
          var positionPercent = this.getSnapPosition(this.state.handlePos[idx]);
          this.slideTo(idx, positionPercent, function () {
            return _this4.fireChangeEvent();
          });
        } else {
          this.fireChangeEvent();
        }
      }

      return endSlide;
    }()

    // istanbul ignore next

  }, {
    key: 'handleClick',
    value: function () {
      function handleClick(ev) {
        var _this5 = this;

        if (ev.target.getAttribute('data-handle-key')) {
          return;
        }

        // Calculate the position of the slider on the page so we can determine
        // the position where you click in relativity.
        var sliderBox = this.getSliderBoundingBox();

        var positionDecimal = this.props.orientation === 'vertical' ? (ev.clientY - sliderBox.top) / sliderBox.height : (ev.clientX - sliderBox.left) / sliderBox.width;

        var positionPercent = positionDecimal * SliderConstants.PERCENT_FULL;

        var handleId = this.getClosestHandle(positionPercent);

        var validPositionPercent = this.getSnapPosition(positionPercent);

        // Move the handle there
        this.slideTo(handleId, validPositionPercent, function () {
          return _this5.fireChangeEvent();
        });

        if (this.props.onClick) this.props.onClick();
      }

      return handleClick;
    }()

    // istanbul ignore next

  }, {
    key: 'handleKeydown',
    value: function () {
      function handleKeydown(ev) {
        var _this6 = this;

        var idx = getHandleFor(ev);

        if (ev.keyCode === SliderConstants.KEYS.ESC) {
          ev.currentTarget.blur();
          return;
        }

        var proposedPercentage = this.getNextPositionForKey(idx, ev.keyCode);

        if (proposedPercentage === null) return;

        if (this.canMove(idx, proposedPercentage)) {
          this.slideTo(idx, proposedPercentage, function () {
            return _this6.fireChangeEvent();
          });
          if (this.props.onKeyPress) this.props.onKeyPress();
        }

        killEvent(ev);
      }

      return handleKeydown;
    }()

    // Make sure the proposed position respects the bounds and
    // does not collide with other handles too much.

  }, {
    key: 'validatePosition',
    value: function () {
      function validatePosition(idx, proposedPosition) {
        var _state3 = this.state,
            handlePos = _state3.handlePos,
            handleDimensions = _state3.handleDimensions;


        return Math.max(Math.min(proposedPosition, handlePos[idx + 1] !== undefined ? handlePos[idx + 1] - handleDimensions : SliderConstants.PERCENT_FULL // 100% is the highest value
        ), handlePos[idx - 1] !== undefined ? handlePos[idx - 1] + handleDimensions : SliderConstants.PERCENT_EMPTY // 0% is the lowest value
        );
      }

      return validatePosition;
    }()
  }, {
    key: 'validateValues',
    value: function () {
      function validateValues(proposedValues, props) {
        var _ref = props || this.props,
            max = _ref.max,
            min = _ref.min;

        return proposedValues.map(function (value, idx, values) {
          var realValue = Math.max(Math.min(value, max), min);

          if (values.length && realValue < values[idx - 1]) {
            return values[idx - 1];
          }

          return realValue;
        });
      }

      return validateValues;
    }()

    // Can we move the slider to the given position?

  }, {
    key: 'canMove',
    value: function () {
      function canMove(idx, proposedPosition) {
        var _state4 = this.state,
            handlePos = _state4.handlePos,
            handleDimensions = _state4.handleDimensions;


        if (proposedPosition < SliderConstants.PERCENT_EMPTY) return false;
        if (proposedPosition > SliderConstants.PERCENT_FULL) return false;

        var nextHandlePosition = handlePos[idx + 1] !== undefined ? handlePos[idx + 1] - handleDimensions : Infinity;

        if (proposedPosition > nextHandlePosition) return false;

        var prevHandlePosition = handlePos[idx - 1] !== undefined ? handlePos[idx - 1] + handleDimensions : -Infinity;

        if (proposedPosition < prevHandlePosition) return false;

        return true;
      }

      return canMove;
    }()

    // istanbul ignore next

  }, {
    key: 'fireChangeEvent',
    value: function () {
      function fireChangeEvent() {
        if (this.props.onChange) this.props.onChange(this.getPublicState());
      }

      return fireChangeEvent;
    }()

    // istanbul ignore next

  }, {
    key: 'slideTo',
    value: function () {
      function slideTo(idx, proposedPosition, onAfterSet) {
        var _this7 = this;

        var nextState = this.getNextState(idx, proposedPosition);

        this.setState(nextState, function () {
          if (_this7.props.onValuesUpdated) _this7.props.onValuesUpdated(_this7.getPublicState());
          if (onAfterSet) onAfterSet();
        });
      }

      return slideTo;
    }()

    // istanbul ignore next

  }, {
    key: 'updateNewValues',
    value: function () {
      function updateNewValues(nextProps) {
        var _this8 = this;

        // Don't update while the slider is sliding
        if (this.state.slidingIndex !== null) {
          return;
        }

        var max = nextProps.max,
            min = nextProps.min,
            values = nextProps.values;


        var nextValues = this.validateValues(values, nextProps);

        this.setState({
          handlePos: nextValues.map(function (value) {
            return _this8.props.algorithm.getPosition(value, min, max);
          }),
          values: nextValues
        }, function () {
          return _this8.fireChangeEvent();
        });
      }

      return updateNewValues;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this9 = this;

        var _props4 = this.props,
            algorithm = _props4.algorithm,
            children = _props4.children,
            disabled = _props4.disabled,
            Handle = _props4.handle,
            max = _props4.max,
            min = _props4.min,
            orientation = _props4.orientation,
            PitComponent = _props4.pitComponent,
            pitPoints = _props4.pitPoints,
            ProgressBar = _props4.progressBar;


        return (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          _react2['default'].createElement(
            'div',
            {
              className: this.state.className,
              ref: 'rheostat',
              onClick: !disabled && this.handleClick,
              style: { position: 'relative' }
            },
            _react2['default'].createElement('div', { className: 'rheostat-background' }),
            this.state.handlePos.map(function (pos, idx) {
              var handleStyle = orientation === 'vertical' ? { top: String(pos) + '%', position: 'absolute' } : { left: String(pos) + '%', position: 'absolute' };

              return _react2['default'].createElement(Handle, {
                'aria-valuemax': _this9.getMaxValue(idx),
                'aria-valuemin': _this9.getMinValue(idx),
                'aria-valuenow': _this9.state.values[idx],
                'aria-disabled': disabled,
                'data-handle-key': idx,
                className: 'rheostat-handle',
                key: idx,
                onClick: _this9.killEvent,
                onKeyDown: !disabled && _this9.handleKeydown,
                onMouseDown: !disabled && _this9.startMouseSlide,
                onTouchStart: !disabled && _this9.startTouchSlide,
                role: 'slider',
                style: handleStyle,
                tabIndex: 0
              });
            }),
            this.state.handlePos.map(function (node, idx, arr) {
              if (idx === 0 && arr.length > 1) {
                return null;
              }

              return _react2['default'].createElement(ProgressBar, {
                className: 'rheostat-progress',
                key: idx,
                style: _this9.getProgressStyle(idx)
              });
            }),
            PitComponent && pitPoints.map(function (n) {
              var pos = algorithm.getPosition(n, min, max);
              var pitStyle = orientation === 'vertical' ? { top: String(pos) + '%', position: 'absolute' } : { left: String(pos) + '%', position: 'absolute' };

              return _react2['default'].createElement(
                PitComponent,
                { key: n, style: pitStyle },
                n
              );
            }),
            children
          )
        );
      }

      return render;
    }()
  }]);

  return Rheostat;
}(_react2['default'].Component);

Rheostat.propTypes = propTypes;
Rheostat.defaultProps = defaultProps;

exports['default'] = Rheostat;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(206);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuBankAccountElement = exports.FpxBankElement = exports.IdealBankElement = exports.IbanElement = exports.PaymentRequestButtonElement = exports.CardCVCElement = exports.CardCvcElement = exports.CardExpiryElement = exports.CardNumberElement = exports.CardElement = exports.Elements = exports.injectStripe = exports.StripeProvider = undefined;

var _Provider = __webpack_require__(70);

var _Provider2 = _interopRequireDefault(_Provider);

var _inject = __webpack_require__(219);

var _inject2 = _interopRequireDefault(_inject);

var _Elements = __webpack_require__(50);

var _Elements2 = _interopRequireDefault(_Elements);

var _Element = __webpack_require__(220);

var _Element2 = _interopRequireDefault(_Element);

var _PaymentRequestButtonElement = __webpack_require__(222);

var _PaymentRequestButtonElement2 = _interopRequireDefault(_PaymentRequestButtonElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Define Elements, and register their implied token / source types for
// automatic token / source creation.

// Card
var CardElement = (0, _Element2.default)('card', {
  impliedTokenType: 'card',
  impliedSourceType: 'card',
  impliedPaymentMethodType: 'card'
});

// Split Fields
// Note: we only register the CardNumberElement for split fields so that we have
// a unique Element to infer when calling `wrappedCreateToken` or `wrappedCreateSource`.

var CardNumberElement = (0, _Element2.default)('cardNumber', {
  impliedTokenType: 'card',
  impliedSourceType: 'card',
  impliedPaymentMethodType: 'card'
});
var CardExpiryElement = (0, _Element2.default)('cardExpiry');
var CardCvcElement = (0, _Element2.default)('cardCvc');
var CardCVCElement = CardCvcElement; // deprecated in favor of CardCvcElement which better matches Elements API

// IBAN
var IbanElement = (0, _Element2.default)('iban', {
  impliedTokenType: 'bank_account',
  impliedSourceType: 'sepa_debit'
});

// iDEAL Bank
var IdealBankElement = (0, _Element2.default)('idealBank', { impliedSourceType: 'ideal' });

// fpx Bank
var FpxBankElement = (0, _Element2.default)('fpxBank');

// auBankAccount
// Requires beta access. Contact Stripe support for more information:
// https://support.stripe.com
var AuBankAccountElement = (0, _Element2.default)('auBankAccount');

exports.StripeProvider = _Provider2.default;
exports.injectStripe = _inject2.default;
exports.Elements = _Elements2.default;
exports.CardElement = CardElement;
exports.CardNumberElement = CardNumberElement;
exports.CardExpiryElement = CardExpiryElement;
exports.CardCvcElement = CardCvcElement;
exports.CardCVCElement = CardCVCElement;
exports.PaymentRequestButtonElement = _PaymentRequestButtonElement2.default;
exports.IbanElement = IbanElement;
exports.IdealBankElement = IdealBankElement;
exports.FpxBankElement = FpxBankElement;
exports.AuBankAccountElement = AuBankAccountElement;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.providerContextTypes = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(49);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO(jez) 'sync' and 'async' are bad tag names.
// TODO(jez) What if redux also uses this.context.tag?
var providerContextTypes = exports.providerContextTypes = {
  tag: _propTypes2.default.string.isRequired,
  stripe: _propTypes2.default.object,
  addStripeLoadListener: _propTypes2.default.func
};

var getOrCreateStripe = function getOrCreateStripe(apiKey, options) {
  /**
   * Note that this is not meant to be a generic memoization solution.
   * This is specifically a solution for `StripeProvider`s being initialized
   * and destroyed regularly (with the same set of props) when users only
   * use `StripeProvider` for the subtree that contains their checkout form.
   */
  window.Stripe.__cachedInstances = window.Stripe.__cachedInstances || {};
  var cacheKey = 'key=' + apiKey + ' options=' + JSON.stringify(options);

  var stripe = window.Stripe.__cachedInstances[cacheKey] || window.Stripe(apiKey, options);
  window.Stripe.__cachedInstances[cacheKey] = stripe;

  return stripe;
};

var ensureStripeShape = function ensureStripeShape(stripe) {
  if (stripe && stripe.elements && stripe.createSource && stripe.createToken && stripe.createPaymentMethod && stripe.handleCardPayment) {
    return stripe;
  } else {
    throw new Error("Please pass a valid Stripe object to StripeProvider. You can obtain a Stripe object by calling 'Stripe(...)' with your publishable key.");
  }
};

var Provider = function (_React$Component) {
  _inherits(Provider, _React$Component);

  // on the other hand: childContextTypes is *required* to use context.
  function Provider(props) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    if (_this.props.apiKey && _this.props.stripe) {
      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider, not both.");
    } else if (_this.props.apiKey) {
      if (!window.Stripe) {
        throw new Error("Please load Stripe.js (https://js.stripe.com/v3/) on this page to use react-stripe-elements. If Stripe.js isn't available yet (it's loading asynchronously, or you're using server-side rendering), see https://github.com/stripe/react-stripe-elements#advanced-integrations");
      } else {
        var _this$props = _this.props,
            _apiKey = _this$props.apiKey,
            _children = _this$props.children,
            options = _objectWithoutProperties(_this$props, ['apiKey', 'children']);

        var _stripe = getOrCreateStripe(_apiKey, options);
        _this._meta = { tag: 'sync', stripe: _stripe };
        _this._register();
      }
    } else if (_this.props.stripe) {
      // If we already have a stripe instance (in the constructor), we can behave synchronously.
      var _stripe2 = ensureStripeShape(_this.props.stripe);
      _this._meta = { tag: 'sync', stripe: _stripe2 };
      _this._register();
    } else if (_this.props.stripe === null) {
      _this._meta = {
        tag: 'async',
        stripe: null
      };
    } else {
      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider. If you're using 'stripe' but don't have a Stripe instance yet, pass 'null' explicitly.");
    }

    _this._didWarn = false;
    _this._didWakeUpListeners = false;
    _this._listeners = [];
    return _this;
  }
  // Even though we're using flow, also use PropTypes so we can take advantage of developer warnings.


  Provider.prototype.getChildContext = function getChildContext() {
    var _this2 = this;

    // getChildContext is run after the constructor, so we WILL have access to
    // the initial state.
    //
    // However, context doesn't update in respnse to state changes like you
    // might expect: context is pulled by the child, not pushed by the parent.
    if (this._meta.tag === 'sync') {
      return {
        tag: 'sync',
        stripe: this._meta.stripe
      };
    } else {
      return {
        tag: 'async',
        addStripeLoadListener: function addStripeLoadListener(fn) {
          if (_this2._meta.stripe) {
            fn(_this2._meta.stripe);
          } else {
            _this2._listeners.push(fn);
          }
        }
      };
    }
  };

  Provider.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var apiKeyChanged = this.props.apiKey && prevProps.apiKey && this.props.apiKey !== prevProps.apiKey;

    var stripeInstanceChanged = this.props.stripe && prevProps.stripe && this.props.stripe !== prevProps.stripe;
    if (!this._didWarn && (apiKeyChanged || stripeInstanceChanged) && window.console && window.console.error) {
      this._didWarn = true;
      // eslint-disable-next-line no-console
      console.error('StripeProvider does not support changing the apiKey parameter.');
      return;
    }

    if (!this._didWakeUpListeners && this.props.stripe) {
      // Wake up the listeners if we've finally been given a StripeShape
      this._didWakeUpListeners = true;
      var _stripe3 = ensureStripeShape(this.props.stripe);
      this._meta.stripe = _stripe3;
      this._register();
      this._listeners.forEach(function (fn) {
        fn(_stripe3);
      });
    }
  };

  Provider.prototype._register = function _register() {
    var stripe = this._meta.stripe;


    if (!stripe || !stripe._registerWrapper) {
      return;
    }

    stripe._registerWrapper({
      name: 'react-stripe-elements',
      version: '6.1.2' || null
    });
  };

  Provider.prototype.render = function render() {
    return _react2.default.Children.only(this.props.children);
  };

  return Provider;
}(_react2.default.Component);

Provider.propTypes = {
  apiKey: _propTypes2.default.string,
  // PropTypes.object is the only way we can accept a Stripe instance
  // eslint-disable-next-line react/forbid-prop-types
  stripe: _propTypes2.default.object,
  children: _propTypes2.default.node
};
Provider.childContextTypes = providerContextTypes;
Provider.defaultProps = {
  apiKey: undefined,
  stripe: undefined,
  children: null
};
exports.default = Provider;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(110);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(111);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(18);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(51);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(52);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

//
exports.default = {
  get: get,
  set: set,
  takeRight: takeRight,
  last: last,
  orderBy: orderBy,
  range: range,
  remove: remove,
  clone: clone,
  getFirstDefined: getFirstDefined,
  sum: sum,
  makeTemplateComponent: makeTemplateComponent,
  groupBy: groupBy,
  isArray: isArray,
  splitProps: splitProps,
  compactObject: compactObject,
  isSortingDesc: isSortingDesc,
  normalizeComponent: normalizeComponent,
  asPx: asPx
};


function get(obj, path, def) {
  if (!path) {
    return obj;
  }
  var pathObj = makePathArray(path);
  var val = void 0;
  try {
    val = pathObj.reduce(function (current, pathPart) {
      return current[pathPart];
    }, obj);
  } catch (e) {
    // continue regardless of error
  }
  return typeof val !== 'undefined' ? val : def;
}

function set() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var path = arguments[1];
  var value = arguments[2];

  var keys = makePathArray(path);
  var keyPart = void 0;
  var cursor = obj;
  while ((keyPart = keys.shift()) && keys.length) {
    if (!cursor[keyPart]) {
      cursor[keyPart] = {};
    }
    cursor = cursor[keyPart];
  }
  cursor[keyPart] = value;
  return obj;
}

function takeRight(arr, n) {
  var start = n > arr.length ? 0 : arr.length - n;
  return arr.slice(start);
}

function last(arr) {
  return arr[arr.length - 1];
}

function range(n) {
  var arr = [];
  for (var i = 0; i < n; i += 1) {
    arr.push(n);
  }
  return arr;
}

function orderBy(arr, funcs, dirs, indexKey) {
  return arr.sort(function (rowA, rowB) {
    for (var i = 0; i < funcs.length; i += 1) {
      var comp = funcs[i];
      var desc = dirs[i] === false || dirs[i] === 'desc';
      var sortInt = comp(rowA, rowB);
      if (sortInt) {
        return desc ? -sortInt : sortInt;
      }
    }
    // Use the row index for tie breakers
    return dirs[0] ? rowA[indexKey] - rowB[indexKey] : rowB[indexKey] - rowA[indexKey];
  });
}

function remove(a, b) {
  return a.filter(function (o, i) {
    var r = b(o);
    if (r) {
      a.splice(i, 1);
      return true;
    }
    return false;
  });
}

function clone(a) {
  try {
    return JSON.parse(JSON.stringify(a, function (key, value) {
      if (typeof value === 'function') {
        return value.toString();
      }
      return value;
    }));
  } catch (e) {
    return a;
  }
}

function getFirstDefined() {
  for (var i = 0; i < arguments.length; i += 1) {
    if (typeof (arguments.length <= i ? undefined : arguments[i]) !== 'undefined') {
      return arguments.length <= i ? undefined : arguments[i];
    }
  }
}

function sum(arr) {
  return arr.reduce(function (a, b) {
    return a + b;
  }, 0);
}

function makeTemplateComponent(compClass, displayName) {
  if (!displayName) {
    throw new Error('No displayName found for template component:', compClass);
  }
  var cmp = function cmp(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = _objectWithoutProperties(_ref, ['children', 'className']);

    return _react2.default.createElement(
      'div',
      _extends({ className: (0, _classnames2.default)(compClass, className) }, rest),
      children
    );
  };
  cmp.displayName = displayName;
  return cmp;
}

function groupBy(xs, key) {
  return xs.reduce(function (rv, x, i) {
    var resKey = typeof key === 'function' ? key(x, i) : x[key];
    rv[resKey] = isArray(rv[resKey]) ? rv[resKey] : [];
    rv[resKey].push(x);
    return rv;
  }, {});
}

function asPx(value) {
  value = Number(value);
  return Number.isNaN(value) ? null : value + 'px';
}

function isArray(a) {
  return Array.isArray(a);
}

// ########################################################################
// Non-exported Helpers
// ########################################################################

function makePathArray(obj) {
  return flattenDeep(obj).join('.').replace(/\[/g, '.').replace(/\]/g, '').split('.');
}

function flattenDeep(arr) {
  var newArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!isArray(arr)) {
    newArr.push(arr);
  } else {
    for (var i = 0; i < arr.length; i += 1) {
      flattenDeep(arr[i], newArr);
    }
  }
  return newArr;
}

function splitProps(_ref2) {
  var className = _ref2.className,
      style = _ref2.style,
      rest = _objectWithoutProperties(_ref2, ['className', 'style']);

  return {
    className: className,
    style: style,
    rest: rest || {}
  };
}

function compactObject(obj) {
  var newObj = {};
  if (obj) {
    Object.keys(obj).map(function (key) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && typeof obj[key] !== 'undefined') {
        newObj[key] = obj[key];
      }
      return true;
    });
  }
  return newObj;
}

function isSortingDesc(d) {
  return !!(d.sort === 'desc' || d.desc === true || d.asc === false);
}

function normalizeComponent(Comp) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Comp;

  return typeof Comp === 'function' ? Object.getPrototypeOf(Comp).isReactComponent ? _react2.default.createElement(Comp, params) : Comp(params) : fallback;
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 77 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(25);
var normalizeHeaderName = __webpack_require__(322);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(130);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(130);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)))

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultCustomerDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultCustomerFamily; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var defaultCustomerDetails = {
    customerId: undefined,
    hasSpouse: undefined,
    mortgage: undefined,
    otherDebt: undefined,
    beneficiaryAmountPerYear: undefined,
    beneficiaryAmountTotalYears: undefined,
    savingsAmount: undefined,
    isSmoker: undefined,
    lastSmokedDate: '',
    age: undefined,
};
var defaultCustomerFamily = {
    familyMemberId: undefined,
    name: '',
    age: undefined,
    relationship: '52866e41fdfae711b9c80028f80bded3' // Child. Using the FamilyRelationship enum in utils doesn't work.
};
var apiUrl = "https://www.insuredbymosaic.ca/api";
var quotingAPI = {
    fetchHeightWeightTable: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/height-weight-table.json")
            .then(function (resp) { return resp.data; });
    },
    fetchCustomerDetails: function (customerId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + customerId + "/details.json")
            .then(function (resp) { return resp.data; });
    },
    fetchCustomerFamilyList: function (customerId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + customerId + "/familylist.json")
            .then(function (resp) { return resp.data; });
    },
    saveCustomerDetails: function (customerDetails) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/customers/details", customerDetails)
            .then(function (resp) { return resp.data; });
    },
    saveCustomerFamilyList: function (customerId, customerFamilyList) {
        var data = {
            customerId: customerId,
            customerFamilyList: customerFamilyList
        };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/customers/familyList", data)
            .then(function (resp) { return resp.data; });
    },
    validateReferralCode: function (referralCode, userId) {
        var data = { referralCode: referralCode, userId: userId };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/referral", data)
            .then(function (resp) { return resp.data; });
    },
};
/* harmony default export */ __webpack_exports__["a"] = (quotingAPI);


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultCustomerNote; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var defaultUser = {
    firstName: '',
    lastName: '',
    email: '',
    mailingAddress: '',
    mailingCity: '',
    mailingProvince: '',
    mailingPostalCode: '',
    mailingCountry: '',
    isSameAddress: true,
    billingAddress: '',
    billingCity: '',
    billingProvince: '',
    billingPostalCode: '',
    billingCountry: '',
    role: ["Customer" /* Customer */],
    gender: '',
};
var defaultCustomerNote = {
    notes: '',
    answerId: undefined
};
var apiUrl = "https://www.insuredbymosaic.ca/api";
var userAPI = {
    fetchUser: function (userId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/users/" + userId + "/details.json")
            .then(function (resp) { return resp.data; });
    },
    fetchUserByPolicyId: function (policyId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/policies/" + policyId + "/user.json")
            .then(function (resp) { return resp.data; });
    },
    fetchReferrerNameByReferralCode: function (referralCode) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/referralCode/" + referralCode + "/name.json")
            .then(function (resp) { return resp.data; });
    },
    fetchReferrerNameBySpousalReferralCode: function (spousalReferralCode) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/spousalReferralCode/" + spousalReferralCode + "/name.json")
            .then(function (resp) { return resp.data; });
    },
    saveUser: function (user) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/users/details", user)
            .then(function (resp) { return resp.data; });
    },
    adminSaveUser: function (user) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/admin/users/details.json", user)
            .then(function (resp) { return resp.data; });
    },
    updateSoftDeclinedUser: function (user, policyId) {
        var data = {
            user: user,
            policyId: policyId
        };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/users/soft-declined-details", data)
            .then(function (resp) { return resp.data; });
    },
    saveStaff: function (user) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/users/admins", user)
            .then(function (resp) { return resp.data; });
    },
    fetchAdmins: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/users/admins.json")
            .then(function (resp) { return resp.data; });
    },
    fetchCustomers: function (filterProspects) {
        var options = {
            params: { filterProspects: filterProspects || null }
        };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/users/customers.json", options)
            .then(function (resp) { return resp.data; });
    },
    fetchSoftDeclinedCustomers: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/users/soft-declined-customers.json")
            .then(function (resp) { return resp.data; });
    },
    clearAdjudicationQueue: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/users/clear-adjudication-queue")
            .then(function (resp) { return resp.data; });
    },
    fetchCustomerNote: function (customerId, noteId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/users/customers/" + customerId + "/notes/" + noteId + ".json")
            .then(function (resp) { return resp.data; });
    },
    fetchCustomerNotes: function (customerId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/users/customers/" + customerId + "/notes.json")
            .then(function (resp) { return resp.data; });
    },
    saveCustomerNote: function (note) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/users/customers/notes", note)
            .then(function (resp) { return resp.data; });
    },
    resetPassword: function (userId, resetUrl) {
        var data = { userId: userId, resetUrl: resetUrl };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/emails/reset-password", data)
            .then(function (resp) { return resp.data; });
    },
    saveRole: function (userId, roles) {
        var data = { roles: roles };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/users/" + userId + "/update-role", data)
            .then(function (resp) { return resp.data; });
    },
    fetchReferrals: function (customerId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/users/customers/" + customerId + "/referrals.json")
            .then(function (resp) { return resp.data; });
    },
    generateNewReferralCode: function (customerId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/users/customers/" + customerId + "/referrals/GenerateNewReferralCode")
            .then(function (resp) { return resp.data; });
    },
    updateReferralBalance: function (customerId, referralBalance) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/users/customers/" + customerId + "/referralBalance", { referralBalance: referralBalance })
            .then(function (resp) { return resp.data; });
    },
    updateRemainingReferrals: function (customerId, remainingReferrals) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/users/customers/" + customerId + "/referrals", { remainingReferrals: remainingReferrals })
            .then(function (resp) { return resp.data; });
    },
    updateCustomerReferralEnabled: function (customerId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/users/customers/" + customerId + "/referralEnabled")
            .then(function (resp) { return resp.data; });
    },
    sendReferralInviteEmail: function (userId, name, email) {
        var data = { userId: userId, name: name, email: email };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/emails/referral-invite", data)
            .then(function (resp) { return resp.data; });
    },
    sendSpousalReferralInviteEmail: function (userId, name, email) {
        var data = { userId: userId, name: name, email: email };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/emails/spousal-referral-invite", data)
            .then(function (resp) { return resp.data; });
    },
    sendSoftDeclinedEmail: function (userId) {
        var data = { userId: userId };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/emails/soft-declined", data)
            .then(function (resp) { return resp.data; });
    },
    updateStripeCustomerEmail: function (customerId, email) {
        var data = {
            customerId: customerId,
            email: email
        };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/customers/email/update", data)
            .then(function (resp) { return resp.data; });
    },
    updateUserWithEmailChecker: function (user) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/users/details-email-check.json", user)
            .then(function (resp) { return resp.data; });
    },
};
/* harmony default export */ __webpack_exports__["a"] = (userAPI);


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tippy_dist_tippy_css__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tippy_dist_tippy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_tippy_dist_tippy_css__);

var Tooltip = __webpack_require__(358).Tooltip;

var CustomTooltip = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tooltip, { title: props.title, html: props.html, className: props.className, animation: "shift", animateFill: false, arrow: true, duration: 175, delay: 100 }, props.children));
};
/* harmony default export */ __webpack_exports__["a"] = (CustomTooltip);


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(139);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)))

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(372)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(404);
var parse = __webpack_require__(405);
var formats = __webpack_require__(145);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Helpers = exports.ScrollElement = exports.ScrollLink = exports.animateScroll = exports.scrollSpy = exports.Events = exports.scroller = exports.Element = exports.Button = exports.Link = undefined;

var _Link = __webpack_require__(410);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(414);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(415);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(58);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(94);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(92);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(146);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(91);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(148);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(416);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Link = _Link2.default;
exports.Button = _Button2.default;
exports.Element = _Element2.default;
exports.scroller = _scroller2.default;
exports.Events = _scrollEvents2.default;
exports.scrollSpy = _scrollSpy2.default;
exports.animateScroll = _animateScroll2.default;
exports.ScrollLink = _scrollLink2.default;
exports.ScrollElement = _scrollElement2.default;
exports.Helpers = _Helpers2.default;
exports.default = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(38);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(42);

var _utils2 = _interopRequireDefault(_utils);

var _scrollSpy = __webpack_require__(92);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(58);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(147);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  spy: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool
};

exports.default = function (Component, customScroller) {

  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2.default.mount(scrollSpyContainer);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (y) {

      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var to = _this2.props.to;
      var element = null;
      var elemTopBound = 0;
      var elemBottomBound = 0;
      var containerTop = 0;

      if (scrollSpyContainer.getBoundingClientRect) {
        var containerCords = scrollSpyContainer.getBoundingClientRect();
        containerTop = containerCords.top;
      }

      if (!element || _this2.props.isDynamic) {
        element = scroller.get(to);
        if (!element) {
          return;
        }

        var cords = element.getBoundingClientRect();
        elemTopBound = cords.top - containerTop + y;
        elemBottomBound = elemTopBound + cords.height;
      }

      var offsetY = y - _this2.props.offset;
      var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
      var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          _scrollHash2.default.changeHash();
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  ;

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(411);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps
var eventThrottler = function eventThrottler(eventHandler) {
  return (0, _lodash2.default)(eventHandler, 66);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      });
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports.default = scrollSpy;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports.default = Events;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT = exports.LEFT = 37;
var UP = exports.UP = 38;
var RIGHT = exports.RIGHT = 39;
var DOWN = exports.DOWN = 40;
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
//# sourceMappingURL=keys.js.map

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var classNames = __webpack_require__(8);
var Checkbox = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-check-wrapper', props.className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-check custom-control custom-checkbox', {
                disabled: props.disabled
            }) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "checkbox", name: props.name, checked: props.checked || false, value: props.value, id: props.id || props.name, onChange: props.onChange, onBlur: props.onBlur, className: "form-check-input custom-control-input" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "form-check-label custom-control-label", htmlFor: props.name },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { dangerouslySetInnerHTML: { __html: props.label } }))),
        props.conditionalChildren));
};
/* harmony default export */ __webpack_exports__["a"] = (Checkbox);


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_ga__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__quoting_quotingActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};











var HomePageAssessmentBottom = /** @class */ (function (_super) {
    __extends(HomePageAssessmentBottom, _super);
    function HomePageAssessmentBottom(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = { age: {} };
        _this.onUserChange = function (e) {
            var user = __assign({}, _this.props.user, (_a = {}, _a[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value, _a));
            _this.props.actions.setUser(user);
            // Set user's age based on birthdate
            if (e.target.name === 'birthDate') {
                var age = __WEBPACK_IMPORTED_MODULE_10__common_utils__["m" /* default */].getAgeRoundedFromBirthdate(e.target.value);
                var customerDetails = __assign({}, _this.props.customerDetails, { age: age });
                _this.props.actions.setCustomerDetails(customerDetails);
            }
            var _a;
        };
        _this.onCustomerDetailsChange = function (e) {
            var value = e.target.value;
            if (e.target.type === 'radio') {
                if (value === 'true') {
                    value = true;
                }
                else if (value === 'false') {
                    value = false;
                }
            }
            else if (e.target.type === 'checkbox') {
                value = e.target.checked;
            }
            var customerDetails = __assign({}, _this.props.customerDetails, (_a = {}, _a[e.target.name] = value, _a));
            _this.props.actions.setCustomerDetails(customerDetails);
            var _a;
        };
        _this.getQuote = function () {
            var abTestIndex = __WEBPACK_IMPORTED_MODULE_10__common_utils__["m" /* default */].getABTestOptimizeIndex();
            __WEBPACK_IMPORTED_MODULE_4_react_ga__["set"]({ 'exp': "Szj9gW87RKe5Yo5GErN82A." + abTestIndex });
            var url = __WEBPACK_IMPORTED_MODULE_10__common_utils__["m" /* default */].getABTestWorkflowUrl(abTestIndex, _this.props.customerDetails.age, _this.props.user.gender);
            _this.props.history.push(url);
        };
        _this.handleBlur = function (field) { return function (evt) {
            _this.setState({
                touched: __assign({}, _this.state.touched, (_a = {}, _a[field] = true, _a))
            });
            var _a;
        }; };
        _this.validate = function () {
            // true means invalid
            return {
                age: __WEBPACK_IMPORTED_MODULE_10__common_utils__["k" /* Validation */].validateAge(_this.props.user.birthDate, _this.props.currentUser.isAuthenticated)
            };
        };
        _this.isGetQuoteDisabled = function () {
            // Allow user to click get quote even if inputs aren't filled. They will be redirected to the About You page.
            return _this.errors.age.hasError;
        };
        _this.state = {
            touched: {
                age: false
            }
        };
        return _this;
    }
    HomePageAssessmentBottom.prototype.componentDidMount = function () {
        // Only resetUser if not authenticated.
        // Otherwise, additional policies will be attached to new users and not the logged in user.
        if (!this.props.currentUser.isAuthenticated) {
            this.props.actions.resetUser();
            this.props.actions.resetCustomerDetails();
        }
        if (this.errors.age.hasError) {
            this.setState({
                touched: __assign({}, this.state.touched, { age: true })
            });
        }
    };
    HomePageAssessmentBottom.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "home-page-assessment home-page-assessment-bottom text-sm-center large" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h3 mb-2 mb-sm-4 text-white" }, "Get covered and get your first two months free!"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-3" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline justify-content-sm-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text form-inline-text-full" }, "Birthdate:"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-daypicker-responsive" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_forms__["a" /* BirthDatePicker */]
                        // Age is set in the onChange handler based on birthdate
                        , { 
                            // Age is set in the onChange handler based on birthdate
                            className: "text-dark text-left fixed-width", name: "birthDate", onBlur: this.handleBlur('age'), onChange: this.onUserChange, value: this.props.user.birthDate, error: __WEBPACK_IMPORTED_MODULE_10__common_utils__["m" /* default */].shouldMarkError(this.errors.age, this.state.touched.age) ? this.errors.age : undefined })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text form-inline-text-full" }, "Sex at birth:"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_forms__["g" /* DropdownInput */], { name: "gender", className: "text-left", defaultOption: 'Select', options: [{ text: 'Male', value: 'male' }, { text: 'Female', value: 'female' }], onChange: this.onUserChange, value: this.props.user.gender }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text form-inline-text-full" }, "Tobacco user:"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_forms__["o" /* ToggleSwitch */], { className: "toggle-on-inverse text-left toggle-yes-no", id: "isSmokerBottom", name: "isSmoker", onChildren: "Yes", offChildren: "No", onChange: this.onCustomerDetailsChange, checked: this.props.customerDetails.isSmoker }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_buttons_Button__["a" /* default */], { id: "getQuoteBtn", onClick: this.getQuote, className: "btn-primary btn-primary-inverse mt-3", disabled: this.isGetQuoteDisabled() },
                "Get my quote! ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_icons__["m" /* IconArrowRight */], null))));
    };
    return HomePageAssessmentBottom;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        user: state.user.user,
        customerDetails: state.quoting.customerDetails,
        currentUser: state.auth.currentUser
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_5__quoting_quotingActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(HomePageAssessmentBottom)));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-scor.7c1cdea0.png";

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);

var settingsActions = {
    setQuestionnaireNavigationEnabled: function (enabled) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_QUESTIONNAIRE_NAVIGATION_ENABLED, enabled: enabled };
    },
    setSelectPlanOptionsEnabled: function (enabled) {
        return { type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_SELECT_POLICY_OPTIONS_ENABLED, enabled: enabled };
    }
};
/* harmony default export */ __webpack_exports__["a"] = (settingsActions);


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(177);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(101);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(200);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(109);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(67);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(51);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(74);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(236);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(51);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(52);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(74);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var classNames = __webpack_require__(8);
var Spinner = function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: classNames('spinner', props.className) });
};
/* harmony default export */ __webpack_exports__["a"] = (Spinner);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var classNames = __webpack_require__(8);

var Page = /** @class */ (function (_super) {
    __extends(Page, _super);
    function Page() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Page.prototype.componentDidMount = function () {
        if (this.props.title || this.props.title === '') {
            __WEBPACK_IMPORTED_MODULE_1__common_utils__["m" /* default */].setDocTitle(this.props.title);
        }
    };
    Page.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.title !== nextProps.title) {
            __WEBPACK_IMPORTED_MODULE_1__common_utils__["m" /* default */].setDocTitle(nextProps.title);
        }
    };
    Page.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("article", { className: classNames('page-content', className) }, children);
    };
    return Page;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Page);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.5';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Gets the value at `key`, unless `key` is "__proto__".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    return key == '__proto__'
      ? undefined
      : object[key];
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26), __webpack_require__(48)(module)))

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errorMiddleware__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__localStoreRedux__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__admin_PickList_pickListActions__ = __webpack_require__(54);



// import {throttle} from 'lodash/throttle';
var throttle = __webpack_require__(305);
// import * as lodash from 'lodash';




var composeEnhancers = Object(__WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension__["composeWithDevTools"])({});
var middlewares = [
    Object(__WEBPACK_IMPORTED_MODULE_4__errorMiddleware__["a" /* default */])(),
    __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default.a,
];
var configureStore = function () {
    var initialState = __WEBPACK_IMPORTED_MODULE_5__localStoreRedux__["a" /* default */].loadState();
    if (!initialState || !initialState.settings || initialState.settings.version !== "1.10.9") {
        initialState = {};
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_3__reducers__["a" /* default */], initialState, composeEnhancers(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"].apply(void 0, middlewares)));
};
var store = configureStore();
// Hydrations here
store.dispatch(__WEBPACK_IMPORTED_MODULE_6__admin_PickList_pickListActions__["a" /* default */].getPickListItems());
// listen to state changes to save back to local storage
store.subscribe(throttle(function () {
    var state = store.getState();
    // only save parts of state
    var persistedState = {
        policy: state.policy,
        quoting: state.quoting,
        user: state.user,
        settings: state.settings
    };
    __WEBPACK_IMPORTED_MODULE_5__localStoreRedux__["a" /* default */].saveState(persistedState);
}, 1000));
/* harmony default export */ __webpack_exports__["a"] = (store);


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(308);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(126);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultPaymentHistory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var defaultPaymentHistory = {};
var apiUrl = "https://www.insuredbymosaic.ca/api";
var paymentAPI = {
    createNewCustomerSubscription: function (userId, policyId, tokenId, referralCode, skipDeclineChecker, resetPasswordUrl) {
        var data = { userId: userId, policyId: policyId, tokenId: tokenId, referralCode: referralCode, skipDeclineChecker: skipDeclineChecker, resetPasswordUrl: resetPasswordUrl };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/subscriptions/new", data)
            .then(function (resp) { return resp.data; })
            .catch(function (err) {
            if (err.response) {
                throw err.response.data;
            }
            throw err;
        });
    },
    fetchPayment: function (invoiceNumber) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/payments/" + invoiceNumber + ".json")
            .then(function (resp) { return resp.data; });
    },
    fetchCustomerPayment: function (userId, invoiceNumber) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + userId + "/payments/" + invoiceNumber + ".json")
            .then(function (resp) { return resp.data; });
    },
    fetchCustomerPayments: function (userId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + userId + "/payments.json")
            .then(function (resp) { return resp.data; });
    },
    fetchCustomerUpcomingInvoice: function (userId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + userId + "/invoices/upcoming.json")
            .then(function (resp) { return resp.data; });
    },
    payInvoice: function (invoiceId, token, customerId) {
        var data = {
            invoiceId: invoiceId,
            tokenId: token != null ? token.id : null,
            customerId: customerId || null
        };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/invoices/pay", data)
            .then(function (resp) { return resp.data; })
            .catch(function (err) {
            if (err.response) {
                throw err.response.data;
            }
            throw err;
        });
    },
    fetchCustomerCard: function (userId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/customers/" + userId + "/card.json")
            .then(function (resp) { return resp.data; });
    },
    fetchInvoiceCard: function (invoiceId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/invoices/" + invoiceId + "/card.json")
            .then(function (resp) { return resp.data; });
    },
    updateCustomerCard: function (customerId, token) {
        var data = {
            customerId: customerId,
            tokenId: token.id
        };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/cards/update", data)
            .then(function (resp) { return resp.data; });
    },
    updateCustomerPlan: function (policy, overwriteRate) {
        var data = __assign({}, policy, { overwriteRate: overwriteRate });
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/plans/update", data)
            .then(function (resp) { return resp.data; });
    },
};
/* harmony default export */ __webpack_exports__["a"] = (paymentAPI);


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(25);
var settle = __webpack_require__(323);
var buildURL = __webpack_require__(325);
var parseHeaders = __webpack_require__(326);
var isURLSameOrigin = __webpack_require__(327);
var createError = __webpack_require__(131);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(328);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(329);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(324);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sections__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons__ = __webpack_require__(7);


var classNames = __webpack_require__(8);


var PageFooter = function (_a) {
    var _b = _a.fluid, fluid = _b === void 0 ? false : _b, title = _a.title, className = _a.className, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("footer", { className: classNames('page-footer no-print', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: fluid ? 'container-fluid' : 'container' },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg-3 mb-3 mb-lg-0" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: "/", className: "text-secondary page-footer-brand" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons__["o" /* IconBrand */], null)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "d-block mt-1 mt-md-3 text-muted" },
                        "Version ",
                        "1.10.9"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-12 float-left mt-2 pl-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://www.facebook.com/insuredbymosaic/", target: "_blank", className: "pr-2" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons__["A" /* IconFacebook */], null)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://twitter.com/insuredbymosaic", target: "_blank", className: "pr-2" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons__["J" /* IconTwitter */], null)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://www.instagram.com/_insuredbymosaic/", target: "_blank", className: "pr-2" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons__["C" /* IconInstagram */], null)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://www.linkedin.com/company/19011371/", target: "_blank" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons__["D" /* IconLinkedIn */], null)))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-4 col-lg-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: "/quote/A/about-you", className: "page-footer-link" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Get an easy quote"))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: "/faq", className: "page-footer-link" }, "FAQ")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: "/claims", className: "page-footer-link" }, "Make a claim")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: "/quote/B/about-you", className: "page-footer-link" }, "Advisory calculator")))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-4 col-lg-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: "/about-us", className: "page-footer-link" }, "About mosaic life")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "https://blog.insuredbymosaic.ca", className: "page-footer-link" }, "Blog")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: "/privacy", className: "page-footer-link" }, "Privacy policy")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: "/terms", className: "page-footer-link" }, "Terms of use")))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__sections__["c" /* SectionRight */], { columns: 12, sectionClassName: "p-4", wrapperClassName: "col-md-4 col-lg-3 pl-md-0 footer-contact-section" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled text-md-right mb-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "d-block pt-2 page-footer-link" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h3 mb-0" }, "Have questions?")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "page-footer-link" },
                            "Call us at ",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "text-primary" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "tel:1-855-643-6945" }, "1-855-643-6945"))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: "/contact-us", className: "page-footer-link" }, "Contact us"))))),
            children)));
};
/* harmony default export */ __webpack_exports__["a"] = (PageFooter);


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

// https://reacttraining.com/react-router/web/guides/scroll-restoration
var ScrollToTop = /** @class */ (function (_super) {
    __extends(ScrollToTop, _super);
    function ScrollToTop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScrollToTop.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
        }
    };
    ScrollToTop.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: this.props.className }, this.props.children);
    };
    return ScrollToTop;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ScrollToTop);


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(18);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(371);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(373);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(374);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(376);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(141);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(56);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(377);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _url = __webpack_require__(391);

var _url2 = _interopRequireDefault(_url);

var _queryString = __webpack_require__(397);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaults = {
  redirectQueryParamName: 'redirect',
  locationSelector: function locationSelector(_ref) {
    var location = _ref.location;
    return location;
  }
};

exports.default = function (args) {
  var _defaults$args = _extends({}, defaults, args),
      redirectQueryParamName = _defaults$args.redirectQueryParamName,
      locationSelector = _defaults$args.locationSelector;

  var getRedirectQueryParam = function getRedirectQueryParam(props) {
    var location = locationSelector(props);
    var query = (0, _queryString.parse)(location.search);
    return query[redirectQueryParamName];
  };

  var createRedirectLoc = function createRedirectLoc(allowRedirectBack) {
    return function (props, redirectPath) {
      var location = locationSelector(props);
      var redirectLoc = _url2.default.parse(redirectPath, true);

      var query = void 0;

      if (allowRedirectBack) {
        query = _defineProperty({}, redirectQueryParamName, '' + location.pathname + location.search + location.hash);
      } else {
        query = {};
      }

      query = _extends({}, query, redirectLoc.query);

      return {
        pathname: redirectLoc.pathname,
        hash: redirectLoc.hash,
        search: (0, _queryString.stringify)(query)
      };
    };
  };

  return {
    getRedirectQueryParam: getRedirectQueryParam,
    createRedirectLoc: createRedirectLoc
  };
};

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var FourOhFourPage = /** @class */ (function (_super) {
    __extends(FourOhFourPage, _super);
    function FourOhFourPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FourOhFourPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["b" /* Page */], { className: "404 text-center", title: "Page not found" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["d" /* PageHeader */], { isCentered: true },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "display-1 text-secondary" }, "404"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "text-secondary mb-0" }, "Page not found")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mt-4" }, "Sorry, I'm not sure how you got here but this place doesn't exist."))));
    };
    return FourOhFourPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FourOhFourPage);


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    var obj;

    while (queue.length) {
        var item = queue.pop();
        obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }

    return obj;
};

exports.arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

exports.merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = exports.arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = exports.merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = exports.merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

exports.assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

exports.decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function encode(str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    return compactQueue(queue);
};

exports.isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

exports.isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(42);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(412);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(413);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(94);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPositionY: 0,
    startPositionY: 0,
    targetPositionY: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    deltaTop: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return Math.max(containerElement.scrollHeight, containerElement.offsetHeight, containerElement.clientHeight);
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.deltaTop = Math.round(data.targetPositionY - data.startPositionY);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPositionY = data.startPositionY + Math.ceil(data.deltaTop * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    data.containerElement.scrollTop = data.currentPositionY;
  } else {
    window.scrollTo(0, data.currentPositionY);
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(y, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPositionY = currentPositionY(options);
  options.data.targetPositionY = options.absolute ? y : y + options.data.startPositionY;

  if (options.data.startPositionY === options.data.targetPositionY) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPositionY);
    }
    return;
  }

  options.data.deltaTop = Math.round(options.data.targetPositionY - options.data.startPositionY);

  options.data.duration = functionWrapper(options.duration)(options.data.deltaTop);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toY, options) {
  animateTopScroll(toY, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toY, options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(currentPositionY(options) + toY, options);
};

exports.default = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(93);

var _utils = __webpack_require__(42);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.pushHash(to);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports.default = scrollHash;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(38);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(58);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.name !== nextProps.name) {
          this.registerElems(nextProps.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),
/* 149 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_day_picker_lib_style_css__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_day_picker_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_day_picker_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobile_detect__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobile_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobile_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Label__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(5);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var DayPickerInput = __webpack_require__(424);


var classNames = __webpack_require__(8);



// Component will receive date, locale and localeUtils props
function YearMonthForm(_a) {
    var date = _a.date, fromMonth = _a.fromMonth, toMonth = _a.toMonth, localeUtils = _a.localeUtils, onChange = _a.onChange;
    var months = localeUtils.getMonths();
    var years = [];
    for (var i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
        years.push(i);
    }
    var handleChange = function (e) {
        var _a = e.target.form, year = _a.year, month = _a.month;
        onChange(new Date(year.value, month.value));
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("form", { className: "DayPicker-Caption" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("select", { name: "month", className: "form-control form-control-sm", onChange: handleChange, value: date.getMonth() }, months.map(function (month, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option", { key: i, value: i }, month)); })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("select", { name: "year", className: "form-control form-control-sm", onChange: handleChange, value: date.getFullYear() }, years.map(function (year, i) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option", { key: i, value: year }, year)); }))));
}
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.formatDateForIE = function (value) {
            var formatted = value;
            if (typeof value === 'string' && value.length >= 8) {
                formatted = __WEBPACK_IMPORTED_MODULE_2_moment__(value).isValid() ? __WEBPACK_IMPORTED_MODULE_2_moment__(value).format('YYYY-MM-DD') : value;
            }
            else if (__WEBPACK_IMPORTED_MODULE_2_moment__["isDate"](value)) {
                formatted = __WEBPACK_IMPORTED_MODULE_2_moment__(value).isValid() ? __WEBPACK_IMPORTED_MODULE_2_moment__(value).format('YYYY-MM-DD') : value;
            }
            return formatted;
        };
        _this.handleYearMonthChange = function (month) {
            _this.setState({ month: month });
        };
        _this.handleOnDayChange = function (value, value2) {
            if (_this.props.onChange && value !== undefined) {
                var e = {
                    target: {
                        name: _this.props.name,
                        value: __WEBPACK_IMPORTED_MODULE_2_moment__(value).format('YYYY-MM-DD')
                    }
                };
                _this.props.onChange(e);
            }
        };
        _this.onKeyUp = function (e) {
            var value = e.target.value;
            if (value.match(/^\d{4}$/) !== null) {
                value = value + '-';
            }
            else if (value.match(/^\d{4}-\d{2}$/) !== null) {
                value = value + '-';
            }
            if (_this.props.onChange) {
                var e2 = {
                    target: {
                        name: _this.props.name,
                        value: value
                    }
                };
                _this.props.onChange(e2);
            }
        };
        _this.onKeyDown = function (e) {
            if (e.key === '-') {
                e.preventDefault();
            }
        };
        _this.handleYearMonthChange = _this.handleYearMonthChange.bind(_this);
        _this.state = {
            month: _this.props.defaultValue
        };
        var md = new __WEBPACK_IMPORTED_MODULE_3_mobile_detect__(window.navigator.userAgent);
        _this.isCustomPicker = md.version('IE') || md.mobile() ? false : true;
        return _this;
    }
    DatePicker.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var fromMonth = props.dateRangeStart || new Date(currentYear, currentDate.getMonth());
        var toMonth = props.dateRangeEnd || new Date(currentYear + 10, 11);
        return this.isCustomPicker ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-group', props.className, { 'custom-datepicker': this.isCustomPicker }) },
            props.labelText && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Label__["a" /* default */], { htmlFor: props.name, required: props.required }, props.labelText)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "input-group" },
                props.disabled ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5____["n" /* TextInput */], { name: props.name, value: __WEBPACK_IMPORTED_MODULE_2_moment__(props.value).format('YYYY-MM-DD'), disabled: props.disabled })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DayPickerInput, { className: classNames('form-control', { 'is-invalid': props.error && props.error.hasError }), id: props.id, name: props.name, type: "text", format: "YYYY-MM-DD", placeholder: props.placeholder || 'YYYY-MM-DD', value: props.value, onDayChange: this.handleOnDayChange, defaultValue: props.defaultValue, dayPickerProps: {
                        month: this.state.month,
                        fromMonth: fromMonth,
                        toMonth: toMonth,
                        captionElement: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](YearMonthForm, { fromMonth: fromMonth, toMonth: toMonth, onChange: function (month) { return _this.handleYearMonthChange(month); } }))
                    }, onBlur: this.props.onBlur, onKeyUp: this.onKeyUp, onKeyDown: this.onKeyDown })),
                props.error && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "invalid-feedback d-block" }, props.error.message)))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5____["n" /* TextInput */], { labelText: props.labelText, className: props.className, id: props.id, name: props.name, type: "date", placeholder: props.placeholder || 'YYYY-MM-DD', value: this.formatDateForIE(props.value), onChange: this.props.onChange, onBlur: this.props.onBlur, onKeyUp: this.onKeyUp, error: props.error, required: true }));
    };
    return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;
var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function formatDay(day) {
  return day.toDateString();
}

function formatMonthTitle(d) {
  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

function formatWeekdayShort(i) {
  return WEEKDAYS_SHORT[i];
}

function formatWeekdayLong(i) {
  return WEEKDAYS_LONG[i];
}

function getFirstDayOfWeek() {
  return 0;
}

function getMonths() {
  return MONTHS;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};
//# sourceMappingURL=LocaleUtils.js.map

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dayMatchesModifier = dayMatchesModifier;
exports.getModifiersForDay = getModifiersForDay;

var _DateUtils = __webpack_require__(44);

var _Helpers = __webpack_require__(60);

/**
 * Return `true` if a date matches the specified modifier.
 * 
 * @export
 * @param {Date} day
 * @param {Any} modifier 
 * @return {Boolean}
 */
function dayMatchesModifier(day, modifier) {
  if (!modifier) {
    return false;
  }
  var arr = Array.isArray(modifier) ? modifier : [modifier];
  return arr.some(function (mod) {
    if (!mod) {
      return false;
    }
    if (mod instanceof Date) {
      return (0, _DateUtils.isSameDay)(day, mod);
    }
    if ((0, _Helpers.isRangeOfDates)(mod)) {
      return (0, _DateUtils.isDayInRange)(day, mod);
    }
    if (mod.after && mod.before && (0, _DateUtils.isDayAfter)(mod.before, mod.after)) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) && (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after && mod.before && ((0, _DateUtils.isDayAfter)(mod.after, mod.before) || (0, _DateUtils.isSameDay)(mod.after, mod.before))) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) || (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after) {
      return (0, _DateUtils.isDayAfter)(day, mod.after);
    }
    if (mod.before) {
      return (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.daysOfWeek) {
      return mod.daysOfWeek.some(function (dayOfWeek) {
        return day.getDay() === dayOfWeek;
      });
    }
    if (typeof mod === 'function') {
      return mod(day);
    }
    return false;
  });
}

/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 * 
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}] 
 * @return {Array}
 */
function getModifiersForDay(day) {
  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
    var value = modifiersObj[modifierName];
    if (dayMatchesModifier(day, value)) {
      modifiers.push(modifierName);
    }
    return modifiers;
  }, []);
}

exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };
//# sourceMappingURL=ModifiersUtils.js.map

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var classNames = __webpack_require__(8);
var RequiredLabel = function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: classNames('label-required', props.className) }, props.children);
};
/* harmony default export */ __webpack_exports__["a"] = (RequiredLabel);


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DropdownInput__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var defaultCountryOptions = [
    {
        text: '',
        value: ''
    }
];
var CountryDropdown = /** @class */ (function (_super) {
    __extends(CountryDropdown, _super);
    function CountryDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.countryOptions = defaultCountryOptions;
        _this.countryOptions = _this.props.countries.map(function (p) {
            return { text: p.description, value: p.description };
        });
        return _this;
    }
    CountryDropdown.prototype.componentWillReceiveProps = function (nextProps) {
        this.countryOptions = nextProps.countries.map(function (p) {
            return { text: p.description, value: p.description };
        });
    };
    CountryDropdown.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DropdownInput__["a" /* default */], { labelText: this.props.labelText, name: this.props.name || 'country', defaultOption: "-", options: this.countryOptions, onBlur: this.props.onBlur, onChange: this.props.onChange, value: this.props.country || '', className: this.props.className, required: this.props.required }));
    };
    return CountryDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state, ownProps) {
    var countries;
    if (ownProps.countries) {
        countries = ownProps.countries;
    }
    else {
        countries = state.pickList.items.filter(function (p) { return p.pickListTypeId === __WEBPACK_IMPORTED_MODULE_3__common_utils__["g" /* PickListType */].Countries; });
    }
    return {
        countries: countries
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(CountryDropdown));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = __webpack_require__(140);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SPRING_PRECISION = 1;

var WAITING = 'WAITING';
var RESIZING = 'RESIZING';
var RESTING = 'RESTING';
var IDLING = 'IDLING';

var noop = function noop() {
  return null;
};
var css = {
  collapse: 'ReactCollapse--collapse',
  content: 'ReactCollapse--content'
};

var Collapse = exports.Collapse = function (_React$PureComponent) {
  _inherits(Collapse, _React$PureComponent);

  function Collapse(props) {
    _classCallCheck(this, Collapse);

    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      currentState: IDLING,
      from: 0,
      to: 0
    };
    return _this;
  }

  _createClass(Collapse, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          isOpened = _props.isOpened,
          forceInitialAnimation = _props.forceInitialAnimation,
          onRest = _props.onRest;

      if (isOpened) {
        var to = this.getTo();
        if (forceInitialAnimation) {
          var from = this.wrapper.clientHeight;
          this.setState({ currentState: RESIZING, from: from, to: to });
        } else {
          this.setState({ currentState: IDLING, from: to, to: to });
        }
      }
      onRest();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hasNestedCollapse) {
        // For nested collapses we do not need to change to waiting state
        // and should keep `height:auto`
        // Because children will be animated and height will not jump anyway
        // See https://github.com/nkbt/react-collapse/issues/76 for more details
        if (nextProps.isOpened !== this.props.isOpened) {
          // Still go to WAITING state if own isOpened was changed
          this.setState({ currentState: WAITING });
        }
      } else if (this.state.currentState === IDLING && (nextProps.isOpened || this.props.isOpened)) {
        this.setState({ currentState: WAITING });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_, prevState) {
      var _props2 = this.props,
          isOpened = _props2.isOpened,
          onRest = _props2.onRest,
          onMeasure = _props2.onMeasure;


      if (this.state.currentState === IDLING) {
        onRest();
        return;
      }

      if (prevState.to !== this.state.to) {
        onMeasure({ height: this.state.to, width: this.content.clientWidth });
      }

      var from = this.wrapper.clientHeight;
      var to = isOpened ? this.getTo() : 0;

      if (from !== to) {
        this.setState({ currentState: RESIZING, from: from, to: to });
        return;
      }

      if (this.state.currentState === RESTING || this.state.currentState === WAITING) {
        this.setState({ currentState: IDLING, from: from, to: to });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      cancelAnimationFrame(this.raf);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_reactMotion.Motion, _extends({}, this.getMotionProps(), {
        onRest: this.onRest,
        children: this.renderContent }));
    }
  }]);

  return Collapse;
}(_react2.default.PureComponent);

Collapse.propTypes = {
  isOpened: _propTypes2.default.bool.isRequired,
  springConfig: _propTypes2.default.objectOf(_propTypes2.default.number),
  forceInitialAnimation: _propTypes2.default.bool,

  hasNestedCollapse: _propTypes2.default.bool,

  fixedHeight: _propTypes2.default.number,

  theme: _propTypes2.default.objectOf(_propTypes2.default.string),
  style: _propTypes2.default.object,

  onRender: _propTypes2.default.func,
  onRest: _propTypes2.default.func,
  onMeasure: _propTypes2.default.func,

  children: _propTypes2.default.node.isRequired
};
Collapse.defaultProps = {
  forceInitialAnimation: false,
  hasNestedCollapse: false,
  fixedHeight: -1,
  style: {},
  theme: css,
  onRender: noop,
  onRest: noop,
  onMeasure: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onContentRef = function (content) {
    _this2.content = content;
  };

  this.onWrapperRef = function (wrapper) {
    _this2.wrapper = wrapper;
  };

  this.onRest = function () {
    _this2.raf = requestAnimationFrame(_this2.setResting);
  };

  this.setResting = function () {
    _this2.setState({ currentState: RESTING });
  };

  this.getTo = function () {
    var fixedHeight = _this2.props.fixedHeight;

    return fixedHeight > -1 ? fixedHeight : _this2.content.clientHeight;
  };

  this.getWrapperStyle = function (height) {
    if (_this2.state.currentState === IDLING && _this2.state.to) {
      var fixedHeight = _this2.props.fixedHeight;

      if (fixedHeight > -1) {
        return { overflow: 'hidden', height: fixedHeight };
      }
      return { height: 'auto' };
    }

    if (_this2.state.currentState === WAITING && !_this2.state.to) {
      return { overflow: 'hidden', height: 0 };
    }

    return { overflow: 'hidden', height: Math.max(0, height) };
  };

  this.getMotionProps = function () {
    var springConfig = _this2.props.springConfig;


    return _this2.state.currentState === IDLING ? {
      // When completely stable, instantly jump to the position
      defaultStyle: { height: _this2.state.to },
      style: { height: _this2.state.to }
    } : {
      // Otherwise, animate
      defaultStyle: { height: _this2.state.from },
      style: { height: (0, _reactMotion.spring)(_this2.state.to, _extends({ precision: SPRING_PRECISION }, springConfig)) }
    };
  };

  this.renderContent = function (_ref) {
    var height = _ref.height;

    // eslint-disable-line
    var _props3 = _this2.props,
        _isOpened = _props3.isOpened,
        _springConfig = _props3.springConfig,
        _forceInitialAnimation = _props3.forceInitialAnimation,
        _hasNestedCollapse = _props3.hasNestedCollapse,
        _fixedHeight = _props3.fixedHeight,
        theme = _props3.theme,
        style = _props3.style,
        onRender = _props3.onRender,
        _onRest = _props3.onRest,
        _onMeasure = _props3.onMeasure,
        children = _props3.children,
        props = _objectWithoutProperties(_props3, ['isOpened', 'springConfig', 'forceInitialAnimation', 'hasNestedCollapse', 'fixedHeight', 'theme', 'style', 'onRender', 'onRest', 'onMeasure', 'children']);

    var _state = _this2.state,
        from = _state.from,
        to = _state.to;

    // DANGEROUS, use with caution, never do setState with it

    onRender({ current: height, from: from, to: to });

    return _react2.default.createElement(
      'div',
      _extends({
        ref: _this2.onWrapperRef,
        className: theme.collapse,
        style: _extends({}, _this2.getWrapperStyle(Math.max(0, height)), style)
      }, props),
      _react2.default.createElement(
        'div',
        { ref: _this2.onContentRef, className: theme.content },
        children
      )
    );
  };
};

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QuotePlan__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QuotePlanDetails__ = __webpack_require__(460);

var classNames = __webpack_require__(8);


var PlanOptions = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('quote-plans', props.className) }, props.planOptions.map(function (option, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__QuotePlan__["a" /* default */], { key: index, workflow: props.workflow, option: option, onCustomerPolicySelect: props.onCustomerPolicySelect, isLoading: props.isLoading }, props.workflow === 'B' && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__QuotePlanDetails__["a" /* default */], { items: [
                {
                    description: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Partial"),
                        " income replacement")),
                    enabled: true
                },
                { description: 'Mortgage & debt protection', enabled: true },
                { description: 'Post-secondary coverage', enabled: false }
            ] })))); })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null, "Rates may change based on lifestyle"))));
};
/* harmony default export */ __webpack_exports__["a"] = (PlanOptions);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_icons__ = __webpack_require__(7);


var classNames = __webpack_require__(8);



var renderWorkflowAPlan = function (props) {
    var children = props.children, _a = props.option, coverageAmount = _a.coverageAmount, term = _a.term, rate = _a.rate;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quote-plan-content" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-inline-flex align-items-center mb-3 px-1 bg-info-dark text-white" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_icons__["I" /* IconTriangleRight */], { className: "svg-inline" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-body mx-1" }, "First two months FREE!"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_icons__["H" /* IconTriangleLeft */], { className: "svg-inline" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "quote-plan-title text-secondary" },
            coverageAmount != null && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "d-block" },
                __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatCurrency(coverageAmount, 0),
                " coverage")),
            term && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "d-block" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { className: "strong" },
                    coverageAmount != null && " for a ",
                    term,
                    " year term")))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "quote-plan-subtitle text-secondary mt-3" }, rate && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
            __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatCurrency(rate, 2),
            "/month")),
        children));
};
var renderWorkflowBPlan = function (props) {
    var children = props.children, _a = props.option, coverageAmount = _a.coverageAmount, term = _a.term, rate = _a.rate;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quote-plan-content" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-inline-flex align-items-center mb-3 px-1 bg-info-dark text-white" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_icons__["I" /* IconTriangleRight */], { className: "svg-inline" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-body mx-1" }, "First two months FREE!"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_icons__["H" /* IconTriangleLeft */], { className: "svg-inline" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "quote-plan-title text-secondary" },
            __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatCurrency(rate, 2),
            "/month"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "quote-plan-subtitle text-secondary" + (coverageAmount != null ? ' mt-3' : '') },
            coverageAmount != null && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "d-block" },
                __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatCurrency(coverageAmount, 0),
                " coverage")),
            term && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "d-block" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { className: "strong" },
                    coverageAmount != null && " for a ",
                    term,
                    " year term")))),
        children));
};
var renderWorkflowCPlan = function (props) {
    var children = props.children, _a = props.option, term = _a.term, rate = _a.rate;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quote-plan-content" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-inline-flex align-items-center mb-3 px-1 bg-info-dark text-white" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_icons__["I" /* IconTriangleRight */], { className: "svg-inline" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-body mx-1" }, "First two months FREE!"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_icons__["H" /* IconTriangleLeft */], { className: "svg-inline" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "quote-plan-title text-secondary" }, term && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "d-block" },
            term,
            " year term")),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "quote-plan-subtitle text-secondary mt-3" }, rate && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
            __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatCurrency(rate, 2),
            "/month")),
        children));
};
var QuotePlan = function (props) {
    var className = props.className, workflow = props.workflow, option = props.option, actionChildren = props.actionChildren, onCustomerPolicySelect = props.onCustomerPolicySelect, isLoading = props.isLoading;
    if (isLoading) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('quote-plan loading', className) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quote-plan-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "quote-plan-title has-loading-text" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "quote-plan-subtitle mt-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "d-block has-loading-text" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "d-block has-loading-text" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quote-plan-actions mt-4" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons__["a" /* Button */], { className: "btn-primary btn-block has-loading-text", disabled: true }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons__["a" /* Button */], { className: "text-primary btn-block has-loading-text", disabled: true }))));
    }
    else {
        var plan = void 0;
        if (workflow === 'A') {
            plan = renderWorkflowAPlan(props);
        }
        else if (workflow === 'B') {
            plan = renderWorkflowBPlan(props);
        }
        else if (workflow === 'C') {
            plan = renderWorkflowCPlan(props);
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('quote-plan content-fade-in', className) },
            plan,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quote-plan-actions" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons__["a" /* Button */], { className: "btn-primary btn-block", onClick: function () { return onCustomerPolicySelect(option); }, disabled: !props.selectPolicyOptionsEnabled }, "Get started"),
                actionChildren)));
    }
};
function mapStateToProps(state) {
    return {
        selectPolicyOptionsEnabled: state.settings.selectPolicyOptionsEnabled
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(QuotePlan));


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payment_PaymentDetailsForm__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




var BillingForm = /** @class */ (function (_super) {
    __extends(BillingForm, _super);
    function BillingForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBlur = function (field) { return function (evt) {
            _this.setState({
                touched: __assign({}, _this.state.touched, (_a = {}, _a[field] = true, _a))
            });
            var _a;
        }; };
        _this.state = {
            touched: {
                mailingPostalCode: false,
                billingPostalCode: false
            }
        };
        return _this;
    }
    BillingForm.prototype.render = function () {
        var userText = this.props.isCustomer ? 'your' : 'customer\'s';
        var sameAddressLabelText = this.props.isCustomer ? 'Your billing address is the same as your mailing address' :
            'Customer\'s billing address is the same as the mailing address';
        var recieveCopyLabelText = this.props.isCustomer ? 'After you enroll, your policy will be emailed to you and will ' +
            'also be available through your online account. In addition to this, would you also like to receive a paper copy ' +
            'in the mail?' :
            'Would customer like to receive a paper copy in the mail?';
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("fieldset", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "col-12" },
                    "Please enter ",
                    userText,
                    " payment details."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-12" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__payment_PaymentDetailsForm__["a" /* default */], { details: this.props.paymentDetails, actions: this.props.actions, onStripeElementChange: this.props.onStripeElementChange }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row mt-4" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "col-12" },
                    "Please enter ",
                    userText,
                    " mailing address."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Street address", name: "mailingAddress", onChange: this.props.onUserChange, value: this.props.user.mailingAddress, className: "col-12" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "City", name: "mailingCity", onChange: this.props.onUserChange, value: this.props.user.mailingCity, className: "col-sm-6" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["k" /* ProvinceDropdown */], { labelText: "Province", name: "mailingProvince", province: this.props.user.mailingProvince, onChange: this.props.onUserChange, className: "col-sm-6" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Postal code", name: "mailingPostalCode", onBlur: this.handleBlur('mailingPostalCode'), onChange: this.props.onUserChange, value: this.props.user.mailingPostalCode, className: "col-sm-6", error: __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].shouldMarkError(this.props.errors.mailingPostalCode, this.state.touched.mailingPostalCode)
                        ? this.props.errors.mailingPostalCode
                        : undefined }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["e" /* CountryDropdown */], { labelText: "Country", name: "mailingCountry", country: this.props.user.mailingCountry, onChange: this.props.onUserChange, className: "col-sm-6" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["b" /* Checkbox */], { label: sameAddressLabelText, name: "isSameAddress", onChange: this.props.onUserChange, checked: this.props.user.isSameAddress }),
            !this.props.user.isSameAddress && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row mt-4" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "col-12" },
                    "Please enter ",
                    userText,
                    " billing address"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Address", name: "billingAddress", onChange: this.props.onUserChange, value: this.props.user.billingAddress, className: "col-sm-12" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "City", name: "billingCity", onChange: this.props.onUserChange, value: this.props.user.billingCity, className: "col-sm-6" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["k" /* ProvinceDropdown */], { labelText: "Province", name: "billingProvince", province: this.props.user.billingProvince, onChange: this.props.onUserChange, className: "col-sm-6" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Postal code", name: "billingPostalCode", onBlur: this.handleBlur('billingPostalCode'), onChange: this.props.onUserChange, value: this.props.user.billingPostalCode, className: "col-sm-6", error: __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].shouldMarkError(this.props.errors.billingPostalCode, this.state.touched.billingPostalCode)
                        ? this.props.errors.billingPostalCode
                        : undefined }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["e" /* CountryDropdown */], { labelText: "Country", name: "billingCountry", country: this.props.user.billingCountry, onChange: this.props.onUserChange, className: "col-sm-6" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row mt-4" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "col-12" },
                    "Please enter ",
                    userText,
                    " phone number and e-mail address."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Phone", name: "phoneNumber", onChange: this.props.onUserChange, onKeyUp: this.props.onPhoneKeyUp, value: this.props.user.phoneNumber, className: "col-md-6 mb-0" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "E-mail", name: "email", onChange: this.props.onUserChange, value: this.props.user.email, className: "col-md-6 mb-0" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row mt-4" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { id: "receivePaperCopy", labelText: recieveCopyLabelText, name: "receivePaperCopy", onChildren: "Yes", offChildren: "No", onChange: this.props.onPolicyChange, checked: this.props.customerPolicy.receivePaperCopy, className: "col-12 toggle-yes-no" }))));
    };
    return BillingForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (BillingForm);


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OptionalBeneficiaryPage__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OptionalBeneficiaryDisbursementPage__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WorkflowStep__ = __webpack_require__(19);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



// import * as toastr from 'toastr';

// import Utils, { UtilsBeneficiaries, BeneficiaryTypes } from '../../../common/utils';
// import { defaultTrustee } from '../../../policy/policyAPI';





var OptionalBeneficiaryContainer = /** @class */ (function (_super) {
    __extends(OptionalBeneficiaryContainer, _super);
    function OptionalBeneficiaryContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.lastStep = 2;
        _this.goToExistingBeneficiary = function () {
            _this.setState({ currentStep: 1 });
            return _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/beneficiary");
        };
        _this.nextStep = function (e) {
            var currentStep = _this.state.currentStep;
            if (currentStep === _this.lastStep) {
                return _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/billing");
            }
            else {
                currentStep++;
                _this.setState(__assign({}, _this.state, { currentStep: currentStep }));
            }
        };
        _this.skip = function () {
            return _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/billing");
        };
        _this.hideSkipButton = function () {
            _this.setState({ allowToSkip: false });
        };
        _this.state = {
            currentStep: _this.getStep(),
            isLoading: false,
            allowToSkip: true
        };
        return _this;
    }
    OptionalBeneficiaryContainer.prototype.getStep = function () {
        var step = parseInt(location.hash.replace('#', ''), 10);
        if (!isNaN(step)) {
            return step;
        }
        return 1;
    };
    OptionalBeneficiaryContainer.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.currentStep !== prevState.currentStep) {
            location.hash = this.state.currentStep.toString();
        }
    };
    OptionalBeneficiaryContainer.prototype.render = function () {
        var currentBeneficiaryComponent = null;
        switch (this.state.currentStep) {
            case 1:
                currentBeneficiaryComponent = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__OptionalBeneficiaryPage__["a" /* default */], __assign({}, this.props, { nextStep: this.nextStep, hidden: false, hideSkipButton: this.hideSkipButton })));
                break;
            case 2:
            default:
                currentBeneficiaryComponent = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__OptionalBeneficiaryDisbursementPage__["a" /* default */], __assign({}, this.props, { nextStep: this.nextStep, hidden: false, goToExistingBeneficiary: this.goToExistingBeneficiary })));
                break;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__WorkflowStep__["a" /* default */], null,
            currentBeneficiaryComponent,
            this.state.currentStep !== this.lastStep && this.state.allowToSkip &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { onClick: this.skip, className: "btn-outline-primary workflow-progress-action", disabled: this.state.isLoading },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Skip"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["t" /* IconChevronRight */], null)))));
    };
    return OptionalBeneficiaryContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        customer: state.user.user,
        customerPolicy: state.policy.customerPolicy
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(OptionalBeneficiaryContainer));


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rheostat__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rheostat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rheostat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rheostat_css_slider_css__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rheostat_css_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rheostat_css_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rheostat_css_slider_horizontal_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rheostat_css_slider_horizontal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rheostat_css_slider_horizontal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var classNames = __webpack_require__(8);

var RheostatPit = function (_a) {
    var style = _a.style, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "rheostat-pit", style: style }, children));
};
var QuoteSlider = /** @class */ (function (_super) {
    __extends(QuoteSlider, _super);
    function QuoteSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.SLIDER_RANGE = _this.props.max - _this.props.min;
        return _this;
    }
    QuoteSlider.prototype.render = function () {
        var props = __rest(this.props, []);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('quote-slider', props.className) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "text-secondary text-center mb-4 rheostat-title" },
                props.titlePrefix && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "rheostat-title-prepend" }, props.titlePrefix),
                props.valuePrefix,
                __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatNumberWithCommas(props.value),
                props.valueSuffix,
                props.titleSuffix && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "rheostat-title-append" }, props.titleSuffix)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row mb-5" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg-2 text-secondary text-right small d-none d-lg-block rheostat-prepend" },
                    props.valuePrefix,
                    __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].getAbbreviatedNumber(props.min),
                    props.minSuffix,
                    props.valueSuffix),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg-8 d-lg-flex align-items-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_rheostat___default.a, { orientation: "horizontal", min: Math.round(props.min / props.max * 100 * 10) / 10, values: [Math.round(props.value / props.max * 100 * 10) / 10], pitComponent: RheostatPit, pitPoints: [
                            (0.25 * this.SLIDER_RANGE + props.min) / props.max * 100,
                            (0.5 * this.SLIDER_RANGE + props.min) / props.max * 100,
                            (0.75 * this.SLIDER_RANGE + props.min) / props.max * 100
                        ], onSliderDragEnd: props.onSliderDragEnd, onValuesUpdated: props.onValuesUpdated, snap: false, snapPoints: props.snapPoints })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg-2 text-secondary text-left small d-none d-lg-block rheostat-append" },
                    props.valuePrefix,
                    __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].getAbbreviatedNumber(props.max),
                    props.maxSuffix,
                    props.valueSuffix))));
    };
    return QuoteSlider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (QuoteSlider);


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QuoteSlider__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var CustomSelectYourPlanPage = /** @class */ (function (_super) {
    __extends(CustomSelectYourPlanPage, _super);
    function CustomSelectYourPlanPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: true,
            rate: 0
        };
        _this.COVERAGE_MAX = 1000000;
        _this.COVERAGE_MIN = 25000;
        _this.COVERAGE_DEFAULT = 500000;
        _this.TERM_MAX = 65 - (_this.props.customerDetails.age || 0);
        _this.TERM_MIN = _this.props.currentUser.isAuthenticated ? 5 : 10;
        _this.TERM_DEFAULT = 65 - (_this.props.customerDetails.age || 0) >= 20 ?
            20 : (65 - (_this.props.customerDetails.age || 0) <= 15 ? 10 : 15);
        _this.onCoverageUpdate = function (slider) {
            // Rheostat uses a values list to support multiple handles. Since we only have one handle, take the first index.
            var valuePct = slider.values[0] / 100;
            var customerPolicy = __assign({}, _this.props.customerPolicy, { coverageAmount: Math.round(_this.COVERAGE_MAX * valuePct) });
            _this.props.actions.setCustomerPolicy(customerPolicy);
        };
        _this.onTermUpdate = function (slider) {
            // Rheostat uses a values list to support multiple handles. Since we only have one handle, take the first index.
            var valuePct = slider.values[0] / 100;
            var customerPolicy = __assign({}, _this.props.customerPolicy, { term: Math.round(_this.TERM_MAX * valuePct) });
            _this.props.actions.setCustomerPolicy(customerPolicy);
        };
        _this.onSliderDragEnd = function () {
            _this.setState({ isLoading: true });
            var _a = _this.props.customerPolicy, coverageAmount = _a.coverageAmount, term = _a.term;
            var _b = _this.props.user, gender = _b.gender, id = _b.id;
            var age = _this.props.customerDetails.age;
            var params = {
                coverageAmount: coverageAmount,
                term: term,
                gender: gender,
                age: age,
                customerDemographicDetailsJson: _this.props.customerDetails,
                childrenAge: _this.props.assessment.childrenAge.map(function (a) { return !a ? 0 : a; }).join(','),
                userId: id
            };
            _this.props.actions.fetchAdvisoryPlanOptions(params)
                .then(function () { return _this.setState({ isLoading: false }); });
        };
        _this.next = function () {
            var customerPolicy = __assign({}, _this.props.customerPolicy, { rate: _this.props.planOptions[0].rate });
            _this.props.onCustomerPolicySelect(customerPolicy);
        };
        return _this;
    }
    CustomSelectYourPlanPage.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({ isLoading: true });
        var _a = this.props.user, gender = _a.gender, id = _a.id;
        var _b = this.props.customerDetails, isSmoker = _b.isSmoker, age = _b.age;
        if (age == null || age < 18 || age > 54 || gender == null || isSmoker == null) {
            this.props.history.replace("/quote/" + this.props.match.params.workflow + "/about-you");
        }
        else {
            var customerPolicy = __assign({}, this.props.customerPolicy);
            if (this.props.customerPolicy.coverageAmount == null) {
                customerPolicy.coverageAmount = this.COVERAGE_DEFAULT;
                this.props.actions.setCustomerPolicy(customerPolicy);
            }
            if (this.props.customerPolicy.term == null || this.props.customerPolicy.term > this.TERM_DEFAULT) {
                customerPolicy.term = this.TERM_DEFAULT;
                this.props.actions.setCustomerPolicy(customerPolicy);
            }
            var coverageAmount = customerPolicy.coverageAmount, term = customerPolicy.term;
            var params = {
                coverageAmount: coverageAmount,
                term: term,
                gender: gender,
                age: age,
                customerDemographicDetailsJson: this.props.customerDetails,
                childrenAge: this.props.assessment.childrenAge.map(function (a) { return !a ? 0 : a; }).join(','),
                userId: id
            };
            this.props.actions.fetchAdvisoryPlanOptions(params)
                .then(function () { return _this.setState({ isLoading: false }); });
        }
    };
    CustomSelectYourPlanPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__WorkflowStep__["a" /* default */], { title: "To see your quote, use the sliders to select the coverage amount and term that best meet your needs." },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section section-lg section-bordered" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg-8" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__QuoteSlider__["a" /* default */], { className: "mb-4", min: this.COVERAGE_MIN, max: this.COVERAGE_MAX, value: this.props.customerPolicy.coverageAmount, valuePrefix: "$", titleSuffix: "in coverage", onSliderDragEnd: this.onSliderDragEnd, onValuesUpdated: this.onCoverageUpdate }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__QuoteSlider__["a" /* default */], { className: "mb-4", min: this.TERM_MIN, max: this.TERM_MAX, value: this.props.customerPolicy.term, titleSuffix: "year term", onSliderDragEnd: this.onSliderDragEnd, onValuesUpdated: this.onTermUpdate, minSuffix: " years", maxSuffix: " years" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg-4 quote-plans-advisory text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quote-plan" }, this.props.planOptions.length > 0
                            ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quote-plan-content" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-inline-flex align-items-center mb-3 px-1 bg-info-dark text-white" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_icons__["I" /* IconTriangleRight */], { className: "svg-inline" }),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-body mx-1" }, "First two months FREE!"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_icons__["H" /* IconTriangleLeft */], { className: "svg-inline" })),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "quote-plan-title text-secondary" },
                                    __WEBPACK_IMPORTED_MODULE_5__common_utils__["m" /* default */].formatCurrency(this.props.planOptions[0].rate, 2),
                                    "/month"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { className: "text-secondary" }, "may change based on lifestyle"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quote-plan-actions" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { onClick: this.next, className: "btn-primary btn-block", disabled: !this.props.selectPolicyOptionsEnabled }, "Get started"))))
                            : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quote-plan-content" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "quote-plan-title text-secondary" }, "Sorry, we currently do not have any plans available for you.")))))))));
    };
    return CustomSelectYourPlanPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        selectPolicyOptionsEnabled: state.settings.selectPolicyOptionsEnabled
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(CustomSelectYourPlanPage));


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_UserDetailsForm__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var CustomerDetailsPage = /** @class */ (function (_super) {
    __extends(CustomerDetailsPage, _super);
    function CustomerDetailsPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errors = {
            email: {},
            mailingPostalCode: {},
            billingPostalCode: {}
        };
        _this.state = {
            originalEmail: _this.props.customer.email
        };
        _this.onUserChange = function (e) {
            var customer = __assign({}, _this.props.customer, (_a = {}, _a[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value, _a));
            _this.props.actions.setUser(customer);
            var _a;
        };
        _this.validate = function () {
            // true means invalid
            return {
                email: __WEBPACK_IMPORTED_MODULE_5__common_utils__["k" /* Validation */].validateEmail(_this.props.customer.email),
                mailingPostalCode: __WEBPACK_IMPORTED_MODULE_5__common_utils__["k" /* Validation */]
                    .validatePostalCode(_this.props.customer.mailingPostalCode, 'Mailing postal code is not valid.'),
                billingPostalCode: __WEBPACK_IMPORTED_MODULE_5__common_utils__["k" /* Validation */]
                    .validatePostalCode(_this.props.customer.billingPostalCode, 'Billing postal code is not valid.')
            };
        };
        _this.save = function () {
            var customer = __assign({}, _this.props.customer);
            if (customer.isSameAddress) {
                customer.billingAddress = customer.mailingAddress;
                customer.billingCity = customer.mailingCity;
                customer.billingProvince = customer.mailingProvince;
                customer.billingPostalCode = customer.mailingPostalCode;
                customer.billingCountry = customer.mailingCountry;
            }
            // We want to try to save first, if that works, then we want to update stripe.
            // Otherwise, there is a race condition, as well if there is an error saving
            // we'll have a bad time.
            _this.props.actions.adminSaveUser(customer)
                .then(function (savedUser) {
                if (_this.state.originalEmail !== customer.email) {
                    _this.props.actions.updateStripeCustomerEmail(customer.stripeCustomerId, customer.email)
                        .then(function (next) {
                        _this.setState({ originalEmail: customer.email });
                        __WEBPACK_IMPORTED_MODULE_1_toastr__["success"]('Saved!');
                    });
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_1_toastr__["success"]('Saved!');
                }
            })
                .catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_1_toastr__["error"](error.response.data.responseStatus.message);
            });
        };
        _this.isSaveDisabled = function () {
            if (_this.errors.email.hasError ||
                _this.errors.mailingPostalCode.hasError ||
                (!_this.props.customer.isSameAddress && _this.errors.billingPostalCode.hasError)) {
                return true;
            }
            return false;
        };
        return _this;
    }
    CustomerDetailsPage.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: this.props.className },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__user_UserDetailsForm__["a" /* default */], { user: this.props.customer, currentUser: this.props.currentUser, onUserChange: this.onUserChange, errors: this.errors }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons_Button__["a" /* default */], { onClick: this.save, disabled: this.isSaveDisabled(), className: "btn-primary mt-4" }, "Save")));
    };
    return CustomerDetailsPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var adminRoles = ["Admin" /* Administrator */, "Agent" /* Agent */, "Adjudicator" /* Adjudicator */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(CustomerDetailsPage, adminRoles));


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var UserDetailsForm = /** @class */ (function (_super) {
    __extends(UserDetailsForm, _super);
    function UserDetailsForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBlur = function (field) { return function (evt) {
            _this.setState({
                touched: __assign({}, _this.state.touched, (_a = {}, _a[field] = true, _a))
            });
            var _a;
        }; };
        _this.state = {
            touched: {
                email: false,
                mailingPostalCode: false,
                billingPostalCode: false
            }
        };
        return _this;
    }
    UserDetailsForm.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: this.props.className },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Contact Information"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "First Name", name: "firstName", onChange: this.props.onUserChange, value: this.props.user.firstName, className: "col-md-6", required: true }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Last Name", name: "lastName", onChange: this.props.onUserChange, value: this.props.user.lastName, className: "col-md-6", required: true }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Email", name: "email", onBlur: this.handleBlur('email'), onChange: this.props.onUserChange, value: this.props.user.email, className: "col-md-6 mb-md-2", required: true, error: __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].shouldMarkError(this.props.errors.email, this.state.touched.email)
                            ? this.props.errors.email
                            : undefined }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-daypicker-responsive col-md-3" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["a" /* BirthDatePicker */], { labelText: "Birthdate", name: "birthDate", onChange: this.props.onUserChange, value: this.props.user.birthDate, disabled: true, className: "mb-2" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Sex", name: "gender", value: __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatFirstUpperCase(this.props.user.gender), disabled: true, className: "col-md-3 mb-md-2" }),
                    this.props.currentUser.isAuthenticated &&
                        this.props.currentUser.role.some(function (r) { return r === 'Admin' || r === 'Agent' || r === 'Adjudicator'; }) &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Phone Number", name: "phoneNumber", value: this.props.user.phoneNumber, className: "col-md-6 mb-2", disabled: true }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title mt-4" }, "Mailing Address"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Address", name: "mailingAddress", onChange: this.props.onUserChange, value: this.props.user.mailingAddress, className: "col-md-12", required: true }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "City", name: "mailingCity", onChange: this.props.onUserChange, value: this.props.user.mailingCity, className: "col-md-6", required: true }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["k" /* ProvinceDropdown */], { labelText: "Province", name: "mailingProvince", province: this.props.user.mailingProvince, onChange: this.props.onUserChange, className: "col-md-6 mb-md-2", required: true }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Postal code", name: "mailingPostalCode", onBlur: this.handleBlur('mailingPostalCode'), onChange: this.props.onUserChange, value: this.props.user.mailingPostalCode, className: "col-sm-6 mb-md-2", required: true, error: __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].shouldMarkError(this.props.errors.mailingPostalCode, this.state.touched.mailingPostalCode)
                            ? this.props.errors.mailingPostalCode
                            : undefined }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["e" /* CountryDropdown */], { labelText: "Country", name: "mailingCountry", country: this.props.user.mailingCountry, onChange: this.props.onUserChange, className: "col-md-6 mb-2", required: true }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title mt-4" }, "Billing Address"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["b" /* Checkbox */], { label: "Billing Address is the same as Mailing Address", name: "isSameAddress", onChange: this.props.onUserChange, checked: this.props.user.isSameAddress }),
                !this.props.user.isSameAddress && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row mt-3 mt-lg-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Address", name: "billingAddress", onChange: this.props.onUserChange, value: this.props.user.billingAddress, required: true, className: "col-md-12" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "City", name: "billingCity", onChange: this.props.onUserChange, value: this.props.user.billingCity, required: true, className: "col-md-6" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["k" /* ProvinceDropdown */], { labelText: "Province", name: "billingProvince", province: this.props.user.billingProvince, onChange: this.props.onUserChange, required: true, className: "col-md-6 mb-md-2" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Postal code", name: "billingPostalCode", onBlur: this.handleBlur('billingPostalCode'), onChange: this.props.onUserChange, value: this.props.user.billingPostalCode, required: true, className: "col-sm-6", error: __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].shouldMarkError(this.props.errors.billingPostalCode, this.state.touched.billingPostalCode)
                            ? this.props.errors.billingPostalCode
                            : undefined }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["e" /* CountryDropdown */], { labelText: "Country", name: "billingCountry", country: this.props.user.billingCountry, onChange: this.props.onUserChange, required: true, className: "col-md-6 mb-2" }))))));
    };
    return UserDetailsForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (UserDetailsForm);


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paymentActions__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentDetailsForm__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};











var InvoiceDetails = /** @class */ (function (_super) {
    __extends(InvoiceDetails, _super);
    function InvoiceDetails(props) {
        var _this = _super.call(this, props) || this;
        _this.makePayment = function () {
            _this.setState({ isPaymentLoading: true });
            var promise = new Promise(function (resolve, reject) {
                if (_this.state.paymentType === 'existing') {
                    resolve(_this.props.actions.payInvoice(_this.props.payment.stripeInvoiceId));
                }
                else {
                    _this.props.stripe.createToken({ name: _this.props.details.ccCardholderName })
                        .then(function (result) {
                        if (result.error) {
                            throw result.error.message;
                        }
                        else {
                            // Send the token to server
                            resolve(_this.props.actions.payInvoice(_this.props.payment.stripeInvoiceId, result.token, _this.props.user.stripeCustomerId));
                        }
                    });
                }
            });
            promise
                .then(function () {
                _this.setState({ isPaymentLoading: false });
                return _this.props.actions.fetchCustomerPayments(_this.props.match.params.customerId);
            })
                .then(function () {
                if (_this.props.baseUrl) {
                    _this.props.history.push(_this.props.baseUrl);
                }
                else {
                    _this.props.history.push("/user/" + _this.props.match.params.userId + "/billing/view-bills");
                }
            })
                .catch(function (errorMessage) {
                __WEBPACK_IMPORTED_MODULE_3_toastr__["error"](errorMessage);
                _this.setState({ isPaymentLoading: false });
            });
        };
        _this.printInvoice = function () {
            window.print();
        };
        _this.state = {
            isPageLoading: true,
            isPaymentLoading: false,
            paymentType: ''
        };
        return _this;
    }
    InvoiceDetails.prototype.componentDidMount = function () {
        var _this = this;
        var userId = this.props.match.params.customerId || this.props.match.params.userId;
        var invoiceNumber = this.props.match.params.pageId || this.props.match.params.invoiceNumber;
        this.props.actions.fetchCustomerCard(userId)
            .then(function () { return _this.props.actions.fetchCustomerPayment(userId, invoiceNumber); })
            .then(function () { return _this.props.actions.fetchInvoiceCard(_this.props.payment.stripeInvoiceId); })
            .then(function () { return _this.props.actions.fetchCustomerPolicy(userId, _this.props.payment.policyId); })
            .then(function () { return _this.setState({ isPageLoading: false }); })
            .then(function () { return __WEBPACK_IMPORTED_MODULE_10__common_utils__["m" /* default */].setDocTitle("Invoice " + _this.props.payment.stripeInvoiceNumber); });
    };
    InvoiceDetails.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set content-set-lg print-only" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_forms_Fieldset__["a" /* default */], { className: this.props.className },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "invoice-header" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "text-center" }, "Mosaic Life")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "text-center" }, "320 Sioux Road, Sherwood Park, AB"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "text-center" }, "T8A 3X6, 1-855-643-6945")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled invoice-info" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "mr-4" },
                        "Invoice Date: ",
                        __WEBPACK_IMPORTED_MODULE_10__common_utils__["m" /* default */].formatDate(this.props.payment.date)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        "Invoice #: ",
                        this.props.payment.stripeInvoiceNumber)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table", { className: "table invoice-table mb-0" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("thead", { className: "text-muted" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", { colSpan: 2, className: "invoice-table-desc" }, "Description"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", { className: "text-right" }, "Amount"))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { colSpan: 2 },
                                "Policy #: ",
                                this.props.policy.number),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "text-right" }, this.state.isPageLoading ? '-' : __WEBPACK_IMPORTED_MODULE_10__common_utils__["m" /* default */].formatCurrency(this.props.payment.amount))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { colSpan: 2, className: "text-muted pl-2" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Coverage Amount: ")),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "text-right text-nowrap" }, this.state.isPageLoading ? '-' : __WEBPACK_IMPORTED_MODULE_10__common_utils__["m" /* default */].formatCurrency(this.props.policy.coverageAmount, 0))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { colSpan: 2, className: "text-muted pl-2" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Start Date: ")),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "text-right text-nowrap" }, this.state.isPageLoading ? '-' : (this.props.policy.effectiveDate))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { colSpan: 2, className: "text-muted pl-2" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "End Date: ")),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "text-right text-nowrap" }, this.state.isPageLoading ? '-' : (this.props.policy.endDate))),
                        this.props.payment.tax1 ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "hidden invoice-table-cell-hidden invoice-table-cell-no-border" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "text-muted invoice-table-cell-no-border pl-0" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Tax")),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "text-right invoice-table-cell-no-border" }, this.state.isPageLoading ? '-' : __WEBPACK_IMPORTED_MODULE_10__common_utils__["m" /* default */].formatCurrency(this.props.payment.tax1)))) : null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { colSpan: 2 },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Total")),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "text-right" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, this.state.isPageLoading ?
                                    '-' : __WEBPACK_IMPORTED_MODULE_10__common_utils__["m" /* default */].formatCurrency(this.props.payment.amount + this.props.payment.tax1)))),
                        this.props.payment.statusId === __WEBPACK_IMPORTED_MODULE_10__common_utils__["f" /* PaymentStatus */].PaymentSucceeded && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", { className: "large" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "hidden" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "pl-0" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Paid")),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "text-right" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, this.state.isPageLoading ?
                                    '-' : __WEBPACK_IMPORTED_MODULE_10__common_utils__["m" /* default */].formatCurrency(this.props.payment.amount + this.props.payment.tax1))))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "text-right" },
                        this.props.invoiceCard.brand,
                        "-",
                        this.props.invoiceCard.last4),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "text-right" },
                        this.props.payment.statusId === __WEBPACK_IMPORTED_MODULE_10__common_utils__["f" /* PaymentStatus */].Created && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "invoice-status text-warning" }, "Payment pending")),
                        this.props.payment.statusId === __WEBPACK_IMPORTED_MODULE_10__common_utils__["f" /* PaymentStatus */].PaymentSucceeded && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", { className: "invoice-status text-success" }, "Paid")),
                        this.props.payment.statusId === __WEBPACK_IMPORTED_MODULE_10__common_utils__["f" /* PaymentStatus */].PaymentFailed && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "invoice-status text-danger" }, "Payment failed")))),
                this.props.payment.statusId !== __WEBPACK_IMPORTED_MODULE_10__common_utils__["f" /* PaymentStatus */].PaymentSucceeded &&
                    this.props.payment.statusId !== __WEBPACK_IMPORTED_MODULE_10__common_utils__["f" /* PaymentStatus */].Created ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: "invoice-payment" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h5 text-center" }, "Pay your bill"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions my-3" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_buttons__["a" /* Button */], { className: "btn btn-outline-secondary workflow-progress-action" + (this.state.paymentType === 'existing' ? ' active' : ''), onClick: function () { return _this.setState({ paymentType: 'existing' }); } }, "Use existing card"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_buttons__["a" /* Button */], { className: "btn btn-outline-secondary workflow-progress-action" + (this.state.paymentType === 'new' ? ' active' : ''), onClick: function () { return _this.setState({ paymentType: 'new' }); } }, "Use a new card")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__PaymentDetailsForm__["a" /* default */], { details: this.props.details, actions: this.props.actions, hidden: this.state.paymentType !== 'new' }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-center mt-4" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_buttons__["a" /* Button */], { className: "btn-primary", type: "button", onClick: this.makePayment, disabled: this.state.isPaymentLoading || !this.state.paymentType }, "Pay now")))) : null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions no-print" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_buttons__["a" /* Button */], { className: "btn-outline-primary mr-2 workflow-progress-action", type: "button", to: this.props.baseUrl || "/user/" + this.props.match.params.userId + "/billing/view-bills" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_icons__["s" /* IconChevronLeft */], null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2 d-none d-sm-inline-block" }, "Back")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_buttons__["a" /* Button */], { className: "btn-outline-primary mr-3", type: "button", onClick: this.printInvoice },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-3 d-none d-sm-inline-block" }, "Print")))));
    };
    return InvoiceDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        card: state.payment.card,
        invoiceCard: state.payment.invoiceCard,
        details: state.payment.details,
        payment: state.payment.payment,
        policy: state.policy.customerPolicy,
        stripe: state.payment.stripe,
        user: state.user.user
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__paymentActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(InvoiceDetails));


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);








var PaymentHistoryList = function (props) {
    var sortPaymentHistory = function (a, b) {
        return (__WEBPACK_IMPORTED_MODULE_6_moment__(a.createdDate).utc()).isAfter(__WEBPACK_IMPORTED_MODULE_6_moment__(b.createdDate).utc()) ? -1 : 1;
    };
    var paymentsCopy = props.payments.slice();
    var sortedPayments = paymentsCopy.sort(sortPaymentHistory);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_forms__["n" /* TextInput */], { name: "search", placeholder: "Search", value: props.searchterm, onChange: props.onSearch, className: "m-0 table-search" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common__["a" /* DataTable */], { className: props.className, TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                {
                    accessor: 'id',
                    show: false
                },
                {
                    Header: 'Date',
                    accessor: 'date',
                    Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_5__common_utils__["m" /* default */].formatDateAsUTC(row.value); }
                },
                {
                    Header: 'Invoice #',
                    accessor: 'stripeInvoiceNumber'
                },
                {
                    Header: 'Amount',
                    accessor: 'amount',
                    Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_5__common_utils__["m" /* default */].formatCurrency(row.value); }
                },
                {
                    Header: 'Status',
                    accessor: 'statusId',
                    Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_5__common_utils__["m" /* default */].getPickListItemDescription(row.value); }
                },
                {
                    Header: 'Actions',
                    className: 'p-0 td-actions',
                    width: 120,
                    Cell: function (row) {
                        if (row.original.statusId !== __WEBPACK_IMPORTED_MODULE_5__common_utils__["f" /* PaymentStatus */].PaymentSucceeded &&
                            row.original.statusId !== __WEBPACK_IMPORTED_MODULE_5__common_utils__["f" /* PaymentStatus */].Created) {
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_buttons__["a" /* Button */], { className: "btn-primary btn-td", type: "button", to: props.baseUrl
                                    ? props.baseUrl + "/" + row.original.stripeInvoiceNumber
                                    : "/user/" + props.match.params.userId + "/billing/view-bills/" + row.original.stripeInvoiceNumber }, "Pay Bill"));
                        }
                        else {
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_buttons__["c" /* IconLinkButton */], { title: "View bill", className: "btn-icon-secondary btn-icon-td", to: props.baseUrl
                                    ? props.baseUrl + "/" + row.original.stripeInvoiceNumber
                                    : "/user/" + props.match.params.userId + "/billing/view-bills/" + row.original.stripeInvoiceNumber },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_icons__["m" /* IconArrowRight */], null)));
                        }
                    }
                }
            ], getTrProps: function (state, rowInfo, column) {
                return {
                    className: 'tr interactive',
                    onClick: function () {
                        if (props.baseUrl) {
                            return props.history.push(props.baseUrl + "/" + rowInfo.original.stripeInvoiceNumber);
                        }
                        else {
                            return props.history.push("/user/" + props.match.params.userId + "/billing/view-bills/" + rowInfo.original.stripeInvoiceNumber);
                        }
                    }
                };
            }, data: sortedPayments, noDataText: "You currently have no bills" })));
};
/* harmony default export */ __webpack_exports__["a"] = (PaymentHistoryList);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomerPolicyList__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CustomerApplicationList__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__policy_PolicyDetails__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









var CustomerPolicyPage = /** @class */ (function (_super) {
    __extends(CustomerPolicyPage, _super);
    function CustomerPolicyPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: true
        };
        _this.onRowClick = function (e, row) {
            e.stopPropagation();
            if (!window.location.href.includes('prospects')) {
                return _this.props.history.push("/admin/customers/" + _this.props.match.params.customerId + "/policies/" + row.id);
            }
            else {
                return _this.props.history.push("/admin/prospects/" + _this.props.match.params.customerId + "/policies/" + row.id);
            }
        };
        _this.onDownloadClick = function (e, row) {
            _this.props.actions.fetchCustomerPolicyDocumentUrl(_this.props.match.params.customerId, row.id)
                .then(function () {
                window.open(_this.props.policyDocumentUrl);
            });
        };
        _this.isAdjudicator = function (roles) {
            if (!roles) {
                return false;
            }
            else {
                return roles.indexOf("Adjudicator" /* Adjudicator */) > -1 && roles.length === 1;
            }
        };
        return _this;
    }
    CustomerPolicyPage.prototype.componentDidMount = function () {
        var _this = this;
        this.props.actions.fetchCustomerPolicies(this.props.match.params.customerId, true)
            .then(function () { return _this.setState({ loading: false }); });
    };
    CustomerPolicyPage.prototype.render = function () {
        if (this.props.match.params.pageId) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__policy_PolicyDetails__["a" /* default */], { match: this.props.match, history: this.props.history });
        }
        else {
            var policies = this.props.policies.filter(function (x) { return x.statusId !== __WEBPACK_IMPORTED_MODULE_8__common_utils__["h" /* PolicyStatus */].Inactive; });
            var applications = this.props.policies.filter(function (x) { return x.statusId === __WEBPACK_IMPORTED_MODULE_8__common_utils__["h" /* PolicyStatus */].Inactive; });
            var applicationsAdjudicatorCanView = applications.filter(function (x) { return x.isSoftDeclined; });
            return this.isAdjudicator(this.props.currentUser.role) ?
                (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, applicationsAdjudicatorCanView.length > 0 &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Applications"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__CustomerApplicationList__["a" /* default */], { className: this.props.className, applications: applicationsAdjudicatorCanView, onRowClick: this.onRowClick, loading: this.state.loading })))) :
                (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    policies.length > 0 &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: applications.length > 0 ? 'mb-4' : '' },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Policies"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__CustomerPolicyList__["a" /* default */], { className: this.props.className, policies: policies, onRowClick: this.onRowClick, onDownloadClick: this.onDownloadClick, loading: this.state.loading })),
                    applications.length > 0 &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Applications"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__CustomerApplicationList__["a" /* default */], { className: this.props.className, applications: applications, onRowClick: this.onRowClick, loading: this.state.loading }))));
        }
    };
    return CustomerPolicyPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        customer: state.user.user,
        currentUser: state.auth.currentUser,
        policies: state.policy.policies,
        customerPolicy: state.policy.customerPolicy,
        policyDocumentUrl: state.policy.tempPolicyDocumentUrl,
        questionnaireReport: state.policy.questionnaireReport,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CustomerPolicyPage);
var adminRoles = ["Admin" /* Administrator */, "Agent" /* Agent */, "Adjudicator" /* Adjudicator */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, adminRoles));


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);





var PolicyBeneficiariesList = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
            {
                accessor: 'id',
                show: false
            },
            {
                Header: 'First Name',
                accessor: 'firstName'
            },
            {
                Header: 'Last Name',
                accessor: 'lastName'
            },
            {
                Header: 'Policy #',
                accessor: 'policy.number'
            },
            {
                Header: 'Type',
                accessor: 'typeId',
                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].getPickListItemDescription(row.value); }
            },
            {
                Header: 'Disbursement',
                accessor: 'disbursementPercent',
                Cell: function (row) { return Math.trunc(row.value * 100).toString() + ' %'; }
            },
            {
                Header: 'Status',
                accessor: 'statusId',
                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].getPickListItemDescription(row.value); }
            },
            {
                Header: 'Actions',
                className: 'p-0 td-actions',
                width: 120,
                Cell: function (rowInfo) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["b" /* IconButton */], { onClick: function (e) {
                            e.stopPropagation(); // Prevent onClick conflict with tr onclick
                            props.onEdit(rowInfo.original);
                        }, title: "Edit beneficiary", className: "btn-icon-secondary btn-icon-td", disabled: props.readOnly },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["x" /* IconEdit */], null)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["b" /* IconButton */], { onClick: function (e) {
                            e.stopPropagation(); // Prevent onClick conflict with tr onclick
                            props.onDelete(rowInfo.original);
                        }, title: "Delete beneficiary", className: "btn-icon-secondary btn-icon-td", disabled: props.readOnly },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["v" /* IconDelete */], null)))); }
            }
        ], data: props.beneficiaries, getTrProps: function (state, rowInfo, column) {
            return { className: 'tr interactive', onClick: function () { return !props.readOnly && props.onEdit(rowInfo.original); } };
        }, noDataText: "No policy beneficiaries found", showPagination: false, loading: props.loading }));
};
/* harmony default export */ __webpack_exports__["a"] = (PolicyBeneficiariesList);


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PolicyBeneficiaryForm__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__policyAPI__ = __webpack_require__(35);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var PolicyBeneficiaryContainer = /** @class */ (function (_super) {
    __extends(PolicyBeneficiaryContainer, _super);
    function PolicyBeneficiaryContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false
        };
        _this.onPolicyBeneficiaryChange = function (e) {
            var value = e.target.value;
            if (e.target.type === 'radio') {
                if (e.target.name === 'typeId') {
                    if (value === 'true') {
                        value = __WEBPACK_IMPORTED_MODULE_6__common_utils__["d" /* BeneficiaryTypes */].Primary;
                    }
                    else if (value === 'false') {
                        value = __WEBPACK_IMPORTED_MODULE_6__common_utils__["d" /* BeneficiaryTypes */].Contingent;
                    }
                }
                else {
                    if (value === 'true') {
                        value = true;
                    }
                    else if (value === 'false') {
                        value = false;
                    }
                }
            }
            var customerPolicyBeneficiary = __assign({}, _this.props.customerPolicyBeneficiary, (_a = {}, _a[e.target.name] = value, _a));
            _this.props.actions.setCustomerPolicyBeneficiary(customerPolicyBeneficiary);
            var _a;
        };
        _this.onRelationshipChange = function (e) {
            var value = e.target.value;
            var customerPolicyBeneficiary = __assign({}, _this.props.customerPolicyBeneficiary, (_a = {}, _a[e.target.name] = value, _a));
            if (e.target.value !== 'Other') {
                customerPolicyBeneficiary.relationshipOther = '';
            }
            _this.props.actions.setCustomerPolicyBeneficiary(customerPolicyBeneficiary);
            var _a;
        };
        _this.save = function () {
            var beneficiary = __assign({}, _this.props.customerPolicyBeneficiary);
            // reset the disbursement percent if assigned policy is changed
            if (beneficiary.typeId === __WEBPACK_IMPORTED_MODULE_6__common_utils__["d" /* BeneficiaryTypes */].Primary) {
                var isPrimarySubsequent = _this.props.pendingBeneficiaries
                    .some(function (b) { return b.customerPolicyId === beneficiary.customerPolicyId &&
                    b.id !== beneficiary.id && b.typeId === __WEBPACK_IMPORTED_MODULE_6__common_utils__["d" /* BeneficiaryTypes */].Primary; });
                if (isPrimarySubsequent) {
                    beneficiary.disbursementPercent = beneficiary.disbursementPercent || 0;
                }
                else {
                    beneficiary.disbursementPercent = beneficiary.disbursementPercent || 1;
                }
            }
            else {
                var isContingentSubsequent = _this.props.pendingBeneficiaries
                    .some(function (b) { return b.customerPolicyId === beneficiary.customerPolicyId &&
                    b.id !== beneficiary.id && b.typeId === __WEBPACK_IMPORTED_MODULE_6__common_utils__["d" /* BeneficiaryTypes */].Contingent; });
                if (isContingentSubsequent) {
                    beneficiary.disbursementPercent = beneficiary.disbursementPercent || 0;
                }
                else {
                    beneficiary.disbursementPercent = beneficiary.disbursementPercent || 1;
                }
            }
            return _this.props.actions.saveCustomerPolicyBeneficiary(beneficiary);
        };
        _this.saveAndNext = function () {
            var userId = _this.props.match.params.userId || _this.props.match.params.customerId;
            _this.save()
                .then(function () {
                _this.props.actions.fetchCustomerPolicyBeneficiaries(userId)
                    .then(function () {
                    __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Beneficiary updated!');
                    var policy = _this.props.policies.find(function (p) { return p.id === _this.props.customerPolicyBeneficiary.customerPolicyId; });
                    _this.props.actions.setCustomerPolicy(policy);
                    var filteredBeneficiaries = _this.props.pendingBeneficiaries
                        .filter(function (b) { return b.customerPolicyId === policy.id; });
                    _this.props.actions.setCustomerPolicyBeneficiaries(filteredBeneficiaries);
                    if (_this.props.pendingBeneficiaries.some(function (b) { return b.isUnderage === true; })) {
                        var trustee = _this.props.pendingBeneficiaries.find(function (b) { return b.typeId === __WEBPACK_IMPORTED_MODULE_6__common_utils__["d" /* BeneficiaryTypes */].Trustee; });
                        if (trustee) {
                            _this.props.actions.setTrustee(trustee);
                        }
                        else {
                            var newTrustee = __WEBPACK_IMPORTED_MODULE_7__policyAPI__["g" /* defaultTrustee */];
                            _this.props.actions.setTrustee(newTrustee);
                        }
                    }
                    if (_this.props.baseUrl) {
                        _this.props.history.push(_this.props.baseUrl + '/beneficiaries-disbursement');
                    }
                    else {
                        _this.props.history.push("/user/" + userId + "/beneficiaries-disbursement");
                    }
                });
            });
        };
        _this.saveAndAdd = function () {
            var userId = _this.props.match.params.userId || _this.props.match.params.customerId;
            _this.save()
                .then(_this.props.actions.resetCustomerPolicyBeneficiary)
                .then(function () {
                if (_this.props.baseUrl) {
                    _this.props.history.push(_this.props.baseUrl + '/beneficiaries/new');
                }
                else {
                    _this.props.history.push("/user/" + userId + "/beneficiaries/new");
                }
            });
        };
        _this.cancel = function () {
            var userId = _this.props.match.params.userId || _this.props.match.params.customerId;
            if (_this.props.baseUrl) {
                _this.props.history.push(_this.props.baseUrl + '/beneficiaries');
            }
            else {
                _this.props.history.push("/user/" + userId + "/beneficiaries");
            }
        };
        return _this;
    }
    PolicyBeneficiaryContainer.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({ loading: true });
        var promises = [];
        var userId = this.props.match.params.userId || this.props.match.params.customerId;
        var beneficiaryId = this.props.match.params.beneficiaryId || this.props.match.params.pageId;
        promises.push(this.props.actions.fetchCustomerPolicies(userId));
        promises.push(this.props.actions.fetchCustomerPolicyBeneficiaries(userId));
        if (beneficiaryId === 'new') {
            promises.push(this.props.actions.resetCustomerPolicyBeneficiary());
        }
        else {
            promises.push(this.props.actions.fetchCustomerPolicyBeneficiary(userId, beneficiaryId));
        }
        Promise.all(promises)
            .then(function () {
            _this.setState({ loading: false });
        });
    };
    PolicyBeneficiaryContainer.prototype.render = function () {
        return !this.state.loading && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__PolicyBeneficiaryForm__["a" /* default */], { customerPolicyBeneficiary: this.props.customerPolicyBeneficiary, policies: this.props.policies, onPolicyBeneficiaryChange: this.onPolicyBeneficiaryChange, onRelationshipChange: this.onRelationshipChange, save: this.saveAndNext, saveAndAdd: this.saveAndAdd, match: this.props.match, cancel: this.cancel }));
    };
    return PolicyBeneficiaryContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state, props) {
    var beneficiary = state.policy.customerPolicyBeneficiary;
    var userId = props.match.params.userId || props.match.params.customerId;
    var beneficiaryId = props.match.params.beneficiaryId || props.match.params.pageId;
    if (beneficiaryId === 'new') {
        beneficiary = __assign({}, beneficiary, { customerId: userId });
    }
    var currentBeneficiaries = state.policy.beneficiaries.current
        .sort(__WEBPACK_IMPORTED_MODULE_6__common_utils__["j" /* UtilsBeneficiaries */].sortPrimaryThenByName);
    var pendingBeneficiaries = state.policy.beneficiaries.pending
        .sort(__WEBPACK_IMPORTED_MODULE_6__common_utils__["j" /* UtilsBeneficiaries */].sortPrimaryThenByName);
    return {
        customerPolicyBeneficiary: beneficiary,
        policies: state.policy.policies,
        currentBeneficiaries: currentBeneficiaries,
        pendingBeneficiaries: pendingBeneficiaries,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(PolicyBeneficiaryContainer));


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buttons__ = __webpack_require__(6);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var FileUpload = /** @class */ (function (_super) {
    __extends(FileUpload, _super);
    function FileUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            files: Array()
        };
        _this.onDrop = function () {
            _this.props.onDrop(_this.input.files[0]);
        };
        _this.onClick = function () {
            if (!_this.props.disabled) {
                _this.input.click();
            }
        };
        return _this;
    }
    FileUpload.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "file", accept: "application/pdf", id: "button-file", ref: function (input) { return _this.input = input; }, onChange: this.onDrop, className: "d-none" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__buttons__["a" /* Button */], { className: "btn-outline-secondary", onClick: this.onClick }, this.props.label)));
    };
    return FileUpload;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FileUpload);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomerNotesList__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CustomerNotesListOptions__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CustomerNoteDetails__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









var CustomerNotesPage = /** @class */ (function (_super) {
    __extends(CustomerNotesPage, _super);
    function CustomerNotesPage(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSearchDebounced = __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].debounce(function () { _this.search(_this.state.searchterm); }, 200);
        _this.addNotes = function () {
            if (!window.location.href.includes('prospects')) {
                return _this.props.history.push("/admin/customers/" + _this.props.match.params.customerId + "/notes/new");
            }
            else {
                return _this.props.history.push("/admin/prospects/" + _this.props.match.params.customerId + "/notes/new");
            }
        };
        _this.onSearch = function (e) {
            _this.setState({ searchterm: e.target.value }, function () {
                _this.handleSearchDebounced();
            });
        };
        _this.search = function (searchterm) {
            var value = searchterm.toLowerCase();
            var notes = _this.props.notes.filter(function (n) {
                var date = __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].formatDate(n.createdDate);
                var note = n.notes || '';
                return (note.toLowerCase().startsWith(value)
                    || date.toLowerCase().startsWith(value));
            });
            _this.setState({ notes: notes });
        };
        _this.renderNotesList = function () {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__CustomerNotesListOptions__["a" /* default */], { addNotes: _this.addNotes, searchterm: _this.state.searchterm, onSearch: _this.onSearch }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__CustomerNotesList__["a" /* default */], { notes: _this.state.notes, history: _this.props.history, match: _this.props.match, hasStripeId: _this.props.customer.stripeCustomerId ? true : false })));
        };
        _this.renderNoteForm = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__CustomerNoteDetails__["a" /* default */], __assign({}, _this.props));
        };
        _this.state = {
            notes: [],
            searchterm: ''
        };
        return _this;
    }
    CustomerNotesPage.prototype.componentDidMount = function () {
        var _this = this;
        this.props.actions.fetchCustomerNotes(this.props.match.params.customerId)
            .then(function () { return _this.setState({ notes: _this.props.notes }); });
    };
    CustomerNotesPage.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (this.props.match.params.pageId !== nextProps.match.params.pageId) {
            if (nextProps.match.params.pageId && nextProps.match.params.pageId !== 'new') {
                this.props.actions.fetchCustomerNote(nextProps.match.params.customerId, nextProps.match.params.pageId);
            }
            else {
                this.props.actions.fetchCustomerNotes(nextProps.match.params.customerId)
                    .then(function () { return _this.setState({ notes: _this.props.notes }); });
            }
        }
    };
    CustomerNotesPage.prototype.render = function () {
        if (this.props.match.params.pageId) {
            return this.renderNoteForm();
        }
        else {
            return this.renderNotesList();
        }
    };
    return CustomerNotesPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        notes: state.user.notes,
        note: state.user.note
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CustomerNotesPage);
var adminRoles = ["Admin" /* Administrator */, "Agent" /* Agent */, "Adjudicator" /* Adjudicator */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, adminRoles));


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_authActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









var AUTHROLE_PICKLISTTYPEID = '363eb8930518e811992f00155d74f005';
var ResetPasswordPage = /** @class */ (function (_super) {
    __extends(ResetPasswordPage, _super);
    function ResetPasswordPage(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = { email: {} };
        _this.send = function () {
            var resetUrl = _this.props.actions.getResetPasswordUrlForEmail();
            _this.props.actions.resetPassword(_this.props.user.id, resetUrl).then(function () {
                __WEBPACK_IMPORTED_MODULE_1_toastr__["info"]('Password reset email sent!');
            });
        };
        _this.isSendDisabled = function () {
            return _this.errors.email.hasError;
        };
        _this.validate = function () {
            // true means invalid
            return {
                email: __WEBPACK_IMPORTED_MODULE_3__common_utils__["k" /* Validation */].validateEmail(_this.state.email)
            };
        };
        _this.saveRole = function () {
            _this.props.actions.saveRole(_this.props.user.id, _this.props.user.role).then(function () {
                __WEBPACK_IMPORTED_MODULE_1_toastr__["info"]('Role updated!');
            });
        };
        _this.isChecked = function (name, roles) {
            if (!roles) {
                return false;
            }
            else {
                return roles.indexOf(name) > -1;
            }
        };
        _this.createCheckOptions = function () {
            var checkOptions = [
                {
                    name: "Admin" /* Administrator */,
                    label: 'Administrator',
                    checked: _this.isChecked("Admin" /* Administrator */, _this.props.user.role),
                    onChange: _this.onCheckedChange
                },
                {
                    name: "Agent" /* Agent */,
                    label: 'Agent',
                    checked: _this.isChecked("Agent" /* Agent */, _this.props.user.role),
                    onChange: _this.onCheckedChange
                },
                {
                    name: "Adjudicator" /* Adjudicator */,
                    label: 'Adjudicator',
                    checked: _this.isChecked("Adjudicator" /* Adjudicator */, _this.props.user.role),
                    onChange: _this.onCheckedChange
                },
                {
                    name: "Customer" /* Customer */,
                    label: 'Customer',
                    checked: _this.isChecked("Customer" /* Customer */, _this.props.user.role),
                    onChange: _this.onCheckedChange
                }
            ];
            return checkOptions;
        };
        _this.onCheckedChange = function (e) {
            // handle old user's without a role array prop
            var roles = [];
            if (_this.props.user.role && Array.isArray(_this.props.user.role)) {
                roles = _this.props.user.role.slice();
            }
            if (e.target.checked) {
                roles.push(e.target.name);
            }
            else {
                roles = roles.filter(function (x) { return x !== e.target.name; });
            }
            var user = __assign({}, _this.props.user, { role: roles });
            _this.props.actions.setUser(user);
        };
        _this.state = {
            email: '',
            touched: {
                email: false
            }
        };
        return _this;
    }
    ResetPasswordPage.prototype.componentDidMount = function () {
        this.setState({ email: this.props.user.email });
    };
    ResetPasswordPage.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: this.props.className },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Change Role"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["c" /* CheckboxGroup */], { title: "Role", 
                    // values={JSON.stringify(this.props.user.role) || ''}
                    name: "role", checkOptions: this.createCheckOptions() }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["a" /* Button */], { onClick: this.saveRole, className: "btn-primary" }, "Save role")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title mt-4" }, "Reset Password"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    "Click the button to send a password recovery email to ",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, this.state.email),
                    "."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["a" /* Button */], { onClick: this.send, disabled: this.isSendDisabled(), className: "btn-primary" }, "Send email"))));
    };
    return ResetPasswordPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state, ownProps) {
    return {
        user: state.user.user,
        roles: state.pickList.items.filter(function (p) { return p.pickListTypeId === AUTHROLE_PICKLISTTYPEID; }),
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_6__user_userActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__auth_authActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ResetPasswordPage));


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paymentActions__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CardDetails__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentDetailsForm__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_buttons__ = __webpack_require__(6);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




var classNames = __webpack_require__(8);




var UpdatePaymentDetails = /** @class */ (function (_super) {
    __extends(UpdatePaymentDetails, _super);
    function UpdatePaymentDetails(props) {
        var _this = _super.call(this, props) || this;
        _this.makePayment = function () {
            _this.setState({ isLoading: true });
            _this.props.stripe
                .createToken({ name: _this.props.details.ccCardholderName })
                .then(function (result) {
                if (result.error) {
                    __WEBPACK_IMPORTED_MODULE_3_toastr__["error"](result.error.message);
                }
                else {
                    // Send the token to server
                    return _this.props.actions.updateCustomerCard(_this.props.customer.stripeCustomerId, result.token).then(function () {
                        __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Card successfully updated!');
                    });
                }
            })
                .then(function () { return _this.setState({ isLoading: false }); });
        };
        _this.state = {
            isLoading: false
        };
        return _this;
    }
    UpdatePaymentDetails.prototype.componentDidMount = function () {
        this.props.actions.fetchCustomerCard(this.props.customer.id);
    };
    UpdatePaymentDetails.prototype.render = function () {
        var className = this.props.className;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('', className) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Current card"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset mb-4" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__CardDetails__["a" /* default */], { card: this.props.card })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "New card"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__PaymentDetailsForm__["a" /* default */], { details: this.props.details, actions: this.props.actions })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_buttons__["a" /* Button */], { className: "btn-primary mt-4", type: "button", onClick: this.makePayment, disabled: this.state.isLoading }, "Update card")));
    };
    return UpdatePaymentDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        details: state.payment.details,
        stripe: state.payment.stripe,
        customer: state.user.user,
        card: state.payment.card
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__paymentActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(UpdatePaymentDetails));


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonAPI__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_toastr__);



var commonActions = {
    contactUs: function (form) {
        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1__commonAPI__["a" /* default */].contactUs(form)
                .then(function (success) {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["a" /* default */].CONTACT_US_SUCCESS, success: success });
            })
                .catch(function (e) { return (__WEBPACK_IMPORTED_MODULE_2_toastr__["error"]('Failed to submit')); });
        };
    },
    fileAClaim: function (form) {
        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1__commonAPI__["a" /* default */].fileAClaim(form)
                .then(function (success) {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["a" /* default */].FILE_A_CLAIM_SUCCESS, success: success });
            })
                .catch(function (e) { return (__WEBPACK_IMPORTED_MODULE_2_toastr__["error"]('Failed to submit')); });
        };
    }
};
/* harmony default export */ __webpack_exports__["a"] = (commonActions);


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(175);
module.exports = __webpack_require__(180);


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(176).enable();
  window.Promise = __webpack_require__(178);
}

// fetch() polyfill for making API calls.
__webpack_require__(179);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(33);


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(100);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(100);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 179 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_stripe_elements__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_css__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_store__ = __webpack_require__(125);








__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"](__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_stripe_elements__["StripeProvider"], { apiKey: "pk_live_BvgJpYGyQaqyiqsf8yokDOUd" },
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"], { store: __WEBPACK_IMPORTED_MODULE_7__common_store__["a" /* default */] },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */], null))), document.getElementById('root'));
// service workers need more work before using in an app. (ie notification of a new version)
// registerServiceWorker();
Object(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* unregister */])();


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.1.1
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var m=__webpack_require__(33),n=__webpack_require__(66),p=__webpack_require__(39);
function q(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var r={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function t(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||r}t.prototype.isReactComponent={};t.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?q("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};t.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function u(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||r}function v(){}v.prototype=t.prototype;var w=u.prototype=new v;w.constructor=u;m(w,t.prototype);w.isPureReactComponent=!0;function x(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||r}var y=x.prototype=new v;y.constructor=x;m(y,t.prototype);y.unstable_isAsyncReactComponent=!0;y.render=function(){return this.props.children};
var z={current:null},A=Object.prototype.hasOwnProperty,B="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103,C={key:!0,ref:!0,__self:!0,__source:!0};
function D(a,b,e){var d,c={},h=null,k=null;if(null!=b)for(d in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(h=""+b.key),b)A.call(b,d)&&!C.hasOwnProperty(d)&&(c[d]=b[d]);var f=arguments.length-2;if(1===f)c.children=e;else if(1<f){for(var g=Array(f),l=0;l<f;l++)g[l]=arguments[l+2];c.children=g}if(a&&a.defaultProps)for(d in f=a.defaultProps,f)void 0===c[d]&&(c[d]=f[d]);return{$$typeof:B,type:a,key:h,ref:k,props:c,_owner:z.current}}function E(a){return"object"===typeof a&&null!==a&&a.$$typeof===B}
var F="function"===typeof Symbol&&Symbol.iterator,G="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103,H="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.portal")||60106;function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var I=/\/+/g,J=[];
function K(a,b,e,d){if(J.length){var c=J.pop();c.result=a;c.keyPrefix=b;c.func=e;c.context=d;c.count=0;return c}return{result:a,keyPrefix:b,func:e,context:d,count:0}}function L(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>J.length&&J.push(a)}
function M(a,b,e,d){var c=typeof a;if("undefined"===c||"boolean"===c)a=null;if(null===a||"string"===c||"number"===c||"object"===c&&a.$$typeof===G||"object"===c&&a.$$typeof===H)return e(d,a,""===b?"."+N(a,0):b),1;var h=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){c=a[k];var f=b+N(c,k);h+=M(c,f,e,d)}else if(f=F&&a[F]||a["@@iterator"],"function"===typeof f)for(a=f.call(a),k=0;!(c=a.next()).done;)c=c.value,f=b+N(c,k++),h+=M(c,f,e,d);else"object"===c&&(e=""+a,q("31","[object Object]"===
e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return h}function N(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function O(a,b){a.func.call(a.context,b,a.count++)}
function P(a,b,e){var d=a.result,c=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?Q(a,d,e,p.thatReturnsArgument):null!=a&&(E(a)&&(b=c+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(I,"$\x26/")+"/")+e,a={$$typeof:B,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),d.push(a))}function Q(a,b,e,d,c){var h="";null!=e&&(h=(""+e).replace(I,"$\x26/")+"/");b=K(b,h,d,c);null==a||M(a,"",P,b);L(b)}"function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.fragment");
var R={Children:{map:function(a,b,e){if(null==a)return a;var d=[];Q(a,d,null,b,e);return d},forEach:function(a,b,e){if(null==a)return a;b=K(null,null,b,e);null==a||M(a,"",O,b);L(b)},count:function(a){return null==a?0:M(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];Q(a,b,null,p.thatReturnsArgument);return b},only:function(a){E(a)?void 0:q("143");return a}},Component:t,PureComponent:u,unstable_AsyncComponent:x,createElement:D,cloneElement:function(a,b,e){var d=m({},a.props),c=a.key,h=a.ref,
k=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,k=z.current);void 0!==b.key&&(c=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(g in b)A.call(b,g)&&!C.hasOwnProperty(g)&&(d[g]=void 0===b[g]&&void 0!==f?f[g]:b[g])}var g=arguments.length-2;if(1===g)d.children=e;else if(1<g){f=Array(g);for(var l=0;l<g;l++)f[l]=arguments[l+2];d.children=f}return{$$typeof:B,type:a.type,key:c,ref:h,props:d,_owner:k}},createFactory:function(a){var b=D.bind(null,a);b.type=a;return b},isValidElement:E,
version:"16.1.1",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:z,assign:m}},S=Object.freeze({default:R}),T=S&&R||S;module.exports=T["default"]?T["default"]:T;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.1.1
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),m=__webpack_require__(183),A=__webpack_require__(33),B=__webpack_require__(39),ca=__webpack_require__(184),da=__webpack_require__(185),ea=__webpack_require__(186),ha=__webpack_require__(187),ia=__webpack_require__(190),C=__webpack_require__(66);
function D(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:D("227");
var la={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function qa(a,b){return(a&b)===b}
var ra={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ra,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){sa.hasOwnProperty(f)?D("48",f):void 0;var g=f.toLowerCase(),k=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:qa(k,b.MUST_USE_PROPERTY),
hasBooleanValue:qa(k,b.HAS_BOOLEAN_VALUE),hasNumericValue:qa(k,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:qa(k,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:qa(k,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:qa(k,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:D("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);sa[f]=g}}},sa={};
function ta(a,b){if(la.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return la.hasOwnProperty(a)?a=!0:(b=ua(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function ua(a){return sa.hasOwnProperty(a)?sa[a]:null}
var va=ra,wa=va.MUST_USE_PROPERTY,H=va.HAS_BOOLEAN_VALUE,xa=va.HAS_NUMERIC_VALUE,ya=va.HAS_POSITIVE_NUMERIC_VALUE,za=va.HAS_OVERLOADED_BOOLEAN_VALUE,Aa=va.HAS_STRING_BOOLEAN_VALUE,Ba={Properties:{allowFullScreen:H,async:H,autoFocus:H,autoPlay:H,capture:za,checked:wa|H,cols:ya,contentEditable:Aa,controls:H,"default":H,defer:H,disabled:H,download:za,draggable:Aa,formNoValidate:H,hidden:H,loop:H,multiple:wa|H,muted:wa|H,noValidate:H,open:H,playsInline:H,readOnly:H,required:H,reversed:H,rows:ya,rowSpan:xa,
scoped:H,seamless:H,selected:wa|H,size:ya,start:xa,span:ya,spellCheck:Aa,style:0,tabIndex:0,itemScope:H,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Aa},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ca=va.HAS_STRING_BOOLEAN_VALUE,K={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Da={Properties:{autoReverse:Ca,externalResourcesRequired:Ca,preserveAlpha:Ca},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:K.xlink,xlinkArcrole:K.xlink,xlinkHref:K.xlink,xlinkRole:K.xlink,xlinkShow:K.xlink,xlinkTitle:K.xlink,xlinkType:K.xlink,
xmlBase:K.xml,xmlLang:K.xml,xmlSpace:K.xml}},Ea=/[\-\:]([a-z])/g;function Ha(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ea,
Ha);Da.Properties[b]=0;Da.DOMAttributeNames[b]=a});va.injectDOMPropertyConfig(Ba);va.injectDOMPropertyConfig(Da);
var N={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?D("197"):void 0;Ia=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,k,h){Ia.apply(N,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,k,h){N.invokeGuardedCallback.apply(this,arguments);if(N.hasCaughtError()){var r=N.clearCaughtError();N._hasRethrowError||(N._hasRethrowError=!0,N._rethrowError=
r)}},rethrowCaughtError:function(){return Ja.apply(N,arguments)},hasCaughtError:function(){return N._hasCaughtError},clearCaughtError:function(){if(N._hasCaughtError){var a=N._caughtError;N._caughtError=null;N._hasCaughtError=!1;return a}D("198")}};function Ia(a,b,c,d,e,f,g,k,h){N._hasCaughtError=!1;N._caughtError=null;var r=Array.prototype.slice.call(arguments,3);try{b.apply(c,r)}catch(n){N._caughtError=n,N._hasCaughtError=!0}}
function Ja(){if(N._hasRethrowError){var a=N._rethrowError;N._rethrowError=null;N._hasRethrowError=!1;throw a;}}var Ka=null,La={};
function Ma(){if(Ka)for(var a in La){var b=La[a],c=Ka.indexOf(a);-1<c?void 0:D("96",a);if(!Na[c]){b.extractEvents?void 0:D("97",a);Na[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,k=d;Oa.hasOwnProperty(k)?D("99",k):void 0;Oa[k]=f;var h=f.phasedRegistrationNames;if(h){for(e in h)h.hasOwnProperty(e)&&Pa(h[e],g,k);e=!0}else f.registrationName?(Pa(f.registrationName,g,k),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
function Pa(a,b,c){Qa[a]?D("100",a):void 0;Qa[a]=b;Ra[a]=b.eventTypes[c].dependencies}var Na=[],Oa={},Qa={},Ra={};function Sa(a){Ka?D("101"):void 0;Ka=Array.prototype.slice.call(a);Ma()}function Ta(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];La.hasOwnProperty(c)&&La[c]===d||(La[c]?D("102",c):void 0,La[c]=d,b=!0)}b&&Ma()}
var Ua=Object.freeze({plugins:Na,eventNameDispatchConfigs:Oa,registrationNameModules:Qa,registrationNameDependencies:Ra,possibleRegistrationNames:null,injectEventPluginOrder:Sa,injectEventPluginsByName:Ta}),Va=null,Wa=null,Xa=null;function Ya(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Xa(d);N.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Za(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function $a(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var ab=null;
function bb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Ya(a,b,c[e],d[e]);else c&&Ya(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function cb(a){return bb(a,!0)}function db(a){return bb(a,!1)}var ib={injectEventPluginOrder:Sa,injectEventPluginsByName:Ta};
function jb(a,b){var c=a.stateNode;if(!c)return null;var d=Va(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
return c}function kb(a,b,c,d){for(var e,f=0;f<Na.length;f++){var g=Na[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Za(e,g))}return e}function lb(a){a&&(ab=Za(ab,a))}function mb(a){var b=ab;ab=null;a?$a(b,cb):$a(b,db);ab?D("95"):void 0;N.rethrowCaughtError()}var nb=Object.freeze({injection:ib,getListener:jb,extractEvents:kb,enqueueEvents:lb,processEventQueue:mb}),ob=Math.random().toString(36).slice(2),O="__reactInternalInstance$"+ob,pb="__reactEventHandlers$"+ob;
function qb(a){if(a[O])return a[O];for(var b=[];!a[O];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[O];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[O]);a=b.pop())c=d;return c}function rb(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function sb(a){return a[pb]||null}
var tb=Object.freeze({precacheFiberNode:function(a,b){b[O]=a},getClosestInstanceFromNode:qb,getInstanceFromNode:function(a){a=a[O];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:rb,getFiberCurrentPropsFromNode:sb,updateFiberProps:function(a,b){a[pb]=b}});function Q(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=Q(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=jb(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Za(c._dispatchListeners,b),c._dispatchInstances=Za(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?Q(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=jb(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Za(c._dispatchListeners,b),c._dispatchInstances=Za(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){$a(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,k=e;k;k=Q(k))g++;k=0;for(var h=f;h;h=Q(h))k++;for(;0<g-k;)e=Q(e),g--;for(;0<k-g;)f=Q(f),k--;for(;g--;){if(e===f||e===f.alternate)break a;e=Q(e);f=Q(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=Q(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=Q(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){$a(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){$a(a,zb)}}),Db=null;function Eb(){!Db&&m.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var R={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(R._fallbackText)return R._fallbackText;var a,b=R._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);R._fallbackText=e.slice(a,1<d?1-d:void 0);return R._fallbackText}function Gb(){return"value"in R._root?R._root.value:R._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:B.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function S(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?B.thatReturnsTrue:B.thatReturnsFalse;this.isPropagationStopped=B.thatReturnsFalse;return this}
A(S.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=B.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=B.thatReturnsTrue)},persist:function(){this.isPersistent=B.thatReturnsTrue},isPersistent:B.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});S.Interface=Ib;S.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;A(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=A({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(S);function Qb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Rb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Qb;a.release=Rb}function Sb(a,b,c,d){return S.call(this,a,b,c,d)}S.augmentClass(Sb,{data:null});function Tb(a,b,c,d){return S.call(this,a,b,c,d)}S.augmentClass(Tb,{data:null});var Ub=[9,13,27,32],Vb=m.canUseDOM&&"CompositionEvent"in window,Wb=null;m.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=m.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=m.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Ub.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),R._root=null,R._startText=null,R._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(R._root=d,R._startText=Gb(),fc=!0)),f=Sb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Tb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Wa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:D("194");var b=Va(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;m.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=S.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){lb(a);mb(!1)}function Ic(a){var b=rb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Qc=!1;m.canUseDOM&&(Qc=yc("input")&&(!document.documentMode||9<document.documentMode));function Rc(){Fc&&(Fc.detachEvent("onpropertychange",Sc),Gc=Fc=null)}function Sc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Tc(a,b,c){"topFocus"===a?(Rc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Sc)):"topBlur"===a&&Rc()}function Uc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Vc(a,b){if("topClick"===a)return Ic(b)}function Wc(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var Xc={eventTypes:Dc,_isInputEventSupported:Qc,extractEvents:function(a,b,c,d){var e=b?rb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Qc)g=Wc;else{g=Uc;var k=Tc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Vc);if(g&&(g=g(a,b)))return Ec(g,c,d);k&&k(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function Yc(a,b,c,d){return S.call(this,a,b,c,d)}S.augmentClass(Yc,{view:null,detail:null});var Zc={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function $c(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Zc[a])?!!b[a]:!1}function ad(){return $c}function bd(a,b,c,d){return S.call(this,a,b,c,d)}
Yc.augmentClass(bd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ad,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var cd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},dd={eventTypes:cd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?qb(b):null):a=null;if(a===
b)return null;var f=null==a?e:rb(a);e=null==b?e:rb(b);var g=bd.getPooled(cd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=bd.getPooled(cd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},ed=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function fd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function gd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function hd(a){return(a=a._reactInternalFiber)?2===gd(a):!1}function id(a){2!==gd(a)?D("188"):void 0}
function jd(a){var b=a.alternate;if(!b)return b=gd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return id(e),a;if(g===d)return id(e),b;g=g.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var k=e.child;k;){if(k===c){g=!0;c=e;d=f;break}if(k===d){g=!0;d=e;c=f;break}k=k.sibling}if(!g){for(k=f.child;k;){if(k===c){g=!0;c=f;d=e;break}if(k===d){g=!0;d=f;c=e;break}k=k.sibling}g?
void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function kd(a){a=jd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function ld(a){a=jd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var md=[];
function nd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=qb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],od(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var pd=!0,od=void 0;function qd(a){pd=!!a}function U(a,b,c){return c?ca.listen(c,b,rd.bind(null,a)):null}function sd(a,b,c){return c?ca.capture(c,b,rd.bind(null,a)):null}
function rd(a,b){if(pd){var c=wc(b);c=qb(c);null===c||"number"!==typeof c.tag||2===gd(c)||(c=null);if(md.length){var d=md.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(nd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>md.length&&md.push(a)}}}
var td=Object.freeze({get _enabled(){return pd},get _handleTopLevel(){return od},setHandleTopLevel:function(a){od=a},setEnabled:qd,isEnabled:function(){return pd},trapBubbledEvent:U,trapCapturedEvent:sd,dispatchEvent:rd});function ud(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var vd={animationend:ud("Animation","AnimationEnd"),animationiteration:ud("Animation","AnimationIteration"),animationstart:ud("Animation","AnimationStart"),transitionend:ud("Transition","TransitionEnd")},wd={},xd={};m.canUseDOM&&(xd=document.createElement("div").style,"AnimationEvent"in window||(delete vd.animationend.animation,delete vd.animationiteration.animation,delete vd.animationstart.animation),"TransitionEvent"in window||delete vd.transitionend.transition);
function yd(a){if(wd[a])return wd[a];if(!vd[a])return a;var b=vd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in xd)return wd[a]=b[c];return""}
var zd={topAbort:"abort",topAnimationEnd:yd("animationend")||"animationend",topAnimationIteration:yd("animationiteration")||"animationiteration",topAnimationStart:yd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:yd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ad={},Bd=0,Cd="_reactListenersID"+(""+Math.random()).slice(2);function Dd(a){Object.prototype.hasOwnProperty.call(a,Cd)||(a[Cd]=Bd++,Ad[a[Cd]]={});return Ad[a[Cd]]}function Ed(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Fd(a,b){var c=Ed(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Ed(c)}}function Gd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Hd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Id={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Jd=null,Kd=null,Ld=null,Md=!1;
function Nd(a,b){if(Md||null==Jd||Jd!==da())return null;var c=Jd;"selectionStart"in c&&Gd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Ld&&ea(Ld,c)?null:(Ld=c,a=S.getPooled(Id.select,Kd,a,b),a.type="select",a.target=Jd,Ab(a),a)}
var Od={eventTypes:Id,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Dd(e);f=Ra.onSelect;for(var g=0;g<f.length;g++){var k=f[g];if(!e.hasOwnProperty(k)||!e[k]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?rb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Jd=e,Kd=b,Ld=null;break;case "topBlur":Ld=Kd=Jd=null;break;case "topMouseDown":Md=!0;break;case "topContextMenu":case "topMouseUp":return Md=!1,Nd(c,d);case "topSelectionChange":if(Hd)break;
case "topKeyDown":case "topKeyUp":return Nd(c,d)}return null}};function Pd(a,b,c,d){return S.call(this,a,b,c,d)}S.augmentClass(Pd,{animationName:null,elapsedTime:null,pseudoElement:null});function Qd(a,b,c,d){return S.call(this,a,b,c,d)}S.augmentClass(Qd,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Rd(a,b,c,d){return S.call(this,a,b,c,d)}Yc.augmentClass(Rd,{relatedTarget:null});
function Sd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Td={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Ud={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Vd(a,b,c,d){return S.call(this,a,b,c,d)}
Yc.augmentClass(Vd,{key:function(a){if(a.key){var b=Td[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Sd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Ud[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ad,charCode:function(a){return"keypress"===a.type?Sd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Sd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function Wd(a,b,c,d){return S.call(this,a,b,c,d)}bd.augmentClass(Wd,{dataTransfer:null});function Xd(a,b,c,d){return S.call(this,a,b,c,d)}Yc.augmentClass(Xd,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ad});function Yd(a,b,c,d){return S.call(this,a,b,c,d)}S.augmentClass(Yd,{propertyName:null,elapsedTime:null,pseudoElement:null});
function Zd(a,b,c,d){return S.call(this,a,b,c,d)}bd.augmentClass(Zd,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var $d={},ae={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};$d[a]=c;ae[b]=c});
var be={eventTypes:$d,extractEvents:function(a,b,c,d){var e=ae[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Sd(c))return null;case "topKeyDown":case "topKeyUp":a=Vd;break;case "topBlur":case "topFocus":a=Rd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=bd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
Wd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Xd;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Pd;break;case "topTransitionEnd":a=Yd;break;case "topScroll":a=Yc;break;case "topWheel":a=Zd;break;case "topCopy":case "topCut":case "topPaste":a=Qd;break;default:a=S}b=a.getPooled(e,b,c,d);Ab(b);return b}};od=function(a,b,c,d){a=kb(a,b,c,d);lb(a);mb(!1)};ib.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Va=tb.getFiberCurrentPropsFromNode;Wa=tb.getInstanceFromNode;Xa=tb.getNodeFromInstance;ib.injectEventPluginsByName({SimpleEventPlugin:be,EnterLeaveEventPlugin:dd,ChangeEventPlugin:Xc,SelectEventPlugin:Od,BeforeInputEventPlugin:ic});var ce=[],de=-1;function V(a){0>de||(a.current=ce[de],ce[de]=null,de--)}function W(a,b){de++;ce[de]=a.current;a.current=b}new Set;var ee={current:C},X={current:!1},fe=C;function ge(a){return he(a)?fe:ee.current}
function ie(a,b){var c=a.type.contextTypes;if(!c)return C;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function he(a){return 2===a.tag&&null!=a.type.childContextTypes}function je(a){he(a)&&(V(X,a),V(ee,a))}
function ke(a,b,c){null!=ee.cursor?D("168"):void 0;W(ee,b,a);W(X,c,a)}function le(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",fd(a)||"Unknown",e);return A({},b,c)}function me(a){if(!he(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||C;fe=ee.current;W(ee,b,a);W(X,X.current,a);return!0}
function ne(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var d=le(a,fe);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ee,a);W(ee,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function oe(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function pe(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):D("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function qe(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function re(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function se(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function te(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ue(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ve=null,we=null;
function xe(a){return function(b){try{return a(b)}catch(c){}}}function ye(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ve=xe(function(a){return b.onCommitFiberRoot(c,a)});we=xe(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function ze(a){"function"===typeof ve&&ve(a)}function Ae(a){"function"===typeof we&&we(a)}
function Be(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ce(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function De(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Be(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Be(null))):a=null;a=a!==d?a:null;null===a?Ce(d,b):null===d.last||null===a.last?(Ce(d,b),Ce(a,b)):(Ce(d,b),a.last=b)}function Ee(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Le(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,k=c.first,h=!1;null!==k;){var r=k.expirationTime;if(r>f){var n=c.expirationTime;if(0===n||n>r)c.expirationTime=r;h||(h=!0,c.baseState=a)}else{h||(c.first=k.next,null===
c.first&&(c.last=null));if(k.isReplace)a=Ee(k,d,a,e),g=!0;else if(r=Ee(k,d,a,e))a=g?A({},a,r):A(a,r),g=!1;k.isForced&&(c.hasForceUpdate=!0);null!==k.callback&&(r=c.callbackList,null===r&&(r=c.callbackList=[]),r.push(k))}k=k.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);h||(c.baseState=a);return a}
function Me(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
function Ne(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:hd,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);De(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var f=b(c);De(c,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,f)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);De(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ge(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?ie(a,d):C;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:D("158");var k=ge(a);d.props=g;d.state=a.memoizedState=e;d.refs=C;d.context=ie(a,k);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Le(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var k=b.memoizedProps,h=b.pendingProps;h||(h=k,null==h?D("159"):void 0);var u=g.context,x=ge(b);x=ie(b,x);"function"!==typeof g.componentWillReceiveProps||k===h&&u===x||(u=g.state,g.componentWillReceiveProps(h,x),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Le(a,b,b.updateQueue,g,h,e):u;if(!(k!==h||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||k===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var F=h;if(null===k||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)F=!0;else{var L=b.stateNode,G=b.type;F="function"===typeof L.shouldComponentUpdate?L.shouldComponentUpdate(F,e,x):G.prototype&&G.prototype.isPureReactComponent?!ea(k,F)||!ea(u,e):!0}F?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(h,e,x),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
k===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,h),d(b,e));g.props=h;g.state=e;g.context=x;return F}}}var Oe="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.portal")||60106;function Pe(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Oe,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var Qe=Array.isArray,Re="function"===typeof Symbol&&Symbol.iterator,Se,Te,Ue,Ve;
"function"===typeof Symbol&&Symbol["for"]?(Se=Symbol["for"]("react.element"),Te=Symbol["for"]("react.call"),Ue=Symbol["for"]("react.return"),Ve=Symbol["for"]("react.fragment")):(Se=60103,Te=60104,Ue=60105,Ve=60107);function We(a){if(null===a||"undefined"===typeof a)return null;a=Re&&a[Re]||a["@@iterator"];return"function"===typeof a?a:null}
function Xe(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?D("110"):void 0,d=b.stateNode);d?void 0:D("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===C?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?D("148"):void 0;b._owner?void 0:D("149",c)}return c}
function Ye(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Ze(a,b){function c(c,d){if(b){if(!a){if(null===d.alternate)return;d=d.alternate}var p=c.lastEffect;null!==p?(p.nextEffect=d,c.lastEffect=d):c.firstEffect=c.lastEffect=d;d.nextEffect=null;d.effectTag=8}}function d(a,d){if(!b)return null;for(;null!==d;)c(a,d),d=d.sibling;return null}function e(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function f(b,c,d){if(a)return b=oe(b,c,d),b.index=0,b.sibling=null,b;b.expirationTime=d;b.effectTag=0;b.index=
0;b.sibling=null;b.pendingProps=c;return b}function g(a,c,d){a.index=d;if(!b)return c;d=a.alternate;if(null!==d)return d=d.index,d<c?(a.effectTag=2,c):d;a.effectTag=2;return c}function k(a){b&&null===a.alternate&&(a.effectTag=2);return a}function h(a,b,c,d){if(null===b||6!==b.tag)return b=re(c,a.internalContextTag,d),b["return"]=a,b;b=f(b,c,d);b["return"]=a;return b}function r(a,b,c,d){if(null!==b&&b.type===c.type)return d=f(b,c.props,d),d.ref=Xe(b,c),d["return"]=a,d;d=pe(c,a.internalContextTag,d);
d.ref=Xe(b,c);d["return"]=a;return d}function n(a,b,c,d){if(null===b||7!==b.tag)return b=se(c,a.internalContextTag,d),b["return"]=a,b;b=f(b,c,d);b["return"]=a;return b}function y(a,b,c,d){if(null===b||9!==b.tag)return b=te(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=f(b,null,d);b.type=c.value;b["return"]=a;return b}function u(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ue(c,a.internalContextTag,
d),b["return"]=a,b;b=f(b,c.children||[],d);b["return"]=a;return b}function x(a,b,c,d,e){if(null===b||10!==b.tag)return b=qe(c,a.internalContextTag,d,e),b["return"]=a,b;b=f(b,c,d);b["return"]=a;return b}function F(a,b,c){if("string"===typeof b||"number"===typeof b)return b=re(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Se:if(b.type===Ve)return b=qe(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=pe(b,a.internalContextTag,c);
c.ref=Xe(null,b);c["return"]=a;return c;case Te:return b=se(b,a.internalContextTag,c),b["return"]=a,b;case Ue:return c=te(b,a.internalContextTag,c),c.type=b.value,c["return"]=a,c;case Oe:return b=ue(b,a.internalContextTag,c),b["return"]=a,b}if(Qe(b)||We(b))return b=qe(b,a.internalContextTag,c,null),b["return"]=a,b;Ye(a,b)}return null}function L(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Se:return c.key===
e?c.type===Ve?x(a,b,c.props.children,d,e):r(a,b,c,d):null;case Te:return c.key===e?n(a,b,c,d):null;case Ue:return null===e?y(a,b,c,d):null;case Oe:return c.key===e?u(a,b,c,d):null}if(Qe(c)||We(c))return null!==e?null:x(a,b,c,d,null);Ye(a,c)}return null}function G(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Se:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?x(b,a,d.props.children,e,d.key):
r(b,a,d,e);case Te:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e);case Ue:return a=a.get(c)||null,y(b,a,d,e);case Oe:return a=a.get(null===d.key?c:d.key)||null,u(b,a,d,e)}if(Qe(d)||We(d))return a=a.get(c)||null,x(b,a,d,e,null);Ye(b,d)}return null}function T(a,f,v,k){for(var p=null,z=null,l=f,h=f=0,t=null;null!==l&&h<v.length;h++){l.index>h?(t=l,l=null):t=l.sibling;var w=L(a,l,v[h],k);if(null===w){null===l&&(l=t);break}b&&l&&null===w.alternate&&c(a,l);f=g(w,f,h);null===z?p=w:z.sibling=w;z=w;
l=t}if(h===v.length)return d(a,l),p;if(null===l){for(;h<v.length;h++)if(l=F(a,v[h],k))f=g(l,f,h),null===z?p=l:z.sibling=l,z=l;return p}for(l=e(a,l);h<v.length;h++)if(t=G(l,a,h,v[h],k)){if(b&&null!==t.alternate)l["delete"](null===t.key?h:t.key);f=g(t,f,h);null===z?p=t:z.sibling=t;z=t}b&&l.forEach(function(b){return c(a,b)});return p}function I(a,f,v,k){var p=We(v);"function"!==typeof p?D("150"):void 0;v=p.call(v);null==v?D("151"):void 0;for(var h=p=null,l=f,z=f=0,t=null,w=v.next();null!==l&&!w.done;z++,
w=v.next()){l.index>z?(t=l,l=null):t=l.sibling;var n=L(a,l,w.value,k);if(null===n){l||(l=t);break}b&&l&&null===n.alternate&&c(a,l);f=g(n,f,z);null===h?p=n:h.sibling=n;h=n;l=t}if(w.done)return d(a,l),p;if(null===l){for(;!w.done;z++,w=v.next())w=F(a,w.value,k),null!==w&&(f=g(w,f,z),null===h?p=w:h.sibling=w,h=w);return p}for(l=e(a,l);!w.done;z++,w=v.next())if(w=G(l,a,z,w.value,k),null!==w){if(b&&null!==w.alternate)l["delete"](null===w.key?z:w.key);f=g(w,f,z);null===h?p=w:h.sibling=w;h=w}b&&l.forEach(function(b){return c(a,
b)});return p}return function(a,b,e,g){var h="object"===typeof e&&null!==e;if(h)switch(e.$$typeof){case Se:a:{var v=e.key;for(h=b;null!==h;){if(h.key===v)if(10===h.tag?e.type===Ve:h.type===e.type){d(a,h.sibling);b=f(h,e.type===Ve?e.props.children:e.props,g);b.ref=Xe(h,e);b["return"]=a;a=b;break a}else{d(a,h);break}else c(a,h);h=h.sibling}e.type===Ve?(e=qe(e.props.children,a.internalContextTag,g,e.key),e["return"]=a,a=e):(g=pe(e,a.internalContextTag,g),g.ref=Xe(b,e),g["return"]=a,a=g)}return k(a);
case Te:a:{for(h=e.key;null!==b;){if(b.key===h)if(7===b.tag){d(a,b.sibling);e=f(b,e,g);e["return"]=a;a=e;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=se(e,a.internalContextTag,g);e["return"]=a;a=e}return k(a);case Ue:a:{if(null!==b)if(9===b.tag){d(a,b.sibling);b=f(b,null,g);b.type=e.value;b["return"]=a;a=b;break a}else d(a,b);b=te(e,a.internalContextTag,g);b.type=e.value;b["return"]=a;a=b}return k(a);case Oe:a:{for(h=e.key;null!==b;){if(b.key===h)if(4===b.tag&&b.stateNode.containerInfo===e.containerInfo&&
b.stateNode.implementation===e.implementation){d(a,b.sibling);e=f(b,e.children||[],g);e["return"]=a;a=e;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=ue(e,a.internalContextTag,g);e["return"]=a;a=e}return k(a)}if("string"===typeof e||"number"===typeof e)return e=""+e,null!==b&&6===b.tag?(d(a,b.sibling),e=f(b,e,g)):(d(a,b),e=re(e,a.internalContextTag,g)),e["return"]=a,a=e,k(a);if(Qe(e))return T(a,b,e,g);if(We(e))return I(a,b,e,g);h&&Ye(a,e);if("undefined"===typeof e)switch(a.tag){case 2:case 1:e=
a.type,D("152",e.displayName||e.name||"Component")}return d(a,b)}}var $e=Ze(!0,!0),af=Ze(!1,!0),bf=Ze(!1,!1);
function cf(a,b,c,d,e){function f(a,b,c){g(a,b,c,b.expirationTime)}function g(a,b,c,d){b.child=null===a?bf(b,b.child,c,d):a.child===b.child?$e(b,b.child,c,d):af(b,b.child,c,d)}function k(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){k(a,b);if(!c)return d&&ne(b,!1),n(a,b);c=b.stateNode;ed.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&ne(b,!0);return b.child}function r(a){var b=a.stateNode;b.pendingContext?ke(a,
b.pendingContext,b.pendingContext!==b.context):b.context&&ke(a,b.context,!1);G(a,b.containerInfo)}function n(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=oe(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=oe(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function y(a,b){switch(b.tag){case 3:r(b);break;case 2:me(b);break;case 4:G(b,b.stateNode.containerInfo)}return null}var u=
a.shouldSetTextContent,x=a.useSyncScheduling,F=a.shouldDeprioritizeSubtree,L=b.pushHostContext,G=b.pushHostContainer,T=c.enterHydrationState,I=c.resetHydrationState,z=c.tryToClaimNextHydratableInstance;a=Ne(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var p=a.adoptClassInstance,v=a.constructClassInstance,t=a.mountClassInstance,Kb=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return y(a,b);switch(b.tag){case 0:null!==a?
D("155"):void 0;var d=b.type,e=b.pendingProps,g=ge(b);g=ie(b,g);d=d(e,g);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=me(b),p(b,d),t(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=n(a,b);break a}d=ge(b);d=ie(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=me(b),d=void 0,null===
a?b.stateNode?D("153"):(v(b,b.pendingProps),t(b,c),d=!0):d=Kb(a,b,c),h(a,b,d,e);case 3:return r(b),e=b.updateQueue,null!==e?(d=b.memoizedState,e=Le(a,b,e,null,null,c),d===e?(I(),b=n(a,b)):(d=e.element,g=b.stateNode,(null===a||null===a.child)&&g.hydrate&&T(b)?(b.effectTag|=2,b.child=bf(b,b.child,d,c)):(I(),f(a,b,d)),b.memoizedState=e,b=b.child)):(I(),b=n(a,b)),b;case 5:L(b);null===a&&z(b);e=b.type;var l=b.memoizedProps;d=b.pendingProps;null===d&&(d=l,null===d?D("154"):void 0);g=null!==a?a.memoizedProps:
null;X.current||null!==d&&l!==d?(l=d.children,u(e,d)?l=null:g&&u(e,g)&&(b.effectTag|=16),k(a,b),2147483647!==c&&!x&&F(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,l),b.memoizedProps=d,b=b.child)):b=n(a,b);return b;case 6:return null===a&&z(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?D("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=
null===a?bf(b,b.stateNode,d,c):a.child===b.child?$e(b,b.stateNode,d,c):af(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;case 9:return null;case 4:a:{G(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?D("154"):void 0);else if(null===e||b.memoizedProps===e){b=n(a,b);break a}null===a?b.child=af(b,b.child,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||
b.memoizedProps===c){b=n(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:D("156")}},beginFailedWork:function(a,b,c){switch(b.tag){case 2:me(b);break;case 3:r(b);break;default:D("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return y(a,b);b.firstEffect=null;b.lastEffect=null;g(a,b,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function df(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,k=a.finalizeInitialChildren,h=a.prepareUpdate,r=a.persistence,n=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,x=b.popHostContainer,F=c.prepareToHydrateHostInstance,L=c.prepareToHydrateHostTextInstance,G=c.popHydrationState,T=void 0,I=void 0,z=void 0;a.mutation?(T=function(){},I=function(a,b,c){(b.updateQueue=c)&&d(b)},z=function(a,b,c,e){c!==e&&d(b)}):r?D("235"):D("236");
return{completeWork:function(a,b,c){var p=b.pendingProps;if(null===p)p=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return je(b),null;case 3:x(b);V(X,b);V(ee,b);p=b.stateNode;p.pendingContext&&(p.context=p.pendingContext,p.pendingContext=null);if(null===a||null===a.child)G(b),b.effectTag&=-3;T(b);return null;case 5:y(b);c=n();var v=b.type;if(null!==a&&null!=b.stateNode){var l=a.memoizedProps,t=b.stateNode,r=u();t=
h(t,v,l,p,c,r);I(a,b,t,v,l,p,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!p)return null===b.stateNode?D("166"):void 0,null;a=u();if(G(b))F(b,c,a)&&d(b);else{a=e(v,p,c,a,b);a:for(l=b.child;null!==l;){if(5===l.tag||6===l.tag)g(a,l.stateNode);else if(4!==l.tag&&null!==l.child){l.child["return"]=l;l=l.child;continue}if(l===b)break;for(;null===l.sibling;){if(null===l["return"]||l["return"]===b)break a;l=l["return"]}l.sibling["return"]=l["return"];l=l.sibling}k(a,v,p,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)z(a,b,a.memoizedProps,p);else{if("string"!==typeof p)return null===b.stateNode?D("166"):void 0,null;a=n();c=u();G(b)?L(b)&&d(b):b.stateNode=f(p,a,c,b)}return null;case 7:(p=b.memoizedProps)?void 0:D("165");b.tag=8;v=[];a:for((l=b.stateNode)&&(l["return"]=b);null!==l;){if(5===l.tag||6===l.tag||4===l.tag)D("247");else if(9===l.tag)v.push(l.type);else if(null!==l.child){l.child["return"]=l;l=l.child;continue}for(;null===l.sibling;){if(null===
l["return"]||l["return"]===b)break a;l=l["return"]}l.sibling["return"]=l["return"];l=l.sibling}l=p.handler;p=l(p.props,v);b.child=$e(b,null!==a?a.child:null,p,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return x(b),T(b),null;case 0:D("167");default:D("156")}}}}
function ef(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(v){b(a,v)}}function d(a){"function"===typeof Ae&&Ae(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(v){b(a,v)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:h&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||h&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?I(f,b.stateNode):T(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var k=a.getPublicInstance,h=a.mutation;a=a.persistence;h||(a?D("235"):D("236"));var r=h.commitMount,n=h.commitUpdate,y=h.resetTextContent,u=h.commitTextUpdate,x=h.appendChild,F=h.appendChildToContainer,L=h.insertBefore,G=h.insertInContainerBefore,
T=h.removeChild,I=h.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):L(b,e.stateNode,c):d?F(b,e.stateNode):x(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&n(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Me(b,c);break;case 3:c=b.updateQueue;null!==c&&Me(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&r(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:D("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(k(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var ff={};
function gf(a){function b(a){a===ff?D("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:ff},f={current:ff},g={current:ff};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),k=b(e.current);
d=c(k,a.type,d);k!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=ff;g.current=ff}}}
function hf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,k=a.getNextHydratableSibling,h=a.getFirstHydratableChild,r=a.hydrateInstance,n=a.hydrateTextInstance,y=null,u=null,x=!1;return{enterHydrationState:function(a){u=
h(a.stateNode.containerInfo);y=a;return x=!0},resetHydrationState:function(){u=y=null;x=!1},tryToClaimNextHydratableInstance:function(a){if(x){var d=u;if(d){if(!c(a,d)){d=k(d);if(!d||!c(a,d)){a.effectTag|=2;x=!1;y=a;return}b(y,u)}y=a;u=h(d)}else a.effectTag|=2,x=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=r(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return n(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!x)return d(a),x=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=k(c);d(a);u=y?k(a.stateNode):null;return!0}}}
function jf(a){function b(a){Lb=ma=!0;var b=a.stateNode;b.current===a?D("177"):void 0;b.isReadyForCommit=!1;ed.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;vg();for(q=c;null!==q;){var d=!1,e=void 0;try{for(;null!==q;){var f=q.effectTag;f&16&&wg(q);if(f&128){var g=q.alternate;null!==g&&xg(g)}switch(f&-242){case 2:He(q);q.effectTag&=-3;break;case 6:He(q);q.effectTag&=-3;Ie(q.alternate,q);break;case 4:Ie(q.alternate,
q);break;case 8:Lc=!0,yg(q),Lc=!1}q=q.nextEffect}}catch(Mc){d=!0,e=Mc}d&&(null===q?D("178"):void 0,k(q,e),null!==q&&(q=q.nextEffect))}zg();b.current=a;for(q=c;null!==q;){c=!1;d=void 0;try{for(;null!==q;){var h=q.effectTag;h&36&&Ag(q.alternate,q);h&128&&Bg(q);if(h&64)switch(e=q,f=void 0,null!==P&&(f=P.get(e),P["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=P.get(e),P["delete"](e))),null==f?D("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ba&&(ba=f.error);break;default:D("157")}var Fa=q.nextEffect;q.nextEffect=null;q=Fa}}catch(Mc){c=!0,d=Mc}c&&(null===q?D("178"):void 0,k(q,d),null!==q&&(q=q.nextEffect))}ma=Lb=!1;"function"===typeof ze&&ze(a.stateNode);fa&&(fa.forEach(F),fa=null);null!==ba&&(a=ba,ba=null,v(a));b=b.current.expirationTime;0===b&&(na=P=null);return b}function c(a){for(;;){var b=og(a.alternate,a,J),c=a["return"],d=a.sibling;var e=a;if(2147483647===J||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=w(a.alternate,a,J);null===b&&(b=c(a));ed.current=null;return b}function e(a){var b=ng(a.alternate,a,J);null===b&&(b=c(a));ed.current=null;return b}function f(a){if(null!==P){if(!(0===J||J>a))if(J<=Nc)for(;null!==E;)E=h(E)?e(E):d(E);else for(;null!==E&&!p();)E=h(E)?e(E):d(E)}else if(!(0===J||J>a))if(J<=Nc)for(;null!==E;)E=d(E);else for(;null!==E&&!p();)E=d(E)}function g(a,b){ma?D("243"):void 0;ma=!0;a.isReadyForCommit=
!1;if(a!==eb||b!==J||null===E){for(;-1<de;)ce[de]=null,de--;fe=C;ee.current=C;X.current=!1;mg();eb=a;J=b;E=oe(eb.current,null,b)}var c=!1,d=null;try{f(b)}catch(Kc){c=!0,d=Kc}for(;c;){if(fb){ba=d;break}var g=E;if(null===g)fb=!0;else{var h=k(g,d);null===h?D("183"):void 0;if(!fb){try{c=h;d=b;for(h=c;null!==g;){switch(g.tag){case 2:je(g);break;case 5:l(g);break;case 3:Fe(g);break;case 4:Fe(g)}if(g===h||g.alternate===h)break;g=g["return"]}E=e(c);f(d)}catch(Kc){c=!0;d=Kc;continue}break}}}b=ba;fb=ma=!1;
ba=null;null!==b&&v(b);return a.isReadyForCommit?a.current.alternate:null}function k(a,b){var c=ed.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,r(a)&&(fb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=fd(g),c=g,e=!0):3===g.tag&&(c=g);if(r(g)){if(Lc||null!==fa&&(fa.has(g)||null!==g.alternate&&fa.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===na&&(na=new Set);na.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,l=g._debugSource;var Fa=fd(g);var n=null;k&&(n=fd(k));k=l;Fa="\n    in "+(Fa||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:Fa=""}h+=Fa;g=g["return"]}while(g);g=h;a=fd(a);null===P&&(P=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};P.set(c,b);try{console.error(b.error)}catch(Cg){console.error(Cg)}Lb?(null===fa&&(fa=new Set),
fa.add(c)):F(c);return c}null===ba&&(ba=b);return null}function h(a){return null!==P&&(P.has(a)||null!==a.alternate&&P.has(a.alternate))}function r(a){return null!==na&&(na.has(a)||null!==a.alternate&&na.has(a.alternate))}function n(){return 20*(((L()+100)/20|0)+1)}function y(a){return 0!==ja?ja:ma?Lb?1:J:!Dg||a.internalContextTag&1?n():1}function u(a,b){return x(a,b,!1)}function x(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||
a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ma&&c===eb&&b<=J&&(E=eb=null,J=0);var d=b;Mb>Eg&&D("185");if(null===c.nextScheduledRoot)c.remainingExpirationTime=d,null===M?(oa=M=c,c.nextScheduledRoot=c):(M=M.nextScheduledRoot=c,M.nextScheduledRoot=oa);else{var e=c.remainingExpirationTime;if(0===e||d<e)c.remainingExpirationTime=d}Ga||(ka?Nb&&z(c,1):1===d?I(1,null):gb||(gb=!0,Je(T)))}else break;a=a["return"]}}function F(a){x(a,1,
!0)}function L(){return Nc=((Ke()-Fg)/10|0)+2}function G(){var a=0,b=null;if(null!==M)for(var c=M,d=oa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===M?D("244"):void 0;if(d===d.nextScheduledRoot){oa=M=d.nextScheduledRoot=null;break}else if(d===oa)oa=e=d.nextScheduledRoot,M.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===M){M=c;M.nextScheduledRoot=oa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===
a||e<a)a=e,b=d;if(d===M)break;c=d;d=d.nextScheduledRoot}}c=pa;null!==c&&c===b?Mb++:Mb=0;pa=b;Ob=a}function T(a){I(0,a)}function I(a,b){hb=b;for(G();null!==pa&&0!==Ob&&(0===a||Ob<=a)&&!Oc;)z(pa,Ob),G();null!==hb&&(gb=!1);null===pa||gb||(gb=!0,Je(T));hb=null;Oc=!1;Mb=0;if(Pb)throw a=Pc,Pc=null,Pb=!1,a;}function z(a,c){Ga?D("245"):void 0;Ga=!0;if(c<=L()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=
b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(p()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Ga=!1}function p(){return null===hb||hb.timeRemaining()>Gg?!1:Oc=!0}function v(a){null===pa?D("246"):void 0;pa.remainingExpirationTime=0;Pb||(Pb=!0,Pc=a)}var t=gf(a),Kb=hf(a),Fe=t.popHostContainer,l=t.popHostContext,mg=t.resetHostContainer,Ge=cf(a,t,Kb,u,y),w=Ge.beginWork,ng=Ge.beginFailedWork,og=df(a,t,Kb).completeWork;
t=ef(a,k);var wg=t.commitResetTextContent,He=t.commitPlacement,yg=t.commitDeletion,Ie=t.commitWork,Ag=t.commitLifeCycles,Bg=t.commitAttachRef,xg=t.commitDetachRef,Ke=a.now,Je=a.scheduleDeferredCallback,Dg=a.useSyncScheduling,vg=a.prepareForCommit,zg=a.resetAfterCommit,Fg=Ke(),Nc=2,ja=0,ma=!1,E=null,eb=null,J=0,q=null,P=null,na=null,fa=null,ba=null,fb=!1,Lb=!1,Lc=!1,oa=null,M=null,gb=!1,Ga=!1,pa=null,Ob=0,Oc=!1,Pb=!1,Pc=null,hb=null,ka=!1,Nb=!1,Eg=1E3,Mb=0,Gg=1;return{computeAsyncExpiration:n,computeExpirationForFiber:y,
scheduleWork:u,batchedUpdates:function(a,b){var c=ka;ka=!0;try{return a(b)}finally{(ka=c)||Ga||I(1,null)}},unbatchedUpdates:function(a){if(ka&&!Nb){Nb=!0;try{return a()}finally{Nb=!1}}return a()},flushSync:function(a){var b=ka;ka=!0;try{a:{var c=ja;ja=1;try{var d=a();break a}finally{ja=c}d=void 0}return d}finally{ka=b,Ga?D("187"):void 0,I(1,null)}},deferredUpdates:function(a){var b=ja;ja=n();try{return a()}finally{ja=b}}}}
function kf(a){function b(a){a=kd(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=jf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,r){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===gd(c)&&2===c.tag?void 0:D("170");for(h=c;3!==h.tag;){if(he(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:D("171")}h=h.stateNode.context}c=he(c)?le(c,h):h}else c=C;null===b.context?b.context=c:b.pendingContext=c;b=r;b=void 0===b?null:b;r=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);De(g,{expirationTime:r,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,r)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=ld(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return ye(A({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var lf=Object.freeze({default:kf}),mf=lf&&kf||lf,nf=mf["default"]?mf["default"]:mf,of="object"===typeof performance&&"function"===typeof performance.now,pf=void 0;pf=of?function(){return performance.now()}:function(){return Date.now()};var qf=void 0;
if(m.canUseDOM)if("function"!==typeof requestIdleCallback){var rf=null,sf=!1,tf=!1,uf=0,vf=33,wf=33,xf;xf=of?{timeRemaining:function(){return uf-performance.now()}}:{timeRemaining:function(){return uf-Date.now()}};var yf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){a.source===window&&a.data===yf&&(sf=!1,a=rf,rf=null,null!==a&&a(xf))},!1);var zf=function(a){tf=!1;var b=a-uf+wf;b<wf&&vf<wf?(8>b&&(b=8),wf=b<vf?vf:b):vf=b;uf=a+wf;sf||(sf=!0,
window.postMessage(yf,"*"))};qf=function(a){rf=a;tf||(tf=!0,requestAnimationFrame(zf));return 0}}else qf=requestIdleCallback;else qf=function(a){setTimeout(function(){a({timeRemaining:function(){return Infinity}})});return 0};
var Af=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Bf={},Cf={};function Df(a){if(Cf.hasOwnProperty(a))return!0;if(Bf.hasOwnProperty(a))return!1;if(Af.test(a))return Cf[a]=!0;Bf[a]=!0;return!1}
function Ef(a,b,c){var d=ua(b);if(d&&ta(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Ff(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Gf(a,b,ta(b,c)?c:null)}
function Gf(a,b,c){Df(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Ff(a,b){var c=ua(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Hf(a,b){var c=b.value,d=b.checked;return A({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function If(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Jf(a,b){var c=b.checked;null!=c&&Ef(a,"checked",c||!1);c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Kf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Lf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Mf(a,b){a=A({children:void 0},b);if(b=Lf(b.children))a.children=b;return a}function Nf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Of(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Pf(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Qf(a,b){var c=b.value,d=c;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""),d=c);a._wrapperState={initialValue:""+d}}
function Rf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Sf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Tf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Uf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Vf(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Uf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Wf=void 0,Xf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Tf.svg||"innerHTML"in a)a.innerHTML=b;else{Wf=Wf||document.createElement("div");Wf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Wf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}}),Yf=/["'&<>]/;
function Zf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
m.canUseDOM&&("textContent"in document.documentElement||(Zf=function(a,b){if(3===a.nodeType)a.nodeValue=b;else{if("boolean"===typeof b||"number"===typeof b)b=""+b;else{b=""+b;var c=Yf.exec(b);if(c){var d="",e,f=0;for(e=c.index;e<b.length;e++){switch(b.charCodeAt(e)){case 34:c="\x26quot;";break;case 38:c="\x26amp;";break;case 39:c="\x26#x27;";break;case 60:c="\x26lt;";break;case 62:c="\x26gt;";break;default:continue}f!==e&&(d+=b.substring(f,e));f=e+1;d+=c}b=f!==e?d+b.substring(f,e):d}}Xf(a,b)}}));
var $f=Zf,ag={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},bg=["Webkit","ms","Moz","O"];Object.keys(ag).forEach(function(a){bg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);ag[b]=ag[a]})});
function cg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||ag.hasOwnProperty(e)&&ag[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var dg=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function eg(a,b,c){b&&(dg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
function fg(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var gg=Tf.html,hg=B.thatReturns("");
function ig(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Dd(a);b=Ra[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topWheel"===e?yc("wheel")?U("topWheel","wheel",a):yc("mousewheel")?U("topWheel","mousewheel",a):U("topWheel","DOMMouseScroll",a):"topScroll"===e?sd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(sd("topFocus","focus",a),sd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&sd("topCancel","cancel",a),c.topCancel=
!0):"topClose"===e?(yc("close",!0)&&sd("topClose","close",a),c.topClose=!0):zd.hasOwnProperty(e)&&U(e,zd[e],a),c[e]=!0)}}
var jg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function kg(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===gg&&(d=Uf(a));d===gg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function lg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=fg(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in jg)jg.hasOwnProperty(f)&&U(f,jg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":If(a,c);f=Hf(a,c);U("topInvalid","invalid",a);
ig(d,"onChange");break;case "option":f=Mf(a,c);break;case "select":Of(a,c);f=A({},c,{value:void 0});U("topInvalid","invalid",a);ig(d,"onChange");break;case "textarea":Qf(a,c);f=Pf(a,c);U("topInvalid","invalid",a);ig(d,"onChange");break;default:f=c}eg(b,f,hg);var g=f,k;for(k in g)if(g.hasOwnProperty(k)){var h=g[k];"style"===k?cg(a,h,hg):"dangerouslySetInnerHTML"===k?(h=h?h.__html:void 0,null!=h&&Xf(a,h)):"children"===k?"string"===typeof h?("textarea"!==b||""!==h)&&$f(a,h):"number"===typeof h&&$f(a,
""+h):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(Qa.hasOwnProperty(k)?null!=h&&ig(d,k):e?Gf(a,k,h):null!=h&&Ef(a,k,h))}switch(b){case "input":Bc(a);Kf(a,c);break;case "textarea":Bc(a);Sf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Nf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Nf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
B)}}
function qg(a,b,c,d,e){var f=null;switch(b){case "input":c=Hf(a,c);d=Hf(a,d);f=[];break;case "option":c=Mf(a,c);d=Mf(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=Pf(a,c);d=Pf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=B)}eg(b,d,hg);var g,k;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(k in b=c[g],b)b.hasOwnProperty(k)&&(a||(a={}),a[k]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Qa.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var h=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&h!==b&&(null!=h||null!=b))if("style"===g)if(b){for(k in b)!b.hasOwnProperty(k)||h&&h.hasOwnProperty(k)||(a||(a={}),a[k]="");for(k in h)h.hasOwnProperty(k)&&b[k]!==h[k]&&(a||(a={}),a[k]=h[k])}else a||(f||(f=[]),f.push(g,a)),a=h;else"dangerouslySetInnerHTML"===
g?(h=h?h.__html:void 0,b=b?b.__html:void 0,null!=h&&b!==h&&(f=f||[]).push(g,""+h)):"children"===g?b===h||"string"!==typeof h&&"number"!==typeof h||(f=f||[]).push(g,""+h):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Qa.hasOwnProperty(g)?(null!=h&&ig(e,g),f||b===h||(f=[])):(f=f||[]).push(g,h))}a&&(f=f||[]).push("style",a);return f}
function rg(a,b,c,d,e){fg(c,d);d=fg(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],k=b[f+1];"style"===g?cg(a,k,hg):"dangerouslySetInnerHTML"===g?Xf(a,k):"children"===g?$f(a,k):d?null!=k?Gf(a,g,k):a.removeAttribute(g):null!=k?Ef(a,g,k):Ff(a,g)}switch(c){case "input":Jf(a,e);Cc(a);break;case "textarea":Rf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Nf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=
e.defaultValue?Nf(a,!!e.multiple,e.defaultValue,!0):Nf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function sg(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in jg)jg.hasOwnProperty(f)&&U(f,jg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":If(a,c);U("topInvalid","invalid",a);ig(e,"onChange");break;case "select":Of(a,c);
U("topInvalid","invalid",a);ig(e,"onChange");break;case "textarea":Qf(a,c),U("topInvalid","invalid",a),ig(e,"onChange")}eg(b,c,hg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Qa.hasOwnProperty(g)&&null!=f&&ig(e,g));switch(b){case "input":Bc(a);Kf(a,c);break;case "textarea":Bc(a);Sf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=B)}return d}function tg(a,b){return a.nodeValue!==b}
var ug=Object.freeze({createElement:kg,createTextNode:lg,setInitialProperties:pg,diffProperties:qg,updateProperties:rg,diffHydratedProperties:sg,diffHydratedText:tg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Jf(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=sb(d);e?void 0:D("90");Jf(d,e)}}}break;case "textarea":Rf(a,c);break;case "select":b=c.value,null!=b&&Nf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(ug);var Hg=null,Ig=null;function Jg(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Kg(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=nf({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Vf(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Vf(a,b)}return a},getChildHostContext:function(a,b){return Vf(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){Hg=pd;var a=da();if(Gd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(x){b=null;break a}var f=0,g=-1,k=-1,h=0,r=0,n=a,y=null;b:for(;;){for(var u;;){n!==b||0!==d&&3!==n.nodeType||(g=f+d);n!==e||0!==c&&3!==n.nodeType||(k=f+c);3===n.nodeType&&(f+=n.nodeValue.length);if(null===(u=n.firstChild))break;y=n;n=u}for(;;){if(n===a)break b;y===b&&++h===d&&(g=f);y===e&&++r===c&&(k=f);if(null!==(u=n.nextSibling))break;n=y;y=n.parentNode}n=u}b=-1===g||-1===k?null:
{start:g,end:k}}else b=null}b=b||{start:0,end:0}}else b=null;Ig={focusedElem:a,selectionRange:b};qd(!1)},resetAfterCommit:function(){var a=Ig,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ha(document.documentElement,c)){if(Gd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Fd(c,a);var f=Fd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Ig=null;qd(Hg);Hg=null},createInstance:function(a,b,c,d,e){a=kg(a,b,c,d);a[O]=e;a[pb]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return qg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=lg(a,b);a[O]=d;return a},now:pf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[pb]=e;rg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[O]=f;a[pb]=c;return sg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[O]=c;return tg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:qf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Lg(a,b,c,d,e){Jg(c)?void 0:D("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Kg(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Mg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Jg(b)?void 0:D("200");return Pe(a,b,null,c)}
function Ng(a,b){this._reactRootContainer=Z.createContainer(a,b)}Ng.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Ng.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Og={createPortal:Mg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?D("188"):D("213",Object.keys(a))},hydrate:function(a,b,c){return Lg(null,a,b,!0,c)},render:function(a,b,c){return Lg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Lg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Jg(a)?void 0:
D("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Lg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Mg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:nb,EventPluginRegistry:Ua,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:tb,ReactDOMEventListener:td}};
Z.injectIntoDevTools({findFiberByHostInstance:qb,bundleType:0,version:"16.1.1",rendererPackageName:"react-dom"});var Pg=Object.freeze({default:Og}),Qg=Pg&&Og||Pg;module.exports=Qg["default"]?Qg["default"]:Qg;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(39);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(188);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(189);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(67);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(39);
var invariant = __webpack_require__(193);
var ReactPropTypesSecret = __webpack_require__(194);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(215);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(108);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(203);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(201);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(26)))

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(105);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(205);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(208);


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(209);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26), __webpack_require__(48)(module)))

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(106);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(107);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(108);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(109);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(216);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(67);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(218);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Elements = __webpack_require__(50);

var _Provider = __webpack_require__(70);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// react-redux does a bunch of stuff with pure components / checking if it needs to re-render.
// not sure if we need to do the same.
var inject = function inject(WrappedComponent) {
  var _class, _temp;

  var componentOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _componentOptions$wit = componentOptions.withRef,
      withRef = _componentOptions$wit === undefined ? false : _componentOptions$wit;


  return _temp = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props, context) {
      _classCallCheck(this, _class);

      if (!context || !context.getRegisteredElements) {
        throw new Error('It looks like you are trying to inject Stripe context outside of an Elements context.\nPlease be sure the component that calls createSource or createToken is within an <Elements> component.');
      }

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      _this.parseElementOrData = function (elementOrOptions) {
        return elementOrOptions && (typeof elementOrOptions === 'undefined' ? 'undefined' : _typeof(elementOrOptions)) === 'object' && elementOrOptions._frame && _typeof(elementOrOptions._frame) === 'object' && elementOrOptions._frame.id && typeof elementOrOptions._frame.id === 'string' && typeof elementOrOptions._componentName === 'string' ? { type: 'element', element: elementOrOptions } : { type: 'data', data: elementOrOptions };
      };

      _this.findElement = function (filterBy, specifiedType) {
        var allElements = _this.context.getRegisteredElements();
        var filteredElements = allElements.filter(function (e) {
          return e[filterBy];
        });
        var matchingElements = specifiedType === 'auto' ? filteredElements : filteredElements.filter(function (e) {
          return e[filterBy] === specifiedType;
        });

        if (matchingElements.length === 1) {
          return matchingElements[0].element;
        } else if (matchingElements.length > 1) {
          throw new Error('You did not specify the type of Source, Token, or PaymentMethod to create.\n        We could not infer which Element you want to use for this operation.');
        } else {
          return null;
        }
      };

      _this.requireElement = function (filterBy, specifiedType) {
        var element = _this.findElement(filterBy, specifiedType);
        if (element) {
          return element;
        } else {
          throw new Error('You did not specify the type of Source, Token, or PaymentMethod to create.\n        We could not infer which Element you want to use for this operation.');
        }
      };

      _this.wrappedCreateToken = function (stripe) {
        return function () {
          var tokenTypeOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          if (tokenTypeOrOptions && (typeof tokenTypeOrOptions === 'undefined' ? 'undefined' : _typeof(tokenTypeOrOptions)) === 'object') {
            // First argument is options; infer the Element and tokenize
            var opts = tokenTypeOrOptions;

            var tokenType = opts.type,
                rest = _objectWithoutProperties(opts, ['type']);

            var specifiedType = typeof tokenType === 'string' ? tokenType : 'auto';
            // Since only options were passed in, a corresponding Element must exist
            // for the tokenization to succeed -- thus we call requireElement.
            var element = _this.requireElement('impliedTokenType', specifiedType);
            return stripe.createToken(element, rest);
          } else if (typeof tokenTypeOrOptions === 'string') {
            // First argument is token type; tokenize with token type and options
            var _tokenType = tokenTypeOrOptions;
            return stripe.createToken(_tokenType, options);
          } else {
            // If a bad value was passed in for options, throw an error.
            throw new Error('Invalid options passed to createToken. Expected an object, got ' + (typeof tokenTypeOrOptions === 'undefined' ? 'undefined' : _typeof(tokenTypeOrOptions)) + '.');
          }
        };
      };

      _this.wrappedCreateSource = function (stripe) {
        return function () {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            if (typeof options.type !== 'string') {
              throw new Error('Invalid Source type passed to createSource. Expected string, got ' + _typeof(options.type) + '.');
            }

            var element = _this.findElement('impliedSourceType', options.type);
            if (element) {
              // If an Element exists for the source type, use that to create the
              // corresponding source.
              //
              // NOTE: this prevents users from independently creating sources of
              // type `foo` if an Element that can create `foo` sources exists in
              // the current <Elements /> context.
              return stripe.createSource(element, options);
            } else {
              // If no Element exists for the source type, directly create a source.
              return stripe.createSource(options);
            }
          } else {
            // If a bad value was passed in for options, throw an error.
            throw new Error('Invalid options passed to createSource. Expected an object, got ' + (typeof options === 'undefined' ? 'undefined' : _typeof(options)) + '.');
          }
        };
      };

      _this.wrappedCreatePaymentMethod = function (stripe) {
        return function (paymentMethodType, elementOrData, maybeData) {
          if (paymentMethodType && (typeof paymentMethodType === 'undefined' ? 'undefined' : _typeof(paymentMethodType)) === 'object') {
            return stripe.createPaymentMethod(paymentMethodType);
          }

          if (!paymentMethodType || typeof paymentMethodType !== 'string') {
            throw new Error('Invalid PaymentMethod type passed to createPaymentMethod. Expected a string, got ' + (typeof paymentMethodType === 'undefined' ? 'undefined' : _typeof(paymentMethodType)) + '.');
          }

          var elementOrDataResult = _this.parseElementOrData(elementOrData);

          // Second argument is Element; use passed in Element
          if (elementOrDataResult.type === 'element') {
            var _element = elementOrDataResult.element;

            if (maybeData) {
              return stripe.createPaymentMethod(paymentMethodType, _element, maybeData);
            } else {
              return stripe.createPaymentMethod(paymentMethodType, _element);
            }
          }

          // Second argument is data or undefined; infer the Element
          var data = elementOrDataResult.data;

          var element = _this.findElement('impliedPaymentMethodType', paymentMethodType);

          if (element) {
            return data ? stripe.createPaymentMethod(paymentMethodType, element, data) : stripe.createPaymentMethod(paymentMethodType, element);
          }

          if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
            return stripe.createPaymentMethod(paymentMethodType, data);
          } else if (!data) {
            throw new Error('Could not find an Element that can be used to create a PaymentMethod of type: ' + paymentMethodType + '.');
          } else {
            // If a bad value was passed in for data, throw an error.
            throw new Error('Invalid data passed to createPaymentMethod. Expected an object, got ' + (typeof data === 'undefined' ? 'undefined' : _typeof(data)) + '.');
          }
        };
      };

      _this.wrappedHandleCardX = function (stripe, method) {
        return function (clientSecret, elementOrData, maybeData) {
          if (!clientSecret || typeof clientSecret !== 'string') {
            // If a bad value was passed in for clientSecret, throw an error.
            throw new Error('Invalid PaymentIntent client secret passed to handleCardPayment. Expected string, got ' + (typeof clientSecret === 'undefined' ? 'undefined' : _typeof(clientSecret)) + '.');
          }

          var elementOrDataResult = _this.parseElementOrData(elementOrData);

          // Second argument is Element; handle with element
          if (elementOrDataResult.type === 'element') {
            var _element2 = elementOrDataResult.element;

            if (maybeData) {
              return stripe[method](clientSecret, _element2, maybeData);
            } else {
              return stripe[method](clientSecret, _element2);
            }
          }

          // Second argument is data or undefined; see if we can find a mounted Element
          // that can create card PaymentMethods
          var data = elementOrDataResult.data;

          var element = _this.findElement('impliedPaymentMethodType', 'card');

          if (element) {
            // If an Element exists that can create card PaymentMethods use it. Otherwise
            // assume that we must be calling with data only.
            //
            // NOTE: this prevents users from using handleCard* with an existing
            // Source or PaymentMethod if an Element that can create card PaymentMethods
            // exists in the current <Elements /> context.
            if (data) {
              return stripe[method](clientSecret, element, data);
            } else {
              return stripe[method](clientSecret, element);
            }
          } else if (data) {
            // if no element exists call handleCard* directly (with data)
            return stripe[method](clientSecret, data);
          } else {
            // if no element exists call handleCard* directly (with only the clientSecret)
            return stripe[method](clientSecret);
          }
        };
      };

      if (_this.context.tag === 'sync') {
        _this.state = {
          stripe: _this.stripeProps(_this.context.stripe)
        };
      } else {
        _this.state = {
          stripe: null
        };
      }
      return _this;
    }

    _class.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      if (this.context.tag === 'async') {
        this.context.addStripeLoadListener(function (stripe) {
          _this2.setState({
            stripe: _this2.stripeProps(stripe)
          });
        });
      } else {
        // when 'sync', it's already set in the constructor.
      }
    };

    _class.prototype.getWrappedInstance = function getWrappedInstance() {
      if (!withRef) {
        throw new Error('To access the wrapped instance, the `{withRef: true}` option must be set when calling `injectStripe()`');
      }
      return this.wrappedInstance;
    };

    _class.prototype.stripeProps = function stripeProps(stripe) {
      return _extends({}, stripe, {
        // These are the only functions that take elements.
        createToken: this.wrappedCreateToken(stripe),
        createSource: this.wrappedCreateSource(stripe),
        createPaymentMethod: this.wrappedCreatePaymentMethod(stripe),
        handleCardPayment: this.wrappedHandleCardX(stripe, 'handleCardPayment'),
        handleCardSetup: this.wrappedHandleCardX(stripe, 'handleCardSetup')
      });
    };

    // Finds an Element by the specified type, if one exists.
    // Throws if multiple Elements match.


    // Require that exactly one Element is found for the specified type.
    // Throws if no Element is found.


    // Wraps createToken in order to infer the Element that is being tokenized.


    // Wraps createSource in order to infer the Element that is being used for
    // source creation.


    // Wraps createPaymentMethod in order to infer the Element that is being
    // used for PaymentMethod creation.


    _class.prototype.render = function render() {
      var _this3 = this;

      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
        stripe: this.state.stripe,
        elements: this.context.elements,
        ref: withRef ? function (c) {
          _this3.wrappedInstance = c;
        } : null
      }));
    };

    return _class;
  }(_react2.default.Component), _class.contextTypes = _extends({}, _Provider.providerContextTypes, _Elements.injectContextTypes), _class.displayName = 'InjectStripe(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _temp;
};

exports.default = inject;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(49);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isEqual = __webpack_require__(221);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _Elements = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var noop = function noop() {};

var _extractOptions = function _extractOptions(props) {
  var id = props.id,
      className = props.className,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onReady = props.onReady,
      options = _objectWithoutProperties(props, ['id', 'className', 'onChange', 'onFocus', 'onBlur', 'onReady']);

  return options;
};

var capitalized = function capitalized(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

var Element = function Element(type) {
  var _class, _temp;

  var hocOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _temp = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props, context) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      _this.handleRef = function (ref) {
        _this._ref = ref;
      };

      _this._element = null;

      var options = _extractOptions(_this.props);
      // We keep track of the extracted options on this._options to avoid re-rendering.
      // (We would unnecessarily re-render if we were tracking them with state.)
      _this._options = options;
      return _this;
    }

    _class.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      this.context.addElementsLoadListener(function (elements) {
        if (!_this2._ref) {
          return;
        }

        var element = elements.create(type, _this2._options);
        _this2._element = element;

        _this2._setupEventListeners(element);

        element.mount(_this2._ref);

        // Register Element for automatic token / source / paymentMethod creation
        _this2.context.registerElement(element, hocOptions.impliedTokenType, hocOptions.impliedSourceType, hocOptions.impliedPaymentMethodType);
      });
    };

    _class.prototype.componentDidUpdate = function componentDidUpdate() {
      var options = _extractOptions(this.props);
      if (Object.keys(options).length !== 0 && !(0, _isEqual2.default)(options, this._options)) {
        this._options = options;
        if (this._element) {
          this._element.update(options);
        }
      }
    };

    _class.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this._element) {
        var element = this._element;
        element.destroy();
        this.context.unregisterElement(element);
      }
    };

    _class.prototype._setupEventListeners = function _setupEventListeners(element) {
      var _this3 = this;

      element.on('ready', function () {
        _this3.props.onReady(_this3._element);
      });

      element.on('change', function (change) {
        _this3.props.onChange(change);
      });

      element.on('blur', function () {
        var _props;

        return (_props = _this3.props).onBlur.apply(_props, arguments);
      });
      element.on('focus', function () {
        var _props2;

        return (_props2 = _this3.props).onFocus.apply(_props2, arguments);
      });
    };

    _class.prototype.render = function render() {
      return _react2.default.createElement('div', {
        id: this.props.id,
        className: this.props.className,
        ref: this.handleRef
      });
    };

    return _class;
  }(_react2.default.Component), _class.propTypes = {
    id: _propTypes2.default.string,
    className: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    onReady: _propTypes2.default.func
  }, _class.defaultProps = {
    id: undefined,
    className: undefined,
    onChange: noop,
    onBlur: noop,
    onFocus: noop,
    onReady: noop
  }, _class.contextTypes = _Elements.elementContextTypes, _class.displayName = capitalized(type) + 'Element', _temp;
};

exports.default = Element;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var PLAIN_OBJECT_STR = '[object Object]';

var isEqual = function isEqual(left, right) {
  if ((typeof left === 'undefined' ? 'undefined' : _typeof(left)) !== 'object' || (typeof right === 'undefined' ? 'undefined' : _typeof(right)) !== 'object') {
    return left === right;
  }

  if (left === null || right === null) return left === right;

  var leftArray = Array.isArray(left);
  var rightArray = Array.isArray(right);

  if (leftArray !== rightArray) return false;

  var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
  var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;

  if (leftPlainObject !== rightPlainObject) return false;

  if (!leftPlainObject && !leftArray) return false;

  var leftKeys = Object.keys(left);
  var rightKeys = Object.keys(right);

  if (leftKeys.length !== rightKeys.length) return false;

  var keySet = {};
  for (var i = 0; i < leftKeys.length; i += 1) {
    keySet[leftKeys[i]] = true;
  }
  for (var _i = 0; _i < rightKeys.length; _i += 1) {
    keySet[rightKeys[_i]] = true;
  }
  var allKeys = Object.keys(keySet);
  if (allKeys.length !== leftKeys.length) {
    return false;
  }

  var l = left;
  var r = right;
  var pred = function pred(key) {
    return isEqual(l[key], r[key]);
  };

  return allKeys.every(pred);
};

exports.default = isEqual;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(49);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowEqual = __webpack_require__(223);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _Elements = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var noop = function noop() {};

var _extractOptions = function _extractOptions(props) {
  var id = props.id,
      className = props.className,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onReady = props.onReady,
      paymentRequest = props.paymentRequest,
      options = _objectWithoutProperties(props, ['id', 'className', 'onBlur', 'onClick', 'onFocus', 'onReady', 'paymentRequest']);

  return options;
};

var PaymentRequestButtonElement = function (_React$Component) {
  _inherits(PaymentRequestButtonElement, _React$Component);

  function PaymentRequestButtonElement(props, context) {
    _classCallCheck(this, PaymentRequestButtonElement);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleRef = function (ref) {
      _this._ref = ref;
    };

    var options = _extractOptions(props);
    // We keep track of the extracted options on this._options to avoid re-rendering.
    // (We would unnecessarily re-render if we were tracking them with state.)
    _this._options = options;
    return _this;
  }

  PaymentRequestButtonElement.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.context.addElementsLoadListener(function (elements) {
      _this2._element = elements.create('paymentRequestButton', _extends({
        paymentRequest: _this2.props.paymentRequest
      }, _this2._options));
      _this2._element.on('ready', function () {
        _this2.props.onReady(_this2._element);
      });
      _this2._element.on('focus', function () {
        var _props;

        return (_props = _this2.props).onFocus.apply(_props, arguments);
      });
      _this2._element.on('click', function () {
        var _props2;

        return (_props2 = _this2.props).onClick.apply(_props2, arguments);
      });
      _this2._element.on('blur', function () {
        var _props3;

        return (_props3 = _this2.props).onBlur.apply(_props3, arguments);
      });
      _this2._element.mount(_this2._ref);
    });
  };

  PaymentRequestButtonElement.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.paymentRequest !== prevProps.paymentRequest) {
      console.warn('Unsupported prop change: paymentRequest is not a customizable property.');
    }
    var options = _extractOptions(this.props);
    if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
      this._options = options;
      this._element.update(options);
    }
  };

  PaymentRequestButtonElement.prototype.componentWillUnmount = function componentWillUnmount() {
    this._element.destroy();
  };

  PaymentRequestButtonElement.prototype.render = function render() {
    return _react2.default.createElement('div', {
      id: this.props.id,
      className: this.props.className,
      ref: this.handleRef
    });
  };

  return PaymentRequestButtonElement;
}(_react2.default.Component);

PaymentRequestButtonElement.propTypes = {
  id: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onReady: _propTypes2.default.func,
  paymentRequest: _propTypes2.default.shape({
    canMakePayment: _propTypes2.default.func.isRequired,
    on: _propTypes2.default.func.isRequired,
    show: _propTypes2.default.func.isRequired
  }).isRequired
};
PaymentRequestButtonElement.defaultProps = {
  id: undefined,
  className: undefined,
  onBlur: noop,
  onClick: noop,
  onFocus: noop,
  onReady: noop
};
PaymentRequestButtonElement.contextTypes = _Elements.elementContextTypes;
exports.default = PaymentRequestButtonElement;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var shallowEqual = function shallowEqual(a, b) {
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  return keysA.length === keysB.length && keysA.every(function (key) {
    return b.hasOwnProperty(key) && b[key] === a[key];
  });
};

exports.default = shallowEqual;

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_css__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_navigation__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Routes__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_toastr_build_toastr_min_css__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_toastr_build_toastr_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__node_modules_toastr_build_toastr_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__withTracker__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth_authActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_questionActions__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};













var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isHydrated: false
        };
        return _this;
    }
    App.prototype.componentDidMount = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_12_axios___default.a.defaults.headers.common['Content-Type'] = 'application/json';
        Promise.all([
            this.props.actions.fetchAuthenticatedUser(),
            this.props.actions.getQuestions(),
        ])
            .then(function () { return _this.setState({ isHydrated: true }); });
    };
    App.prototype.render = function () {
        return !this.state.isHydrated ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "page-content page-content-fullscreen d-flex align-items-center" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common__["f" /* Spinner */], { className: "mx-auto xlarge" }))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("main", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_navigation__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { component: Object(__WEBPACK_IMPORTED_MODULE_7__withTracker__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__Routes__["a" /* default */]) }))));
    };
    return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {};
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_8__auth_authActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__common_questionActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_10_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(App));


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(73);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(18);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(22);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(71);

var _PathUtils = __webpack_require__(40);

var _createTransitionManager = __webpack_require__(72);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(73);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(18);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(22);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(71);

var _PathUtils = __webpack_require__(40);

var _createTransitionManager = __webpack_require__(72);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(114);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(18);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(40);

var _LocationUtils = __webpack_require__(71);

var _createTransitionManager = __webpack_require__(72);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(113);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(233)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(116);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(117);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(237);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(238);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(239);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(53);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(41);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(118);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(118);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(75);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(119);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(120);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(52);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(121);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_table__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_table_react_table_css__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_table_react_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_table_react_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var classNames = __webpack_require__(8);

var DataTable = /** @class */ (function (_super) {
    __extends(DataTable, _super);
    function DataTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onPageChange = function (e, callback) {
            // TODO: Find a better way to animate the page
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
            callback();
        };
        return _this;
    }
    DataTable.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, TableComponent = _a.TableComponent, columns = _a.columns, data = _a.data, loading = _a.loading, _b = _a.getTheadProps, getTheadProps = _b === void 0 ? function () {
            return { className: 'thead' };
        } : _b, _c = _a.getTheadThProps, getTheadThProps = _c === void 0 ? function () {
            return { className: 'th' };
        } : _c, _d = _a.getTbodyProps, getTbodyProps = _d === void 0 ? function () {
            return { className: 'tbody' };
        } : _d, _e = _a.getTrProps, getTrProps = _e === void 0 ? function () {
            return { className: 'tr' };
        } : _e, _f = _a.getTdProps, getTdProps = _f === void 0 ? function () {
            return { className: 'td' };
        } : _f, _g = _a.minRows, minRows = _g === void 0 ? 0 : _g, _h = _a.resizable, resizable = _h === void 0 ? false : _h, _j = _a.sortable, sortable = _j === void 0 ? false : _j, noDataText = _a.noDataText, onPageChange = _a.onPageChange, page = _a.page, _k = _a.defaultPageSize, defaultPageSize = _k === void 0 ? 20 : _k, setRef = _a.setRef, showPagination = _a.showPagination;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_table___default.a, { className: classNames('data-table', className), TableComponent: TableComponent, columns: columns, data: data, loading: loading, getTheadProps: getTheadProps, getTheadThProps: getTheadThProps, getTbodyProps: getTbodyProps, getTrProps: getTrProps, getTdProps: getTdProps, minRows: minRows, resizable: resizable, sortable: sortable, PreviousComponent: function (p) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { type: "button", onClick: function (e) { return _this.onPageChange(e, p.onClick); }, disabled: p.disabled, className: "btn btn-outline-secondary" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons__["s" /* IconChevronLeft */], null))); }, NextComponent: function (p) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { type: "button", onClick: function (e) { return _this.onPageChange(e, p.onClick); }, disabled: p.disabled, className: "btn btn-outline-secondary" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons__["t" /* IconChevronRight */], null))); }, onPageChange: onPageChange, noDataText: noDataText, page: page, defaultPageSize: defaultPageSize, ref: setRef, showPagination: showPagination }));
    };
    return DataTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DataTable);


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactTableDefaults = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = __webpack_require__(76);

var _utils2 = _interopRequireDefault(_utils);

var _lifecycle = __webpack_require__(247);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _methods = __webpack_require__(248);

var _methods2 = _interopRequireDefault(_methods);

var _defaultProps = __webpack_require__(249);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _propTypes = __webpack_require__(251);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//


var ReactTableDefaults = exports.ReactTableDefaults = _defaultProps2.default;

var ReactTable = function (_Methods) {
  _inherits(ReactTable, _Methods);

  function ReactTable(props) {
    _classCallCheck(this, ReactTable);

    var _this = _possibleConstructorReturn(this, (ReactTable.__proto__ || Object.getPrototypeOf(ReactTable)).call(this));

    _this.getResolvedState = _this.getResolvedState.bind(_this);
    _this.getDataModel = _this.getDataModel.bind(_this);
    _this.getSortedData = _this.getSortedData.bind(_this);
    _this.fireFetchData = _this.fireFetchData.bind(_this);
    _this.getPropOrState = _this.getPropOrState.bind(_this);
    _this.getStateOrProp = _this.getStateOrProp.bind(_this);
    _this.filterData = _this.filterData.bind(_this);
    _this.sortData = _this.sortData.bind(_this);
    _this.getMinRows = _this.getMinRows.bind(_this);
    _this.onPageChange = _this.onPageChange.bind(_this);
    _this.onPageSizeChange = _this.onPageSizeChange.bind(_this);
    _this.sortColumn = _this.sortColumn.bind(_this);
    _this.filterColumn = _this.filterColumn.bind(_this);
    _this.resizeColumnStart = _this.resizeColumnStart.bind(_this);
    _this.resizeColumnEnd = _this.resizeColumnEnd.bind(_this);
    _this.resizeColumnMoving = _this.resizeColumnMoving.bind(_this);

    _this.state = {
      page: 0,
      pageSize: props.defaultPageSize,
      sorted: props.defaultSorted,
      expanded: props.defaultExpanded,
      filtered: props.defaultFiltered,
      resized: props.defaultResized,
      currentlyResizing: false,
      skipNextSort: false
    };
    return _this;
  }

  _createClass(ReactTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var resolvedState = this.getResolvedState();
      var children = resolvedState.children,
          className = resolvedState.className,
          style = resolvedState.style,
          getProps = resolvedState.getProps,
          getTableProps = resolvedState.getTableProps,
          getTheadGroupProps = resolvedState.getTheadGroupProps,
          getTheadGroupTrProps = resolvedState.getTheadGroupTrProps,
          getTheadGroupThProps = resolvedState.getTheadGroupThProps,
          getTheadProps = resolvedState.getTheadProps,
          getTheadTrProps = resolvedState.getTheadTrProps,
          getTheadThProps = resolvedState.getTheadThProps,
          getTheadFilterProps = resolvedState.getTheadFilterProps,
          getTheadFilterTrProps = resolvedState.getTheadFilterTrProps,
          getTheadFilterThProps = resolvedState.getTheadFilterThProps,
          getTbodyProps = resolvedState.getTbodyProps,
          getTrGroupProps = resolvedState.getTrGroupProps,
          getTrProps = resolvedState.getTrProps,
          getTdProps = resolvedState.getTdProps,
          getTfootProps = resolvedState.getTfootProps,
          getTfootTrProps = resolvedState.getTfootTrProps,
          getTfootTdProps = resolvedState.getTfootTdProps,
          getPaginationProps = resolvedState.getPaginationProps,
          getLoadingProps = resolvedState.getLoadingProps,
          getNoDataProps = resolvedState.getNoDataProps,
          getResizerProps = resolvedState.getResizerProps,
          showPagination = resolvedState.showPagination,
          showPaginationTop = resolvedState.showPaginationTop,
          showPaginationBottom = resolvedState.showPaginationBottom,
          manual = resolvedState.manual,
          loadingText = resolvedState.loadingText,
          noDataText = resolvedState.noDataText,
          sortable = resolvedState.sortable,
          multiSort = resolvedState.multiSort,
          resizable = resolvedState.resizable,
          filterable = resolvedState.filterable,
          pivotIDKey = resolvedState.pivotIDKey,
          pivotValKey = resolvedState.pivotValKey,
          pivotBy = resolvedState.pivotBy,
          subRowsKey = resolvedState.subRowsKey,
          aggregatedKey = resolvedState.aggregatedKey,
          originalKey = resolvedState.originalKey,
          indexKey = resolvedState.indexKey,
          groupedByPivotKey = resolvedState.groupedByPivotKey,
          loading = resolvedState.loading,
          pageSize = resolvedState.pageSize,
          page = resolvedState.page,
          sorted = resolvedState.sorted,
          filtered = resolvedState.filtered,
          resized = resolvedState.resized,
          expanded = resolvedState.expanded,
          pages = resolvedState.pages,
          onExpandedChange = resolvedState.onExpandedChange,
          TableComponent = resolvedState.TableComponent,
          TheadComponent = resolvedState.TheadComponent,
          TbodyComponent = resolvedState.TbodyComponent,
          TrGroupComponent = resolvedState.TrGroupComponent,
          TrComponent = resolvedState.TrComponent,
          ThComponent = resolvedState.ThComponent,
          TdComponent = resolvedState.TdComponent,
          TfootComponent = resolvedState.TfootComponent,
          PaginationComponent = resolvedState.PaginationComponent,
          LoadingComponent = resolvedState.LoadingComponent,
          SubComponent = resolvedState.SubComponent,
          NoDataComponent = resolvedState.NoDataComponent,
          ResizerComponent = resolvedState.ResizerComponent,
          ExpanderComponent = resolvedState.ExpanderComponent,
          PivotValueComponent = resolvedState.PivotValueComponent,
          PivotComponent = resolvedState.PivotComponent,
          AggregatedComponent = resolvedState.AggregatedComponent,
          FilterComponent = resolvedState.FilterComponent,
          PadRowComponent = resolvedState.PadRowComponent,
          resolvedData = resolvedState.resolvedData,
          allVisibleColumns = resolvedState.allVisibleColumns,
          headerGroups = resolvedState.headerGroups,
          hasHeaderGroups = resolvedState.hasHeaderGroups,
          sortedData = resolvedState.sortedData,
          currentlyResizing = resolvedState.currentlyResizing;

      // Pagination

      var startRow = pageSize * page;
      var endRow = startRow + pageSize;
      var pageRows = manual ? resolvedData : sortedData.slice(startRow, endRow);
      var minRows = this.getMinRows();
      var padRows = _utils2.default.range(Math.max(minRows - pageRows.length, 0));

      var hasColumnFooter = allVisibleColumns.some(function (d) {
        return d.Footer;
      });
      var hasFilters = filterable || allVisibleColumns.some(function (d) {
        return d.filterable;
      });

      var recurseRowsViewIndex = function recurseRowsViewIndex(rows) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
        return [rows.map(function (row, i) {
          index += 1;
          var rowWithViewIndex = _extends({}, row, {
            _viewIndex: index
          });
          var newPath = path.concat([i]);
          if (rowWithViewIndex[subRowsKey] && _utils2.default.get(expanded, newPath)) {
            var _recurseRowsViewIndex = recurseRowsViewIndex(rowWithViewIndex[subRowsKey], newPath, index);

            var _recurseRowsViewIndex2 = _slicedToArray(_recurseRowsViewIndex, 2);

            rowWithViewIndex[subRowsKey] = _recurseRowsViewIndex2[0];
            index = _recurseRowsViewIndex2[1];
          }
          return rowWithViewIndex;
        }), index];
      };
      var _recurseRowsViewIndex3 = recurseRowsViewIndex(pageRows);

      var _recurseRowsViewIndex4 = _slicedToArray(_recurseRowsViewIndex3, 1);

      pageRows = _recurseRowsViewIndex4[0];


      var canPrevious = page > 0;
      var canNext = page + 1 < pages;

      var rowMinWidth = _utils2.default.sum(allVisibleColumns.map(function (d) {
        var resizedColumn = resized.find(function (x) {
          return x.id === d.id;
        }) || {};
        return _utils2.default.getFirstDefined(resizedColumn.value, d.width, d.minWidth);
      }));

      var rowIndex = -1;

      var finalState = _extends({}, resolvedState, {
        startRow: startRow,
        endRow: endRow,
        pageRows: pageRows,
        minRows: minRows,
        padRows: padRows,
        hasColumnFooter: hasColumnFooter,
        canPrevious: canPrevious,
        canNext: canNext,
        rowMinWidth: rowMinWidth
      });

      var rootProps = _utils2.default.splitProps(getProps(finalState, undefined, undefined, this));
      var tableProps = _utils2.default.splitProps(getTableProps(finalState, undefined, undefined, this));
      var tBodyProps = _utils2.default.splitProps(getTbodyProps(finalState, undefined, undefined, this));
      var loadingProps = getLoadingProps(finalState, undefined, undefined, this);
      var noDataProps = getNoDataProps(finalState, undefined, undefined, this);

      // Visual Components

      var makeHeaderGroup = function makeHeaderGroup(column, i) {
        var resizedValue = function resizedValue(col) {
          return (resized.find(function (x) {
            return x.id === col.id;
          }) || {}).value;
        };
        var flex = _utils2.default.sum(column.columns.map(function (col) {
          return col.width || resizedValue(col) ? 0 : col.minWidth;
        }));
        var width = _utils2.default.sum(column.columns.map(function (col) {
          return _utils2.default.getFirstDefined(resizedValue(col), col.width, col.minWidth);
        }));
        var maxWidth = _utils2.default.sum(column.columns.map(function (col) {
          return _utils2.default.getFirstDefined(resizedValue(col), col.width, col.maxWidth);
        }));

        var theadGroupThProps = _utils2.default.splitProps(getTheadGroupThProps(finalState, undefined, column, _this2));
        var columnHeaderProps = _utils2.default.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadGroupThProps.className, columnHeaderProps.className];

        var styles = _extends({}, column.headerStyle, theadGroupThProps.style, columnHeaderProps.style);

        var rest = _extends({}, theadGroupThProps.rest, columnHeaderProps.rest);

        var flexStyles = {
          flex: flex + ' 0 auto',
          width: _utils2.default.asPx(width),
          maxWidth: _utils2.default.asPx(maxWidth)
        };

        return _react2.default.createElement(
          ThComponent,
          _extends({
            key: i + '-' + column.id,
            className: (0, _classnames2.default)(classes),
            style: _extends({}, styles, flexStyles)
          }, rest),
          _utils2.default.normalizeComponent(column.Header, {
            data: sortedData,
            column: column
          })
        );
      };

      var makeHeaderGroups = function makeHeaderGroups() {
        var theadGroupProps = _utils2.default.splitProps(getTheadGroupProps(finalState, undefined, undefined, _this2));
        var theadGroupTrProps = _utils2.default.splitProps(getTheadGroupTrProps(finalState, undefined, undefined, _this2));
        return _react2.default.createElement(
          TheadComponent,
          _extends({
            className: (0, _classnames2.default)('-headerGroups', theadGroupProps.className),
            style: _extends({}, theadGroupProps.style, {
              minWidth: rowMinWidth + 'px'
            })
          }, theadGroupProps.rest),
          _react2.default.createElement(
            TrComponent,
            _extends({
              className: theadGroupTrProps.className,
              style: theadGroupTrProps.style
            }, theadGroupTrProps.rest),
            headerGroups.map(makeHeaderGroup)
          )
        );
      };

      var makeHeader = function makeHeader(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var sort = sorted.find(function (d) {
          return d.id === column.id;
        });
        var show = typeof column.show === 'function' ? column.show() : column.show;
        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var theadThProps = _utils2.default.splitProps(getTheadThProps(finalState, undefined, column, _this2));
        var columnHeaderProps = _utils2.default.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadThProps.className, columnHeaderProps.className];

        var styles = _extends({}, column.headerStyle, theadThProps.style, columnHeaderProps.style);

        var rest = _extends({}, theadThProps.rest, columnHeaderProps.rest);

        var isResizable = _utils2.default.getFirstDefined(column.resizable, resizable, false);
        var resizer = isResizable ? _react2.default.createElement(ResizerComponent, _extends({
          onMouseDown: function onMouseDown(e) {
            return _this2.resizeColumnStart(e, column, false);
          },
          onTouchStart: function onTouchStart(e) {
            return _this2.resizeColumnStart(e, column, true);
          }
        }, getResizerProps('finalState', undefined, column, _this2))) : null;

        var isSortable = _utils2.default.getFirstDefined(column.sortable, sortable, false);

        return _react2.default.createElement(
          ThComponent,
          _extends({
            key: i + '-' + column.id,
            className: (0, _classnames2.default)(classes, isResizable && 'rt-resizable-header', sort ? sort.desc ? '-sort-desc' : '-sort-asc' : '', isSortable && '-cursor-pointer', !show && '-hidden', pivotBy && pivotBy.slice(0, -1).includes(column.id) && 'rt-header-pivot'),
            style: _extends({}, styles, {
              flex: width + ' 0 auto',
              width: _utils2.default.asPx(width),
              maxWidth: _utils2.default.asPx(maxWidth)
            }),
            toggleSort: function toggleSort(e) {
              if (isSortable) _this2.sortColumn(column, multiSort ? e.shiftKey : false);
            }
          }, rest),
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(isResizable && 'rt-resizable-header-content') },
            _utils2.default.normalizeComponent(column.Header, {
              data: sortedData,
              column: column
            })
          ),
          resizer
        );
      };

      var makeHeaders = function makeHeaders() {
        var theadProps = _utils2.default.splitProps(getTheadProps(finalState, undefined, undefined, _this2));
        var theadTrProps = _utils2.default.splitProps(getTheadTrProps(finalState, undefined, undefined, _this2));
        return _react2.default.createElement(
          TheadComponent,
          _extends({
            className: (0, _classnames2.default)('-header', theadProps.className),
            style: _extends({}, theadProps.style, {
              minWidth: rowMinWidth + 'px'
            })
          }, theadProps.rest),
          _react2.default.createElement(
            TrComponent,
            _extends({
              className: theadTrProps.className,
              style: theadTrProps.style
            }, theadTrProps.rest),
            allVisibleColumns.map(makeHeader)
          )
        );
      };

      var makeFilter = function makeFilter(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var theadFilterThProps = _utils2.default.splitProps(getTheadFilterThProps(finalState, undefined, column, _this2));
        var columnHeaderProps = _utils2.default.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadFilterThProps.className, columnHeaderProps.className];

        var styles = _extends({}, column.headerStyle, theadFilterThProps.style, columnHeaderProps.style);

        var rest = _extends({}, theadFilterThProps.rest, columnHeaderProps.rest);

        var filter = filtered.find(function (filter) {
          return filter.id === column.id;
        });

        var ResolvedFilterComponent = column.Filter || FilterComponent;

        var isFilterable = _utils2.default.getFirstDefined(column.filterable, filterable, false);

        return _react2.default.createElement(
          ThComponent,
          _extends({
            key: i + '-' + column.id,
            className: (0, _classnames2.default)(classes),
            style: _extends({}, styles, {
              flex: width + ' 0 auto',
              width: _utils2.default.asPx(width),
              maxWidth: _utils2.default.asPx(maxWidth)
            })
          }, rest),
          isFilterable ? _utils2.default.normalizeComponent(ResolvedFilterComponent, {
            column: column,
            filter: filter,
            onChange: function onChange(value) {
              return _this2.filterColumn(column, value);
            }
          }, _defaultProps2.default.column.Filter) : null
        );
      };

      var makeFilters = function makeFilters() {
        var theadFilterProps = _utils2.default.splitProps(getTheadFilterProps(finalState, undefined, undefined, _this2));
        var theadFilterTrProps = _utils2.default.splitProps(getTheadFilterTrProps(finalState, undefined, undefined, _this2));
        return _react2.default.createElement(
          TheadComponent,
          _extends({
            className: (0, _classnames2.default)('-filters', theadFilterProps.className),
            style: _extends({}, theadFilterProps.style, {
              minWidth: rowMinWidth + 'px'
            })
          }, theadFilterProps.rest),
          _react2.default.createElement(
            TrComponent,
            _extends({
              className: theadFilterTrProps.className,
              style: theadFilterTrProps.style
            }, theadFilterTrProps.rest),
            allVisibleColumns.map(makeFilter)
          )
        );
      };

      var makePageRow = function makePageRow(row, i) {
        var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        var rowInfo = {
          original: row[originalKey],
          row: row,
          index: row[indexKey],
          viewIndex: rowIndex += 1,
          pageSize: pageSize,
          page: page,
          level: path.length,
          nestingPath: path.concat([i]),
          aggregated: row[aggregatedKey],
          groupedByPivot: row[groupedByPivotKey],
          subRows: row[subRowsKey]
        };
        var isExpanded = _utils2.default.get(expanded, rowInfo.nestingPath);
        var trGroupProps = getTrGroupProps(finalState, rowInfo, undefined, _this2);
        var trProps = _utils2.default.splitProps(getTrProps(finalState, rowInfo, undefined, _this2));
        return _react2.default.createElement(
          TrGroupComponent,
          _extends({ key: rowInfo.nestingPath.join('_') }, trGroupProps),
          _react2.default.createElement(
            TrComponent,
            _extends({
              className: (0, _classnames2.default)(trProps.className, row._viewIndex % 2 ? '-even' : '-odd'),
              style: trProps.style
            }, trProps.rest),
            allVisibleColumns.map(function (column, i2) {
              var resizedCol = resized.find(function (x) {
                return x.id === column.id;
              }) || {};
              var show = typeof column.show === 'function' ? column.show() : column.show;
              var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
              var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
              var tdProps = _utils2.default.splitProps(getTdProps(finalState, rowInfo, column, _this2));
              var columnProps = _utils2.default.splitProps(column.getProps(finalState, rowInfo, column, _this2));

              var classes = [tdProps.className, column.className, columnProps.className];

              var styles = _extends({}, tdProps.style, column.style, columnProps.style);

              var cellInfo = _extends({}, rowInfo, {
                isExpanded: isExpanded,
                column: _extends({}, column),
                value: rowInfo.row[column.id],
                pivoted: column.pivoted,
                expander: column.expander,
                resized: resized,
                show: show,
                width: width,
                maxWidth: maxWidth,
                tdProps: tdProps,
                columnProps: columnProps,
                classes: classes,
                styles: styles
              });

              var value = cellInfo.value;

              var useOnExpanderClick = void 0;
              var isBranch = void 0;
              var isPreview = void 0;

              var onExpanderClick = function onExpanderClick(e) {
                var newExpanded = _utils2.default.clone(expanded);
                if (isExpanded) {
                  newExpanded = _utils2.default.set(newExpanded, cellInfo.nestingPath, false);
                } else {
                  newExpanded = _utils2.default.set(newExpanded, cellInfo.nestingPath, {});
                }

                return _this2.setStateWithData({
                  expanded: newExpanded
                }, function () {
                  return onExpandedChange && onExpandedChange(newExpanded, cellInfo.nestingPath, e);
                });
              };

              // Default to a standard cell
              var resolvedCell = _utils2.default.normalizeComponent(column.Cell, cellInfo, value);

              // Resolve Renderers
              var ResolvedAggregatedComponent = column.Aggregated || (!column.aggregate ? AggregatedComponent : column.Cell);
              var ResolvedExpanderComponent = column.Expander || ExpanderComponent;
              var ResolvedPivotValueComponent = column.PivotValue || PivotValueComponent;
              var DefaultResolvedPivotComponent = PivotComponent || function (props) {
                return _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(ResolvedExpanderComponent, props),
                  _react2.default.createElement(ResolvedPivotValueComponent, props)
                );
              };
              var ResolvedPivotComponent = column.Pivot || DefaultResolvedPivotComponent;

              // Is this cell expandable?
              if (cellInfo.pivoted || cellInfo.expander) {
                // Make it expandable by defualt
                cellInfo.expandable = true;
                useOnExpanderClick = true;
                // If pivoted, has no subRows, and does not have a subComponent,
                // do not make expandable
                if (cellInfo.pivoted && !cellInfo.subRows && !SubComponent) {
                  cellInfo.expandable = false;
                }
              }

              if (cellInfo.pivoted) {
                // Is this column a branch?
                isBranch = rowInfo.row[pivotIDKey] === column.id && cellInfo.subRows;
                // Should this column be blank?
                isPreview = pivotBy.indexOf(column.id) > pivotBy.indexOf(rowInfo.row[pivotIDKey]) && cellInfo.subRows;
                // Pivot Cell Render Override
                if (isBranch) {
                  // isPivot
                  resolvedCell = _utils2.default.normalizeComponent(ResolvedPivotComponent, _extends({}, cellInfo, {
                    value: row[pivotValKey]
                  }), row[pivotValKey]);
                } else if (isPreview) {
                  // Show the pivot preview
                  resolvedCell = _utils2.default.normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
                } else {
                  resolvedCell = null;
                }
              } else if (cellInfo.aggregated) {
                resolvedCell = _utils2.default.normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
              }

              if (cellInfo.expander) {
                resolvedCell = _utils2.default.normalizeComponent(ResolvedExpanderComponent, cellInfo, row[pivotValKey]);
                if (pivotBy) {
                  if (cellInfo.groupedByPivot) {
                    resolvedCell = null;
                  }
                  if (!cellInfo.subRows && !SubComponent) {
                    resolvedCell = null;
                  }
                }
              }

              var resolvedOnExpanderClick = useOnExpanderClick ? onExpanderClick : function () {};

              // If there are multiple onClick events, make sure they don't
              // override eachother. This should maybe be expanded to handle all
              // function attributes
              var interactionProps = {
                onClick: resolvedOnExpanderClick
              };

              if (tdProps.rest.onClick) {
                interactionProps.onClick = function (e) {
                  tdProps.rest.onClick(e, function () {
                    return resolvedOnExpanderClick(e);
                  });
                };
              }

              if (columnProps.rest.onClick) {
                interactionProps.onClick = function (e) {
                  columnProps.rest.onClick(e, function () {
                    return resolvedOnExpanderClick(e);
                  });
                };
              }

              // Return the cell
              return _react2.default.createElement(
                TdComponent
                // eslint-disable-next-line react/no-array-index-key
                ,
                _extends({ key: i2 + '-' + column.id,
                  className: (0, _classnames2.default)(classes, !show && 'hidden', cellInfo.expandable && 'rt-expandable', (isBranch || isPreview) && 'rt-pivot'),
                  style: _extends({}, styles, {
                    flex: width + ' 0 auto',
                    width: _utils2.default.asPx(width),
                    maxWidth: _utils2.default.asPx(maxWidth)
                  })
                }, tdProps.rest, columnProps.rest, interactionProps),
                resolvedCell
              );
            })
          ),
          rowInfo.subRows && isExpanded && rowInfo.subRows.map(function (d, i) {
            return makePageRow(d, i, rowInfo.nestingPath);
          }),
          SubComponent && !rowInfo.subRows && isExpanded && SubComponent(rowInfo)
        );
      };

      var makePadColumn = function makePadColumn(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var show = typeof column.show === 'function' ? column.show() : column.show;
        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var flex = width;
        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var tdProps = _utils2.default.splitProps(getTdProps(finalState, undefined, column, _this2));
        var columnProps = _utils2.default.splitProps(column.getProps(finalState, undefined, column, _this2));

        var classes = [tdProps.className, column.className, columnProps.className];

        var styles = _extends({}, tdProps.style, column.style, columnProps.style);

        return _react2.default.createElement(
          TdComponent,
          _extends({
            key: i + '-' + column.id,
            className: (0, _classnames2.default)(classes, !show && 'hidden'),
            style: _extends({}, styles, {
              flex: flex + ' 0 auto',
              width: _utils2.default.asPx(width),
              maxWidth: _utils2.default.asPx(maxWidth)
            })
          }, tdProps.rest),
          _utils2.default.normalizeComponent(PadRowComponent)
        );
      };

      var makePadRow = function makePadRow(row, i) {
        var trGroupProps = getTrGroupProps(finalState, undefined, undefined, _this2);
        var trProps = _utils2.default.splitProps(getTrProps(finalState, undefined, undefined, _this2));
        return _react2.default.createElement(
          TrGroupComponent,
          _extends({ key: i }, trGroupProps),
          _react2.default.createElement(
            TrComponent,
            {
              className: (0, _classnames2.default)('-padRow', (pageRows.length + i) % 2 ? '-even' : '-odd', trProps.className),
              style: trProps.style || {}
            },
            allVisibleColumns.map(makePadColumn)
          )
        );
      };

      var makeColumnFooter = function makeColumnFooter(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var show = typeof column.show === 'function' ? column.show() : column.show;
        var width = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var maxWidth = _utils2.default.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var tFootTdProps = _utils2.default.splitProps(getTfootTdProps(finalState, undefined, undefined, _this2));
        var columnProps = _utils2.default.splitProps(column.getProps(finalState, undefined, column, _this2));
        var columnFooterProps = _utils2.default.splitProps(column.getFooterProps(finalState, undefined, column, _this2));

        var classes = [tFootTdProps.className, column.className, columnProps.className, columnFooterProps.className];

        var styles = _extends({}, tFootTdProps.style, column.style, columnProps.style, columnFooterProps.style);

        return _react2.default.createElement(
          TdComponent,
          _extends({
            key: i + '-' + column.id,
            className: (0, _classnames2.default)(classes, !show && 'hidden'),
            style: _extends({}, styles, {
              flex: width + ' 0 auto',
              width: _utils2.default.asPx(width),
              maxWidth: _utils2.default.asPx(maxWidth)
            })
          }, columnProps.rest, tFootTdProps.rest, columnFooterProps.rest),
          _utils2.default.normalizeComponent(column.Footer, {
            data: sortedData,
            column: column
          })
        );
      };

      var makeColumnFooters = function makeColumnFooters() {
        var tFootProps = getTfootProps(finalState, undefined, undefined, _this2);
        var tFootTrProps = _utils2.default.splitProps(getTfootTrProps(finalState, undefined, undefined, _this2));
        return _react2.default.createElement(
          TfootComponent,
          _extends({
            className: tFootProps.className,
            style: _extends({}, tFootProps.style, {
              minWidth: rowMinWidth + 'px'
            })
          }, tFootProps.rest),
          _react2.default.createElement(
            TrComponent,
            _extends({
              className: (0, _classnames2.default)(tFootTrProps.className),
              style: tFootTrProps.style
            }, tFootTrProps.rest),
            allVisibleColumns.map(makeColumnFooter)
          )
        );
      };

      var makePagination = function makePagination() {
        var paginationProps = _utils2.default.splitProps(getPaginationProps(finalState, undefined, undefined, _this2));
        return _react2.default.createElement(PaginationComponent, _extends({}, resolvedState, {
          pages: pages,
          canPrevious: canPrevious,
          canNext: canNext,
          onPageChange: _this2.onPageChange,
          onPageSizeChange: _this2.onPageSizeChange,
          className: paginationProps.className,
          style: paginationProps.style
        }, paginationProps.rest));
      };

      var makeTable = function makeTable() {
        var pagination = makePagination();
        return _react2.default.createElement(
          'div',
          _extends({
            className: (0, _classnames2.default)('ReactTable', className, rootProps.className),
            style: _extends({}, style, rootProps.style)
          }, rootProps.rest),
          showPagination && showPaginationTop ? _react2.default.createElement(
            'div',
            { className: 'pagination-top' },
            pagination
          ) : null,
          _react2.default.createElement(
            TableComponent,
            _extends({
              className: (0, _classnames2.default)(tableProps.className, currentlyResizing ? 'rt-resizing' : ''),
              style: tableProps.style
            }, tableProps.rest),
            hasHeaderGroups ? makeHeaderGroups() : null,
            makeHeaders(),
            hasFilters ? makeFilters() : null,
            _react2.default.createElement(
              TbodyComponent,
              _extends({
                className: (0, _classnames2.default)(tBodyProps.className),
                style: _extends({}, tBodyProps.style, {
                  minWidth: rowMinWidth + 'px'
                })
              }, tBodyProps.rest),
              pageRows.map(function (d, i) {
                return makePageRow(d, i);
              }),
              padRows.map(makePadRow)
            ),
            hasColumnFooter ? makeColumnFooters() : null
          ),
          showPagination && showPaginationBottom ? _react2.default.createElement(
            'div',
            { className: 'pagination-bottom' },
            pagination
          ) : null,
          !pageRows.length && _react2.default.createElement(
            NoDataComponent,
            noDataProps,
            _utils2.default.normalizeComponent(noDataText)
          ),
          _react2.default.createElement(LoadingComponent, _extends({
            loading: loading,
            loadingText: loadingText
          }, loadingProps))
        );
      };

      // childProps are optionally passed to a function-as-a-child
      return children ? children(finalState, makeTable, this) : makeTable();
    }
  }]);

  return ReactTable;
}((0, _methods2.default)((0, _lifecycle2.default)(_react.Component)));

ReactTable.propTypes = _propTypes2.default;
ReactTable.defaultProps = _defaultProps2.default;
exports.default = ReactTable;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Base) {
  return function (_Base) {
    _inherits(_class, _Base);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.setStateWithData(this.getDataModel(this.getResolvedState()));
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.fireFetchData();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextState) {
        var oldState = this.getResolvedState();
        var newState = this.getResolvedState(nextProps, nextState);

        // Do a deep compare of new and old `defaultOption` and
        // if they are different reset `option = defaultOption`
        var defaultableOptions = ['sorted', 'filtered', 'resized', 'expanded'];
        defaultableOptions.forEach(function (x) {
          var defaultName = 'default' + (x.charAt(0).toUpperCase() + x.slice(1));
          if (JSON.stringify(oldState[defaultName]) !== JSON.stringify(newState[defaultName])) {
            newState[x] = newState[defaultName];
          }
        });

        // If they change these table options, we need to reset defaults
        // or else we could get into a state where the user has changed the UI
        // and then disabled the ability to change it back.
        // e.g. If `filterable` has changed, set `filtered = defaultFiltered`
        var resettableOptions = ['sortable', 'filterable', 'resizable'];
        resettableOptions.forEach(function (x) {
          if (oldState[x] !== newState[x]) {
            var baseName = x.replace('able', '');
            var optionName = baseName + 'ed';
            var defaultName = 'default' + (optionName.charAt(0).toUpperCase() + optionName.slice(1));
            newState[optionName] = newState[defaultName];
          }
        });

        // Props that trigger a data update
        if (oldState.data !== newState.data || oldState.columns !== newState.columns || oldState.pivotBy !== newState.pivotBy || oldState.sorted !== newState.sorted || oldState.filtered !== newState.filtered) {
          this.setStateWithData(this.getDataModel(newState));
        }
      }
    }, {
      key: 'setStateWithData',
      value: function setStateWithData(newState, cb) {
        var _this2 = this;

        var oldState = this.getResolvedState();
        var newResolvedState = this.getResolvedState({}, newState);
        var freezeWhenExpanded = newResolvedState.freezeWhenExpanded;

        // Default to unfrozen state

        newResolvedState.frozen = false;

        // If freezeWhenExpanded is set, check for frozen conditions
        if (freezeWhenExpanded) {
          // if any rows are expanded, freeze the existing data and sorting
          var keys = Object.keys(newResolvedState.expanded);
          for (var i = 0; i < keys.length; i += 1) {
            if (newResolvedState.expanded[keys[i]]) {
              newResolvedState.frozen = true;
              break;
            }
          }
        }

        // If the data isn't frozen and either the data or
        // sorting model has changed, update the data
        if (oldState.frozen && !newResolvedState.frozen || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData) {
          // Handle collapseOnsortedChange & collapseOnDataChange
          if (oldState.sorted !== newResolvedState.sorted && this.props.collapseOnSortingChange || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || oldState.sortedData && !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData && this.props.collapseOnDataChange) {
            newResolvedState.expanded = {};
          }

          Object.assign(newResolvedState, this.getSortedData(newResolvedState));
        }

        // Set page to 0 if filters change
        if (oldState.filtered !== newResolvedState.filtered) {
          newResolvedState.page = 0;
        }

        // Calculate pageSize all the time
        if (newResolvedState.sortedData) {
          newResolvedState.pages = newResolvedState.manual ? newResolvedState.pages : Math.ceil(newResolvedState.sortedData.length / newResolvedState.pageSize);
          newResolvedState.page = Math.max(newResolvedState.page >= newResolvedState.pages ? newResolvedState.pages - 1 : newResolvedState.page, 0);
        }

        return this.setState(newResolvedState, function () {
          if (cb) {
            cb();
          }
          if (oldState.page !== newResolvedState.page || oldState.pageSize !== newResolvedState.pageSize || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered) {
            _this2.fireFetchData();
          }
        });
      }
    }]);

    return _class;
  }(Base);
};
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(76);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Base) {
  return function (_Base) {
    _inherits(_class, _Base);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'getResolvedState',
      value: function getResolvedState(props, state) {
        var resolvedState = _extends({}, _utils2.default.compactObject(this.state), _utils2.default.compactObject(this.props), _utils2.default.compactObject(state), _utils2.default.compactObject(props));
        return resolvedState;
      }
    }, {
      key: 'getDataModel',
      value: function getDataModel(newState) {
        var _this2 = this;

        var columns = newState.columns,
            _newState$pivotBy = newState.pivotBy,
            pivotBy = _newState$pivotBy === undefined ? [] : _newState$pivotBy,
            data = newState.data,
            pivotIDKey = newState.pivotIDKey,
            pivotValKey = newState.pivotValKey,
            subRowsKey = newState.subRowsKey,
            aggregatedKey = newState.aggregatedKey,
            nestingLevelKey = newState.nestingLevelKey,
            originalKey = newState.originalKey,
            indexKey = newState.indexKey,
            groupedByPivotKey = newState.groupedByPivotKey,
            SubComponent = newState.SubComponent;

        // Determine Header Groups

        var hasHeaderGroups = false;
        columns.forEach(function (column) {
          if (column.columns) {
            hasHeaderGroups = true;
          }
        });

        var columnsWithExpander = [].concat(_toConsumableArray(columns));

        var expanderColumn = columns.find(function (col) {
          return col.expander || col.columns && col.columns.some(function (col2) {
            return col2.expander;
          });
        });
        // The actual expander might be in the columns field of a group column
        if (expanderColumn && !expanderColumn.expander) {
          expanderColumn = expanderColumn.columns.find(function (col) {
            return col.expander;
          });
        }

        // If we have SubComponent's we need to make sure we have an expander column
        if (SubComponent && !expanderColumn) {
          expanderColumn = { expander: true };
          columnsWithExpander = [expanderColumn].concat(_toConsumableArray(columnsWithExpander));
        }

        var makeDecoratedColumn = function makeDecoratedColumn(column, parentColumn) {
          var dcol = void 0;
          if (column.expander) {
            dcol = _extends({}, _this2.props.column, _this2.props.expanderDefaults, column);
          } else {
            dcol = _extends({}, _this2.props.column, column);
          }

          // Ensure minWidth is not greater than maxWidth if set
          if (dcol.maxWidth < dcol.minWidth) {
            dcol.minWidth = dcol.maxWidth;
          }

          if (parentColumn) {
            dcol.parentColumn = parentColumn;
          }

          // First check for string accessor
          if (typeof dcol.accessor === 'string') {
            var _ret = function () {
              dcol.id = dcol.id || dcol.accessor;
              var accessorString = dcol.accessor;
              dcol.accessor = function (row) {
                return _utils2.default.get(row, accessorString);
              };
              return {
                v: dcol
              };
            }();

            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
          }

          // Fall back to functional accessor (but require an ID)
          if (dcol.accessor && !dcol.id) {
            console.warn(dcol);
            throw new Error('A column id is required if using a non-string accessor for column above.');
          }

          // Fall back to an undefined accessor
          if (!dcol.accessor) {
            dcol.accessor = function () {
              return undefined;
            };
          }

          return dcol;
        };

        var allDecoratedColumns = [];

        // Decorate the columns
        var decorateAndAddToAll = function decorateAndAddToAll(column, parentColumn) {
          var decoratedColumn = makeDecoratedColumn(column, parentColumn);
          allDecoratedColumns.push(decoratedColumn);
          return decoratedColumn;
        };

        var decoratedColumns = columnsWithExpander.map(function (column) {
          if (column.columns) {
            return _extends({}, column, {
              columns: column.columns.map(function (d) {
                return decorateAndAddToAll(d, column);
              })
            });
          }
          return decorateAndAddToAll(column);
        });

        // Build the visible columns, headers and flat column list
        var visibleColumns = decoratedColumns.slice();
        var allVisibleColumns = [];

        visibleColumns = visibleColumns.map(function (column) {
          if (column.columns) {
            var visibleSubColumns = column.columns.filter(function (d) {
              return pivotBy.indexOf(d.id) > -1 ? false : _utils2.default.getFirstDefined(d.show, true);
            });
            return _extends({}, column, {
              columns: visibleSubColumns
            });
          }
          return column;
        });

        visibleColumns = visibleColumns.filter(function (column) {
          return column.columns ? column.columns.length : pivotBy.indexOf(column.id) > -1 ? false : _utils2.default.getFirstDefined(column.show, true);
        });

        // Find any custom pivot location
        var pivotIndex = visibleColumns.findIndex(function (col) {
          return col.pivot;
        });

        // Handle Pivot Columns
        if (pivotBy.length) {
          (function () {
            // Retrieve the pivot columns in the correct pivot order
            var pivotColumns = [];
            pivotBy.forEach(function (pivotID) {
              var found = allDecoratedColumns.find(function (d) {
                return d.id === pivotID;
              });
              if (found) {
                pivotColumns.push(found);
              }
            });

            var PivotParentColumn = pivotColumns.reduce(function (prev, current) {
              return prev && prev === current.parentColumn && current.parentColumn;
            }, pivotColumns[0].parentColumn);

            var PivotGroupHeader = hasHeaderGroups && PivotParentColumn.Header;
            PivotGroupHeader = PivotGroupHeader || function () {
              return _react2.default.createElement(
                'strong',
                null,
                'Pivoted'
              );
            };

            var pivotColumnGroup = {
              Header: PivotGroupHeader,
              columns: pivotColumns.map(function (col) {
                return _extends({}, _this2.props.pivotDefaults, col, {
                  pivoted: true
                });
              })
            };

            // Place the pivotColumns back into the visibleColumns
            if (pivotIndex >= 0) {
              pivotColumnGroup = _extends({}, visibleColumns[pivotIndex], pivotColumnGroup);
              visibleColumns.splice(pivotIndex, 1, pivotColumnGroup);
            } else {
              visibleColumns.unshift(pivotColumnGroup);
            }
          })();
        }

        // Build Header Groups
        var headerGroups = [];
        var currentSpan = [];

        // A convenience function to add a header and reset the currentSpan
        var addHeader = function addHeader(columns, column) {
          headerGroups.push(_extends({}, _this2.props.column, column, {
            columns: columns
          }));
          currentSpan = [];
        };

        // Build flast list of allVisibleColumns and HeaderGroups
        visibleColumns.forEach(function (column) {
          if (column.columns) {
            allVisibleColumns = allVisibleColumns.concat(column.columns);
            if (currentSpan.length > 0) {
              addHeader(currentSpan);
            }
            addHeader(column.columns, column);
            return;
          }
          allVisibleColumns.push(column);
          currentSpan.push(column);
        });
        if (hasHeaderGroups && currentSpan.length > 0) {
          addHeader(currentSpan);
        }

        // Access the data
        var accessRow = function accessRow(d, i) {
          var _row;

          var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

          var row = (_row = {}, _defineProperty(_row, originalKey, d), _defineProperty(_row, indexKey, i), _defineProperty(_row, subRowsKey, d[subRowsKey]), _defineProperty(_row, nestingLevelKey, level), _row);
          allDecoratedColumns.forEach(function (column) {
            if (column.expander) return;
            row[column.id] = column.accessor(d);
          });
          if (row[subRowsKey]) {
            row[subRowsKey] = row[subRowsKey].map(function (d, i) {
              return accessRow(d, i, level + 1);
            });
          }
          return row;
        };
        var resolvedData = data.map(function (d, i) {
          return accessRow(d, i);
        });

        // TODO: Make it possible to fabricate nested rows without pivoting
        var aggregatingColumns = allVisibleColumns.filter(function (d) {
          return !d.expander && d.aggregate;
        });

        // If pivoting, recursively group the data
        var aggregate = function aggregate(rows) {
          var aggregationValues = {};
          aggregatingColumns.forEach(function (column) {
            var values = rows.map(function (d) {
              return d[column.id];
            });
            aggregationValues[column.id] = column.aggregate(values, rows);
          });
          return aggregationValues;
        };
        if (pivotBy.length) {
          (function () {
            var groupRecursively = function groupRecursively(rows, keys) {
              var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

              // This is the last level, just return the rows
              if (i === keys.length) {
                return rows;
              }
              // Group the rows together for this level
              var groupedRows = Object.entries(_utils2.default.groupBy(rows, keys[i])).map(function (_ref) {
                var _ref3;

                var _ref2 = _slicedToArray(_ref, 2),
                    key = _ref2[0],
                    value = _ref2[1];

                return _ref3 = {}, _defineProperty(_ref3, pivotIDKey, keys[i]), _defineProperty(_ref3, pivotValKey, key), _defineProperty(_ref3, keys[i], key), _defineProperty(_ref3, subRowsKey, value), _defineProperty(_ref3, nestingLevelKey, i), _defineProperty(_ref3, groupedByPivotKey, true), _ref3;
              });
              // Recurse into the subRows
              groupedRows = groupedRows.map(function (rowGroup) {
                var _extends2;

                var subRows = groupRecursively(rowGroup[subRowsKey], keys, i + 1);
                return _extends({}, rowGroup, (_extends2 = {}, _defineProperty(_extends2, subRowsKey, subRows), _defineProperty(_extends2, aggregatedKey, true), _extends2), aggregate(subRows));
              });
              return groupedRows;
            };
            resolvedData = groupRecursively(resolvedData, pivotBy);
          })();
        }

        return _extends({}, newState, {
          resolvedData: resolvedData,
          allVisibleColumns: allVisibleColumns,
          headerGroups: headerGroups,
          allDecoratedColumns: allDecoratedColumns,
          hasHeaderGroups: hasHeaderGroups
        });
      }
    }, {
      key: 'getSortedData',
      value: function getSortedData(resolvedState) {
        var manual = resolvedState.manual,
            sorted = resolvedState.sorted,
            filtered = resolvedState.filtered,
            defaultFilterMethod = resolvedState.defaultFilterMethod,
            resolvedData = resolvedState.resolvedData,
            allVisibleColumns = resolvedState.allVisibleColumns,
            allDecoratedColumns = resolvedState.allDecoratedColumns;


        var sortMethodsByColumnID = {};

        allDecoratedColumns.filter(function (col) {
          return col.sortMethod;
        }).forEach(function (col) {
          sortMethodsByColumnID[col.id] = col.sortMethod;
        });

        // Resolve the data from either manual data or sorted data
        return {
          sortedData: manual ? resolvedData : this.sortData(this.filterData(resolvedData, filtered, defaultFilterMethod, allVisibleColumns), sorted, sortMethodsByColumnID)
        };
      }
    }, {
      key: 'fireFetchData',
      value: function fireFetchData() {
        this.props.onFetchData(this.getResolvedState(), this);
      }
    }, {
      key: 'getPropOrState',
      value: function getPropOrState(key) {
        return _utils2.default.getFirstDefined(this.props[key], this.state[key]);
      }
    }, {
      key: 'getStateOrProp',
      value: function getStateOrProp(key) {
        return _utils2.default.getFirstDefined(this.state[key], this.props[key]);
      }
    }, {
      key: 'filterData',
      value: function filterData(data, filtered, defaultFilterMethod, allVisibleColumns) {
        var _this3 = this;

        var filteredData = data;

        if (filtered.length) {
          filteredData = filtered.reduce(function (filteredSoFar, nextFilter) {
            var column = allVisibleColumns.find(function (x) {
              return x.id === nextFilter.id;
            });

            // Don't filter hidden columns or columns that have had their filters disabled
            if (!column || column.filterable === false) {
              return filteredSoFar;
            }

            var filterMethod = column.filterMethod || defaultFilterMethod;

            // If 'filterAll' is set to true, pass the entire dataset to the filter method
            if (column.filterAll) {
              return filterMethod(nextFilter, filteredSoFar, column);
            }
            return filteredSoFar.filter(function (row) {
              return filterMethod(nextFilter, row, column);
            });
          }, filteredData);

          // Apply the filter to the subrows if we are pivoting, and then
          // filter any rows without subcolumns because it would be strange to show
          filteredData = filteredData.map(function (row) {
            if (!row[_this3.props.subRowsKey]) {
              return row;
            }
            return _extends({}, row, _defineProperty({}, _this3.props.subRowsKey, _this3.filterData(row[_this3.props.subRowsKey], filtered, defaultFilterMethod, allVisibleColumns)));
          }).filter(function (row) {
            if (!row[_this3.props.subRowsKey]) {
              return true;
            }
            return row[_this3.props.subRowsKey].length > 0;
          });
        }

        return filteredData;
      }
    }, {
      key: 'sortData',
      value: function sortData(data, sorted) {
        var _this4 = this;

        var sortMethodsByColumnID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        if (!sorted.length) {
          return data;
        }

        var sortedData = (this.props.orderByMethod || _utils2.default.orderBy)(data, sorted.map(function (sort) {
          // Support custom sorting methods for each column
          if (sortMethodsByColumnID[sort.id]) {
            return function (a, b) {
              return sortMethodsByColumnID[sort.id](a[sort.id], b[sort.id], sort.desc);
            };
          }
          return function (a, b) {
            return _this4.props.defaultSortMethod(a[sort.id], b[sort.id], sort.desc);
          };
        }), sorted.map(function (d) {
          return !d.desc;
        }), this.props.indexKey);

        sortedData.forEach(function (row) {
          if (!row[_this4.props.subRowsKey]) {
            return;
          }
          row[_this4.props.subRowsKey] = _this4.sortData(row[_this4.props.subRowsKey], sorted, sortMethodsByColumnID);
        });

        return sortedData;
      }
    }, {
      key: 'getMinRows',
      value: function getMinRows() {
        return _utils2.default.getFirstDefined(this.props.minRows, this.getStateOrProp('pageSize'));
      }

      // User actions

    }, {
      key: 'onPageChange',
      value: function onPageChange(page) {
        var _props = this.props,
            onPageChange = _props.onPageChange,
            collapseOnPageChange = _props.collapseOnPageChange;


        var newState = { page: page };
        if (collapseOnPageChange) {
          newState.expanded = {};
        }
        this.setStateWithData(newState, function () {
          return onPageChange && onPageChange(page);
        });
      }
    }, {
      key: 'onPageSizeChange',
      value: function onPageSizeChange(newPageSize) {
        var onPageSizeChange = this.props.onPageSizeChange;

        var _getResolvedState = this.getResolvedState(),
            pageSize = _getResolvedState.pageSize,
            page = _getResolvedState.page;

        // Normalize the page to display


        var currentRow = pageSize * page;
        var newPage = Math.floor(currentRow / newPageSize);

        this.setStateWithData({
          pageSize: newPageSize,
          page: newPage
        }, function () {
          return onPageSizeChange && onPageSizeChange(newPageSize, newPage);
        });
      }
    }, {
      key: 'sortColumn',
      value: function sortColumn(column, additive) {
        var _getResolvedState2 = this.getResolvedState(),
            sorted = _getResolvedState2.sorted,
            skipNextSort = _getResolvedState2.skipNextSort,
            defaultSortDesc = _getResolvedState2.defaultSortDesc;

        var firstSortDirection = Object.prototype.hasOwnProperty.call(column, 'defaultSortDesc') ? column.defaultSortDesc : defaultSortDesc;
        var secondSortDirection = !firstSortDirection;

        // we can't stop event propagation from the column resize move handlers
        // attached to the document because of react's synthetic events
        // so we have to prevent the sort function from actually sorting
        // if we click on the column resize element within a header.
        if (skipNextSort) {
          this.setStateWithData({
            skipNextSort: false
          });
          return;
        }

        var onSortedChange = this.props.onSortedChange;


        var newSorted = _utils2.default.clone(sorted || []).map(function (d) {
          d.desc = _utils2.default.isSortingDesc(d);
          return d;
        });
        if (!_utils2.default.isArray(column)) {
          // Single-Sort
          var existingIndex = newSorted.findIndex(function (d) {
            return d.id === column.id;
          });
          if (existingIndex > -1) {
            var existing = newSorted[existingIndex];
            if (existing.desc === secondSortDirection) {
              if (additive) {
                newSorted.splice(existingIndex, 1);
              } else {
                existing.desc = firstSortDirection;
                newSorted = [existing];
              }
            } else {
              existing.desc = secondSortDirection;
              if (!additive) {
                newSorted = [existing];
              }
            }
          } else if (additive) {
            newSorted.push({
              id: column.id,
              desc: firstSortDirection
            });
          } else {
            newSorted = [{
              id: column.id,
              desc: firstSortDirection
            }];
          }
        } else {
          (function () {
            // Multi-Sort
            var existingIndex = newSorted.findIndex(function (d) {
              return d.id === column[0].id;
            });
            // Existing Sorted Column
            if (existingIndex > -1) {
              var _existing = newSorted[existingIndex];
              if (_existing.desc === secondSortDirection) {
                if (additive) {
                  newSorted.splice(existingIndex, column.length);
                } else {
                  column.forEach(function (d, i) {
                    newSorted[existingIndex + i].desc = firstSortDirection;
                  });
                }
              } else {
                column.forEach(function (d, i) {
                  newSorted[existingIndex + i].desc = secondSortDirection;
                });
              }
              if (!additive) {
                newSorted = newSorted.slice(existingIndex, column.length);
              }
              // New Sort Column
            } else if (additive) {
              newSorted = newSorted.concat(column.map(function (d) {
                return {
                  id: d.id,
                  desc: firstSortDirection
                };
              }));
            } else {
              newSorted = column.map(function (d) {
                return {
                  id: d.id,
                  desc: firstSortDirection
                };
              });
            }
          })();
        }

        this.setStateWithData({
          page: !sorted.length && newSorted.length || !additive ? 0 : this.state.page,
          sorted: newSorted
        }, function () {
          return onSortedChange && onSortedChange(newSorted, column, additive);
        });
      }
    }, {
      key: 'filterColumn',
      value: function filterColumn(column, value) {
        var _getResolvedState3 = this.getResolvedState(),
            filtered = _getResolvedState3.filtered;

        var onFilteredChange = this.props.onFilteredChange;

        // Remove old filter first if it exists

        var newFiltering = (filtered || []).filter(function (x) {
          return x.id !== column.id;
        });

        if (value !== '') {
          newFiltering.push({
            id: column.id,
            value: value
          });
        }

        this.setStateWithData({
          filtered: newFiltering
        }, function () {
          return onFilteredChange && onFilteredChange(newFiltering, column, value);
        });
      }
    }, {
      key: 'resizeColumnStart',
      value: function resizeColumnStart(event, column, isTouch) {
        var _this5 = this;

        event.stopPropagation();
        var parentWidth = event.target.parentElement.getBoundingClientRect().width;

        var pageX = void 0;
        if (isTouch) {
          pageX = event.changedTouches[0].pageX;
        } else {
          pageX = event.pageX;
        }

        this.trapEvents = true;
        this.setStateWithData({
          currentlyResizing: {
            id: column.id,
            startX: pageX,
            parentWidth: parentWidth
          }
        }, function () {
          if (isTouch) {
            document.addEventListener('touchmove', _this5.resizeColumnMoving);
            document.addEventListener('touchcancel', _this5.resizeColumnEnd);
            document.addEventListener('touchend', _this5.resizeColumnEnd);
          } else {
            document.addEventListener('mousemove', _this5.resizeColumnMoving);
            document.addEventListener('mouseup', _this5.resizeColumnEnd);
            document.addEventListener('mouseleave', _this5.resizeColumnEnd);
          }
        });
      }
    }, {
      key: 'resizeColumnMoving',
      value: function resizeColumnMoving(event) {
        event.stopPropagation();
        var onResizedChange = this.props.onResizedChange;

        var _getResolvedState4 = this.getResolvedState(),
            resized = _getResolvedState4.resized,
            currentlyResizing = _getResolvedState4.currentlyResizing;

        // Delete old value


        var newResized = resized.filter(function (x) {
          return x.id !== currentlyResizing.id;
        });

        var pageX = void 0;

        if (event.type === 'touchmove') {
          pageX = event.changedTouches[0].pageX;
        } else if (event.type === 'mousemove') {
          pageX = event.pageX;
        }

        // Set the min size to 10 to account for margin and border or else the
        // group headers don't line up correctly
        var newWidth = Math.max(currentlyResizing.parentWidth + pageX - currentlyResizing.startX, 11);

        newResized.push({
          id: currentlyResizing.id,
          value: newWidth
        });

        this.setStateWithData({
          resized: newResized
        }, function () {
          return onResizedChange && onResizedChange(newResized, event);
        });
      }
    }, {
      key: 'resizeColumnEnd',
      value: function resizeColumnEnd(event) {
        event.stopPropagation();
        var isTouch = event.type === 'touchend' || event.type === 'touchcancel';

        if (isTouch) {
          document.removeEventListener('touchmove', this.resizeColumnMoving);
          document.removeEventListener('touchcancel', this.resizeColumnEnd);
          document.removeEventListener('touchend', this.resizeColumnEnd);
        }

        // If its a touch event clear the mouse one's as well because sometimes
        // the mouseDown event gets called as well, but the mouseUp event doesn't
        document.removeEventListener('mousemove', this.resizeColumnMoving);
        document.removeEventListener('mouseup', this.resizeColumnEnd);
        document.removeEventListener('mouseleave', this.resizeColumnEnd);

        // The touch events don't propagate up to the sorting's onMouseDown event so
        // no need to prevent it from happening or else the first click after a touch
        // event resize will not sort the column.
        if (!isTouch) {
          this.setStateWithData({
            skipNextSort: true,
            currentlyResizing: false
          });
        }
      }
    }]);

    return _class;
  }(Base);
};
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = __webpack_require__(76);

var _utils2 = _interopRequireDefault(_utils);

var _pagination = __webpack_require__(250);

var _pagination2 = _interopRequireDefault(_pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
//


var emptyObj = function emptyObj() {
  return {};
};

exports.default = {
  // General
  data: [],
  loading: false,
  showPagination: true,
  showPaginationTop: false,
  showPaginationBottom: true,
  showPageSizeOptions: true,
  pageSizeOptions: [5, 10, 20, 25, 50, 100],
  defaultPageSize: 20,
  showPageJump: true,
  collapseOnSortingChange: true,
  collapseOnPageChange: true,
  collapseOnDataChange: true,
  freezeWhenExpanded: false,
  sortable: true,
  multiSort: true,
  resizable: true,
  filterable: false,
  defaultSortDesc: false,
  defaultSorted: [],
  defaultFiltered: [],
  defaultResized: [],
  defaultExpanded: {},
  // eslint-disable-next-line no-unused-vars
  defaultFilterMethod: function defaultFilterMethod(filter, row, column) {
    var id = filter.pivotId || filter.id;
    return row[id] !== undefined ? String(row[id]).startsWith(filter.value) : true;
  },
  // eslint-disable-next-line no-unused-vars
  defaultSortMethod: function defaultSortMethod(a, b, desc) {
    // force null and undefined to the bottom
    a = a === null || a === undefined ? '' : a;
    b = b === null || b === undefined ? '' : b;
    // force any string values to lowercase
    a = typeof a === 'string' ? a.toLowerCase() : a;
    b = typeof b === 'string' ? b.toLowerCase() : b;
    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or
    // the index as a tiebreaker
    return 0;
  },

  // Controlled State Props
  // page: undefined,
  // pageSize: undefined,
  // sorted: [],
  // filtered: [],
  // resized: [],
  // expanded: {},

  // Controlled State Callbacks
  onPageChange: undefined,
  onPageSizeChange: undefined,
  onSortedChange: undefined,
  onFilteredChange: undefined,
  onResizedChange: undefined,
  onExpandedChange: undefined,

  // Pivoting
  pivotBy: undefined,

  // Key Constants
  pivotValKey: '_pivotVal',
  pivotIDKey: '_pivotID',
  subRowsKey: '_subRows',
  aggregatedKey: '_aggregated',
  nestingLevelKey: '_nestingLevel',
  originalKey: '_original',
  indexKey: '_index',
  groupedByPivotKey: '_groupedByPivot',

  // Server-side Callbacks
  onFetchData: function onFetchData() {
    return null;
  },

  // Classes
  className: '',
  style: {},

  // Component decorators
  getProps: emptyObj,
  getTableProps: emptyObj,
  getTheadGroupProps: emptyObj,
  getTheadGroupTrProps: emptyObj,
  getTheadGroupThProps: emptyObj,
  getTheadProps: emptyObj,
  getTheadTrProps: emptyObj,
  getTheadThProps: emptyObj,
  getTheadFilterProps: emptyObj,
  getTheadFilterTrProps: emptyObj,
  getTheadFilterThProps: emptyObj,
  getTbodyProps: emptyObj,
  getTrGroupProps: emptyObj,
  getTrProps: emptyObj,
  getTdProps: emptyObj,
  getTfootProps: emptyObj,
  getTfootTrProps: emptyObj,
  getTfootTdProps: emptyObj,
  getPaginationProps: emptyObj,
  getLoadingProps: emptyObj,
  getNoDataProps: emptyObj,
  getResizerProps: emptyObj,

  // Global Column Defaults
  column: {
    // Renderers
    Cell: undefined,
    Header: undefined,
    Footer: undefined,
    Aggregated: undefined,
    Pivot: undefined,
    PivotValue: undefined,
    Expander: undefined,
    Filter: undefined,
    // All Columns
    sortable: undefined, // use table default
    resizable: undefined, // use table default
    filterable: undefined, // use table default
    show: true,
    minWidth: 100,
    // Cells only
    className: '',
    style: {},
    getProps: emptyObj,
    // Pivot only
    aggregate: undefined,
    // Headers only
    headerClassName: '',
    headerStyle: {},
    getHeaderProps: emptyObj,
    // Footers only
    footerClassName: '',
    footerStyle: {},
    getFooterProps: emptyObj,
    filterMethod: undefined,
    filterAll: false,
    sortMethod: undefined
  },

  // Global Expander Column Defaults
  expanderDefaults: {
    sortable: false,
    resizable: false,
    filterable: false,
    width: 35
  },

  pivotDefaults: {
    // extend the defaults for pivoted columns here
  },

  // Text
  previousText: 'Previous',
  nextText: 'Next',
  loadingText: 'Loading...',
  noDataText: 'No rows found',
  pageText: 'Page',
  ofText: 'of',
  rowsText: 'rows',

  // Components
  TableComponent: _utils2.default.makeTemplateComponent('rt-table', 'Table'),
  TheadComponent: _utils2.default.makeTemplateComponent('rt-thead', 'Thead'),
  TbodyComponent: _utils2.default.makeTemplateComponent('rt-tbody', 'Tbody'),
  TrGroupComponent: _utils2.default.makeTemplateComponent('rt-tr-group', 'TrGroup'),
  TrComponent: _utils2.default.makeTemplateComponent('rt-tr', 'Tr'),
  ThComponent: function ThComponent(_ref) {
    var toggleSort = _ref.toggleSort,
        className = _ref.className,
        children = _ref.children,
        rest = _objectWithoutProperties(_ref, ['toggleSort', 'className', 'children']);

    return _react2.default.createElement(
      'div',
      _extends({
        className: (0, _classnames2.default)('rt-th', className),
        onClick: function onClick(e) {
          return toggleSort && toggleSort(e);
        },
        role: 'heading'
      }, rest),
      children
    );
  },
  TdComponent: _utils2.default.makeTemplateComponent('rt-td', 'Td'),
  TfootComponent: _utils2.default.makeTemplateComponent('rt-tfoot', 'Tfoot'),
  FilterComponent: function FilterComponent(_ref2) {
    var filter = _ref2.filter,
        _onChange = _ref2.onChange;
    return _react2.default.createElement('input', {
      type: 'text',
      style: {
        width: '100%'
      },
      value: filter ? filter.value : '',
      onChange: function onChange(event) {
        return _onChange(event.target.value);
      }
    });
  },
  ExpanderComponent: function ExpanderComponent(_ref3) {
    var isExpanded = _ref3.isExpanded;
    return _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)('rt-expander', isExpanded && '-open') },
      '\u2022'
    );
  },
  PivotValueComponent: function PivotValueComponent(_ref4) {
    var subRows = _ref4.subRows,
        value = _ref4.value;
    return _react2.default.createElement(
      'span',
      null,
      value,
      ' ',
      subRows && '(' + subRows.length + ')'
    );
  },
  AggregatedComponent: function AggregatedComponent(_ref5) {
    var subRows = _ref5.subRows,
        column = _ref5.column;

    var previewValues = subRows.filter(function (d) {
      return typeof d[column.id] !== 'undefined';
    }).map(function (row, i) {
      return (
        // eslint-disable-next-line react/no-array-index-key
        _react2.default.createElement(
          'span',
          { key: i },
          row[column.id],
          i < subRows.length - 1 ? ', ' : ''
        )
      );
    });
    return _react2.default.createElement(
      'span',
      null,
      previewValues
    );
  },
  PivotComponent: undefined, // this is a computed default generated using
  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
  PaginationComponent: _pagination2.default,
  PreviousComponent: undefined,
  NextComponent: undefined,
  LoadingComponent: function LoadingComponent(_ref6) {
    var className = _ref6.className,
        loading = _ref6.loading,
        loadingText = _ref6.loadingText,
        rest = _objectWithoutProperties(_ref6, ['className', 'loading', 'loadingText']);

    return _react2.default.createElement(
      'div',
      _extends({
        className: (0, _classnames2.default)('-loading', { '-active': loading }, className)
      }, rest),
      _react2.default.createElement(
        'div',
        { className: '-loading-inner' },
        loadingText
      )
    );
  },
  NoDataComponent: _utils2.default.makeTemplateComponent('rt-noData', 'NoData'),
  ResizerComponent: _utils2.default.makeTemplateComponent('rt-resizer', 'Resizer'),
  PadRowComponent: function PadRowComponent() {
    return _react2.default.createElement(
      'span',
      null,
      '\xA0'
    );
  }
};
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//
// import _ from './utils'

var defaultButton = function defaultButton(props) {
  return _react2.default.createElement(
    'button',
    _extends({ type: 'button' }, props, { className: '-btn' }),
    props.children
  );
};

var ReactTablePagination = function (_Component) {
  _inherits(ReactTablePagination, _Component);

  function ReactTablePagination(props) {
    _classCallCheck(this, ReactTablePagination);

    var _this = _possibleConstructorReturn(this, (ReactTablePagination.__proto__ || Object.getPrototypeOf(ReactTablePagination)).call(this));

    _this.getSafePage = _this.getSafePage.bind(_this);
    _this.changePage = _this.changePage.bind(_this);
    _this.applyPage = _this.applyPage.bind(_this);

    _this.state = {
      page: props.page
    };
    return _this;
  }

  _createClass(ReactTablePagination, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ page: nextProps.page });
    }
  }, {
    key: 'getSafePage',
    value: function getSafePage(page) {
      if (isNaN(page)) {
        page = this.props.page;
      }
      return Math.min(Math.max(page, 0), this.props.pages - 1);
    }
  }, {
    key: 'changePage',
    value: function changePage(page) {
      page = this.getSafePage(page);
      this.setState({ page: page });
      if (this.props.page !== page) {
        this.props.onPageChange(page);
      }
    }
  }, {
    key: 'applyPage',
    value: function applyPage(e) {
      if (e) {
        e.preventDefault();
      }
      var page = this.state.page;
      this.changePage(page === '' ? this.props.page : page);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          pages = _props.pages,
          page = _props.page,
          showPageSizeOptions = _props.showPageSizeOptions,
          pageSizeOptions = _props.pageSizeOptions,
          pageSize = _props.pageSize,
          showPageJump = _props.showPageJump,
          canPrevious = _props.canPrevious,
          canNext = _props.canNext,
          onPageSizeChange = _props.onPageSizeChange,
          className = _props.className,
          _props$PreviousCompon = _props.PreviousComponent,
          PreviousComponent = _props$PreviousCompon === undefined ? defaultButton : _props$PreviousCompon,
          _props$NextComponent = _props.NextComponent,
          NextComponent = _props$NextComponent === undefined ? defaultButton : _props$NextComponent;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)(className, '-pagination'),
          style: this.props.paginationStyle
        },
        _react2.default.createElement(
          'div',
          { className: '-previous' },
          _react2.default.createElement(
            PreviousComponent,
            {
              onClick: function onClick() {
                if (!canPrevious) return;
                _this2.changePage(page - 1);
              },
              disabled: !canPrevious
            },
            this.props.previousText
          )
        ),
        _react2.default.createElement(
          'div',
          { className: '-center' },
          _react2.default.createElement(
            'span',
            { className: '-pageInfo' },
            this.props.pageText,
            ' ',
            showPageJump ? _react2.default.createElement(
              'div',
              { className: '-pageJump' },
              _react2.default.createElement('input', {
                type: this.state.page === '' ? 'text' : 'number',
                onChange: function onChange(e) {
                  var val = e.target.value;
                  var page = val - 1;
                  if (val === '') {
                    return _this2.setState({ page: val });
                  }
                  _this2.setState({ page: _this2.getSafePage(page) });
                },
                value: this.state.page === '' ? '' : this.state.page + 1,
                onBlur: this.applyPage,
                onKeyPress: function onKeyPress(e) {
                  if (e.which === 13 || e.keyCode === 13) {
                    _this2.applyPage();
                  }
                }
              })
            ) : _react2.default.createElement(
              'span',
              { className: '-currentPage' },
              page + 1
            ),
            ' ',
            this.props.ofText,
            ' ',
            _react2.default.createElement(
              'span',
              { className: '-totalPages' },
              pages || 1
            )
          ),
          showPageSizeOptions && _react2.default.createElement(
            'span',
            { className: 'select-wrap -pageSizeOptions' },
            _react2.default.createElement(
              'select',
              {
                onChange: function onChange(e) {
                  return onPageSizeChange(Number(e.target.value));
                },
                value: pageSize
              },
              pageSizeOptions.map(function (option, i) {
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  _react2.default.createElement(
                    'option',
                    { key: i, value: option },
                    option,
                    ' ',
                    _this2.props.rowsText
                  )
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: '-next' },
          _react2.default.createElement(
            NextComponent,
            {
              onClick: function onClick() {
                if (!canNext) return;
                _this2.changePage(page + 1);
              },
              disabled: !canNext
            },
            this.props.nextText
          )
        )
      );
    }
  }]);

  return ReactTablePagination;
}(_react.Component);

exports.default = ReactTablePagination;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  // General
  data: _propTypes2.default.array,
  loading: _propTypes2.default.bool,
  showPagination: _propTypes2.default.bool,
  showPaginationTop: _propTypes2.default.bool,
  showPaginationBottom: _propTypes2.default.bool,
  showPageSizeOptions: _propTypes2.default.bool,
  pageSizeOptions: _propTypes2.default.array,
  defaultPageSize: _propTypes2.default.number,
  showPageJump: _propTypes2.default.bool,
  collapseOnSortingChange: _propTypes2.default.bool,
  collapseOnPageChange: _propTypes2.default.bool,
  collapseOnDataChange: _propTypes2.default.bool,
  freezeWhenExpanded: _propTypes2.default.bool,
  sortable: _propTypes2.default.bool,
  resizable: _propTypes2.default.bool,
  filterable: _propTypes2.default.bool,
  defaultSortDesc: _propTypes2.default.bool,
  defaultSorted: _propTypes2.default.array,
  defaultFiltered: _propTypes2.default.array,
  defaultResized: _propTypes2.default.array,
  defaultExpanded: _propTypes2.default.object,
  defaultFilterMethod: _propTypes2.default.func,
  defaultSortMethod: _propTypes2.default.func,

  // Controlled State Callbacks
  onPageChange: _propTypes2.default.func,
  onPageSizeChange: _propTypes2.default.func,
  onSortedChange: _propTypes2.default.func,
  onFilteredChange: _propTypes2.default.func,
  onResizedChange: _propTypes2.default.func,
  onExpandedChange: _propTypes2.default.func,

  // Pivoting
  pivotBy: _propTypes2.default.array,

  // Key Constants
  pivotValKey: _propTypes2.default.string,
  pivotIDKey: _propTypes2.default.string,
  subRowsKey: _propTypes2.default.string,
  aggregatedKey: _propTypes2.default.string,
  nestingLevelKey: _propTypes2.default.string,
  originalKey: _propTypes2.default.string,
  indexKey: _propTypes2.default.string,
  groupedByPivotKey: _propTypes2.default.string,

  // Server-side Callbacks
  onFetchData: _propTypes2.default.func,

  // Classes
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,

  // Component decorators
  getProps: _propTypes2.default.func,
  getTableProps: _propTypes2.default.func,
  getTheadGroupProps: _propTypes2.default.func,
  getTheadGroupTrProps: _propTypes2.default.func,
  getTheadGroupThProps: _propTypes2.default.func,
  getTheadProps: _propTypes2.default.func,
  getTheadTrProps: _propTypes2.default.func,
  getTheadThProps: _propTypes2.default.func,
  getTheadFilterProps: _propTypes2.default.func,
  getTheadFilterTrProps: _propTypes2.default.func,
  getTheadFilterThProps: _propTypes2.default.func,
  getTbodyProps: _propTypes2.default.func,
  getTrGroupProps: _propTypes2.default.func,
  getTrProps: _propTypes2.default.func,
  getTdProps: _propTypes2.default.func,
  getTfootProps: _propTypes2.default.func,
  getTfootTrProps: _propTypes2.default.func,
  getTfootTdProps: _propTypes2.default.func,
  getPaginationProps: _propTypes2.default.func,
  getLoadingProps: _propTypes2.default.func,
  getNoDataProps: _propTypes2.default.func,
  getResizerProps: _propTypes2.default.func,

  // Global Column Defaults
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    // Renderers
    Cell: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
    Header: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
    Footer: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
    Aggregated: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
    Pivot: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
    PivotValue: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
    Expander: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.func]),
    Filter: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),

    // All Columns
    sortable: _propTypes2.default.bool, // use table default
    resizable: _propTypes2.default.bool, // use table default
    filterable: _propTypes2.default.bool, // use table default
    show: _propTypes2.default.bool,
    minWidth: _propTypes2.default.number,

    // Cells only
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    getProps: _propTypes2.default.func,

    // Pivot only
    aggregate: _propTypes2.default.func,

    // Headers only
    headerClassName: _propTypes2.default.string,
    headerStyle: _propTypes2.default.object,
    getHeaderProps: _propTypes2.default.func,

    // Footers only
    footerClassName: _propTypes2.default.string,
    footerStyle: _propTypes2.default.object,
    getFooterProps: _propTypes2.default.object,
    filterMethod: _propTypes2.default.func,
    filterAll: _propTypes2.default.bool,
    sortMethod: _propTypes2.default.func
  })),

  // Global Expander Column Defaults
  expanderDefaults: _propTypes2.default.shape({
    sortable: _propTypes2.default.bool,
    resizable: _propTypes2.default.bool,
    filterable: _propTypes2.default.bool,
    width: _propTypes2.default.number
  }),

  pivotDefaults: _propTypes2.default.object,

  // Text
  previousText: _propTypes2.default.node,
  nextText: _propTypes2.default.node,
  loadingText: _propTypes2.default.node,
  noDataText: _propTypes2.default.node,
  pageText: _propTypes2.default.node,
  ofText: _propTypes2.default.node,
  rowsText: _propTypes2.default.node,

  // Components
  TableComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  TheadComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  TbodyComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  TrGroupComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  TrComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  ThComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  TdComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  TfootComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  FilterComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  ExpanderComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  PivotValueComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  AggregatedComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  // this is a computed default generated using
  PivotComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
  PaginationComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  PreviousComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  NextComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  LoadingComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  NoDataComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  ResizerComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
  PadRowComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element])
};
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0h24v24H0V0z","key":0}),React.createElement("path",{"d":"M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h154.76v27.77H0z","fill":"none","key":0}),React.createElement("path",{"d":"M21.27 8.68a7.34 7.34 0 0 0-3.2.79 6.89 6.89 0 0 0-2.3 2.2A4.76 4.76 0 0 0 11 8.78a5.71 5.71 0 0 0-5.09 2.49V9.18H0v16.57h6v-9.09a4.2 4.2 0 0 1 .6-2.49 2.32 2.32 0 0 1 1.9-.9 1.7 1.7 0 0 1 1.49.6 3.76 3.76 0 0 1 .4 2.09v9.79h6v-9.09a3.65 3.65 0 0 1 .7-2.49 2.46 2.46 0 0 1 1.9-.9 1.72 1.72 0 0 1 1.5.6 3.76 3.76 0 0 1 .4 2.09v9.79h6v-9.89a8.92 8.92 0 0 0-1.4-5.39 5.28 5.28 0 0 0-4.22-1.79zm23.56 4.09a7.72 7.72 0 0 0-3.2-3 10.19 10.19 0 0 0-4.79-1 10 10 0 0 0-4.79 1 7.72 7.72 0 0 0-3.2 3 8.31 8.31 0 0 0-1.1 4.59 9.14 9.14 0 0 0 1.1 4.64 8.37 8.37 0 0 0 3.2 3 11.56 11.56 0 0 0 4.79 1.1 9.92 9.92 0 0 0 4.79-1.1 8.37 8.37 0 0 0 3.2-3 8.21 8.21 0 0 0 1.1-4.59 8.23 8.23 0 0 0-1.1-4.64zm-8 8.79c-2.1 0-3.19-1.4-3.19-4.2s1.09-4.19 3.19-4.19S40 14.57 40 17.36s-1 4.2-3.16 4.2z","key":1}),React.createElement("path",{"d":"M55.81 15.66L53 15.07a5.56 5.56 0 0 1-1.19-.4.6.6 0 0 1-.3-.6 1.05 1.05 0 0 1 .5-.9 3.92 3.92 0 0 1 1.49-.3 7.51 7.51 0 0 1 2.6.5 11 11 0 0 1 2.69 1.3l1.6-3.9a17.81 17.81 0 0 0-3.19-1.49 14.87 14.87 0 0 0-3.6-.5 10.87 10.87 0 0 0-3.89.69 6.36 6.36 0 0 0-2.7 1.9 4.77 4.77 0 0 0-1 2.8 4.17 4.17 0 0 0 1.09 3.19 7 7 0 0 0 3.7 1.7l2.69.6a9.83 9.83 0 0 1 1.6.5.84.84 0 0 1 .4.7.77.77 0 0 1-.5.79 4 4 0 0 1-1.5.3 12.91 12.91 0 0 1-3.29-.49 12.32 12.32 0 0 1-3.1-1.4l-1.49 4.09a10.25 10.25 0 0 0 3.39 1.5 16.49 16.49 0 0 0 4.39.5 9.26 9.26 0 0 0 5.39-1.4 4.61 4.61 0 0 0 2-3.89 4.51 4.51 0 0 0-1.2-3.3 6.27 6.27 0 0 0-3.77-1.9zm13.68-7a13.36 13.36 0 0 0-4 .6 11.24 11.24 0 0 0-3.59 1.49l1.5 4a13.81 13.81 0 0 1 2.79-1.2 8.08 8.08 0 0 1 2.7-.5 2.84 2.84 0 0 1 2 .5 2.72 2.72 0 0 1 .6 1.7v.49h-.89a25.6 25.6 0 0 0-5.5.5 5.72 5.72 0 0 0-3 1.5 3.76 3.76 0 0 0-.9 2.9 5.37 5.37 0 0 0 .8 2.79 5.1 5.1 0 0 0 2.2 1.9 6.63 6.63 0 0 0 3.09.7 5.19 5.19 0 0 0 2.7-.7 3.74 3.74 0 0 0 1.59-1.9v2.3h5.69v-9.57c0-2.49-.59-4.39-1.89-5.59a8.25 8.25 0 0 0-5.89-1.89zm2 10.18a3 3 0 0 1-.79 2.2 2.54 2.54 0 0 1-2 .89 2.16 2.16 0 0 1-1.3-.49 1.9 1.9 0 0 1-.5-1.3 1.42 1.42 0 0 1 .9-1.3 10.53 10.53 0 0 1 3.09-.4h.5zM78.37.79h6.29v5.39h-6.29zm.2 8.29h6v16.67h-6zm16.58 4.19a7 7 0 0 1 4.19 1.5l1.5-4.1A7.44 7.44 0 0 0 98 9.18a11.16 11.16 0 0 0-3.59-.5 10.07 10.07 0 0 0-4.8 1.09 8.25 8.25 0 0 0-3.29 3.1 9.25 9.25 0 0 0-1.2 4.59 8 8 0 0 0 2.4 6.29 9.42 9.42 0 0 0 6.69 2.3 16.5 16.5 0 0 0 3.79-.5 7.3 7.3 0 0 0 2.9-1.5L99.44 20a7 7 0 0 1-4.19 1.5 3.74 3.74 0 0 1-2.8-1 4.45 4.45 0 0 1-1-3.1 4.43 4.43 0 0 1 1-3.09 3.39 3.39 0 0 1 2.7-1.04zm14.07-11.38h6v23.86h-6zm7.49-1.1H123v5.39h-6.29zM117 9.07v16.7h6v-12.2h3.1v12.2h6v-12.2h2.5a10 10 0 0 0-.8 3.8 9.2 9.2 0 0 0 1.1 4.6 8.37 8.37 0 0 0 3.2 3 10.93 10.93 0 0 0 5 1 13.45 13.45 0 0 0 3.5-.5 10.32 10.32 0 0 0 3-1.4l-1.5-4a8 8 0 0 1-4.7 1.5 4.1 4.1 0 0 1-2.6-.7 3.47 3.47 0 0 1-1.2-2.3H150v-1.2a8.68 8.68 0 0 0-2.1-6.2 7.29 7.29 0 0 0-5.7-2.3 9.16 9.16 0 0 0-4.3 1.1 7.46 7.46 0 0 0-1.7 1.4v-2h-4v-.6a2 2 0 0 1 .7-1.8 6 6 0 0 1 2.7-.6l1.6-.1-.3-4.4-2 .1c-2.8.2-4.9.8-6.4 2a7 7 0 0 0-2.3 5.3m13.4 6.5q.3-3 2.7-3c1.6 0 2.5 1 2.6 3zM154.53.12l.23 3.12h-.54a.09.09 0 0 1-.08-.08L154 1.93l-.43 1.31h-.43-.08l-.42-1.31-.12 1.31h-.57a.09.09 0 0 1-.08-.08l.23-3.12a.09.09 0 0 1 .08-.08H152.83l.54 2.08.5-2.04H154.53v.12zM149 0h2.51a.09.09 0 0 1 .08.08v.61a.09.09 0 0 1-.08.08h-.89v2.55a.08.08 0 0 1-.07.07H150a.09.09 0 0 1-.08-.07V.77H149V.12a.09.09 0 0 1 0-.12z","key":2})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 154.76 27.77"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z","key":0}),React.createElement("path",{"d":"M0-.75h24v24H0z","fill":"none","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z","key":0}),React.createElement("path",{"d":"M0-.5h24v24H0z","fill":"none","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z","key":0}),React.createElement("path",{"d":"M0-.25h24v24H0z","fill":"none","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M0 0h24v24H0V0z","id":"a"})),React.createElement("clipPath",{"id":"b","key":1},React.createElement("use",{"overflow":"visible","xlinkHref":"#a"})),React.createElement("path",{"clipPath":"url(#b)","d":"M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z","key":2})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19,10H5V8H19V10M19,16H5V14H19V16Z"}));
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0h24v24H0V0z","key":0}),React.createElement("path",{"d":"M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"st1","d":"M20.9,2H3.1C2.5,2,2,2.5,2,3.1v17.8C2,21.5,2.5,22,3.1,22h9.6v-7.7h-2.6v-3h2.6V9c0-2.6,1.6-4,3.9-4\r\n\t\tc1.1,0,2.1,0.1,2.3,0.1v2.7l-1.6,0c-1.3,0-1.5,0.6-1.5,1.5v1.9h3l-0.4,3h-2.6V22h5.1c0.6,0,1.1-0.5,1.1-1.1V3.1\r\n\t\tC22,2.5,21.5,2,20.9,2z","key":0}),React.createElement("path",{"d":"M0,0h24v24H0V0z","fill":"none","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#3c5a99","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"10","y":"10","width":"70","height":"70","style":{"fill":"none","stroke":"#eee","strokeWidth":"1","opacity":"0.2","vectorEffect":"non-scaling-stroke"},"key":0}),React.createElement("polygon",{"points":"20 74 0 74 10 89.85 20 74","style":{"fill":"#eee","opacity":"0.2"},"key":1}),React.createElement("rect",{"width":"90","height":"90","style":{"fill":"none"},"key":2})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 90 90"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"17.5 21 17.5 1 1.65 11 17.5 21","style":{"fill":"none","stroke":"#eee","strokeWidth":"1","vectorEffect":"non-scaling-stroke"},"key":0}),React.createElement("rect",{"width":"18","height":"22","style":{"fill":"none"},"key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 18 22"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 13H5v-2h14v2z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M173.4,67.8c0-0.6-0.4-1-1-1H158c-0.6,0-1,0.4-1,1s0.4,1,1,1h14.4C173,68.8,173.4,68.4,173.4,67.8z","key":0}),React.createElement("path",{"d":"M120,67.8c0-0.6-0.4-1-1-1H80.9c-0.6,0-1,0.4-1,1s0.4,1,1,1H119C119.6,68.8,120,68.4,120,67.8z","key":1}),React.createElement("path",{"d":"M175.9,77.6c0-0.1-0.1-0.3-0.2-0.4c-0.3-0.6-0.8-1.1-1.5-1.4c-0.1,0-0.1-0.1-0.2-0.1c-1.1-0.4-5.4-2.1-8-3.1\r\n\tc-1.2-0.5-3.6-1.4-3.9-1.6c-0.3-0.4-0.8-0.8-1.9-1.9l-2.6-2.4l-0.5-0.8l-0.1,0l0,0c0.6-0.2,0.9-0.7,0.7-1.2\r\n\tc-0.2-0.6-0.7-0.9-1.2-0.7l-1.4,0.4l-0.2-0.1l-1.4-1.2l0.1,0c0.4-0.1,0.7-0.4,0.7-0.8c0-0.1,0-0.3,0-0.5c-0.2-0.6-0.7-0.9-1.2-0.7\r\n\tl-0.9,0.2l-0.5,0.1l-1.2-1.1l0.1,0c0.6-0.2,0.9-0.7,0.7-1.2c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.4-0.6-0.5-1-0.5c0,0-0.1,0-0.1,0l-1.3,0.4\r\n\tl0,0l-1.7-1.6c0,0,0-0.1-0.1-0.1c-0.7-0.5-1.4-0.8-2.1-0.9c-0.9-0.1-1.8,0-2.7,0.3c-1.3,0.6-2.2,1.7-2.4,3c0,0.3,0.1,0.6,0.3,0.8\r\n\tl10.3,10c0.8,0.8,1.9,1.2,3,1.4l5,0.4l4.9,1.8c0.1,0,4.8,1.8,7.8,3c1,0.4,1.8,0.7,2.2,0.9c0.3,0.1,0.5,0.3,0.6,0.7\r\n\tc0.2,0.5,0,1.2-0.2,1.8c0,0.1,0,0.1-0.1,0.2l-0.1,0l-3.4,0l-4.3,0l-7.2-0.1c-1,0-2-0.4-3-0.8l0,0l-7.7-3l-11.1-4.3l-9.6-3.7\r\n\tl-0.4-0.3c0.4-0.6,0.5-1.4,0.2-2.2l-0.1-0.1l-2.8-7l-0.7-1.8c0.1-0.7,0.4-1.6,0.6-2c0.2-0.5,0.6-0.7,1-0.5c0.1,0,0.3,0.1,0.6,0.3\r\n\tc0.5,0.3,1.4,1,2.9,2.2c0.6,0.5,1.3,1.1,2.1,1.8c0,0,0,0,0.1,0c2,1.6,4.6,2.4,7.1,2.2c0.1,0,0.1,0,0.2-0.1c0.5-0.1,0.8-0.5,0.8-1\r\n\tc0-0.5-0.6-1-1.1-0.9c-2,0.2-4.1-0.4-5.7-1.8c-0.6-0.5-1.1-1-1.5-1.4c-0.9-0.8-1.6-1.4-2.2-1.8c-0.6-0.5-1.1-0.8-1.5-1.1\r\n\tc-0.5-0.3-0.8-0.4-1-0.5c-0.3-0.1-0.7-0.2-1-0.2c-1.1,0-2,0.7-2.6,1.7l-3.2,10.5c-0.2,0.7-0.2,1.3,0.2,2.1c-0.6,0.4-1.2,1-1.4,1.7\r\n\tl-0.7,2.4c-0.2,0.8-0.2,1.6,0.2,2.3c0.4,0.7,1.1,1.3,1.8,1.5c0,0,29.2,9.1,35.5,11c1.3,0.4,2.2,0.4,3.9,0.4c0,0,5.2,0,5.3,0\r\n\tc3.8,0,8.9-1.1,11.1-4.1C175.8,80.7,176.3,79.1,175.9,77.6z M151.9,68.7l-9.8-9.6c0.2-0.4,0.6-0.7,1.1-0.9c0.5-0.2,1.5-0.4,2.7,0.3\r\n\tl0.7,0.6l-0.2,0.1c-0.6,0.2-0.9,0.7-0.7,1.2c0.2,0.6,0.7,0.9,1.2,0.7l0.8-0.2l0.6-0.2l1.2,1.1l-0.2,0.1c-0.4,0.1-0.6,0.4-0.7,0.7\r\n\tc0,0.2,0,0.3,0,0.5c0.1,0.4,0.4,0.7,0.7,0.7c0.2,0,0.3,0,0.5,0l1.5-0.4l0.5,0.5l1,0.9l-0.2,0.1c-0.1,0-0.1,0-0.2,0.1\r\n\tc-0.4,0.2-0.6,0.7-0.5,1.2c0.2,0.6,0.7,0.9,1.2,0.7l0.3-0.1l1.1-0.3l3.2,3l0.3,0.3l-4.4-0.2c-0.4,0-0.7-0.2-1.1-0.3\r\n\tC152.3,69,152.1,68.8,151.9,68.7z M125.1,66.6c0,0.2,0,0.3,0,0.4c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.3,0.2-0.5,0.1l-2.8-1.1\r\n\tc-0.5-0.3-0.8-0.8-0.7-1.3l0.1-0.4l0.6-1.9l0.8-2.6l1.6,4.1L125.1,66.6z M167.4,83.7c-1.2,0.2-2.3,0.3-3.5,0.3l-6.1,0\r\n\tc-0.6,0-1.2-0.1-1.8-0.2c-0.2,0-0.5-0.1-0.7-0.2c-2.3-0.7-35.5-10.9-35.5-10.9c-0.2,0-0.5-0.3-0.5-0.5c-0.2-0.3-0.1-0.5-0.1-0.8\r\n\tl0.7-2.4c0-0.2,0.3-0.5,0.6-0.6c0.3-0.2,0.6-0.2,0.8,0l0.8,0.3l32.8,12.6c1.5,0.6,2.5,0.8,3.6,0.8l6.6,0.1l5.6,0l0.9,0\r\n\tC170.3,82.9,168.8,83.4,167.4,83.7z","key":2}),React.createElement("path",{"d":"M187.4,67.2c0.1-0.1,0.1-0.3,0.2-0.4c0.3-0.6,0.4-1.3,0.3-2c0-0.1,0-0.1,0-0.2c-0.3-1.1-1.6-5.6-2.3-8.2\r\n\tc-0.3-1.2-1-3.7-1.1-4.1c0.2-0.5,0.2-1.1,0.4-2.7l0.4-3.6l0.3-0.8l-0.1-0.1l0,0c0.5,0.4,1,0.3,1.4-0.2c0.4-0.5,0.3-1-0.2-1.4\r\n\tl-1.1-0.9l0-0.2l0.2-1.8l0.1,0.1c0.3,0.3,0.7,0.3,1.1,0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.4-0.5,0.3-1-0.2-1.4l-0.7-0.5l-0.4-0.3l0.1-1.7\r\n\tl0.1,0.1c0.5,0.4,1,0.3,1.4-0.2c0.1-0.1,0.1-0.2,0.1-0.2c0.2-0.4,0.1-0.8-0.2-1.1c0,0-0.1-0.1-0.1-0.1l-1.1-0.8l0,0l0.3-2.3\r\n\tc0,0,0.1-0.1,0-0.1c0-0.8-0.2-1.5-0.5-2.2c-0.4-0.8-1-1.5-1.8-1.9c-1.2-0.7-2.7-0.8-3.8-0.2c-0.3,0.2-0.4,0.4-0.5,0.8L178,42.3\r\n\tc-0.1,1.2,0.1,2.3,0.7,3.2l2.7,4.2l1.5,5c0,0.1,1.4,4.9,2.3,8c0.3,1,0.5,1.9,0.7,2.3c0.1,0.3,0.1,0.6-0.2,0.9\r\n\tc-0.3,0.4-0.9,0.7-1.6,0.9c-0.1,0-0.1,0-0.2,0.1l-0.1-0.1l-2-2.7l-2.6-3.4l-4.2-5.8c-0.6-0.8-0.9-1.9-1.2-2.9l0,0l-2.2-7.9\r\n\tl-3.2-11.4l-2.8-9.9l0-0.5c0.7-0.1,1.4-0.5,1.8-1.2l0.1-0.1l4-6.4l1-1.7c0.6-0.3,1.5-0.6,2-0.8c0.5-0.1,0.9,0.1,1,0.5\r\n\tc0,0.1,0.1,0.3,0.1,0.7c0.1,0.6,0.1,1.7,0,3.6c0,0.8-0.1,1.7-0.2,2.7c0,0,0,0,0,0.1c-0.1,2.6,0.8,5.1,2.5,7.1\r\n\tc0.1,0.1,0.1,0.1,0.2,0.1c0.4,0.3,0.9,0.3,1.3,0c0.4-0.3,0.4-1.1,0.1-1.4c-1.4-1.5-2.1-3.5-2-5.6c0.1-0.7,0.1-1.4,0.2-2\r\n\tc0.1-1.2,0.1-2.1,0.1-2.8c0-0.8,0-1.4,0-1.8c-0.1-0.6-0.1-0.9-0.2-1.1c-0.1-0.3-0.2-0.6-0.4-0.9c-0.6-0.9-1.8-1.2-2.9-1.1l-10.3,3.7\r\n\tc-0.7,0.2-1.1,0.6-1.6,1.4c-0.7-0.3-1.5-0.4-2.2-0.1l-2.3,0.9c-0.7,0.3-1.4,0.8-1.7,1.6c-0.3,0.8-0.4,1.6-0.1,2.3\r\n\tc0,0,10.2,28.9,12.4,35c0.4,1.3,1,2,2,3.3c0,0,3.1,4.2,3.2,4.3c2.3,3.1,6.2,6.5,9.9,6.4C184.8,68.9,186.4,68.4,187.4,67.2z\r\n\t M180.1,42.6l1.8-13.6c0.4-0.1,0.9,0.1,1.4,0.3s1.3,1,1.4,2.3l-0.1,0.9l-0.2-0.1c-0.5-0.4-1-0.3-1.4,0.2c-0.4,0.5-0.3,1,0.2,1.4\r\n\tl0.7,0.5l0.5,0.4l-0.1,1.7l-0.2-0.1c-0.3-0.2-0.7-0.3-1-0.2c-0.2,0.1-0.3,0.2-0.4,0.3c-0.3,0.3-0.3,0.7-0.1,1\r\n\tc0.1,0.1,0.2,0.3,0.3,0.4L184,39l-0.1,0.7l-0.1,1.3l-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.2-0.9-0.1-1.2,0.3\r\n\tc-0.4,0.5-0.3,1,0.2,1.4l0.2,0.2l0.9,0.7l-0.5,4.4l0,0.4l-2.5-3.7c-0.2-0.3-0.3-0.7-0.4-1.1C180.1,43.1,180.1,42.8,180.1,42.6z\r\n\t M165.7,19.8c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2,0-0.2,0c-0.1,0-0.3-0.1-0.4-0.3l-0.8-2.9c-0.1-0.6,0.2-1.1,0.6-1.3l0.4-0.2\r\n\tl1.9-0.7l2.6-0.9l-2.4,3.7L165.7,19.8z M177.4,63.9c-0.9-0.8-1.7-1.7-2.4-2.6l-3.7-4.9c-0.4-0.5-0.7-1-0.9-1.6\r\n\tc-0.1-0.2-0.2-0.4-0.3-0.7c-0.8-2.3-12.5-35-12.5-35c-0.1-0.2-0.1-0.6,0.1-0.7c0.1-0.3,0.3-0.4,0.6-0.6l2.3-0.9\r\n\tc0.2-0.1,0.6-0.1,0.8,0.1c0.3,0.1,0.5,0.4,0.5,0.7l0.2,0.8l9.5,33.8c0.5,1.6,0.8,2.4,1.5,3.4l3.9,5.4l3.4,4.5l0.5,0.7\r\n\tC179.7,65.8,178.5,64.9,177.4,63.9z","key":3}),React.createElement("path",{"d":"M139.9,84.1H91c-0.6,0-1,0.4-1,1s0.4,1,1,1h48.9c0.5,0,1-0.4,1-0.9c0,0,0-0.1,0-0.1C140.9,84.5,140.4,84.1,139.9,84.1z","key":4}),React.createElement("path",{"d":"M124,80.3c0-0.5-0.4-1-0.9-1c0,0-0.1,0-0.1,0H35.2c-0.6,0-1,0.4-1,1s0.4,1,1,1H123c0.5,0,1-0.4,1-0.9\r\n\tC124,80.4,124,80.3,124,80.3z","key":5}),React.createElement("path",{"d":"M112,75.6c0-0.5-0.4-1-0.9-1c0,0-0.1,0-0.1,0H9c-0.6,0-1,0.4-1,1s0.4,1,1,1h102C111.5,76.5,112,76.1,112,75.6z","key":6}),React.createElement("path",{"d":"M5.6,74.9c-0.4-0.4-1-0.4-1.4,0C4.1,75,4,75.1,4,75.2s-0.1,0.2-0.1,0.4c0,0.6,0.4,1,1,1s1-0.4,1-1c0-0.1,0-0.3-0.1-0.4\r\n\tC5.8,75.1,5.7,75,5.6,74.9z","key":7})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 192 96","style":{"enableBackground":"new 0 0 192 96"},"xmlSpace":"preserve"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"st0","d":"M23.1,5.1c-0.8,0.4-1.7,0.6-2.6,0.7c0.9-0.6,1.7-1.5,2-2.5c-0.9,0.6-1.9,0.9-2.9,1.1c-0.8-0.9-2-1.5-3.3-1.5\r\n\t\tc-2.5,0-4.5,2-4.5,4.5c0,0.4,0,0.7,0.1,1C8,8.4,4.7,6.5,2.4,3.8C2,4.5,1.8,5.2,1.8,6.1c0,1.6,0.8,3,2,3.8c-0.7,0-1.5-0.2-2-0.6v0.1\r\n\t\tc0,2.2,1.6,4.1,3.6,4.5C5,13.9,4.7,14,4.2,14c-0.3,0-0.6,0-0.8-0.1c0.6,1.9,2.2,3.2,4.3,3.2c-1.6,1.2-3.5,1.9-5.7,1.9\r\n\t\tc-0.4,0-0.7,0-1.1-0.1c2,1.3,4.5,2,7.1,2c8.4,0,13-7,13-13c0-0.2,0-0.4,0-0.6C21.7,6.8,22.5,6.1,23.1,5.1L23.1,5.1z","key":0}),React.createElement("path",{"d":"M0,0h24v24H0V0z","fill":"none","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#1da1f2","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.5045 14L0.999996 7.98915L10.5045 2V14Z"}));
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 13 16","fill":"none"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 14L11.5045 7.98915L2 2V14Z"}));
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 13 16","fill":"none"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"}));
}

Icon.displayName = "Icon";

Icon.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"fab","data-icon":"instagram","className":"svg-inline--fa fa-instagram fa-w-14","role":"img","viewBox":"0 0 448 512"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"}));
}

Icon.displayName = "Icon";

Icon.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"fab","data-icon":"linkedin","className":"svg-inline--fa fa-linkedin fa-w-14","role":"img","viewBox":"0 0 448 512"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"163","height":"163","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M84.47,111.19H78.74a3.08,3.08,0,0,1-3.1-3.07,2.93,2.93,0,0,1,.1-.78L78,98.7A6.51,6.51,0,1,1,87,97a6.63,6.63,0,0,1-1.83,1.79l2.22,8.54a3.08,3.08,0,0,1-2.19,3.75,3.15,3.15,0,0,1-.81.1Zm-3-2.86h3a.18.18,0,0,0,.17-.27l-2.51-9.65A1.43,1.43,0,0,1,83,96.72a3.59,3.59,0,1,0-3.77-.63,4,4,0,0,0,1,.63A1.43,1.43,0,0,1,81,98.4l-2.46,9.66a.31.31,0,0,0,0,.19.21.21,0,0,0,.17.08Z","key":1}),React.createElement("path",{"d":"M102.9,73.71H102V60.18a20.45,20.45,0,0,0-40.89-.91c0,.3,0,.6,0,.91V73.71h-.92a10.07,10.07,0,0,0-10.06,10v30a10.08,10.08,0,0,0,10.06,10.06H102.9a10.07,10.07,0,0,0,10-10.06V83.76A10.06,10.06,0,0,0,102.9,73.71ZM64,60.18a17.58,17.58,0,1,1,35.15-.84q0,.42,0,.84V73.71H95.57V60.18a14,14,0,1,0-28.09,0V73.71H64Zm28.76,0V73.71H70.34V60.18a11.19,11.19,0,0,1,22.37-.67C92.72,59.73,92.72,60,92.71,60.18Zm17.38,53.49a7.21,7.21,0,0,1-7.19,7.19H60.16A7.19,7.19,0,0,1,53,113.67h0V83.76a7.2,7.2,0,0,1,7.19-7.19H102.9a7.2,7.2,0,0,1,7.19,7.19Z","key":2})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 163 163"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"163","height":"163","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M138.88,65.06a1.5,1.5,0,0,0-1.64-.54L94.6,77.44a1.5,1.5,0,0,0-1,1.89,1.59,1.59,0,0,0,.52.73l6.41,4.57A60.19,60.19,0,0,1,81.49,95.18,60,60,0,0,1,62.4,84.67l6.4-4.61a1.47,1.47,0,0,0,.61-1.46,1.49,1.49,0,0,0-1-1.2L25.73,64.55a1.5,1.5,0,0,0-1.64.51,1.52,1.52,0,0,0,0,1.73L43.52,96.24a1.56,1.56,0,0,0,1,.65,1.54,1.54,0,0,0,1.14-.26l5.73-4.08a55.78,55.78,0,0,0,24.66,6,52.27,52.27,0,0,0,5.46-.29,52.22,52.22,0,0,0,5.45.29,55.78,55.78,0,0,0,24.66-6l5.72,4.08a1.48,1.48,0,0,0,2.07-.32l0-.07,19.46-29.42A1.52,1.52,0,0,0,138.88,65.06Zm-87,24.37a1.34,1.34,0,0,0-.68-.16,1.43,1.43,0,0,0-.87.28l-5.11,3.74L28.84,68.63l35.74,10.8-5.52,3.94a1.47,1.47,0,0,0-.63,1.16A1.56,1.56,0,0,0,59,85.74a68,68,0,0,0,15.14,9.77,53.49,53.49,0,0,1-22.2-6.05Zm65.89,3.83-5.2-3.71a1.47,1.47,0,0,0-1.55-.12,53.45,53.45,0,0,1-22.19,6A68.4,68.4,0,0,0,104,85.71a1.53,1.53,0,0,0,.53-1.21,1.47,1.47,0,0,0-.63-1.16L98.36,79.4,134.1,68.6Z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 163 163"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"163","height":"163","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M127.83,88.77a3.46,3.46,0,0,0-3.31-2.34H107.39v-44a1.5,1.5,0,0,0-1.5-1.5H70.12a1.5,1.5,0,0,0-1.5,1.5v4.74a28.53,28.53,0,1,0-5.11,56.59h.23l23.35,18a1.52,1.52,0,0,0,1.83,0l37.73-29.09A3.45,3.45,0,0,0,127.83,88.77ZM38,75.23a25.54,25.54,0,0,1,31.8-24.75h.1a25.53,25.53,0,0,1-5.61,50.24h-.76A25.56,25.56,0,0,1,38,75.23Zm86.84,15.06L88,118.66,68.17,103.37a28.52,28.52,0,0,0,3.45-55.48v-4h32.77v44a1.5,1.5,0,0,0,1.5,1.5h18.63a.5.5,0,0,1,.3.9Z","key":1}),React.createElement("path",{"d":"M70.11,84.24a8.64,8.64,0,0,1-5.17,2V89.6H62.48V86.32a16.7,16.7,0,0,1-4.2-.81,9.17,9.17,0,0,1-3.16-1.68l1.36-3a9.67,9.67,0,0,0,2.69,1.52,12.07,12.07,0,0,0,3.31.76v-6A22,22,0,0,1,58.92,76a6.06,6.06,0,0,1-2.39-1.8,4.82,4.82,0,0,1-1-3.14,5.51,5.51,0,0,1,1.77-4.14,8.38,8.38,0,0,1,5.14-2V61.43H65v3.33a14.1,14.1,0,0,1,3.28.57,11.25,11.25,0,0,1,2.81,1.26l-1.24,3A12.42,12.42,0,0,0,65,68v6.06a23.54,23.54,0,0,1,3.58,1.11A6.24,6.24,0,0,1,71,77a4.77,4.77,0,0,1,1,3.13A5.52,5.52,0,0,1,70.11,84.24ZM60.23,72.43a6.6,6.6,0,0,0,2.25,1V68.11a4.14,4.14,0,0,0-2.29,1,2.34,2.34,0,0,0-.75,1.77A1.88,1.88,0,0,0,60.23,72.43Zm7.06,9.66a2.25,2.25,0,0,0,.77-1.66,2,2,0,0,0-.82-1.63,6.94,6.94,0,0,0-2.3-1v5.31A4.49,4.49,0,0,0,67.29,82.09Z","key":2})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 163 163"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"163","height":"163","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M92.6,85.33a15.58,15.58,0,1,0-22.18,0,24.8,24.8,0,0,0-13.58,22V108a1.51,1.51,0,0,0,.44,1c5.24,5.25,14.29,8.39,24.22,8.39s19-3.14,24.22-8.39a1.51,1.51,0,0,0,.44-1v-.64A24.86,24.86,0,0,0,92.6,85.33ZM68.93,74.41A12.58,12.58,0,1,1,74,84.51,12.58,12.58,0,0,1,68.93,74.41Zm12.58,40c-8.87,0-16.91-2.65-21.67-7.1A21.78,21.78,0,0,1,73,87.44a15.48,15.48,0,0,0,17,0,21.82,21.82,0,0,1,13.19,19.84c-4.76,4.46-12.8,7.1-21.67,7.1Z","key":1}),React.createElement("path",{"d":"M89.52,110.39a1.49,1.49,0,0,1-.69-.16c-4.52-2.33-7.08-5.7-6.87-9A4.65,4.65,0,0,1,85,97a4.29,4.29,0,0,1,4.6,1,4.26,4.26,0,0,1,4.59-1,4.65,4.65,0,0,1,3,4.19c.21,3.31-2.35,6.68-6.87,9A1.43,1.43,0,0,1,89.52,110.39Zm-3-10.63a1.39,1.39,0,0,0-.53.1,1.66,1.66,0,0,0-1,1.55c-.1,1.52,1.06,3.78,4.56,5.78,3.49-2,4.65-4.26,4.55-5.78a1.66,1.66,0,0,0-1-1.55c-1.4-.51-2.1,1.15-2.18,1.34a1.49,1.49,0,0,1-2.79,0c-.16-.36-.69-1.44-1.66-1.44Zm40.91-32a13,13,0,0,0,3.55-9,13.15,13.15,0,1,0-26.3,0,13,13,0,0,0,3.55,9A20.84,20.84,0,0,0,97.16,86.1v.55a1.51,1.51,0,0,0,.44,1c4.45,4.46,11.82,7,20.22,7s15.78-2.56,20.23-7a1.51,1.51,0,0,0,.44-1v-.54a20.81,20.81,0,0,0-11.06-18.33Zm-19.75-9a10.15,10.15,0,1,1,16.22,8.15l-.18.14a10.15,10.15,0,0,1-16-8.27Zm10.15,32.86c-7.22,0-13.77-2.13-17.67-5.73a17.78,17.78,0,0,1,10.61-16,13.07,13.07,0,0,0,14.12,0,17.79,17.79,0,0,1,10.62,16C131.61,89.51,125.06,91.64,117.83,91.64Zm-63-23.85a13.15,13.15,0,1,0-19.2,0A20.8,20.8,0,0,0,24.51,86.1v.55a1.5,1.5,0,0,0,.43,1c4.46,4.46,11.83,7,20.23,7s15.78-2.56,20.23-7a1.5,1.5,0,0,0,.43-1,5,5,0,0,0,0-.55A20.82,20.82,0,0,0,54.78,67.79ZM35,58.79a10.15,10.15,0,1,1,16.24,8.14,1.33,1.33,0,0,0-.19.14,10.17,10.17,0,0,1-16-8.25ZM45.18,91.64c-7.23,0-13.77-2.13-17.67-5.73a17.75,17.75,0,0,1,10.61-16,13.09,13.09,0,0,0,14.15,0,17.79,17.79,0,0,1,10.59,16C59,89.51,52.41,91.64,45.18,91.64Z","key":2})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 163 163"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"163","height":"163","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M8.25,111.38a3.39,3.39,0,0,1-2.4-1L1,105.58a3.37,3.37,0,0,1-1-2.4,3.41,3.41,0,0,1,1-2.41l9.52-9.51a.39.39,0,0,0,0-.56L1,81.18a3.41,3.41,0,0,1-1-2.41,3.37,3.37,0,0,1,1-2.4l4.85-4.84a3.38,3.38,0,0,1,4.79,0h0L20.17,81a.39.39,0,0,0,.55,0h0l9.51-9.51a3.4,3.4,0,0,1,4.8,0l4.85,4.84a3.4,3.4,0,0,1,0,4.8L30.37,90.7a.4.4,0,0,0,0,.56l9.51,9.52a3.38,3.38,0,0,1,0,4.79h0L35,110.42a3.4,3.4,0,0,1-4.8,0l-9.51-9.54a.39.39,0,0,0-.55,0h0l-9.52,9.51A3.38,3.38,0,0,1,8.25,111.38Zm0-37.88a.36.36,0,0,0-.28.12L3.12,78.46a.39.39,0,0,0,0,.56l9.53,9.56a3.38,3.38,0,0,1,0,4.79h0L3.13,102.9a.36.36,0,0,0-.12.28.5.5,0,0,0,.12.28L8,108.3a.4.4,0,0,0,.56,0l9.52-9.52a3.4,3.4,0,0,1,4.8,0l9.51,9.52a.4.4,0,0,0,.56,0l4.84-4.84a.39.39,0,0,0,0-.55h0l-9.51-9.52a3.4,3.4,0,0,1,0-4.8l9.51-9.53a.39.39,0,0,0,0-.55h0l-4.85-4.91a.4.4,0,0,0-.56,0l-9.51,9.51a3.38,3.38,0,0,1-4.79,0h0L8.58,73.58A.36.36,0,0,0,8.25,73.5ZM154.77,92.44a3.41,3.41,0,0,1-2.41-1l-9.51-9.51a.39.39,0,0,0-.55,0h0l-9.51,9.51a3.4,3.4,0,0,1-4.8,0l-4.86-4.86a3.42,3.42,0,0,1,0-4.81l9.53-9.51a.41.41,0,0,0,.11-.28.43.43,0,0,0-.11-.28l-9.53-9.52a3.41,3.41,0,0,1-1-2.41,3.37,3.37,0,0,1,1-2.4L128,52.58a3.4,3.4,0,0,1,4.8,0l9.51,9.51a.39.39,0,0,0,.55,0h0l9.51-9.51a3.49,3.49,0,0,1,4.81,0L162,57.42a3.4,3.4,0,0,1,0,4.8l-9.52,9.53a.4.4,0,0,0,0,.56L162,81.83a3.4,3.4,0,0,1,0,4.8l-4.84,4.84a3.36,3.36,0,0,1-2.4,1ZM130.38,54.58a.36.36,0,0,0-.28.12l-4.86,4.84a.43.43,0,0,0-.11.28.41.41,0,0,0,.11.28l9.53,9.48a3.4,3.4,0,0,1,0,4.8l-9.53,9.52a.41.41,0,0,0-.11.28.43.43,0,0,0,.11.28l4.86,4.84a.4.4,0,0,0,.56,0l9.51-9.52a3.4,3.4,0,0,1,4.8,0l9.52,9.52a.4.4,0,0,0,.56,0l4.84-4.84a.43.43,0,0,0,.11-.28.41.41,0,0,0-.11-.28l-9.52-9.52a3.4,3.4,0,0,1,0-4.8l9.52-9.53a.4.4,0,0,0,0-.56l-4.84-4.84a.35.35,0,0,0-.49-.07.23.23,0,0,0-.07.07L145,64.16a3.4,3.4,0,0,1-4.8,0l-9.51-9.52A.39.39,0,0,0,130.38,54.58Z","key":1}),React.createElement("path",{"d":"M44.46,97.68a1.39,1.39,0,0,1-.53-.1A24,24,0,0,1,41,96.27a1.5,1.5,0,0,1,1.45-2.62A24.11,24.11,0,0,0,45,94.78a1.5,1.5,0,0,1-.54,2.9Zm13.12,2.47a38.86,38.86,0,0,1-6-.5,1.52,1.52,0,1,1,.48-3,35,35,0,0,0,5.5.46,1.5,1.5,0,1,1,0,3Zm7.63-.77a1.51,1.51,0,0,1-.31-3h0a33.84,33.84,0,0,0,5.29-1.58,1.5,1.5,0,1,1,1.08,2.8,37.78,37.78,0,0,1-5.69,1.75,2,2,0,0,1-.34,0Zm12.37-5.13a1.5,1.5,0,0,1-1.5-1.5,1.53,1.53,0,0,1,.69-1.26,48.73,48.73,0,0,0,4.52-3.29,1.53,1.53,0,1,1,1.92,2.38,49.93,49.93,0,0,1-4.81,3.49A1.46,1.46,0,0,1,77.58,94.25Zm10.33-8.56a1.49,1.49,0,0,1-1.07-.45,1.51,1.51,0,0,1,0-2.12l1.79-1.78c.78-.77,1.54-1.54,2.31-2.29A1.5,1.5,0,1,1,93,81.2h0c-.76.74-1.52,1.5-2.29,2.26-.59.6-1.19,1.19-1.8,1.79a1.51,1.51,0,0,1-1,.44Zm9.88-9.11a1.5,1.5,0,0,1-1.5-1.5,1.48,1.48,0,0,1,.61-1.21,29.87,29.87,0,0,1,5.16-3.14,1.5,1.5,0,0,1,2,.71h0a1.52,1.52,0,0,1-.71,2,27.37,27.37,0,0,0-4.66,2.84A1.54,1.54,0,0,1,97.79,76.58ZM110,71.38a1.5,1.5,0,1,1-.22-3,32.57,32.57,0,0,1,6-.29,1.5,1.5,0,0,1-.12,3,30.31,30.31,0,0,0-5.47.27Zm16.35,1.38H126c-1-.25-1.92-.48-2.85-.67a1.5,1.5,0,1,1,.61-2.94h0c1,.21,2,.44,3,.7a1.5,1.5,0,0,1-.37,3Z","key":2})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 163 163"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"163","height":"163","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M83.86,127A45.56,45.56,0,0,1,39.14,90l-4.79,4.77a1.53,1.53,0,0,1-1.06.41,1.5,1.5,0,0,1-1.06-.44L26,88.5a1.51,1.51,0,0,1,0-2.12L42.45,70.15A1.49,1.49,0,0,1,44.37,70l18.5,13.07a1.49,1.49,0,0,1,.36,2.09l-5,7.16a1.51,1.51,0,0,1-2.09.36L51,89.06a33.76,33.76,0,1,0,1.94-20.94,1.53,1.53,0,0,1-2,.78l-8-3.49a1.5,1.5,0,0,1-.79-2v0A45.51,45.51,0,1,1,83.86,127ZM40.18,85.33a1.37,1.37,0,0,1,.49.09,1.49,1.49,0,0,1,1,1.23,42.5,42.5,0,1,0,3.81-23.42l5.3,2.29a36.76,36.76,0,1,1-3.39,20.36,1.49,1.49,0,0,1,2.35-1.4l6.85,4.83,3.33-4.7L43.67,73.15,29.24,87.46l4.06,4.09,5.82-5.78A1.5,1.5,0,0,1,40.18,85.33Z","key":1}),React.createElement("path",{"d":"M70.8,97.06a1.49,1.49,0,0,1-1.5-1.48,1.42,1.42,0,0,1,.39-1L82.85,80V59.38a1.5,1.5,0,1,1,3,0v21.2a1.5,1.5,0,0,1-.39,1l-13.54,15A1.52,1.52,0,0,1,70.8,97.06Z","key":2}),React.createElement("circle",{"cx":"84.35","cy":"109.24","r":"2.11","key":3}),React.createElement("circle",{"cx":"99.69","cy":"103.82","r":"2.11","key":4}),React.createElement("circle",{"cx":"108.77","cy":"90.83","r":"2.11","key":5}),React.createElement("circle",{"cx":"110.2","cy":"74.36","r":"2.11","key":6})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 163 163"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"68.6","height":"68.6","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M34.3,68.6A34.3,34.3,0,1,1,68.6,34.3,34.3,34.3,0,0,1,34.3,68.6ZM34.3,3a31.3,31.3,0,1,0,31.3,31.3h0A31.33,31.33,0,0,0,34.3,3Z","key":1}),React.createElement("path",{"d":"M29.38,56.59h-.05a1.5,1.5,0,0,1-1.1-.54L16.41,41.84a1.5,1.5,0,0,1,0-2l3.28-3.72a1.5,1.5,0,0,1,1.91-.29l7.84,4.76L53.38,20.9a1.51,1.51,0,0,1,2,.06l3.5,3.29a1.49,1.49,0,0,1,.47,1.05,1.54,1.54,0,0,1-.41,1.08L30.47,56.12A1.5,1.5,0,0,1,29.38,56.59ZM19.54,40.91l9.92,11.93L55.7,25.4l-1.43-1.35L30.56,43.63a1.49,1.49,0,0,1-1.74.12l-7.68-4.66Z","key":2})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 68.6 68.6"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"68.6","height":"68.6","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M34.31,68.6A34.3,34.3,0,1,1,68.6,34.29v0A34.34,34.34,0,0,1,34.31,68.6ZM34.31,3A31.3,31.3,0,1,0,65.6,34.32h0A31.33,31.33,0,0,0,34.31,3ZM45.77,53.08A2.52,2.52,0,0,1,44,52.32l-9.67-9.75-9.7,9.75a2.55,2.55,0,0,1-1.87.74A2.48,2.48,0,0,1,21,52.22l-4.44-5a2.52,2.52,0,0,1,.09-3.41l9.44-9.49L16.25,24.4a2.48,2.48,0,0,1,0-3.51h0l4.65-4.65a2.5,2.5,0,0,1,3.53,0l9.88,9.88,9.87-9.87A2.55,2.55,0,0,1,46,15.48a2.44,2.44,0,0,1,1.76.75l4.63,4.63a2.49,2.49,0,0,1,0,3.52l-9.86,9.94L52,43.77a2.52,2.52,0,0,1,.1,3.43l-4.46,5a2.43,2.43,0,0,1-1.77.84ZM34.32,39a1.5,1.5,0,0,1,1.06.44L45.74,49.84l3.8-4.29L39.35,35.37a1.51,1.51,0,0,1,0-2.12L49.88,22.62,46,18.69,35.38,29.32a1.55,1.55,0,0,1-2.12,0L22.67,18.68l-3.94,3.94L29.27,33.25a1.51,1.51,0,0,1,0,2.12L19.09,45.55l3.79,4.29L33.25,39.4A1.54,1.54,0,0,1,34.32,39Z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 68.6 68.6"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Path 168","d":"M8.213 17.184l-4.679-.068a.644.644 0 0 0-.521 1.036l11.008 14.4a.479.479 0 0 0 .774-.016l10.089-14.44a.647.647 0 0 0-.531-1.018h-3.5a.644.644 0 0 1-.647-.622c-.163-4.752-1.178-15.189-6.862-16.455H.002c7.858.694 8.762 13.43 8.866 16.522a.642.642 0 0 1-.655.661z","fill":"#85d1c5"}));
}

Icon.displayName = "Icon";

Icon.defaultProps = {"width":"25","height":"32.741","viewBox":"0 0 25 32.741"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Path 163","d":"M8.213 15.557l-4.679.068a.644.644 0 0 1-.521-1.036L14.021.189a.479.479 0 0 1 .774.016l10.089 14.441a.647.647 0 0 1-.531 1.018h-3.5a.644.644 0 0 0-.647.622c-.163 4.752-1.178 15.189-6.862 16.456H0c7.858-.694 8.762-13.43 8.866-16.523a.642.642 0 0 0-.653-.662z","fill":"#ddd"}));
}

Icon.displayName = "Icon";

Icon.defaultProps = {"width":"25","height":"32.742","viewBox":"0 0 25 32.742"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M108.8 92.5v.8h-1.5v4h-.9v-4h-1.5v-.8h3.9zm5.2 4.7l-.2-2.8v-1.3h-.1c-.1.4-.3 1-.4 1.4l-.9 2.6h-1l-.9-2.7c-.1-.3-.2-.9-.3-1.3h-.1v1.3l-.2 2.8h-.9l.3-4.8h1.4l.8 2.3c.1.4.2.7.3 1.2l.3-1.2.8-2.4h1.4l.4 4.8h-.7zM15.6 10.7l-.8 4.8s21.2-8 18.7 7.1C31 37.6 23 76.5 23 76.5S21.5 91.5.2 93c0 2.8-.5 4.1-.5 4.1h36.6L55.5-.5 15.6 10.7","fill":"#231f20","key":0}),React.createElement("path",{"d":"M42.8 95.3h27.1l-8.5-6.8 36.7 3-9.8-7.5 20.2-14.2s-22.4-4.7-27.4-6.1c1.1-2.2 1.2-2.1 10.1-13.8 0 0-18.6 9-24.4 11.7C77.5 49.1 101.5 21 101.5 21s-30.2 7.6-34.9 8.8C65.4 25.6 60 7.9 60 7.9L42.8 95.3","fill":"#e1251b","key":1}),React.createElement("path",{"d":"M40.4 97.3h35.3s-6.2-5-7.9-6.3c8.8.7 36.9 3 36.9 3s-10.3-8-12.9-10c3.5-2.5 21.7-15.3 21.7-15.3l-4.5-.9c-.2 0-17.3-3.6-24.8-5.4.7-1 1.9-2.6 4.4-5.8l9.3-12.2s-16.2 7.8-23.4 11.2c8.3-9.7 32.6-38.2 32.6-38.2s-35.8 9-39.1 9.8c-.9-3-8.4-27.6-8.4-27.6L40.4 97.3zm20-81.2c2 6.4 4.9 16 4.9 16l1.8-.5s20.5-5.2 28.8-7.2c-6.3 7.4-36.8 43-36.8 43s18.2-8.7 25.3-12.2c-4 5.2-4.4 5.7-5.3 7.6L78 65l2.3.6c3.7 1 16.2 3.7 23.1 5.2C98.6 74.2 85 83.9 85 83.9l6.6 5.1c-9-.7-36.5-3-36.5-3s7.1 5.7 9.2 7.3h-19c.7-4.1 12.6-64.7 15.1-77.2M121.1 37.3h19.1v5h-13.1v6.3h11.3v4.6h-11.3v11.2h-6V37.3M148.6 41.7h-5.4v-4.4h5.4v4.4zm-5.4 3.1h5.4v19.6h-5.4V44.8M152.9 44.8h5.1v3.6h.1c1-2.5 3.6-4.2 6.3-4.2.4 0 .8.1 1.2.2v5c-.5-.1-1.3-.2-1.9-.2-4 0-5.3 2.8-5.3 6.3v8.9H153V44.8M171.1 58c0 2.4 2 3.3 4.1 3.3 1.6 0 3.5-.6 3.5-2.5 0-1.6-2.2-2.2-6.1-3-3.1-.7-6.2-1.8-6.2-5.2 0-5 4.3-6.3 8.6-6.3s8.2 1.4 8.7 6.3h-5.1c-.2-2.1-1.7-2.7-3.7-2.7-1.2 0-3 .2-3 1.8 0 1.9 3 2.2 6.1 2.9 3.2.7 6.2 1.9 6.2 5.5 0 5.2-4.5 6.8-9 6.8-4.6 0-9-1.7-9.2-6.9h5.1M193.4 44.8h4v3.6h-4v9.7c0 1.8.5 2.3 2.3 2.3.6 0 1.1 0 1.7-.2v4.2c-.9.2-2.1.2-3.2.2-3.3 0-6.2-.8-6.2-4.7V48.4h-3.3v-3.6h3.3v-5.9h5.4v5.9M229.1 46.4c-.4-2.7-3-4.8-5.9-4.8-5.4 0-7.4 4.6-7.4 9.3 0 4.5 2 9.1 7.4 9.1 3.6 0 5.7-2.5 6.2-6.1h5.8c-.6 6.8-5.3 11.1-11.9 11.1-8.4 0-13.3-6.3-13.3-14.1 0-8.1 4.9-14.3 13.3-14.3 6 0 11 3.5 11.7 9.8h-5.9M237.7 50.8c.3-5.1 4.8-6.6 9.2-6.6 3.9 0 8.6.9 8.6 5.6V60c0 1.8.2 3.6.7 4.4h-5.5c-.2-.6-.3-1.3-.4-1.9-1.7 1.8-4.2 2.4-6.6 2.4-3.7 0-6.7-1.9-6.7-5.9 0-4.4 3.3-5.5 6.7-6 3.3-.5 6.4-.4 6.4-2.6 0-2.3-1.6-2.7-3.5-2.7-2.1 0-3.4.8-3.6 3h-5.3v.1zm12.4 4c-.9.8-2.8.8-4.5 1.1-1.7.3-3.2.9-3.2 2.9s1.6 2.5 3.3 2.5c4.2 0 4.4-3.3 4.4-4.5v-2M258.9 44.8h5.1v2.7h.1c1.4-2.2 3.7-3.3 6-3.3 5.7 0 7.2 3.2 7.2 8.1v12.1H272V53.3c0-3.2-.9-4.8-3.5-4.8-2.9 0-4.2 1.6-4.2 5.6v10.3h-5.4V44.8M281.2 50.8c.3-5.1 4.8-6.6 9.2-6.6 3.9 0 8.6.9 8.6 5.6V60c0 1.8.2 3.6.7 4.4h-5.5c-.2-.6-.3-1.3-.4-1.9-1.7 1.8-4.2 2.4-6.6 2.4-3.7 0-6.7-1.9-6.7-5.9 0-4.4 3.3-5.5 6.7-6 3.3-.5 6.4-.4 6.4-2.6 0-2.3-1.6-2.7-3.5-2.7-2.1 0-3.4.8-3.6 3h-5.3v.1zm12.5 4c-.9.8-2.8.8-4.5 1.1-1.7.3-3.2.9-3.2 2.9s1.6 2.5 3.3 2.5c4.2 0 4.4-3.3 4.4-4.5v-2M317.3 61.9c-1.3 2.1-3.5 3-6 3-5.9 0-8.8-5.1-8.8-10.5 0-5.3 2.9-10.2 8.7-10.2 2.3 0 4.6 1 5.9 2.9h.1v-9.9h5.4v27.1h-5.1v-2.4h-.2zm-4.7-13.6c-3.5 0-4.8 3-4.8 6.3 0 3.1 1.4 6.3 4.8 6.3 3.6 0 4.6-3.1 4.6-6.3 0-3.2-1.1-6.3-4.6-6.3M332 41.7h-5.4v-4.4h5.4v4.4zm-5.4 3.1h5.4v19.6h-5.4V44.8M336.1 50.8c.3-5.1 4.8-6.6 9.2-6.6 3.9 0 8.6.9 8.6 5.6V60c0 1.8.2 3.6.7 4.4h-5.5c-.2-.6-.3-1.3-.4-1.9-1.7 1.8-4.2 2.4-6.6 2.4-3.7 0-6.7-1.9-6.7-5.9 0-4.4 3.3-5.5 6.7-6 3.3-.5 6.4-.4 6.4-2.6 0-2.3-1.6-2.7-3.5-2.7-2.1 0-3.4.8-3.6 3h-5.3v.1zm12.4 4c-.9.8-2.8.8-4.5 1.1-1.7.3-3.2.9-3.2 2.9s1.6 2.5 3.3 2.5c4.2 0 4.4-3.3 4.4-4.5v-2M358.1 44.8h5.1v2.7h.1c1.4-2.2 3.7-3.3 6-3.3 5.7 0 7.2 3.2 7.2 8.1v12.1h-5.4V53.3c0-3.2-1-4.8-3.5-4.8-2.9 0-4.2 1.6-4.2 5.6v10.3H358V44.8M120.8 79.3h2.6v18.1h-2.6V79.3M127.8 84.2h2.4v2.1h.1c.7-1.5 2.5-2.4 4.3-2.4 3.4 0 5 2.1 5 5.7v7.9h-2.4v-6.9c0-3.1-.7-4.6-2.8-4.7-2.8 0-4 2.2-4 5.5v6.1H128V84.2M142.7 94.8c1 .6 2.3.9 3 .9 1.1 0 2.5-.5 2.5-1.9 0-2.4-5.7-2.2-5.7-5.9 0-2.8 2.1-4.1 4.7-4.1 1.1 0 2.1.2 3 .5l-.2 2.1c-.5-.3-2-.7-2.6-.7-1.2 0-2.3.5-2.3 1.6 0 2.7 5.7 1.9 5.7 6.2 0 2.8-2.3 4.1-4.6 4.1-1.2 0-2.5-.1-3.6-.7l.1-2.1M165.5 97.4h-2.4v-2.1h-.1c-.7 1.5-2.5 2.4-4.3 2.4-3.4 0-5-2.1-5-5.7v-7.9h2.4V91c0 3.1.7 4.6 2.8 4.7 2.8 0 4-2.2 4-5.5v-6.1h2.4v13.3M169.2 84.2h2.3v2.1h.1c.6-1.4 2.1-2.4 3.5-2.4.7 0 1.1.1 1.6.2v2.2c-.4-.2-.9-.2-1.4-.2-2.2 0-3.6 2.1-3.6 5.4v6h-2.4V84.2M178.9 85.1c1.2-.7 2.7-1.2 4.4-1.2 3.8 0 5.3 1.9 5.3 5.5v5.5c0 1.5.1 2.2.1 2.6h-2.3v-1.7h-.1c-.6.8-1.9 2-4.1 2-2.9 0-4.9-1.2-4.9-4.1 0-3.3 3.6-4.4 6.2-4.4 1 0 1.6 0 2.6.1 0-2.3-.8-3.5-3.3-3.5-1.4 0-2.9.5-3.8 1.4l-.1-2.2zm7.2 6c-.5 0-1-.1-1.6-.1-1.3 0-4.6.2-4.6 2.6 0 1.4 1.4 2.2 2.5 2.2 2.4 0 3.7-1.5 3.7-3.5v-1.2M192.2 84.2h2.4v2.1c.7-1.5 2.5-2.4 4.3-2.4 3.4 0 5 2.1 5 5.7v7.9h-2.4v-6.9c0-3.1-.7-4.6-2.8-4.7-2.8 0-4 2.2-4 5.5v6.1h-2.4V84.2M216 86.4c-.9-.4-1.9-.6-2.7-.6-2.7 0-4.3 2.4-4.3 5 0 2.4 1.3 5 4.4 5 .8 0 1.9-.3 2.6-.8l.2 2.2c-1 .5-2.2.5-3.1.5-4 0-6.8-3.1-6.8-6.9 0-4 2.7-6.9 6.8-6.9 1 0 2.3.2 3 .5l-.1 2M229.2 96.9c-.9.3-2 .9-4.2.9-4.7 0-6.9-2.9-6.9-7.2 0-3.9 2.5-6.7 6.2-6.7 4.4 0 5.8 3.2 5.8 7.5h-9.5c0 2.6 2.1 4.4 4.4 4.4 1.6 0 3.5-.8 4.1-1.3v2.4h.1zm-1.5-7.4c0-2-1.2-3.7-3.3-3.7-2.4 0-3.4 2-3.6 3.7h6.9M253.5 82.3c-1.1-.7-2.4-1-3.7-1-4.2 0-7 3-7 7.1 0 4.3 3.1 7.1 6.8 7.1 1.3 0 3-.3 4-.9l.2 2.5c-1.4.6-3.1.6-4.1.6-5.7 0-9.6-3.7-9.6-9.5 0-5.6 4.1-9.3 9.6-9.3 1.4 0 2.8.2 4.1.8l-.3 2.6M261.5 83.9c4 0 6.7 2.9 6.7 6.9 0 3.8-2.8 6.9-6.7 6.9-4 0-6.8-3.1-6.8-6.9 0-4 2.7-6.9 6.8-6.9zm0 11.9c2.9 0 4.1-2.6 4.1-5 0-2.5-1.5-5-4.1-5-2.6 0-4.2 2.4-4.2 5 0 2.4 1.3 5 4.2 5","fill":"#231f20","key":2}),React.createElement("defs",{"key":3},React.createElement("path",{"id":"a","d":"M-.3-.5h378.7v103H-.3z"})),React.createElement("clipPath",{"id":"b","key":4},React.createElement("use",{"xlinkHref":"#a","overflow":"visible"})),React.createElement("path",{"d":"M270.5 84.2h2.3v2.1h.1c.7-1.4 2.1-2.4 3.5-2.4.7 0 1.1.1 1.6.2v2.2c-.4-.2-.9-.2-1.4-.2-2.2 0-3.6 2.1-3.6 5.4v6h-2.4V84.2M279.5 84.2h2.3V86c.7-1 2.2-2.2 4.5-2.2 3.8 0 5.7 3.1 5.7 6.7s-1.7 7.2-5.7 7.2c-2.3 0-3.7-.9-4.4-2.1h.1v7.3h-2.4V84.2h-.1zm6.4 1.6c-2.7 0-3.9 2.5-3.9 5 0 2.2 1.1 4.9 3.9 4.9 2.6 0 3.7-2.9 3.7-5 0-2.4-1.1-4.9-3.7-4.9","clipPath":"url(#b)","fill":"#231f20","key":5}),React.createElement("path",{"d":"M300.8 83.9c4 0 6.7 2.9 6.7 6.9 0 3.8-2.8 6.9-6.7 6.9-4 0-6.8-3.1-6.8-6.9 0-4 2.7-6.9 6.8-6.9zm0 11.9c2.9 0 4.1-2.6 4.1-5 0-2.5-1.5-5-4.1-5-2.6 0-4.2 2.4-4.2 5 0 2.4 1.3 5 4.2 5M310.3 84.2h2.3v2.1h.1c.7-1.4 2.1-2.4 3.5-2.4.7 0 1.1.1 1.6.2v2.2c-.4-.2-.9-.2-1.4-.2-2.2 0-3.6 2.1-3.6 5.4v6h-2.4V84.2M320 85.1c1.2-.7 2.7-1.2 4.4-1.2 3.8 0 5.3 1.9 5.3 5.5v5.5c0 1.5.1 2.2.1 2.6h-2.3v-1.7h-.1c-.6.8-1.9 2-4.1 2-2.9 0-4.9-1.2-4.9-4.1 0-3.3 3.6-4.4 6.2-4.4 1 0 1.6 0 2.6.1 0-2.3-.8-3.5-3.3-3.5-1.4 0-2.9.5-3.8 1.4l-.1-2.2zm7.2 6c-.5 0-1-.1-1.6-.1-1.3 0-4.6.2-4.6 2.6 0 1.4 1.4 2.2 2.5 2.2 2.4 0 3.7-1.5 3.7-3.5v-1.2M340.3 86.1h-3.5v7.3c0 1.5.9 2.4 2.1 2.4.8 0 1.3-.2 1.7-.5v2.1c-.5.2-1.3.4-2.1.4-2.5 0-4.1-1.2-4.1-3.8v-7.8h-3v-2h3v-3.1l2.4-.8v3.9h3.5v1.9M347.3 81.2h-2.8v-2.8h2.8v2.8zm-2.6 3h2.4v13.3h-2.4V84.2M356.5 83.9c4 0 6.7 2.9 6.7 6.9 0 3.8-2.8 6.9-6.7 6.9-4 0-6.8-3.1-6.8-6.9 0-4 2.7-6.9 6.8-6.9zm0 11.9c2.9 0 4.1-2.6 4.1-5 0-2.5-1.5-5-4.1-5-2.6 0-4.2 2.4-4.2 5 0 2.4 1.3 5 4.2 5M365.5 84.2h2.4v2.1h.1c.7-1.5 2.5-2.4 4.3-2.4 3.4 0 5 2.1 5 5.7v7.9h-2.4v-6.9c0-3.1-.7-4.6-2.8-4.7-2.8 0-4 2.2-4 5.5v6.1h-2.4V84.2","fill":"#231f20","key":6}),React.createElement("path",{"fill":"none","stroke":"#e1251b","d":"M120.1 72.5h258.2M120.1 72.5h258.2","key":7}),React.createElement("path",{"fill":"none","d":"M-.3-.5h378.7v103H-.3z","key":8})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 378 102"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M635.45 133.92a6.21 6.21 0 0 0-1.87 4.53 6.27 6.27 0 0 0 1.86 4.57 6.4 6.4 0 0 0 9.06 0 6.24 6.24 0 0 0 1.87-4.57 6.39 6.39 0 0 0-10.92-4.53zm9.79 9.82a7.42 7.42 0 0 1-10.53 0 7.25 7.25 0 0 1-2.16-5.29 7.44 7.44 0 1 1 12.69 5.29zm-3.87-8.1a3.6 3.6 0 0 0-1.73-.31h-1.23v3h1.3a4 4 0 0 0 1.37-.18 1.26 1.26 0 0 0 .84-1.28 1.23 1.23 0 0 0-.55-1.23zm-1.54-1.29a6.39 6.39 0 0 1 2.23.29 2 2 0 0 1 1.27 2.07 1.78 1.78 0 0 1-.8 1.61 3 3 0 0 1-1.19.4 2 2 0 0 1 1.41.8 2.21 2.21 0 0 1 .45 1.27v1.2a1.12 1.12 0 0 0 .07.43l.05.1H642v-.08-1a2 2 0 0 0-.77-1.88 3.53 3.53 0 0 0-1.6-.27h-1.14v3.23H637v-8.17z","key":0}),React.createElement("path",{"d":"M605.71 60.33v-1.21a4.46 4.46 0 0 0 .51-.47 50.84 50.84 0 0 0 1.19-7.72 31 31 0 0 0 2.58 6.5 15.32 15.32 0 0 1-4.28 2.9zm-14.62 5.2s-1.59-4.35-1.59-4.39a43.1 43.1 0 0 0-6.24-.13c-.41.21-1.5.5-1.72.63s-.6-.08-.82-.07a5.7 5.7 0 0 1-.86-.13l-1.31.17a2.47 2.47 0 0 1-1.2-.75l-.36-.6-.06-.86-.6-.68v-1l-.43-.72.53-1.22s1.08-.44 1.87-.71c-.91-.14-1.08-.52-1.17-.78.66-.17 2-.4 2.89-.61a4.17 4.17 0 0 1 2 .61c.38.27.89 1 1.33 1.29.8.51 3.66.65 5 .44 0 0 .06-5.06-.64-5.38a31.45 31.45 0 0 1-2.93-3.43 4 4 0 0 1-.57-1.31c-.28-.27-.32-.46 0-.74a2 2 0 0 1 .25-.77c.89-1.62 3.4-4.74 3.63-5.16.35-.66.31-.27-.43-4.59a4.81 4.81 0 0 1 .08-2.78c.38-1 1.79-1.38 2.67-1.54a5.39 5.39 0 0 0 3.68-2v-1.9c0-.02-4.88.63-4.49-1.81 0 0-.7-.83-.62-.89a7.4 7.4 0 0 0 1.22-1.19c-1.22.07-1.75-.06-1.75-.13a11.64 11.64 0 0 0-.13-1.72c-1.18 0-1.64-1-.85-1.75a2.27 2.27 0 0 0 .91-1.45c.17-.77-.58-1.45-.48-2.36a10.05 10.05 0 0 1 1.59-4.07 2.59 2.59 0 0 1-.15-2.71c1.05-1.66 2.93-2.39 4.83-3a19 19 0 0 1 7.6-1c1.06.07 2 .81 2.91.6 2.8-.6 4.77 2.1 8.74.87a6.06 6.06 0 0 1-4.16 1.13 11.75 11.75 0 0 1 4.24 1c.51.31 1.56.08 2.33.27 1.86.46 3.53.74 5.34 1.23-1 .19-4.59 1.28-5.63.91.55.33 5.93.89 7 1.92s1.24 2.34 2.6 3.22a17.16 17.16 0 0 0 3.86 1.42c-.18.58-2.24.17-2.78.39-.91.36-1 .76-1.93 1-.72.2-3.19-.56-3.85-.13-.24.15-1.71.55-1.71 1.93 3.19.28 3.16 1 5.65 1.43l-2 .41 2.18.12-1.73.29a5.38 5.38 0 0 1 2.32.71 7.23 7.23 0 0 0-4.43.65 33 33 0 0 0 4.78 0 25.26 25.26 0 0 0-4.84 1.69c-.3 1.18-.27 2.14-1.25 2.68a22.5 22.5 0 0 1-2.68 1.4c1.79.87 2.75 1.75 4 1.61-5.48 1.93-14.66-1.3-19.29-3.85l.22.7s3.26 2.44 4.88 2.84c1.41.34 4 1.45 4.4 2.07 2.12 3.15 2.12 4.7 2.71 8.37 1.5 5.16 4.85 15.8 3.24 20.49a47.88 47.88 0 0 1-10.75 5.11c.11 1 .25 2 .32 2.75s.36 3 .77 3.47c1 1.08 1.47 2.9 1.93 3.63 1.78 2.8 2.47 3.39 3.16 5.55a18.67 18.67 0 0 1 .31 6.71 13.46 13.46 0 0 0-.93 4.29c4.08 6.17 4.32 19.17 5.33 23.41.74-.43 3.4-3.13 7.66-4 4-.85 11.48-1.31 15.48-1.7a5.39 5.39 0 0 0 2.82-.63c-.86-1 .83-1.79 1.34-2.13a14.71 14.71 0 0 0 1.7-2.44c1-1.31 1.74-.7 2.93-1.73.5-1.08 0-1 1-1.74a26.91 26.91 0 0 1 7.19 7.61c11 8.4 7.91 9.36 7.91 9.36s-.89.29-1.42.36c-.88.68-2.77-.14-3.74-.58a12.07 12.07 0 0 0-2-.77 6.34 6.34 0 0 1-2.81-.73c-.73-.43-1.51.21-2.6-.62-.49-.38-1 .3-2.87-.62a9.78 9.78 0 0 0-2.84-.47l-.6-.33c-2.08.66-10.92 4.77-12.4 5.35-6 2.34-12.19 5.4-17.28 7.64-.29.13-1.15.43-1.47.54-.23.85-1.9.38-3.6-1-2.83-4.21-8.73-18.34-10.5-23.51a1.16 1.16 0 0 1-.56-.49c-.47-.86-1.69-2.71-1.72-2.71s-1.33 1-2.74 2.37c-3.93 6.48-14.54 12.61-14.61 13.38.31 1.54-.69 7-1.86 9.79-2.77 6.72-7.85 10.88-11.86 16.82-.65.91-3.07 4.62-3 5.69 1.25 0 .7 1.73.6 2.33a14.46 14.46 0 0 0 .62 2.9c.26 1.64-.68 1.76-.74 3.33.46 1.1.7.69.6 1.91a24.4 24.4 0 0 1-9.41.27c-14.32 1.55-13.87-.58-13.87-.58-.18 0 .39-.85.71-1.29.1-1.1 2-1.93 3-2.34a21.92 21.92 0 0 0 2.5-1.15 6.32 6.32 0 0 1 2.46-1.56c.8-.24.86-1.24 2.21-1.48.62-.1.47-.94 2.42-1.67.86-.33 1.62-1.82 1.62-1.82s3-4.27 3.28-5.37c1.45-5.94 11.09-27.31 9.89-24.24.15-.08-.08-3.21.23-4.46a17.53 17.53 0 0 0 1.25-2.48c1.33-2.42 9.83-14 11.86-16.52a4.46 4.46 0 0 0 .79-1.26c.17-.5-.34-.34-.16-.85s2.08-2.79 2.18-3.06a24.17 24.17 0 0 1 2.15-2.79c1-1.48.49-1.57 1.5-3.06 0-.07.66-4.65 2-7 .81-1.25 0-6.71 0-6.71a7.12 7.12 0 0 0-2.85 1 5.13 5.13 0 0 1-3.19 1l-1.06-.1-.17-.7c-.57 0-.75 0-.89-.29v-.69l-.4-.26c-.18-.21-.26-.37-.24-.49v-.47l-.54-.45-.18-.64 1-1a.6.6 0 0 1-.52-.63 25.28 25.28 0 0 0 2.73-1.13 10.15 10.15 0 0 1 2.28 0s2.41.57 2.85-.01zM427.72 75.87a7.05 7.05 0 0 0 3-1.44c1-.93 1.56-2.74 1.56-5.45V34.07q0-3.6-1.27-5a6.05 6.05 0 0 0-3.34-1.57v-3.17h20.8v8.52a24 24 0 0 1 7.19-7.07 17.62 17.62 0 0 1 9.74-2.85q7.65 0 11.83 3.95t4.23 13.86v28.7q0 4 1.34 5.17a7 7 0 0 0 2.85 1.26V79h-23.9v-3.41a5.68 5.68 0 0 0 2.13-1.16q1.15-1.09 1.16-5V40.68a17.32 17.32 0 0 0-.81-6.09 5.36 5.36 0 0 0-5.51-3.65A8.48 8.48 0 0 0 453 33.2a19.57 19.57 0 0 0-3.94 4.46v31.78q0 3.9 1.15 5a5.84 5.84 0 0 0 2.16 1.17V79h-24.65zM511 59.65q2.25 6.65 8.63 6.64 5.79 0 8-4.94t2.18-14.6q0-10.19-2.33-14.83t-7.81-4.64q-6.07 0-8.1 5t-2 14.46q-.03 8.71 1.43 12.91zm-8.42 10.45a30.38 30.38 0 0 1-8-8.1q-4.58-6.82-4.57-16.54 0-12.24 8-20.21t21.65-8a34.14 34.14 0 0 1 9.44 1.23 32.41 32.41 0 0 1 6.64 2.54c8.58 1.07 11.86-5.53 6.17-13.67 10.45-1.47 16.16 9.67 8.16 18.06-2 1.83-4.76 1.32-6.9 5.14a24 24 0 0 1 4.36 8 30 30 0 0 1 1.57 9.89q0 16.8-13.07 23-6.83 3.34-17.03 3.33c-1.48 0-2.46 0-2.93-.08a16 16 0 0 0-2-.09 16.44 16.44 0 0 1-6.75-1.69 5.42 5.42 0 0 0-.81 2.9 4.42 4.42 0 0 0 1.07 3.19 5 5 0 0 0 3 1.4c.63.09 2 .18 4.09.27s3.7.06 4.86.06l8.5.13a33.2 33.2 0 0 1 12.14 2.2q9.39 4 9.4 14.29 0 13.31-14.07 18.29-7.41 2.6-18.66 2.59a59.29 59.29 0 0 1-15.84-1.86q-11-3.12-11-10.64a10.23 10.23 0 0 1 2.3-6q2.35-3.06 8.11-4v-.93a18.58 18.58 0 0 1-5.56-3.12 10 10 0 0 1-3.06-7.68 12.37 12.37 0 0 1 4.8-9.77 35.55 35.55 0 0 1 5.99-4.13zm6.36 41.14q3.44 2.34 9.9 2.34a32.43 32.43 0 0 0 9.5-1.17q7-2.22 7-8.14a6.55 6.55 0 0 0-2-5.22q-2-1.69-7.22-1.69h-17a17.85 17.85 0 0 0-2.33 2.87 8.86 8.86 0 0 0-1.26 4.56 7.46 7.46 0 0 0 3.41 6.45zm-295.79-87v38.35a17.56 17.56 0 0 0 .81 6.09 5.37 5.37 0 0 0 5.51 3.66 8.56 8.56 0 0 0 5.69-2.26 19.63 19.63 0 0 0 3.94-4.47V33.84c0-2.59-.38-4.26-1.16-5a9 9 0 0 0-4.35-1.74v-2.83h22.31v44.92q0 3.6 1.28 5a4.14 4.14 0 0 0 1.57 1V79h-19v-8.57a24.15 24.15 0 0 1-7.19 7.08 17.66 17.66 0 0 1-9.74 2.84q-7.66 0-11.83-3.94t-4.24-13.86V33.84q0-4-1.33-5.16a9 9 0 0 0-4.58-1.57v-2.84zm-62.69 48.92c4.63-3 8.94-9.32 8.94-19.91q0-9.73-2.63-15.39c-3-6.39-10.58-10-18.62-10q-6.56 0-8.63 1.72t-2 5.49v42.67q16.06-.24 22.94-4.58zM132 85.8h-4.3v36.08q0 9.72 2.85 13.14t11.39 3.69v4.67H90v-4.67q8.23-.45 11.24-3.51t3-13.32V40.46c0-7.14-1.18-11.78-3.56-13.95q-2.37-2.16-10.68-3v-4.65h49.31q16.22 0 26.26 3.87Q185 30.56 185 50.9q0 15-9.73 23.66a35.14 35.14 0 0 1-15.73 8.27c22 8.48 34.86 36.73 36.17 37.78 13.89 20.43 34 3.56 28.92-14.74 5.73.41 15 9 13.26 19.45-2.32 24.41-42 42.87-65.09 5.11-5.99-13.64-13.21-42.21-40.8-44.63zm197.89 45.72q2 6.66 8.06 6.66 5.75 0 7.54-5.11t1.8-16.61q0-11.46-1.92-16.57a7.18 7.18 0 0 0-7.37-5.16q-6 0-8.06 6.66-1.33 4.45-1.34 15.07t1.24 15.06zm-11.19-35.8a25.08 25.08 0 0 1 19.2-8.29 24.52 24.52 0 0 1 19.25 8.47 29.77 29.77 0 0 1 7.54 20.53 30.24 30.24 0 0 1-7.42 20.47q-7.42 8.52-19.37 8.53a24.93 24.93 0 0 1-19.2-8.3q-7.59-8.35-7.59-20.7t7.59-20.71zm73.67-19.92a6.33 6.33 0 0 0 2.54-1.19c1.16-1 1.74-2.92 1.74-5.63V34.07c0-2.4-.4-4-1.22-4.87a6.37 6.37 0 0 0-3-1.58v-3.29h21v45.11q0 3.9 1.16 5a6.56 6.56 0 0 0 2.58 1.31V79h-24.8zM398 2.9a9 9 0 0 1 6.52-2.72A8.7 8.7 0 0 1 411 2.9a8.75 8.75 0 0 1 2.73 6.5A8.91 8.91 0 0 1 411 16a8.77 8.77 0 0 1-6.44 2.67 9.12 9.12 0 0 1-9.26-9.27 8.85 8.85 0 0 1 2.7-6.5zm-72 73a7 7 0 0 0 3-1.44c1-.93 1.57-2.74 1.57-5.45V34.07q0-3.6-1.27-5a5.83 5.83 0 0 0-3-1.5v-3.24h20.47v8.52a24.11 24.11 0 0 1 7.19-7.07 17.67 17.67 0 0 1 9.75-2.85q7.65 0 11.83 3.95t4.23 13.86v28.7q0 4 1.34 5.17a7 7 0 0 0 2.85 1.26V79H360v-3.41a5.76 5.76 0 0 0 2.13-1.16q1.15-1.09 1.16-5V40.68a17.32 17.32 0 0 0-.81-6.09 5.37 5.37 0 0 0-5.51-3.65 8.48 8.48 0 0 0-5.68 2.26 19.63 19.63 0 0 0-3.95 4.46v31.78q0 3.9 1.16 5a5.84 5.84 0 0 0 2.16 1.17V79h-24.72zm-66.41 0a7 7 0 0 0 3.06-1.44c1.05-.93 1.57-2.74 1.57-5.45V34.07c0-2.4-.43-4.06-1.27-5a6.09 6.09 0 0 0-3.34-1.57v-3.17h20.79v8.52a24.11 24.11 0 0 1 7.19-7.07 17.67 17.67 0 0 1 9.75-2.85q7.65 0 11.83 3.95t4.23 13.86v28.7q0 4 1.34 5.17a7 7 0 0 0 2.85 1.26V79h-23.97v-3.42a5.77 5.77 0 0 0 2.09-1.15q1.16-1.09 1.16-5V40.68a17.32 17.32 0 0 0-.81-6.09 5.37 5.37 0 0 0-5.51-3.65 8.51 8.51 0 0 0-5.69 2.26 19.81 19.81 0 0 0-3.94 4.46v31.78q0 3.9 1.16 5a5.94 5.94 0 0 0 2.25 1.2V79h-24.8zm111 64.63a6.76 6.76 0 0 0 2.75-1.1c1.31-1.05 2-3 2-5.81V98.68q0-3.71-1.33-5a6.58 6.58 0 0 0-3.2-1.48v-3.26h20.6v8.52a32 32 0 0 1 5.74-6 18.63 18.63 0 0 1 11.48-3.88q7.14 0 11.08 3.36a18.34 18.34 0 0 1 4.18 6.26h.81A31.57 31.57 0 0 1 431 91a18.11 18.11 0 0 1 10.62-3.42 16.6 16.6 0 0 1 11 4q4.8 4 4.81 12.64v29.87q0 4.11 1.33 5.28a6.78 6.78 0 0 0 3 1.19v3.1h-24.29v-3.29a6.07 6.07 0 0 0 2.34-1.12c.85-.77 1.27-2.49 1.28-5.16v-28.8a15.31 15.31 0 0 0-1.39-7.19c-.89-1.7-2.62-2.55-5.17-2.55q-3.07 0-6.49 2.84c-2.25 1.86-3.37 3.15-3.37 3.89v31.78q0 3.88 1.16 5a5.87 5.87 0 0 0 2.18 1.17v3.41h-23.43v-3.27a6 6 0 0 0 2.29-1.08q1.33-1.16 1.33-5.22v-28.78a16.49 16.49 0 0 0-1.27-7.13c-.86-1.74-2.61-2.61-5.28-2.61a9.65 9.65 0 0 0-6.79 3c-2.08 2-3.13 3.21-3.13 3.71v31.78q0 3.88 1.1 5a5.79 5.79 0 0 0 2.2 1.19v3.39h-24.55zm-102.65-9q2 6.66 8.06 6.66 5.75 0 7.54-5.11t1.8-16.61q0-11.46-1.91-16.57a7.2 7.2 0 0 0-7.43-5.17q-6 0-8.06 6.66-1.33 4.45-1.33 15.07t1.22 15.06zM256.7 95.72a25 25 0 0 1 19.19-8.29 24.55 24.55 0 0 1 19.26 8.47 29.81 29.81 0 0 1 7.54 20.53 30.24 30.24 0 0 1-7.43 20.47q-7.42 8.52-19.37 8.53a24.9 24.9 0 0 1-19.19-8.3q-7.6-8.35-7.6-20.7t7.6-20.71z","key":1}),React.createElement("path",{"d":"M524 124v3.43h-6.09v16h-4.29v-16h-6.13V124zm24.81 17.76a1.81 1.81 0 1 1 1.8 1.81 1.8 1.8 0 0 1-1.8-1.86zm-15.57-14.39V140h3.93a4.23 4.23 0 0 0 4.2-2.82 9.64 9.64 0 0 0 .65-3.7 8.67 8.67 0 0 0-1-4.54q-1-1.59-3.87-1.59zm7.8-2.95a6.76 6.76 0 0 1 3.47 2.46A8.5 8.5 0 0 1 546 130a14.27 14.27 0 0 1 .39 3.21 12.45 12.45 0 0 1-1.63 6.55 7.43 7.43 0 0 1-6.83 3.62h-8.78V124h8.78a11.43 11.43 0 0 1 3.07.37zm-46.15-.42h4.26v15.91h9.08v3.48h-13.34zM30.82 88.55c-1.82-2.83-3-8.44-2.12-11.55.37-1.3 2.51-7 3-8.68a73.81 73.81 0 0 0-10.35-5.93c-1.88-1.08-9.27-5.51-13.58-10.07-.32-.35-.63-.71-.94-1.07A2.84 2.84 0 0 1 7 48.46c4-6.12 13.31-15 14.28-15.88 2.53-2.44 4.25-5.41 6.35-6.65a11.44 11.44 0 0 1 8-1.36 21.27 21.27 0 0 1 3.86-1.46 3.12 3.12 0 0 0 .83-1.69c-.32-.42-2.32-1.7-2.79-2.7-1.21-.88-1.7-5.16-2.45-8.06 0-.63-2-6.55 5.63-9.21 4-1.4 11.48-3 10.18 1.68 1.18.41 1.65 2.24 2.13 3.54.59 1.64-.61 2.87-.27 3.28 1 1.2 2.9 3.11 2 3.52 0 0-.37.26-1.15.71 0 .08.2 1.27.4 2 0 0-1.39.34-1.42.3s1.23 1 1.23 1-.05.59-.12 1c1 .62.05 3-.56 3.28s-3.51.92-4.13 1.48a4.84 4.84 0 0 0-.52 1.06c-.24.78 2 2.31 2.77 2.48a13.36 13.36 0 0 1 1.72.58 11.44 11.44 0 0 1 2.78 1.78c1.52 1.59 2.46 3 3.93 7.16.15.44 5.19 9.67 5.82 10.74 0 0 .34-1.52 3.61-7.06 1-1.79 3.93-5.53 4.92-7.41.67-1.26-1-3.18-1.82-3.95a4.1 4.1 0 0 1-1-1.88.61.61 0 0 1 .37-.54 6.66 6.66 0 0 0 1-.71c.2-.12.21-.5.4-.66-.07-.44 1.31-1.48 2.22-2.13 1.36-1 2.56-.92 2.62-.23 2.09.33 1.5.86 1.6 1.3 1.09-.1 1.55.29 1.46 1.49.72.32 1.36.33 1.15 1.72 0 .26-.17 1.27-.19 1.56 0 .87-.53 1-1.1 1.83-.59.59-1.55 1.64-2.31 2.31s-3.5 11.8-5.06 15.55a35.47 35.47 0 0 1-4.92 8c-.23.29-.88 1.08-1.27 1.2a2.76 2.76 0 0 1-2.25-.27c-1.06-1.27-9.21-11.36-10-12.6-.3-.34-.86 8.68-1.79 13.48a94.57 94.57 0 0 1-2.75 10.43 4.08 4.08 0 0 1 .55 2.35c1.22 1 .54 4.23 1.58 4.62 1.27.48 3.39 1.76 4.35 2.17.14.12-.32.3-.19.43C67 83.77 76.34 93.69 77.85 95.39s2.36 4.2 2.8 4.67.12 3.32 0 3.59c-.11.69-3.1 3.32-4.1 4.21-1.51 1.47-14.52 16-17.4 18.93-.8.8-.19 1.54-.57 2.36-.57 1.24-.06 2.36.6 3.51.4.71.81 1.8 1.32 2.6.74 1.17 1.84 2.3 2.46 3.46.36.69 2.19 2.78 1.5 4.13a3.35 3.35 0 0 1-.36 1.62s-5.86 1.53-12.6-6.92c-7-2.11-8.7-6.44-8.7-6.44s1.74-1 1.79-1.09c1-1.84 3.32-3.31 4.95-4.37.34-.22.77-.07 1.27-.69a4.58 4.58 0 0 0 3.26-2 32.63 32.63 0 0 0 3.52-6.65c1-3.39 2.07-7.24 6-10.35a47.36 47.36 0 0 1 6.23-3.44c-1.68-1.16-21.32-10.85-23.13-11.93-.38 2.55-1 6.46-1.68 8.75-1 3.45-4.93 14.08-9.39 19.26a8.61 8.61 0 0 1-3.11 5.6c-1.22 1.52-8.5 12.44-10.45 15.36-.39.59-5.23 6.62-6.16 7.9a22.89 22.89 0 0 0-2.46 4.24c-.29.67.3 2.39 0 2.94a3.84 3.84 0 0 0-.28 1.37 16.65 16.65 0 0 0 1 4.16c.07.19 2.68 4.13 2.77 4.23a3.07 3.07 0 0 1 .94 2.52c0 .08.84.54 1.19 1 .21.31 0 1.13-.06 1.16-.19.33-.37.42-.54.42l-6.84-.6s-4.29-1.35-5.22-2.71l-1.95-5.15A18.49 18.49 0 0 1 0 154a5.08 5.08 0 0 1 1-.4c.34-1.28 1.46-2.07 3.83-3.07a5.66 5.66 0 0 1 2.59-2c2-1.85 4.08-5 4-5.28 1.86-4.7 2.54-10.27 3.84-13.72a21.7 21.7 0 0 1 9.09-10.78c1-14.62 5.23-25.28 6.58-30.14zM15.19 50.07A5.48 5.48 0 0 1 17 48.19c3.87-2.65 9.63-8.41 11.23-10C28 49 31.41 59 31.48 61.56c-.92.26-13.38-11.09-16.29-11.49z","key":2})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 665.46 169.49","fill":"#d31f36"};

module.exports = Icon;

Icon.default = Icon;


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spinner__ = __webpack_require__(122);

var classNames = __webpack_require__(8);

var LoadingPage = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('page-loading', props.className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Spinner__["a" /* default */], { className: "page-loading-spinner" })),
        props.children));
};
/* unused harmony default export */ var _unused_webpack_default_export = (LoadingPage);


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Papa Parse
	v4.3.7
	https://github.com/mholt/PapaParse
	License: MIT
*/
(function(root, factory)
{
	if (true)
	{
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module === 'object' && typeof exports !== 'undefined')
	{
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	}
	else
	{
		// Browser globals (root is window)
		root.Papa = factory();
	}
}(this, function()
{
	'use strict';

	var global = (function () {
		// alternative method, similar to `Function('return this')()`
		// but without using `eval` (which is disabled when
		// using Content Security Policy).

		if (typeof self !== 'undefined') { return self; }
		if (typeof window !== 'undefined') { return window; }
		if (typeof global !== 'undefined') { return global; }

		// When running tests none of the above have been defined
		return {};
	})();


	var IS_WORKER = !global.document && !!global.postMessage,
		IS_PAPA_WORKER = IS_WORKER && /(\?|&)papaworker(=|&|$)/.test(global.location.search),
		LOADED_SYNC = false, AUTO_SCRIPT_PATH;
	var workers = {}, workerIdCounter = 0;

	var Papa = {};

	Papa.parse = CsvToJson;
	Papa.unparse = JsonToCsv;

	Papa.RECORD_SEP = String.fromCharCode(30);
	Papa.UNIT_SEP = String.fromCharCode(31);
	Papa.BYTE_ORDER_MARK = '\ufeff';
	Papa.BAD_DELIMITERS = ['\r', '\n', '"', Papa.BYTE_ORDER_MARK];
	Papa.WORKERS_SUPPORTED = !IS_WORKER && !!global.Worker;
	Papa.SCRIPT_PATH = null;	// Must be set by your code if you use workers and this lib is loaded asynchronously

	// Configurable chunk sizes for local and remote files, respectively
	Papa.LocalChunkSize = 1024 * 1024 * 10;	// 10 MB
	Papa.RemoteChunkSize = 1024 * 1024 * 5;	// 5 MB
	Papa.DefaultDelimiter = ',';			// Used if not specified and detection fails

	// Exposed for testing and development only
	Papa.Parser = Parser;
	Papa.ParserHandle = ParserHandle;
	Papa.NetworkStreamer = NetworkStreamer;
	Papa.FileStreamer = FileStreamer;
	Papa.StringStreamer = StringStreamer;
	Papa.ReadableStreamStreamer = ReadableStreamStreamer;

	if (global.jQuery)
	{
		var $ = global.jQuery;
		$.fn.parse = function(options)
		{
			var config = options.config || {};
			var queue = [];

			this.each(function(idx)
			{
				var supported = $(this).prop('tagName').toUpperCase() === 'INPUT'
								&& $(this).attr('type').toLowerCase() === 'file'
								&& global.FileReader;

				if (!supported || !this.files || this.files.length === 0)
					return true;	// continue to next input element

				for (var i = 0; i < this.files.length; i++)
				{
					queue.push({
						file: this.files[i],
						inputElem: this,
						instanceConfig: $.extend({}, config)
					});
				}
			});

			parseNextFile();	// begin parsing
			return this;		// maintains chainability


			function parseNextFile()
			{
				if (queue.length === 0)
				{
					if (isFunction(options.complete))
						options.complete();
					return;
				}

				var f = queue[0];

				if (isFunction(options.before))
				{
					var returned = options.before(f.file, f.inputElem);

					if (typeof returned === 'object')
					{
						if (returned.action === 'abort')
						{
							error('AbortError', f.file, f.inputElem, returned.reason);
							return;	// Aborts all queued files immediately
						}
						else if (returned.action === 'skip')
						{
							fileComplete();	// parse the next file in the queue, if any
							return;
						}
						else if (typeof returned.config === 'object')
							f.instanceConfig = $.extend(f.instanceConfig, returned.config);
					}
					else if (returned === 'skip')
					{
						fileComplete();	// parse the next file in the queue, if any
						return;
					}
				}

				// Wrap up the user's complete callback, if any, so that ours also gets executed
				var userCompleteFunc = f.instanceConfig.complete;
				f.instanceConfig.complete = function(results)
				{
					if (isFunction(userCompleteFunc))
						userCompleteFunc(results, f.file, f.inputElem);
					fileComplete();
				};

				Papa.parse(f.file, f.instanceConfig);
			}

			function error(name, file, elem, reason)
			{
				if (isFunction(options.error))
					options.error({name: name}, file, elem, reason);
			}

			function fileComplete()
			{
				queue.splice(0, 1);
				parseNextFile();
			}
		}
	}


	if (IS_PAPA_WORKER)
	{
		global.onmessage = workerThreadReceivedMessage;
	}
	else if (Papa.WORKERS_SUPPORTED)
	{
		AUTO_SCRIPT_PATH = getScriptPath();

		// Check if the script was loaded synchronously
		if (!document.body)
		{
			// Body doesn't exist yet, must be synchronous
			LOADED_SYNC = true;
		}
		else
		{
			document.addEventListener('DOMContentLoaded', function () {
				LOADED_SYNC = true;
			}, true);
		}
	}




	function CsvToJson(_input, _config)
	{
		_config = _config || {};
		var dynamicTyping = _config.dynamicTyping || false;
		if (isFunction(dynamicTyping)) {
			_config.dynamicTypingFunction = dynamicTyping;
			// Will be filled on first row call
			dynamicTyping = {};
		}
		_config.dynamicTyping = dynamicTyping;

		if (_config.worker && Papa.WORKERS_SUPPORTED)
		{
			var w = newWorker();

			w.userStep = _config.step;
			w.userChunk = _config.chunk;
			w.userComplete = _config.complete;
			w.userError = _config.error;

			_config.step = isFunction(_config.step);
			_config.chunk = isFunction(_config.chunk);
			_config.complete = isFunction(_config.complete);
			_config.error = isFunction(_config.error);
			delete _config.worker;	// prevent infinite loop

			w.postMessage({
				input: _input,
				config: _config,
				workerId: w.id
			});

			return;
		}

		var streamer = null;
		if (typeof _input === 'string')
		{
			if (_config.download)
				streamer = new NetworkStreamer(_config);
			else
				streamer = new StringStreamer(_config);
		}
		else if (_input.readable === true && isFunction(_input.read) && isFunction(_input.on))
		{
			streamer = new ReadableStreamStreamer(_config);
		}
		else if ((global.File && _input instanceof File) || _input instanceof Object)	// ...Safari. (see issue #106)
			streamer = new FileStreamer(_config);

		return streamer.stream(_input);
	}






	function JsonToCsv(_input, _config)
	{
		var _output = '';
		var _fields = [];

		// Default configuration

		/** whether to surround every datum with quotes */
		var _quotes = false;

		/** whether to write headers */
		var _writeHeader = true;

		/** delimiting character */
		var _delimiter = ',';

		/** newline character(s) */
		var _newline = '\r\n';

		/** quote character */
		var _quoteChar = '"';

		unpackConfig();

		var quoteCharRegex = new RegExp(_quoteChar, 'g');

		if (typeof _input === 'string')
			_input = JSON.parse(_input);

		if (_input instanceof Array)
		{
			if (!_input.length || _input[0] instanceof Array)
				return serialize(null, _input);
			else if (typeof _input[0] === 'object')
				return serialize(objectKeys(_input[0]), _input);
		}
		else if (typeof _input === 'object')
		{
			if (typeof _input.data === 'string')
				_input.data = JSON.parse(_input.data);

			if (_input.data instanceof Array)
			{
				if (!_input.fields)
					_input.fields =  _input.meta && _input.meta.fields;

				if (!_input.fields)
					_input.fields =  _input.data[0] instanceof Array
									? _input.fields
									: objectKeys(_input.data[0]);

				if (!(_input.data[0] instanceof Array) && typeof _input.data[0] !== 'object')
					_input.data = [_input.data];	// handles input like [1,2,3] or ['asdf']
			}

			return serialize(_input.fields || [], _input.data || []);
		}

		// Default (any valid paths should return before this)
		throw 'exception: Unable to serialize unrecognized input';


		function unpackConfig()
		{
			if (typeof _config !== 'object')
				return;

			if (typeof _config.delimiter === 'string'
				&& _config.delimiter.length === 1
				&& Papa.BAD_DELIMITERS.indexOf(_config.delimiter) === -1)
			{
				_delimiter = _config.delimiter;
			}

			if (typeof _config.quotes === 'boolean'
				|| _config.quotes instanceof Array)
				_quotes = _config.quotes;

			if (typeof _config.newline === 'string')
				_newline = _config.newline;

			if (typeof _config.quoteChar === 'string')
				_quoteChar = _config.quoteChar;

			if (typeof _config.header === 'boolean')
				_writeHeader = _config.header;
		}


		/** Turns an object's keys into an array */
		function objectKeys(obj)
		{
			if (typeof obj !== 'object')
				return [];
			var keys = [];
			for (var key in obj)
				keys.push(key);
			return keys;
		}

		/** The double for loop that iterates the data and writes out a CSV string including header row */
		function serialize(fields, data)
		{
			var csv = '';

			if (typeof fields === 'string')
				fields = JSON.parse(fields);
			if (typeof data === 'string')
				data = JSON.parse(data);

			var hasHeader = fields instanceof Array && fields.length > 0;
			var dataKeyedByField = !(data[0] instanceof Array);

			// If there a header row, write it first
			if (hasHeader && _writeHeader)
			{
				for (var i = 0; i < fields.length; i++)
				{
					if (i > 0)
						csv += _delimiter;
					csv += safe(fields[i], i);
				}
				if (data.length > 0)
					csv += _newline;
			}

			// Then write out the data
			for (var row = 0; row < data.length; row++)
			{
				var maxCol = hasHeader ? fields.length : data[row].length;

				for (var col = 0; col < maxCol; col++)
				{
					if (col > 0)
						csv += _delimiter;
					var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
					csv += safe(data[row][colIdx], col);
				}

				if (row < data.length - 1)
					csv += _newline;
			}

			return csv;
		}

		/** Encloses a value around quotes if needed (makes a value safe for CSV insertion) */
		function safe(str, col)
		{
			if (typeof str === 'undefined' || str === null)
				return '';

			str = str.toString().replace(quoteCharRegex, _quoteChar+_quoteChar);

			var needsQuotes = (typeof _quotes === 'boolean' && _quotes)
							|| (_quotes instanceof Array && _quotes[col])
							|| hasAny(str, Papa.BAD_DELIMITERS)
							|| str.indexOf(_delimiter) > -1
							|| str.charAt(0) === ' '
							|| str.charAt(str.length - 1) === ' ';

			return needsQuotes ? _quoteChar + str + _quoteChar : str;
		}

		function hasAny(str, substrings)
		{
			for (var i = 0; i < substrings.length; i++)
				if (str.indexOf(substrings[i]) > -1)
					return true;
			return false;
		}
	}

	/** ChunkStreamer is the base prototype for various streamer implementations. */
	function ChunkStreamer(config)
	{
		this._handle = null;
		this._paused = false;
		this._finished = false;
		this._input = null;
		this._baseIndex = 0;
		this._partialLine = '';
		this._rowCount = 0;
		this._start = 0;
		this._nextChunk = null;
		this.isFirstChunk = true;
		this._completeResults = {
			data: [],
			errors: [],
			meta: {}
		};
		replaceConfig.call(this, config);

		this.parseChunk = function(chunk)
		{
			// First chunk pre-processing
			if (this.isFirstChunk && isFunction(this._config.beforeFirstChunk))
			{
				var modifiedChunk = this._config.beforeFirstChunk(chunk);
				if (modifiedChunk !== undefined)
					chunk = modifiedChunk;
			}
			this.isFirstChunk = false;

			// Rejoin the line we likely just split in two by chunking the file
			var aggregate = this._partialLine + chunk;
			this._partialLine = '';

			var results = this._handle.parse(aggregate, this._baseIndex, !this._finished);

			if (this._handle.paused() || this._handle.aborted())
				return;

			var lastIndex = results.meta.cursor;

			if (!this._finished)
			{
				this._partialLine = aggregate.substring(lastIndex - this._baseIndex);
				this._baseIndex = lastIndex;
			}

			if (results && results.data)
				this._rowCount += results.data.length;

			var finishedIncludingPreview = this._finished || (this._config.preview && this._rowCount >= this._config.preview);

			if (IS_PAPA_WORKER)
			{
				global.postMessage({
					results: results,
					workerId: Papa.WORKER_ID,
					finished: finishedIncludingPreview
				});
			}
			else if (isFunction(this._config.chunk))
			{
				this._config.chunk(results, this._handle);
				if (this._paused)
					return;
				results = undefined;
				this._completeResults = undefined;
			}

			if (!this._config.step && !this._config.chunk) {
				this._completeResults.data = this._completeResults.data.concat(results.data);
				this._completeResults.errors = this._completeResults.errors.concat(results.errors);
				this._completeResults.meta = results.meta;
			}

			if (finishedIncludingPreview && isFunction(this._config.complete) && (!results || !results.meta.aborted))
				this._config.complete(this._completeResults, this._input);

			if (!finishedIncludingPreview && (!results || !results.meta.paused))
				this._nextChunk();

			return results;
		};

		this._sendError = function(error)
		{
			if (isFunction(this._config.error))
				this._config.error(error);
			else if (IS_PAPA_WORKER && this._config.error)
			{
				global.postMessage({
					workerId: Papa.WORKER_ID,
					error: error,
					finished: false
				});
			}
		};

		function replaceConfig(config)
		{
			// Deep-copy the config so we can edit it
			var configCopy = copy(config);
			configCopy.chunkSize = parseInt(configCopy.chunkSize);	// parseInt VERY important so we don't concatenate strings!
			if (!config.step && !config.chunk)
				configCopy.chunkSize = null;  // disable Range header if not streaming; bad values break IIS - see issue #196
			this._handle = new ParserHandle(configCopy);
			this._handle.streamer = this;
			this._config = configCopy;	// persist the copy to the caller
		}
	}


	function NetworkStreamer(config)
	{
		config = config || {};
		if (!config.chunkSize)
			config.chunkSize = Papa.RemoteChunkSize;
		ChunkStreamer.call(this, config);

		var xhr;

		if (IS_WORKER)
		{
			this._nextChunk = function()
			{
				this._readChunk();
				this._chunkLoaded();
			};
		}
		else
		{
			this._nextChunk = function()
			{
				this._readChunk();
			};
		}

		this.stream = function(url)
		{
			this._input = url;
			this._nextChunk();	// Starts streaming
		};

		this._readChunk = function()
		{
			if (this._finished)
			{
				this._chunkLoaded();
				return;
			}

			xhr = new XMLHttpRequest();

			if (this._config.withCredentials)
			{
				xhr.withCredentials = this._config.withCredentials;
			}

			if (!IS_WORKER)
			{
				xhr.onload = bindFunction(this._chunkLoaded, this);
				xhr.onerror = bindFunction(this._chunkError, this);
			}

			xhr.open('GET', this._input, !IS_WORKER);
			// Headers can only be set when once the request state is OPENED
			if (this._config.downloadRequestHeaders)
			{
				var headers = this._config.downloadRequestHeaders;

				for (var headerName in headers)
				{
					xhr.setRequestHeader(headerName, headers[headerName]);
				}
			}

			if (this._config.chunkSize)
			{
				var end = this._start + this._config.chunkSize - 1;	// minus one because byte range is inclusive
				xhr.setRequestHeader('Range', 'bytes='+this._start+'-'+end);
				xhr.setRequestHeader('If-None-Match', 'webkit-no-cache'); // https://bugs.webkit.org/show_bug.cgi?id=82672
			}

			try {
				xhr.send();
			}
			catch (err) {
				this._chunkError(err.message);
			}

			if (IS_WORKER && xhr.status === 0)
				this._chunkError();
			else
				this._start += this._config.chunkSize;
		}

		this._chunkLoaded = function()
		{
			if (xhr.readyState != 4)
				return;

			if (xhr.status < 200 || xhr.status >= 400)
			{
				this._chunkError();
				return;
			}

			this._finished = !this._config.chunkSize || this._start > getFileSize(xhr);
			this.parseChunk(xhr.responseText);
		}

		this._chunkError = function(errorMessage)
		{
			var errorText = xhr.statusText || errorMessage;
			this._sendError(errorText);
		}

		function getFileSize(xhr)
		{
			var contentRange = xhr.getResponseHeader('Content-Range');
			if (contentRange === null) { // no content range, then finish!
					return -1;
					}
			return parseInt(contentRange.substr(contentRange.lastIndexOf('/') + 1));
		}
	}
	NetworkStreamer.prototype = Object.create(ChunkStreamer.prototype);
	NetworkStreamer.prototype.constructor = NetworkStreamer;


	function FileStreamer(config)
	{
		config = config || {};
		if (!config.chunkSize)
			config.chunkSize = Papa.LocalChunkSize;
		ChunkStreamer.call(this, config);

		var reader, slice;

		// FileReader is better than FileReaderSync (even in worker) - see http://stackoverflow.com/q/24708649/1048862
		// But Firefox is a pill, too - see issue #76: https://github.com/mholt/PapaParse/issues/76
		var usingAsyncReader = typeof FileReader !== 'undefined';	// Safari doesn't consider it a function - see issue #105

		this.stream = function(file)
		{
			this._input = file;
			slice = file.slice || file.webkitSlice || file.mozSlice;

			if (usingAsyncReader)
			{
				reader = new FileReader();		// Preferred method of reading files, even in workers
				reader.onload = bindFunction(this._chunkLoaded, this);
				reader.onerror = bindFunction(this._chunkError, this);
			}
			else
				reader = new FileReaderSync();	// Hack for running in a web worker in Firefox

			this._nextChunk();	// Starts streaming
		};

		this._nextChunk = function()
		{
			if (!this._finished && (!this._config.preview || this._rowCount < this._config.preview))
				this._readChunk();
		}

		this._readChunk = function()
		{
			var input = this._input;
			if (this._config.chunkSize)
			{
				var end = Math.min(this._start + this._config.chunkSize, this._input.size);
				input = slice.call(input, this._start, end);
			}
			var txt = reader.readAsText(input, this._config.encoding);
			if (!usingAsyncReader)
				this._chunkLoaded({ target: { result: txt } });	// mimic the async signature
		}

		this._chunkLoaded = function(event)
		{
			// Very important to increment start each time before handling results
			this._start += this._config.chunkSize;
			this._finished = !this._config.chunkSize || this._start >= this._input.size;
			this.parseChunk(event.target.result);
		}

		this._chunkError = function()
		{
			this._sendError(reader.error.message);
		}

	}
	FileStreamer.prototype = Object.create(ChunkStreamer.prototype);
	FileStreamer.prototype.constructor = FileStreamer;


	function StringStreamer(config)
	{
		config = config || {};
		ChunkStreamer.call(this, config);

		var string;
		var remaining;
		this.stream = function(s)
		{
			string = s;
			remaining = s;
			return this._nextChunk();
		}
		this._nextChunk = function()
		{
			if (this._finished) return;
			var size = this._config.chunkSize;
			var chunk = size ? remaining.substr(0, size) : remaining;
			remaining = size ? remaining.substr(size) : '';
			this._finished = !remaining;
			return this.parseChunk(chunk);
		}
	}
	StringStreamer.prototype = Object.create(StringStreamer.prototype);
	StringStreamer.prototype.constructor = StringStreamer;


	function ReadableStreamStreamer(config)
	{
		config = config || {};

		ChunkStreamer.call(this, config);

		var queue = [];
		var parseOnData = true;

		this.stream = function(stream)
		{
			this._input = stream;

			this._input.on('data', this._streamData);
			this._input.on('end', this._streamEnd);
			this._input.on('error', this._streamError);
		}

		this._nextChunk = function()
		{
			if (queue.length)
			{
				this.parseChunk(queue.shift());
			}
			else
			{
				parseOnData = true;
			}
		}

		this._streamData = bindFunction(function(chunk)
		{
			try
			{
				queue.push(typeof chunk === 'string' ? chunk : chunk.toString(this._config.encoding));

				if (parseOnData)
				{
					parseOnData = false;
					this.parseChunk(queue.shift());
				}
			}
			catch (error)
			{
				this._streamError(error);
			}
		}, this);

		this._streamError = bindFunction(function(error)
		{
			this._streamCleanUp();
			this._sendError(error.message);
		}, this);

		this._streamEnd = bindFunction(function()
		{
			this._streamCleanUp();
			this._finished = true;
			this._streamData('');
		}, this);

		this._streamCleanUp = bindFunction(function()
		{
			this._input.removeListener('data', this._streamData);
			this._input.removeListener('end', this._streamEnd);
			this._input.removeListener('error', this._streamError);
		}, this);
	}
	ReadableStreamStreamer.prototype = Object.create(ChunkStreamer.prototype);
	ReadableStreamStreamer.prototype.constructor = ReadableStreamStreamer;


	// Use one ParserHandle per entire CSV file or string
	function ParserHandle(_config)
	{
		// One goal is to minimize the use of regular expressions...
		var FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;

		var self = this;
		var _stepCounter = 0;	// Number of times step was called (number of rows parsed)
		var _input;				// The input being parsed
		var _parser;			// The core parser being used
		var _paused = false;	// Whether we are paused or not
		var _aborted = false;	// Whether the parser has aborted or not
		var _delimiterError;	// Temporary state between delimiter detection and processing results
		var _fields = [];		// Fields are from the header row of the input, if there is one
		var _results = {		// The last results returned from the parser
			data: [],
			errors: [],
			meta: {}
		};

		if (isFunction(_config.step))
		{
			var userStep = _config.step;
			_config.step = function(results)
			{
				_results = results;

				if (needsHeaderRow())
					processResults();
				else	// only call user's step function after header row
				{
					processResults();

					// It's possbile that this line was empty and there's no row here after all
					if (_results.data.length === 0)
						return;

					_stepCounter += results.data.length;
					if (_config.preview && _stepCounter > _config.preview)
						_parser.abort();
					else
						userStep(_results, self);
				}
			};
		}

		/**
		 * Parses input. Most users won't need, and shouldn't mess with, the baseIndex
		 * and ignoreLastRow parameters. They are used by streamers (wrapper functions)
		 * when an input comes in multiple chunks, like from a file.
		 */
		this.parse = function(input, baseIndex, ignoreLastRow)
		{
			if (!_config.newline)
				_config.newline = guessLineEndings(input);

			_delimiterError = false;
			if (!_config.delimiter)
			{
				var delimGuess = guessDelimiter(input, _config.newline, _config.skipEmptyLines);
				if (delimGuess.successful)
					_config.delimiter = delimGuess.bestDelimiter;
				else
				{
					_delimiterError = true;	// add error after parsing (otherwise it would be overwritten)
					_config.delimiter = Papa.DefaultDelimiter;
				}
				_results.meta.delimiter = _config.delimiter;
			}
			else if(isFunction(_config.delimiter))
			{
				_config.delimiter = _config.delimiter(input);
				_results.meta.delimiter = _config.delimiter;
			}

			var parserConfig = copy(_config);
			if (_config.preview && _config.header)
				parserConfig.preview++;	// to compensate for header row

			_input = input;
			_parser = new Parser(parserConfig);
			_results = _parser.parse(_input, baseIndex, ignoreLastRow);
			processResults();
			return _paused ? { meta: { paused: true } } : (_results || { meta: { paused: false } });
		};

		this.paused = function()
		{
			return _paused;
		};

		this.pause = function()
		{
			_paused = true;
			_parser.abort();
			_input = _input.substr(_parser.getCharIndex());
		};

		this.resume = function()
		{
			_paused = false;
			self.streamer.parseChunk(_input);
		};

		this.aborted = function ()
		{
			return _aborted;
		};

		this.abort = function()
		{
			_aborted = true;
			_parser.abort();
			_results.meta.aborted = true;
			if (isFunction(_config.complete))
				_config.complete(_results);
			_input = '';
		};

		function processResults()
		{
			if (_results && _delimiterError)
			{
				addError('Delimiter', 'UndetectableDelimiter', 'Unable to auto-detect delimiting character; defaulted to \''+Papa.DefaultDelimiter+'\'');
				_delimiterError = false;
			}

			if (_config.skipEmptyLines)
			{
				for (var i = 0; i < _results.data.length; i++)
					if (_results.data[i].length === 1 && _results.data[i][0] === '')
						_results.data.splice(i--, 1);
			}

			if (needsHeaderRow())
				fillHeaderFields();

			return applyHeaderAndDynamicTyping();
		}

		function needsHeaderRow()
		{
			return _config.header && _fields.length === 0;
		}

		function fillHeaderFields()
		{
			if (!_results)
				return;
			for (var i = 0; needsHeaderRow() && i < _results.data.length; i++)
				for (var j = 0; j < _results.data[i].length; j++)
					_fields.push(_results.data[i][j]);
			_results.data.splice(0, 1);
		}

		function shouldApplyDynamicTyping(field) {
			// Cache function values to avoid calling it for each row
			if (_config.dynamicTypingFunction && _config.dynamicTyping[field] === undefined) {
				_config.dynamicTyping[field] = _config.dynamicTypingFunction(field);
			}
			return (_config.dynamicTyping[field] || _config.dynamicTyping) === true
		}

		function parseDynamic(field, value)
		{
			if (shouldApplyDynamicTyping(field))
			{
				if (value === 'true' || value === 'TRUE')
					return true;
				else if (value === 'false' || value === 'FALSE')
					return false;
				else
					return tryParseFloat(value);
			}
			return value;
		}

		function applyHeaderAndDynamicTyping()
		{
			if (!_results || (!_config.header && !_config.dynamicTyping))
				return _results;

			for (var i = 0; i < _results.data.length; i++)
			{
				var row = _config.header ? {} : [];

				for (var j = 0; j < _results.data[i].length; j++)
				{
					var field = j;
					var value = _results.data[i][j];

					if (_config.header)
						field = j >= _fields.length ? '__parsed_extra' : _fields[j];

					value = parseDynamic(field, value);

					if (field === '__parsed_extra')
					{
						row[field] = row[field] || [];
						row[field].push(value);
					}
					else
						row[field] = value;
				}

				_results.data[i] = row;

				if (_config.header)
				{
					if (j > _fields.length)
						addError('FieldMismatch', 'TooManyFields', 'Too many fields: expected ' + _fields.length + ' fields but parsed ' + j, i);
					else if (j < _fields.length)
						addError('FieldMismatch', 'TooFewFields', 'Too few fields: expected ' + _fields.length + ' fields but parsed ' + j, i);
				}
			}

			if (_config.header && _results.meta)
				_results.meta.fields = _fields;
			return _results;
		}

		function guessDelimiter(input, newline, skipEmptyLines)
		{
			var delimChoices = [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP];
			var bestDelim, bestDelta, fieldCountPrevRow;

			for (var i = 0; i < delimChoices.length; i++)
			{
				var delim = delimChoices[i];
				var delta = 0, avgFieldCount = 0, emptyLinesCount = 0;
				fieldCountPrevRow = undefined;

				var preview = new Parser({
					delimiter: delim,
					newline: newline,
					preview: 10
				}).parse(input);

				for (var j = 0; j < preview.data.length; j++)
				{
					if (skipEmptyLines && preview.data[j].length === 1 && preview.data[j][0].length === 0) {
						emptyLinesCount++
						continue
					}
					var fieldCount = preview.data[j].length;
					avgFieldCount += fieldCount;

					if (typeof fieldCountPrevRow === 'undefined')
					{
						fieldCountPrevRow = fieldCount;
						continue;
					}
					else if (fieldCount > 1)
					{
						delta += Math.abs(fieldCount - fieldCountPrevRow);
						fieldCountPrevRow = fieldCount;
					}
				}

				if (preview.data.length > 0)
					avgFieldCount /= (preview.data.length - emptyLinesCount);

				if ((typeof bestDelta === 'undefined' || delta < bestDelta)
					&& avgFieldCount > 1.99)
				{
					bestDelta = delta;
					bestDelim = delim;
				}
			}

			_config.delimiter = bestDelim;

			return {
				successful: !!bestDelim,
				bestDelimiter: bestDelim
			}
		}

		function guessLineEndings(input)
		{
			input = input.substr(0, 1024*1024);	// max length 1 MB

			var r = input.split('\r');

			var n = input.split('\n');

			var nAppearsFirst = (n.length > 1 && n[0].length < r[0].length);

			if (r.length === 1 || nAppearsFirst)
				return '\n';

			var numWithN = 0;
			for (var i = 0; i < r.length; i++)
			{
				if (r[i][0] === '\n')
					numWithN++;
			}

			return numWithN >= r.length / 2 ? '\r\n' : '\r';
		}

		function tryParseFloat(val)
		{
			var isNumber = FLOAT.test(val);
			return isNumber ? parseFloat(val) : val;
		}

		function addError(type, code, msg, row)
		{
			_results.errors.push({
				type: type,
				code: code,
				message: msg,
				row: row
			});
		}
	}





	/** The core parser implements speedy and correct CSV parsing */
	function Parser(config)
	{
		// Unpack the config object
		config = config || {};
		var delim = config.delimiter;
		var newline = config.newline;
		var comments = config.comments;
		var step = config.step;
		var preview = config.preview;
		var fastMode = config.fastMode;
		/** Allows for no quoteChar by setting quoteChar to undefined in config */
		if (config.quoteChar === undefined){
			var quoteChar = '"';
		} else {
			var quoteChar = config.quoteChar;
		}

		// Delimiter must be valid
		if (typeof delim !== 'string'
			|| Papa.BAD_DELIMITERS.indexOf(delim) > -1)
			delim = ',';

		// Comment character must be valid
		if (comments === delim)
			throw 'Comment character same as delimiter';
		else if (comments === true)
			comments = '#';
		else if (typeof comments !== 'string'
			|| Papa.BAD_DELIMITERS.indexOf(comments) > -1)
			comments = false;

		// Newline must be valid: \r, \n, or \r\n
		if (newline != '\n' && newline != '\r' && newline != '\r\n')
			newline = '\n';

		// We're gonna need these at the Parser scope
		var cursor = 0;
		var aborted = false;

		this.parse = function(input, baseIndex, ignoreLastRow)
		{
			// For some reason, in Chrome, this speeds things up (!?)
			if (typeof input !== 'string')
				throw 'Input must be a string';

			// We don't need to compute some of these every time parse() is called,
			// but having them in a more local scope seems to perform better
			var inputLen = input.length,
				delimLen = delim.length,
				newlineLen = newline.length,
				commentsLen = comments.length;
			var stepIsFunction = isFunction(step);

			// Establish starting state
			cursor = 0;
			var data = [], errors = [], row = [], lastCursor = 0;

			if (!input)
				return returnable();

			if (fastMode || (fastMode !== false && input.indexOf(quoteChar) === -1))
			{
				var rows = input.split(newline);
				for (var i = 0; i < rows.length; i++)
				{
					var row = rows[i];
					cursor += row.length;
					if (i !== rows.length - 1)
						cursor += newline.length;
					else if (ignoreLastRow)
						return returnable();
					if (comments && row.substr(0, commentsLen) === comments)
						continue;
					if (stepIsFunction)
					{
						data = [];
						pushRow(row.split(delim));
						doStep();
						if (aborted)
							return returnable();
					}
					else
						pushRow(row.split(delim));
					if (preview && i >= preview)
					{
						data = data.slice(0, preview);
						return returnable(true);
					}
				}
				return returnable();
			}

			var nextDelim = input.indexOf(delim, cursor);
			var nextNewline = input.indexOf(newline, cursor);
			var quoteCharRegex = new RegExp(quoteChar+quoteChar, 'g');

			// Parser loop
			for (;;)
			{
				// Field has opening quote
				if (input[cursor] === quoteChar)
				{
					// Start our search for the closing quote where the cursor is
					var quoteSearch = cursor;

					// Skip the opening quote
					cursor++;

					for (;;)
					{
						// Find closing quote
						var quoteSearch = input.indexOf(quoteChar, quoteSearch+1);

						//No other quotes are found - no other delimiters
						if (quoteSearch === -1)
						{
							if (!ignoreLastRow) {
								// No closing quote... what a pity
								errors.push({
									type: 'Quotes',
									code: 'MissingQuotes',
									message: 'Quoted field unterminated',
									row: data.length,	// row has yet to be inserted
									index: cursor
								});
							}
							return finish();
						}

						// Closing quote at EOF
						if (quoteSearch === inputLen-1)
						{
							var value = input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar);
							return finish(value);
						}

						// If this quote is escaped, it's part of the data; skip it
						if (input[quoteSearch+1] === quoteChar)
						{
							quoteSearch++;
							continue;
						}

						// Closing quote followed by delimiter
						if (input[quoteSearch+1] === delim)
						{
							row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
							cursor = quoteSearch + 1 + delimLen;
							nextDelim = input.indexOf(delim, cursor);
							nextNewline = input.indexOf(newline, cursor);
							break;
						}

						// Closing quote followed by newline
						if (input.substr(quoteSearch+1, newlineLen) === newline)
						{
							row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
							saveRow(quoteSearch + 1 + newlineLen);
							nextDelim = input.indexOf(delim, cursor);	// because we may have skipped the nextDelim in the quoted field

							if (stepIsFunction)
							{
								doStep();
								if (aborted)
									return returnable();
							}

							if (preview && data.length >= preview)
								return returnable(true);

							break;
						}


						// Checks for valid closing quotes are complete (escaped quotes or quote followed by EOF/delimiter/newline) -- assume these quotes are part of an invalid text string
						errors.push({
							type: 'Quotes',
							code: 'InvalidQuotes',
							message: 'Trailing quote on quoted field is malformed',
							row: data.length,	// row has yet to be inserted
							index: cursor
						});

						quoteSearch++;
						continue;

					}

					continue;
				}

				// Comment found at start of new line
				if (comments && row.length === 0 && input.substr(cursor, commentsLen) === comments)
				{
					if (nextNewline === -1)	// Comment ends at EOF
						return returnable();
					cursor = nextNewline + newlineLen;
					nextNewline = input.indexOf(newline, cursor);
					nextDelim = input.indexOf(delim, cursor);
					continue;
				}

				// Next delimiter comes before next newline, so we've reached end of field
				if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1))
				{
					row.push(input.substring(cursor, nextDelim));
					cursor = nextDelim + delimLen;
					nextDelim = input.indexOf(delim, cursor);
					continue;
				}

				// End of row
				if (nextNewline !== -1)
				{
					row.push(input.substring(cursor, nextNewline));
					saveRow(nextNewline + newlineLen);

					if (stepIsFunction)
					{
						doStep();
						if (aborted)
							return returnable();
					}

					if (preview && data.length >= preview)
						return returnable(true);

					continue;
				}

				break;
			}


			return finish();


			function pushRow(row)
			{
				data.push(row);
				lastCursor = cursor;
			}

			/**
			 * Appends the remaining input from cursor to the end into
			 * row, saves the row, calls step, and returns the results.
			 */
			function finish(value)
			{
				if (ignoreLastRow)
					return returnable();
				if (typeof value === 'undefined')
					value = input.substr(cursor);
				row.push(value);
				cursor = inputLen;	// important in case parsing is paused
				pushRow(row);
				if (stepIsFunction)
					doStep();
				return returnable();
			}

			/**
			 * Appends the current row to the results. It sets the cursor
			 * to newCursor and finds the nextNewline. The caller should
			 * take care to execute user's step function and check for
			 * preview and end parsing if necessary.
			 */
			function saveRow(newCursor)
			{
				cursor = newCursor;
				pushRow(row);
				row = [];
				nextNewline = input.indexOf(newline, cursor);
			}

			/** Returns an object with the results, errors, and meta. */
			function returnable(stopped)
			{
				return {
					data: data,
					errors: errors,
					meta: {
						delimiter: delim,
						linebreak: newline,
						aborted: aborted,
						truncated: !!stopped,
						cursor: lastCursor + (baseIndex || 0)
					}
				};
			}

			/** Executes the user's step function and resets data & errors. */
			function doStep()
			{
				step(returnable());
				data = [], errors = [];
			}
		};

		/** Sets the abort flag */
		this.abort = function()
		{
			aborted = true;
		};

		/** Gets the cursor position */
		this.getCharIndex = function()
		{
			return cursor;
		};
	}


	// If you need to load Papa Parse asynchronously and you also need worker threads, hard-code
	// the script path here. See: https://github.com/mholt/PapaParse/issues/87#issuecomment-57885358
	function getScriptPath()
	{
		var scripts = document.getElementsByTagName('script');
		return scripts.length ? scripts[scripts.length - 1].src : '';
	}

	function newWorker()
	{
		if (!Papa.WORKERS_SUPPORTED)
			return false;
		if (!LOADED_SYNC && Papa.SCRIPT_PATH === null)
			throw new Error(
				'Script path cannot be determined automatically when Papa Parse is loaded asynchronously. ' +
				'You need to set Papa.SCRIPT_PATH manually.'
			);
		var workerUrl = Papa.SCRIPT_PATH || AUTO_SCRIPT_PATH;
		// Append 'papaworker' to the search string to tell papaparse that this is our worker.
		workerUrl += (workerUrl.indexOf('?') !== -1 ? '&' : '?') + 'papaworker';
		var w = new global.Worker(workerUrl);
		w.onmessage = mainThreadReceivedMessage;
		w.id = workerIdCounter++;
		workers[w.id] = w;
		return w;
	}

	/** Callback when main thread receives a message */
	function mainThreadReceivedMessage(e)
	{
		var msg = e.data;
		var worker = workers[msg.workerId];
		var aborted = false;

		if (msg.error)
			worker.userError(msg.error, msg.file);
		else if (msg.results && msg.results.data)
		{
			var abort = function() {
				aborted = true;
				completeWorker(msg.workerId, { data: [], errors: [], meta: { aborted: true } });
			};

			var handle = {
				abort: abort,
				pause: notImplemented,
				resume: notImplemented
			};

			if (isFunction(worker.userStep))
			{
				for (var i = 0; i < msg.results.data.length; i++)
				{
					worker.userStep({
						data: [msg.results.data[i]],
						errors: msg.results.errors,
						meta: msg.results.meta
					}, handle);
					if (aborted)
						break;
				}
				delete msg.results;	// free memory ASAP
			}
			else if (isFunction(worker.userChunk))
			{
				worker.userChunk(msg.results, handle, msg.file);
				delete msg.results;
			}
		}

		if (msg.finished && !aborted)
			completeWorker(msg.workerId, msg.results);
	}

	function completeWorker(workerId, results) {
		var worker = workers[workerId];
		if (isFunction(worker.userComplete))
			worker.userComplete(results);
		worker.terminate();
		delete workers[workerId];
	}

	function notImplemented() {
		throw 'Not implemented.';
	}

	/** Callback when worker thread receives a message */
	function workerThreadReceivedMessage(e)
	{
		var msg = e.data;

		if (typeof Papa.WORKER_ID === 'undefined' && msg)
			Papa.WORKER_ID = msg.workerId;

		if (typeof msg.input === 'string')
		{
			global.postMessage({
				workerId: Papa.WORKER_ID,
				results: Papa.parse(msg.input, msg.config),
				finished: true
			});
		}
		else if ((global.File && msg.input instanceof File) || msg.input instanceof Object)	// thank you, Safari (see issue #106)
		{
			var results = Papa.parse(msg.input, msg.config);
			if (results)
				global.postMessage({
					workerId: Papa.WORKER_ID,
					results: results,
					finished: true
				});
		}
	}

	/** Makes a deep copy of an array or object (mostly) */
	function copy(obj)
	{
		if (typeof obj !== 'object')
			return obj;
		var cpy = obj instanceof Array ? [] : {};
		for (var key in obj)
			cpy[key] = copy(obj[key]);
		return cpy;
	}

	function bindFunction(f, self)
	{
		return function() { f.apply(self, arguments); };
	}

	function isFunction(func)
	{
		return typeof func === 'function';
	}

	return Papa;
}));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(4).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(306),
    isObject = __webpack_require__(77);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(77),
    now = __webpack_require__(307),
    toNumber = __webpack_require__(309);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(126);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(77),
    isSymbol = __webpack_require__(310);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(311),
    isObjectLike = __webpack_require__(314);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(127),
    getRawTag = __webpack_require__(312),
    objectToString = __webpack_require__(313);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(127);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 313 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navigation_navReducer__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__admin_PickList_pickListReducer__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_paymentReducer__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__policy_policyReducer__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__quoting_quotingReducer__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__report_reportReducer__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_userReducer__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth_authReducer__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__settingsReducer__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__questionReducer__ = __webpack_require__(343);











var reducers = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
    nav: __WEBPACK_IMPORTED_MODULE_1__components_navigation_navReducer__["a" /* default */],
    pickList: __WEBPACK_IMPORTED_MODULE_2__admin_PickList_pickListReducer__["a" /* default */],
    payment: __WEBPACK_IMPORTED_MODULE_3__payment_paymentReducer__["a" /* default */],
    policy: __WEBPACK_IMPORTED_MODULE_4__policy_policyReducer__["a" /* default */],
    quoting: __WEBPACK_IMPORTED_MODULE_5__quoting_quotingReducer__["a" /* default */],
    report: __WEBPACK_IMPORTED_MODULE_6__report_reportReducer__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_7__user_userReducer__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_8__auth_authReducer__["a" /* default */],
    settings: __WEBPACK_IMPORTED_MODULE_9__settingsReducer__["a" /* default */],
    question: __WEBPACK_IMPORTED_MODULE_10__questionReducer__["a" /* default */],
});
/* harmony default export */ __webpack_exports__["a"] = (reducers);


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toggleNavReducer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    menuIsOpen: false,
};
function toggleNavReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].TOGGLE_NAV_MENU:
            return __assign({}, state, { menuIsOpen: !state.menuIsOpen });
        default:
            return state;
    }
}
/* harmony default export */ __webpack_exports__["a"] = (toggleNavReducer);


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pickListReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    types: [],
    items: [],
    type: {},
    item: {}
};
function pickListReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_PICKLIST_TYPE_SUCCESS:
            return __assign({}, state, { type: action.pickListType });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_PICKLIST_ITEM_SUCCESS:
            return __assign({}, state, { item: action.pickListItem });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].GET_PICKLIST_TYPE_SUCCESS:
            return __assign({}, state, { type: action.pickListType });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].GET_PICKLIST_TYPES_SUCCESS:
            return __assign({}, state, { types: action.pickListTypes });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].GET_PICKLIST_ITEM_SUCCESS:
            return __assign({}, state, { item: action.pickListItem });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].GET_PICKLIST_ITEMS_SUCCESS:
            return __assign({}, state, { items: action.pickListItems });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_PICKLIST_TYPE_SUCCESS:
            var filteredTypes = state.types.filter(function (type) { return type.id !== action.pickListType.id; });
            return __assign({}, state, { types: filteredTypes.concat([action.pickListType]), type: action.pickListType });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_PICKLIST_ITEM_SUCCESS:
            var filteredItems = state.items.filter(function (item) { return item.id !== action.pickListItem.id; });
            return __assign({}, state, { items: filteredItems.concat([action.pickListItem]), item: action.pickListItem });
        default:
            return state;
    }
}


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = paymentReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__paymentAPI__ = __webpack_require__(128);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var initialState = {
    details: {
        amount: '',
        ccCardholderName: ''
    },
    payment: __WEBPACK_IMPORTED_MODULE_1__paymentAPI__["b" /* defaultPaymentHistory */],
    payments: [],
    stripe: {},
    subscriptionResponse: {},
    chargeResponse: {},
    invoice: {},
    card: {},
    invoiceCard: {}
};
function paymentReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_STRIPE:
            return __assign({}, state, { stripe: action.stripe });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_PAYMENT_DETAILS:
            return __assign({}, state, { details: action.details });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].CREATE_SUBSCRIPTION:
            return __assign({}, state, { subscriptionResponse: action.subscriptionResponse });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].CREATE_CHARGE:
            return __assign({}, state, { chargeResponse: action.chargeResponse });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_PAYMENT:
            return __assign({}, state, { payment: action.payment });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_PAYMENTS:
            return __assign({}, state, { payments: action.payments });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_UPCOMING_INVOICE:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].PAY_INVOICE:
            return __assign({}, state, { invoice: action.invoice });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_CARD:
            return __assign({}, state, { card: action.card });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_INVOICE_CARD:
            return __assign({}, state, { invoiceCard: action.invoiceCard });
        default:
            return state;
    }
}


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(25);
var bind = __webpack_require__(129);
var Axios = __webpack_require__(321);
var defaults = __webpack_require__(78);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(133);
axios.CancelToken = __webpack_require__(335);
axios.isCancel = __webpack_require__(132);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(336);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(78);
var utils = __webpack_require__(25);
var InterceptorManager = __webpack_require__(330);
var dispatchRequest = __webpack_require__(331);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(25);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(131);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(25);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(25);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(25);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(25);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(25);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(25);
var transformData = __webpack_require__(332);
var isCancel = __webpack_require__(132);
var defaults = __webpack_require__(78);
var isAbsoluteURL = __webpack_require__(333);
var combineURLs = __webpack_require__(334);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(25);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(133);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = policyReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__policyAPI__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




var initialState = {
    customerPolicy: __WEBPACK_IMPORTED_MODULE_1__policyAPI__["b" /* defaultCustomerPolicy */],
    customerPolicyBeneficiary: __WEBPACK_IMPORTED_MODULE_1__policyAPI__["c" /* defaultCustomerPolicyBeneficiary */],
    planOptions: __WEBPACK_IMPORTED_MODULE_1__policyAPI__["f" /* defaultPlanOptions */],
    questionnaire: {
        heightUnit: 'in',
        weightUnit: 'lbs',
        maxWeightLoss: 0,
        ownPetsTypes: {},
        foreignTravelList: [],
        cancer: {},
        heartCirculatory: {},
        psychological: {},
        reproductive: {},
        head: {},
        immuno: {},
        blood: {},
        liver: {},
        respiratory: {},
        neurological: {},
    },
    subscription: {},
    deleteSucceed: false,
    policies: [],
    beneficiaries: { current: [], pending: [] },
    trustee: __WEBPACK_IMPORTED_MODULE_1__policyAPI__["g" /* defaultTrustee */],
    isHardDeclined: __WEBPACK_IMPORTED_MODULE_1__policyAPI__["d" /* defaultDeclineChecker */],
    isSoftDeclined: __WEBPACK_IMPORTED_MODULE_1__policyAPI__["d" /* defaultDeclineChecker */],
    qcHardDeclined: false,
    questionnaireReport: '',
    answers: [],
    tempPolicyDocumentUrl: '',
    premiumChanged: false,
    redirectFromAdjudication: false,
};
function policyReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_DEV_QUESTIONNAIRE:
            return __assign({}, state, { questionnaire: __WEBPACK_IMPORTED_MODULE_1__policyAPI__["h" /* devQuestionnaire */] });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_CUSTOMER_POLICY:
            return __assign({}, state, { customerPolicy: initialState.customerPolicy });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_CUSTOMER_POLICY_BENEFICIARY:
            return __assign({}, state, { customerPolicyBeneficiary: initialState.customerPolicyBeneficiary });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_POLICY:
            {
                // we want to calcuate the dates here.
                var userPolicy = action.customerPolicy;
                if (userPolicy.term && __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].isValidDate(userPolicy.effectiveDate, 'YYYY-MM-DD')) {
                    // adjust the end date. The clone is there to create a new date, w/ the modifications
                    // there seems to be a bug in moment, where if you create a date, then adjust 
                    // it to an invalid date, checking if it's valid. returns true. However, formatting fails.
                    var endDate = __WEBPACK_IMPORTED_MODULE_3_moment__(userPolicy.effectiveDate).add(userPolicy.term, 'years').subtract(1, 'day').clone();
                    if (endDate.isValid()) {
                        userPolicy.endDate = endDate.format('YYYY-MM-DD');
                    }
                }
                return __assign({}, state, { customerPolicy: userPolicy });
            }
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_POLICY:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_CUSTOMER_POLICY:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_CUSTOMER_PLAN:
            var policy = action.customerPolicy;
            if (policy.effectiveDate) {
                policy.effectiveDate = __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatDateAsUTC(policy.effectiveDate);
            }
            if (policy.endDate) {
                policy.endDate = __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatDateAsUTC(policy.endDate);
            }
            return __assign({}, state, { customerPolicy: policy });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_POLICY_FREE_TRIAL_MONTHS:
            var freeTrialMonths = action.months;
            var customerPolicy = __assign({}, state.customerPolicy);
            customerPolicy.freeMonthTrial = freeTrialMonths;
            return __assign({}, state, { customerPolicy: customerPolicy });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_POLICY_DOCUMENT_URL:
            return __assign({}, state, { tempPolicyDocumentUrl: action.url });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_POLICIES:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_CUSTOMER_POLICY:
            var remainingPolicies = state.policies.filter(function (b) { return b.id !== action.customerPolicy.id; });
            var savedPolicy = action.customerPolicy;
            if (savedPolicy.effectiveDate) {
                savedPolicy.effectiveDate = __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatDateAsUTC(savedPolicy.effectiveDate);
            }
            if (savedPolicy.endDate) {
                savedPolicy.endDate = __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatDateAsUTC(savedPolicy.endDate);
            }
            return __assign({}, state, { policies: remainingPolicies.concat([savedPolicy]), customerPolicy: savedPolicy });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_POLICIES:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_POLICIES:
            return __assign({}, state, { policies: action.policies });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].DELETE_CUSTOMER_POLICY:
            var unchangedPolicies = state.policies.filter(function (b) { return b.id !== action.customerPolicy.id; });
            return __assign({}, state, { policies: unchangedPolicies.concat([action.customerPolicy]), customerPolicy: action.customerPolicy });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_POLICY_BENEFICIARY:
            var beneficiary = action.customerPolicyBeneficiary;
            if (beneficiary.birthDate) {
                beneficiary.birthDate = __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatDateAsUTC(beneficiary.birthDate);
            }
            return __assign({}, state, { customerPolicyBeneficiary: beneficiary });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_TRUSTEE:
            return __assign({}, state, { trustee: action.trustee });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_POLICY_BENEFICIARIES:
            return __assign({}, state, { beneficiaries: __assign({}, state.beneficiaries, { pending: action.beneficiaries }) });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_POLICY_BENEFICIARIES:
            return __assign({}, state, { beneficiaries: action.beneficiaries });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_QUESTIONNAIRE:
            return __assign({}, state, { questionnaire: action.questionnaire });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_QUESTIONNAIRE:
            return __assign({}, state, { questionnaire: initialState.questionnaire });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_PLAN_OPTIONS:
            return __assign({}, state, { planOptions: action.planOptions });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_POLICY_BENEFICIARY:
            if (action.customerPolicyBeneficiary.id) {
                var updatedBeneficiaries = state.beneficiaries.pending.slice();
                var beneficiaryIndex = updatedBeneficiaries.findIndex(function (b) { return b.id === action.customerPolicyBeneficiary.id; });
                var updatedBeneficiary = __assign({}, state.customerPolicyBeneficiary, action.customerPolicyBeneficiary);
                if (beneficiaryIndex === -1) {
                    updatedBeneficiaries.push(updatedBeneficiary);
                }
                else {
                    updatedBeneficiaries.splice(beneficiaryIndex, 1, updatedBeneficiary);
                }
                return __assign({}, state, { beneficiaries: __assign({}, state.beneficiaries, { pending: updatedBeneficiaries }), customerPolicyBeneficiary: updatedBeneficiary });
            }
            else {
                return __assign({}, state, { customerPolicyBeneficiary: action.customerPolicyBeneficiary });
            }
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_CUSTOMER_POLICY_BENEFICIARY:
            if (action.customerPolicyBeneficiary.id) {
                var updatedBeneficiaries = state.beneficiaries.pending.slice();
                var beneficiaryIndex = updatedBeneficiaries.findIndex(function (b) { return b.id === action.customerPolicyBeneficiary.id; });
                var updatedBeneficiary = __assign({}, state.customerPolicyBeneficiary, action.customerPolicyBeneficiary);
                if (updatedBeneficiary.birthDate) {
                    updatedBeneficiary.birthDate = __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatDateAsUTC(updatedBeneficiary.birthDate);
                }
                if (beneficiaryIndex === -1) {
                    updatedBeneficiaries.push(updatedBeneficiary);
                }
                else {
                    updatedBeneficiaries.splice(beneficiaryIndex, 1, updatedBeneficiary);
                }
                return __assign({}, state, { beneficiaries: __assign({}, state.beneficiaries, { pending: updatedBeneficiaries }), customerPolicyBeneficiary: updatedBeneficiary });
            }
            else {
                return __assign({}, state, { customerPolicyBeneficiary: action.customerPolicyBeneficiary });
            }
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].DELETE_CUSTOMER_POLICY_BENEFICIARY:
            return __assign({}, state, { deleteSucceed: action.deleteSucceed });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_RATE_PLUS_MINUS_SUCCESS:
            return __assign({}, state, { ratePlusMinus: action.ratePlusMinus });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_IS_HARD_DECLINED_SUCCESS:
            return __assign({}, state, { isHardDeclined: action.isHardDeclined });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_IS_SOFT_DECLINED_SUCCESS:
            return __assign({}, state, { isSoftDeclined: action.isSoftDeclined });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_QUESTIONNAIRE_REPORT_SUCCESS:
            return __assign({}, state, { questionnaireReport: action.questionnaireReport });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_POLICY_ANSWER_SUCCESS:
            return __assign({}, state, { answers: action.answers });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_PREMIUM_CHANGED:
            return __assign({}, state, { premiumChanged: action.premiumChanged });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_POLICY_ANSWER:
            return __assign({}, state, { answers: [] });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].REDIRECT_FROM_ADJUDICATION:
            return __assign({}, state, { redirectFromAdjudication: action.redirectFromAdjudication });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_POLICY_PAPER_STATUS:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_CUSTOMER_POLICY_CURRENT_BENEFICIARY:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].DELETE_BENEFICIARY_DURING_SIGN_UP:
        default:
            return state;
    }
}


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quotingReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__quotingAPI__ = __webpack_require__(80);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var initialState = {
    customerDetails: __WEBPACK_IMPORTED_MODULE_1__quotingAPI__["b" /* defaultCustomerDetails */],
    customerFamilyList: [__WEBPACK_IMPORTED_MODULE_1__quotingAPI__["c" /* defaultCustomerFamily */]],
    hwTable: [],
    assessment: {
        numChildren: '',
        childrenAge: [],
        childrenAge1: '',
        childrenAge2: ''
    },
    validReferral: false
};
function quotingReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_HEIGHT_WEIGHT_TABLE:
            return __assign({}, state, { hwTable: action.hwTable });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_CUSTOMER_DETAILS:
            return __assign({}, state, { customerDetails: __WEBPACK_IMPORTED_MODULE_1__quotingAPI__["b" /* defaultCustomerDetails */] });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_DETAILS:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_DETAILS:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_CUSTOMER_DETAILS:
            return __assign({}, state, { customerDetails: action.customerDetails });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_FAMILY_LIST:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_FAMILY_LIST:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_CUSTOMER_FAMILY_LIST:
            return __assign({}, state, { customerFamilyList: action.customerFamilyList });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_QUOTING_ASSESSMENT:
            return __assign({}, state, { assessment: action.assessment });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].VALIDATE_REFERRALCODE_SUCCESS:
            return __assign({}, state, { validReferral: action.validReferral });
        default:
            return state;
    }
}


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reportReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    customersCount: {},
    users: [],
    policiesCount: {},
    unmailedPolicies: [],
    unmailedPoliciesCount: {},
    failedPaymentsCount: undefined,
    failedPayments: [],
    expiringPoliciesCount: undefined,
    expiringPolicies: [],
    missingBeneficiaryFormsCount: undefined,
    bouncedEmailsCount: undefined,
    bouncedEmails: [],
    financials: [],
    referrals: []
};
function reportReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMERS_COUNT:
            return __assign({}, state, { customersCount: action.customersCount });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_USER_ACTIVITIES:
            return __assign({}, state, { users: action.users });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_POLICIES_COUNT:
            return __assign({}, state, { policiesCount: action.policiesCount });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_UNMAILED_POLICIES_COUNT:
            return __assign({}, state, { unmailedPoliciesCount: action.unmailedPoliciesCount });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_UNMAILED_POLICIES:
            return __assign({}, state, { unmailedPolicies: action.unmailedPolicies });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_FAILED_PAYMENTS_COUNT:
            return __assign({}, state, { failedPaymentsCount: action.failedPaymentsCount });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_FAILED_PAYMENTS:
            return __assign({}, state, { failedPayments: action.failedPayments });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_EXPIRING_POLICIES_COUNT:
            return __assign({}, state, { expiringPoliciesCount: action.expiringPoliciesCount });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_EXPIRING_POLICIES:
            return __assign({}, state, { expiringPolicies: action.expiringPolicies });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_MISSING_BENEFICIARY_FORMS_COUNT:
            return __assign({}, state, { missingBeneficiaryFormsCount: action.missingBeneficiaryFormsCount });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_BOUNCED_EMAILS_COUNT:
            return __assign({}, state, { bouncedEmailsCount: action.bouncedEmailsCount });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_BOUNCED_EMAILS:
            return __assign({}, state, { bouncedEmails: action.bouncedEmails });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESOLVE_BOUNCED_EMAIL:
            var filteredEmails = state.bouncedEmails.filter(function (e) { return e.id !== action.bouncedEmail.id; });
            return __assign({}, state, { bouncedEmails: filteredEmails.concat([action.bouncedEmail]) });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_FINANCIAL_REPORT:
            return __assign({}, state, { financials: action.financials });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_REFERRALS:
            return __assign({}, state, { referrals: action.referrals });
        default:
            return state;
    }
}


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = userReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__userAPI__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(1);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var initialState = {
    user: __WEBPACK_IMPORTED_MODULE_1__userAPI__["c" /* defaultUser */],
    customers: [],
    softDeclinedCustomers: [],
    admins: [],
    note: __WEBPACK_IMPORTED_MODULE_1__userAPI__["b" /* defaultCustomerNote */],
    notes: [],
    referrals: {
        referralCode: '',
        spousalReferralCode: '',
        referees: [],
        healthScore: 50,
        referralBalance: 0,
        remainingReferrals: 0,
        referralEnabled: false,
        pendingReferral: 0,
        paidReferral: 0,
        referredSpouseName: '',
        referredSpouseEmail: '',
        referredSpouseExpiryDate: '',
        isSpousalReferralUsed: false,
        statusId: '',
    },
    referrerName: ''
};
function userReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_USER:
            var resetUser = __WEBPACK_IMPORTED_MODULE_1__userAPI__["c" /* defaultUser */];
            var defaultReferrals = initialState.referrals;
            if (state.referrals.referralCode) {
                defaultReferrals.referralCode = state.referrals.referralCode;
            }
            return __assign({}, state, { user: resetUser, referrals: defaultReferrals });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_USER:
            return __assign({}, state, { user: action.user });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_USER:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_USER:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_CUSTOMER_REFERREDBY_SUCCESS:
            var user = action.user;
            if (user.birthDate) {
                user.birthDate = __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatDateAsUTC(user.birthDate);
            }
            return __assign({}, state, { user: user });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_SOFT_DECLINED_CUSTOMERS:
            return __assign({}, state, { softDeclinedCustomers: action.customers });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMERS:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMERS_MISSING_BENEFICIARY_FORMS:
            return __assign({}, state, { customers: action.customers });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_ADMINS:
            return __assign({}, state, { admins: action.admins });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_CUSTOMER_NOTES:
            var note = __assign({}, __WEBPACK_IMPORTED_MODULE_1__userAPI__["b" /* defaultCustomerNote */]);
            note.customerId = action.customerId;
            return __assign({}, state, { note: note });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_NOTE:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_NOTE:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SAVE_CUSTOMER_NOTE:
            return __assign({}, state, { note: action.note });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_NOTES:
            return __assign({}, state, { notes: action.notes });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_CUSTOMER_ANSWER_NOTES:
            var answerNote = __assign({}, __WEBPACK_IMPORTED_MODULE_1__userAPI__["b" /* defaultCustomerNote */]);
            answerNote.customerId = action.customerId;
            answerNote.answerId = action.answerId;
            return __assign({}, state, { note: answerNote });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].RESET_CUSTOMER_REFERRALS:
            return __assign({}, state, { referrals: initialState.referrals });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_CUSTOMER_REFERRALS_SUCCESS:
            return __assign({}, state, { referrals: action.referrals });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_REMAINING_REFERRALS:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_REMAINING_REFERRALS_SUCCESS:
            return __assign({}, state, { referrals: __assign({}, state.referrals, { remainingReferrals: action.remainingReferrals }) });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CUSTOMER_REFERRAL_BALANCE:
            return __assign({}, state, { referrals: __assign({}, state.referrals, { referralBalance: action.referralBalance }) });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_REFERAL_BALANCE_SUCCESS:
            return __assign({}, state, { referrals: __assign({}, state.referrals, { referralBalance: action.referralBalance }) });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].UPDATE_REFERRAL_ENABLED_SUCCESS:
            return __assign({}, state, { referrals: __assign({}, state.referrals, { referralEnabled: action.referralEnabled }) });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].GENERATE_NEW_REFERRALCODE_SUCCESS:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_REFERRALCODE_SUCCESS:
            return __assign({}, state, { referrals: __assign({}, state.referrals, { referralCode: action.referralCode }) });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_SPOUSALREFERRALCODE_SUCCESS:
            return __assign({}, state, { referrals: __assign({}, state.referrals, { spousalReferralCode: action.spousalReferralCode }) });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_REFERRER_NAME_BY_REFERRAL_CODE_SUCCESS:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_REFERRER_NAME_BY_SPOUSAL_REFERRAL_CODE_SUCCESS:
            return __assign({}, state, { referrerName: action.referrerName });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].CLEAR_ADJUDICATION_QUEUE:
        default:
            return state;
    }
}


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = authReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    currentUser: {
        isAuthenticated: false,
        fullName: '',
        role: ["Customer" /* Customer */],
        userId: '',
        hasBeenDirected: false,
    }
};
function authReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_USER_AUTH_SUCCESS:
            action.user.isAuthenticated = true;
            return __assign({}, state, { currentUser: __assign({}, state.currentUser, action.user) });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].FETCH_USER_AUTH_FAILURE:
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].USER_AUTH_LOGOUT:
            return __assign({}, state, { currentUser: initialState.currentUser });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_DIRECT_STATUS_SUCCESS:
            action.currentUser.hasBeenDirected = true;
            return __assign({}, state, { currentUser: __assign({}, action.currentUser) });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_CURRENTUSER_HAS_SIGNED_IN:
            var currentUser = __assign({}, state.currentUser, { hasSignedIn: action.hasSignedIn });
            return __assign({}, state, { currentUser: currentUser });
        default:
            return state;
    }
}


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export settingsReducer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// using settings reducer to simply hold data so it doesn't have any actions currently.

var initialState = {
    questionnaireNavigationEnabled: true,
    selectPolicyOptionsEnabled: true,
    version: "1.10.9",
};
function settingsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_QUESTIONNAIRE_NAVIGATION_ENABLED:
            return __assign({}, state, { questionnaireNavigationEnabled: action.enabled });
        case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].SET_SELECT_POLICY_OPTIONS_ENABLED:
            return __assign({}, state, { selectPolicyOptionsEnabled: action.enabled });
        default:
            return state;
    }
}
/* harmony default export */ __webpack_exports__["a"] = (settingsReducer);


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = questionReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(15);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var initialState = {
    questions: {},
};
function questionReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["a" /* default */].FETCH_QUESTION_SUCCESS:
            return __assign({}, state, { questions: action.questions });
        default:
            return state;
    }
}


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_toastr__);

// tslint:disable-next-line
// took from https://github.com/pburtchaell/redux-promise-middleware/blob/master/examples/complex/middleware/error.js as an example
function errorMiddleware() {
    return function (store) { return function (next) { return function (action) {
        var result = next(action);
        if (!isPromise(result)) {
            return result;
        }
        return result.catch(function (error) {
            var message = error.message ? JSON.stringify(error.message) : JSON.stringify(error);
            console.warn(action.name + " caught at middleware with reason: " + message + ".");
            __WEBPACK_IMPORTED_MODULE_0_toastr__["error"]('Sorry something went wrong!');
            throw error;
        });
    }; }; };
}
function isPromise(value) {
    if (value !== null && typeof value === 'object') {
        return value && typeof value.then === 'function';
    }
    return false;
}
/* harmony default export */ __webpack_exports__["a"] = (errorMiddleware);


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( ">tbody", elem )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with computed style
	var valueIsBorderBox,
		styles = getStyles( elem ),
		val = curCSS( elem, name, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test( val ) ) {
		return val;
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = isBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ name ] );

	// Fall back to offsetWidth/Height when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	if ( val === "auto" ) {
		val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var doc, docElem, rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		doc = elem.ownerDocument;
		docElem = doc.documentElement;
		win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( jQuery.isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var stateKey = 'app-state';
var localStoreRedux = {
    loadState: function () {
        try {
            var serializedState = localStorage.getItem(stateKey);
            if (serializedState === null) {
                return undefined;
            }
            return JSON.parse(serializedState);
        }
        catch (err) {
            return undefined;
        }
    },
    saveState: function (state) {
        try {
            var serializedState = JSON.stringify(state);
            localStorage.setItem(stateKey, serializedState);
        }
        catch (err) {
            // tslint:disable-next-line
            console.error('failed to write redux state to local storage', err);
        }
    }
};
/* harmony default export */ __webpack_exports__["a"] = (localStoreRedux);


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var apiUrl = "https://www.insuredbymosaic.ca/api";
var pickListAPI = {
    getPickListType: function (id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/pick-list-types/" + id)
            .then(function (response) { return response.data; });
    },
    getPickListTypes: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/pick-list-types") // todo: see if axios or an interceptor can auto add the apiUrl.
            .then(function (response) { return response.data; });
    },
    getPickListItem: function (itemId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/pick-list-items/" + itemId)
            .then(function (response) { return response.data; });
    },
    getPickListItems: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/pick-list-items")
            .then(function (response) { return response.data; });
    },
    savePickListType: function (type) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/pick-list-types", type)
            .then(function (response) { return response.data; });
    },
    savePickListItem: function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/pick-list-items", item)
            .then(function (response) { return response.data; });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (pickListAPI);


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sections__ = __webpack_require__(23);

var classNames = __webpack_require__(8);

var PageFooter = function (_a) {
    var wrapperClassName = _a.wrapperClassName, sectionClassName = _a.sectionClassName, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_sections__["b" /* SectionMain */], { wrapperClassName: classNames('my-4', wrapperClassName), sectionClassName: sectionClassName }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (PageFooter);


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var classNames = __webpack_require__(8);
var Section = function (_a) {
    var _b = _a.fluid, fluid = _b === void 0 ? false : _b, wrapperClassName = _a.wrapperClassName, sectionClassName = _a.sectionClassName, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames(fluid ? 'container-fluid' : 'container', wrapperClassName) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: classNames('section', sectionClassName) }, children)));
};
/* unused harmony default export */ var _unused_webpack_default_export = (Section);


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var classNames = __webpack_require__(8);
var SectionLeft = function (_a) {
    var _b = _a.fluid, fluid = _b === void 0 ? false : _b, _c = _a.columns, columns = _c === void 0 ? 10 : _c, _d = _a.maxColumns, maxColumns = _d === void 0 ? 12 : _d, title = _a.title, wrapperClassName = _a.wrapperClassName, sectionClassName = _a.sectionClassName, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames(fluid ? 'container-fluid' : 'container', wrapperClassName) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-" + columns },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: classNames('section section-left', sectionClassName) }, children)))));
};
/* harmony default export */ __webpack_exports__["a"] = (SectionLeft);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var classNames = __webpack_require__(8);
var SectionMain = function (_a) {
    var _b = _a.fluid, fluid = _b === void 0 ? false : _b, wrapperClassName = _a.wrapperClassName, sectionClassName = _a.sectionClassName, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames(fluid ? 'container-fluid' : 'container', wrapperClassName) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: classNames('section section-main', sectionClassName) }, children)));
};
/* harmony default export */ __webpack_exports__["a"] = (SectionMain);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var classNames = __webpack_require__(8);
var SectionRight = function (_a) {
    var _b = _a.fluid, fluid = _b === void 0 ? false : _b, _c = _a.columns, columns = _c === void 0 ? 10 : _c, _d = _a.maxColumns, maxColumns = _d === void 0 ? 12 : _d, title = _a.title, wrapperClassName = _a.wrapperClassName, sectionClassName = _a.sectionClassName, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames(fluid ? 'container-fluid' : 'container', wrapperClassName) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-" + columns + " offset-md-" + (maxColumns - columns) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: classNames('section section-right', sectionClassName) }, children)))));
};
/* harmony default export */ __webpack_exports__["a"] = (SectionRight);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var classNames = __webpack_require__(8);
var PageHeader = function (_a) {
    var title = _a.title, className = _a.className, isCentered = _a.isCentered, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("header", { className: classNames('page-header mb-4 mb-md-5', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-8" + (isCentered ? ' mx-auto text-md-center' : '') },
                title && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "page-header-title " + (children ? '' : ' mb-0') }, title),
                children))));
};
/* harmony default export */ __webpack_exports__["a"] = (PageHeader);


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var classNames = __webpack_require__(8);
var PageHeaderFullWidth = function (_a) {
    var title = _a.title, className = _a.className, isCentered = _a.isCentered, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("header", { className: classNames('page-header mb-4 mb-md-5', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-12" + (isCentered ? ' mx-auto text-md-center' : '') },
                title && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "page-header-title " + (children ? '' : ' mb-0') }, title),
                children))));
};
/* harmony default export */ __webpack_exports__["a"] = (PageHeaderFullWidth);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

var classNames = __webpack_require__(8);
var RegularTable = function (_a) {
    var isDataTable = _a.isDataTable, props = __rest(_a, ["isDataTable"]);
    if (isDataTable) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", __assign({}, props));
    }
    else {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table", __assign({}, props));
    }
};
var Table = function (_a) {
    var className = _a.className, isDataTable = _a.isDataTable, _b = _a.disableScroll, disableScroll = _b === void 0 ? false : _b, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames(className, { 'table-scroll-x': !disableScroll }) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RegularTable, { isDataTable: isDataTable, className: "table table-hover" }, children)));
};
/* harmony default export */ __webpack_exports__["a"] = (Table);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_icons__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var classNames = __webpack_require__(8);



var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.getTabTitle = function (tabs, url, defaultTitle) {
            if (url === void 0) { url = _this.props.match.url; }
            var title = defaultTitle || '';
            tabs.forEach(function (tab) {
                if (tab.to === url) {
                    title = tab.label;
                }
            });
            return title;
        };
        _this.onTabToggle = function (state) {
            var isOpened = !_this.state.isTabExpanded;
            switch (state) {
                case 'open':
                    isOpened = true;
                    break;
                case 'close':
                    isOpened = false;
                    break;
                default:
                    break;
            }
            // Close the tab toggle if the user clicks anywhere
            if (isOpened) {
                document.body.addEventListener('click', function () { return _this.onTabToggle('close'); });
            }
            else {
                document.body.removeEventListener('click', function () { return _this.onTabToggle('close'); });
            }
            _this.setState({ isTabExpanded: isOpened });
        };
        _this.state = {
            isTabExpanded: false
        };
        return _this;
    }
    Tabs.prototype.componentDidMount = function () {
        if (!this.props.disableDocTitle) {
            __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].setDocTitle(this.getTabTitle(this.props.tabs));
        }
    };
    Tabs.prototype.componentWillReceiveProps = function (nextProps) {
        if (!this.props.disableDocTitle && nextProps.match.params.tab !== this.props.match.params.tab) {
            __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].setDocTitle(this.getTabTitle(nextProps.tabs, nextProps.match.url));
        }
    };
    Tabs.prototype.render = function () {
        var props = __rest(this.props, []);
        return props.tabs.length > 0 ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('tab-wrapper mb-4 mb-md-5', props.className) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons__["a" /* Button */], { className: "tab-toggler" + (this.state.isTabExpanded ? ' active' : ''), onClick: this.onTabToggle },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "tab-toggler-label align-middle" }, this.getTabTitle(props.tabs, props.toggleLabel, 'Select a page...')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_icons__["r" /* IconChevronDown */], { className: "tab-toggler-icon" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "tab-collapse" + (this.state.isTabExpanded ? '' : ' collapsed') }, props.tabs.map(function (tab, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */], { className: "btn btn-outline-secondary tab", to: tab.to, key: index }, tab.label)); })))) : null;
    };
    return Tabs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Tabs);


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Tooltip__ = __webpack_require__(82);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var className = __webpack_require__(8);

var IconButton = /** @class */ (function (_super) {
    __extends(IconButton, _super);
    function IconButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconButton.prototype.render = function () {
        var Button = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { style: this.props.style ? this.props.style : {}, type: this.props.type || 'button', className: className('btn btn-icon', this.props.className), disabled: this.props.disabled, onClick: this.props.onClick },
            this.props.icon,
            this.props.children));
        if (this.props.title) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Tooltip__["a" /* default */], { title: this.props.title }, Button));
        }
        return Button;
    };
    return IconButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (IconButton);


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(359), __webpack_require__(38));
	else if(typeof define === 'function' && define.amd)
		define("reactTippy", ["react", "popper.js", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["reactTippy"] = factory(require("react"), require("popper.js"), require("react-dom"));
	else
		root["reactTippy"] = factory(root["React"], root["Popper"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_38__, __WEBPACK_EXTERNAL_MODULE_39__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Browser = exports.Browser = {};

if (typeof window !== 'undefined') {
  Browser.SUPPORTED = 'requestAnimationFrame' in window;
  Browser.SUPPORTS_TOUCH = 'ontouchstart' in window;
  Browser.touch = false;
  Browser.dynamicInputDetection = true;
  // Chrome device/touch emulation can make this dynamic
  Browser.iOS = function () {
    return (/iPhone|iPad|iPod/.test(navigator.userAgent) && !window.MSStream
    );
  };
}

/**
* The global storage array which holds all data reference objects
* from every instance
* This allows us to hide tooltips from all instances, finding the ref when
* clicking on the body, and for followCursor
*/
var Store = exports.Store = [];

/**
* Selector constants used for grabbing elements
*/
var Selectors = exports.Selectors = {
  POPPER: '.tippy-popper',
  TOOLTIP: '.tippy-tooltip',
  CONTENT: '.tippy-tooltip-content',
  CIRCLE: '[x-circle]',
  ARROW: '[x-arrow]',
  TOOLTIPPED_EL: '[data-tooltipped]',
  CONTROLLER: '[data-tippy-controller]'
};

/**
* The default settings applied to each instance
*/
var Defaults = exports.Defaults = {
  html: false,
  position: 'top',
  animation: 'shift',
  animateFill: true,
  arrow: false,
  arrowSize: 'regular',
  delay: 0,
  trigger: 'mouseenter focus',
  duration: 350,
  interactive: false,
  interactiveBorder: 2,
  theme: 'dark',
  size: 'regular',
  distance: 10,
  offset: 0,
  hideOnClick: true,
  multiple: false,
  followCursor: false,
  inertia: false,
  flipDuration: 350,
  sticky: false,
  stickyDuration: 200,
  appendTo: function appendTo() {
    return document.body;
  },
  zIndex: 9999,
  touchHold: false,
  performance: false,
  dynamicTitle: false,
  useContext: false,
  reactInstance: undefined,
  popperOptions: {},
  open: undefined,
  onRequestClose: function onRequestClose() {}
};

/**
* The keys of the defaults object for reducing down into a new object
* Used in `getIndividualSettings()`
*/
var DefaultsKeys = exports.DefaultsKeys = Browser.SUPPORTED && Object.keys(Defaults);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefix;
/**
* Returns the supported prefixed property - only `webkit` is needed, `moz`, `ms` and `o` are obsolete
* @param {String} property
* @return {String} - browser supported prefixed property
*/
function prefix(property) {
  var prefixes = [false, 'webkit'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var _prefix = prefixes[i];
    var prefixedProp = _prefix ? '' + _prefix + upperProp : property;
    if (typeof window.document.body.style[prefixedProp] !== 'undefined') {
      return prefixedProp;
    }
  }

  return null;
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = find;
/**
* Ponyfill for Array.prototype.find
* @param {Array} arr
* @param {Function} checkFn
* @return item in the array
*/
function find(arr, checkFn) {
  if (Array.prototype.find) {
    return arr.find(checkFn);
  }

  // use `filter` as fallback
  return arr.filter(checkFn)[0];
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCorePlacement;
/**
* Returns the non-shifted placement (e.g., 'bottom-start' => 'bottom')
* @param {String} placement
* @return {String}
*/
function getCorePlacement(placement) {
  return placement.replace(/-.+/, '');
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = closest;

var _matches = __webpack_require__(8);

/**
* Ponyfill to get the closest parent element
* @param {Element} element - child of parent to be returned
* @param {String} parentSelector - selector to match the parent if found
* @return {Element}
*/
function closest(element, parentSelector) {
  var _closest = Element.prototype.closest || function (selector) {
    var el = this;
    while (el) {
      if (_matches.matches.call(el, selector)) {
        return el;
      }
      el = el.parentElement;
    }
  };

  return _closest.call(element, parentSelector);
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defer;
/**
* Waits until next repaint to execute a fn
* @param {Function} fn
*/
function defer(fn) {
  window.requestAnimationFrame(function () {
    setTimeout(fn, 0);
  });
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getInnerElements;

var _globals = __webpack_require__(0);

/**
* Returns inner elements of the popper element
* @param {Element} popper
* @return {Object}
*/
function getInnerElements(popper) {
  return {
    tooltip: popper.querySelector(_globals.Selectors.TOOLTIP),
    circle: popper.querySelector(_globals.Selectors.CIRCLE),
    content: popper.querySelector(_globals.Selectors.CONTENT)
  };
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isVisible;
/**
* Determines if a popper is currently visible
* @param {Element} popper
* @return {Boolean}
*/
function isVisible(popper) {
  return popper.style.visibility === 'visible';
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function defaultMatchSelector(s) {
  var matches = (this.document || this.ownerDocument).querySelectorAll(s),
      i = matches.length;
  while (--i >= 0 && matches.item(i) !== this) {}
  return i > -1;
}

var matches = exports.matches = typeof window === 'undefined' ? defaultMatchSelector : Element.prototype.matches || Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || defaultMatchSelector;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(13);

var _react2 = _interopRequireDefault(_react);

var _tippy = __webpack_require__(30);

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProps = {
  html: null,
  position: 'top',
  animation: 'shift',
  animateFill: true,
  arrow: false,
  delay: 0,
  hideDelay: 0,
  trigger: 'mouseenter focus',
  duration: 375,
  hideDuration: 375,
  interactive: false,
  interactiveBorder: 2,
  theme: 'dark',
  offset: 0,
  hideOnClick: true,
  multiple: false,
  followCursor: false,
  inertia: false,
  popperOptions: {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onHide: function onHide() {},
  onHidden: function onHidden() {},
  disabled: false,
  arrowSize: 'regular',
  size: 'regular',
  className: '',
  style: {},
  distance: 10,
  onRequestClose: function onRequestClose() {},
  sticky: false,
  stickyDuration: 200,
  touchHold: false,
  unmountHTMLWhenHide: false
};

var propKeys = Object.keys(defaultProps);

var detectPropsChanged = function detectPropsChanged(props, prevProps) {
  var result = [];
  propKeys.forEach(function (key) {
    if (props[key] !== prevProps[key]) {
      result.push(key);
    }
  });
  return result;
};

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip(props) {
    _classCallCheck(this, Tooltip);

    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.initTippy = _this._initTippy.bind(_this);
    _this.destroyTippy = _this._destroyTippy.bind(_this);
    _this.updateTippy = _this._updateTippy.bind(_this);
    _this.updateReactDom = _this._updateReactDom.bind(_this);
    _this.showTooltip = _this._showTooltip.bind(_this);
    _this.hideTooltip = _this._hideTooltip.bind(_this);
    _this.updateSettings = _this._updateSettings.bind(_this);
    return _this;
  }

  _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      this.initTippy();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      this.destroyTippy();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      // enable and disabled
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.props.disabled === false && prevProps.disabled === true) {
        this.updateSettings('disabled', false);
        this.destroyTippy();
        this.initTippy();
        return;
      }

      if (this.props.disabled === true && prevProps.disabled === false) {
        this.updateSettings('disabled', true);
        this.destroyTippy();
        return;
      }

      // open
      if (this.props.open === true && !prevProps.open) {
        this.updateSettings('open', true);
        setTimeout(function () {
          _this2.showTooltip();
        }, 0);
      }
      if (this.props.open === false && prevProps.open === true) {
        this.updateSettings('open', false);
        this.hideTooltip();
      }

      if (this.props.html !== prevProps.html) {
        this.updateReactDom();
      }

      // Update content
      if (this.props.title !== prevProps.title) {
        this.updateTippy();
      }

      // update otherProps
      var propChanges = detectPropsChanged(this.props, prevProps);
      propChanges.forEach(function (key) {
        _this2.updateSettings(key, _this2.props[key]);
      });
    }
  }, {
    key: '_showTooltip',
    value: function _showTooltip() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.tippy.show(popper, this.props.duration);
      }
    }
  }, {
    key: '_hideTooltip',
    value: function _hideTooltip() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.tippy.hide(popper, this.props.hideDuration);
      }
    }
  }, {
    key: '_updateSettings',
    value: function _updateSettings(name, value) {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.tippy.updateSettings(popper, name, value);
      }
    }
  }, {
    key: '_updateReactDom',
    value: function _updateReactDom() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        this.updateSettings('reactDOM', this.props.html);
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        var isVisible = popper.style.visibility === 'visible' || this.props.open;
        if (isVisible) {
          this.tippy.updateForReact(popper, this.props.html);
        }
      }
    }
  }, {
    key: '_updateTippy',
    value: function _updateTippy() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.tippy.update(popper);
      }
    }
  }, {
    key: '_initTippy',
    value: function _initTippy() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (!this.props.disabled) {
        this.tooltipDOM.setAttribute('title', this.props.title);
        this.tippy = (0, _tippy2.default)(this.tooltipDOM, {
          disabled: this.props.disabled,
          position: this.props.position,
          animation: this.props.animation,
          animateFill: this.props.animateFill,
          arrow: this.props.arrow,
          arrowSize: this.props.arrowSize,
          delay: this.props.delay,
          hideDelay: this.props.hideDelay,
          trigger: this.props.trigger,
          duration: this.props.duration,
          hideDuration: this.props.hideDuration,
          interactive: this.props.interactive,
          interactiveBorder: this.props.interactiveBorder,
          theme: this.props.theme,
          offset: this.props.offset,
          hideOnClick: this.props.hideOnClick,
          multiple: this.props.multiple,
          size: this.props.size,
          followCursor: this.props.followCursor,
          inertia: this.props.inertia,
          popperOptions: this.props.popperOptions,
          onShow: this.props.onShow,
          onShown: this.props.onShown,
          onHide: this.props.onHide,
          onHidden: this.props.onHidden,
          distance: this.props.distance,
          reactDOM: this.props.html,
          unmountHTMLWhenHide: this.props.unmountHTMLWhenHide,
          open: this.props.open,
          sticky: this.props.sticky,
          stickyDuration: this.props.stickyDuration,
          touchHold: this.props.touchHold,
          onRequestClose: this.props.onRequestClose,
          useContext: this.props.useContext,
          reactInstance: this.props.useContext ? this : undefined,
          performance: true,
          html: this.props.rawTemplate ? this.props.rawTemplate : undefined
        });
        if (this.props.open) {
          this.showTooltip();
        }
      } else {
        this.tippy = null;
      }
    }
  }, {
    key: '_destroyTippy',
    value: function _destroyTippy() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      if (this.tippy) {
        var popper = this.tippy.getPopperElement(this.tooltipDOM);
        this.updateSettings('open', false);
        this.tippy.hide(popper, 0);
        this.tippy.destroy(popper);
        this.tippy = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(tooltip) {
            _this3.tooltipDOM = tooltip;
          },
          title: this.props.title,
          className: this.props.className,
          tabIndex: this.props.tabIndex,
          style: _extends({
            display: 'inline'
          }, this.props.style)
        },
        this.props.children
      );
    }
  }]);

  return Tooltip;
}(_react.Component);

Tooltip.defaultProps = defaultProps;

exports.default = Tooltip;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = followCursorHandler;

var _globals = __webpack_require__(0);

var _getCorePlacement = __webpack_require__(3);

var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _closest = __webpack_require__(4);

var _closest2 = _interopRequireDefault(_closest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Mousemove event listener callback method for follow cursor setting
* @param {MouseEvent} e
*/
function followCursorHandler(e) {
  var _this = this;

  var refData = (0, _find2.default)(_globals.Store, function (refData) {
    return refData.el === _this;
  });

  var popper = refData.popper,
      offset = refData.settings.offset;


  var position = (0, _getCorePlacement2.default)(popper.getAttribute('x-placement'));
  var halfPopperWidth = Math.round(popper.offsetWidth / 2);
  var halfPopperHeight = Math.round(popper.offsetHeight / 2);
  var viewportPadding = 5;
  var pageWidth = document.documentElement.offsetWidth || document.body.offsetWidth;

  var pageX = e.pageX,
      pageY = e.pageY;


  var x = void 0,
      y = void 0;

  switch (position) {
    case 'top':
      x = pageX - halfPopperWidth + offset;
      y = pageY - 2.25 * halfPopperHeight;
      break;
    case 'left':
      x = pageX - 2 * halfPopperWidth - 10;
      y = pageY - halfPopperHeight + offset;
      break;
    case 'right':
      x = pageX + halfPopperHeight;
      y = pageY - halfPopperHeight + offset;
      break;
    case 'bottom':
      x = pageX - halfPopperWidth + offset;
      y = pageY + halfPopperHeight / 1.5;
      break;
  }

  var isRightOverflowing = pageX + viewportPadding + halfPopperWidth + offset > pageWidth;
  var isLeftOverflowing = pageX - viewportPadding - halfPopperWidth + offset < 0;

  // Prevent left/right overflow
  if (position === 'top' || position === 'bottom') {
    if (isRightOverflowing) {
      x = pageWidth - viewportPadding - 2 * halfPopperWidth;
    }

    if (isLeftOverflowing) {
      x = viewportPadding;
    }
  }

  popper.style[(0, _prefix2.default)('transform')] = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOffsetDistanceInPx;

var _globals = __webpack_require__(0);

/**
* Returns the distance taking into account the default distance due to
* the transform: translate setting in CSS
* @param {Number} distance
* @return {String}
*/
function getOffsetDistanceInPx(distance) {
  return -(distance - _globals.Defaults.distance) + 'px';
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeTitle;
/**
* Removes the title from the tooltipped element, setting `data-original-title`
* appropriately
* @param {Element} el
*/
function removeTitle(el) {
  var title = el.getAttribute('title');

  // Only set `data-original-title` attr if there is a title
  if (title) {
    el.setAttribute('data-original-title', title);
  }

  el.removeAttribute('title');
}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_13__;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(13);

var _react2 = _interopRequireDefault(_react);

var _component = __webpack_require__(9);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var withTooltip = function withTooltip(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref) {
    var props = _objectWithoutProperties(_ref, []);

    return _react2.default.createElement(
      _component2.default,
      options,
      _react2.default.createElement(Component, props)
    );
  };
};

exports.default = withTooltip;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTooltip = exports.Tooltip = undefined;

var _component = __webpack_require__(9);

var _component2 = _interopRequireDefault(_component);

var _hoc = __webpack_require__(14);

var _hoc2 = _interopRequireDefault(_hoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Tooltip = _component2.default;
exports.withTooltip = _hoc2.default;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bindEventListeners;

var _globals = __webpack_require__(0);

var _hideAllPoppers = __webpack_require__(25);

var _hideAllPoppers2 = _interopRequireDefault(_hideAllPoppers);

var _closest = __webpack_require__(4);

var _closest2 = _interopRequireDefault(_closest);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _matches = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Adds the needed event listeners
*/
function bindEventListeners() {
  var touchHandler = function touchHandler() {
    _globals.Browser.touch = true;

    if (_globals.Browser.iOS()) {
      document.body.classList.add('tippy-touch');
    }

    if (_globals.Browser.dynamicInputDetection && window.performance) {
      document.addEventListener('mousemove', mousemoveHandler);
    }
  };

  var mousemoveHandler = function () {
    var time = void 0;

    return function () {
      var now = performance.now();

      // Chrome 60+ is 1 mousemove per rAF, use 20ms time difference
      if (now - time < 20) {
        _globals.Browser.touch = false;
        document.removeEventListener('mousemove', mousemoveHandler);
        if (!_globals.Browser.iOS()) {
          document.body.classList.remove('tippy-touch');
        }
      }

      time = now;
    };
  }();

  var clickHandler = function clickHandler(event) {
    // Simulated events dispatched on the document
    if (!(event.target instanceof Element)) {
      return (0, _hideAllPoppers2.default)();
    }

    var el = (0, _closest2.default)(event.target, _globals.Selectors.TOOLTIPPED_EL);
    var popper = (0, _closest2.default)(event.target, _globals.Selectors.POPPER);

    if (popper) {
      var ref = (0, _find2.default)(_globals.Store, function (ref) {
        return ref.popper === popper;
      });
      var interactive = ref.settings.interactive;

      if (interactive) return;
    }

    if (el) {
      var _ref = (0, _find2.default)(_globals.Store, function (ref) {
        return ref.el === el;
      });
      var _ref$settings = _ref.settings,
          hideOnClick = _ref$settings.hideOnClick,
          multiple = _ref$settings.multiple,
          trigger = _ref$settings.trigger;

      // Hide all poppers except the one belonging to the element that was clicked IF
      // `multiple` is false AND they are a touch user, OR
      // `multiple` is false AND it's triggered by a click

      if (!multiple && _globals.Browser.touch || !multiple && trigger.indexOf('click') !== -1) {
        return (0, _hideAllPoppers2.default)(_ref);
      }

      // If hideOnClick is not strictly true or triggered by a click don't hide poppers
      if (hideOnClick !== true || trigger.indexOf('click') !== -1) return;
    }

    // Don't trigger a hide for tippy controllers, and don't needlessly run loop
    if ((0, _closest2.default)(event.target, _globals.Selectors.CONTROLLER) || !document.querySelector(_globals.Selectors.POPPER)) return;

    (0, _hideAllPoppers2.default)();
  };

  var blurHandler = function blurHandler(event) {
    var _document = document,
        el = _document.activeElement;

    if (el && el.blur && _matches.matches.call(el, _globals.Selectors.TOOLTIPPED_EL)) {
      el.blur();
    }
  };

  // Hook events
  document.addEventListener('click', clickHandler);
  document.addEventListener('touchstart', touchHandler);
  window.addEventListener('blur', blurHandler);

  if (!_globals.Browser.SUPPORTS_TOUCH && (navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0)) {
    document.addEventListener('pointerdown', touchHandler);
  }
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPopperElement;

var _getCorePlacement = __webpack_require__(3);

var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);

var _getOffsetDistanceInPx = __webpack_require__(11);

var _getOffsetDistanceInPx2 = _interopRequireDefault(_getOffsetDistanceInPx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Creates a popper element then returns it
* @param {Number} id - the popper id
* @param {String} title - the tooltip's `title` attribute
* @param {Object} settings - individual settings
* @return {Element} - the popper element
*/
function createPopperElement(id, title, settings) {
  var position = settings.position,
      distance = settings.distance,
      arrow = settings.arrow,
      animateFill = settings.animateFill,
      inertia = settings.inertia,
      animation = settings.animation,
      arrowSize = settings.arrowSize,
      size = settings.size,
      theme = settings.theme,
      html = settings.html,
      zIndex = settings.zIndex,
      interactive = settings.interactive;


  var popper = document.createElement('div');
  popper.setAttribute('class', 'tippy-popper');
  popper.setAttribute('role', 'tooltip');
  popper.setAttribute('aria-hidden', 'true');
  popper.setAttribute('id', 'tippy-tooltip-' + id);
  popper.style.zIndex = zIndex;

  var tooltip = document.createElement('div');
  tooltip.setAttribute('class', 'tippy-tooltip tippy-tooltip--' + size + ' leave');
  tooltip.setAttribute('data-animation', animation);

  theme.split(' ').forEach(function (t) {
    tooltip.classList.add(t + '-theme');
  });

  if (arrow) {
    // Add an arrow
    var _arrow = document.createElement('div');
    _arrow.setAttribute('class', 'arrow-' + arrowSize);
    _arrow.setAttribute('x-arrow', '');
    tooltip.appendChild(_arrow);
  }

  if (animateFill) {
    // Create animateFill circle element for animation
    tooltip.setAttribute('data-animatefill', '');
    var circle = document.createElement('div');
    circle.setAttribute('class', 'leave');
    circle.setAttribute('x-circle', '');
    tooltip.appendChild(circle);
  }

  if (inertia) {
    // Change transition timing function cubic bezier
    tooltip.setAttribute('data-inertia', '');
  }

  if (interactive) {
    tooltip.setAttribute('data-interactive', '');
  }

  // Tooltip content (text or HTML)
  var content = document.createElement('div');
  content.setAttribute('class', 'tippy-tooltip-content');

  if (html) {
    var templateId = void 0;

    if (html instanceof Element) {
      content.appendChild(html);
      templateId = '#' + html.id || 'tippy-html-template';
    } else {
      content.innerHTML = document.getElementById(html.replace('#', '')).innerHTML;
      templateId = html;
    }

    popper.classList.add('html-template');
    interactive && popper.setAttribute('tabindex', '-1');
    tooltip.setAttribute('data-template-id', templateId);
  } else {
    content.innerHTML = title;
  }

  // Init distance. Further updates are made in the popper instance's `onUpdate()` method
  tooltip.style[(0, _getCorePlacement2.default)(position)] = (0, _getOffsetDistanceInPx2.default)(distance);

  tooltip.appendChild(content);
  popper.appendChild(tooltip);

  return popper;
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createPopperInstance;

var _popper = __webpack_require__(38);

var _popper2 = _interopRequireDefault(_popper);

var _defer = __webpack_require__(5);

var _defer2 = _interopRequireDefault(_defer);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _getCorePlacement = __webpack_require__(3);

var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);

var _getInnerElements2 = __webpack_require__(6);

var _getInnerElements3 = _interopRequireDefault(_getInnerElements2);

var _getOffsetDistanceInPx = __webpack_require__(11);

var _getOffsetDistanceInPx2 = _interopRequireDefault(_getOffsetDistanceInPx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Creates a new popper instance
* @param {Object} data
* @return {Object} - the popper instance
*/
function createPopperInstance(data) {
  var el = data.el,
      popper = data.popper,
      _data$settings = data.settings,
      position = _data$settings.position,
      popperOptions = _data$settings.popperOptions,
      offset = _data$settings.offset,
      distance = _data$settings.distance,
      flipDuration = _data$settings.flipDuration;

  var _getInnerElements = (0, _getInnerElements3.default)(popper),
      tooltip = _getInnerElements.tooltip;

  var config = _extends({
    placement: position
  }, popperOptions || {}, {
    modifiers: _extends({}, popperOptions ? popperOptions.modifiers : {}, {
      flip: _extends({
        padding: distance + 5 /* 5px from viewport boundary */
      }, popperOptions && popperOptions.modifiers ? popperOptions.modifiers.flip : {}),
      offset: _extends({
        offset: offset
      }, popperOptions && popperOptions.modifiers ? popperOptions.modifiers.offset : {})
    }),
    onUpdate: function onUpdate() {
      var styles = tooltip.style;
      styles.top = '';
      styles.bottom = '';
      styles.left = '';
      styles.right = '';
      styles[(0, _getCorePlacement2.default)(popper.getAttribute('x-placement'))] = (0, _getOffsetDistanceInPx2.default)(distance);
    }
  });

  // Update the popper's position whenever its content changes
  // Not supported in IE10 unless polyfilled
  if (window.MutationObserver) {
    var styles = popper.style;

    var observer = new MutationObserver(function () {
      styles[(0, _prefix2.default)('transitionDuration')] = '0ms';
      data.popperInstance.update();
      (0, _defer2.default)(function () {
        styles[(0, _prefix2.default)('transitionDuration')] = flipDuration + 'ms';
      });
    });

    observer.observe(popper, {
      childList: true,
      subtree: true,
      characterData: true
    });

    data._mutationObserver = observer;
  }

  return new _popper2.default(el, popper, config);
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTooltips;

var _getIndividualSettings = __webpack_require__(24);

var _getIndividualSettings2 = _interopRequireDefault(_getIndividualSettings);

var _createPopperElement = __webpack_require__(17);

var _createPopperElement2 = _interopRequireDefault(_createPopperElement);

var _createTrigger = __webpack_require__(20);

var _createTrigger2 = _interopRequireDefault(_createTrigger);

var _getEventListenerHandlers = __webpack_require__(23);

var _getEventListenerHandlers2 = _interopRequireDefault(_getEventListenerHandlers);

var _evaluateSettings = __webpack_require__(21);

var _evaluateSettings2 = _interopRequireDefault(_evaluateSettings);

var _removeTitle = __webpack_require__(12);

var _removeTitle2 = _interopRequireDefault(_removeTitle);

var _globals = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var idCounter = 1;

/**
* Creates tooltips for all el elements that match the instance's selector
* @param {Element[]} els
* @return {Object[]} Array of ref data objects
*/
function createTooltips(els) {
  var _this = this;

  return els.reduce(function (a, el) {
    var id = idCounter;

    var settings = (0, _evaluateSettings2.default)(_this.settings.performance ? _this.settings : (0, _getIndividualSettings2.default)(el, _this.settings));

    var html = settings.html,
        trigger = settings.trigger,
        touchHold = settings.touchHold;


    var title = el.getAttribute('title');
    if (!title && !html) return a;

    el.setAttribute('data-tooltipped', '');
    el.setAttribute('aria-describedby', 'tippy-tooltip-' + id);
    (0, _removeTitle2.default)(el);

    var popper = (0, _createPopperElement2.default)(id, title, settings);
    var handlers = _getEventListenerHandlers2.default.call(_this, el, popper, settings);

    var listeners = [];

    trigger.trim().split(' ').forEach(function (event) {
      return listeners = listeners.concat((0, _createTrigger2.default)(event, el, handlers, touchHold));
    });

    a.push({
      id: id,
      el: el,
      popper: popper,
      settings: settings,
      listeners: listeners,
      tippyInstance: _this
    });

    idCounter++;

    return a;
  }, []);
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTrigger;

var _globals = __webpack_require__(0);

/**
* Creates a trigger
* @param {Object} event - the custom event specified in the `trigger` setting
* @param {Element} el - tooltipped element
* @param {Object} handlers - the handlers for each listener
* @param {Boolean} touchHold
* @return {Array} - array of listener objects
*/
function createTrigger(event, el, handlers, touchHold) {
  var listeners = [];

  if (event === 'manual') return listeners;

  // Enter
  el.addEventListener(event, handlers.handleTrigger);
  listeners.push({
    event: event,
    handler: handlers.handleTrigger
  });

  // Leave
  if (event === 'mouseenter') {
    if (_globals.Browser.SUPPORTS_TOUCH && touchHold) {
      el.addEventListener('touchstart', handlers.handleTrigger);
      listeners.push({
        event: 'touchstart',
        handler: handlers.handleTrigger
      });
      el.addEventListener('touchend', handlers.handleMouseleave);
      listeners.push({
        event: 'touchend',
        handler: handlers.handleMouseleave
      });
    }

    el.addEventListener('mouseleave', handlers.handleMouseleave);
    listeners.push({
      event: 'mouseleave',
      handler: handlers.handleMouseleave
    });
  }

  if (event === 'focus') {
    el.addEventListener('blur', handlers.handleBlur);
    listeners.push({
      event: 'blur',
      handler: handlers.handleBlur
    });
  }

  return listeners;
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = evaluateSettings;
/**
* Evaluates/modifies the settings object for appropriate behavior
* @param {Object} settings
* @return {Object} modified/evaluated settings
*/
function evaluateSettings(settings) {
  // animateFill is disabled if an arrow is true
  if (settings.arrow) {
    settings.animateFill = false;
  }

  // reassign appendTo into the result of evaluating appendTo
  // if it's set as a function instead of Element
  if (settings.appendTo && typeof settings.appendTo === 'function') {
    settings.appendTo = settings.appendTo();
  }

  return settings;
}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getArrayOfElements;
/**
* Returns an array of elements based on the selector input
* @param {String|Element|Element[]} selector
* @return {Element[]}
*/
function getArrayOfElements(selector) {
  if (selector instanceof Element) {
    return [selector];
  }

  if (Array.isArray(selector)) {
    return selector;
  }

  return [].slice.call(document.querySelectorAll(selector));
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getEventListenerHandlers;

var _globals = __webpack_require__(0);

var _isVisible = __webpack_require__(7);

var _isVisible2 = _interopRequireDefault(_isVisible);

var _closest = __webpack_require__(4);

var _closest2 = _interopRequireDefault(_closest);

var _cursorIsOutsideInteractiveBorder = __webpack_require__(32);

var _cursorIsOutsideInteractiveBorder2 = _interopRequireDefault(_cursorIsOutsideInteractiveBorder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Returns relevant listener callbacks for each ref
* @param {Element} el
* @param {Element} popper
* @param {Object} settings
* @return {Object} - relevant listener handlers
*/
function getEventListenerHandlers(el, popper, settings) {
  var _this = this;

  var position = settings.position,
      delay = settings.delay,
      duration = settings.duration,
      interactive = settings.interactive,
      interactiveBorder = settings.interactiveBorder,
      distance = settings.distance,
      hideOnClick = settings.hideOnClick,
      trigger = settings.trigger,
      touchHold = settings.touchHold,
      touchWait = settings.touchWait;


  var showDelay = void 0,
      hideDelay = void 0;

  var clearTimeouts = function clearTimeouts() {
    clearTimeout(showDelay);
    clearTimeout(hideDelay);
  };

  var _show = function _show() {
    clearTimeouts();

    // Not hidden. For clicking when it also has a `focus` event listener
    if ((0, _isVisible2.default)(popper)) return;

    var _delay = Array.isArray(delay) ? delay[0] : delay;

    if (delay) {
      showDelay = setTimeout(function () {
        return _this.show(popper);
      }, _delay);
    } else {
      _this.show(popper);
    }
  };

  var show = function show(event) {
    return _this.callbacks.wait ? _this.callbacks.wait.call(popper, _show, event) : _show();
  };

  var hide = function hide() {
    clearTimeouts();

    var _delay = Array.isArray(delay) ? delay[1] : delay;

    if (delay) {
      hideDelay = setTimeout(function () {
        return _this.hide(popper);
      }, _delay);
    } else {
      _this.hide(popper);
    }
  };

  var handleTrigger = function handleTrigger(event) {
    var mouseenterTouch = event.type === 'mouseenter' && _globals.Browser.SUPPORTS_TOUCH && _globals.Browser.touch;

    if (mouseenterTouch && touchHold) return;

    // Toggle show/hide when clicking click-triggered tooltips
    var isClick = event.type === 'click';
    var isNotPersistent = hideOnClick !== 'persistent';

    isClick && (0, _isVisible2.default)(popper) && isNotPersistent ? hide() : show(event);

    if (mouseenterTouch && _globals.Browser.iOS() && el.click) {
      el.click();
    }
  };

  var handleMouseleave = function handleMouseleave(event) {

    // Don't fire 'mouseleave', use the 'touchend'
    if (event.type === 'mouseleave' && _globals.Browser.SUPPORTS_TOUCH && _globals.Browser.touch && touchHold) {
      return;
    }

    if (interactive) {
      // Temporarily handle mousemove to check if the mouse left somewhere
      // other than its popper
      var handleMousemove = function handleMousemove(event) {

        var triggerHide = function triggerHide() {
          document.body.removeEventListener('mouseleave', hide);
          document.removeEventListener('mousemove', handleMousemove);
          hide();
        };

        var closestTooltippedEl = (0, _closest2.default)(event.target, _globals.Selectors.TOOLTIPPED_EL);

        var isOverPopper = (0, _closest2.default)(event.target, _globals.Selectors.POPPER) === popper;
        var isOverEl = closestTooltippedEl === el;
        var isClickTriggered = trigger.indexOf('click') !== -1;
        var isOverOtherTooltippedEl = closestTooltippedEl && closestTooltippedEl !== el;

        if (isOverOtherTooltippedEl) {
          return triggerHide();
        }

        if (isOverPopper || isOverEl || isClickTriggered) return;

        if ((0, _cursorIsOutsideInteractiveBorder2.default)(event, popper, settings)) {
          triggerHide();
        }
      };

      document.body.addEventListener('mouseleave', hide);
      document.addEventListener('mousemove', handleMousemove);

      return;
    }

    // If it's not interactive, just hide it
    hide();
  };

  var handleBlur = function handleBlur(event) {
    // Ignore blur on touch devices, if there is no `relatedTarget`, hide
    // If the related target is a popper, ignore
    if (!event.relatedTarget || _globals.Browser.touch) return;
    if ((0, _closest2.default)(event.relatedTarget, _globals.Selectors.POPPER)) return;

    hide();
  };

  return {
    handleTrigger: handleTrigger,
    handleMouseleave: handleMouseleave,
    handleBlur: handleBlur
  };
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIndividualSettings;

var _globals = __webpack_require__(0);

/**
* Returns an object of settings to override global settings
* @param {Element} el - the tooltipped element
* @param {Object} instanceSettings
* @return {Object} - individual settings
*/
function getIndividualSettings(el, instanceSettings) {
  var settings = _globals.DefaultsKeys.reduce(function (acc, key) {
    var val = el.getAttribute('data-' + key.toLowerCase()) || instanceSettings[key];

    // Convert strings to booleans
    if (val === 'false') val = false;
    if (val === 'true') val = true;

    // Convert number strings to true numbers
    if (isFinite(val) && !isNaN(parseFloat(val))) {
      val = parseFloat(val);
    }

    // Convert array strings to actual arrays
    if (typeof val === 'string' && val.trim().charAt(0) === '[') {
      val = JSON.parse(val);
    }

    acc[key] = val;

    return acc;
  }, {});

  return Object.assign({}, instanceSettings, settings);
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hideAllPoppers;

var _globals = __webpack_require__(0);

/**
* Hides all poppers
* @param {Object} exclude - refData to exclude if needed
*/
function hideAllPoppers(exclude) {
  _globals.Store.forEach(function (refData) {
    var popper = refData.popper,
        tippyInstance = refData.tippyInstance,
        _refData$settings = refData.settings,
        appendTo = _refData$settings.appendTo,
        hideOnClick = _refData$settings.hideOnClick,
        trigger = _refData$settings.trigger;

    // Don't hide already hidden ones

    if (!appendTo.contains(popper)) return;

    // hideOnClick can have the truthy value of 'persistent', so strict check is needed
    var isHideOnClick = hideOnClick === true || trigger.indexOf('focus') !== -1;
    var isNotCurrentRef = !exclude || popper !== exclude.popper;

    if (isHideOnClick && isNotCurrentRef) {
      refData.settings.onRequestClose();
      tippyInstance.hide(popper);
    }
  });
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _bindEventListeners = __webpack_require__(16);

var _bindEventListeners2 = _interopRequireDefault(_bindEventListeners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* To run a single time, once DOM is presumed to be ready
* @return {Boolean} whether the function has run or not
*/
function init() {
  if (init.done) return false;
  init.done = true;

  (0, _bindEventListeners2.default)();

  return true;
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeSticky;

var _defer = __webpack_require__(5);

var _defer2 = _interopRequireDefault(_defer);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _isVisible = __webpack_require__(7);

var _isVisible2 = _interopRequireDefault(_isVisible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Updates a popper's position on each animation frame to make it stick to a moving element
* @param {Object} refData
*/
function makeSticky(refData) {
  var popper = refData.popper,
      popperInstance = refData.popperInstance,
      stickyDuration = refData.settings.stickyDuration;


  var applyTransitionDuration = function applyTransitionDuration() {
    return popper.style[(0, _prefix2.default)('transitionDuration')] = stickyDuration + 'ms';
  };

  var removeTransitionDuration = function removeTransitionDuration() {
    return popper.style[(0, _prefix2.default)('transitionDuration')] = '';
  };

  var updatePosition = function updatePosition() {
    popperInstance && popperInstance.scheduleUpdate();

    applyTransitionDuration();

    (0, _isVisible2.default)(popper) ? window.requestAnimationFrame(updatePosition) : removeTransitionDuration();
  };

  // Wait until Popper's position has been updated initially
  (0, _defer2.default)(updatePosition);
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mountPopper;

var _globals = __webpack_require__(0);

var _followCursorHandler = __webpack_require__(10);

var _followCursorHandler2 = _interopRequireDefault(_followCursorHandler);

var _createPopperInstance = __webpack_require__(18);

var _createPopperInstance2 = _interopRequireDefault(_createPopperInstance);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Appends the popper and creates a popper instance if one does not exist
* Also updates its position if need be and enables event listeners
* @param {Object} data -  the element/popper reference data
*/
function mountPopper(data) {
  var el = data.el,
      popper = data.popper,
      _data$settings = data.settings,
      appendTo = _data$settings.appendTo,
      followCursor = _data$settings.followCursor;

  // Already on the DOM

  if (appendTo.contains(popper)) return;

  appendTo.appendChild(popper);

  if (!data.popperInstance) {
    data.popperInstance = (0, _createPopperInstance2.default)(data);
  } else {
    data.popperInstance.update();
    if (!followCursor || _globals.Browser.touch) {
      data.popperInstance.enableEventListeners();
    }
  }

  // Since touch is determined dynamically, followCursor is set on mount
  if (followCursor && !_globals.Browser.touch) {
    el.addEventListener('mousemove', _followCursorHandler2.default);
    data.popperInstance.disableEventListeners();
  }
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = onTransitionEnd;

var _globals = __webpack_require__(0);

var _getInnerElements2 = __webpack_require__(6);

var _getInnerElements3 = _interopRequireDefault(_getInnerElements2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Prepares the callback functions for `show` and `hide` methods
* @param {Object} data
* @param {Number} duration
* @param {Function} callback - callback function to fire once transitions complete
*/
function onTransitionEnd(data, duration, callback) {
  // Make callback synchronous if duration is 0
  if (!duration) {
    return callback();
  }

  var _getInnerElements = (0, _getInnerElements3.default)(data.popper),
      tooltip = _getInnerElements.tooltip;

  var transitionendFired = false;

  var listenerCallback = function listenerCallback(e) {
    if (e.target === tooltip && !transitionendFired) {
      transitionendFired = true;
      callback();
    }
  };

  // Fire callback upon transition completion
  tooltip.addEventListener('webkitTransitionEnd', listenerCallback);
  tooltip.addEventListener('transitionend', listenerCallback);

  // Fallback: transitionend listener sometimes may not fire
  clearTimeout(data._transitionendTimeout);
  data._transitionendTimeout = setTimeout(function () {
    if (!transitionendFired) {
      callback();
    }
  }, duration);
}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

/* Utility functions */


/* Core library functions */


var _globals = __webpack_require__(0);

var _reactDom = __webpack_require__(39);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _init = __webpack_require__(26);

var _init2 = _interopRequireDefault(_init);

var _defer = __webpack_require__(5);

var _defer2 = _interopRequireDefault(_defer);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _findIndex = __webpack_require__(34);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _removeTitle = __webpack_require__(12);

var _removeTitle2 = _interopRequireDefault(_removeTitle);

var _elementIsInViewport = __webpack_require__(33);

var _elementIsInViewport2 = _interopRequireDefault(_elementIsInViewport);

var _triggerReflow = __webpack_require__(37);

var _triggerReflow2 = _interopRequireDefault(_triggerReflow);

var _modifyClassList = __webpack_require__(35);

var _modifyClassList2 = _interopRequireDefault(_modifyClassList);

var _getInnerElements4 = __webpack_require__(6);

var _getInnerElements5 = _interopRequireDefault(_getInnerElements4);

var _applyTransitionDuration = __webpack_require__(31);

var _applyTransitionDuration2 = _interopRequireDefault(_applyTransitionDuration);

var _isVisible = __webpack_require__(7);

var _isVisible2 = _interopRequireDefault(_isVisible);

var _noop = __webpack_require__(36);

var _noop2 = _interopRequireDefault(_noop);

var _followCursorHandler = __webpack_require__(10);

var _followCursorHandler2 = _interopRequireDefault(_followCursorHandler);

var _getArrayOfElements = __webpack_require__(22);

var _getArrayOfElements2 = _interopRequireDefault(_getArrayOfElements);

var _onTransitionEnd = __webpack_require__(29);

var _onTransitionEnd2 = _interopRequireDefault(_onTransitionEnd);

var _mountPopper = __webpack_require__(28);

var _mountPopper2 = _interopRequireDefault(_mountPopper);

var _makeSticky = __webpack_require__(27);

var _makeSticky2 = _interopRequireDefault(_makeSticky);

var _createTooltips = __webpack_require__(19);

var _createTooltips2 = _interopRequireDefault(_createTooltips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
* @param {String|Element|Element[]} selector
* @param {Object} settings (optional) - the object of settings to be applied to the instance
*/
var Tippy = function () {
  function Tippy(selector) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Tippy);

    // Use default browser tooltip on unsupported browsers
    if (!_globals.Browser.SUPPORTED) return;

    (0, _init2.default)();

    this.state = {
      destroyed: false
    };

    this.selector = selector;

    this.settings = _extends({}, _globals.Defaults, settings);

    if (settings.show || settings.shown || settings.hide || settings.hidden) {
      console.warn('Callbacks without the `on` prefix are deprecated (with the exception of `wait`).' + ' Use onShow, onShown, onHide, and onHidden instead.');
    }

    this.callbacks = {
      wait: settings.wait,
      show: settings.onShow || settings.show || _noop2.default,
      shown: settings.onShown || settings.shown || _noop2.default,
      hide: settings.onHide || settings.hide || _noop2.default,
      hidden: settings.onHidden || settings.hidden || _noop2.default
    };

    this.store = _createTooltips2.default.call(this, (0, _getArrayOfElements2.default)(selector));
    _globals.Store.push.apply(_globals.Store, this.store);
  }

  /**
  * Returns the reference element's popper element
  * @param {Element} el
  * @return {Element}
  */


  _createClass(Tippy, [{
    key: 'getPopperElement',
    value: function getPopperElement(el) {
      try {
        return (0, _find2.default)(this.store, function (data) {
          return data.el === el;
        }).popper;
      } catch (e) {
        console.error('[getPopperElement]: Element passed as the argument does not exist in the instance');
      }
    }

    /**
    * Returns a popper's reference element
    * @param {Element} popper
    * @return {Element}
    */

  }, {
    key: 'getReferenceElement',
    value: function getReferenceElement(popper) {
      try {
        return (0, _find2.default)(this.store, function (data) {
          return data.popper === popper;
        }).el;
      } catch (e) {
        console.error('[getReferenceElement]: Popper passed as the argument does not exist in the instance');
      }
    }

    /**
    * Returns the reference data object from either the reference element or popper element
    * @param {Element} x (reference element or popper)
    * @return {Object}
    */

  }, {
    key: 'getReferenceData',
    value: function getReferenceData(x) {
      return (0, _find2.default)(this.store, function (data) {
        return data.el === x || data.popper === x;
      });
    }

    /**
    * Update settings
    * @param {DOMElement} - popper
    * @param {string} - name
    * @param {string} - value
    */

  }, {
    key: 'updateSettings',
    value: function updateSettings(popper, name, value) {
      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });
      var newSettings = _extends({}, data.settings, _defineProperty({}, name, value));
      data.settings = newSettings;
    }
  }, {
    key: 'updateForReact',


    /**
    * Update for React
    * @param {DOMElement} - popper
    * @param {ReactElement} - content
    */
    value: function updateForReact(popper, updatedContent) {
      var tooltipContent = popper.querySelector(_globals.Selectors.CONTENT);
      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });

      var _data$settings = data.settings,
          useContext = _data$settings.useContext,
          reactInstance = _data$settings.reactInstance;

      if (useContext) {
        _reactDom2.default.unstable_renderSubtreeIntoContainer(data.settings.reactInstance, updatedContent, tooltipContent);
      } else {
        _reactDom2.default.render(updatedContent, tooltipContent);
      }
    }
    /**
    * Shows a popper
    * @param {Element} popper
    * @param {Number} customDuration (optional)
    */

  }, {
    key: 'show',
    value: function show(popper, customDuration) {
      var _this = this;

      if (this.state.destroyed) return;

      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });

      var _getInnerElements = (0, _getInnerElements5.default)(popper),
          tooltip = _getInnerElements.tooltip,
          circle = _getInnerElements.circle,
          content = _getInnerElements.content;

      if (!document.body.contains(data.el)) {
        this.destroy(popper);
        return;
      }

      this.callbacks.show.call(popper);

      // Custom react
      if (data && data.settings && data.settings.open === false) {
        return;
      }

      if (data.settings.reactDOM) {
        this.updateForReact(popper, data.settings.reactDOM);
      }
      // end: Custom react

      var el = data.el,
          _data$settings2 = data.settings,
          appendTo = _data$settings2.appendTo,
          sticky = _data$settings2.sticky,
          interactive = _data$settings2.interactive,
          followCursor = _data$settings2.followCursor,
          flipDuration = _data$settings2.flipDuration,
          duration = _data$settings2.duration,
          dynamicTitle = _data$settings2.dynamicTitle;


      if (dynamicTitle) {
        var title = el.getAttribute('title');
        if (title) {
          content.innerHTML = title;
          (0, _removeTitle2.default)(el);
        }
      }

      var _duration = customDuration !== undefined ? customDuration : Array.isArray(duration) ? duration[0] : duration;

      // Prevent a transition when popper changes position
      (0, _applyTransitionDuration2.default)([popper, tooltip, circle], 0);

      (0, _mountPopper2.default)(data);

      popper.style.visibility = 'visible';
      popper.setAttribute('aria-hidden', 'false');

      // Wait for popper's position to update
      (0, _defer2.default)(function () {
        // Sometimes the arrow will not be in the correct position, force another update
        if (!followCursor || _globals.Browser.touch) {
          data.popperInstance.update();
          (0, _applyTransitionDuration2.default)([popper], flipDuration);
        }

        // Re-apply transition durations
        (0, _applyTransitionDuration2.default)([tooltip, circle], _duration);

        // Make content fade out a bit faster than the tooltip if `animateFill`
        if (circle) content.style.opacity = 1;

        // Interactive tooltips receive a class of 'active'
        interactive && el.classList.add('active');

        // Update popper's position on every animation frame
        sticky && (0, _makeSticky2.default)(data);

        // Repaint/reflow is required for CSS transition when appending
        (0, _triggerReflow2.default)(tooltip, circle);

        (0, _modifyClassList2.default)([tooltip, circle], function (list) {
          list.contains('tippy-notransition') && list.remove('tippy-notransition');
          list.remove('leave');
          list.add('enter');
        });

        // Wait for transitions to complete
        (0, _onTransitionEnd2.default)(data, _duration, function () {
          if (!(0, _isVisible2.default)(popper) || data._onShownFired) return;

          // Focus interactive tooltips only
          interactive && popper.focus();
          // Remove transitions from tooltip
          tooltip.classList.add('tippy-notransition');
          // Prevents shown() from firing more than once from early transition cancellations
          data._onShownFired = true;

          _this.callbacks.shown.call(popper);
        });
      });
    }

    /**
    * Hides a popper
    * @param {Element} popper
    * @param {Number} customDuration (optional)
    */

  }, {
    key: 'hide',
    value: function hide(popper, customDuration) {
      var _this2 = this;

      if (this.state.destroyed) return;

      this.callbacks.hide.call(popper);

      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });

      var _getInnerElements2 = (0, _getInnerElements5.default)(popper),
          tooltip = _getInnerElements2.tooltip,
          circle = _getInnerElements2.circle,
          content = _getInnerElements2.content;

      // custom react
      // Prevent hide if open


      if (data.settings.disabled === false && data.settings.open) {
        return;
      }

      var isUnmount = data && data.settings && data.settings.unmountHTMLWhenHide && data.settings.reactDOM;
      // end: custom react

      var el = data.el,
          _data$settings3 = data.settings,
          appendTo = _data$settings3.appendTo,
          sticky = _data$settings3.sticky,
          interactive = _data$settings3.interactive,
          followCursor = _data$settings3.followCursor,
          html = _data$settings3.html,
          trigger = _data$settings3.trigger,
          duration = _data$settings3.duration;


      var _duration = customDuration !== undefined ? customDuration : Array.isArray(duration) ? duration[1] : duration;

      data._onShownFired = false;
      interactive && el.classList.remove('active');

      popper.style.visibility = 'hidden';
      popper.setAttribute('aria-hidden', 'true');

      (0, _applyTransitionDuration2.default)([tooltip, circle, circle ? content : null], _duration);

      if (circle) content.style.opacity = 0;

      (0, _modifyClassList2.default)([tooltip, circle], function (list) {
        list.contains('tippy-tooltip') && list.remove('tippy-notransition');
        list.remove('enter');
        list.add('leave');
      });

      // Re-focus click-triggered html elements
      // and the tooltipped element IS in the viewport (otherwise it causes unsightly scrolling
      // if the tooltip is closed and the element isn't in the viewport anymore)
      if (html && trigger.indexOf('click') !== -1 && (0, _elementIsInViewport2.default)(el)) {
        el.focus();
      }

      // Wait for transitions to complete
      (0, _onTransitionEnd2.default)(data, _duration, function () {
        // `isVisible` is not completely reliable to determine if we shouldn't
        // run the hidden callback, we need to check the computed opacity style.
        // This prevents glitchy behavior of the transition when quickly showing
        // and hiding a tooltip.
        if ((0, _isVisible2.default)(popper) || !appendTo.contains(popper) || getComputedStyle(tooltip).opacity === '1') return;

        el.removeEventListener('mousemove', _followCursorHandler2.default);
        data.popperInstance.disableEventListeners();
        appendTo.removeChild(popper);

        _this2.callbacks.hidden.call(popper);

        // custom react
        if (isUnmount) {
          _reactDom2.default.unmountComponentAtNode(content);
        }
      });
    }

    /**
    * Updates a popper with new content
    * @param {Element} popper
    */

  }, {
    key: 'update',
    value: function update(popper) {
      if (this.state.destroyed) return;

      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });

      var _getInnerElements3 = (0, _getInnerElements5.default)(popper),
          content = _getInnerElements3.content;

      var el = data.el,
          html = data.settings.html;


      if (html instanceof Element) {
        console.warn('Aborted: update() should not be used if `html` is a DOM element');
        return;
      }

      content.innerHTML = html ? document.getElementById(html.replace('#', '')).innerHTML : el.getAttribute('title') || el.getAttribute('data-original-title');

      if (!html) (0, _removeTitle2.default)(el);
    }

    /**
    * Destroys a popper
    * @param {Element} popper
    * @param {Boolean} _isLast - private param used by destroyAll to optimize
    */

  }, {
    key: 'destroy',
    value: function destroy(popper, _isLast) {
      var _this3 = this;

      if (this.state.destroyed) return;

      var data = (0, _find2.default)(this.store, function (data) {
        return data.popper === popper;
      });

      var el = data.el,
          popperInstance = data.popperInstance,
          listeners = data.listeners,
          _mutationObserver = data._mutationObserver;

      // Ensure the popper is hidden

      if ((0, _isVisible2.default)(popper)) {
        this.hide(popper, 0);
      }

      // Remove Tippy-only event listeners from tooltipped element
      listeners.forEach(function (listener) {
        return el.removeEventListener(listener.event, listener.handler);
      });

      // Restore original title
      el.setAttribute('title', el.getAttribute('data-original-title'));

      el.removeAttribute('data-original-title');
      el.removeAttribute('data-tooltipped');
      el.removeAttribute('aria-describedby');

      popperInstance && popperInstance.destroy();
      _mutationObserver && _mutationObserver.disconnect();

      // Remove from store
      _globals.Store.splice((0, _findIndex2.default)(_globals.Store, function (data) {
        return data.popper === popper;
      }), 1);

      // Ensure filter is called only once
      if (_isLast === undefined || _isLast) {
        this.store = _globals.Store.filter(function (data) {
          return data.tippyInstance === _this3;
        });
      }
    }

    /**
    * Destroys all tooltips created by the instance
    */

  }, {
    key: 'destroyAll',
    value: function destroyAll() {
      var _this4 = this;

      if (this.state.destroyed) return;

      var storeLength = this.store.length;

      this.store.forEach(function (_ref, index) {
        var popper = _ref.popper;

        _this4.destroy(popper, index === storeLength - 1);
      });

      this.store = null;
      this.state.destroyed = true;
    }
  }]);

  return Tippy;
}();

function tippy(selector, settings) {
  return new Tippy(selector, settings);
}

tippy.Browser = _globals.Browser;
tippy.Defaults = _globals.Defaults;
tippy.disableDynamicInputDetection = function () {
  return _globals.Browser.dynamicInputDetection = false;
};
tippy.enableDynamicInputDetection = function () {
  return _globals.Browser.dynamicInputDetection = true;
};

exports.default = tippy;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyTransitionDuration;

var _globals = __webpack_require__(0);

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

var _matches = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Applies the transition duration to each element
* @param {Element[]} els - Array of elements
* @param {Number} duration
*/
function applyTransitionDuration(els, duration) {
  els.forEach(function (el) {
    if (!el) return;

    var isContent = _matches.matches.call(el, _globals.Selectors.CONTENT);

    var _duration = isContent ? Math.round(duration / 1.3) : duration;

    el.style[(0, _prefix2.default)('transitionDuration')] = _duration + 'ms';
  });
}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursorIsOutsideInteractiveBorder;

var _getCorePlacement = __webpack_require__(3);

var _getCorePlacement2 = _interopRequireDefault(_getCorePlacement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Determines if the mouse's cursor is outside the interactive border
* @param {MouseEvent} event
* @param {Element} popper
* @param {Object} settings
* @return {Boolean}
*/
function cursorIsOutsideInteractiveBorder(event, popper, settings) {
  if (!popper.getAttribute('x-placement')) return true;

  var x = event.clientX,
      y = event.clientY;
  var interactiveBorder = settings.interactiveBorder,
      distance = settings.distance;


  var rect = popper.getBoundingClientRect();
  var corePosition = (0, _getCorePlacement2.default)(popper.getAttribute('x-placement'));
  var borderWithDistance = interactiveBorder + distance;

  var exceeds = {
    top: rect.top - y > interactiveBorder,
    bottom: y - rect.bottom > interactiveBorder,
    left: rect.left - x > interactiveBorder,
    right: x - rect.right > interactiveBorder
  };

  switch (corePosition) {
    case 'top':
      exceeds.top = rect.top - y > borderWithDistance;
      break;
    case 'bottom':
      exceeds.bottom = y - rect.bottom > borderWithDistance;
      break;
    case 'left':
      exceeds.left = rect.left - x > borderWithDistance;
      break;
    case 'right':
      exceeds.right = x - rect.right > borderWithDistance;
      break;
  }

  return exceeds.top || exceeds.bottom || exceeds.left || exceeds.right;
}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = elementIsInViewport;
/**
* Determines if an element is visible in the viewport
* @param {Element} el
* @return {Boolean}
*/
function elementIsInViewport(el) {
  var rect = el.getBoundingClientRect();

  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findIndex;

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Ponyfill for Array.prototype.findIndex
* @param {Array} arr
* @param {Function} checkFn
* @return index of the item in the array
*/
function findIndex(arr, checkFn) {
  if (Array.prototype.findIndex) {
    return arr.findIndex(checkFn);
  }

  // fallback
  return arr.indexOf((0, _find2.default)(arr, checkFn));
}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = modifyClassList;
/**
* Modifies elements' class lists
* @param {Element[]} els - Array of elements
* @param {Function} callback
*/
function modifyClassList(els, callback) {
  els.forEach(function (el) {
    if (!el) return;
    callback(el.classList);
  });
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = noop;
function noop() {}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = triggerReflow;

var _prefix = __webpack_require__(1);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Triggers a document repaint or reflow for CSS transition
* @param {Element} tooltip
* @param {Element} circle
*/
function triggerReflow(tooltip, circle) {
  // Safari needs the specific 'transform' property to be accessed
  circle ? window.getComputedStyle(circle)[(0, _prefix2.default)('transform')] : window.getComputedStyle(tooltip).opacity;
}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_38__;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_39__;

/***/ })
/******/ ]);
});
//# sourceMappingURL=react-tippy.js.map

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.12.9
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  // NOTE: 1 DOM access here
  var offsetParent = element && element.offsetParent;
  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    if (element) {
      return element.ownerDocument.documentElement;
    }

    return document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

/**
 * Tells if you are running Internet Explorer 10
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean} isIE10
 */
var isIE10 = undefined;

var isIE10$1 = function () {
  if (isIE10 === undefined) {
    isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1;
  }
  return isIE10;
};

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE10$1() ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
}

function getWindowSizes() {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE10$1() && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  if (isIE10$1()) {
    try {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } catch (err) {}
  } else {
    rect = element.getBoundingClientRect();
  }

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var isIE10 = isIE10$1();
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = getScroll(html);
  var scrollLeft = getScroll(html, 'left');

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  // NOTE: 1 DOM access here
  var boundaries = { top: 0, left: 0 };
  var offsetParent = findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  boundaries.left += padding;
  boundaries.top += padding;
  boundaries.right -= padding;
  boundaries.bottom -= padding;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var commonOffsetParent = findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length - 1; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.left = '';
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger onUpdate callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper.
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // floor sides to avoid blurry text
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.floor(popper.top),
    bottom: Math.floor(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    top = -offsetParentRect.height + offsets.bottom;
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    left = -offsetParentRect.width + offsets.right;
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjuction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-right` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement);
  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unitless, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the height.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * An scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper this makes sure the popper has always a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier, can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near eachothers
   * without leaving any gap between the two. Expecially useful when the arrow is
   * enabled and you want to assure it to point to its reference element.
   * It cares only about the first axis, you can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjuction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations).
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position,
     * the popper will never be placed outside of the defined boundaries
     * (except if keepTogether is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define you own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the informations used by Popper.js
 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overriden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass as 3rd argument an object with the same
 * structure of this object, example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Whether events (resize, scroll) are initially enabled
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated, this callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Create a new Popper.js instance
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper.
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedule an update, it will run on the next UI update available
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(26)))

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Tooltip__ = __webpack_require__(82);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var className = __webpack_require__(8);

var IconLinkButton = /** @class */ (function (_super) {
    __extends(IconLinkButton, _super);
    function IconLinkButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconLinkButton.prototype.render = function () {
        var LinkElement = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: this.props.to, style: this.props.style ? this.props.style : {}, className: className('btn btn-icon', this.props.className, this.props.disabled ? 'disabled' : ''), onClick: this.props.action }, this.props.children));
        if (this.props.title) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Tooltip__["a" /* default */], { title: this.props.title }, LinkElement));
        }
        return LinkElement;
    };
    return IconLinkButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (IconLinkButton);


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var classNames = __webpack_require__(8);


var ANIM_DURATION = 300;
var CustomTooltip = /** @class */ (function (_super) {
    __extends(CustomTooltip, _super);
    function CustomTooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.onRequestOpen = function (e) {
            e.currentTarget.blur();
            __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].disableBodyScrolling({ allBreakpoints: true });
            _this.setState(__assign({}, _this.state, { isOpen: true }));
        };
        _this.onRequestClose = function () {
            __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].enableBodyScrolling();
            _this.setState(__assign({}, _this.state, { isOpen: false }));
        };
        _this.state = {
            isOpen: false
        };
        // http://reactcommunity.org/react-modal/accessibility/#app-element
        __WEBPACK_IMPORTED_MODULE_1_react_modal__["setAppElement"]('#root');
        return _this;
    }
    CustomTooltip.prototype.render = function () {
        var props = this.props;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: props.className },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { type: "button", className: classNames('btn btn-link btn-tooltip-modal-toggle', props.toggleClassName, { 'btn-tooltip-modal-toggle-default': !props.toggle }), onClick: this.onRequestOpen }, props.toggle ? (props.toggle) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_icons__["B" /* IconHelpCircle */], null))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_modal__, { isOpen: this.state.isOpen, onRequestClose: this.onRequestClose, portalClassName: "ReactModal" // Redefine className to remove inline styles
                , overlayClassName: "ReactModal_Overlay modal-overlay" // Redefine className to remove inline styles
                , className: "ReactModal_Content section section-main" // Redefine className to remove inline styles
                , closeTimeoutMS: ANIM_DURATION },
                props.children,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn btn-icon ReactModal__Close", onClick: this.onRequestClose },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_icons__["u" /* IconClose */], null)))));
    };
    return CustomTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CustomTooltip);


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(38);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(364);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(138);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(83);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(368);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(365);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(366);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(138);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(367);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(83);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {})),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(137);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(137);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NavBar__ = __webpack_require__(370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__NavBar__["a"]; });



/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_motion__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ga__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navActions__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavButton__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavItem__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__auth_LoginWelcome__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AdminNavBar__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CustomerNavBar__ = __webpack_require__(387);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};














var NavBar = /** @class */ (function (_super) {
    __extends(NavBar, _super);
    function NavBar(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleNavMenu = function () {
            if (window.innerWidth < __WEBPACK_IMPORTED_MODULE_6__common_utils__["l" /* breakpoints */].xl) {
                _this.props.actions.toggleNavigation();
            }
        };
        _this.getQuote = function () {
            _this.toggleNavMenu();
            var abTestIndex = __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].getABTestOptimizeIndex();
            __WEBPACK_IMPORTED_MODULE_5_react_ga__["set"]({ 'exp': "Szj9gW87RKe5Yo5GErN82A." + abTestIndex });
            var url = __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].getABTestWorkflowUrl(abTestIndex);
            window.location.href = url;
        };
        return _this;
    }
    NavBar.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.menuIsOpen) {
            __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].disableBodyScrolling({ className: 'nav-open' });
        }
        else {
            var bodyEl = document.querySelector('body');
            if (bodyEl && bodyEl.classList.contains('nav-open')) {
                __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].enableBodyScrolling({ className: 'nav-open' });
            }
        }
    };
    NavBar.prototype.render = function () {
        var _this = this;
        var menuIsOpen = this.props.menuIsOpen;
        var customerAuthProps = { rolesRequired: ["Customer" /* Customer */], currentUser: this.props.currentUser };
        var adminAuthProps = {
            currentRoles: this.props.currentUser.role,
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "navbar-wrapper fixed-top bg-light no-print", "data-adjust-fixed-scrollbar": true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container px-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("nav", { className: "navbar navbar-expand-xl pr-0" },
                    (this.props.currentUser.role !== undefined) && (this.props.currentUser.role[0] === 'Customer') &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { className: "navbar-brand", to: "/" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__icons__["o" /* IconBrand */], null)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__NavButton__["a" /* default */], { className: "navbar-toggler" + (menuIsOpen ? '' : ' collapsed'), onClick: this.toggleNavMenu }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_motion__["Motion"], { style: {
                            x: Object(__WEBPACK_IMPORTED_MODULE_4_react_motion__["spring"])(menuIsOpen ? 0 : -100, {
                                stiffness: 300,
                                damping: 30
                            })
                        } }, function (_a) {
                        var x = _a.x;
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "navbar-collapse" + (menuIsOpen ? '' : ' collapse'), style: {
                                display: x === -100 ? 'none' : 'block',
                                WebkitTransform: "translate(0, " + x + "%)",
                                transform: "translate(0, " + x + "%)"
                            } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container px-0 d-xl-flex" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "navbar-nav mb-5 d-xl-none" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "nav-item" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: "/", onClick: _this.toggleNavMenu, className: "nav-item-brand" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__icons__["o" /* IconBrand */], null)))),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__auth_LoginWelcome__["a" /* default */], { className: "d-xl-none", onClick: _this.toggleNavMenu }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__AdminNavBar__["a" /* default */], __assign({ onClick: _this.toggleNavMenu }, adminAuthProps)),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__CustomerNavBar__["a" /* default */], __assign({ onClick: _this.toggleNavMenu }, customerAuthProps)),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "navbar-nav navbar-nav-separator ml-xl-auto" + (_this.props.currentUser.isAuthenticated ? ' d-xl-none' : '') },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__NavItem__["a" /* default */], { to: "#", onClick: _this.getQuote, className: "nav-item-em", linkClassName: "text-primary" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Get an easy quote")),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__NavItem__["a" /* default */], { to: "/faq", onClick: _this.toggleNavMenu }, "FAQ"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__NavItem__["a" /* default */], { to: "/about-us", onClick: _this.toggleNavMenu }, "About mosaic life"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "nav-item" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "nav-link", "aria-current": "false", href: "https://blog.insuredbymosaic.ca" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "nav-link-label" }, "Blog"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__NavItem__["a" /* default */], { to: "/claims", className: _this.props.currentUser.isAuthenticated ? 'd-none' : '', onClick: _this.toggleNavMenu }, "Make a claim")),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "navbar-nav mt-4 d-xl-none" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__NavItem__["a" /* default */], { className: "reduced-em" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "reduced-em" },
                                            "Version ",
                                            "1.10.9"))),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__auth_LoginWelcome__["a" /* default */], { className: "d-none d-xl-block", onClick: _this.toggleNavMenu }))));
                    })))));
    };
    return NavBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state, ownProps) {
    return {
        menuIsOpen: state.nav.menuIsOpen,
        currentUser: state.auth.currentUser
    };
}
function mapDispatchToProps(dispatch) {
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(Object.assign({}, __WEBPACK_IMPORTED_MODULE_7__navActions__), dispatch)
    };
}
// Added {pure: false} to get the active NavLinks to update when going forward/back via history,
// which will force a re-render. Not sure if this is the optimal solution.
// https://github.com/ReactTraining/react-router/issues/3536
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps, null, { pure: false })(NavBar));


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(84);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(56);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(85);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(86);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(87);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(88);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)))

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(84);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(56);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(85);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(86);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(87);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(88);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(84);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(56);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(85);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(375);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(86);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(87);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(88);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(141);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(379);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(33),n=__webpack_require__(66),p=__webpack_require__(39),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["toggleNavigation"] = toggleNavigation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(15);

function toggleNavigation() {
    return function toggleNavigationThunk(dispatch) {
        return dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* default */].TOGGLE_NAV_MENU });
    };
}


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons__ = __webpack_require__(7);


var NavButton = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { type: "button", onClick: props.onClick, className: props.className },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__icons__["E" /* IconMenu */], null)));
};
/* harmony default export */ __webpack_exports__["a"] = (NavButton);


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_buttons__ = __webpack_require__(6);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var classNames = __webpack_require__(8);
var LoginWelcome = /** @class */ (function (_super) {
    __extends(LoginWelcome, _super);
    function LoginWelcome() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.logout = function (e) {
            _this.props.actions.resetCustomerPolicy();
            _this.props.actions.logout();
            _this.props.onClick();
        };
        _this.login = function (e) {
            _this.props.actions.login();
        };
        return _this;
    }
    LoginWelcome.prototype.render = function () {
        var content;
        if (this.props.currentUser.isAuthenticated) {
            content = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "navbar-account-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "navbar-account-username align-middle" }, this.props.currentUser.fullName),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { onClick: this.logout, className: "btn btn-link text-tertiary text-uppercase nav-link" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Log out"))));
        }
        else {
            content = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "nav-item" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { onClick: this.login, className: "btn btn-link text-tertiary text-uppercase nav-link" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Log In"))));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('navbar-nav navbar-account', this.props.className, {
                'navbar-account-auth': this.props.currentUser.isAuthenticated
            }) }, content));
    };
    return LoginWelcome;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        currentUser: state.auth.currentUser
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_2__authActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(LoginWelcome));


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! msal v0.1.6 2018-05-21 */


(function webpackUniversalModuleDefinition(root, factory) {
	if (true)
		module.exports = factory();
	else if (typeof define === 'function' && define.amd)
		define("Msal", [], factory);
	else if (typeof exports === 'object')
		exports["Msal"] = factory();
	else
		root["Msal"] = factory();
})(typeof self !== 'undefined' ? self : this, function () {
	return /******/ (function (modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if (installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
				/******/
			}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
				/******/
			};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
			/******/
		}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function (exports, name, getter) {
/******/ 		if (!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
			/******/
		});
				/******/
			}
			/******/
		};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function (module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
			/******/
		};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function (object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
		/******/
	})
/************************************************************************/
/******/([
/* 0 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			/*
			 * @hidden
			 */
			var Utils = /** @class */ (function () {
				function Utils() {
				}
				Utils.compareObjects = function (u1, u2) {
					if (!u1 || !u2) {
						return false;
					}
					if (u1.userIdentifier && u2.userIdentifier) {
						if (u1.userIdentifier === u2.userIdentifier) {
							return true;
						}
					}
					return false;
				};
				Utils.expiresIn = function (expires) {
					// if AAD did not send "expires_in" property, use default expiration of 3599 seconds, for some reason AAD sends 3599 as "expires_in" value instead of 3600
					if (!expires) {
						expires = "3599";
					}
					return this.now() + parseInt(expires, 10);
				};
				Utils.now = function () {
					return Math.round(new Date().getTime() / 1000.0);
				};
				Utils.isEmpty = function (str) {
					return (typeof str === "undefined" || !str || 0 === str.length);
				};
				Utils.extractIdToken = function (encodedIdToken) {
					// id token will be decoded to get the username
					var decodedToken = this.decodeJwt(encodedIdToken);
					if (!decodedToken) {
						return null;
					}
					try {
						var base64IdToken = decodedToken.JWSPayload;
						var base64Decoded = this.base64DecodeStringUrlSafe(base64IdToken);
						if (!base64Decoded) {
							//this._requestContext.logger.info("The returned id_token could not be base64 url safe decoded.");
							return null;
						}
						// ECMA script has JSON built-in support
						return JSON.parse(base64Decoded);
					}
					catch (err) {
						//this._requestContext.logger.error("The returned id_token could not be decoded" + err);
					}
					return null;
				};
				Utils.base64EncodeStringUrlSafe = function (input) {
					// html5 should support atob function for decoding
					if (window.btoa) {
						return window.btoa(input);
					}
					else {
						return this.encode(input);
					}
				};
				Utils.base64DecodeStringUrlSafe = function (base64IdToken) {
					// html5 should support atob function for decoding
					base64IdToken = base64IdToken.replace(/-/g, "+").replace(/_/g, "/");
					if (window.atob) {
						return decodeURIComponent(encodeURIComponent(window.atob(base64IdToken))); // jshint ignore:line
					}
					else {
						return decodeURIComponent(encodeURIComponent(this.decode(base64IdToken)));
					}
				};
				Utils.encode = function (input) {
					var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
					var output = "";
					var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
					var i = 0;
					input = this.utf8Encode(input);
					while (i < input.length) {
						chr1 = input.charCodeAt(i++);
						chr2 = input.charCodeAt(i++);
						chr3 = input.charCodeAt(i++);
						enc1 = chr1 >> 2;
						enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
						enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
						enc4 = chr3 & 63;
						if (isNaN(chr2)) {
							enc3 = enc4 = 64;
						}
						else if (isNaN(chr3)) {
							enc4 = 64;
						}
						output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
					}
					return output.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
				};
				Utils.utf8Encode = function (input) {
					input = input.replace(/\r\n/g, "\n");
					var utftext = "";
					for (var n = 0; n < input.length; n++) {
						var c = input.charCodeAt(n);
						if (c < 128) {
							utftext += String.fromCharCode(c);
						}
						else if ((c > 127) && (c < 2048)) {
							utftext += String.fromCharCode((c >> 6) | 192);
							utftext += String.fromCharCode((c & 63) | 128);
						}
						else {
							utftext += String.fromCharCode((c >> 12) | 224);
							utftext += String.fromCharCode(((c >> 6) & 63) | 128);
							utftext += String.fromCharCode((c & 63) | 128);
						}
					}
					return utftext;
				};
				Utils.decode = function (base64IdToken) {
					var codes = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
					base64IdToken = String(base64IdToken).replace(/=+$/, "");
					var length = base64IdToken.length;
					if (length % 4 === 1) {
						throw new Error("The token to be decoded is not correctly encoded.");
					}
					var h1, h2, h3, h4, bits, c1, c2, c3, decoded = "";
					for (var i = 0; i < length; i += 4) {
						//Every 4 base64 encoded character will be converted to 3 byte string, which is 24 bits
						// then 6 bits per base64 encoded character
						h1 = codes.indexOf(base64IdToken.charAt(i));
						h2 = codes.indexOf(base64IdToken.charAt(i + 1));
						h3 = codes.indexOf(base64IdToken.charAt(i + 2));
						h4 = codes.indexOf(base64IdToken.charAt(i + 3));
						// For padding, if last two are "="
						if (i + 2 === length - 1) {
							bits = h1 << 18 | h2 << 12 | h3 << 6;
							c1 = bits >> 16 & 255;
							c2 = bits >> 8 & 255;
							decoded += String.fromCharCode(c1, c2);
							break;
						}
						// if last one is "="
						else if (i + 1 === length - 1) {
							bits = h1 << 18 | h2 << 12;
							c1 = bits >> 16 & 255;
							decoded += String.fromCharCode(c1);
							break;
						}
						bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;
						// then convert to 3 byte chars
						c1 = bits >> 16 & 255;
						c2 = bits >> 8 & 255;
						c3 = bits & 255;
						decoded += String.fromCharCode(c1, c2, c3);
					}
					return decoded;
				};
				Utils.decodeJwt = function (jwtToken) {
					if (this.isEmpty(jwtToken)) {
						return null;
					}
					var idTokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
					var matches = idTokenPartsRegex.exec(jwtToken);
					if (!matches || matches.length < 4) {
						//this._requestContext.logger.warn("The returned id_token is not parseable.");
						return null;
					}
					var crackedToken = {
						header: matches[1],
						JWSPayload: matches[2],
						JWSSig: matches[3]
					};
					return crackedToken;
				};
				Utils.deserialize = function (query) {
					var match; // Regex for replacing addition symbol with a space
					var pl = /\+/g;
					var search = /([^&=]+)=([^&]*)/g;
					var decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); };
					var obj = {};
					match = search.exec(query);
					while (match) {
						obj[decode(match[1])] = decode(match[2]);
						match = search.exec(query);
					}
					return obj;
				};
				Utils.isIntersectingScopes = function (cachedScopes, scopes) {
					cachedScopes = this.convertToLowerCase(cachedScopes);
					for (var i = 0; i < scopes.length; i++) {
						if (cachedScopes.indexOf(scopes[i].toLowerCase()) > -1) {
							return true;
						}
					}
					return false;
				};
				Utils.containsScope = function (cachedScopes, scopes) {
					cachedScopes = this.convertToLowerCase(cachedScopes);
					return scopes.every(function (value) { return cachedScopes.indexOf(value.toString().toLowerCase()) >= 0; });
				};
				Utils.convertToLowerCase = function (scopes) {
					return scopes.map(function (scope) { return scope.toLowerCase(); });
				};
				Utils.removeElement = function (scopes, scope) {
					return scopes.filter(function (value) { return value !== scope; });
				};
				Utils.decimalToHex = function (num) {
					var hex = num.toString(16);
					while (hex.length < 2) {
						hex = "0" + hex;
					}
					return hex;
				};
				Utils.getLibraryVersion = function () {
					return "0.1.6";
				};
				/*
				  * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
				  * @param href The url
				  * @param tenantId The tenant id to replace
				  */
				Utils.replaceFirstPath = function (href, tenantId) {
					var match = href.match(/^(https?\:)\/\/(([^:\/?#] *)(?:\:([0-9]+))?)([\/]{0,1}[^?#] *)(\?[^#] *|)(#. *|)$/);
					if (match) {
						var urlObject = Utils.GetUrlComponents(href);
						var pathArray = urlObject.PathSegments;
						pathArray.shift();
						if (pathArray[0] && pathArray[0] === "common" || pathArray[0] === "organizations") {
							pathArray[0] = tenantId;
							href = urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + pathArray.join("/");
						}
					}
					return href;
				};
				Utils.createNewGuid = function () {
					// RFC4122: The version 4 UUID is meant for generating UUIDs from truly-random or
					// pseudo-random numbers.
					// The algorithm is as follows:
					//     Set the two most significant bits (bits 6 and 7) of the
					//        clock_seq_hi_and_reserved to zero and one, respectively.
					//     Set the four most significant bits (bits 12 through 15) of the
					//        time_hi_and_version field to the 4-bit version number from
					//        Section 4.1.3. Version4
					//     Set all the other bits to randomly (or pseudo-randomly) chosen
					//     values.
					// UUID                   = time-low "-" time-mid "-"time-high-and-version "-"clock-seq-reserved and low(2hexOctet)"-" node
					// time-low               = 4hexOctet
					// time-mid               = 2hexOctet
					// time-high-and-version  = 2hexOctet
					// clock-seq-and-reserved = hexOctet:
					// clock-seq-low          = hexOctet
					// node                   = 6hexOctet
					// Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
					// y could be 1000, 1001, 1010, 1011 since most significant two bits needs to be 10
					// y values are 8, 9, A, B
					var cryptoObj = window.crypto; // for IE 11
					if (cryptoObj && cryptoObj.getRandomValues) {
						var buffer = new Uint8Array(16);
						cryptoObj.getRandomValues(buffer);
						//buffer[6] and buffer[7] represents the time_hi_and_version field. We will set the four most significant bits (4 through 7) of buffer[6] to represent decimal number 4 (UUID version number).
						buffer[6] |= 0x40; //buffer[6] | 01000000 will set the 6 bit to 1.
						buffer[6] &= 0x4f; //buffer[6] & 01001111 will set the 4, 5, and 7 bit to 0 such that bits 4-7 == 0100 = "4".
						//buffer[8] represents the clock_seq_hi_and_reserved field. We will set the two most significant bits (6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively.
						buffer[8] |= 0x80; //buffer[8] | 10000000 will set the 7 bit to 1.
						buffer[8] &= 0xbf; //buffer[8] & 10111111 will set the 6 bit to 0.
						return Utils.decimalToHex(buffer[0]) + Utils.decimalToHex(buffer[1])
							+ Utils.decimalToHex(buffer[2]) + Utils.decimalToHex(buffer[3])
							+ "-" + Utils.decimalToHex(buffer[4]) + Utils.decimalToHex(buffer[5])
							+ "-" + Utils.decimalToHex(buffer[6]) + Utils.decimalToHex(buffer[7])
							+ "-" + Utils.decimalToHex(buffer[8]) + Utils.decimalToHex(buffer[9])
							+ "-" + Utils.decimalToHex(buffer[10]) + Utils.decimalToHex(buffer[11])
							+ Utils.decimalToHex(buffer[12]) + Utils.decimalToHex(buffer[13])
							+ Utils.decimalToHex(buffer[14]) + Utils.decimalToHex(buffer[15]);
					}
					else {
						var guidHolder = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
						var hex = "0123456789abcdef";
						var r = 0;
						var guidResponse = "";
						for (var i = 0; i < 36; i++) {
							if (guidHolder[i] !== "-" && guidHolder[i] !== "4") {
								// each x and y needs to be random
								r = Math.random() * 16 | 0;
							}
							if (guidHolder[i] === "x") {
								guidResponse += hex[r];
							}
							else if (guidHolder[i] === "y") {
								// clock-seq-and-reserved first hex is filtered and remaining hex values are random
								r &= 0x3; // bit and with 0011 to set pos 2 to zero ?0??
								r |= 0x8; // set pos 3 to 1 as 1???
								guidResponse += hex[r];
							}
							else {
								guidResponse += guidHolder[i];
							}
						}
						return guidResponse;
					}
				};
				/*
				 * Parses out the components from a url string.
				 * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
				 */
				Utils.GetUrlComponents = function (url) {
					if (!url) {
						throw "Url required";
					}
					// https://gist.github.com/curtisz/11139b2cfcaef4a261e0
					var regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
					var match = url.match(regEx);
					if (!match || match.length < 6) {
						throw "Valid url required";
					}
					var urlComponents = {
						Protocol: match[1],
						HostNameAndPort: match[4],
						AbsolutePath: match[5]
					};
					var pathSegments = urlComponents.AbsolutePath.split("/");
					pathSegments = pathSegments.filter(function (val) { return val && val.length > 0; }); // remove empty elements
					urlComponents.PathSegments = pathSegments;
					return urlComponents;
				};
				/*
				 * Given a url or path, append a trailing slash if one doesnt exist
				 */
				Utils.CanonicalizeUri = function (url) {
					if (url) {
						url = url.toLowerCase();
					}
					if (url && !Utils.endsWith(url, "/")) {
						url += "/";
					}
					return url;
				};
				/*
				  * Checks to see if the url ends with the suffix
				  * Required because we are compiling for es5 instead of es6
				  * @param url
				  * @param str
				  */
				Utils.endsWith = function (url, suffix) {
					if (!url || !suffix) {
						return false;
					}
					return url.indexOf(suffix, url.length - suffix.length) !== -1;
				};
				return Utils;
			}());
			exports.Utils = Utils;


			/***/
		}),
/* 1 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			Object.defineProperty(exports, "__esModule", { value: true });
			var Utils_1 = __webpack_require__(0);
			var ErrorMessage_1 = __webpack_require__(5);
			var XHRClient_1 = __webpack_require__(9);
			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			/*
			 * @hidden
			 */
			var AuthorityType;
			(function (AuthorityType) {
				AuthorityType[AuthorityType["Aad"] = 0] = "Aad";
				AuthorityType[AuthorityType["Adfs"] = 1] = "Adfs";
				AuthorityType[AuthorityType["B2C"] = 2] = "B2C";
			})(AuthorityType = exports.AuthorityType || (exports.AuthorityType = {}));
			/*
			 * @hidden
			 */
			var Authority = /** @class */ (function () {
				function Authority(authority, validateAuthority) {
					this.IsValidationEnabled = validateAuthority;
					this.CanonicalAuthority = authority;
					this.validateAsUri();
				}
				Object.defineProperty(Authority.prototype, "Tenant", {
					get: function () {
						return this.CanonicalAuthorityUrlComponents.PathSegments[0];
					},
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Authority.prototype, "AuthorizationEndpoint", {
					get: function () {
						this.validateResolved();
						return this.tenantDiscoveryResponse.AuthorizationEndpoint.replace("{tenant}", this.Tenant);
					},
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Authority.prototype, "EndSessionEndpoint", {
					get: function () {
						this.validateResolved();
						return this.tenantDiscoveryResponse.EndSessionEndpoint.replace("{tenant}", this.Tenant);
					},
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Authority.prototype, "SelfSignedJwtAudience", {
					get: function () {
						this.validateResolved();
						return this.tenantDiscoveryResponse.Issuer.replace("{tenant}", this.Tenant);
					},
					enumerable: true,
					configurable: true
				});
				Authority.prototype.validateResolved = function () {
					if (!this.tenantDiscoveryResponse) {
						throw "Please call ResolveEndpointsAsync first";
					}
				};
				Object.defineProperty(Authority.prototype, "CanonicalAuthority", {
					/*
					 * A URL that is the authority set by the developer
					 */
					get: function () {
						return this.canonicalAuthority;
					},
					set: function (url) {
						this.canonicalAuthority = Utils_1.Utils.CanonicalizeUri(url);
						this.canonicalAuthorityUrlComponents = null;
					},
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Authority.prototype, "CanonicalAuthorityUrlComponents", {
					get: function () {
						if (!this.canonicalAuthorityUrlComponents) {
							this.canonicalAuthorityUrlComponents = Utils_1.Utils.GetUrlComponents(this.CanonicalAuthority);
						}
						return this.canonicalAuthorityUrlComponents;
					},
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Authority.prototype, "DefaultOpenIdConfigurationEndpoint", {
					/*
					 * // http://openid.net/specs/openid-connect-discovery-1_0.html#ProviderMetadata
					 */
					get: function () {
						return this.CanonicalAuthority + "v2.0/.well-known/openid-configuration";
					},
					enumerable: true,
					configurable: true
				});
				/*
				 * Given a string, validate that it is of the form https://domain/path
				 */
				Authority.prototype.validateAsUri = function () {
					var components;
					try {
						components = this.CanonicalAuthorityUrlComponents;
					}
					catch (e) {
						throw ErrorMessage_1.ErrorMessage.invalidAuthorityType;
					}
					if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") {
						throw ErrorMessage_1.ErrorMessage.authorityUriInsecure;
					}
					if (!components.PathSegments || components.PathSegments.length < 1) {
						throw ErrorMessage_1.ErrorMessage.authorityUriInvalidPath;
					}
				};
				/*
				 * Calls the OIDC endpoint and returns the response
				 */
				Authority.prototype.DiscoverEndpoints = function (openIdConfigurationEndpoint) {
					var client = new XHRClient_1.XhrClient();
					return client.sendRequestAsync(openIdConfigurationEndpoint, "GET", /*enableCaching: */ true)
						.then(function (response) {
							return {
								AuthorizationEndpoint: response.authorization_endpoint,
								EndSessionEndpoint: response.end_session_endpoint,
								Issuer: response.issuer
							};
						});
				};
				/*
				 * Returns a promise.
				 * Checks to see if the authority is in the cache
				 * Discover endpoints via openid-configuration
				 * If successful, caches the endpoint for later use in OIDC
				 */
				Authority.prototype.ResolveEndpointsAsync = function () {
					var _this = this;
					var openIdConfigurationEndpoint = "";
					return this.GetOpenIdConfigurationEndpointAsync().then(function (openIdConfigurationEndpointResponse) {
						openIdConfigurationEndpoint = openIdConfigurationEndpointResponse;
						return _this.DiscoverEndpoints(openIdConfigurationEndpoint);
					}).then(function (tenantDiscoveryResponse) {
						_this.tenantDiscoveryResponse = tenantDiscoveryResponse;
						return _this;
					});
				};
				return Authority;
			}());
			exports.Authority = Authority;


			/***/
		}),
/* 2 */
/***/ (function (module, __webpack_exports__, __webpack_require__) {

			"use strict";
			Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function () { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
			/*! *****************************************************************************
			Copyright (c) Microsoft Corporation. All rights reserved.
			Licensed under the Apache License, Version 2.0 (the "License"); you may not use
			this file except in compliance with the License. You may obtain a copy of the
			License at http://www.apache.org/licenses/LICENSE-2.0
			
			THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
			KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
			WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
			MERCHANTABLITY OR NON-INFRINGEMENT.
			
			See the Apache Version 2.0 License for specific language governing permissions
			and limitations under the License.
			***************************************************************************** */
			/* global Reflect, Promise */

			var extendStatics = Object.setPrototypeOf ||
				({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
				function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

			function __extends(d, b) {
				extendStatics(d, b);
				function __() { this.constructor = d; }
				d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
			}

			var __assign = Object.assign || function __assign(t) {
				for (var s, i = 1, n = arguments.length; i < n; i++) {
					s = arguments[i];
					for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
				}
				return t;
			}

			function __rest(s, e) {
				var t = {};
				for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
					t[p] = s[p];
				if (s != null && typeof Object.getOwnPropertySymbols === "function")
					for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
						t[p[i]] = s[p[i]];
				return t;
			}

			function __decorate(decorators, target, key, desc) {
				var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
				if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
				else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
				return c > 3 && r && Object.defineProperty(target, key, r), r;
			}

			function __param(paramIndex, decorator) {
				return function (target, key) { decorator(target, key, paramIndex); }
			}

			function __metadata(metadataKey, metadataValue) {
				if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
			}

			function __awaiter(thisArg, _arguments, P, generator) {
				return new (P || (P = Promise))(function (resolve, reject) {
					function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
					function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
					function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
					step((generator = generator.apply(thisArg, _arguments || [])).next());
				});
			}

			function __generator(thisArg, body) {
				var _ = { label: 0, sent: function () { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
				return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
				function verb(n) { return function (v) { return step([n, v]); }; }
				function step(op) {
					if (f) throw new TypeError("Generator is already executing.");
					while (_) try {
						if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
						if (y = 0, t) op = [0, t.value];
						switch (op[0]) {
							case 0: case 1: t = op; break;
							case 4: _.label++; return { value: op[1], done: false };
							case 5: _.label++; y = op[1]; op = [0]; continue;
							case 7: op = _.ops.pop(); _.trys.pop(); continue;
							default:
								if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
								if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
								if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
								if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
								if (t[2]) _.ops.pop();
								_.trys.pop(); continue;
						}
						op = body.call(thisArg, _);
					} catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
					if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
				}
			}

			function __exportStar(m, exports) {
				for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
			}

			function __values(o) {
				var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
				if (m) return m.call(o);
				return {
					next: function () {
						if (o && i >= o.length) o = void 0;
						return { value: o && o[i++], done: !o };
					}
				};
			}

			function __read(o, n) {
				var m = typeof Symbol === "function" && o[Symbol.iterator];
				if (!m) return o;
				var i = m.call(o), r, ar = [], e;
				try {
					while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
				}
				catch (error) { e = { error: error }; }
				finally {
					try {
						if (r && !r.done && (m = i["return"])) m.call(i);
					}
					finally { if (e) throw e.error; }
				}
				return ar;
			}

			function __spread() {
				for (var ar = [], i = 0; i < arguments.length; i++)
					ar = ar.concat(__read(arguments[i]));
				return ar;
			}

			function __await(v) {
				return this instanceof __await ? (this.v = v, this) : new __await(v);
			}

			function __asyncGenerator(thisArg, _arguments, generator) {
				if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
				var g = generator.apply(thisArg, _arguments || []), i, q = [];
				return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
				function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
				function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
				function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
				function fulfill(value) { resume("next", value); }
				function reject(value) { resume("throw", value); }
				function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
			}

			function __asyncDelegator(o) {
				var i, p;
				return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
				function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
			}

			function __asyncValues(o) {
				if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
				var m = o[Symbol.asyncIterator], i;
				return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
				function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
				function settle(resolve, reject, d, v) { Promise.resolve(v).then(function (v) { resolve({ value: v, done: d }); }, reject); }
			}

			function __makeTemplateObject(cooked, raw) {
				if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
				return cooked;
			};

			function __importStar(mod) {
				if (mod && mod.__esModule) return mod;
				var result = {};
				if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
				result.default = mod;
				return result;
			}

			function __importDefault(mod) {
				return (mod && mod.__esModule) ? mod : { default: mod };
			}


			/***/
		}),
/* 3 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/*
			  * Copyright (c) Microsoft Corporation
			  *  All Rights Reserved
			  *  MIT License
			  *
			  * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			  * software and associated documentation files (the "Software"), to deal in the Software
			  * without restriction, including without limitation the rights to use, copy, modify,
			  * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			  * permit persons to whom the Software is furnished to do so, subject to the following
			  * conditions:
			  *
			  * The above copyright notice and this permission notice shall be
			  * included in all copies or substantial portions of the Software.
			  *
			  * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
			  * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			  * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			  * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			  * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			  * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			  */
			Object.defineProperty(exports, "__esModule", { value: true });
			/*
			 * @hidden
			 */
			var Constants = /** @class */ (function () {
				function Constants() {
				}
				Object.defineProperty(Constants, "errorDescription", {
					get: function () { return "error_description"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "error", {
					get: function () { return "error"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "scope", {
					get: function () { return "scope"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "acquireTokenUser", {
					get: function () { return "msal.acquireTokenUser"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "clientInfo", {
					get: function () { return "client_info"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "clientId", {
					get: function () { return "clientId"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "authority", {
					get: function () { return "msal.authority"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "idToken", {
					get: function () { return "id_token"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "accessToken", {
					get: function () { return "access_token"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "expiresIn", {
					get: function () { return "expires_in"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "sessionState", {
					get: function () { return "session_state"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "msalClientInfo", {
					get: function () { return "msal.client.info"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "msalError", {
					get: function () { return "msal.error"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "msalErrorDescription", {
					get: function () { return "msal.error.description"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "msalSessionState", {
					get: function () { return "msal.session.state"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "tokenKeys", {
					get: function () { return "msal.token.keys"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "accessTokenKey", {
					get: function () { return "msal.access.token.key"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "expirationKey", {
					get: function () { return "msal.expiration.key"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "stateLogin", {
					get: function () { return "msal.state.login"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "stateAcquireToken", {
					get: function () { return "msal.state.acquireToken"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "stateRenew", {
					get: function () { return "msal.state.renew"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "nonceIdToken", {
					get: function () { return "msal.nonce.idtoken"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "userName", {
					get: function () { return "msal.username"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "idTokenKey", {
					get: function () { return "msal.idtoken"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "loginRequest", {
					get: function () { return "msal.login.request"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "loginError", {
					get: function () { return "msal.login.error"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "renewStatus", {
					get: function () { return "msal.token.renew.status"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "msal", {
					get: function () { return "msal"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "resourceDelimeter", {
					get: function () { return "|"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "tokenRenewStatusCancelled", {
					get: function () { return "Canceled"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "tokenRenewStatusCompleted", {
					get: function () { return "Completed"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "tokenRenewStatusInProgress", {
					get: function () { return "In Progress"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "popUpWidth", {
					get: function () { return this._popUpWidth; },
					set: function (width) {
						this._popUpWidth = width;
					},
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "popUpHeight", {
					get: function () { return this._popUpHeight; },
					set: function (height) {
						this._popUpHeight = height;
					},
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "login", {
					get: function () { return "LOGIN"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "renewToken", {
					get: function () { return "RENEW_TOKEN"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "unknown", {
					get: function () { return "UNKNOWN"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "urlHash", {
					get: function () { return "msal.urlHash"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "angularLoginRequest", {
					get: function () { return "msal.angular.login.request"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(Constants, "userIdentifier", {
					get: function () { return "userIdentifier"; },
					enumerable: true,
					configurable: true
				});
				Constants._popUpWidth = 483;
				Constants._popUpHeight = 600;
				return Constants;
			}());
			exports.Constants = Constants;
			/*
			 * @hidden
			 */
			var ErrorCodes = /** @class */ (function () {
				function ErrorCodes() {
				}
				Object.defineProperty(ErrorCodes, "loginProgressError", {
					get: function () { return "login_progress_error"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorCodes, "acquireTokenProgressError", {
					get: function () { return "acquiretoken_progress_error"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorCodes, "inputScopesError", {
					get: function () { return "input_scopes_error"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorCodes, "endpointResolutionError", {
					get: function () { return "endpoints_resolution_error"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorCodes, "popUpWindowError", {
					get: function () { return "popup_window_error"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorCodes, "userLoginError", {
					get: function () { return "user_login_error"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorCodes, "userCancelledError", {
					get: function () { return "user_cancelled"; },
					enumerable: true,
					configurable: true
				});
				return ErrorCodes;
			}());
			exports.ErrorCodes = ErrorCodes;
			/*
			 * @hidden
			 */
			var ErrorDescription = /** @class */ (function () {
				function ErrorDescription() {
				}
				Object.defineProperty(ErrorDescription, "loginProgressError", {
					get: function () { return "Login is in progress"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorDescription, "acquireTokenProgressError", {
					get: function () { return "Acquire token is in progress"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorDescription, "inputScopesError", {
					get: function () { return "Invalid value of input scopes provided"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorDescription, "endpointResolutionError", {
					get: function () { return "Endpoints cannot be resolved"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorDescription, "popUpWindowError", {
					get: function () { return "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser."; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorDescription, "userLoginError", {
					get: function () { return "User login is required"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorDescription, "userCancelledError", {
					get: function () { return "User closed the popup window window and cancelled the flow"; },
					enumerable: true,
					configurable: true
				});
				return ErrorDescription;
			}());
			exports.ErrorDescription = ErrorDescription;


			/***/
		}),
/* 4 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			var Utils_1 = __webpack_require__(0);
			var LogLevel;
			(function (LogLevel) {
				LogLevel[LogLevel["Error"] = 0] = "Error";
				LogLevel[LogLevel["Warning"] = 1] = "Warning";
				LogLevel[LogLevel["Info"] = 2] = "Info";
				LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
			})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
			var Logger = /** @class */ (function () {
				function Logger(localCallback, options) {
					if (options === void 0) { options = {}; }
					/*
					 * @hidden
					 */
					this._level = LogLevel.Info;
					var _a = options.correlationId, correlationId = _a === void 0 ? "" : _a, _b = options.level, level = _b === void 0 ? LogLevel.Info : _b, _c = options.piiLoggingEnabled, piiLoggingEnabled = _c === void 0 ? false : _c;
					this._localCallback = localCallback;
					this._correlationId = correlationId;
					this._level = level;
					this._piiLoggingEnabled = piiLoggingEnabled;
				}
				/*
				 * @hidden
				 */
				Logger.prototype.logMessage = function (logLevel, logMessage, containsPii) {
					if ((logLevel > this._level) || (!this._piiLoggingEnabled && containsPii)) {
						return;
					}
					var timestamp = new Date().toUTCString();
					var log;
					if (!Utils_1.Utils.isEmpty(this._correlationId)) {
						log = timestamp + ":" + this._correlationId + "-" + Utils_1.Utils.getLibraryVersion() + "-" + LogLevel[logLevel] + " " + logMessage;
					}
					else {
						log = timestamp + ":" + Utils_1.Utils.getLibraryVersion() + "-" + LogLevel[logLevel] + " " + logMessage;
					}
					this.executeCallback(logLevel, log, containsPii);
				};
				/*
				 * @hidden
				 */
				Logger.prototype.executeCallback = function (level, message, containsPii) {
					if (this._localCallback) {
						this._localCallback(level, message, containsPii);
					}
				};
				/*
				 * @hidden
				 */
				Logger.prototype.error = function (message) {
					this.logMessage(LogLevel.Error, message, false);
				};
				/*
				 * @hidden
				 */
				Logger.prototype.errorPii = function (message) {
					this.logMessage(LogLevel.Error, message, true);
				};
				/*
				 * @hidden
				 */
				Logger.prototype.warning = function (message) {
					this.logMessage(LogLevel.Warning, message, false);
				};
				/*
				 * @hidden
				 */
				Logger.prototype.warningPii = function (message) {
					this.logMessage(LogLevel.Warning, message, true);
				};
				/*
				 * @hidden
				 */
				Logger.prototype.info = function (message) {
					this.logMessage(LogLevel.Info, message, false);
				};
				/*
				 * @hidden
				 */
				Logger.prototype.infoPii = function (message) {
					this.logMessage(LogLevel.Info, message, true);
				};
				/*
				 * @hidden
				 */
				Logger.prototype.verbose = function (message) {
					this.logMessage(LogLevel.Verbose, message, false);
				};
				/*
				 * @hidden
				 */
				Logger.prototype.verbosePii = function (message) {
					this.logMessage(LogLevel.Verbose, message, true);
				};
				return Logger;
			}());
			exports.Logger = Logger;


			/***/
		}),
/* 5 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/*
			  * Copyright (c) Microsoft Corporation
			  *  All Rights Reserved
			  *  MIT License
			  *
			  * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			  * software and associated documentation files (the "Software"), to deal in the Software
			  * without restriction, including without limitation the rights to use, copy, modify,
			  * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			  * permit persons to whom the Software is furnished to do so, subject to the following
			  * conditions:
			  *
			  * The above copyright notice and this permission notice shall be
			  * included in all copies or substantial portions of the Software.
			  *
			  * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
			  * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			  * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			  * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			  * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			  * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			  */
			Object.defineProperty(exports, "__esModule", { value: true });
			/*
			 * @hidden
			 */
			var ErrorMessage = /** @class */ (function () {
				function ErrorMessage() {
				}
				Object.defineProperty(ErrorMessage, "authorityUriInvalidPath", {
					get: function () { return "AuthorityUriInvalidPath"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorMessage, "authorityUriInsecure", {
					get: function () { return "AuthorityUriInsecure"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorMessage, "invalidAuthorityType", {
					get: function () { return "InvalidAuthorityType"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorMessage, "unsupportedAuthorityValidation", {
					get: function () { return "UnsupportedAuthorityValidation"; },
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ErrorMessage, "b2cAuthorityUriInvalidPath", {
					get: function () { return "B2cAuthorityUriInvalidPath"; },
					enumerable: true,
					configurable: true
				});
				return ErrorMessage;
			}());
			exports.ErrorMessage = ErrorMessage;


			/***/
		}),
/* 6 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			/*
			 * @hidden
			 */
			var TokenResponse = /** @class */ (function () {
				function TokenResponse() {
					this.valid = false;
					this.parameters = {};
					this.stateMatch = false;
					this.stateResponse = "";
					this.requestType = "unknown";
				}
				return TokenResponse;
			}());
			exports.TokenResponse = TokenResponse;


			/***/
		}),
/* 7 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			var Utils_1 = __webpack_require__(0);
			var User = /** @class */ (function () {
				/*
				 * @hidden
				 */
				function User(displayableId, name, identityProvider, userIdentifier, idToken) {
					this.displayableId = displayableId;
					this.name = name;
					this.identityProvider = identityProvider;
					this.userIdentifier = userIdentifier;
					this.idToken = idToken;
				}
				/*
				 * @hidden
				 */
				User.createUser = function (idToken, clientInfo, authority) {
					var uid;
					var utid;
					if (!clientInfo) {
						uid = "";
						utid = "";
					}
					else {
						uid = clientInfo.uid;
						utid = clientInfo.utid;
					}
					var userIdentifier = Utils_1.Utils.base64EncodeStringUrlSafe(uid) + "." + Utils_1.Utils.base64EncodeStringUrlSafe(utid);
					return new User(idToken.preferredName, idToken.name, idToken.issuer, userIdentifier, idToken.decodedIdToken);
				};
				return User;
			}());
			exports.User = User;


			/***/
		}),
/* 8 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			var tslib_1 = __webpack_require__(2);
			var Authority_1 = __webpack_require__(1);
			var XHRClient_1 = __webpack_require__(9);
			/**
			 * @hidden
			 */
			var AadAuthority = /** @class */ (function (_super) {
				tslib_1.__extends(AadAuthority, _super);
				function AadAuthority(authority, validateAuthority) {
					return _super.call(this, authority, validateAuthority) || this;
				}
				Object.defineProperty(AadAuthority.prototype, "AadInstanceDiscoveryEndpointUrl", {
					get: function () {
						return AadAuthority.AadInstanceDiscoveryEndpoint + "?api-version=1.0&authorization_endpoint=" + this.CanonicalAuthority + "oauth2/v2.0/authorize";
					},
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(AadAuthority.prototype, "AuthorityType", {
					get: function () {
						return Authority_1.AuthorityType.Aad;
					},
					enumerable: true,
					configurable: true
				});
				/**
				 * Returns a promise which resolves to the OIDC endpoint
				 * Only responds with the endpoint
				 */
				AadAuthority.prototype.GetOpenIdConfigurationEndpointAsync = function () {
					var _this = this;
					var resultPromise = new Promise(function (resolve, reject) {
						return resolve(_this.DefaultOpenIdConfigurationEndpoint);
					});
					if (!this.IsValidationEnabled) {
						return resultPromise;
					}
					var host = this.CanonicalAuthorityUrlComponents.HostNameAndPort;
					if (this.IsInTrustedHostList(host)) {
						return resultPromise;
					}
					var client = new XHRClient_1.XhrClient();
					return client.sendRequestAsync(this.AadInstanceDiscoveryEndpointUrl, "GET", true)
						.then(function (response) {
							return response.tenant_discovery_endpoint;
						});
				};
				/**
				 * Checks to see if the host is in a list of trusted hosts
				 * @param {string} The host to look up
				 */
				AadAuthority.prototype.IsInTrustedHostList = function (host) {
					return AadAuthority.TrustedHostList[host.toLowerCase()];
				};
				AadAuthority.AadInstanceDiscoveryEndpoint = "https://login.microsoftonline.com/common/discovery/instance";
				AadAuthority.TrustedHostList = {
					"login.windows.net": "login.windows.net",
					"login.chinacloudapi.cn": "login.chinacloudapi.cn",
					"login.cloudgovapi.us": "login.cloudgovapi.us",
					"login.microsoftonline.com": "login.microsoftonline.com",
					"login.microsoftonline.de": "login.microsoftonline.de",
					"login.microsoftonline.us": "login.microsoftonline.us",
					"markb2c.b2clogin.com": "markb2c.b2clogin.com",
					"termlifeb2c.b2clogin.com": "termlifeb2c.b2clogin.com",
				};
				return AadAuthority;
			}(Authority_1.Authority));
			exports.AadAuthority = AadAuthority;


			/***/
		}),
/* 9 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			/*
			 * XHR client for JSON endpoints
			 * https://www.npmjs.com/package/async-promise
			 * @hidden
			 */
			var XhrClient = /** @class */ (function () {
				function XhrClient() {
				}
				XhrClient.prototype.sendRequestAsync = function (url, method, enableCaching) {
					var _this = this;
					return new Promise(function (resolve, reject) {
						var xhr = new XMLHttpRequest();
						xhr.open(method, url, /*async: */ true);
						if (enableCaching) {
							// TODO: (shivb) ensure that this can be cached
							// xhr.setRequestHeader("Cache-Control", "Public");
						}
						xhr.onload = function (ev) {
							if (xhr.status < 200 || xhr.status >= 300) {
								reject(_this.handleError(xhr.responseText));
							}
							try {
								var jsonResponse = JSON.parse(xhr.responseText);
							}
							catch (e) {
								reject(_this.handleError(xhr.responseText));
							}
							resolve(jsonResponse);
						};
						xhr.onerror = function (ev) {
							reject(xhr.status);
						};
						if (method === "GET") {
							xhr.send();
						}
						else {
							throw "not implemented";
						}
					});
				};
				XhrClient.prototype.handleError = function (responseText) {
					var jsonResponse;
					try {
						jsonResponse = JSON.parse(responseText);
						if (jsonResponse.error) {
							return jsonResponse.error;
						}
						else {
							throw responseText;
						}
					}
					catch (e) {
						return responseText;
					}
				};
				return XhrClient;
			}());
			exports.XhrClient = XhrClient;


			/***/
		}),
/* 10 */
/***/ (function (module, exports, __webpack_require__) {

			module.exports = __webpack_require__(11);


			/***/
		}),
/* 11 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			Object.defineProperty(exports, "__esModule", { value: true });
			var UserAgentApplication_1 = __webpack_require__(12);
			exports.UserAgentApplication = UserAgentApplication_1.UserAgentApplication;
			var Logger_1 = __webpack_require__(4);
			exports.Logger = Logger_1.Logger;
			var Logger_2 = __webpack_require__(4);
			exports.LogLevel = Logger_2.LogLevel;
			var User_1 = __webpack_require__(7);
			exports.User = User_1.User;
			var Constants_1 = __webpack_require__(3);
			exports.Constants = Constants_1.Constants;
			var RequestInfo_1 = __webpack_require__(6);
			exports.TokenResponse = RequestInfo_1.TokenResponse;
			var Authority_1 = __webpack_require__(1);
			exports.Authority = Authority_1.Authority;


			/***/
		}),
/* 12 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			var tslib_1 = __webpack_require__(2);
			var AccessTokenKey_1 = __webpack_require__(13);
			var AccessTokenValue_1 = __webpack_require__(14);
			var AuthenticationRequestParameters_1 = __webpack_require__(15);
			var ClientInfo_1 = __webpack_require__(16);
			var Constants_1 = __webpack_require__(3);
			var IdToken_1 = __webpack_require__(17);
			var Logger_1 = __webpack_require__(4);
			var Storage_1 = __webpack_require__(18);
			var RequestInfo_1 = __webpack_require__(6);
			var User_1 = __webpack_require__(7);
			var Utils_1 = __webpack_require__(0);
			var AuthorityFactory_1 = __webpack_require__(20);
			/*
			 * @hidden
			 */
			var ResponseTypes = {
				id_token: "id_token",
				token: "token",
				id_token_token: "id_token token"
			};
			var resolveTokenOnlyIfOutOfIframe = function (target, propertyKey, descriptor) {
				var tokenAcquisitionMethod = descriptor.value;
				descriptor.value = function () {
					var args = [];
					for (var _i = 0; _i < arguments.length; _i++) {
						args[_i] = arguments[_i];
					}
					return this.isInIframe()
						? new Promise(function () { })
						: tokenAcquisitionMethod.apply(this, args);
				};
				return descriptor;
			};
			var UserAgentApplication = /** @class */ (function () {
				/*
				 * Initialize a UserAgentApplication with a given clientId and authority.
				 * @constructor
				 * @param {string} clientId - The clientID of your application, you should get this from the application registration portal.
				 * @param {string} authority - A URL indicating a directory that MSAL can use to obtain tokens.
				 * - In Azure AD, it is of the form https://&lt;instance>/&lt;tenant&gt;,\ where &lt;instance&gt; is the directory host (e.g. https://login.microsoftonline.com) and &lt;tenant&gt; is a identifier within the directory itself (e.g. a domain associated to the tenant, such as contoso.onmicrosoft.com, or the GUID representing the TenantID property of the directory)
				 * - In Azure B2C, it is of the form https://&lt;instance&gt;/tfp/&lt;tenantId&gt;/&lt;policyName&gt;/
				 * - Default value is: "https://login.microsoftonline.com/common"
				 * @param _tokenReceivedCallback -  The function that will get the call back once this API is completed (either successfully or with a failure).
				 * @param {boolean} validateAuthority -  boolean to turn authority validation on/off.
				 */
				function UserAgentApplication(clientId, authority, tokenReceivedCallback, options) {
					if (options === void 0) { options = {}; }
					/*
					 * @hidden
					 */
					this._cacheLocations = {
						localStorage: "localStorage",
						sessionStorage: "sessionStorage"
					};
					/*
					 * @hidden
					 */
					this._clockSkew = 300;
					/*
					 * @hidden
					 */
					this._tokenReceivedCallback = null;
					this._isAngular = false;
					var _a = options.validateAuthority, validateAuthority = _a === void 0 ? true : _a, _b = options.cacheLocation, cacheLocation = _b === void 0 ? "sessionStorage" : _b, _c = options.redirectUri, redirectUri = _c === void 0 ? window.location.href.split("?")[0].split("#")[0] : _c, _d = options.postLogoutRedirectUri, postLogoutRedirectUri = _d === void 0 ? window.location.href.split("?")[0].split("#")[0] : _d, _e = options.logger, logger = _e === void 0 ? new Logger_1.Logger(null) : _e, _f = options.loadFrameTimeout, loadFrameTimeout = _f === void 0 ? 6000 : _f, _g = options.navigateToLoginRequestUrl, navigateToLoginRequestUrl = _g === void 0 ? true : _g, _h = options.isAngular, isAngular = _h === void 0 ? false : _h, _j = options.anonymousEndpoints, anonymousEndpoints = _j === void 0 ? new Array() : _j, _k = options.endPoints, endPoints = _k === void 0 ? new Map() : _k;
					this.loadFrameTimeout = loadFrameTimeout;
					this.clientId = clientId;
					this.validateAuthority = validateAuthority;
					this.authority = authority || "https://login.microsoftonline.com/common";
					this._tokenReceivedCallback = tokenReceivedCallback;
					this._redirectUri = redirectUri;
					this._postLogoutredirectUri = postLogoutRedirectUri;
					this._loginInProgress = false;
					this._acquireTokenInProgress = false;
					this._cacheLocation = cacheLocation;
					this._navigateToLoginRequestUrl = navigateToLoginRequestUrl;
					this._isAngular = isAngular;
					this._anonymousEndpoints = anonymousEndpoints;
					this._endpoints = endPoints;
					if (!this._cacheLocations[cacheLocation]) {
						throw new Error("Cache Location is not valid. Provided value:" + this._cacheLocation + ".Possible values are: " + this._cacheLocations.localStorage + ", " + this._cacheLocations.sessionStorage);
					}
					this._cacheStorage = new Storage_1.Storage(this._cacheLocation); //cache keys msal
					this._logger = logger;
					window.openedWindows = [];
					window.activeRenewals = {};
					window.renewStates = [];
					window.callBackMappedToRenewStates = {};
					window.callBacksMappedToRenewStates = {};
					window.msal = this;
					var urlHash = window.location.hash;
					var isCallback = this.isCallback(urlHash);
					if (!this._isAngular) {
						if (isCallback) {
							this.handleAuthenticationResponse.call(this, urlHash);
						}
						else {
							var pendingCallback = this._cacheStorage.getItem(Constants_1.Constants.urlHash);
							if (pendingCallback) {
								this.processCallBack(pendingCallback);
							}
						}
					}
				}
				Object.defineProperty(UserAgentApplication.prototype, "cacheLocation", {
					/*
					 * Used to get the cache location
					 */
					get: function () {
						return this._cacheLocation;
					},
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(UserAgentApplication.prototype, "authority", {
					/*
					 * Used to get the authority.
					 */
					get: function () {
						return this.authorityInstance.CanonicalAuthority;
					},
					/*
					 * Used to set the authority.
					 * @param {string} authority - A URL indicating a directory that MSAL can use to obtain tokens.
					 * - In Azure AD, it is of the form https://&lt;tenant&gt;/&lt;tenant&gt;, where &lt;tenant&gt; is the directory host (e.g. https://login.microsoftonline.com) and &lt;tenant&gt; is a identifier within the directory itself (e.g. a domain associated to the tenant, such as contoso.onmicrosoft.com, or the GUID representing the TenantID property of the directory)
					 * - In Azure B2C, it is of the form https://&lt;instance&gt;/tfp/&lt;tenant&gt;/<policyName>/
					 * - Default value is: "https://login.microsoftonline.com/common"
					 */
					set: function (val) {
						this.authorityInstance = AuthorityFactory_1.AuthorityFactory.CreateInstance(val, this.validateAuthority);
					},
					enumerable: true,
					configurable: true
				});
				/*
				 * Used to call the constructor callback with the token/error
				 * @param {string} [hash=window.location.hash] - Hash fragment of Url.
				 * @hidden
				 */
				UserAgentApplication.prototype.processCallBack = function (hash) {
					this._logger.info('Processing the callback from redirect response');
					var requestInfo = this.getRequestInfo(hash);
					this.saveTokenFromHash(requestInfo);
					var token = requestInfo.parameters[Constants_1.Constants.accessToken] || requestInfo.parameters[Constants_1.Constants.idToken];
					var errorDesc = requestInfo.parameters[Constants_1.Constants.errorDescription];
					var error = requestInfo.parameters[Constants_1.Constants.error];
					var tokenType;
					if (requestInfo.parameters[Constants_1.Constants.accessToken]) {
						tokenType = Constants_1.Constants.accessToken;
					}
					else {
						tokenType = Constants_1.Constants.idToken;
					}
					this._cacheStorage.removeItem(Constants_1.Constants.urlHash);
					try {
						if (this._tokenReceivedCallback) {
							this._tokenReceivedCallback.call(this, errorDesc, token, error, tokenType);
						}
					}
					catch (err) {
						this._logger.error("Error occurred in token received callback function: " + err);
					}
				};
				/*
				 * Initiate the login process by redirecting the user to the STS authorization endpoint.
				 * @param {Array.<string>} scopes - Permissions you want included in the access token. Not all scopes are guaranteed to be included in the access token returned.
				 * @param {string} extraQueryParameters - Key-value pairs to pass to the authentication server during the interactive authentication flow.
				 */
				UserAgentApplication.prototype.loginRedirect = function (scopes, extraQueryParameters) {
					var _this = this;
					/*
					1. Create navigate url
					2. saves value in cache
					3. redirect user to AAD
					 */
					if (this._loginInProgress) {
						if (this._tokenReceivedCallback) {
							this._tokenReceivedCallback(Constants_1.ErrorDescription.loginProgressError, null, Constants_1.ErrorCodes.loginProgressError, Constants_1.Constants.idToken);
							return;
						}
					}
					if (scopes) {
						var isValidScope = this.validateInputScope(scopes);
						if (isValidScope && !Utils_1.Utils.isEmpty(isValidScope)) {
							if (this._tokenReceivedCallback) {
								this._tokenReceivedCallback(Constants_1.ErrorDescription.inputScopesError, null, Constants_1.ErrorCodes.inputScopesError, Constants_1.Constants.idToken);
								return;
							}
						}
						scopes = this.filterScopes(scopes);
					}
					this._loginInProgress = true;
					this.authorityInstance.ResolveEndpointsAsync()
						.then(function () {
							var authenticationRequest = new AuthenticationRequestParameters_1.AuthenticationRequestParameters(_this.authorityInstance, _this.clientId, scopes, ResponseTypes.id_token, _this._redirectUri);
							if (extraQueryParameters) {
								authenticationRequest.extraQueryParameters = extraQueryParameters;
							}
							var loginStartPage = _this._cacheStorage.getItem(Constants_1.Constants.angularLoginRequest);
							if (!loginStartPage || loginStartPage === "") {
								loginStartPage = window.location.href;
							}
							else {
								_this._cacheStorage.setItem(Constants_1.Constants.angularLoginRequest, "");
							}
							_this._cacheStorage.setItem(Constants_1.Constants.loginRequest, loginStartPage);
							_this._cacheStorage.setItem(Constants_1.Constants.loginError, "");
							_this._cacheStorage.setItem(Constants_1.Constants.stateLogin, authenticationRequest.state);
							_this._cacheStorage.setItem(Constants_1.Constants.nonceIdToken, authenticationRequest.nonce);
							_this._cacheStorage.setItem(Constants_1.Constants.msalError, "");
							_this._cacheStorage.setItem(Constants_1.Constants.msalErrorDescription, "");
							var authorityKey = Constants_1.Constants.authority + Constants_1.Constants.resourceDelimeter + authenticationRequest.state;
							if (Utils_1.Utils.isEmpty(_this._cacheStorage.getItem(authorityKey))) {
								_this._cacheStorage.setItem(authorityKey, _this.authority);
							}
							var urlNavigate = authenticationRequest.createNavigateUrl(scopes) + "&prompt=select_account" + "&response_mode=fragment";
							_this.promptUser(urlNavigate);
						});
				};
				/*
				 * Initiate the login process by opening a popup window.
				 * @param {Array.<string>} scopes - Permissions you want included in the access token. Not all scopes are  guaranteed to be included in the access token returned.
				 * @param {string} extraQueryParameters - Key-value pairs to pass to the STS during the interactive authentication flow.
				 * @returns {Promise.<string>} - A Promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the token or error.
				 */
				UserAgentApplication.prototype.loginPopup = function (scopes, extraQueryParameters) {
					var _this = this;
					/*
					1. Create navigate url
					2. saves value in cache
					3. redirect user to AAD
					 */
					return new Promise(function (resolve, reject) {
						if (_this._loginInProgress) {
							reject(Constants_1.ErrorCodes.loginProgressError + "|" + Constants_1.ErrorDescription.loginProgressError);
							return;
						}
						if (scopes) {
							var isValidScope = _this.validateInputScope(scopes);
							if (isValidScope && !Utils_1.Utils.isEmpty(isValidScope)) {
								reject(Constants_1.ErrorCodes.inputScopesError + "|" + Constants_1.ErrorDescription.inputScopesError);
								return;
							}
							scopes = _this.filterScopes(scopes);
						}
						else {
							scopes = [_this.clientId];
						}
						var scope = scopes.join(" ").toLowerCase();
						var popUpWindow = _this.openWindow("about:blank", "_blank", 1, _this, resolve, reject);
						if (!popUpWindow) {
							return;
						}
						_this._loginInProgress = true;
						_this.authorityInstance.ResolveEndpointsAsync().then(function () {
							var authenticationRequest = new AuthenticationRequestParameters_1.AuthenticationRequestParameters(_this.authorityInstance, _this.clientId, scopes, ResponseTypes.id_token, _this._redirectUri);
							if (extraQueryParameters) {
								authenticationRequest.extraQueryParameters = extraQueryParameters;
							}
							_this._cacheStorage.setItem(Constants_1.Constants.loginRequest, window.location.href);
							_this._cacheStorage.setItem(Constants_1.Constants.loginError, "");
							_this._cacheStorage.setItem(Constants_1.Constants.nonceIdToken, authenticationRequest.nonce);
							_this._cacheStorage.setItem(Constants_1.Constants.msalError, "");
							_this._cacheStorage.setItem(Constants_1.Constants.msalErrorDescription, "");
							var authorityKey = Constants_1.Constants.authority + Constants_1.Constants.resourceDelimeter + authenticationRequest.state;
							if (Utils_1.Utils.isEmpty(_this._cacheStorage.getItem(authorityKey))) {
								_this._cacheStorage.setItem(authorityKey, _this.authority);
							}
							var urlNavigate = authenticationRequest.createNavigateUrl(scopes) + "&prompt=select_account" + "&response_mode=fragment";
							window.renewStates.push(authenticationRequest.state);
							window.requestType = Constants_1.Constants.login;
							_this.registerCallback(authenticationRequest.state, scope, resolve, reject);
							if (popUpWindow) {
								_this._logger.infoPii("Navigated Popup window to:" + urlNavigate);
								popUpWindow.location.href = urlNavigate;
							}
						}, function () {
							_this._logger.info(Constants_1.ErrorCodes.endpointResolutionError + ":" + Constants_1.ErrorDescription.endpointResolutionError);
							_this._cacheStorage.setItem(Constants_1.Constants.msalError, Constants_1.ErrorCodes.endpointResolutionError);
							_this._cacheStorage.setItem(Constants_1.Constants.msalErrorDescription, Constants_1.ErrorDescription.endpointResolutionError);
							if (reject) {
								reject(Constants_1.ErrorCodes.endpointResolutionError + ":" + Constants_1.ErrorDescription.endpointResolutionError);
							}
							if (popUpWindow) {
								popUpWindow.close();
							}
						}).catch(function (err) {
							_this._logger.warning("could not resolve endpoints");
							reject(err);
						});
					});
				};
				/*
				  * Used to redirect the browser to the STS authorization endpoint
				  * @param {string} urlNavigate - URL of the authorization endpoint
				  * @hidden
				  */
				UserAgentApplication.prototype.promptUser = function (urlNavigate) {
					if (urlNavigate && !Utils_1.Utils.isEmpty(urlNavigate)) {
						this._logger.infoPii("Navigate to:" + urlNavigate);
						window.location.replace(urlNavigate);
					}
					else {
						this._logger.info("Navigate url is empty");
					}
				};
				/*
				 * Used to send the user to the redirect_uri after authentication is complete. The user"s bearer token is attached to the URI fragment as an id_token/access_token field.
				 * This function also closes the popup window after redirection.
				 * @hidden
				 * @ignore
				 */
				UserAgentApplication.prototype.openWindow = function (urlNavigate, title, interval, instance, resolve, reject) {
					var _this = this;
					var popupWindow = this.openPopup(urlNavigate, title, Constants_1.Constants.popUpWidth, Constants_1.Constants.popUpHeight);
					if (popupWindow == null) {
						instance._loginInProgress = false;
						instance._acquireTokenInProgress = false;
						this._logger.info(Constants_1.ErrorCodes.popUpWindowError + ":" + Constants_1.ErrorDescription.popUpWindowError);
						this._cacheStorage.setItem(Constants_1.Constants.msalError, Constants_1.ErrorCodes.popUpWindowError);
						this._cacheStorage.setItem(Constants_1.Constants.msalErrorDescription, Constants_1.ErrorDescription.popUpWindowError);
						if (reject) {
							reject(Constants_1.ErrorCodes.popUpWindowError + "|" + Constants_1.ErrorDescription.popUpWindowError);
						}
						return null;
					}
					window.openedWindows.push(popupWindow);
					var pollTimer = window.setInterval(function () {
						if (popupWindow && popupWindow.closed && instance._loginInProgress) {
							if (reject) {
								reject(Constants_1.ErrorCodes.userCancelledError + "|" + Constants_1.ErrorDescription.userCancelledError);
							}
							window.clearInterval(pollTimer);
							if (_this._isAngular) {
								_this.broadcast('msal:popUpClosed', Constants_1.ErrorCodes.userCancelledError + "|" + Constants_1.ErrorDescription.userCancelledError);
								return;
							}
							instance._loginInProgress = false;
							instance._acquireTokenInProgress = false;
						}
						try {
							var popUpWindowLocation = popupWindow.location;
							if (popUpWindowLocation.href.indexOf(_this._redirectUri) !== -1) {
								window.clearInterval(pollTimer);
								instance._loginInProgress = false;
								instance._acquireTokenInProgress = false;
								_this._logger.info("Closing popup window");
								if (_this._isAngular) {
									_this.broadcast('msal:popUpHashChanged', popUpWindowLocation.hash);
									for (var i = 0; i < window.openedWindows.length; i++) {
										window.openedWindows[i].close();
									}
								}
							}
						}
						catch (e) {
							//Cross Domain url check error. Will be thrown until AAD redirects the user back to the app"s root page with the token. No need to log or throw this error as it will create unnecessary traffic.
						}
					}, interval);
					return popupWindow;
				};
				UserAgentApplication.prototype.broadcast = function (eventName, data) {
					var evt = new CustomEvent(eventName, { detail: data });
					window.dispatchEvent(evt);
				};
				/*
				 * Used to log out the current user, and redirect the user to the postLogoutRedirectUri.
				 * Defaults behaviour is to redirect the user to `window.location.href`.
				 */
				UserAgentApplication.prototype.logout = function () {
					this.clearCache();
					this._user = null;
					var logout = "";
					if (this._postLogoutredirectUri) {
						logout = "post_logout_redirect_uri=" + encodeURIComponent(this._postLogoutredirectUri);
					}
					var urlNavigate = this.authority + "/oauth2/v2.0/logout?" + logout;
					this.promptUser(urlNavigate);
				};
				/*
				 * Used to configure the popup window for login.
				 * @ignore
				 * @hidden
				 */
				UserAgentApplication.prototype.clearCache = function () {
					window.renewStates = [];
					var accessTokenItems = this._cacheStorage.getAllAccessTokens(Constants_1.Constants.clientId, Constants_1.Constants.userIdentifier);
					for (var i = 0; i < accessTokenItems.length; i++) {
						this._cacheStorage.removeItem(JSON.stringify(accessTokenItems[i].key));
					}
					this._cacheStorage.resetCacheItems();
				};
				UserAgentApplication.prototype.clearCacheForScope = function (accessToken) {
					var accessTokenItems = this._cacheStorage.getAllAccessTokens(Constants_1.Constants.clientId, Constants_1.Constants.userIdentifier);
					for (var i = 0; i < accessTokenItems.length; i++) {
						var token = accessTokenItems[i];
						if (token.value.accessToken == accessToken) {
							this._cacheStorage.removeItem(JSON.stringify(token.key));
						}
					}
				};
				/*
				 * Configures popup window for login.
				 * @ignore
				 * @hidden
				 */
				UserAgentApplication.prototype.openPopup = function (urlNavigate, title, popUpWidth, popUpHeight) {
					try {
						/*
						 * adding winLeft and winTop to account for dual monitor
						 * using screenLeft and screenTop for IE8 and earlier
						 */
						var winLeft = window.screenLeft ? window.screenLeft : window.screenX;
						var winTop = window.screenTop ? window.screenTop : window.screenY;
						/*
						 * window.innerWidth displays browser window"s height and width excluding toolbars
						 * using document.documentElement.clientWidth for IE8 and earlier
						 */
						var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
						var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
						var left = ((width / 2) - (popUpWidth / 2)) + winLeft;
						var top_1 = ((height / 2) - (popUpHeight / 2)) + winTop;
						var popupWindow = window.open(urlNavigate, title, "width=" + popUpWidth + ", height=" + popUpHeight + ", top=" + top_1 + ", left=" + left);
						if (popupWindow.focus) {
							popupWindow.focus();
						}
						return popupWindow;
					}
					catch (e) {
						this._logger.error("error opening popup " + e.message);
						this._loginInProgress = false;
						this._acquireTokenInProgress = false;
						return null;
					}
				};
				/*
				 * Used to validate the scopes input parameter requested  by the developer.
				 * @param {Array<string>} scopes - Developer requested permissions. Not all scopes are guaranteed to be included in the access token returned.
				 * @ignore
				 * @hidden
				 */
				UserAgentApplication.prototype.validateInputScope = function (scopes) {
					if (!scopes || scopes.length < 1) {
						return "Scopes cannot be passed as an empty array";
					}
					if (!Array.isArray(scopes)) {
						throw new Error("API does not accept non-array scopes");
					}
					if (scopes.indexOf(this.clientId) > -1) {
						if (scopes.length > 1) {
							return "ClientId can only be provided as a single scope";
						}
					}
					return "";
				};
				/*
				  * Used to remove openid and profile from the list of scopes passed by the developer.These scopes are added by default
				  * @hidden
				  */
				UserAgentApplication.prototype.filterScopes = function (scopes) {
					scopes = scopes.filter(function (element) {
						return element !== "openid";
					});
					scopes = scopes.filter(function (element) {
						return element !== "profile";
					});
					return scopes;
				};
				/*
				 * Used to add the developer requested callback to the array of callbacks for the specified scopes. The updated array is stored on the window object
				 * @param {string} scope - Developer requested permissions. Not all scopes are guaranteed to be included in the access token returned.
				 * @param {string} expectedState - Unique state identifier (guid).
				 * @param {Function} resolve - The resolve function of the promise object.
				 * @param {Function} reject - The reject function of the promise object.
				 * @ignore
				 * @hidden
				 */
				UserAgentApplication.prototype.registerCallback = function (expectedState, scope, resolve, reject) {
					var _this = this;
					window.activeRenewals[scope] = expectedState;
					if (!window.callBacksMappedToRenewStates[expectedState]) {
						window.callBacksMappedToRenewStates[expectedState] = [];
					}
					window.callBacksMappedToRenewStates[expectedState].push({ resolve: resolve, reject: reject });
					if (!window.callBackMappedToRenewStates[expectedState]) {
						window.callBackMappedToRenewStates[expectedState] =
							function (errorDesc, token, error, tokenType) {
								window.activeRenewals[scope] = null;
								for (var i = 0; i < window.callBacksMappedToRenewStates[expectedState].length; ++i) {
									try {
										if (errorDesc || error) {
											window.callBacksMappedToRenewStates[expectedState][i].reject(errorDesc + "|" + error);
										}
										else if (token) {
											window.callBacksMappedToRenewStates[expectedState][i].resolve(token);
										}
									}
									catch (e) {
										_this._logger.warning(e);
									}
								}
								window.callBacksMappedToRenewStates[expectedState] = null;
								window.callBackMappedToRenewStates[expectedState] = null;
							};
					}
				};
				UserAgentApplication.prototype.getCachedTokenInternal = function (scopes, user) {
					var userObject = user ? user : this.getUser();
					if (!userObject) {
						return;
					}
					var authenticationRequest;
					var newAuthority = this.authorityInstance ? this.authorityInstance : AuthorityFactory_1.AuthorityFactory.CreateInstance(this.authority, this.validateAuthority);
					if (Utils_1.Utils.compareObjects(userObject, this.getUser())) {
						if (scopes.indexOf(this.clientId) > -1) {
							authenticationRequest = new AuthenticationRequestParameters_1.AuthenticationRequestParameters(newAuthority, this.clientId, scopes, ResponseTypes.id_token, this._redirectUri);
						}
						else {
							authenticationRequest = new AuthenticationRequestParameters_1.AuthenticationRequestParameters(newAuthority, this.clientId, scopes, ResponseTypes.token, this._redirectUri);
						}
					}
					else {
						authenticationRequest = new AuthenticationRequestParameters_1.AuthenticationRequestParameters(newAuthority, this.clientId, scopes, ResponseTypes.id_token_token, this._redirectUri);
					}
					return this.getCachedToken(authenticationRequest, user);
				};
				/*
				 * Used to get token for the specified set of scopes from the cache
				 * @param {AuthenticationRequestParameters} authenticationRequest - Request sent to the STS to obtain an id_token/access_token
				 * @param {User} user - User for which the scopes were requested
				 * @hidden
				 */
				UserAgentApplication.prototype.getCachedToken = function (authenticationRequest, user) {
					var accessTokenCacheItem = null;
					var scopes = authenticationRequest.scopes;
					var tokenCacheItems = this._cacheStorage.getAllAccessTokens(this.clientId, user ? user.userIdentifier : null); //filter by clientId and user
					if (tokenCacheItems.length === 0) { // No match found after initial filtering
						return null;
					}
					var filteredItems = [];
					//if no authority passed
					if (!authenticationRequest.authority) {
						//filter by scope
						for (var i = 0; i < tokenCacheItems.length; i++) {
							var cacheItem = tokenCacheItems[i];
							var cachedScopes = cacheItem.key.scopes.split(" ");
							if (Utils_1.Utils.containsScope(cachedScopes, scopes)) {
								filteredItems.push(cacheItem);
							}
						}
						//if only one cached token found
						if (filteredItems.length === 1) {
							accessTokenCacheItem = filteredItems[0];
							authenticationRequest.authorityInstance = AuthorityFactory_1.AuthorityFactory.CreateInstance(accessTokenCacheItem.key.authority, this.validateAuthority);
						}
						else if (filteredItems.length > 1) {
							return {
								errorDesc: "The cache contains multiple tokens satisfying the requirements. Call AcquireToken again providing more requirements like authority",
								token: null,
								error: "multiple_matching_tokens_detected"
							};
						}
						else {
							//no match found. check if there was a single authority used
							var authorityList = this.getUniqueAuthority(tokenCacheItems, "authority");
							if (authorityList.length > 1) {
								return {
									errorDesc: "Multiple authorities found in the cache. Pass authority in the API overload.",
									token: null,
									error: "multiple_matching_tokens_detected"
								};
							}
							authenticationRequest.authorityInstance = AuthorityFactory_1.AuthorityFactory.CreateInstance(authorityList[0], this.validateAuthority);
						}
					}
					else {
						//authority was passed in the API, filter by authority and scope
						for (var i = 0; i < tokenCacheItems.length; i++) {
							var cacheItem = tokenCacheItems[i];
							var cachedScopes = cacheItem.key.scopes.split(" ");
							if (Utils_1.Utils.containsScope(cachedScopes, scopes) && cacheItem.key.authority === authenticationRequest.authority) {
								filteredItems.push(cacheItem);
							}
						}
						//no match
						if (filteredItems.length === 0) {
							return null;
						}
						//only one cachedToken Found
						else if (filteredItems.length === 1) {
							accessTokenCacheItem = filteredItems[0];
						}
						else {
							//more than one match found.
							return {
								errorDesc: "The cache contains multiple tokens satisfying the requirements.Call AcquireToken again providing more requirements like authority",
								token: null,
								error: "multiple_matching_tokens_detected"
							};
						}
					}
					if (accessTokenCacheItem != null) {
						var expired = Number(accessTokenCacheItem.value.expiresIn);
						// If expiration is within offset, it will force renew
						var offset = this._clockSkew || 300;
						if (expired && (expired > Utils_1.Utils.now() + offset)) {
							return {
								errorDesc: null,
								token: accessTokenCacheItem.value.accessToken,
								error: null
							};
						}
						else {
							this._cacheStorage.removeItem(JSON.stringify(filteredItems[0].key));
							return null;
						}
					}
					else {
						return null;
					}
				};
				/*
				 * Used to filter all cached items and return a list of unique users based on userIdentifier.
				 * @param {Array<User>} Users - users saved in the cache.
				 */
				UserAgentApplication.prototype.getAllUsers = function () {
					var users = [];
					var accessTokenCacheItems = this._cacheStorage.getAllAccessTokens(Constants_1.Constants.clientId, Constants_1.Constants.userIdentifier);
					for (var i = 0; i < accessTokenCacheItems.length; i++) {
						var idToken = new IdToken_1.IdToken(accessTokenCacheItems[i].value.idToken);
						var clientInfo = new ClientInfo_1.ClientInfo(accessTokenCacheItems[i].value.clientInfo);
						var user = User_1.User.createUser(idToken, clientInfo, this.authority);
						users.push(user);
					}
					return this.getUniqueUsers(users);
				};
				/*
				 * Used to filter users based on userIdentifier
				 * @param {Array<User>}  Users - users saved in the cache
				 * @ignore
				 * @hidden
				 */
				UserAgentApplication.prototype.getUniqueUsers = function (users) {
					if (!users || users.length <= 1) {
						return users;
					}
					var flags = [];
					var uniqueUsers = [];
					for (var index = 0; index < users.length; ++index) {
						if (users[index].userIdentifier && flags.indexOf(users[index].userIdentifier) === -1) {
							flags.push(users[index].userIdentifier);
							uniqueUsers.push(users[index]);
						}
					}
					return uniqueUsers;
				};
				/*
				* Used to get a unique list of authoritues from the cache
				* @param {Array<AccessTokenCacheItem>}  accessTokenCacheItems - accessTokenCacheItems saved in the cache
				* @ignore
				* @hidden
				*/
				UserAgentApplication.prototype.getUniqueAuthority = function (accessTokenCacheItems, property) {
					var authorityList = [];
					var flags = [];
					accessTokenCacheItems.forEach(function (element) {
						if (element.key.hasOwnProperty(property) && (flags.indexOf(element.key[property]) === -1)) {
							flags.push(element.key[property]);
							authorityList.push(element.key[property]);
						}
					});
					return authorityList;
				};
				/*
				 * Adds login_hint to authorization URL which is used to pre-fill the username field of sign in page for the user if known ahead of time
				 * domain_hint can be one of users/organisations which when added skips the email based discovery process of the user
				 * domain_req utid received as part of the clientInfo
				 * login_req uid received as part of clientInfo
				 * @param {string} urlNavigate - Authentication request url
				 * @param {User} user - User for which the token is requested
				 * @ignore
				 * @hidden
				 */
				UserAgentApplication.prototype.addHintParameters = function (urlNavigate, user) {
					var userObject = user ? user : this.getUser();
					var decodedClientInfo = userObject.userIdentifier.split(".");
					var uid = Utils_1.Utils.base64DecodeStringUrlSafe(decodedClientInfo[0]);
					var utid = Utils_1.Utils.base64DecodeStringUrlSafe(decodedClientInfo[1]);
					if (!this.urlContainsQueryStringParameter("login_hint", urlNavigate) && userObject.displayableId && !Utils_1.Utils.isEmpty(userObject.displayableId)) {
						urlNavigate += "&login_hint=" + encodeURIComponent(user.displayableId);
					}
					if (!Utils_1.Utils.isEmpty(uid) && !Utils_1.Utils.isEmpty(utid)) {
						if (!this.urlContainsQueryStringParameter("domain_req", urlNavigate) && !Utils_1.Utils.isEmpty(utid)) {
							urlNavigate += "&domain_req=" + encodeURIComponent(utid);
						}
						if (!this.urlContainsQueryStringParameter("login_req", urlNavigate) && !Utils_1.Utils.isEmpty(uid)) {
							urlNavigate += "&login_req=" + encodeURIComponent(uid);
						}
						if (!this.urlContainsQueryStringParameter("domain_hint", urlNavigate) && !Utils_1.Utils.isEmpty(utid)) {
							if (utid === "9188040d-6c67-4c5b-b112-36a304b66dad") {
								urlNavigate += "&domain_hint=" + encodeURIComponent("consumers");
							}
							else {
								urlNavigate += "&domain_hint=" + encodeURIComponent("organizations");
							}
						}
					}
					return urlNavigate;
				};
				/*
				 * Checks if the authorization endpoint URL contains query string parameters
				 * @ignore
				 * @hidden
				 */
				UserAgentApplication.prototype.urlContainsQueryStringParameter = function (name, url) {
					// regex to detect pattern of a ? or & followed by the name parameter and an equals character
					var regex = new RegExp("[\\?&]" + name + "=");
					return regex.test(url);
				};
				UserAgentApplication.prototype.acquireTokenRedirect = function (scopes, authority, user, extraQueryParameters) {
					var _this = this;
					var isValidScope = this.validateInputScope(scopes);
					if (isValidScope && !Utils_1.Utils.isEmpty(isValidScope)) {
						if (this._tokenReceivedCallback) {
							this._tokenReceivedCallback(Constants_1.ErrorDescription.inputScopesError, null, Constants_1.ErrorCodes.inputScopesError, Constants_1.Constants.accessToken);
							return;
						}
					}
					if (scopes) {
						scopes = this.filterScopes(scopes);
					}
					var userObject = user ? user : this.getUser();
					if (this._acquireTokenInProgress) {
						return;
					}
					var scope = scopes.join(" ").toLowerCase();
					if (!userObject) {
						if (this._tokenReceivedCallback) {
							this._tokenReceivedCallback(Constants_1.ErrorDescription.userLoginError, null, Constants_1.ErrorCodes.userLoginError, Constants_1.Constants.accessToken);
							return;
						}
					}
					this._acquireTokenInProgress = true;
					var authenticationRequest;
					var acquireTokenAuthority = authority ? AuthorityFactory_1.AuthorityFactory.CreateInstance(authority, this.validateAuthority) : this.authorityInstance;
					acquireTokenAuthority.ResolveEndpointsAsync().then(function () {
						if (Utils_1.Utils.compareObjects(userObject, _this.getUser())) {
							authenticationRequest = new AuthenticationRequestParameters_1.AuthenticationRequestParameters(acquireTokenAuthority, _this.clientId, scopes, ResponseTypes.token, _this._redirectUri);
						}
						else {
							authenticationRequest = new AuthenticationRequestParameters_1.AuthenticationRequestParameters(acquireTokenAuthority, _this.clientId, scopes, ResponseTypes.id_token_token, _this._redirectUri);
						}
						_this._cacheStorage.setItem(Constants_1.Constants.nonceIdToken, authenticationRequest.nonce);
						var acquireTokenUserKey = Constants_1.Constants.acquireTokenUser + Constants_1.Constants.resourceDelimeter + userObject.userIdentifier + Constants_1.Constants.resourceDelimeter + authenticationRequest.state;
						if (Utils_1.Utils.isEmpty(_this._cacheStorage.getItem(acquireTokenUserKey))) {
							_this._cacheStorage.setItem(acquireTokenUserKey, JSON.stringify(userObject));
						}
						var authorityKey = Constants_1.Constants.authority + Constants_1.Constants.resourceDelimeter + authenticationRequest.state;
						if (Utils_1.Utils.isEmpty(_this._cacheStorage.getItem(authorityKey))) {
							_this._cacheStorage.setItem(authorityKey, acquireTokenAuthority.CanonicalAuthority);
						}
						if (extraQueryParameters) {
							authenticationRequest.extraQueryParameters = extraQueryParameters;
						}
						var urlNavigate = authenticationRequest.createNavigateUrl(scopes) + "&prompt=select_account" + "&response_mode=fragment";
						urlNavigate = _this.addHintParameters(urlNavigate, userObject);
						if (urlNavigate) {
							_this._cacheStorage.setItem(Constants_1.Constants.stateAcquireToken, authenticationRequest.state);
							window.location.replace(urlNavigate);
						}
					});
				};
				UserAgentApplication.prototype.acquireTokenPopup = function (scopes, authority, user, extraQueryParameters) {
					var _this = this;
					return new Promise(function (resolve, reject) {
						var isValidScope = _this.validateInputScope(scopes);
						if (isValidScope && !Utils_1.Utils.isEmpty(isValidScope)) {
							reject(Constants_1.ErrorCodes.inputScopesError + "|" + isValidScope);
						}
						if (scopes) {
							scopes = _this.filterScopes(scopes);
						}
						var userObject = user ? user : _this.getUser();
						if (_this._acquireTokenInProgress) {
							reject(Constants_1.ErrorCodes.acquireTokenProgressError + "|" + Constants_1.ErrorDescription.acquireTokenProgressError);
							return;
						}
						var scope = scopes.join(" ").toLowerCase();
						if (!userObject) {
							reject(Constants_1.ErrorCodes.userLoginError + "|" + Constants_1.ErrorDescription.userLoginError);
							return;
						}
						_this._acquireTokenInProgress = true;
						var authenticationRequest;
						var acquireTokenAuthority = authority ? AuthorityFactory_1.AuthorityFactory.CreateInstance(authority, _this.validateAuthority) : _this.authorityInstance;
						var popUpWindow = _this.openWindow("about:blank", "_blank", 1, _this, resolve, reject);
						if (!popUpWindow) {
							return;
						}
						acquireTokenAuthority.ResolveEndpointsAsync().then(function () {
							if (Utils_1.Utils.compareObjects(userObject, _this.getUser())) {
								if (scopes.indexOf(_this.clientId) > -1) {
									authenticationRequest = new AuthenticationRequestParameters_1.AuthenticationRequestParameters(acquireTokenAuthority, _this.clientId, scopes, ResponseTypes.id_token, _this._redirectUri);
								}
								else {
									authenticationRequest = new AuthenticationRequestParameters_1.AuthenticationRequestParameters(acquireTokenAuthority, _this.clientId, scopes, ResponseTypes.token, _this._redirectUri);
								}
							}
							else {
								authenticationRequest = new AuthenticationRequestParameters_1.AuthenticationRequestParameters(acquireTokenAuthority, _this.clientId, scopes, ResponseTypes.id_token_token, _this._redirectUri);
							}
							_this._cacheStorage.setItem(Constants_1.Constants.nonceIdToken, authenticationRequest.nonce);
							authenticationRequest.state = authenticationRequest.state;
							var acquireTokenUserKey = Constants_1.Constants.acquireTokenUser + Constants_1.Constants.resourceDelimeter + userObject.userIdentifier + Constants_1.Constants.resourceDelimeter + authenticationRequest.state;
							if (Utils_1.Utils.isEmpty(_this._cacheStorage.getItem(acquireTokenUserKey))) {
								_this._cacheStorage.setItem(acquireTokenUserKey, JSON.stringify(userObject));
							}
							var authorityKey = Constants_1.Constants.authority + Constants_1.Constants.resourceDelimeter + authenticationRequest.state;
							if (Utils_1.Utils.isEmpty(_this._cacheStorage.getItem(authorityKey))) {
								_this._cacheStorage.setItem(authorityKey, acquireTokenAuthority.CanonicalAuthority);
							}
							if (extraQueryParameters) {
								authenticationRequest.extraQueryParameters = extraQueryParameters;
							}
							var urlNavigate = authenticationRequest.createNavigateUrl(scopes) + "&prompt=select_account" + "&response_mode=fragment";
							urlNavigate = _this.addHintParameters(urlNavigate, userObject);
							window.renewStates.push(authenticationRequest.state);
							window.requestType = Constants_1.Constants.renewToken;
							_this.registerCallback(authenticationRequest.state, scope, resolve, reject);
							if (popUpWindow) {
								popUpWindow.location.href = urlNavigate;
							}
						}, function () {
							_this._logger.info(Constants_1.ErrorCodes.endpointResolutionError + ":" + Constants_1.ErrorDescription.endpointResolutionError);
							_this._cacheStorage.setItem(Constants_1.Constants.msalError, Constants_1.ErrorCodes.endpointResolutionError);
							_this._cacheStorage.setItem(Constants_1.Constants.msalErrorDescription, Constants_1.ErrorDescription.endpointResolutionError);
							if (reject) {
								reject(Constants_1.ErrorCodes.endpointResolutionError + "|" + Constants_1.ErrorDescription.endpointResolutionError);
							}
							if (popUpWindow) {
								popUpWindow.close();
							}
						}).catch(function (err) {
							_this._logger.warning("could not resolve endpoints");
							reject(err);
						});
					});
				};
				/*
				 * Used to get the token from cache.
				 * MSAL will return the cached token if it is not expired.
				 * Or it will send a request to the STS to obtain an access_token using a hidden iframe. To renew idToken, clientId should be passed as the only scope in the scopes array.
				 * @param {Array<string>} scopes - Permissions you want included in the access token. Not all scopes are  guaranteed to be included in the access token. Scopes like "openid" and "profile" are sent with every request.
				 * @param {string} authority - A URL indicating a directory that MSAL can use to obtain tokens.
				 * - In Azure AD, it is of the form https://&lt;tenant&gt;/&lt;tenant&gt;, where &lt;tenant&gt; is the directory host (e.g. https://login.microsoftonline.com) and &lt;tenant&gt; is a identifier within the directory itself (e.g. a domain associated to the tenant, such as contoso.onmicrosoft.com, or the GUID representing the TenantID property of the directory)
				 * - In Azure B2C, it is of the form https://&lt;instance&gt;/tfp/&lt;tenant&gt;/<policyName>/
				 * - Default value is: "https://login.microsoftonline.com/common"
				 * @param {User} user - The user for which the scopes are requested.The default user is the logged in user.
				 * @param {string} extraQueryParameters - Key-value pairs to pass to the STS during the  authentication flow.
				 * @returns {Promise.<string>} - A Promise that is fulfilled when this function has completed, or rejected if an error was raised. Resolved with token or rejected with error.
				 */
				UserAgentApplication.prototype.acquireTokenSilent = function (scopes, authority, user, extraQueryParameters) {
					var _this = this;
					return new Promise(function (resolve, reject) {
						var isValidScope = _this.validateInputScope(scopes);
						if (isValidScope && !Utils_1.Utils.isEmpty(isValidScope)) {
							reject(Constants_1.ErrorCodes.inputScopesError + "|" + isValidScope);
						}
						else {
							if (scopes) {
								scopes = _this.filterScopes(scopes);
							}
							var scope_1 = scopes.join(" ").toLowerCase();
							var userObject_1 = user ? user : _this.getUser();
							if (!userObject_1) {
								reject(Constants_1.ErrorCodes.userLoginError + "|" + Constants_1.ErrorDescription.userLoginError);
								return;
							}
							var authenticationRequest_1;
							var newAuthority = authority ? AuthorityFactory_1.AuthorityFactory.CreateInstance(authority, _this.validateAuthority) : _this.authorityInstance;
							if (Utils_1.Utils.compareObjects(userObject_1, _this.getUser())) {
								if (scopes.indexOf(_this.clientId) > -1) {
									authenticationRequest_1 = new AuthenticationRequestParameters_1.AuthenticationRequestParameters(newAuthority, _this.clientId, scopes, ResponseTypes.id_token, _this._redirectUri);
								}
								else {
									authenticationRequest_1 = new AuthenticationRequestParameters_1.AuthenticationRequestParameters(newAuthority, _this.clientId, scopes, ResponseTypes.token, _this._redirectUri);
								}
							}
							else {
								authenticationRequest_1 = new AuthenticationRequestParameters_1.AuthenticationRequestParameters(newAuthority, _this.clientId, scopes, ResponseTypes.id_token_token, _this._redirectUri);
							}
							var cacheResult = _this.getCachedToken(authenticationRequest_1, userObject_1);
							if (cacheResult) {
								if (cacheResult.token) {
									_this._logger.info("Token is already in cache for scope:" + scope_1);
									resolve(cacheResult.token);
									return;
								}
								else if (cacheResult.errorDesc || cacheResult.error) {
									_this._logger.infoPii(cacheResult.errorDesc + ":" + cacheResult.error);
									reject(cacheResult.errorDesc + "|" + cacheResult.error);
									return;
								}
							}
							else {
								_this._logger.verbose("Token is not in cache for scope:" + scope_1);
							}
							// cache miss
							return _this.authorityInstance.ResolveEndpointsAsync()
								.then(function () {
									// refresh attept with iframe
									//Already renewing for this scope, callback when we get the token.
									if (window.activeRenewals[scope_1]) {
										_this._logger.verbose("Renew token for scope: " + scope_1 + " is in progress. Registering callback");
										//Active renewals contains the state for each renewal.
										_this.registerCallback(window.activeRenewals[scope_1], scope_1, resolve, reject);
									}
									else {
										if (scopes && scopes.indexOf(_this.clientId) > -1 && scopes.length === 1) {
											// App uses idToken to send to api endpoints
											// Default scope is tracked as clientId to store this token
											_this._logger.verbose("renewing idToken");
											_this.renewIdToken(scopes, resolve, reject, userObject_1, authenticationRequest_1, extraQueryParameters);
										}
										else {
											_this._logger.verbose("renewing accesstoken");
											_this.renewToken(scopes, resolve, reject, userObject_1, authenticationRequest_1, extraQueryParameters);
										}
									}
								}).catch(function (err) {
									_this._logger.warning("could not resolve endpoints");
									reject(err);
								});
						}
					});
				};
				/*
				 * Calling _loadFrame but with a timeout to signal failure in loadframeStatus. Callbacks are left.
				 * registered when network errors occur and subsequent token requests for same resource are registered to the pending request.
				 * @ignore
				 * @hidden
				 */
				UserAgentApplication.prototype.loadIframeTimeout = function (urlNavigate, frameName, scope) {
					var _this = this;
					//set iframe session to pending
					var expectedState = window.activeRenewals[scope];
					this._logger.verbose("Set loading state to pending for: " + scope + ":" + expectedState);
					this._cacheStorage.setItem(Constants_1.Constants.renewStatus + expectedState, Constants_1.Constants.tokenRenewStatusInProgress);
					this.loadFrame(urlNavigate, frameName);
					setTimeout(function () {
						if (_this._cacheStorage.getItem(Constants_1.Constants.renewStatus + expectedState) === Constants_1.Constants.tokenRenewStatusInProgress) {
							// fail the iframe session if it"s in pending state
							_this._logger.verbose("Loading frame has timed out after: " + (_this.loadFrameTimeout / 1000) + " seconds for scope " + scope + ":" + expectedState);
							if (expectedState && window.callBackMappedToRenewStates[expectedState]) {
								window.callBackMappedToRenewStates[expectedState]("Token renewal operation failed due to timeout", null, "Token Renewal Failed", Constants_1.Constants.accessToken);
							}
							_this._cacheStorage.setItem(Constants_1.Constants.renewStatus + expectedState, Constants_1.Constants.tokenRenewStatusCancelled);
						}
					}, this.loadFrameTimeout);
				};
				/*
				 * Loads iframe with authorization endpoint URL
				 * @ignore
				 * @hidden
				 */
				UserAgentApplication.prototype.loadFrame = function (urlNavigate, frameName) {
					var _this = this;
					// This trick overcomes iframe navigation in IE
					// IE does not load the page consistently in iframe
					this._logger.info("LoadFrame: " + frameName);
					var frameCheck = frameName;
					setTimeout(function () {
						var frameHandle = _this.addAdalFrame(frameCheck);
						if (frameHandle.src === "" || frameHandle.src === "about:blank") {
							frameHandle.src = urlNavigate;
							_this._logger.infoPii("Frame Name : " + frameName + " Navigated to: " + urlNavigate);
						}
					}, 500);
				};
				/*
				 * Adds the hidden iframe for silent token renewal.
				 * @ignore
				 * @hidden
				 */
				UserAgentApplication.prototype.addAdalFrame = function (iframeId) {
					if (typeof iframeId === "undefined") {
						return null;
					}
					this._logger.info("Add msal frame to document:" + iframeId);
					var adalFrame = document.getElementById(iframeId);
					if (!adalFrame) {
						if (document.createElement &&
							document.documentElement &&
							(window.navigator.userAgent.indexOf("MSIE 5.0") === -1)) {
							var ifr = document.createElement("iframe");
							ifr.setAttribute("id", iframeId);
							ifr.style.visibility = "hidden";
							ifr.style.position = "absolute";
							ifr.style.width = ifr.style.height = "0";
							ifr.style.border = "0";
							adalFrame = document.getElementsByTagName("body")[0].appendChild(ifr);
						}
						else if (document.body && document.body.insertAdjacentHTML) {
							document.body.insertAdjacentHTML('beforeend', '<iframe name="' + iframeId + '" id="' + iframeId + '" style="display:none"></iframe>');
						}
						if (window.frames && window.frames[iframeId]) {
							adalFrame = window.frames[iframeId];
						}
					}
					return adalFrame;
				};
				/*
				 * Acquires access token using a hidden iframe.
				 * @ignore
				 * @hidden
				 */
				UserAgentApplication.prototype.renewToken = function (scopes, resolve, reject, user, authenticationRequest, extraQueryParameters) {
					var scope = scopes.join(" ").toLowerCase();
					this._logger.verbose("renewToken is called for scope:" + scope);
					var frameHandle = this.addAdalFrame("msalRenewFrame" + scope);
					if (extraQueryParameters) {
						authenticationRequest.extraQueryParameters = extraQueryParameters;
					}
					var acquireTokenUserKey = Constants_1.Constants.acquireTokenUser + Constants_1.Constants.resourceDelimeter + user.userIdentifier + Constants_1.Constants.resourceDelimeter + authenticationRequest.state;
					if (Utils_1.Utils.isEmpty(this._cacheStorage.getItem(acquireTokenUserKey))) {
						this._cacheStorage.setItem(acquireTokenUserKey, JSON.stringify(user));
					}
					var authorityKey = Constants_1.Constants.authority + Constants_1.Constants.resourceDelimeter + authenticationRequest.state;
					if (Utils_1.Utils.isEmpty(this._cacheStorage.getItem(authorityKey))) {
						this._cacheStorage.setItem(authorityKey, authenticationRequest.authority);
					}
					// renew happens in iframe, so it keeps javascript context
					this._cacheStorage.setItem(Constants_1.Constants.nonceIdToken, authenticationRequest.nonce);
					this._logger.verbose("Renew token Expected state: " + authenticationRequest.state);
					var urlNavigate = authenticationRequest.createNavigateUrl(scopes) + "&prompt=none";
					urlNavigate = this.addHintParameters(urlNavigate, user);
					window.renewStates.push(authenticationRequest.state);
					window.requestType = Constants_1.Constants.renewToken;
					this.registerCallback(authenticationRequest.state, scope, resolve, reject);
					this._logger.infoPii("Navigate to:" + urlNavigate);
					frameHandle.src = "about:blank";
					this.loadIframeTimeout(urlNavigate, "msalRenewFrame" + scope, scope);
				};
				/*
				 * Renews idtoken for app"s own backend when clientId is passed as a single scope in the scopes array.
				 * @ignore
				 * @hidden
				 */
				UserAgentApplication.prototype.renewIdToken = function (scopes, resolve, reject, user, authenticationRequest, extraQueryParameters) {
					var scope = scopes.join(" ").toLowerCase();
					this._logger.info("renewidToken is called");
					var frameHandle = this.addAdalFrame("msalIdTokenFrame");
					if (extraQueryParameters) {
						authenticationRequest.extraQueryParameters = extraQueryParameters;
					}
					var acquireTokenUserKey = Constants_1.Constants.acquireTokenUser + Constants_1.Constants.resourceDelimeter + user.userIdentifier + Constants_1.Constants.resourceDelimeter + authenticationRequest.state;
					if (Utils_1.Utils.isEmpty(this._cacheStorage.getItem(acquireTokenUserKey))) {
						this._cacheStorage.setItem(acquireTokenUserKey, JSON.stringify(user));
					}
					var authorityKey = Constants_1.Constants.authority + Constants_1.Constants.resourceDelimeter + authenticationRequest.state;
					if (Utils_1.Utils.isEmpty(this._cacheStorage.getItem(authorityKey))) {
						this._cacheStorage.setItem(authorityKey, authenticationRequest.authority);
					}
					this._cacheStorage.setItem(Constants_1.Constants.nonceIdToken, authenticationRequest.nonce);
					this._logger.verbose("Renew Idtoken Expected state: " + authenticationRequest.state);
					var urlNavigate = authenticationRequest.createNavigateUrl(scopes) + "&prompt=none";
					urlNavigate = this.addHintParameters(urlNavigate, user);
					window.renewStates.push(authenticationRequest.state);
					window.requestType = Constants_1.Constants.renewToken;
					this.registerCallback(authenticationRequest.state, this.clientId, resolve, reject);
					this._logger.infoPii("Navigate to:" + urlNavigate);
					frameHandle.src = "about:blank";
					this.loadIframeTimeout(urlNavigate, "msalIdTokenFrame", this.clientId);
				};
				/*
				  * Returns the signed in user (received from a user object created at the time of login) or null.
				  */
				UserAgentApplication.prototype.getUser = function () {
					// idToken is first call
					if (this._user) {
						return this._user;
					}
					// frame is used to get idToken
					var rawIdToken = this._cacheStorage.getItem(Constants_1.Constants.idTokenKey);
					var rawClientInfo = this._cacheStorage.getItem(Constants_1.Constants.msalClientInfo);
					if (!Utils_1.Utils.isEmpty(rawIdToken) && !Utils_1.Utils.isEmpty(rawClientInfo)) {
						var idToken = new IdToken_1.IdToken(rawIdToken);
						var clientInfo = new ClientInfo_1.ClientInfo(rawClientInfo);
						this._user = User_1.User.createUser(idToken, clientInfo, this.authority);
						return this._user;
					}
					return null;
				};
				/*
				 * This method must be called for processing the response received from the STS. It extracts the hash, processes the token or error information and saves it in the cache. It then
				 * calls the registered callbacks in case of redirect or resolves the promises with the result.
				 * @param {string} [hash=window.location.hash] - Hash fragment of Url.
				 * @hidden
				 */
				UserAgentApplication.prototype.handleAuthenticationResponse = function (hash) {
					if (hash == null) {
						hash = window.location.hash;
					}
					var self = null;
					var isPopup = false;
					var isWindowOpenerMsal = false;
					try {
						isWindowOpenerMsal = window.opener && window.opener.msal && window.opener.msal !== window.msal;
					}
					catch (err) {
						// err = SecurityError: Blocked a frame with origin "[url]" from accessing a cross-origin frame.
						isWindowOpenerMsal = false;
					}
					if (isWindowOpenerMsal) {
						self = window.opener.msal;
						isPopup = true;
					}
					else if (window.parent && window.parent.msal) {
						self = window.parent.msal;
					}
					var requestInfo = self.getRequestInfo(hash); //if(window.parent!==window), by using self, window.parent becomes equal to window in getRequestInfo method specifically
					var token = null, tokenReceivedCallback = null, tokenType, saveToken = true;
					self._logger.info("Returned from redirect url");
					delete window.opener;
					if (window.parent !== window && window.parent.msal) {
						tokenReceivedCallback = window.parent.callBackMappedToRenewStates[requestInfo.stateResponse];
					}
					else if (window.opener && window.opener.msal) {
						tokenReceivedCallback = window.opener.callBackMappedToRenewStates[requestInfo.stateResponse];
					}
					else {
						if (self._navigateToLoginRequestUrl) {
							tokenReceivedCallback = null;
							self._cacheStorage.setItem(Constants_1.Constants.urlHash, hash);
							saveToken = false;
							if (window.parent === window && !isPopup) {
								if (!window.opener) {
									window.location.href = '/';
								} else {
									window.location.href = self._cacheStorage.getItem(Constants_1.Constants.loginRequest);
								}
							}
							return;
						}
						else {
							tokenReceivedCallback = self._tokenReceivedCallback;
							window.location.hash = '';
						}
					}
					self.saveTokenFromHash(requestInfo);
					if ((requestInfo.requestType === Constants_1.Constants.renewToken) && window.parent) {
						if (window.parent !== window) {
							self._logger.verbose("Window is in iframe, acquiring token silently");
						}
						else {
							self._logger.verbose("acquiring token interactive in progress");
						}
						token = requestInfo.parameters[Constants_1.Constants.accessToken] || requestInfo.parameters[Constants_1.Constants.idToken];
						tokenType = Constants_1.Constants.accessToken;
					}
					else if (requestInfo.requestType === Constants_1.Constants.login) {
						token = requestInfo.parameters[Constants_1.Constants.idToken];
						tokenType = Constants_1.Constants.idToken;
					}
					var errorDesc = requestInfo.parameters[Constants_1.Constants.errorDescription];
					var error = requestInfo.parameters[Constants_1.Constants.error];
					try {
						if (tokenReceivedCallback) {
							tokenReceivedCallback.call(self, errorDesc, token, error, tokenType);
						}
					}
					catch (err) {
						self._logger.error("Error occurred in token received callback function: " + err);
					}
					if (isWindowOpenerMsal) {
						for (var i = 0; i < window.opener.openedWindows.length; i++) {
							window.opener.openedWindows[i].close();
						}
					}
				};
				/*
				 * This method must be called for processing the response received from AAD. It extracts the hash, processes the token or error, saves it in the cache and calls the registered callbacks with the result.
				 * @param {string} authority authority received in the redirect response from AAD.
				 * @param {TokenResponse} requestInfo an object created from the redirect response from AAD comprising of the keys - parameters, requestType, stateMatch, stateResponse and valid.
				 * @param {User} user user object for which scopes are consented for. The default user is the logged in user.
				 * @param {ClientInfo} clientInfo clientInfo received as part of the response comprising of fields uid and utid.
				 * @param {IdToken} idToken idToken received as part of the response.
				 * @ignore
				 * @private
				 * @hidden
				 */
				UserAgentApplication.prototype.saveAccessToken = function (authority, tokenResponse, user, clientInfo, idToken) {
					var scope;
					var clientObj = new ClientInfo_1.ClientInfo(clientInfo);
					if (tokenResponse.parameters.hasOwnProperty("scope")) {
						scope = tokenResponse.parameters["scope"];
						var consentedScopes = scope.split(" ");
						var accessTokenCacheItems = this._cacheStorage.getAllAccessTokens(this.clientId, authority);
						for (var i = 0; i < accessTokenCacheItems.length; i++) {
							var accessTokenCacheItem = accessTokenCacheItems[i];
							if (accessTokenCacheItem.key.userIdentifier === user.userIdentifier) {
								var cachedScopes = accessTokenCacheItem.key.scopes.split(" ");
								if (Utils_1.Utils.isIntersectingScopes(cachedScopes, consentedScopes)) {
									this._cacheStorage.removeItem(JSON.stringify(accessTokenCacheItem.key));
								}
							}
						}
						var accessTokenKey = new AccessTokenKey_1.AccessTokenKey(authority, this.clientId, scope, clientObj.uid, clientObj.utid);
						var accessTokenValue = new AccessTokenValue_1.AccessTokenValue(tokenResponse.parameters[Constants_1.Constants.accessToken], idToken.rawIdToken, Utils_1.Utils.expiresIn(tokenResponse.parameters[Constants_1.Constants.expiresIn]).toString(), clientInfo);
						this._cacheStorage.setItem(JSON.stringify(accessTokenKey), JSON.stringify(accessTokenValue));
					}
					else {
						scope = this.clientId;
						var accessTokenKey = new AccessTokenKey_1.AccessTokenKey(authority, this.clientId, scope, clientObj.uid, clientObj.utid);
						var accessTokenValue = new AccessTokenValue_1.AccessTokenValue(tokenResponse.parameters[Constants_1.Constants.idToken], tokenResponse.parameters[Constants_1.Constants.idToken], idToken.expiration, clientInfo);
						this._cacheStorage.setItem(JSON.stringify(accessTokenKey), JSON.stringify(accessTokenValue));
					}
				};
				/*
				 * Saves token or error received in the response from AAD in the cache. In case of id_token, it also creates the user object.
				 * @ignore
				 * @hidden
				 */
				UserAgentApplication.prototype.saveTokenFromHash = function (tokenResponse) {
					this._logger.info("State status:" + tokenResponse.stateMatch + "; Request type:" + tokenResponse.requestType);
					this._cacheStorage.setItem(Constants_1.Constants.msalError, "");
					this._cacheStorage.setItem(Constants_1.Constants.msalErrorDescription, "");
					var scope = "";
					var authorityKey = "";
					var acquireTokenUserKey = "";
					if (tokenResponse.parameters.hasOwnProperty("scope")) {
						scope = tokenResponse.parameters["scope"].toLowerCase();
					}
					else {
						scope = this.clientId;
					}
					// Record error
					if (tokenResponse.parameters.hasOwnProperty(Constants_1.Constants.errorDescription) || tokenResponse.parameters.hasOwnProperty(Constants_1.Constants.error)) {
						this._logger.infoPii("Error :" + tokenResponse.parameters[Constants_1.Constants.error] + "; Error description:" + tokenResponse.parameters[Constants_1.Constants.errorDescription]);
						this._cacheStorage.setItem(Constants_1.Constants.msalError, tokenResponse.parameters["error"]);
						this._cacheStorage.setItem(Constants_1.Constants.msalErrorDescription, tokenResponse.parameters[Constants_1.Constants.errorDescription]);
						if (tokenResponse.requestType === Constants_1.Constants.login) {
							this._loginInProgress = false;
							this._cacheStorage.setItem(Constants_1.Constants.loginError, tokenResponse.parameters[Constants_1.Constants.errorDescription] + ":" + tokenResponse.parameters[Constants_1.Constants.error]);
							authorityKey = Constants_1.Constants.authority + Constants_1.Constants.resourceDelimeter + tokenResponse.stateResponse;
						}
						if (tokenResponse.requestType === Constants_1.Constants.renewToken) {
							this._acquireTokenInProgress = false;
							authorityKey = Constants_1.Constants.authority + Constants_1.Constants.resourceDelimeter + tokenResponse.stateResponse;
							var userKey = this.getUser() !== null ? this.getUser().userIdentifier : "";
							acquireTokenUserKey = Constants_1.Constants.acquireTokenUser + Constants_1.Constants.resourceDelimeter + userKey + Constants_1.Constants.resourceDelimeter + tokenResponse.stateResponse;
						}
					}
					else {
						// It must verify the state from redirect
						if (tokenResponse.stateMatch) {
							// record tokens to storage if exists
							this._logger.info("State is right");
							if (tokenResponse.parameters.hasOwnProperty(Constants_1.Constants.sessionState)) {
								this._cacheStorage.setItem(Constants_1.Constants.msalSessionState, tokenResponse.parameters[Constants_1.Constants.sessionState]);
							}
							var idToken;
							var clientInfo = "";
							if (tokenResponse.parameters.hasOwnProperty(Constants_1.Constants.accessToken)) {
								this._logger.info("Fragment has access token");
								this._acquireTokenInProgress = false;
								var user = void 0;
								if (tokenResponse.parameters.hasOwnProperty(Constants_1.Constants.idToken)) {
									idToken = new IdToken_1.IdToken(tokenResponse.parameters[Constants_1.Constants.idToken]);
								}
								else {
									idToken = new IdToken_1.IdToken(this._cacheStorage.getItem(Constants_1.Constants.idTokenKey));
								}
								authorityKey = Constants_1.Constants.authority + Constants_1.Constants.resourceDelimeter + tokenResponse.stateResponse;
								var authority = void 0;
								if (!Utils_1.Utils.isEmpty(this._cacheStorage.getItem(authorityKey))) {
									authority = this._cacheStorage.getItem(authorityKey);
									authority = Utils_1.Utils.replaceFirstPath(authority, idToken.tenantId);
								}
								if (tokenResponse.parameters.hasOwnProperty(Constants_1.Constants.clientInfo)) {
									clientInfo = tokenResponse.parameters[Constants_1.Constants.clientInfo];
									user = User_1.User.createUser(idToken, new ClientInfo_1.ClientInfo(clientInfo), authority);
								}
								else {
									this._logger.warning("ClientInfo not received in the response from AAD");
									user = User_1.User.createUser(idToken, new ClientInfo_1.ClientInfo(clientInfo), authority);
								}
								acquireTokenUserKey = Constants_1.Constants.acquireTokenUser + Constants_1.Constants.resourceDelimeter + user.userIdentifier + Constants_1.Constants.resourceDelimeter + tokenResponse.stateResponse;
								var acquireTokenUser = void 0;
								if (!Utils_1.Utils.isEmpty(this._cacheStorage.getItem(acquireTokenUserKey))) {
									acquireTokenUser = JSON.parse(this._cacheStorage.getItem(acquireTokenUserKey));
									if (user && acquireTokenUser && Utils_1.Utils.compareObjects(user, acquireTokenUser)) {
										this.saveAccessToken(authority, tokenResponse, user, clientInfo, idToken);
										this._logger.info("The user object received in the response is the same as the one passed in the acquireToken request");
									}
									else {
										this._logger.warning("The user object created from the response is not the same as the one passed in the acquireToken request");
									}
								}
							}
							if (tokenResponse.parameters.hasOwnProperty(Constants_1.Constants.idToken)) {
								if (scope.indexOf(this.clientId) > -1) {
									this._logger.info("Fragment has id token");
									this._loginInProgress = false;
									idToken = new IdToken_1.IdToken(tokenResponse.parameters[Constants_1.Constants.idToken]);
									if (tokenResponse.parameters.hasOwnProperty(Constants_1.Constants.clientInfo)) {
										clientInfo = tokenResponse.parameters[Constants_1.Constants.clientInfo];
									}
									else {
										this._logger.warning("ClientInfo not received in the response from AAD");
									}
									authorityKey = Constants_1.Constants.authority + Constants_1.Constants.resourceDelimeter + tokenResponse.stateResponse;
									var authority = void 0;
									if (!Utils_1.Utils.isEmpty(this._cacheStorage.getItem(authorityKey))) {
										authority = this._cacheStorage.getItem(authorityKey);
										authority = Utils_1.Utils.replaceFirstPath(authority, idToken.tenantId);
									}
									this._user = User_1.User.createUser(idToken, new ClientInfo_1.ClientInfo(clientInfo), authority);
									if (idToken && idToken.nonce) {
										if (idToken.nonce !== this._cacheStorage.getItem(Constants_1.Constants.nonceIdToken)) {
											this._user = null;
											this._cacheStorage.setItem(Constants_1.Constants.loginError, "Nonce Mismatch. Expected Nonce: " + this._cacheStorage.getItem(Constants_1.Constants.nonceIdToken) + "," + "Actual Nonce: " + idToken.nonce);
											this._logger.error("Nonce Mismatch.Expected Nonce: " + this._cacheStorage.getItem(Constants_1.Constants.nonceIdToken) + "," + "Actual Nonce: " + idToken.nonce);
										}
										else {
											this._cacheStorage.setItem(Constants_1.Constants.idTokenKey, tokenResponse.parameters[Constants_1.Constants.idToken]);
											this._cacheStorage.setItem(Constants_1.Constants.msalClientInfo, clientInfo);
											// Save idToken as access token for app itself
											this.saveAccessToken(authority, tokenResponse, this._user, clientInfo, idToken);
										}
									}
									else {
										this._logger.error("Invalid id_token received in the response");
										this._cacheStorage.setItem(Constants_1.Constants.msalError, "invalid idToken");
										this._cacheStorage.setItem(Constants_1.Constants.msalErrorDescription, "Invalid idToken. idToken: " + tokenResponse.parameters[Constants_1.Constants.idToken]);
									}
								}
							}
						}
						else {
							this._logger.error("State Mismatch.Expected State: " + this._cacheStorage.getItem(Constants_1.Constants.stateLogin) + "," + "Actual State: " + tokenResponse.stateResponse);
							this._cacheStorage.setItem(Constants_1.Constants.msalError, "Invalid_state");
							this._cacheStorage.setItem(Constants_1.Constants.msalErrorDescription, "Invalid_state. state: " + tokenResponse.stateResponse);
						}
					}
					this._cacheStorage.setItem(Constants_1.Constants.renewStatus + tokenResponse.stateResponse, Constants_1.Constants.tokenRenewStatusCompleted);
					this._cacheStorage.removeAcquireTokenEntries(authorityKey, acquireTokenUserKey);
				};
				/*
				 * Checks if the redirect response is received from the STS. In case of redirect, the url fragment has either id_token, access_token or error.
				 * @param {string} hash - Hash passed from redirect page.
				 * @returns {Boolean} - true if response contains id_token, access_token or error, false otherwise.
				 * @hidden
				 */
				UserAgentApplication.prototype.isCallback = function (hash) {
					hash = this.getHash(hash);
					var parameters = Utils_1.Utils.deserialize(hash);
					return (parameters.hasOwnProperty(Constants_1.Constants.errorDescription) ||
						parameters.hasOwnProperty(Constants_1.Constants.error) ||
						parameters.hasOwnProperty(Constants_1.Constants.accessToken) ||
						parameters.hasOwnProperty(Constants_1.Constants.idToken));
				};
				/*
				 * Returns the anchor part(#) of the URL
				 * @ignore
				 * @hidden
				 */
				UserAgentApplication.prototype.getHash = function (hash) {
					if (hash.indexOf("#/") > -1) {
						hash = hash.substring(hash.indexOf("#/") + 2);
					}
					else if (hash.indexOf("#") > -1) {
						hash = hash.substring(1);
					}
					return hash;
				};
				/*
				  * Creates a requestInfo object from the URL fragment and returns it.
				  * @param {string} hash  -  Hash passed from redirect page
				  * @returns {TokenResponse} an object created from the redirect response from AAD comprising of the keys - parameters, requestType, stateMatch, stateResponse and valid.
				  * @ignore
				  * @hidden
				  */
				UserAgentApplication.prototype.getRequestInfo = function (hash) {
					hash = this.getHash(hash);
					var parameters = Utils_1.Utils.deserialize(hash);
					var tokenResponse = new RequestInfo_1.TokenResponse();
					if (parameters) {
						tokenResponse.parameters = parameters;
						if (parameters.hasOwnProperty(Constants_1.Constants.errorDescription) ||
							parameters.hasOwnProperty(Constants_1.Constants.error) ||
							parameters.hasOwnProperty(Constants_1.Constants.accessToken) ||
							parameters.hasOwnProperty(Constants_1.Constants.idToken)) {
							tokenResponse.valid = true;
							// which call
							var stateResponse = void 0;
							if (parameters.hasOwnProperty("state")) {
								stateResponse = parameters.state;
							}
							else {
								return tokenResponse;
							}
							tokenResponse.stateResponse = stateResponse;
							// async calls can fire iframe and login request at the same time if developer does not use the API as expected
							// incoming callback needs to be looked up to find the request type
							if (stateResponse === this._cacheStorage.getItem(Constants_1.Constants.stateLogin)) { // loginRedirect
								tokenResponse.requestType = Constants_1.Constants.login;
								tokenResponse.stateMatch = true;
								return tokenResponse;
							}
							else if (stateResponse === this._cacheStorage.getItem(Constants_1.Constants.stateAcquireToken)) { //acquireTokenRedirect
								tokenResponse.requestType = Constants_1.Constants.renewToken;
								tokenResponse.stateMatch = true;
								return tokenResponse;
							}
							// external api requests may have many renewtoken requests for different resource
							if (!tokenResponse.stateMatch) {
								tokenResponse.requestType = window.requestType;
								var statesInParentContext = window.renewStates;
								for (var i = 0; i < statesInParentContext.length; i++) {
									if (statesInParentContext[i] === tokenResponse.stateResponse) {
										tokenResponse.stateMatch = true;
										break;
									}
								}
							}
						}
					}
					return tokenResponse;
				};
				/*
				  * Extracts scope value from the state sent with the authentication request.
				  * @returns {string} scope.
				  * @ignore
				  * @hidden
				  */
				UserAgentApplication.prototype.getScopeFromState = function (state) {
					if (state) {
						var splitIndex = state.indexOf("|");
						if (splitIndex > -1 && splitIndex + 1 < state.length) {
							return state.substring(splitIndex + 1);
						}
					}
					return "";
				};
				/*
				  * Returns whether current window is in ifram for token renewal
				  * @ignore
				  * @hidden
				  */
				UserAgentApplication.prototype.isInIframe = function () {
					return window.parent !== window;
				};
				UserAgentApplication.prototype.loginInProgress = function () {
					var pendingCallback = this._cacheStorage.getItem(Constants_1.Constants.urlHash);
					if (pendingCallback)
						return true;
					return this._loginInProgress;
				};
				UserAgentApplication.prototype.getHostFromUri = function (uri) {
					// remove http:// or https:// from uri
					var extractedUri = String(uri).replace(/^(https?:)\/\//, '');
					extractedUri = extractedUri.split('/')[0];
					return extractedUri;
				};
				UserAgentApplication.prototype.getScopesForEndpoint = function (endpoint) {
					// if user specified list of anonymous endpoints, no need to send token to these endpoints, return null.
					if (this._anonymousEndpoints.length > 0) {
						for (var i = 0; i < this._anonymousEndpoints.length; i++) {
							if (endpoint.indexOf(this._anonymousEndpoints[i]) > -1) {
								return null;
							}
						}
					}
					if (this._endpoints.size > 0) {
						for (var _i = 0, _a = Array.from(this._endpoints.keys()); _i < _a.length; _i++) {
							var key = _a[_i];
							// configEndpoint is like /api/Todo requested endpoint can be /api/Todo/1
							if (endpoint.indexOf(key) > -1) {
								return this._endpoints.get(key);
							}
						}
					}
					// default resource will be clientid if nothing specified
					// App will use idtoken for calls to itself
					// check if it's staring from http or https, needs to match with app host
					if (endpoint.indexOf('http://') > -1 || endpoint.indexOf('https://') > -1) {
						if (this.getHostFromUri(endpoint) === this.getHostFromUri(this._redirectUri)) {
							return new Array(this.clientId);
						}
					}
					else {
						// in angular level, the url for $http interceptor call could be relative url,
						// if it's relative call, we'll treat it as app backend call.            
						return new Array(this.clientId);
					}
					// if not the app's own backend or not a domain listed in the endpoints structure
					return null;
				};
				//These APIS are exposed for msalAngular wrapper only
				UserAgentApplication.prototype.setloginInProgress = function (loginInProgress) {
					this._loginInProgress = loginInProgress;
				};
				UserAgentApplication.prototype.getAcquireTokenInProgress = function () {
					return this._acquireTokenInProgress;
				};
				UserAgentApplication.prototype.setAcquireTokenInProgress = function (acquireTokenInProgress) {
					this._acquireTokenInProgress = acquireTokenInProgress;
				};
				UserAgentApplication.prototype.getLogger = function () {
					return this._logger;
				};
				tslib_1.__decorate([
					resolveTokenOnlyIfOutOfIframe
				], UserAgentApplication.prototype, "acquireTokenSilent", null);
				return UserAgentApplication;
			}());
			exports.UserAgentApplication = UserAgentApplication;


			/***/
		}),
/* 13 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/*
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the "Software"), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			var Utils_1 = __webpack_require__(0);
			/*
			 * @hidden
			 */
			var AccessTokenKey = /** @class */ (function () {
				function AccessTokenKey(authority, clientId, scopes, uid, utid) {
					this.authority = authority;
					this.clientId = clientId;
					this.scopes = scopes;
					this.userIdentifier = Utils_1.Utils.base64EncodeStringUrlSafe(uid) + "." + Utils_1.Utils.base64EncodeStringUrlSafe(utid);
				}
				return AccessTokenKey;
			}());
			exports.AccessTokenKey = AccessTokenKey;


			/***/
		}),
/* 14 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			/*
			 * @hidden
			 */
			var AccessTokenValue = /** @class */ (function () {
				function AccessTokenValue(accessToken, idToken, expiresIn, clientInfo) {
					this.accessToken = accessToken;
					this.idToken = idToken;
					this.expiresIn = expiresIn;
					this.clientInfo = clientInfo;
				}
				return AccessTokenValue;
			}());
			exports.AccessTokenValue = AccessTokenValue;


			/***/
		}),
/* 15 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			var Utils_1 = __webpack_require__(0);
			/*
			 * @hidden
			 */
			var AuthenticationRequestParameters = /** @class */ (function () {
				function AuthenticationRequestParameters(authority, clientId, scope, responseType, redirectUri) {
					this.authorityInstance = authority;
					this.clientId = clientId;
					this.scopes = scope;
					this.responseType = responseType;
					this.redirectUri = redirectUri;
					// randomly generated values
					this.correlationId = Utils_1.Utils.createNewGuid();
					this.state = Utils_1.Utils.createNewGuid();
					this.nonce = Utils_1.Utils.createNewGuid();
					// telemetry information
					this.xClientSku = "MSAL.JS";
					this.xClientVer = Utils_1.Utils.getLibraryVersion();
				}
				Object.defineProperty(AuthenticationRequestParameters.prototype, "authority", {
					get: function () {
						return this.authorityInstance.CanonicalAuthority;
					},
					enumerable: true,
					configurable: true
				});
				AuthenticationRequestParameters.prototype.createNavigateUrl = function (scopes) {
					if (!scopes) {
						scopes = [this.clientId];
					}
					if (scopes.indexOf(this.clientId) === -1) {
						scopes.push(this.clientId);
					}
					var str = [];
					str.push("response_type=" + this.responseType);
					this.translateclientIdUsedInScope(scopes);
					str.push("scope=" + encodeURIComponent(this.parseScope(scopes)));
					str.push("client_id=" + encodeURIComponent(this.clientId));
					str.push("redirect_uri=" + encodeURIComponent(this.redirectUri));
					str.push("state=" + encodeURIComponent(this.state));
					str.push("nonce=" + encodeURIComponent(this.nonce));
					str.push("client_info=1");
					str.push("x-client-SKU=" + this.xClientSku);
					str.push("x-client-Ver=" + this.xClientVer);
					if (this.extraQueryParameters) {
						str.push(this.extraQueryParameters);
					}
					str.push("client-request-id=" + encodeURIComponent(this.correlationId));
					var authEndpoint = this.authorityInstance.AuthorizationEndpoint;
					// if the endpoint already has queryparams, lets add to it, otherwise add the first one
					if (authEndpoint.indexOf("?") < 0) {
						authEndpoint += "?";
					}
					else {
						authEndpoint += "&";
					}
					var requestUrl = "" + authEndpoint + str.join("&");
					return requestUrl;
				};
				AuthenticationRequestParameters.prototype.translateclientIdUsedInScope = function (scopes) {
					var clientIdIndex = scopes.indexOf(this.clientId);
					if (clientIdIndex >= 0) {
						scopes.splice(clientIdIndex, 1);
						if (scopes.indexOf("openid") === -1) {
							scopes.push("openid");
						}
						if (scopes.indexOf("profile") === -1) {
							scopes.push("profile");
						}
					}
				};
				AuthenticationRequestParameters.prototype.parseScope = function (scopes) {
					var scopeList = "";
					if (scopes) {
						for (var i = 0; i < scopes.length; ++i) {
							scopeList += (i !== scopes.length - 1) ? scopes[i] + " " : scopes[i];
						}
					}
					return scopeList;
				};
				return AuthenticationRequestParameters;
			}());
			exports.AuthenticationRequestParameters = AuthenticationRequestParameters;


			/***/
		}),
/* 16 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			var Utils_1 = __webpack_require__(0);
			/*
			 * @hidden
			 */
			var ClientInfo = /** @class */ (function () {
				function ClientInfo(rawClientInfo) {
					if (!rawClientInfo || Utils_1.Utils.isEmpty(rawClientInfo)) {
						this.uid = "";
						this.utid = "";
						return;
					}
					try {
						var decodedClientInfo = Utils_1.Utils.base64DecodeStringUrlSafe(rawClientInfo);
						var clientInfo = JSON.parse(decodedClientInfo);
						if (clientInfo) {
							if (clientInfo.hasOwnProperty("uid")) {
								this.uid = clientInfo.uid;
							}
							if (clientInfo.hasOwnProperty("utid")) {
								this.utid = clientInfo.utid;
							}
						}
					}
					catch (e) {
						throw new Error(e);
					}
				}
				Object.defineProperty(ClientInfo.prototype, "uid", {
					get: function () {
						return this._uid ? this._uid : "";
					},
					set: function (uid) {
						this._uid = uid;
					},
					enumerable: true,
					configurable: true
				});
				Object.defineProperty(ClientInfo.prototype, "utid", {
					get: function () {
						return this._utid ? this._utid : "";
					},
					set: function (utid) {
						this._utid = utid;
					},
					enumerable: true,
					configurable: true
				});
				return ClientInfo;
			}());
			exports.ClientInfo = ClientInfo;


			/***/
		}),
/* 17 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/*
			  * Copyright (c) Microsoft Corporation
			  *  All Rights Reserved
			  *  MIT License
			  *
			  * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			  * software and associated documentation files (the "Software"), to deal in the Software
			  * without restriction, including without limitation the rights to use, copy, modify,
			  * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			  * permit persons to whom the Software is furnished to do so, subject to the following
			  * conditions:
			  *
			  * The above copyright notice and this permission notice shall be
			  * included in all copies or substantial portions of the Software.
			  *
			  * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
			  * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			  * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			  * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			  * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			  * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			  */
			Object.defineProperty(exports, "__esModule", { value: true });
			var Utils_1 = __webpack_require__(0);
			/*
			 * @hidden
			 */
			var IdToken = /** @class */ (function () {
				function IdToken(rawIdToken) {
					if (Utils_1.Utils.isEmpty(rawIdToken)) {
						throw new Error("null or empty raw idtoken");
					}
					try {
						this.rawIdToken = rawIdToken;
						this.decodedIdToken = Utils_1.Utils.extractIdToken(rawIdToken);
						if (this.decodedIdToken) {
							if (this.decodedIdToken.hasOwnProperty("iss")) {
								this.issuer = this.decodedIdToken["iss"];
							}
							if (this.decodedIdToken.hasOwnProperty("oid")) {
								this.objectId = this.decodedIdToken['oid'];
							}
							if (this.decodedIdToken.hasOwnProperty("sub")) {
								this.subject = this.decodedIdToken["sub"];
							}
							if (this.decodedIdToken.hasOwnProperty("tid")) {
								this.tenantId = this.decodedIdToken["tid"];
							}
							if (this.decodedIdToken.hasOwnProperty("ver")) {
								this.version = this.decodedIdToken["ver"];
							}
							if (this.decodedIdToken.hasOwnProperty("preferred_username")) {
								this.preferredName = this.decodedIdToken["preferred_username"];
							}
							if (this.decodedIdToken.hasOwnProperty("name")) {
								this.name = this.decodedIdToken["name"];
							}
							if (this.decodedIdToken.hasOwnProperty("nonce")) {
								this.nonce = this.decodedIdToken["nonce"];
							}
							if (this.decodedIdToken.hasOwnProperty("exp")) {
								this.expiration = this.decodedIdToken["exp"];
							}
							if (this.decodedIdToken.hasOwnProperty("home_oid")) {
								this.homeObjectId = this.decodedIdToken["home_oid"];
							}
						}
					}
					catch (e) {
						throw new Error("Failed to parse the returned id token");
					}
				}
				return IdToken;
			}());
			exports.IdToken = IdToken;


			/***/
		}),
/* 18 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			var Constants_1 = __webpack_require__(3);
			var AccessTokenCacheItem_1 = __webpack_require__(19);
			/*
			 * @hidden
			 */
			var Storage = /** @class */ (function () {
				function Storage(cacheLocation) {
					if (Storage._instance) {
						return Storage._instance;
					}
					this._cacheLocation = cacheLocation;
					this._localStorageSupported = typeof window[this._cacheLocation] !== "undefined" && window[this._cacheLocation] != null;
					this._sessionStorageSupported = typeof window[cacheLocation] !== "undefined" && window[cacheLocation] != null;
					Storage._instance = this;
					if (!this._localStorageSupported && !this._sessionStorageSupported) {
						throw new Error("localStorage and sessionStorage not supported");
					}
					return Storage._instance;
				}
				// add value to storage
				Storage.prototype.setItem = function (key, value) {
					if (window[this._cacheLocation]) {
						window[this._cacheLocation].setItem(key, value);
					}
					else {
						throw new Error("localStorage and sessionStorage are not supported");
					}
				};
				// get one item by key from storage
				Storage.prototype.getItem = function (key) {
					if (window[this._cacheLocation]) {
						return window[this._cacheLocation].getItem(key);
					}
					else {
						throw new Error("localStorage and sessionStorage are not supported");
					}
				};
				// remove value from storage
				Storage.prototype.removeItem = function (key) {
					if (window[this._cacheLocation]) {
						return window[this._cacheLocation].removeItem(key);
					}
					else {
						throw new Error("localStorage and sessionStorage are not supported");
					}
				};
				// clear storage (remove all items from it)
				Storage.prototype.clear = function () {
					if (window[this._cacheLocation]) {
						return window[this._cacheLocation].clear();
					}
					else {
						throw new Error("localStorage and sessionStorage are not supported");
					}
				};
				Storage.prototype.getAllAccessTokens = function (clientId, userIdentifier) {
					var results = [];
					var accessTokenCacheItem;
					var storage = window[this._cacheLocation];
					if (storage) {
						var key = void 0;
						for (key in storage) {
							if (storage.hasOwnProperty(key)) {
								if (key.match(clientId) && key.match(userIdentifier)) {
									var value = this.getItem(key);
									if (value) {
										accessTokenCacheItem = new AccessTokenCacheItem_1.AccessTokenCacheItem(JSON.parse(key), JSON.parse(value));
										results.push(accessTokenCacheItem);
									}
								}
							}
						}
					}
					else {
						throw new Error("localStorage and sessionStorage are not supported");
					}
					return results;
				};
				Storage.prototype.removeAcquireTokenEntries = function (authorityKey, acquireTokenUserKey) {
					var storage = window[this._cacheLocation];
					if (storage) {
						var key = void 0;
						for (key in storage) {
							if (storage.hasOwnProperty(key)) {
								if ((authorityKey != "" && key.indexOf(authorityKey) > -1) || (acquireTokenUserKey != "" && key.indexOf(acquireTokenUserKey) > -1)) {
									this.removeItem(key);
								}
							}
						}
					}
					else {
						throw new Error("localStorage and sessionStorage are not supported");
					}
				};
				Storage.prototype.resetCacheItems = function () {
					var storage = window[this._cacheLocation];
					if (storage) {
						var key = void 0;
						for (key in storage) {
							if (storage.hasOwnProperty(key) && key.indexOf(Constants_1.Constants.msal) !== -1) {
								this.setItem(key, "");
							}
							if (storage.hasOwnProperty(key) && key.indexOf(Constants_1.Constants.renewStatus) !== -1)
								this.removeItem(key);
						}
					}
					else {
						throw new Error("localStorage and sessionStorage are not supported");
					}
				};
				return Storage;
			}());
			exports.Storage = Storage;


			/***/
		}),
/* 19 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			/*
			 * @hidden
			 */
			var AccessTokenCacheItem = /** @class */ (function () {
				function AccessTokenCacheItem(key, value) {
					this.key = key;
					this.value = value;
				}
				return AccessTokenCacheItem;
			}());
			exports.AccessTokenCacheItem = AccessTokenCacheItem;


			/***/
		}),
/* 20 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			/*
			 * @hidden
			 */
			var Utils_1 = __webpack_require__(0);
			var AadAuthority_1 = __webpack_require__(8);
			var B2cAuthority_1 = __webpack_require__(21);
			var Authority_1 = __webpack_require__(1);
			var ErrorMessage_1 = __webpack_require__(5);
			var AuthorityFactory = /** @class */ (function () {
				function AuthorityFactory() {
				}
				/*
				* Parse the url and determine the type of authority
				*/
				AuthorityFactory.DetectAuthorityFromUrl = function (authorityUrl) {
					authorityUrl = Utils_1.Utils.CanonicalizeUri(authorityUrl);
					var components = Utils_1.Utils.GetUrlComponents(authorityUrl);
					var pathSegments = components.PathSegments;
					switch (pathSegments[0]) {
						case "tfp":
							return Authority_1.AuthorityType.B2C;
						case "adfs":
							return Authority_1.AuthorityType.Adfs;
						default:
							return Authority_1.AuthorityType.Aad;
					}
				};
				/*
				* Create an authority object of the correct type based on the url
				* Performs basic authority validation - checks to see if the authority is of a valid type (eg aad, b2c)
				*/
				AuthorityFactory.CreateInstance = function (authorityUrl, validateAuthority) {
					var type = AuthorityFactory.DetectAuthorityFromUrl(authorityUrl);
					// Depending on above detection, create the right type.
					switch (type) {
						case Authority_1.AuthorityType.B2C:
							return new B2cAuthority_1.B2cAuthority(authorityUrl, validateAuthority);
						case Authority_1.AuthorityType.Aad:
							return new AadAuthority_1.AadAuthority(authorityUrl, validateAuthority);
						default:
							throw ErrorMessage_1.ErrorMessage.invalidAuthorityType;
					}
				};
				return AuthorityFactory;
			}());
			exports.AuthorityFactory = AuthorityFactory;


			/***/
		}),
/* 21 */
/***/ (function (module, exports, __webpack_require__) {

			"use strict";

			/**
			 * Copyright (c) Microsoft Corporation
			 *  All Rights Reserved
			 *  MIT License
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
			 * software and associated documentation files (the 'Software'), to deal in the Software
			 * without restriction, including without limitation the rights to use, copy, modify,
			 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to the following
			 * conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
			 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
			 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
			 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT
			 * OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 */
			Object.defineProperty(exports, "__esModule", { value: true });
			var tslib_1 = __webpack_require__(2);
			var AadAuthority_1 = __webpack_require__(8);
			var Authority_1 = __webpack_require__(1);
			var ErrorMessage_1 = __webpack_require__(5);
			var Utils_1 = __webpack_require__(0);
			/*
			 * @hidden
			 */
			var B2cAuthority = /** @class */ (function (_super) {
				tslib_1.__extends(B2cAuthority, _super);
				function B2cAuthority(authority, validateAuthority) {
					var _this = _super.call(this, authority, validateAuthority) || this;
					var urlComponents = Utils_1.Utils.GetUrlComponents(authority);
					var pathSegments = urlComponents.PathSegments;
					if (pathSegments.length < 3) {
						throw ErrorMessage_1.ErrorMessage.b2cAuthorityUriInvalidPath;
					}
					_this.CanonicalAuthority = "https://" + urlComponents.HostNameAndPort + "/" + pathSegments[0] + "/" + pathSegments[1] + "/" + pathSegments[2] + "/";
					return _this;
				}
				Object.defineProperty(B2cAuthority.prototype, "AuthorityType", {
					get: function () {
						return Authority_1.AuthorityType.B2C;
					},
					enumerable: true,
					configurable: true
				});
				/*
				 * Returns a promise with the TenantDiscoveryEndpoint
				 */
				B2cAuthority.prototype.GetOpenIdConfigurationEndpointAsync = function () {
					var _this = this;
					var resultPromise = new Promise(function (resolve, reject) {
						return resolve(_this.DefaultOpenIdConfigurationEndpoint);
					});
					if (!this.IsValidationEnabled) {
						return resultPromise;
					}
					if (this.IsInTrustedHostList(this.CanonicalAuthorityUrlComponents.HostNameAndPort)) {
						return resultPromise;
					}
					return new Promise(function (resolve, reject) {
						return reject(ErrorMessage_1.ErrorMessage.unsupportedAuthorityValidation);
					});
				};
				return B2cAuthority;
			}(AadAuthority_1.AadAuthority));
			exports.B2cAuthority = B2cAuthority;


			/***/
		})
/******/]);
});


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var apiUrl = "https://www.insuredbymosaic.ca/api";
var pickListAPI = {
    getCurrentUserData: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/users/current")
            .then(function (response) { return response.data; });
    },
    linkUserAndAuthRecords: function (userId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/users/" + userId + "/linktob2c", {});
    }
};
/* harmony default export */ __webpack_exports__["a"] = (pickListAPI);


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavItem__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavFlyout__ = __webpack_require__(386);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var AdminNavBar = function (props) {
    var allAllowedRoles = ["Admin" /* Administrator */, "Agent" /* Agent */, "Adjudicator" /* Adjudicator */];
    var adminAgentAuthProps = {
        rolesRequired: ["Admin" /* Administrator */, "Agent" /* Agent */],
        currentRoles: props.currentRoles
    };
    var adjudicatorAuthProps = {
        rolesRequired: ["Admin" /* Administrator */, "Adjudicator" /* Adjudicator */],
        currentRoles: props.currentRoles
    };
    var isAuthorized = allAllowedRoles.some(function (role) {
        return Array.isArray(props.currentRoles)
            && props.currentRoles.indexOf(role) >= 0;
    });
    return isAuthorized ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "navbar-nav navbar-nav-separator ml-xl-auto" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */], { className: "nav-item-heading d-xl-none" }, "Administration"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */], __assign({ to: "/admin" }, adminAgentAuthProps, { onClick: props.onClick, linkExactActive: true }), "Home"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */], __assign({ to: "/admin/pick-lists" }, adminAgentAuthProps, { onClick: props.onClick }), "PickLists"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */], __assign({ to: "/admin/customers" }, adminAgentAuthProps, { onClick: props.onClick }), "Customers"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */], __assign({ to: "/admin/adjudication" }, adjudicatorAuthProps, { onClick: props.onClick }), "Adjudication"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */], __assign({ to: "/admin/staff" }, adminAgentAuthProps, { onClick: props.onClick }), "Staff"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */], __assign({ to: "/admin/group" }, adminAgentAuthProps, { onClick: props.onClick }), "Groups"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__NavFlyout__["a" /* default */], __assign({ togglerTo: "#", togglerChildren: "Reports", items: [
                { to: '/admin/reports/user-activity', label: 'User activity', onClick: props.onClick },
                { to: '/admin/reports/policies-created', label: 'Policies created', onClick: props.onClick },
                { to: '/admin/reports/policies-unmailed', label: 'Policies not mailed', onClick: props.onClick },
                { to: '/admin/reports/policies-expiring', label: 'Policies expiring', onClick: props.onClick },
                { to: '/admin/reports/failed-payments', label: 'Failed payment', onClick: props.onClick },
                {
                    to: '/admin/reports/missing-beneficiary-forms',
                    label: 'Missing beneficiary forms',
                    onClick: props.onClick
                },
                { to: '/admin/reports/bounced-emails', label: 'Bounced emails', onClick: props.onClick },
                { to: '/admin/reports/financial-export', label: 'Financial export', onClick: props.onClick },
                { to: '/admin/reports/referrals', label: 'Referrals', onClick: props.onClick }
            ] }, adminAgentAuthProps)))) : null;
};
/* harmony default export */ __webpack_exports__["a"] = (AdminNavBar);


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavItem__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var classNames = __webpack_require__(8);


var NavFlyout = /** @class */ (function (_super) {
    __extends(NavFlyout, _super);
    function NavFlyout(props) {
        var _this = _super.call(this, props) || this;
        _this.isAuthorized = !Array.isArray(_this.props.rolesRequired) ||
            _this.props.rolesRequired.length === 0 ||
            _this.props.rolesRequired.some(function (role) {
                return Array.isArray(_this.props.currentRoles)
                    && _this.props.currentRoles.indexOf(role) >= 0;
            });
        _this.onLinkFocus = function (e) {
            var currentEl = e.target;
            if (currentEl && currentEl.dataset.flyout === 'nav-flyout') {
                _this.setState({ isFocused: true });
                _this.handleOpen();
            }
        };
        _this.onLinkBlur = function (e) {
            var relatedEl = e.relatedTarget;
            if (!relatedEl || relatedEl.dataset.flyout !== 'nav-flyout') {
                _this.setState({ isFocused: false });
                _this.handleClose();
            }
        };
        _this.onLinkClick = function (e, callback) {
            _this.handleClose();
            if (callback) {
                callback(e);
            }
        };
        _this.onMouseEnter = function () {
            _this.handleOpen();
        };
        _this.onMouseLeave = function () {
            if (!_this.state.isFocused) {
                _this.handleClose();
            }
        };
        _this.handleOpen = function () {
            _this.setState({ isOpen: true });
        };
        _this.handleClose = function () {
            _this.setState({ isOpen: false });
        };
        _this.state = {
            isOpen: false,
            isFocused: false
        };
        return _this;
    }
    NavFlyout.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, items = _a.items, togglerTo = _a.togglerTo, togglerClassName = _a.togglerClassName, togglerChildren = _a.togglerChildren;
        return this.isAuthorized ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: classNames('nav-item nav-flyout', className, { active: this.state.isOpen }), onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "navbar-nav-separator" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "nav-item" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */], { className: classNames('nav-flyout-toggler nav-link', togglerClassName), to: togglerTo, onFocus: function (e) { return _this.onLinkFocus(e); }, onBlur: function (e) { return _this.onLinkBlur(e); }, "data-flyout": "nav-flyout" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "nav-link-label" }, togglerChildren),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons__["r" /* IconChevronDown */], { className: "nav-flyout-toggler-icon" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "nav-flyout-menu", "aria-expanded": this.state.isOpen },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled" }, items.map(function (item, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__NavItem__["a" /* default */], { className: item.className, to: item.to, onClick: function (e) { return _this.onLinkClick(e, item.onClick); }, onFocus: function (e) { return _this.onLinkFocus(e); }, onBlur: function (e) { return _this.onLinkBlur(e); }, key: index, linkDataFlyout: "nav-flyout", rolesRequired: item.rolesRequired, currentRoles: item.currentRoles }, item.label)); })))))) : null;
    };
    return NavFlyout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (NavFlyout);


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavItem__ = __webpack_require__(57);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var CustomerNavBar = function (props) {
    var currentRoles = props.currentUser.role;
    var customerAuthProps = { rolesRequired: props.rolesRequired, currentRoles: currentRoles };
    var isAuthorized = props.currentUser.isAuthenticated
        && (!Array.isArray(props.rolesRequired)
            || props.rolesRequired.length === 0
            || props.rolesRequired.some(function (role) { return Array.isArray(currentRoles) && currentRoles.indexOf(role) >= 0; }));
    return isAuthorized ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "navbar-nav navbar-nav-separator ml-xl-auto" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */], __assign({ to: "/user" }, customerAuthProps, { onClick: props.onClick, linkExactActive: true }), "Home"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */], __assign({ to: "/user/" + props.currentUser.id + "/policies" }, customerAuthProps, { onClick: props.onClick }), "Your policies"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */], __assign({ to: "/user/" + props.currentUser.id + "/beneficiaries" }, customerAuthProps, { onClick: props.onClick }), "Beneficiaries"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */], __assign({ to: "/user/" + props.currentUser.id + "/profile" }, customerAuthProps, { onClick: props.onClick }), "Contact info"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */], __assign({ to: "/user/" + props.currentUser.id + "/billing" }, customerAuthProps, { onClick: props.onClick }), "Billing"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */], __assign({ to: "/user/" + props.currentUser.id + "/refer" }, customerAuthProps, { onClick: props.onClick }), "Referral"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NavItem__["a" /* default */], __assign({ to: "/claims" }, customerAuthProps, { onClick: props.onClick }), "File a claim"))) : ((null));
};
/* harmony default export */ __webpack_exports__["a"] = (CustomerNavBar);


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_LoginPage__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_ScrollToTop__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_404Page__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_401Page__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_403Page__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_PageFooter__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth_RequireMultiFactorLoginPage__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__quoting_enrollment_DuplicateEmailRedirect__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__landing_HomePage__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__landing_LandingFirstChildPage__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_AboutUsPage__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_FAQPage__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__landing_RunningHomePage__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__landing_HomeownersHomePage__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__quoting_QuotingPage__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__quoting_QuotingDeclined__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__admin_AdminHomePage__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__admin_PickList_PickListTypeListPage__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__admin_PickList_PickListItemListPage__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__admin_PickList_PickListItemPage__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__admin_customers_CustomerListPage__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__admin_customers_CustomerPage__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__admin_customers_ProspectPage__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__admin_staff_StaffListPage__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__admin_staff_StaffPage__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__admin_groups_GroupListPage__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__admin_groups_GroupDetailPage__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__admin_adjudication_AdjudicationListPage__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__admin_customers_CustomerApplicationPaymentPage__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__admin_reports_ReferralsPage__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__admin_reports_FinancialExportPage__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__admin_reports_UserActivityPage__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__admin_reports_FailedPaymentsListPage__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__admin_reports_FailedPaymentDetailsPage__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__admin_reports_MissingBeneficiaryFormsListPage__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__admin_reports_CreatedPoliciesListPage__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__admin_reports_UnmailedPoliciesListPage__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__admin_reports_ExpiringPoliciesListPage__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__admin_reports_BouncedEmailsListPage__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__user_ReferPage__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__user_PoliciesPage__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__policy_PolicyBeneficiaryPage__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__policy_PolicyBeneficiariesDisbursementPage__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__user_BeneficiariesPage__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__user_TransactionsPage__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__user_ProfilePage__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__user_UserHomePage__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__claim_MakeAClaimPage__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_react_router__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__common_ResetPasswordPage__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__common_ReferralLinkPage__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__common_SpousalReferralLinkPage__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__dev_MarkPage__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__common_ContactUsPage__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__common_TermsPage__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__common_PrivacyPolicyPage__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__common_ComplaintsPage__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__quoting_custom_CustomSelectYourPlanPage__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__landing_CampaignUnbouncePage__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__landing_CampaignPage__ = __webpack_require__(611);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var classNames = __webpack_require__(8);




























































var Routes = /** @class */ (function (_super) {
    __extends(Routes, _super);
    function Routes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Routes.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common_ScrollToTop__["a" /* default */], { className: classNames('page-content-wrapper page-flair-column', {
                'logged-in': true // this.props.auth.token.userId
            }), location: this.props.location },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/login", component: __WEBPACK_IMPORTED_MODULE_2__auth_LoginPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/require-multi-factor-login", component: __WEBPACK_IMPORTED_MODULE_8__auth_RequireMultiFactorLoginPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/existing-account-found", component: __WEBPACK_IMPORTED_MODULE_9__quoting_enrollment_DuplicateEmailRedirect__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/fourohthree", component: __WEBPACK_IMPORTED_MODULE_6__common_403Page__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/fourohone", component: __WEBPACK_IMPORTED_MODULE_5__common_401Page__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/", component: __WEBPACK_IMPORTED_MODULE_10__landing_HomePage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/runningroom", component: __WEBPACK_IMPORTED_MODULE_14__landing_RunningHomePage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/homeowners", component: __WEBPACK_IMPORTED_MODULE_15__landing_HomeownersHomePage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/life-insurance-and-your-first-child", component: __WEBPACK_IMPORTED_MODULE_11__landing_LandingFirstChildPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/about-us", component: __WEBPACK_IMPORTED_MODULE_12__common_AboutUsPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/faq", component: __WEBPACK_IMPORTED_MODULE_13__common_FAQPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/contact-us", component: __WEBPACK_IMPORTED_MODULE_55__common_ContactUsPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/terms", component: __WEBPACK_IMPORTED_MODULE_56__common_TermsPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/privacy", component: __WEBPACK_IMPORTED_MODULE_57__common_PrivacyPolicyPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/complaints", component: __WEBPACK_IMPORTED_MODULE_58__common_ComplaintsPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/quote/:workflow/enrollment", component: function (_a) {
                        var params = _a.match.params;
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_50_react_router__["a" /* Redirect */], { to: "/quote/" + params.workflow + "/enrollment/my-pledge" }));
                    } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/quote/:workflow/:page/:enrollmentPage", component: __WEBPACK_IMPORTED_MODULE_16__quoting_QuotingPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/quote/:workflow/:page", component: __WEBPACK_IMPORTED_MODULE_16__quoting_QuotingPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/quote/declined", component: __WEBPACK_IMPORTED_MODULE_17__quoting_QuotingDeclined__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/quote/:workflow", component: __WEBPACK_IMPORTED_MODULE_16__quoting_QuotingPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/campaign", component: __WEBPACK_IMPORTED_MODULE_61__landing_CampaignPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/fourohthree", component: __WEBPACK_IMPORTED_MODULE_6__common_403Page__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/fourohone", component: __WEBPACK_IMPORTED_MODULE_5__common_401Page__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/admin/pick-lists/:pickListTypeId/:pickListItemId", component: __WEBPACK_IMPORTED_MODULE_21__admin_PickList_PickListItemPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/pick-lists/:pickListTypeId", component: __WEBPACK_IMPORTED_MODULE_20__admin_PickList_PickListItemListPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/pick-lists", component: __WEBPACK_IMPORTED_MODULE_19__admin_PickList_PickListTypeListPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/adjudication", component: __WEBPACK_IMPORTED_MODULE_29__admin_adjudication_AdjudicationListPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/admin/customers/:customerId", component: function (_a) {
                        var params = _a.match.params;
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_50_react_router__["a" /* Redirect */], { to: "/admin/customers/" + params.customerId + "/details" }));
                    } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/prospects/:customerId/:tab/:pageId/payment-update", component: __WEBPACK_IMPORTED_MODULE_30__admin_customers_CustomerApplicationPaymentPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/prospects/:customerId/:tab/:pageId", component: __WEBPACK_IMPORTED_MODULE_24__admin_customers_ProspectPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/prospects/:customerId/:tab", component: __WEBPACK_IMPORTED_MODULE_24__admin_customers_ProspectPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/prospects/:customerId", component: __WEBPACK_IMPORTED_MODULE_24__admin_customers_ProspectPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/customers/:customerId/:tab/:pageId", component: __WEBPACK_IMPORTED_MODULE_23__admin_customers_CustomerPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/customers/:customerId/:tab", component: __WEBPACK_IMPORTED_MODULE_23__admin_customers_CustomerPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/customers/:customerId", component: __WEBPACK_IMPORTED_MODULE_23__admin_customers_CustomerPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/customers", component: __WEBPACK_IMPORTED_MODULE_22__admin_customers_CustomerListPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/staff/:userId/:tab", component: __WEBPACK_IMPORTED_MODULE_26__admin_staff_StaffPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/staff/:userId", component: __WEBPACK_IMPORTED_MODULE_26__admin_staff_StaffPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/staff", component: __WEBPACK_IMPORTED_MODULE_25__admin_staff_StaffListPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/group/:groupId", component: __WEBPACK_IMPORTED_MODULE_28__admin_groups_GroupDetailPage__["a" /* default */] }) // todo: delete?
            ,
                " // todo: delete?",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/group", component: __WEBPACK_IMPORTED_MODULE_27__admin_groups_GroupListPage__["a" /* default */] }) // todo: delete?
            ,
                " // todo: delete?",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/reports/user-activity", component: __WEBPACK_IMPORTED_MODULE_33__admin_reports_UserActivityPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/admin/reports/failed-payments/:id", component: __WEBPACK_IMPORTED_MODULE_35__admin_reports_FailedPaymentDetailsPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/reports/failed-payments", component: __WEBPACK_IMPORTED_MODULE_34__admin_reports_FailedPaymentsListPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/reports/missing-beneficiary-forms", component: __WEBPACK_IMPORTED_MODULE_36__admin_reports_MissingBeneficiaryFormsListPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/reports/policies-created", component: __WEBPACK_IMPORTED_MODULE_37__admin_reports_CreatedPoliciesListPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/reports/policies-unmailed", component: __WEBPACK_IMPORTED_MODULE_38__admin_reports_UnmailedPoliciesListPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/reports/policies-expiring", component: __WEBPACK_IMPORTED_MODULE_39__admin_reports_ExpiringPoliciesListPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/reports/bounced-emails", component: __WEBPACK_IMPORTED_MODULE_40__admin_reports_BouncedEmailsListPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/reports/financial-export", component: __WEBPACK_IMPORTED_MODULE_32__admin_reports_FinancialExportPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin/reports/referrals", component: __WEBPACK_IMPORTED_MODULE_31__admin_reports_ReferralsPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/admin", component: __WEBPACK_IMPORTED_MODULE_18__admin_AdminHomePage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/user/:userId/billing", component: function (_a) {
                        var params = _a.match.params;
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_50_react_router__["a" /* Redirect */], { to: "/user/" + params.userId + "/billing/view-bills" }));
                    } }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/user/:userId/billing/:tab/:invoiceNumber", component: __WEBPACK_IMPORTED_MODULE_46__user_TransactionsPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/user/:userId/billing/:tab", component: __WEBPACK_IMPORTED_MODULE_46__user_TransactionsPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/user/:userId/policies", component: __WEBPACK_IMPORTED_MODULE_42__user_PoliciesPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/user/:userId/refer", component: __WEBPACK_IMPORTED_MODULE_41__user_ReferPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/user/:userId/beneficiaries/:beneficiaryId", component: __WEBPACK_IMPORTED_MODULE_43__policy_PolicyBeneficiaryPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/user/:userId/beneficiaries", component: __WEBPACK_IMPORTED_MODULE_45__user_BeneficiariesPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/user/:userId/beneficiaries-disbursement", component: __WEBPACK_IMPORTED_MODULE_44__policy_PolicyBeneficiariesDisbursementPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/user/:userId/profile", component: __WEBPACK_IMPORTED_MODULE_47__user_ProfilePage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/user", component: __WEBPACK_IMPORTED_MODULE_48__user_UserHomePage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { exact: true, path: "/claims", component: __WEBPACK_IMPORTED_MODULE_49__claim_MakeAClaimPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/reset-password", component: __WEBPACK_IMPORTED_MODULE_51__common_ResetPasswordPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/refer/:referralCode", component: __WEBPACK_IMPORTED_MODULE_52__common_ReferralLinkPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/refer-spousal/:spousalReferralCode", component: __WEBPACK_IMPORTED_MODULE_53__common_SpousalReferralLinkPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/unbounce", component: __WEBPACK_IMPORTED_MODULE_60__landing_CampaignUnbouncePage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/dev/mark", component: __WEBPACK_IMPORTED_MODULE_54__dev_MarkPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "/dev/customPlan", component: __WEBPACK_IMPORTED_MODULE_59__quoting_custom_CustomSelectYourPlanPage__["a" /* default */] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { path: "*", component: __WEBPACK_IMPORTED_MODULE_4__common_404Page__["a" /* default */] })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common_PageFooter__["a" /* default */], null)));
    };
    return Routes;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Routes);


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_authActions__ = __webpack_require__(17);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var LoginPage = /** @class */ (function (_super) {
    __extends(LoginPage, _super);
    function LoginPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoginPage.prototype.componentDidMount = function () {
        setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_4__auth_authActions__["a" /* default */].login()({});
        }, 1000);
    };
    LoginPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "navbar-account" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common_index__["b" /* Page */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common_index__["c" /* PageContent */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common_index__["d" /* PageHeader */], { isCentered: true, className: "page-header-sm", title: "Redirecting you to the login pages" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-4 text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common__["f" /* Spinner */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mt-3" }, "One moment, please."))))));
    };
    return LoginPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__authComponents__["c" /* userIsNotAuthenticatedRedir */])(LoginPage));


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectedReduxRedirect = exports.connectedRouterRedirect = undefined;

var _locationHelper = __webpack_require__(142);

var _locationHelper2 = _interopRequireDefault(_locationHelper);

var _redirect = __webpack_require__(399);

var _redirect2 = _interopRequireDefault(_redirect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _redirectUtil = (0, _redirect2.default)({
  locationHelperBuilder: _locationHelper2.default,
  getRouterRedirect: function getRouterRedirect(_ref) {
    var history = _ref.history;
    return history.replace;
  }
});

var connectedRouterRedirect = _redirectUtil.connectedRouterRedirect,
    connectedReduxRedirect = _redirectUtil.connectedReduxRedirect;
exports.connectedRouterRedirect = connectedRouterRedirect;
exports.connectedReduxRedirect = connectedReduxRedirect;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(392);
var util = __webpack_require__(393);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(394);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module), __webpack_require__(26)))

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(395);
exports.encode = exports.stringify = __webpack_require__(396);


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(398);
var objectAssign = __webpack_require__(33);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = __webpack_require__(2);

var _invariant = __webpack_require__(22);

var _invariant2 = _interopRequireDefault(_invariant);

var _authWrapper = __webpack_require__(400);

var _authWrapper2 = _interopRequireDefault(_authWrapper);

var _redirect = __webpack_require__(402);

var _redirect2 = _interopRequireDefault(_redirect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var connectedDefaults = {
  authenticatingSelector: function authenticatingSelector() {
    return false;
  },
  allowRedirectBack: true,
  FailureComponent: _redirect2.default,
  redirectQueryParamName: 'redirect'
};

exports.default = function (_ref) {
  var locationHelperBuilder = _ref.locationHelperBuilder,
      getRouterRedirect = _ref.getRouterRedirect;


  var connectedRouterRedirect = function connectedRouterRedirect(args) {
    var allArgs = _extends({}, connectedDefaults, args);
    var FailureComponent = allArgs.FailureComponent,
        redirectPath = allArgs.redirectPath,
        authenticatedSelector = allArgs.authenticatedSelector,
        authenticatingSelector = allArgs.authenticatingSelector,
        allowRedirectBack = allArgs.allowRedirectBack,
        redirectQueryParamName = allArgs.redirectQueryParamName;

    var _locationHelperBuilde = locationHelperBuilder({
      redirectQueryParamName: redirectQueryParamName
    }),
        createRedirectLoc = _locationHelperBuilde.createRedirectLoc;

    var redirectPathSelector = void 0;
    if (typeof redirectPath === 'string') {
      redirectPathSelector = function redirectPathSelector() {
        return redirectPath;
      };
    } else if (typeof redirectPath === 'function') {
      redirectPathSelector = redirectPath;
    } else {
      (0, _invariant2.default)(false, 'redirectPath must be either a string or a function');
    }

    var allowRedirectBackFn = void 0;
    if (typeof allowRedirectBack === 'boolean') {
      allowRedirectBackFn = function allowRedirectBackFn() {
        return allowRedirectBack;
      };
    } else if (typeof allowRedirectBack === 'function') {
      allowRedirectBackFn = allowRedirectBack;
    } else {
      (0, _invariant2.default)(false, 'allowRedirectBack must be either a boolean or a function');
    }

    var redirect = function redirect(replace) {
      return function (props, path) {
        return replace(createRedirectLoc(allowRedirectBackFn(props, path))(props, path));
      };
    };

    var ConnectedFailureComponent = (0, _reactRedux.connect)(function (state, ownProps) {
      return {
        redirect: redirect(getRouterRedirect(ownProps))
      };
    })(FailureComponent);

    return function (DecoratedComponent) {
      return (0, _reactRedux.connect)(function (state, ownProps) {
        return {
          redirectPath: redirectPathSelector(state, ownProps),
          isAuthenticated: authenticatedSelector(state, ownProps),
          isAuthenticating: authenticatingSelector(state, ownProps)
        };
      })((0, _authWrapper2.default)(_extends({}, allArgs, { FailureComponent: ConnectedFailureComponent }))(DecoratedComponent));
    };
  };

  var connectedReduxRedirect = function connectedReduxRedirect(args) {
    var allArgs = _extends({}, connectedDefaults, args);
    var FailureComponent = allArgs.FailureComponent,
        redirectPath = allArgs.redirectPath,
        authenticatedSelector = allArgs.authenticatedSelector,
        authenticatingSelector = allArgs.authenticatingSelector,
        allowRedirectBack = allArgs.allowRedirectBack,
        redirectAction = allArgs.redirectAction,
        redirectQueryParamName = allArgs.redirectQueryParamName;

    var _locationHelperBuilde2 = locationHelperBuilder({
      redirectQueryParamName: redirectQueryParamName
    }),
        createRedirectLoc = _locationHelperBuilde2.createRedirectLoc;

    var redirectPathSelector = void 0;
    if (typeof redirectPath === 'string') {
      redirectPathSelector = function redirectPathSelector() {
        return redirectPath;
      };
    } else if (typeof redirectPath === 'function') {
      redirectPathSelector = redirectPath;
    } else {
      (0, _invariant2.default)(false, 'redirectPath must be either a string or a function');
    }

    var allowRedirectBackFn = void 0;
    if (typeof allowRedirectBack === 'boolean') {
      allowRedirectBackFn = function allowRedirectBackFn() {
        return allowRedirectBack;
      };
    } else if (typeof allowRedirectBack === 'function') {
      allowRedirectBackFn = allowRedirectBack;
    } else {
      (0, _invariant2.default)(false, 'allowRedirectBack must be either a boolean or a function');
    }

    var createRedirect = function createRedirect(dispatch) {
      return {
        redirect: function redirect(props, path) {
          return dispatch(redirectAction(createRedirectLoc(allowRedirectBackFn(props, path))(props, path)));
        }
      };
    };

    var ConnectedFailureComponent = (0, _reactRedux.connect)(null, createRedirect)(FailureComponent);

    return function (DecoratedComponent) {
      return (0, _reactRedux.connect)(function (state, ownProps) {
        return {
          redirectPath: redirectPathSelector(state, ownProps),
          isAuthenticated: authenticatedSelector(state, ownProps),
          isAuthenticating: authenticatingSelector(state, ownProps)
        };
      })((0, _authWrapper2.default)(_extends({}, allArgs, { FailureComponent: ConnectedFailureComponent }))(DecoratedComponent));
    };
  };

  return {
    connectedRouterRedirect: connectedRouterRedirect,
    connectedReduxRedirect: connectedReduxRedirect
  };
};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(401);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaults = {
  AuthenticatingComponent: function AuthenticatingComponent() {
    return null;
  }, // dont render anything while authenticating
  FailureComponent: function FailureComponent() {
    return null;
  }, // dont render anything on failure of the predicate
  wrapperDisplayName: 'AuthWrapper'
};

exports.default = function (args) {
  var _defaults$args = _extends({}, defaults, args),
      AuthenticatingComponent = _defaults$args.AuthenticatingComponent,
      FailureComponent = _defaults$args.FailureComponent,
      wrapperDisplayName = _defaults$args.wrapperDisplayName;

  // Wraps the component that needs the auth enforcement


  function wrapComponent(DecoratedComponent) {
    var _class, _temp;

    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

    var UserAuthWrapper = (_temp = _class = function (_Component) {
      _inherits(UserAuthWrapper, _Component);

      function UserAuthWrapper() {
        _classCallCheck(this, UserAuthWrapper);

        return _possibleConstructorReturn(this, (UserAuthWrapper.__proto__ || Object.getPrototypeOf(UserAuthWrapper)).apply(this, arguments));
      }

      _createClass(UserAuthWrapper, [{
        key: 'render',
        value: function render() {
          var _props = this.props,
              isAuthenticated = _props.isAuthenticated,
              isAuthenticating = _props.isAuthenticating;

          if (isAuthenticated) {
            return _react2.default.createElement(DecoratedComponent, this.props);
          } else if (isAuthenticating) {
            return _react2.default.createElement(AuthenticatingComponent, this.props);
          } else {
            return _react2.default.createElement(FailureComponent, this.props);
          }
        }
      }]);

      return UserAuthWrapper;
    }(_react.Component), _class.displayName = wrapperDisplayName + '(' + displayName + ')', _class.propTypes = {
      isAuthenticated: _propTypes2.default.bool,
      isAuthenticating: _propTypes2.default.bool
    }, _class.defaultProps = {
      isAuthenticating: false
    }, _temp);


    return (0, _hoistNonReactStatics2.default)(UserAuthWrapper, DecoratedComponent);
  }

  return wrapComponent;
};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Redirect = (_temp = _class = function (_Component) {
  _inherits(Redirect, _Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, (Redirect.__proto__ || Object.getPrototypeOf(Redirect)).apply(this, arguments));
  }

  _createClass(Redirect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.redirect(this.props, this.props.redirectPath);
    }
  }, {
    key: 'render',
    value: function render() {
      // Redirect should happen before this is rendered
      return null;
    }
  }]);

  return Redirect;
}(_react.Component), _class.propTypes = {
  redirectPath: _propTypes2.default.string.isRequired,
  redirect: _propTypes2.default.func.isRequired
}, _temp);
exports.default = Redirect;

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_authActions__ = __webpack_require__(17);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var qs = __webpack_require__(89);
var FourOhOnePage = /** @class */ (function (_super) {
    __extends(FourOhOnePage, _super);
    function FourOhOnePage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FourOhOnePage.prototype.componentWillMount = function () {
        var queryString = this.props.location.search[0] === '?'
            ? this.props.location.search.slice(1)
            : this.props.location.search;
        var parsed = qs.parse(queryString);
        var url = parsed.redirect ? parsed.redirect : '/';
        if (this.props.currentUser.isAuthenticated) {
            this.props.history.push(url);
        }
        else if (url.startsWith('/admin')) {
            this.props.actions.loginAdmin();
        }
        else {
            this.props.actions.login();
        }
    };
    FourOhOnePage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["b" /* Page */], { className: "401 text-center", title: "Unauthenticated" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["d" /* PageHeader */], { isCentered: true },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "display-1 text-secondary" }, "401"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "text-secondary mb-0" }, "Unauthenticated")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mt-4" }, "Redirecting you to the login page."))));
    };
    return FourOhOnePage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        currentUser: state.auth.currentUser
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__auth_authActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(FourOhOnePage));


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(144);
var formats = __webpack_require__(145);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(144);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder);
            val = options.decoder(part.slice(pos + 1), defaults.decoder);
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]') {
            obj = [];
            obj = obj.concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var FourOhThreePage = /** @class */ (function (_super) {
    __extends(FourOhThreePage, _super);
    function FourOhThreePage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FourOhThreePage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["b" /* Page */], { className: "401 text-center", title: "Unauthorized" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["d" /* PageHeader */], { isCentered: true },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "display-1 text-secondary" }, "403"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "text-secondary mb-0" }, "Unauthorized")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mt-4" }, "Sorry, you do not have access to the secret level."))));
    };
    return FourOhThreePage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FourOhThreePage);


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_authActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_Button__ = __webpack_require__(16);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var RequireMultiFactorLoginPage = /** @class */ (function (_super) {
    __extends(RequireMultiFactorLoginPage, _super);
    function RequireMultiFactorLoginPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.redirectToMultiFactorLogin = function () {
            _this.props.actions.loginAdmin();
        };
        return _this;
    }
    RequireMultiFactorLoginPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "navbar-account" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common_index__["b" /* Page */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common_index__["c" /* PageContent */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common_index__["d" /* PageHeader */], { isCentered: true, className: "page-header-sm", title: "Log In Denied" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-4 text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mt-3" },
                            "You tried to login to the customer portal using an administration account.",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                            "Please access the administration site via\u00A0",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_buttons_Button__["a" /* default */], { className: "btn-link btn-link-inline", onClick: this.redirectToMultiFactorLogin },
                                window.location.origin,
                                "/admin"),
                            "\u00A0or click the button below."),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_buttons_Button__["a" /* default */], { className: "btn-primary", onClick: this.redirectToMultiFactorLogin }, "Admin Log In"))))));
    };
    return RequireMultiFactorLoginPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_5__auth_authActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connector = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(null, mapDispatchToProps)(RequireMultiFactorLoginPage);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__authComponents__["c" /* userIsNotAuthenticatedRedir */])(connector));


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_authActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_Button__ = __webpack_require__(16);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var DuplicateEmailRedirect = /** @class */ (function (_super) {
    __extends(DuplicateEmailRedirect, _super);
    function DuplicateEmailRedirect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.redirectToLogin = function () {
            _this.props.actions.login();
        };
        return _this;
    }
    DuplicateEmailRedirect.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "navbar-account" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common_index__["b" /* Page */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common_index__["c" /* PageContent */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common_index__["d" /* PageHeader */], { isCentered: true, className: "page-header-sm", title: "Existing Email Address Found" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-4 text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mt-3" },
                            "That email address is already associated with an account.",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                            "Please login to\u00A0",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_buttons_Button__["a" /* default */], { className: "btn-link btn-link-inline", onClick: this.redirectToLogin }, "your account"),
                            "\u00A0to purchase an additional policy."),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_buttons_Button__["a" /* default */], { className: "btn-primary", onClick: this.redirectToLogin }, "Log In"))))));
    };
    return DuplicateEmailRedirect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_5__auth_authActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connector = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(null, mapDispatchToProps)(DuplicateEmailRedirect);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__auth_authComponents__["c" /* userIsNotAuthenticatedRedir */])(connector));


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_scroll__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_authActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HomePageAssessment__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HomePageAssessmentBottom__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_sections__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_icons__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};













var scorLogoSrc = __webpack_require__(98);
var HomePage = /** @class */ (function (_super) {
    __extends(HomePage, _super);
    function HomePage(props) {
        var _this = _super.call(this, props) || this;
        _this.onAltCtaClick = function () {
            var topOffset = 15;
            var navbar = document.querySelector('.navbar-wrapper.fixed-top');
            if (navbar) {
                topOffset += navbar.clientHeight;
            }
            __WEBPACK_IMPORTED_MODULE_1_react_scroll__["scroller"].scrollTo('homePageAssessment', {
                duration: 300,
                smooth: true,
                offset: -topOffset
            });
        };
        return _this;
    }
    HomePage.prototype.componentDidMount = function () {
        if (this.props.currentUser.isAuthenticated) {
            if (this.props.currentUser.role !== undefined) {
                if (this.props.currentUser.role[0] !== 'Customer') {
                    if (this.props.currentUser.role.some(function (r) { return r === 'Adjudicator'; })) {
                        return this.props.history.push('/admin/adjudication');
                    }
                    else {
                        return this.props.history.push('/admin');
                    }
                }
                else if (!this.props.currentUser.hasBeenDirected) {
                    this.props.actions.doneDirect(this.props.currentUser);
                    return this.props.history.push('/user');
                }
            }
        }
    };
    HomePage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_common__["b" /* Page */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { charSet: "utf-8" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "Simple. Direct. Affordable. Discover your life insurance options in just 10 minutes and apply for up to $1 million in coverage." }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Mosaic Life - Simple & Affordable Life Insurance for Canadians")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("header", { className: "page-hero page-hero-lg", role: "img", "aria-label": "A man holding a small child on a dock by a lake" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "page-hero-content" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-5 text-light d-flex flex-column justify-content-center" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "page-hero-title page-title-display mb-0 mb-md-2" }, "Simple and affordable life insurance for Canadians"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h3 my-3 max-read-width text-white d-flex bg-info-dark px-3 py-2" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_icons__["I" /* IconTriangleRight */], { className: "mr-1 text-white" }),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Sign up today and get your first two months free!")),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0 page-hero-lead max-read-width" }, "Protect your family and their future in less than 10 minutes for 10 years or more. Up to a million dollars for as little as $1.50 a day with no in-home medical assessment required."),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_buttons_Button__["a" /* default */], { className: "btn-primary btn-primary-inverse my-3 page-hero-cta-alt", onClick: this.onAltCtaClick },
                                        "Get started",
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_icons__["l" /* IconArrowDown */], { className: "ml-2" })))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 offset-md-1 mt-3 mt-md-0 px-0 d-flex flex-column justify-content-center" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_scroll__["Element"], { name: "homePageAssessment" }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_sections__["c" /* SectionRight */], { columns: 12, sectionClassName: "pr-0" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__HomePageAssessment__["a" /* default */], null))))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container my-4 my-md-6" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: "card-deck" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "card" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "card-body section section-lg" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "mb-3" }, "Simple"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0" }, "Unlike other insurers, we don't require medical exams or urine samples. You can get coverage in 10 minutes, all online."))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "card" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "card-body section section-lg" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "mb-3" }, "Direct"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0" }, "We\u2019ve cut out the middlemen to give you an experience that\u2019s free of hefty fees, commissions, and complexity."))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "card" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "card-body section section-lg" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "mb-3" }, "Affordable"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0" }, "By skipping pricey broker commissions and taking insurance online, we\u2019re able to offer $1 million of coverage for as little as $1.50/day."))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-4 mt-md-0 pt-md-6 landing-section" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "landing-section-img landing-section-img-01 landing-section-img-right", role: "img", "aria-label": "A woman, young child, and dog playing in a lake surrounded by an evergreen forest" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_sections__["a" /* SectionLeft */], { columns: 8, sectionClassName: "section-lg" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "mb-3" }, "How Mosaic Life Works"),
                    "If you're young & healthy (the best time to buy life insurance), getting protection from Mosaic Life is simple:",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ol", { className: "custom-ol" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "custom-ol-content" },
                                "Choose a term and coverage amount (if you're unsure, ",
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "/quote/B/about-you" }, "we can help"),
                                ").")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "custom-ol-content" }, "Answer some quick lifestyle and health questions.")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "custom-ol-content" }, "Get an instant decision and sign up."))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Once you're covered, if you die during the term of your protection, your loved ones will receive your coverage amount."),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "You can apply for up to $1 million of coverage, and it's easy to add or cancel policies if your needs change. If you change your mind during the first 30 days, you can cancel your policy and get a full refund."),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_buttons_Button__["a" /* default */], { to: "/faq", className: "btn-outline-primary mt-3" }, "Learn more"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: "mt-4 mt-md-6 container d-none d-lg-block" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "mb-3" }, "Why Choose Mosaic Life"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row row-x-1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container", onTouchStart: function (e) { return e; } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Convenient and easy"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "Most insurers require you to provide blood and urine samples and can take weeks to issue a policy. With Mosaic Life, you can get coverage in 10 minutes just by answering some lifestyle and health questions online.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Direct"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "We don\u2019t rely on brokers or agents to sell our policies which means we don't pay sales commissions. We pass those savings on to you.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-lg-3 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Team Canada"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "Mosaic Life is proudly for Canadians, by Canadians.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Affordable"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "By skipping pricey broker commissions and dealing with you directly instead, we're able to offer better rates than our competitors. You can get up to $1 million in coverage starting at ~$1.50/day.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-lg-3 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Guaranteed rates"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "Your premiums are set for the term of your policy. Even if you get sick during your policy term, your premiums will not change.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Relevant"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "We launched Mosaic Life out of our own need for protection. We've reimagined how life insurance should work\u2014100% online, totally flexible, no brokers, simple.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Cancel anytime (with money-back guarantee)"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "You can cancel your policy at any time and for any reason. If you cancel in the first 30 days, we will give you a full refund of your premium.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-lg-3 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "No fees"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "Besides your monthly premium, there are no additional fees to obtain coverage.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Flexible"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "We offer a range of terms and coverage amounts to meet your specific needs. You can have up to $1 million in total coverage across as many policies as you would like.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-lg-3 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Insurance you can trust"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "We try to be honest, transparent, and helpful. Your privacy is important to us.")))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_sections__["b" /* SectionMain */], { sectionClassName: "mt-4 mt-md-6 section-lg" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-5 col-lg-4 text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_icons__["K" /* LogoFirstCanadian */], { className: "landing-section-logo landing-section-logo-fc" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-7 col-lg-8 mt-4 mt-md-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Mosaic Life policies are underwritten by First Canadian Insurance Corporation, a life insurer based in Edmonton that has provided protection to over 1 million Canadian families.  First Canadian has been around for over 30 years and is rated A (with stable outlook) by A.M. Best, the leading ratings agency for insurance companies."))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-center mt-4 mt-md-5" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-5 col-lg-4 text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: scorLogoSrc, alt: "The logo of SCOR (The Art & Science of Risk)", className: "landing-section-logo landing-section-logo-scor" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-7 col-lg-8 mt-4 mt-md-0 order-md-first" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Mosaic Life is also backed by SCOR, one of the world\u2019s largest reinsurers and a leader in the creation of innovative risk management solutions for insurance companies. SCOR has been around for almost 50 years and is rated A+ (with stable outlook) by A.M. Best.")))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: "mt-4 mt-md-6 section section-lg bg-secondary text-light" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__HomePageAssessmentBottom__["a" /* default */], null)))));
    };
    return HomePage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        currentUser: state.auth.currentUser
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_6__auth_authActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_4__node_modules_redux__["bindActionCreators"])(actions, dispatch),
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(HomePage)));


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(91);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(LinkElement);

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(93);

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports.default = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(91);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(ButtonElement);

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(148);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports.default = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(38);

var utils = __webpack_require__(42);
var scrollSpy = __webpack_require__(92);
var defaultScroller = __webpack_require__(58);
var PropTypes = __webpack_require__(9);
var scrollHash = __webpack_require__(147);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          if (this.props.name !== nextProps.name) {
            this.registerElems(nextProps.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var ExecutionEnvironment = _interopDefault(__webpack_require__(139));
var shallowEqual = _interopDefault(__webpack_require__(418));

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;


    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 418 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(420);
var isArguments = __webpack_require__(421);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 420 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 421 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(33);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DatePicker__ = __webpack_require__(150);


var BirthDatePicker = function (props) {
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__DatePicker__["a" /* default */], { name: props.name, labelText: props.labelText, placeholder: props.placeholder, value: props.value, dateRangeStart: props.dateRangeStart || new Date(currentYear - 100, 0), dateRangeEnd: props.dateRangeEnd || new Date(currentYear, currentDate.getMonth()), onBlur: props.onBlur, onChange: props.onChange, defaultValue: props.defaultValue, required: props.required, className: props.className, id: props.id, error: props.error, disabled: props.disabled }));
};
/* harmony default export */ __webpack_exports__["a"] = (BirthDatePicker);


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-var */
/* eslint-env node */

var DayPickerInput = __webpack_require__(425);

module.exports = DayPickerInput.default || DayPickerInput;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HIDE_TIMEOUT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(34);

var _moment2 = _interopRequireDefault(_moment);

var _DayPicker = __webpack_require__(426);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _ModifiersUtils = __webpack_require__(152);

var _keys = __webpack_require__(95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-extraneous-dependencies

var HIDE_TIMEOUT = exports.HIDE_TIMEOUT = 100;

function getStateFromProps(props) {
  var month = void 0;
  if (props.value) {
    var m = (0, _moment2.default)(props.value, props.format, true);
    if (m.isValid()) {
      month = m.toDate();
    }
  } else {
    month = props.dayPickerProps.initialMonth || props.dayPickerProps.month || new Date();
  }

  return {
    value: props.value,
    month: month
  };
}

var DayPickerInput = function (_React$Component) {
  _inherits(DayPickerInput, _React$Component);

  function DayPickerInput(props) {
    _classCallCheck(this, DayPickerInput);

    var _this = _possibleConstructorReturn(this, (DayPickerInput.__proto__ || Object.getPrototypeOf(DayPickerInput)).call(this, props));

    _this.input = null;
    _this.daypicker = null;
    _this.clickedInside = false;
    _this.clickTimeout = null;
    _this.hideTimeout = null;

    _this.hideAfterDayClick = function () {
      if (!_this.props.hideOnDayClick) {
        return;
      }
      _this.hideTimeout = setTimeout(function () {
        return _this.hideDayPicker();
      }, HIDE_TIMEOUT // give a timeout to show the clicked day
      );
    };

    _this.handleContainerMouseDown = function () {
      _this.clickedInside = true;
      // The input's onBlur method is called from a queue right after onMouseDown event.
      // setTimeout adds another callback in the queue, but is called later than onBlur event
      _this.clickTimeout = setTimeout(function () {
        _this.clickedInside = false;
      }, 0);
    };

    _this.handleClick = function (e) {
      _this.showDayPicker();
      if (_this.props.onClick) {
        e.persist();
        _this.props.onClick(e);
      }
    };

    _this.handleFocus = function (e) {
      _this.showDayPicker();
      if (_this.props.onFocus) {
        e.persist();
        _this.props.onFocus(e);
      }
    };

    _this.handleBlur = function (e) {
      _this.setState({
        showOverlay: _this.clickedInside
      });

      // Force input's focus if blur event was caused
      // by clicking inside the overlay
      if (_this.clickedInside) {
        _this.input.focus();
      }

      if (_this.props.onBlur) {
        e.persist();
        _this.props.onBlur(e);
      }
    };

    _this.handleChange = function (e) {
      var value = e.target.value;
      var _this$props = _this.props,
          format = _this$props.format,
          dayPickerProps = _this$props.dayPickerProps,
          onDayChange = _this$props.onDayChange,
          onChange = _this$props.onChange;

      var m = (0, _moment2.default)(value, format, true);

      if (onChange) {
        e.persist();
        onChange(e);
      }

      if (value.trim() === '') {
        _this.setState({ value: value });
        if (_this.props.onDayChange) {
          _this.props.onDayChange(undefined, {});
        }
        return;
      }

      if (!m.isValid()) {
        _this.setState({ value: value });
        return;
      }

      var day = m.toDate();
      _this.setState({ month: day, value: value }, function () {
        if (!onDayChange) {
          return;
        }
        var modifiersObj = _extends({
          disabled: dayPickerProps.disabledDays,
          selected: dayPickerProps.selectedDays
        }, dayPickerProps.modifiers);
        var modifiers = (0, _ModifiersUtils.getModifiersForDay)(day, modifiersObj).reduce(function (obj, modifier) {
          var newObj = _extends({}, obj);
          newObj[modifier] = true;
          return newObj;
        }, {});
        _this.props.onDayChange(m, modifiers);
      });
    };

    _this.handleOnKeyUp = function (e) {
      _this.setState({
        showOverlay: e.keyCode !== _keys.ESC
      });
      if (_this.props.onKeyUp) {
        e.persist();
        _this.props.onKeyUp(e);
      }
    };

    _this.handleDayClick = function (day, modifiers, e) {
      if (_this.props.dayPickerProps.onDayClick) {
        _this.props.dayPickerProps.onDayClick(day, modifiers, e);
      }

      if (modifiers.disabled) {
        // Do nothing if the day is disabled
        return;
      }
      if (modifiers.selected && _this.props.clickUnselectsDay) {
        // Unselect the day
        _this.setState({ value: '' }, _this.hideAfterDayClick);
        if (_this.props.onDayChange) {
          _this.props.onDayChange(undefined, modifiers);
        }
        return;
      }

      var format = _this.props.format;

      var m = (0, _moment2.default)(day);
      _this.setState({
        value: m.format(typeof format === 'string' ? format : format[0]),
        month: day
      }, function () {
        if (_this.props.onDayChange) {
          _this.props.onDayChange(m, modifiers);
        }
        _this.hideAfterDayClick();
      });
    };

    _this.state = getStateFromProps(props);
    _this.state.showOverlay = false;
    return _this;
  }

  _createClass(DayPickerInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          dayPickerProps = _props.dayPickerProps,
          value = _props.value;
      var nextDayPickerProps = nextProps.dayPickerProps,
          nextValue = nextProps.value;


      var hasDifferentValue = nextValue !== value;

      var willUpdateDayPickerMonth = nextDayPickerProps.month && dayPickerProps.month;

      var newMonthProp = nextDayPickerProps.month && !dayPickerProps.month;

      var shouldDisplayAnotherMonth = newMonthProp || willUpdateDayPickerMonth && (nextDayPickerProps.month.getFullYear() !== dayPickerProps.month.getFullYear() || nextDayPickerProps.month.getMonth() !== dayPickerProps.month.getMonth());

      if (hasDifferentValue && !shouldDisplayAnotherMonth) {
        this.setState(getStateFromProps(nextProps));
      } else if (shouldDisplayAnotherMonth) {
        this.setState({ month: nextDayPickerProps.month });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.clickTimeout);
      clearTimeout(this.hideTimeout);
    }
  }, {
    key: 'showDayPicker',


    /**
     * Show the Day Picker overlay.
     * 
     * @memberof DayPickerInput
     */
    value: function showDayPicker() {
      this.setState({
        showOverlay: true
      });
    }

    /**
     * Hide the Day Picker overlay
     * 
     * @memberof DayPickerInput
     */

  }, {
    key: 'hideDayPicker',
    value: function hideDayPicker() {
      this.setState({
        showOverlay: false
      });
    }
  }, {
    key: 'renderOverlay',
    value: function renderOverlay() {
      var _this2 = this;

      var selectedDay = void 0;
      if (this.state.value) {
        var m = (0, _moment2.default)(this.state.value, this.props.format, true);
        if (m.isValid()) {
          selectedDay = m.toDate();
        }
      }

      return _react2.default.createElement(
        'div',
        { className: this.props.classNames.overlayWrapper },
        _react2.default.createElement(
          'div',
          { className: this.props.classNames.overlay },
          _react2.default.createElement(_DayPicker2.default, _extends({
            ref: function ref(el) {
              return _this2.daypicker = el;
            },
            fixedWeeks: true
          }, this.props.dayPickerProps, {
            month: this.state.month,
            selectedDays: selectedDay,
            onDayClick: this.handleDayClick,
            numberOfMonths: 1
          }))
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var inputProps = _extends({}, this.props);
      delete inputProps.component;
      delete inputProps.dayPickerProps;
      delete inputProps.format;
      delete inputProps.clickUnselectsDay;
      delete inputProps.hideOnDayClick;
      delete inputProps.onDayChange;
      delete inputProps.classNames;
      return _react2.default.createElement(
        'div',
        {
          className: this.props.classNames.container,
          onMouseDown: this.handleContainerMouseDown
        },
        _react2.default.createElement(this.props.component, _extends({
          ref: function ref(el) {
            return _this3.input = el;
          }
        }, inputProps, {
          value: this.state.value,
          onChange: this.handleChange,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onKeyUp: this.handleOnKeyUp,
          onClick: this.handleClick
        })),
        this.state.showOverlay && this.renderOverlay()
      );
    }
  }]);

  return DayPickerInput;
}(_react2.default.Component);

DayPickerInput.defaultProps = {
  dayPickerProps: {},
  value: '',
  format: 'L',
  hideOnDayClick: true,
  clickUnselectsDay: false,
  component: 'input',
  classNames: {
    container: 'DayPickerInput',
    overlayWrapper: 'DayPickerInput-OverlayWrapper',
    overlay: 'DayPickerInput-Overlay'
  }
};
exports.default = DayPickerInput;
DayPickerInput.propTypes =  false ? {
  // eslint-disable-next-line react/no-unused-prop-types
  value: _propTypes2.default.string,

  format: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]).isRequired,

  dayPickerProps: _propTypes2.default.object,
  hideOnDayClick: _propTypes2.default.bool,
  clickUnselectsDay: _propTypes2.default.bool,
  component: _propTypes2.default.any,

  classNames: _propTypes2.default.shape({
    container: _propTypes2.default.string,
    overlayWrapper: _propTypes2.default.string,
    overlay: _propTypes2.default.string.isRequired
  }),

  onDayChange: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func
} : {};
//# sourceMappingURL=DayPickerInput.js.map

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Caption = __webpack_require__(427);

var _Caption2 = _interopRequireDefault(_Caption);

var _Navbar = __webpack_require__(428);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Month = __webpack_require__(429);

var _Month2 = _interopRequireDefault(_Month);

var _Weekday = __webpack_require__(432);

var _Weekday2 = _interopRequireDefault(_Weekday);

var _Helpers = __webpack_require__(60);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(44);

var DateUtils = _interopRequireWildcard(_DateUtils);

var _LocaleUtils = __webpack_require__(151);

var LocaleUtils = _interopRequireWildcard(_LocaleUtils);

var _classNames = __webpack_require__(59);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(95);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DayPicker = function (_Component) {
  _inherits(DayPicker, _Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = _this.getStateFromProps(props);
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.month !== nextProps.month) {
        this.setState(this.getStateFromProps(nextProps));
      }
    }
  }, {
    key: 'getNextNavigableMonth',
    value: function getNextNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
    }
  }, {
    key: 'getPreviousNavigableMonth',
    value: function getPreviousNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, -1);
    }
  }, {
    key: 'allowPreviousMonth',
    value: function allowPreviousMonth() {
      var previousMonth = DateUtils.addMonths(this.state.currentMonth, -1);
      return this.allowMonth(previousMonth);
    }
  }, {
    key: 'allowNextMonth',
    value: function allowNextMonth() {
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
      return this.allowMonth(nextMonth);
    }
  }, {
    key: 'allowMonth',
    value: function allowMonth(d) {
      var _props = this.props,
          fromMonth = _props.fromMonth,
          toMonth = _props.toMonth,
          canChangeMonth = _props.canChangeMonth;

      if (!canChangeMonth || fromMonth && Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers.getMonthsDiff(toMonth, d) > 0) {
        return false;
      }
      return true;
    }
  }, {
    key: 'allowYearChange',
    value: function allowYearChange() {
      return this.props.canChangeMonth;
    }
  }, {
    key: 'showMonth',
    value: function showMonth(d, callback) {
      var _this2 = this;

      if (!this.allowMonth(d)) {
        return;
      }
      this.setState({ currentMonth: Helpers.startOfMonth(d) }, function () {
        if (callback) {
          callback();
        }
        if (_this2.props.onMonthChange) {
          _this2.props.onMonthChange(_this2.state.currentMonth);
        }
      });
    }
  }, {
    key: 'showNextYear',
    value: function showNextYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, 12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'showPreviousYear',
    value: function showPreviousYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, -12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'focusFirstDayOfMonth',
    value: function focusFirstDayOfMonth() {
      Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
    }
  }, {
    key: 'focusLastDayOfMonth',
    value: function focusLastDayOfMonth() {
      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      dayNodes[dayNodes.length - 1].focus();
    }
  }, {
    key: 'focusPreviousDay',
    value: function focusPreviousDay(dayNode) {
      var _this3 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);

      if (dayNodeIndex === 0) {
        this.showPreviousMonth(function () {
          return _this3.focusLastDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex - 1].focus();
      }
    }
  }, {
    key: 'focusNextDay',
    value: function focusNextDay(dayNode) {
      var _this4 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);

      if (dayNodeIndex === dayNodes.length - 1) {
        this.showNextMonth(function () {
          return _this4.focusFirstDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex + 1].focus();
      }
    }
  }, {
    key: 'focusNextWeek',
    value: function focusNextWeek(dayNode) {
      var _this5 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;

      if (isInLastWeekOfMonth) {
        this.showNextMonth(function () {
          var daysAfterIndex = dayNodes.length - dayNodeIndex;
          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
          Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex + 7].focus();
      }
    }
  }, {
    key: 'focusPreviousWeek',
    value: function focusPreviousWeek(dayNode) {
      var _this6 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInFirstWeekOfMonth = dayNodeIndex <= 6;

      if (isInFirstWeekOfMonth) {
        this.showPreviousMonth(function () {
          var previousMonthDayNodes = Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex - 7].focus();
      }
    }

    // Event handlers

  }, {
    key: 'handleOutsideDayClick',
    value: function handleOutsideDayClick(day) {
      var currentMonth = this.state.currentMonth;
      var numberOfMonths = this.props.numberOfMonths;

      var diffInMonths = Helpers.getMonthsDiff(currentMonth, day);
      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
        this.showNextMonth();
      } else if (diffInMonths < 0) {
        this.showPreviousMonth();
      }
    }
  }, {
    key: 'renderNavbar',
    value: function renderNavbar() {
      var _props2 = this.props,
          labels = _props2.labels,
          locale = _props2.locale,
          localeUtils = _props2.localeUtils,
          canChangeMonth = _props2.canChangeMonth,
          navbarElement = _props2.navbarElement,
          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);

      if (!canChangeMonth) return null;

      var props = {
        classNames: this.props.classNames,
        className: this.props.classNames.navBar,
        nextMonth: this.getNextNavigableMonth(),
        previousMonth: this.getPreviousNavigableMonth(),
        showPreviousButton: this.allowPreviousMonth(),
        showNextButton: this.allowNextMonth(),
        onNextClick: this.showNextMonth,
        onPreviousClick: this.showPreviousMonth,
        dir: attributes.dir,
        labels: labels,
        locale: locale,
        localeUtils: localeUtils
      };
      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
    }
  }, {
    key: 'renderMonths',
    value: function renderMonths() {
      var months = [];
      var firstDayOfWeek = Helpers.getFirstDayOfWeekFromProps(this.props);

      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
        var month = DateUtils.addMonths(this.state.currentMonth, i);

        months.push(_react2.default.createElement(_Month2.default, _extends({
          key: i
        }, this.props, {
          month: month,
          footer: this.props.todayButton && this.renderTodayButton(),
          firstDayOfWeek: firstDayOfWeek,
          onDayKeyDown: this.handleDayKeyDown,
          onDayClick: this.handleDayClick
        })));
      }

      if (this.props.reverseMonths) {
        months.reverse();
      }
      return months;
    }
  }, {
    key: 'renderTodayButton',
    value: function renderTodayButton() {
      return _react2.default.createElement(
        'button',
        {
          type: 'button',
          tabIndex: 0,
          className: this.props.classNames.todayButton,
          'aria-label': this.props.todayButton,
          onClick: this.handleTodayButtonClick
        },
        this.props.todayButton
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var className = this.props.classNames.container;

      if (!this.props.onDayClick) {
        className = className + ' ' + this.props.classNames.interactionDisabled;
      }
      if (this.props.className) {
        className = className + ' ' + this.props.className;
      }
      return _react2.default.createElement(
        'div',
        _extends({}, this.props.containerProps, {
          className: className,
          ref: function ref(el) {
            return _this7.dayPicker = el;
          },
          role: 'application',
          lang: this.props.locale
        }),
        _react2.default.createElement(
          'div',
          {
            className: this.props.classNames.wrapper,
            tabIndex: this.props.canChangeMonth && this.props.tabIndex ? this.props.tabIndex : -1,
            onKeyDown: this.handleKeyDown,
            onFocus: this.props.onFocus,
            onBlur: this.props.onBlur
          },
          this.renderNavbar(),
          this.renderMonths()
        )
      );
    }
  }]);

  return DayPicker;
}(_react.Component);

DayPicker.VERSION = '6.2.1';
DayPicker.defaultProps = {
  classNames: _classNames2.default,
  tabIndex: 0,
  initialMonth: new Date(),
  numberOfMonths: 1,
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  locale: 'en',
  localeUtils: LocaleUtils,
  enableOutsideDays: false,
  fixedWeeks: false,
  canChangeMonth: true,
  reverseMonths: false,
  pagedNavigation: false,
  showWeekNumbers: false,
  renderDay: function renderDay(day) {
    return day.getDate();
  },
  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
};

var _initialiseProps = function _initialiseProps() {
  var _this8 = this;

  this.getStateFromProps = function (props) {
    var initialMonth = Helpers.startOfMonth(props.month || props.initialMonth);
    var currentMonth = initialMonth;

    if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
      var diffInMonths = Helpers.getMonthsDiff(props.fromMonth, currentMonth);
      currentMonth = DateUtils.addMonths(props.fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
    }
    return { currentMonth: currentMonth };
  };

  this.dayPicker = null;

  this.showNextMonth = function (callback) {
    if (!_this8.allowNextMonth()) {
      return;
    }
    var deltaMonths = _this8.props.pagedNavigation ? _this8.props.numberOfMonths : 1;
    var nextMonth = DateUtils.addMonths(_this8.state.currentMonth, deltaMonths);
    _this8.showMonth(nextMonth, callback);
  };

  this.showPreviousMonth = function (callback) {
    if (!_this8.allowPreviousMonth()) {
      return;
    }
    var deltaMonths = _this8.props.pagedNavigation ? _this8.props.numberOfMonths : 1;
    var previousMonth = DateUtils.addMonths(_this8.state.currentMonth, -deltaMonths);
    _this8.showMonth(previousMonth, callback);
  };

  this.handleKeyDown = function (e) {
    e.persist();

    switch (e.keyCode) {
      case _keys.LEFT:
        _this8.showPreviousMonth();
        break;
      case _keys.RIGHT:
        _this8.showNextMonth();
        break;
      case _keys.UP:
        _this8.showPreviousYear();
        break;
      case _keys.DOWN:
        _this8.showNextYear();
        break;
      default:
        break;
    }

    if (_this8.props.onKeyDown) {
      _this8.props.onKeyDown(e);
    }
  };

  this.handleDayKeyDown = function (day, modifiers, e) {
    e.persist();
    switch (e.keyCode) {
      case _keys.LEFT:
        Helpers.cancelEvent(e);
        _this8.focusPreviousDay(e.target);
        break;
      case _keys.RIGHT:
        Helpers.cancelEvent(e);
        _this8.focusNextDay(e.target);
        break;
      case _keys.UP:
        Helpers.cancelEvent(e);
        _this8.focusPreviousWeek(e.target);
        break;
      case _keys.DOWN:
        Helpers.cancelEvent(e);
        _this8.focusNextWeek(e.target);
        break;
      case _keys.ENTER:
      case _keys.SPACE:
        Helpers.cancelEvent(e);
        if (_this8.props.onDayClick) {
          _this8.handleDayClick(day, modifiers, e);
        }
        break;
      default:
        break;
    }
    if (_this8.props.onDayKeyDown) {
      _this8.props.onDayKeyDown(day, modifiers, e);
    }
  };

  this.handleDayClick = function (day, modifiers, e) {
    e.persist();
    if (modifiers[_this8.props.classNames.outside]) {
      _this8.handleOutsideDayClick(day);
    }
    if (_this8.props.onDayClick) {
      _this8.props.onDayClick(day, modifiers, e);
    }
  };

  this.handleTodayButtonClick = function (e) {
    _this8.showMonth(new Date());
    e.target.blur();
  };
};

exports.default = DayPicker;
DayPicker.propTypes =  false ? {
  // Rendering months
  initialMonth: _propTypes2.default.instanceOf(Date),
  month: _propTypes2.default.instanceOf(Date),
  numberOfMonths: _propTypes2.default.number,
  fromMonth: _propTypes2.default.instanceOf(Date),
  toMonth: _propTypes2.default.instanceOf(Date),
  canChangeMonth: _propTypes2.default.bool,
  reverseMonths: _propTypes2.default.bool,
  pagedNavigation: _propTypes2.default.bool,
  todayButton: _propTypes2.default.string,
  showWeekNumbers: _propTypes2.default.bool,

  // Modifiers
  selectedDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
  disabledDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),

  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,

  // Localization
  dir: _propTypes2.default.string,
  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
  labels: _propTypes2.default.shape({
    nextMonth: _propTypes2.default.string.isRequired,
    previousMonth: _propTypes2.default.string.isRequired
  }).isRequired,
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),

  // Customization
  enableOutsideDays: _propTypes2.default.bool,
  fixedWeeks: _propTypes2.default.bool,

  // CSS and HTML
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string,
    container: _propTypes2.default.string,
    day: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.string.isRequired,
    footer: _propTypes2.default.string,
    interactionDisabled: _propTypes2.default.string,
    month: _propTypes2.default.string,
    navBar: _propTypes2.default.string,
    outside: _propTypes2.default.string.isRequired,
    selected: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    todayButton: _propTypes2.default.string,
    week: _propTypes2.default.string,
    wrapper: _propTypes2.default.string
  }),
  className: _propTypes2.default.string,
  containerProps: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,

  // Custom elements
  renderDay: _propTypes2.default.func,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  navbarElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),

  // Events
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onMonthChange: _propTypes2.default.func,
  onCaptionClick: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func
} : {};
//# sourceMappingURL=DayPicker.js.map

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Caption = function (_Component) {
  _inherits(Caption, _Component);

  function Caption() {
    _classCallCheck(this, Caption);

    return _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).apply(this, arguments));
  }

  _createClass(Caption, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          date = _props.date,
          months = _props.months,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          onClick = _props.onClick;

      return _react2.default.createElement(
        'div',
        { className: classNames.caption, role: 'heading' },
        _react2.default.createElement(
          'div',
          { onClick: onClick },
          months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)
        )
      );
    }
  }]);

  return Caption;
}(_react.Component);

exports.default = Caption;
Caption.propTypes =  false ? {
  date: _propTypes2.default.instanceOf(Date),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  classNames: _propTypes2.default.shape({
    caption: _propTypes2.default.string.isRequired
  }).isRequired
} : {};
//# sourceMappingURL=Caption.js.map

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classNames = __webpack_require__(59);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navbar = function (_Component) {
  _inherits(Navbar, _Component);

  function Navbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Navbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
      if (_this.props.onNextClick) {
        _this.props.onNextClick();
      }
    }, _this.handlePreviousClick = function () {
      if (_this.props.onPreviousClick) {
        _this.props.onPreviousClick();
      }
    }, _this.handleNextKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handleNextClick();
    }, _this.handlePreviousKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handlePreviousClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Navbar, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          className = _props.className,
          showPreviousButton = _props.showPreviousButton,
          showNextButton = _props.showNextButton,
          labels = _props.labels,
          dir = _props.dir;


      var previousClickHandler = void 0;
      var nextClickHandler = void 0;
      var previousKeyDownHandler = void 0;
      var nextKeyDownHandler = void 0;
      var shouldShowPrevious = void 0;
      var shouldShowNext = void 0;

      if (dir === 'rtl') {
        previousClickHandler = this.handleNextClick;
        nextClickHandler = this.handlePreviousClick;
        previousKeyDownHandler = this.handleNextKeyDown;
        nextKeyDownHandler = this.handlePreviousKeyDown;
        shouldShowNext = showPreviousButton;
        shouldShowPrevious = showNextButton;
      } else {
        previousClickHandler = this.handlePreviousClick;
        nextClickHandler = this.handleNextClick;
        previousKeyDownHandler = this.handlePreviousKeyDown;
        nextKeyDownHandler = this.handleNextKeyDown;
        shouldShowNext = showNextButton;
        shouldShowPrevious = showPreviousButton;
      }

      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;

      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;

      var previousButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.previousMonth,
        key: 'previous',
        className: previousClassName,
        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
        onClick: shouldShowPrevious ? previousClickHandler : undefined
      });

      var nextButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.nextMonth,
        key: 'right',
        className: nextClassName,
        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
        onClick: shouldShowNext ? nextClickHandler : undefined
      });

      return _react2.default.createElement(
        'div',
        { className: className || classNames.navBar },
        dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]
      );
    }
  }]);

  return Navbar;
}(_react.Component);

Navbar.defaultProps = {
  classNames: _classNames2.default,
  dir: 'ltr',
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  showPreviousButton: true,
  showNextButton: true
};
exports.default = Navbar;
Navbar.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    navBar: _propTypes2.default.string.isRequired,
    navButtonPrev: _propTypes2.default.string.isRequired,
    navButtonNext: _propTypes2.default.string.isRequired
  }),
  className: _propTypes2.default.string,
  showPreviousButton: _propTypes2.default.bool,
  showNextButton: _propTypes2.default.bool,
  onPreviousClick: _propTypes2.default.func,
  onNextClick: _propTypes2.default.func,
  dir: _propTypes2.default.string,
  labels: _propTypes2.default.shape({
    previousMonth: _propTypes2.default.string.isRequired,
    nextMonth: _propTypes2.default.string.isRequired
  })
} : {};
//# sourceMappingURL=Navbar.js.map

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Weekdays = __webpack_require__(430);

var _Weekdays2 = _interopRequireDefault(_Weekdays);

var _Day = __webpack_require__(431);

var _Day2 = _interopRequireDefault(_Day);

var _ModifiersUtils = __webpack_require__(152);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _Helpers = __webpack_require__(60);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(44);

var DateUtils = _interopRequireWildcard(_DateUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Month = function (_Component) {
  _inherits(Month, _Component);

  function Month() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
      var monthNumber = _this.props.month.getMonth();
      var propModifiers = Helpers.getModifiersFromProps(_this.props);
      var dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);
      if (DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
        dayModifiers.push(_this.props.classNames.today);
      }
      if (day.getMonth() !== monthNumber) {
        dayModifiers.push(_this.props.classNames.outside);
      }

      var isOutside = day.getMonth() !== monthNumber;
      var tabIndex = -1;
      // Focus on the first day of the month
      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
        tabIndex = _this.props.tabIndex;
      }
      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
      var modifiers = {};
      dayModifiers.forEach(function (modifier) {
        modifiers[modifier] = true;
      });

      return _react2.default.createElement(
        _Day2.default,
        {
          key: '' + (isOutside ? 'outside-' : '') + key,
          classNames: _this.props.classNames,
          day: day,
          modifiers: modifiers,
          modifiersStyles: _this.props.modifiersStyles,
          empty: isOutside && !_this.props.enableOutsideDays && !_this.props.fixedWeeks,
          tabIndex: tabIndex,
          ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
          ariaDisabled: isOutside || dayModifiers.indexOf('disabled') > -1,
          ariaSelected: dayModifiers.indexOf('selected') > -1,
          onClick: _this.props.onDayClick,
          onFocus: _this.props.onDayFocus,
          onKeyDown: _this.props.onDayKeyDown,
          onMouseEnter: _this.props.onDayMouseEnter,
          onMouseLeave: _this.props.onDayMouseLeave,
          onMouseDown: _this.props.onDayMouseDown,
          onMouseUp: _this.props.onDayMouseUp,
          onTouchEnd: _this.props.onDayTouchEnd,
          onTouchStart: _this.props.onDayTouchStart
        },
        _this.props.renderDay(day, modifiers)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Month, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classNames = _props.classNames,
          month = _props.month,
          months = _props.months,
          fixedWeeks = _props.fixedWeeks,
          captionElement = _props.captionElement,
          weekdayElement = _props.weekdayElement,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          firstDayOfWeek = _props.firstDayOfWeek,
          onCaptionClick = _props.onCaptionClick,
          footer = _props.footer,
          showWeekNumbers = _props.showWeekNumbers,
          onWeekClick = _props.onWeekClick;


      var captionProps = {
        date: month,
        classNames: classNames,
        months: months,
        localeUtils: localeUtils,
        locale: locale,
        onClick: onCaptionClick ? function (e) {
          return onCaptionClick(month, e);
        } : undefined
      };
      var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);

      var weeks = Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);

      return _react2.default.createElement(
        'div',
        { className: classNames.month, role: 'grid' },
        caption,
        _react2.default.createElement(_Weekdays2.default, {
          classNames: classNames,
          weekdaysShort: weekdaysShort,
          weekdaysLong: weekdaysLong,
          firstDayOfWeek: firstDayOfWeek,
          showWeekNumbers: showWeekNumbers,
          locale: locale,
          localeUtils: localeUtils,
          weekdayElement: weekdayElement
        }),
        _react2.default.createElement(
          'div',
          { className: classNames.body, role: 'rowgroup' },
          weeks.map(function (week) {
            var weekNumber = void 0;
            if (showWeekNumbers) {
              weekNumber = DateUtils.getWeekNumber(week[0]);
            }
            return _react2.default.createElement(
              'div',
              {
                key: week[0].getTime(),
                className: classNames.week,
                role: 'row'
              },
              showWeekNumbers && _react2.default.createElement(
                'div',
                {
                  className: classNames.weekNumber,
                  tabIndex: 0,
                  role: 'gridcell',
                  onClick: function onClick(e) {
                    return onWeekClick(weekNumber, week, e);
                  }
                },
                weekNumber
              ),
              week.map(_this2.renderDay)
            );
          })
        ),
        footer && _react2.default.createElement(
          'div',
          { className: classNames.footer },
          footer
        )
      );
    }
  }]);

  return Month;
}(_react.Component);

exports.default = Month;
Month.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string.isRequired,
    month: _propTypes2.default.string.isRequired,
    outside: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    week: _propTypes2.default.string.isRequired
  }).isRequired,
  tabIndex: _propTypes2.default.number,

  month: _propTypes2.default.instanceOf(Date).isRequired,
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),

  modifiersStyles: _propTypes2.default.object,

  enableOutsideDays: _propTypes2.default.bool,

  renderDay: _propTypes2.default.func.isRequired,

  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]).isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]),

  footer: _propTypes2.default.node,
  fixedWeeks: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,

  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  firstDayOfWeek: _propTypes2.default.number.isRequired,

  onCaptionClick: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func
} : {};
//# sourceMappingURL=Month.js.map

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekdays = function (_Component) {
  _inherits(Weekdays, _Component);

  function Weekdays() {
    _classCallCheck(this, Weekdays);

    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
  }

  _createClass(Weekdays, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          firstDayOfWeek = _props.firstDayOfWeek,
          showWeekNumbers = _props.showWeekNumbers,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdayElement = _props.weekdayElement;

      var days = [];
      for (var i = 0; i < 7; i += 1) {
        var weekday = (i + firstDayOfWeek) % 7;
        var elementProps = {
          key: i,
          className: classNames.weekday,
          weekday: weekday,
          weekdaysLong: weekdaysLong,
          weekdaysShort: weekdaysShort,
          localeUtils: localeUtils,
          locale: locale
        };
        var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
        days.push(element);
      }

      return _react2.default.createElement(
        'div',
        { className: classNames.weekdays, role: 'rowgroup' },
        _react2.default.createElement(
          'div',
          { className: classNames.weekdaysRow, role: 'row' },
          showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }),
          days
        )
      );
    }
  }]);

  return Weekdays;
}(_react.Component);

exports.default = Weekdays;
Weekdays.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    weekday: _propTypes2.default.string.isRequired,
    weekdays: _propTypes2.default.string.isRequired,
    weekdaysRow: _propTypes2.default.string.isRequired
  }).isRequired,

  firstDayOfWeek: _propTypes2.default.number.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showWeekNumbers: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)])
} : {};
//# sourceMappingURL=Weekdays.js.map

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(33);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateUtils = __webpack_require__(44);

var _Helpers = __webpack_require__(60);

var _classNames = __webpack_require__(59);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */

function handleEvent(handler, day, modifiers) {
  if (!handler) {
    return undefined;
  }
  return function (e) {
    e.persist();
    handler(day, modifiers, e);
  };
}

var Day = function (_Component) {
  _inherits(Day, _Component);

  function Day() {
    _classCallCheck(this, Day);

    return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
  }

  _createClass(Day, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      var propNames = Object.keys(this.props);
      var nextPropNames = Object.keys(nextProps);
      if (propNames.length !== nextPropNames.length) {
        return true;
      }
      return propNames.some(function (name) {
        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
          var prop = _this2.props[name];
          var nextProp = nextProps[name];
          var modifiers = Object.keys(prop);
          var nextModifiers = Object.keys(nextProp);
          if (modifiers.length !== nextModifiers.length) {
            return true;
          }
          return modifiers.some(function (mod) {
            return !(0, _Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
          });
        }
        if (name === 'day') {
          return !(0, _DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
        }
        return !(0, _Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          modifiersStyles = _props.modifiersStyles,
          day = _props.day,
          tabIndex = _props.tabIndex,
          empty = _props.empty,
          modifiers = _props.modifiers,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onMouseDown = _props.onMouseDown,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          onTouchStart = _props.onTouchStart,
          onTouchEnd = _props.onTouchEnd,
          onFocus = _props.onFocus,
          ariaLabel = _props.ariaLabel,
          ariaDisabled = _props.ariaDisabled,
          ariaSelected = _props.ariaSelected,
          children = _props.children;


      var className = classNames.day;
      if (classNames !== _classNames2.default) {
        // When using CSS modules prefix the modifier as required by the BEM syntax
        className += ' ' + Object.keys(modifiers).join(' ');
      } else {
        className += Object.keys(modifiers).map(function (modifier) {
          return ' ' + className + '--' + modifier;
        }).join('');
      }

      var style = void 0;
      if (modifiersStyles) {
        Object.keys(modifiers).filter(function (modifier) {
          return !!modifiersStyles[modifier];
        }).forEach(function (modifier) {
          style = (0, _objectAssign2.default)({}, style, modifiersStyles[modifier]);
        });
      }

      if (empty) {
        return _react2.default.createElement('div', { 'aria-disabled': true, className: className, style: style });
      }
      return _react2.default.createElement(
        'div',
        {
          className: className,
          tabIndex: tabIndex,
          style: style,
          role: 'gridcell',
          'aria-label': ariaLabel,
          'aria-disabled': ariaDisabled,
          'aria-selected': ariaSelected,
          onClick: handleEvent(onClick, day, modifiers),
          onKeyDown: handleEvent(onKeyDown, day, modifiers),
          onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
          onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
          onMouseUp: handleEvent(onMouseUp, day, modifiers),
          onMouseDown: handleEvent(onMouseDown, day, modifiers),
          onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
          onTouchStart: handleEvent(onTouchStart, day, modifiers),
          onFocus: handleEvent(onFocus, day, modifiers)
        },
        children
      );
    }
  }]);

  return Day;
}(_react.Component);

Day.defaultProps = {
  tabIndex: -1
};
Day.defaultProps = {
  modifiers: {},
  modifiersStyles: {},
  empty: false
};
exports.default = Day;
Day.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    day: _propTypes2.default.string.isRequired
  }).isRequired,

  day: _propTypes2.default.instanceOf(Date).isRequired,
  children: _propTypes2.default.node.isRequired,

  ariaDisabled: _propTypes2.default.bool,
  ariaLabel: _propTypes2.default.string,
  ariaSelected: _propTypes2.default.bool,
  empty: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number
} : {};
//# sourceMappingURL=Day.js.map

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekday = function (_Component) {
  _inherits(Weekday, _Component);

  function Weekday() {
    _classCallCheck(this, Weekday);

    return _possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
  }

  _createClass(Weekday, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          weekday = _props.weekday,
          className = _props.className,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          localeUtils = _props.localeUtils,
          locale = _props.locale;

      var title = void 0;
      if (weekdaysLong) {
        title = weekdaysLong[weekday];
      } else {
        title = localeUtils.formatWeekdayLong(weekday, locale);
      }
      var content = void 0;
      if (weekdaysShort) {
        content = weekdaysShort[weekday];
      } else {
        content = localeUtils.formatWeekdayShort(weekday, locale);
      }

      return _react2.default.createElement(
        'div',
        { className: className, role: 'columnheader' },
        _react2.default.createElement(
          'abbr',
          { title: title },
          content
        )
      );
    }
  }]);

  return Weekday;
}(_react.Component);

exports.default = Weekday;
Weekday.propTypes =  false ? {
  weekday: _propTypes2.default.number,
  className: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,

  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string)
} : {};
//# sourceMappingURL=Weekday.js.map

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// THIS FILE IS GENERATED - DO NOT EDIT!
/*!mobile-detect v1.4.2 2018-06-10*/
/*global module:false, define:false*/
/*jshint latedef:false*/
/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
(function (define, undefined) {
define(function () {
    'use strict';

    var impl = {};

    impl.mobileDetectRules = {
    "phones": {
        "iPhone": "\\biPhone\\b|\\biPod\\b",
        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+",
        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
        "Dell": "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
        "Samsung": "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F",
        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)",
        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
        "NokiaLumia": "Lumia [0-9]{3,4}",
        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
        "Palm": "PalmSource|Palm",
        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
        "Alcatel": "Alcatel",
        "Nintendo": "Nintendo (3DS|Switch)",
        "Amoi": "Amoi",
        "INQ": "INQ",
        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
    },
    "tablets": {
        "iPad": "iPad|iPad.*Mobile",
        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
        "GoogleTablet": "Android.*Pixel C",
        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708",
        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
        "BlackBerryTablet": "PlayBook|RIM Tablet",
        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304F|TB-X304L|TB-8703F|Tab2A7-10F",
        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
        "IRUTablet": "M702pro",
        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
        "NokiaLumiaTablet": "Lumia 2520",
        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP612|SOT31",
        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
        "FlyTablet": "IQ310|Fly Vision",
        "bqTablet": "Android.*(bq)?.*(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))|Maxwell.*Lite|Maxwell.*Plus",
        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09",
        "NecTablet": "\\bN-06D|\\bN-08D",
        "PantechTablet": "Pantech.*P4100",
        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
        "ZyncTablet": "z1000|Z99 2G|z99|z930|z999|z990|z909|Z919|z900",
        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
        "NabiTablet": "Android.*\\bNabi",
        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
        "PlaystationTablet": "Playstation.*(Portable|Vita)",
        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
        "GalapadTablet": "Android.*\\bG1\\b",
        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
        "DPSTablet": "DPS Dream 9|DPS Dual 7",
        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497",
        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
        "iMobileTablet": "i-mobile i-note",
        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
        "AMPETablet": "Android.* A78 ",
        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
        "TecnoTablet": "TECNO P9|TECNO DP8D",
        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
        "VerizonTablet": "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
        "CaptivaTablet": "CAPTIVA PAD",
        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+",
        "JaytechTablet": "TPC-PA762",
        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
        "MediacomTablet": "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
        "UbislateTablet": "UbiSlate[\\s]?7C",
        "PocketBookTablet": "Pocketbook",
        "KocasoTablet": "\\b(TB-1207)\\b",
        "HisenseTablet": "\\b(F5281|E2371)\\b",
        "Hudl": "Hudl HT7S3|Hudl 2",
        "TelstraTablet": "T-Hub2",
        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
    },
    "oss": {
        "AndroidOS": "Android",
        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Window Mobile|Windows Phone [0-9.]+|WCE;",
        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
        "MeeGoOS": "MeeGo",
        "MaemoOS": "Maemo",
        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
        "webOS": "webOS|hpwOS",
        "badaOS": "\\bBada\\b",
        "BREWOS": "BREW"
    },
    "uas": {
        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
        "Dolfin": "\\bDolfin\\b",
        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+|Coast\/[0-9.]+",
        "Skyfire": "Skyfire",
        "Edge": "Mobile Safari\/[.0-9]* Edge",
        "IE": "IEMobile|MSIEMobile",
        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
        "Bolt": "bolt",
        "TeaShark": "teashark",
        "Blazer": "Blazer",
        "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
        "UCBrowser": "UC.*Browser|UCWEB",
        "baiduboxapp": "baiduboxapp",
        "baidubrowser": "baidubrowser",
        "DiigoBrowser": "DiigoBrowser",
        "Puffin": "Puffin",
        "Mercury": "\\bMercury\\b",
        "ObigoBrowser": "Obigo",
        "NetFront": "NF-Browser",
        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
    },
    "props": {
        "Mobile": "Mobile\/[VER]",
        "Build": "Build\/[VER]",
        "Version": "Version\/[VER]",
        "VendorID": "VendorID\/[VER]",
        "iPad": "iPad.*CPU[a-z ]+[VER]",
        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
        "iPod": "iPod.*CPU[a-z ]+[VER]",
        "Kindle": "Kindle\/[VER]",
        "Chrome": [
            "Chrome\/[VER]",
            "CriOS\/[VER]",
            "CrMo\/[VER]"
        ],
        "Coast": [
            "Coast\/[VER]"
        ],
        "Dolfin": "Dolfin\/[VER]",
        "Firefox": [
            "Firefox\/[VER]",
            "FxiOS\/[VER]"
        ],
        "Fennec": "Fennec\/[VER]",
        "Edge": "Edge\/[VER]",
        "IE": [
            "IEMobile\/[VER];",
            "IEMobile [VER]",
            "MSIE [VER];",
            "Trident\/[0-9.]+;.*rv:[VER]"
        ],
        "NetFront": "NetFront\/[VER]",
        "NokiaBrowser": "NokiaBrowser\/[VER]",
        "Opera": [
            " OPR\/[VER]",
            "Opera Mini\/[VER]",
            "Version\/[VER]"
        ],
        "Opera Mini": "Opera Mini\/[VER]",
        "Opera Mobi": "Version\/[VER]",
        "UCBrowser": [
            "UCWEB[VER]",
            "UC.*Browser\/[VER]"
        ],
        "MQQBrowser": "MQQBrowser\/[VER]",
        "MicroMessenger": "MicroMessenger\/[VER]",
        "baiduboxapp": "baiduboxapp\/[VER]",
        "baidubrowser": "baidubrowser\/[VER]",
        "SamsungBrowser": "SamsungBrowser\/[VER]",
        "Iron": "Iron\/[VER]",
        "Safari": [
            "Version\/[VER]",
            "Safari\/[VER]"
        ],
        "Skyfire": "Skyfire\/[VER]",
        "Tizen": "Tizen\/[VER]",
        "Webkit": "webkit[ \/][VER]",
        "PaleMoon": "PaleMoon\/[VER]",
        "Gecko": "Gecko\/[VER]",
        "Trident": "Trident\/[VER]",
        "Presto": "Presto\/[VER]",
        "Goanna": "Goanna\/[VER]",
        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
        "Android": "Android [VER]",
        "BlackBerry": [
            "BlackBerry[\\w]+\/[VER]",
            "BlackBerry.*Version\/[VER]",
            "Version\/[VER]"
        ],
        "BREW": "BREW [VER]",
        "Java": "Java\/[VER]",
        "Windows Phone OS": [
            "Windows Phone OS [VER]",
            "Windows Phone [VER]"
        ],
        "Windows Phone": "Windows Phone [VER]",
        "Windows CE": "Windows CE\/[VER]",
        "Windows NT": "Windows NT [VER]",
        "Symbian": [
            "SymbianOS\/[VER]",
            "Symbian\/[VER]"
        ],
        "webOS": [
            "webOS\/[VER]",
            "hpwOS\/[VER];"
        ]
    },
    "utils": {
        "Bot": "Googlebot|facebookexternalhit|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom",
        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
        "DesktopMode": "WPDesktop",
        "TV": "SonyDTV|HbbTV",
        "WebKit": "(webkit)[ \/]([\\w.]+)",
        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
        "Watch": "SM-V700"
    }
};

    // following patterns come from http://detectmobilebrowsers.com/
    impl.detectMobileBrowsers = {
        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        tabletPattern: /android|ipad|playbook|silk/i
    };

    var hasOwnProp = Object.prototype.hasOwnProperty,
        isArray;

    impl.FALLBACK_PHONE = 'UnknownPhone';
    impl.FALLBACK_TABLET = 'UnknownTablet';
    impl.FALLBACK_MOBILE = 'UnknownMobile';

    isArray = ('isArray' in Array) ?
        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };

    function equalIC(a, b) {
        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
    }

    function containsIC(array, value) {
        var valueLC, i, len = array.length;
        if (!len || !value) {
            return false;
        }
        valueLC = value.toLowerCase();
        for (i = 0; i < len; ++i) {
            if (valueLC === array[i].toLowerCase()) {
                return true;
            }
        }
        return false;
    }

    function convertPropsToRegExp(object) {
        for (var key in object) {
            if (hasOwnProp.call(object, key)) {
                object[key] = new RegExp(object[key], 'i');
            }
        }
    }

    function prepareUserAgent(userAgent) {
        return (userAgent || '').substr(0, 500); // mitigate vulnerable to ReDoS
    }

    (function init() {
        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
        for (key in mobileDetectRules.props) {
            if (hasOwnProp.call(mobileDetectRules.props, key)) {
                values = mobileDetectRules.props[key];
                if (!isArray(values)) {
                    values = [values];
                }
                len = values.length;
                for (i = 0; i < len; ++i) {
                    value = values[i];
                    verPos = value.indexOf('[VER]');
                    if (verPos >= 0) {
                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
                    }
                    values[i] = new RegExp(value, 'i');
                }
                mobileDetectRules.props[key] = values;
            }
        }
        convertPropsToRegExp(mobileDetectRules.oss);
        convertPropsToRegExp(mobileDetectRules.phones);
        convertPropsToRegExp(mobileDetectRules.tablets);
        convertPropsToRegExp(mobileDetectRules.uas);
        convertPropsToRegExp(mobileDetectRules.utils);

        // copy some patterns to oss0 which are tested first (see issue#15)
        mobileDetectRules.oss0 = {
            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
        };
    }());

    /**
     * Test userAgent string against a set of rules and find the first matched key.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
     * @private
     */
    impl.findMatch = function(rules, userAgent) {
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    return key;
                }
            }
        }
        return null;
    };

    /**
     * Test userAgent string against a set of rules and return an array of matched keys.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
     * @private
     */
    impl.findMatches = function(rules, userAgent) {
        var result = [];
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    result.push(key);
                }
            }
        }
        return result;
    };

    /**
     * Check the version of the given property in the User-Agent.
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {String} version or <tt>null</tt> if version not found
     * @private
     */
    impl.getVersionStr = function (propertyName, userAgent) {
        var props = impl.mobileDetectRules.props, patterns, i, len, match;
        if (hasOwnProp.call(props, propertyName)) {
            patterns = props[propertyName];
            len = patterns.length;
            for (i = 0; i < len; ++i) {
                match = patterns[i].exec(userAgent);
                if (match !== null) {
                    return match[1];
                }
            }
        }
        return null;
    };

    /**
     * Check the version of the given property in the User-Agent.
     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {Number} version or <tt>NaN</tt> if version not found
     * @private
     */
    impl.getVersion = function (propertyName, userAgent) {
        var version = impl.getVersionStr(propertyName, userAgent);
        return version ? impl.prepareVersionNo(version) : NaN;
    };

    /**
     * Prepare the version number.
     *
     * @param {String} version
     * @return {Number} the version number as a floating number
     * @private
     */
    impl.prepareVersionNo = function (version) {
        var numbers;

        numbers = version.split(/[a-z._ \/\-]/i);
        if (numbers.length === 1) {
            version = numbers[0];
        }
        if (numbers.length > 1) {
            version = numbers[0] + '.';
            numbers.shift();
            version += numbers.join('');
        }
        return Number(version);
    };

    impl.isMobileFallback = function (userAgent) {
        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
    };

    impl.isTabletFallback = function (userAgent) {
        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
    };

    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
        if (cache.mobile !== undefined) {
            return;
        }
        var phone, tablet, phoneSized;

        // first check for stronger tablet rules, then phone (see issue#5)
        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
        if (tablet) {
            cache.mobile = cache.tablet = tablet;
            cache.phone = null;
            return; // unambiguously identified as tablet
        }

        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
        if (phone) {
            cache.mobile = cache.phone = phone;
            cache.tablet = null;
            return; // unambiguously identified as phone
        }

        // our rules haven't found a match -> try more general fallback rules
        if (impl.isMobileFallback(userAgent)) {
            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
            if (phoneSized === undefined) {
                cache.mobile = impl.FALLBACK_MOBILE;
                cache.tablet = cache.phone = null;
            } else if (phoneSized) {
                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
                cache.tablet = null;
            } else {
                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                cache.phone = null;
            }
        } else if (impl.isTabletFallback(userAgent)) {
            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
            cache.phone = null;
        } else {
            // not mobile at all!
            cache.mobile = cache.tablet = cache.phone = null;
        }
    };

    // t is a reference to a MobileDetect instance
    impl.mobileGrade = function (t) {
        // impl note:
        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
        // When changes are made in Mobile_Detect.php, copy this method and replace:
        //     $this-> / t.
        //     self::MOBILE_GRADE_(.) / '$1'
        //     , self::VERSION_TYPE_FLOAT / (nothing)
        //     isIOS() / os('iOS')
        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
        var $isMobile = t.mobile() !== null;

        if (
            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
            t.os('iOS') && t.version('iPad')>=4.3 ||
            t.os('iOS') && t.version('iPhone')>=3.1 ||
            t.os('iOS') && t.version('iPod')>=3.1 ||

            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
            ( t.version('Android')>2.1 && t.is('Webkit') ) ||

            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
            t.version('Windows Phone OS')>=7.0 ||

            // Blackberry 7 - Tested on BlackBerry Torch 9810
            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
            t.match('Playbook.*Tablet') ||

            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
            // Palm WebOS 3.0  - Tested on HP TouchPad
            t.match('hp.*TouchPad') ||

            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||

            // Chrome for Android - Tested on Android 4.0, 4.1 device
            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||

            // Skyfire 4.1 - Tested on Android 2.3 device
            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||

            // Opera Mobile 11.5-12: Tested on Android 2.3
            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||

            // Meego 1.2 - Tested on Nokia 950 and N9
            t.is('MeeGoOS') ||

            // Tizen (pre-release) - Tested on early hardware
            t.is('Tizen') ||

            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
            // @todo: more tests here!
            t.is('Dolfin') && t.version('Bada')>=2.0 ||

            // UC Browser - Tested on Android 2.3 device
            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||

            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
            ( t.match('Kindle Fire') ||
                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||

            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
            t.is('AndroidOS') && t.is('NookTablet') ||

            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
            t.version('Chrome')>=11 && !$isMobile ||

            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
            t.version('Safari')>=5.0 && !$isMobile ||

            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
            t.version('Firefox')>=4.0 && !$isMobile ||

            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
            t.version('MSIE')>=7.0 && !$isMobile ||

            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
            // @reference: http://my.opera.com/community/openweb/idopera/
            t.version('Opera')>=10 && !$isMobile

            ){
            return 'A';
        }

        if (
            t.os('iOS') && t.version('iPad')<4.3 ||
            t.os('iOS') && t.version('iPhone')<3.1 ||
            t.os('iOS') && t.version('iPod')<3.1 ||

            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||

            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
                (t.version('Android')>=2.3 || t.is('iOS')) ) ||

            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||

            // @todo: report this (tested on Nokia N71)
            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
            ){
            return 'B';
        }

        if (
        // Blackberry 4.x - Tested on the Curve 8330
            t.version('BlackBerry')<5.0 ||
            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2

            ){
            return 'C';
        }

        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
        //will receive the basic, C grade experience.
        return 'C';
    };

    impl.detectOS = function (ua) {
        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
            impl.findMatch(impl.mobileDetectRules.oss, ua);
    };

    impl.getDeviceSmallerSide = function () {
        return window.screen.width < window.screen.height ?
            window.screen.width :
            window.screen.height;
    };

    /**
     * Constructor for MobileDetect object.
     * <br>
     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
     *     <strong>Find information how to download and install:</strong>
     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
     * </div>
     *
     * @example <pre>
     *     var md = new MobileDetect(window.navigator.userAgent);
     *     if (md.mobile()) {
     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
     *     }
     * </pre>
     *
     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
     *        as phone.
     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
     *        for Android</a>.<br>
     *        If you provide a value < 0, then this "fuzzy" check is disabled.
     * @constructor
     * @global
     */
    function MobileDetect(userAgent, maxPhoneWidth) {
        this.ua = prepareUserAgent(userAgent);
        this._cache = {};
        //600dp is typical 7" tablet minimum width
        this.maxPhoneWidth = maxPhoneWidth || 600;
    }

    MobileDetect.prototype = {
        constructor: MobileDetect,

        /**
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */
        mobile: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.mobile;
        },

        /**
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
         * Wolfgang, Alcatel, Nintendo, Amoi, INQ, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */
        phone: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.phone;
        },

        /**
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
         * GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */
        tablet: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.tablet;
        },

        /**
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */
        userAgent: function () {
            if (this._cache.userAgent === undefined) {
                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgent;
        },

        /**
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */
        userAgents: function () {
            if (this._cache.userAgents === undefined) {
                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgents;
        },

        /**
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */
        os: function () {
            if (this._cache.os === undefined) {
                this._cache.os = impl.detectOS(this.ua);
            }
            return this._cache.os;
        },

        /**
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */
        version: function (key) {
            return impl.getVersion(key, this.ua);
        },

        /**
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */
        versionStr: function (key) {
            return impl.getVersionStr(key, this.ua);
        },

        /**
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */
        is: function (key) {
            return containsIC(this.userAgents(), key) ||
                   equalIC(key, this.os()) ||
                   equalIC(key, this.phone()) ||
                   equalIC(key, this.tablet()) ||
                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
        },

        /**
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */
        match: function (pattern) {
            if (!(pattern instanceof RegExp)) {
                pattern = new RegExp(pattern, 'i');
            }
            return pattern.test(this.ua);
        },

        /**
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */
        isPhoneSized: function (maxPhoneWidth) {
            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
        },

        /**
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */
        mobileGrade: function () {
            if (this._cache.grade === undefined) {
                this._cache.grade = impl.mobileGrade(this);
            }
            return this._cache.grade;
        }
    };

    // environment-dependent
    if (typeof window !== 'undefined' && window.screen) {
        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
        };
    } else {
        MobileDetect.isPhoneSized = function () {};
    }

    // should not be replaced by a completely new object - just overwrite existing methods
    MobileDetect._impl = impl;
    
    MobileDetect.version = '1.4.2 2018-06-10';

    return MobileDetect;
}); // end of call of define()
})((function (undefined) {
    if (typeof module !== 'undefined' && module.exports) {
        return function (factory) { module.exports = factory(); };
    } else if (true) {
        return __webpack_require__(134);
    } else if (typeof window !== 'undefined') {
        return function (factory) { window.MobileDetect = factory(); };
    } else {
        // please file a bug if you get this error!
        throw new Error('unknown environment');
    }
})());

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Checkbox__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Label__ = __webpack_require__(31);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var classNames = __webpack_require__(8);


var CheckboxGroup = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-group', props.className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Label__["a" /* default */], null, props.title),
        props.checkOptions.map(function (check, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Checkbox__["a" /* default */], __assign({ key: index }, check))); }),
        props.children));
};
/* harmony default export */ __webpack_exports__["a"] = (CheckboxGroup);


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Checkbox__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Label__ = __webpack_require__(31);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var classNames = __webpack_require__(8);


var CheckboxGroupSerialize = function (props) {
    var valuesArray;
    if (!props.values) {
        valuesArray = [];
    }
    else {
        valuesArray = JSON.parse(props.values);
    }
    props.checkOptions.forEach(function (check) {
        check.value = check.name;
        if (valuesArray.indexOf(check.name) > -1) {
            check.checked = true;
        }
        else {
            check.checked = false;
        }
    });
    var onChange = function (e) {
        if (!props.values) {
            valuesArray = [];
        }
        else {
            valuesArray = JSON.parse(props.values);
        }
        var values;
        if (e.target.checked) {
            values = valuesArray.concat([e.target.name]);
        }
        else {
            values = valuesArray.filter(function (x) { return x !== e.target.name; });
        }
        var eventProperties = {
            target: {
                value: JSON.stringify(values),
                type: 'checkboxSerial',
                name: props.name
            }
        };
        props.onUpdate(eventProperties);
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-group', props.className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Label__["a" /* default */], null, props.title),
        props.checkOptions.map(function (check, index) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Checkbox__["a" /* default */], __assign({ key: index }, check, { onChange: onChange })); }),
        props.children));
};
/* harmony default export */ __webpack_exports__["a"] = (CheckboxGroupSerialize);


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DropdownInput__ = __webpack_require__(61);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var RELATIONSHIP_PICKLISTTYPEID = '111eb11dfdfae711b9c80028f80bded3';
var defaultFamilyRelationshipOptions = [
    {
        text: '',
        value: ''
    }
];
var FamilyRelationshipDropdown = /** @class */ (function (_super) {
    __extends(FamilyRelationshipDropdown, _super);
    function FamilyRelationshipDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.relationshipOptions = defaultFamilyRelationshipOptions;
        _this.relationshipOptions = _this.props.relationships.map(function (p) {
            return { text: p.description, value: p.id };
        });
        return _this;
    }
    FamilyRelationshipDropdown.prototype.componentWillReceiveProps = function (nextProps) {
        this.relationshipOptions = nextProps.relationships.map(function (p) {
            return { text: p.description, value: p.id };
        });
    };
    FamilyRelationshipDropdown.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DropdownInput__["a" /* default */], { labelText: this.props.labelText, name: this.props.name || 'relationship', id: this.props.id, defaultOption: this.props.defaultOption || '-', options: this.relationshipOptions, onChange: this.props.onChange, value: this.props.relationship || '', className: this.props.className, required: this.props.required }));
    };
    return FamilyRelationshipDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state, ownProps) {
    return {
        relationships: state.pickList.items.filter(function (p) { return p.pickListTypeId === RELATIONSHIP_PICKLISTTYPEID; })
    };
}
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(FamilyRelationshipDropdown));


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CountryDropdown__ = __webpack_require__(154);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var FOREIGN_COUNTRIES_PICKLISTTYPEID = '10f482f2a73ee811b9dc0028f80bded3';
var ForeignCountryDropdown = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__CountryDropdown__["a" /* default */], __assign({}, props, { countries: props.countries })));
};
function mapStateToProps(state, ownProps) {
    var countries = state.pickList.items.filter(function (p) { return p.pickListTypeId === FOREIGN_COUNTRIES_PICKLISTTYPEID; });
    countries = countries.sort(function (a, b) {
        if (a.code < b.code) {
            return -1;
        }
        if (a.code > b.code) {
            return 1;
        }
        return 0;
    });
    return {
        countries: countries
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(ForeignCountryDropdown));


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var classNames = __webpack_require__(8);
var FormCheckConditional = /** @class */ (function (_super) {
    __extends(FormCheckConditional, _super);
    function FormCheckConditional() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormCheckConditional.prototype.render = function () {
        var _a = this.props, className = _a.className, contentClassName = _a.contentClassName, children = _a.children, isOpen = _a.isOpen;
        return isOpen ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-check-conditional', className) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content-wrapper" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-check-conditional-content', contentClassName) }, children)))) : null;
    };
    return FormCheckConditional;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FormCheckConditional);


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DropdownInput__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var defaultProvinceOptions = [
    {
        text: '',
        value: ''
    }
];
var ProvinceDropdown = /** @class */ (function (_super) {
    __extends(ProvinceDropdown, _super);
    function ProvinceDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.provinceOptions = defaultProvinceOptions;
        _this.provinceOptions = _this.props.provinces.map(function (p) {
            return { text: p.description, value: p.description };
        });
        return _this;
    }
    ProvinceDropdown.prototype.componentWillReceiveProps = function (nextProps) {
        this.provinceOptions = nextProps.provinces.map(function (p) {
            return { text: p.description, value: p.description };
        });
    };
    ProvinceDropdown.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DropdownInput__["a" /* default */], { labelText: this.props.labelText, name: this.props.name || 'province', defaultOption: "-", options: this.provinceOptions, onChange: this.props.onChange, value: this.props.province || '', className: this.props.className, required: this.props.required }));
    };
    return ProvinceDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state, ownProps) {
    return {
        provinces: state.pickList.items.filter(function (p) { return p.pickListTypeId === __WEBPACK_IMPORTED_MODULE_3__common_utils__["g" /* PickListType */].Provinces; })
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(ProvinceDropdown));


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Label__ = __webpack_require__(31);

var classNames = __webpack_require__(8);

var RadioGroup = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-group', props.className, {
            'form-group-required': props.required
        }), onBlur: props.onBlur, onChange: props.onChange },
        props.title && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Label__["a" /* default */], { required: props.required }, props.title),
        props.radioOptions.map(function (radio) { return (
        // TODO: Only include wrapper div if conditionalChildren exists
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-check-wrapper', radio.className), key: radio.value },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-check custom-control custom-radio', {
                    disabled: radio.disabled
                }) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "radio", name: props.name, value: radio.value, id: radio.id, checked: radio.checked, onBlur: radio.onBlur, onChange: radio.onChange, disabled: radio.disabled, className: "form-check-input custom-control-input" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "form-check-label custom-control-label", htmlFor: radio.id }, radio.label)),
            radio.conditionalChildren)); }),
        props.children));
};
/* harmony default export */ __webpack_exports__["a"] = (RadioGroup);


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var classNames = __webpack_require__(8);
var TextInput = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", __assign({}, props, { type: props.type ? props.type : 'text', className: classNames('form-control form-table-control', props.className) })));
};
/* unused harmony default export */ var _unused_webpack_default_export = (TextInput);


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Label__ = __webpack_require__(31);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

var classNames = __webpack_require__(8);

var TextInput = function (_a) {
    var className = _a.className, labelText = _a.labelText, addOnBefore = _a.addOnBefore, addOnAfter = _a.addOnAfter, controlClassName = _a.controlClassName, helpBlock = _a.helpBlock, props = __rest(_a, ["className", "labelText", "addOnBefore", "addOnAfter", "controlClassName", "helpBlock"]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-group', className) },
        labelText && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Label__["a" /* default */], { required: props.required, htmlFor: props.id || props.name }, labelText)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "input-group" },
            addOnBefore && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "input-group-prepend" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "input-group-text" }, addOnBefore))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", __assign({}, props, { id: props.id || props.name, type: props.type ? props.type : 'text', value: props.value || '', className: classNames('form-control', { 'is-invalid': props.error && props.error.hasError }, controlClassName) })),
            addOnAfter && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "input-group-append" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "input-group-text" }, addOnAfter))),
            helpBlock && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-help-block form-text text-muted" }, helpBlock),
            props.error && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "invalid-feedback" }, props.error.message))));
};
/* harmony default export */ __webpack_exports__["a"] = (TextInput);


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Label__ = __webpack_require__(31);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

var classNames = __webpack_require__(8);

var TextArea = function (_a) {
    var className = _a.className, wrapperStyle = _a.wrapperStyle, labelText = _a.labelText, controlClassName = _a.controlClassName, props = __rest(_a, ["className", "wrapperStyle", "labelText", "controlClassName"]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-group', className), style: wrapperStyle },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Label__["a" /* default */], { htmlFor: props.name, required: props.required }, labelText),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("textarea", __assign({}, props, { className: classNames('form-control', controlClassName) }))));
};
/* harmony default export */ __webpack_exports__["a"] = (TextArea);


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Label__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons__ = __webpack_require__(7);

var classNames = __webpack_require__(8);


var ToggleSwitch = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-group toggle-switch', props.className, { disabled: props.disabled }) },
        props.labelText && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Label__["a" /* default */], null, props.labelText),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "toggle-switch-button" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: "toggle-switch-radio", type: "radio", id: (props.id || props.name) + 'On', name: props.name, value: 'true', onBlur: props.onBlur, onChange: props.onChange, checked: props.checked === true, disabled: props.disabled }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: classNames('toggle-switch-label toggle-left', props.checked === true ? 'toggle-on' : 'toggle-off'), htmlFor: (props.id || props.name) + 'On' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "toggle-switch-text align-middle" }, props.onChildren),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__icons__["p" /* IconCheck */], { className: "toggle-switch-icon ml-2" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "toggle-switch-button" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { className: "toggle-switch-radio", type: "radio", id: (props.id || props.name) + 'Off', name: props.name, value: 'false', onBlur: props.onBlur, onChange: props.onChange, checked: props.checked === false, disabled: props.disabled }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: classNames('toggle-switch-label toggle-right', props.checked === false ? 'toggle-on' : 'toggle-off'), htmlFor: (props.id || props.name) + 'Off' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "toggle-switch-text align-middle" }, props.offChildren),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__icons__["p" /* IconCheck */], { className: "toggle-switch-icon ml-2" })))),
        props.conditionalChildren));
};
/* harmony default export */ __webpack_exports__["a"] = (ToggleSwitch);


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons_Button__ = __webpack_require__(16);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var LandingFirstChildPage = /** @class */ (function (_super) {
    __extends(LandingFirstChildPage, _super);
    function LandingFirstChildPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LandingFirstChildPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["b" /* Page */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["d" /* PageHeader */], { title: "Life Insurance and your first child" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-8 offset-md-2" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section section-right section-secondary" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons_Button__["a" /* default */], { to: "/quote", className: "btn-primary" }, "CTA to Quote Workflow")))))));
    };
    return LandingFirstChildPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LandingFirstChildPage);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sections__ = __webpack_require__(23);




var AboutUsPage = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_common__["b" /* Page */], { title: "About Us" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_helmet__["Helmet"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { charSet: "utf-8" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "Mosaic Life is relevant, simple, and affordable life insurance. " +
                    "100% Canadian-owned and operated. We call Edmonton home, but service all of Canada." }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "About Mosaic Life | Mosaic Life")),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_sections__["b" /* SectionMain */], { sectionClassName: "my-4 section-lg" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_common__["d" /* PageHeader */], { title: "About Mosaic Life" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "In choosing an insurance company, it\u2019s important to consider who is providing your protection."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Mosaic Life is part of First Canadian Insurance Corporation, a life insurance company that has been in business for over 30 years. First Canadian is rated \u2018A (Excellent)\u2019 by A.M. Best, the major ratings agency for insurance companies."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Our mission is to protect the lives of Canadians through relevant, simple, and affordable products. We are 100% Canadian-owned and operated. We call Edmonton home, but we provide insurance across the country."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0" }, "We launched Mosaic Life out of our own need for protection. The Mosaic Life team is a bunch of 20 and 30-somethings who needed coverage, but found the available options not relevant and too complicated. So we decided to reimagine how life insurance should work\u2014100% online, totally flexible, no brokers, simple.")),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-4 mt-md-0 py-md-4 landing-section" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "landing-section-img landing-section-img-02 landing-section-img-right", role: "img", "aria-label": "A man holding a small child with their home and trees in the background" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_sections__["a" /* SectionLeft */], { columns: 8, sectionClassName: "section-lg" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h3" }, "Our Values"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", { className: "mt-4" }, "Act with integrity"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Life insurance is about trust. We have to trust each other to be fair and honest at all times. That means we trust you'll be honest with us in setting up your coverage."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", { className: "mt-4" }, "Community"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We care about giving back to the community that supports us. We're actively involved with the United Way, and we love it when our employees get involved."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", { className: "mt-4" }, "In it for the long haul"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We protect our customers over long time horizons, which means we're careful in how we manage our business. This is reflected in our 'A (Excellent)' rating by A.M. Best."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", { className: "mt-4" }, "Customer Focused"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We want to earn your business by giving you affordable and reliable coverage, and quality customer service."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", { className: "mt-4" }, "Different from the big guys"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We want to bring a new approach to life insurance\u2014one that is easy for people to use and affordable to buy. We do it all online because, like you, we like simple."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", { className: "mt-4" }, "Talk to us"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    "We are taking insurance online, but we're not robots. If you have a question or a problem, please",
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "/contact-us" }, "contact us"),
                    " directly.")))));
};
/* harmony default export */ __webpack_exports__["a"] = (AboutUsPage);


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_authActions__ = __webpack_require__(17);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






// import { FormCheckConditional } from '../components/forms';

var FAQPage = /** @class */ (function (_super) {
    __extends(FAQPage, _super);
    function FAQPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            section0: {
                sectionHeaderExpanded: true,
                q1Expanded: false,
                q2Expanded: false,
                q3Expanded: false
            },
            section1: {
                sectionHeaderExpanded: true,
                q1Expanded: false,
                q2Expanded: false,
                q3Expanded: false,
                q4Expanded: false,
                q5Expanded: false,
                q6Expanded: false,
                q7Expanded: false
            },
            section2: {
                sectionHeaderExpanded: true,
                q1Expanded: false,
                q2Expanded: false,
                q3Expanded: false,
                q4Expanded: false,
                q5Expanded: false,
                q6Expanded: false,
                q7Expanded: false,
                q8Expanded: false,
                q9Expanded: false,
                q10Expanded: false
            },
            section3: {
                sectionHeaderExpanded: true,
                q1Expanded: false,
                q2Expanded: false,
                q3Expanded: false,
                q4Expanded: false,
                q5Expanded: false
            },
            section4: {
                sectionHeaderExpanded: true,
                q1Expanded: false,
                q2Expanded: false
            },
            section5: {
                sectionHeaderExpanded: true,
                q1Expanded: false,
                q2Expanded: false,
                q3Expanded: false,
                q4Expanded: false,
                q5Expanded: false,
                q6Expanded: false,
            },
            section6: {
                sectionHeaderExpanded: true,
                q1Expanded: false,
                q2Expanded: false,
                q3Expanded: false,
                q4Expanded: false
            }
        };
        _this.onRedirectClick = function (e) {
            e.preventDefault();
            if (_this.props.currentUser.isAuthenticated) {
                if (_this.props.currentUser.role !== undefined) {
                    if (_this.props.currentUser.role[0] !== 'Customer') {
                        return _this.props.history.push('/admin');
                    }
                    else {
                        return _this.props.history.push('/user');
                    }
                }
            }
            else {
                _this.props.actions.login();
            }
        };
        _this.onSectionToggle = function (section, header) {
            _this.setState((_a = {},
                _a[section] = __assign({}, _this.state[section], (_b = {}, _b[header] = !_this.state[section][header], _b)),
                _a));
            var _a, _b;
        };
        return _this;
    }
    FAQPage.prototype.componentDidMount = function () {
        if (this.props.currentUser.isAuthenticated) {
            if (this.props.currentUser.role !== undefined) {
                if (this.props.currentUser.role[0] !== 'Customer') {
                    return this.props.history.push('/admin');
                }
                else if (!this.props.currentUser.hasBeenDirected) {
                    this.props.actions.doneDirect(this.props.currentUser);
                    return this.props.history.push('/user');
                }
            }
        }
    };
    FAQPage.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["b" /* Page */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_helmet__["Helmet"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { charSet: "utf-8" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "Mosaic life is here to make life insurance less overwhelming and more understandable. " +
                        "Discover the most frequently asked questions we get about life insurance." }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Frequently Asked Questions | Mosaic Life")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["d" /* PageHeader */], { title: "Frequently Asked Questions" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "faq-section" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "faq-question" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section0.sectionHeaderExpanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section0', 'sectionHeaderExpanded'); } },
                            this.state.section0.sectionHeaderExpanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Questions about Mosaic Life"))),
                    this.state.section0.sectionHeaderExpanded &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section0.q1Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section0', 'q1Expanded'); } },
                                            this.state.section0.q1Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Where is Mosaic Life located?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section0.q1Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                                    "We are 100% Canadian-owned and operated.",
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                                                    "We call Edmonton home, but we provide insurance across the country.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section0.q2Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section0', 'q2Expanded'); } },
                                            this.state.section0.q2Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "How do I contact Mosaic Life?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section0.q2Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                                    "Call us at ",
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "tel:1-855-643-6945" }, "1-855-643-6945"),
                                                    ", chat with us online, or email us at",
                                                    ' ',
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "mailto:info@insuredbymosaic.ca" }, "info@insuredbymosaic.ca"),
                                                    ". We look forward to hearing from you!")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section0.q3Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section0', 'q3Expanded'); } },
                                            this.state.section0.q3Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Who is backing Mosaic Life?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section0.q3Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Mosaic Life policies are backed by First Canadian Insurance Corporation, a Canadian life insurance company that has been in business for over 30 years. First Canadian has provided protection to over 1 million Canadian families.  First Canadian is rated \u2018A (Excellent) with stable outlook\u2019 by A.M. Best, the major ratings agency for insurance companies.")))))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "faq-section" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "faq-question" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section1.sectionHeaderExpanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section1', 'sectionHeaderExpanded'); } },
                            this.state.section1.sectionHeaderExpanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Life Insurance"))),
                    this.state.section1.sectionHeaderExpanded &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section1.q1Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section1', 'q1Expanded'); } },
                                            this.state.section1.q1Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "What is life insurance?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section1.q1Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Life is full of unexpected events, some positive, and unfortunately, some negative. Life insurance provides financial protection for your loved ones in the event that you pass away. If you die while your policy is in place, your loved ones will receive a financial payout, known in the industry as the \u2018death benefit\u2019 (we know, it\u2019s kind of morbid), and in exchange for that protection, you pay a monthly payment, known as the 'premium'.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section1.q2Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section1', 'q2Expanded'); } },
                                            this.state.section1.q2Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Do I need life insurance?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section1.q2Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "People commonly buy life insurance after important life events, such as getting married, having a child, buying a home, or starting a new job. Bottom line is, if you have people in your life who you are financially responsible for, you should consider life insurance so that they have support in case you pass away."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Unfortunately, most people overlook life insurance until they actually need it, at which point the cost of insurance increases significantly (assuming you can find coverage at all). The best time to buy insurance is when you are young and healthy. Plan for future you.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section1.q3Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section1', 'q3Expanded'); } },
                                            this.state.section1.q3Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Can I get life insurance through my employer?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section1.q3Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Absolutely, and you should consider doing so if it\u2019s offered as part of your employee benefits."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "However, many employer-based plans limit your coverage to a certain percentage of your income, and quite often, that amount is not enough to cover your financial obligations in the event you die. So, many people top up their employer-based plans with additional term life insurance."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "The additional benefits of a term policy over employer-based coverage are that with a term policy, coverage stays in place in the event you switch jobs, and the premiums do not increase as you get older."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                                    "Use our ",
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "/quote/B/about-you" }, "calculator"),
                                                    " to figure out how much insurance you need in addition to your employer-provided coverage.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section1.q4Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section1', 'q4Expanded'); } },
                                            this.state.section1.q4Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "How much coverage do I need?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section1.q4Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "While there are general rules of thumb (e.g., budgeting 1% of gross income for insurance premiums), there\u2019s no single right answer, because the amount of coverage you need will depend on your current and expected future life situation."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "There are a number of factors to consider, such as family size, income, lifestyle, savings, debt, and budget. On top of that, the reality is that your insurance needs will likely change over time. For example, you might want more coverage if you have an addition to the family, or you might want less coverage after your mortgage is paid off."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                                    "Our ",
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "/quote/B/about-you" }, "calculator"),
                                                    " can help you determine the appropriate amount of coverage based on your personal situation."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Remember that life insurance doesn't have to be an all or none decision. Even if you can\u2019t afford the amount of coverage you would like, having at least some coverage will help protect your loved ones.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section1.q5Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section1', 'q5Expanded'); } },
                                            this.state.section1.q5Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "How long of a term do I need?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section1.q5Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Mosaic Life offers terms ranging from 10 years to \u201CT65\u201D (industry lingo for coverage until you turn 65 years old)."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "The appropriate term for you will vary based on your personal situation. Things to consider include how long you expect to be financially responsible for others, your current and expected savings and debts, and your budget. Also keep in mind that financial commitments can vary over time. For example, you might need additional insurance when you have a new child, and less when a child graduates from college and starts working."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                                    "Our ",
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "/quote/B/about-you" }, "calculator"),
                                                    " can help you figure out the right term based on your personal situation.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section1.q6Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section1', 'q6Expanded'); } },
                                            this.state.section1.q6Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "If I die, who receives the life insurance payout?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section1.q6Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Your payout is paid to the person(s) you name as your beneficiary on the beneficiary designation form. For most people, the payout is made to close family members (e.g., spouse, children, or parents). You are allowed to name more than one beneficiary if you\u2019d like. In that case, you need to allocate each beneficiary a percentage or dollar amount of the payout."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "If you do not complete a beneficiary designation form, the payout will be made to your estate.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section1.q7Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section1', 'q7Expanded'); } },
                                            this.state.section1.q7Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "What\u2019s an underwriter?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section1.q7Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "The underwriter is the insurance company that is backing the policy\u2014i.e., the one who is on the hook for paying out the death benefit. It is important that the underwriter be financially stable so that you can be confident that it will be around when you need it. A third party rating agency, A.M. Best, provides ratings on the financial health of various insurance companies."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Mosaic Life\u2019s underwriter is First Canadian Insurance Corporation, headquartered in Edmonton, Alberta. First Canadian has been in business for over 30 years and has an A.M. Best rating of \u2018A (Excellent) with stable outlook\u2019.")))))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "faq-section" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "faq-question" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section2.sectionHeaderExpanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section2', 'sectionHeaderExpanded'); } },
                            this.state.section2.sectionHeaderExpanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Obtaining Coverage"))),
                    this.state.section2.sectionHeaderExpanded &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section2.q1Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section2', 'q1Expanded'); } },
                                            this.state.section2.q1Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "How do I buy a Mosaic Life policy?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section2.q1Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We offer our policies directly to consumers through our online application. Unlike most insurance companies, we do not rely on brokers or agents, which means we don\u2019t pay a sales commissions every time a policy is sold. We pass those savings on to you.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section2.q10Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section2', 'q10Expanded'); } },
                                            this.state.section2.q10Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "How does the free two month offer work?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section2.q10Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "When you purchase a new Mosaic Life policy, the first two months of your coverage will be absolutely free.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section2.q2Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section2', 'q2Expanded'); } },
                                            this.state.section2.q2Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Who is eligible to apply for a Mosaic Life policy?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section2.q2Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Mosaic Life is available to Canadian citizens and residents between the ages of 18 and 55.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section2.q3Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section2', 'q3Expanded'); } },
                                            this.state.section2.q3Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "How long does it take to get coverage?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section2.q3Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We believe that protecting your loved ones should be simple. Healthy individuals are able to obtain coverage with Mosaic Life in as little as 10 minutes.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section2.q4Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section2', 'q4Expanded'); } },
                                            this.state.section2.q4Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Will I need to complete a medical exam or provide bodily fluids as part of my application?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section2.q4Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "For most people, no. Unlike other life insurers, we do not typically require you to provide blood and urine samples or to complete a medical exam. Instead, we base our decision on our online questionnaire, which for most people, takes under 10 minutes to complete.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section2.q5Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section2', 'q5Expanded'); } },
                                            this.state.section2.q5Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "What\u2019s the maximum coverage I can take?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section2.q5Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "You can have up to $1 million Canadian in aggregate coverage from Mosaic Life. This limit applies across all of your Mosaic Life policies.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section2.q6Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section2', 'q6Expanded'); } },
                                            this.state.section2.q6Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "What am I covered for? What is not covered?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section2.q6Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                                    "Your policy covers you if you die during the term of the policy, unless your death is related to one of the following:",
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null,
                                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "suicide within the first two years of the policy"),
                                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "you committing or attempting to commit a criminal act (including driving under the influence)"),
                                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "an act of war (whether declared or not)"))),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Based on your answers to our questionnaire, your policy may also exclude certain risky lifestyle activities. If this is the case your policy will explicitly call out these activities so that there is no ambiguity about what's not covered."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "You will also not be covered if your application is deemed fraudulent or contains a material misrepresentation. This includes not accurately disclosing your smoking habits on the application.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section2.q7Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section2', 'q7Expanded'); } },
                                            this.state.section2.q7Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Can I switch to Mosaic Life if I already have a life policy?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section2.q7Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "No, Mosaic Life policies are not intended to replace other existing coverage. But you are allowed to have a Mosaic Life policy alongside of another insurer's policy.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section2.q8Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section2', 'q8Expanded'); } },
                                            this.state.section2.q8Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Will I ever need more than one policy?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section2.q8Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Potentially, depending on how your personal situation changes over time. With Mosaic Life, it\u2019s easy to apply for additional policies as you need more coverage (and cancel them as you need less coverage). Each individual can get coverage up to an aggregate limit of $1 million Canadian.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section2.q9Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section2', 'q9Expanded'); } },
                                            this.state.section2.q9Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Is the death benefit taxed?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section2.q9Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "In the majority of cases, if you've completed your beneficiary designation form, the benefit is not taxed. But our lawyers tell us we\u2019re not tax experts so you should seek advice if you\u2019re unsure.")))))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "faq-section" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "faq-question" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section3.sectionHeaderExpanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section3', 'sectionHeaderExpanded'); } },
                            this.state.section3.sectionHeaderExpanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Premiums"))),
                    this.state.section3.sectionHeaderExpanded &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section3.q1Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section3', 'q1Expanded'); } },
                                            this.state.section3.q1Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "What\u2019s a premium?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section3.q1Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Your premium is the amount you pay each month to maintain your insurance coverage. Premiums vary by individual based on factors such as the desired coverage amount, the length of the policy, and the applicant\u2019s age, gender, tobacco usage, lifestyle, and medical history.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section3.q2Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section3', 'q2Expanded'); } },
                                            this.state.section3.q2Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Will my premiums change over time?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section3.q2Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Your monthly premiums will not change during the term of your policy."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "That said, if you apply for an additional Mosaic Life policy, your premiums for that new policy will possibly be different from the premiums for your existing policy, as you will be older and your lifestyle and medical situation may have changed.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section3.q3Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section3', 'q3Expanded'); } },
                                            this.state.section3.q3Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Will my premiums change if I\u2019m diagnosed with an illness?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section3.q3Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "No. After you purchase your policy, your premiums are guaranteed for the term of that policy."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "However, if you have an illness (or symptoms of an illness) before you apply for insurance and don\u2019t properly disclose it on your application, your coverage may be voided for misrepresentation or fraud.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section3.q4Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section3', 'q4Expanded'); } },
                                            this.state.section3.q4Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "How do I pay my premium?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section3.q4Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "You can pay your monthly premium by credit card.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section3.q5Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section3', 'q5Expanded'); } },
                                            this.state.section3.q5Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "What happens if I miss my premium payment?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section3.q5Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "If you do not make a premium payment in full by the due date, you will have a 31-day grace period to make the payment. After that grace period, your coverage will automatically terminate.")))))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "faq-section" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "faq-question" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section4.sectionHeaderExpanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section4', 'sectionHeaderExpanded'); } },
                            this.state.section4.sectionHeaderExpanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Data & Security"))),
                    this.state.section4.sectionHeaderExpanded &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section4.q1Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section4', 'q1Expanded'); } },
                                            this.state.section4.q1Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "What happens to the information I give you?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section4.q1Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We use the information you provide on your application to make a decision on your application and for our own risk-monitoring analytics."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We will not sell your information to third-party advertisers.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section4.q2Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section4', 'q2Expanded'); } },
                                            this.state.section4.q2Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "How secure is my information?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section4.q2Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We have taken a technology-first approach to insurance. This includes focusing heavily on data security. We do not store login credentials or credit card information on our servers, and all data is fully encrypted.")))))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "faq-section" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "faq-question" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section5.sectionHeaderExpanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section5', 'sectionHeaderExpanded'); } },
                            this.state.section5.sectionHeaderExpanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Managing My Policy"))),
                    this.state.section5.sectionHeaderExpanded &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section5.q1Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section5', 'q1Expanded'); } },
                                            this.state.section5.q1Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Can I modify my policy?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section5.q1Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "You are able to make limited changes to your policy, including changes to your beneficiaries, contact information, and payment details.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section5.q2Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section5', 'q2Expanded'); } },
                                            this.state.section5.q2Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "How do I change a beneficiary?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section5.q2Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                                    "To change a beneficiary, you will need to update your beneficiary designation form. You can find instructions on how to do this when you sign into your",
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: this.onRedirectClick, href: "#" }, " online account"),
                                                    ".")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section5.q3Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section5', 'q3Expanded'); } },
                                            this.state.section5.q3Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "How do I change my contact information and payment details?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section5.q3Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                                    "You can manage your contact information and payment details by signing in to your ",
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { onClick: this.onRedirectClick, href: "#" }, " online account"),
                                                    ".")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section5.q4Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section5', 'q4Expanded'); } },
                                            this.state.section5.q4Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Can I cancel my policy?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section5.q4Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Yes, you can cancel your policy at any time."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "If you cancel within 30 days of your policy's start date, you will receive a full refund of your premium. If you cancel after that, you will receive a pro-rated refund of the premium you paid in the month you cancel."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "If you have multiple Mosaic Life policies, you can choose to cancel certain policies while keeping others in place. Stacking and unstacking policies is an effective way of increasing or decreasing coverage as your life situation changes over time.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section5.q5Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section5', 'q5Expanded'); } },
                                            this.state.section5.q5Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Is there a fee for modifying or cancelling a policy?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section5.q5Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Nope.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section5.q6Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section5', 'q6Expanded'); } },
                                            this.state.section5.q6Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Can I review a sample policy prior to signing up?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section5.q6Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                                    "Here is a ",
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "/Term Life Policy Sample.pdf", target: "_blank" }, "sample policy"),
                                                    ".")))))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "faq-section" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "faq-question" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section6.sectionHeaderExpanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section6', 'sectionHeaderExpanded'); } },
                            this.state.section6.sectionHeaderExpanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Claims"))),
                    this.state.section6.sectionHeaderExpanded &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section6.q1Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section6', 'q1Expanded'); } },
                                            this.state.section6.q1Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Where will my loved ones find the details they need to submit a claim?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section6.q1Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Good question. Sharing policy details with loved ones is often an overlooked step after obtaining insurance coverage. It is important that you have a plan ahead of time so that your loved ones know about your policy if you pass away."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "While each family situation is different, to the extent you want to notify your beneficiaries of this policy upfront, you can share the policy by email through our online portal. If you select this option, your beneficiaries will be notified any time changes to your beneficiary designation form are made."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Also, in the event we see a missed premium payment on your policy, we will try to contact you to fix the issue. You have the option of providing a backup contact for us to reach out to if we are unable to get ahold of you regarding the payment in the event that your payments ceased due to your passing.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section6.q2Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section6', 'q2Expanded'); } },
                                            this.state.section6.q2Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "I\u2019m a beneficiary, next-of-kin, or estate executor. How do I file a claim?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section6.q2Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "First off, we\u2019re sorry for your loss."),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                                    "You can initiate your claim either ",
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "/claims" }, "online"),
                                                    " or by calling us at ",
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "tel:780-417-5480" }, "780-417-5480"),
                                                    ".")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section6.q3Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section6', 'q3Expanded'); } },
                                            this.state.section6.q3Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "What information is needed to submit a claim?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section6.q3Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                                    "An authorized person (e.g., a beneficiary, next of kin, or estate trustee) will need to submit a claim. In order to validate the claim, we will need to verify certain information, including the following:",
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null,
                                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "the date and cause of death"),
                                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "the insured\u2019s age, sex at birth, and smoking class at the time of application"),
                                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "that the person making the claim has the authority to do so"))),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                                    "There are a few documents that may be needed to process a claim, such as the following:",
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null,
                                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "an authorization for release of personal information"),
                                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "a claimant's statement"),
                                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "a physician statement"),
                                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "death certificate and either birth certificate or driver's license"),
                                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "if the cause of death is accidental, a police report or workplace accident report"))),
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "It may sound like a lot, but our claims team will walk you through the process step-by-step.")))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "faq-question" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.section6.q4Expanded ? ' active' : ''), onClick: function () { return _this.onSectionToggle('section6', 'q4Expanded'); } },
                                            this.state.section6.q4Expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["k" /* IconAdd */], null),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "How long does it take to receive a life insurance payout?"))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional faq-question-answer " + (this.state.section6.q4Expanded ? '' : 'd-none') },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditonal-content-wrapper" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check-conditional-content" },
                                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We try to process claims as quickly as possible, though there are some necessary administrative steps we have to take when we receive a claim to minimize the risk of fraud. Our goal is to process your claim in under 5 business days from when we receive the required documentation for the claim.")))))))))));
    };
    return FAQPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        currentUser: state.auth.currentUser
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_6__auth_authActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(FAQPage));


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_scroll__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_authActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HomePageAssessment__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HomePageAssessmentBottom__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_sections__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_logo_mosaic_life_inverse_no_tm_svg__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_logo_mosaic_life_inverse_no_tm_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_logo_mosaic_life_inverse_no_tm_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_logo_running_room_inverse_svg__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_logo_running_room_inverse_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_logo_running_room_inverse_svg__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
















var scorLogoSrc = __webpack_require__(98);
var RunningHomePage = /** @class */ (function (_super) {
    __extends(RunningHomePage, _super);
    function RunningHomePage(props) {
        var _this = _super.call(this, props) || this;
        _this.onAltCtaClick = function () {
            var topOffset = 15;
            var navbar = document.querySelector('.navbar-wrapper.fixed-top');
            if (navbar) {
                topOffset += navbar.clientHeight;
            }
            __WEBPACK_IMPORTED_MODULE_1_react_scroll__["scroller"].scrollTo('homePageAssessment', {
                duration: 300,
                smooth: true,
                offset: -topOffset
            });
        };
        return _this;
    }
    RunningHomePage.prototype.componentWillMount = function () {
        document.body.classList.add('page-running-room');
    };
    RunningHomePage.prototype.componentDidMount = function () {
        if (this.props.currentUser.isAuthenticated) {
            if (this.props.currentUser.role !== undefined) {
                if (this.props.currentUser.role[0] !== 'Customer') {
                    if (this.props.currentUser.role.some(function (r) { return r === 'Adjudicator'; })) {
                        return this.props.history.push('/admin/adjudication');
                    }
                    else {
                        return this.props.history.push('/admin');
                    }
                }
                else if (!this.props.currentUser.hasBeenDirected) {
                    this.props.actions.doneDirect(this.props.currentUser);
                    return this.props.history.push('/user');
                }
            }
        }
        var referralCode = 'RunningRoom';
        this.props.actions.setReferralCode(referralCode);
    };
    RunningHomePage.prototype.componentWillUnmount = function () {
        document.body.classList.remove('page-running-room');
    };
    RunningHomePage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_common__["b" /* Page */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { charSet: "utf-8" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "Simple. Direct. Affordable. Discover your life insurance options in just 10 minutes" +
                        "and receive a free pair of running shoes from the Running Room when you apply." }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Mosaic Life - Simple & Afforadable Life Insurance | Runners")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("header", { className: "page-hero page-hero-running page-hero-lg" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "page-hero-content" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-5 text-light d-flex flex-column" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_sections__["a" /* SectionLeft */], { columns: 12, wrapperClassName: "page-hero-partners", sectionClassName: "pt-3 pr-3 pb-3 pl-0" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-flex align-items-center" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: __WEBPACK_IMPORTED_MODULE_15__assets_images_logo_running_room_inverse_svg___default.a, className: "page-hero-partner-logo", alt: "Running Room Logo" }),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "mx-3" }, "+"),
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: __WEBPACK_IMPORTED_MODULE_14__assets_images_logo_mosaic_life_inverse_no_tm_svg___default.a, className: "page-hero-partner-logo", title: "Mosaic Life Logo" }))),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "page-hero-title page-title-display mb-0 mb-md-2" }, "Life insurance for runners"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0 page-hero-lead-lg max-read-width mt-1 mb-3 strong" },
                                        "Sign up and get a free pair of ",
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "d-inline-block" }, "running shoes! *")),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_buttons_Button__["a" /* default */], { className: "btn-primary btn-primary-inverse my-3 page-hero-cta-alt", onClick: this.onAltCtaClick },
                                        "Get started",
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_icons__["l" /* IconArrowDown */], { className: "ml-2" })))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 offset-md-1 mt-3 mt-md-0 px-0 d-flex flex-column justify-content-center" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_scroll__["Element"], { name: "homePageAssessment" }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_sections__["c" /* SectionRight */], { columns: 12, sectionClassName: "pr-0" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__HomePageAssessment__["a" /* default */], null))))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container my-4 my-md-6" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: "card-deck" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "card" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "card-body section section-lg" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "mb-3 text-primary" }, "*Get a free pair of shoes!"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0 mb-md-4 mb-lg-3" }, "How it works: Sign up for a policy with a minimum premium of $25/month and we\u2019ll send you a $150 Running Room gift card. Gift card will be sent by email 31 days after you enroll."),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_icons__["G" /* IconRunningShoes */], { className: "icon-running-shoes text-primary" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "card" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "card-body section section-lg" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "mb-3" }, "Coverage for an active lifestyle"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "You take care of yourself and should be rewarded for it. Mosaic Life offers great rates for active people."))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "card" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "card-body section section-lg" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "mb-3" }, "It\u2019s easy"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Unlike other insurers, Mosaic Life doesn\u2019t require medical exams or urine samples. You can get coverage in 10 minutes, all online."))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: "mt-4 mt-md-6 container d-none d-lg-block" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "mb-3" }, "Why Choose Mosaic Life"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row row-x-1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container", onTouchStart: function (e) { return e; } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Convenient and easy"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "Most insurers require you to provide blood and urine samples and can take weeks to issue a policy. With Mosaic Life, you can get coverage in 10 minutes just by answering some lifestyle and health questions online.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Direct"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "We\u2019ve cut out the middlemen to give you an experience that\u2019s free of hefty fees, commissions, and complexity.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-lg-3 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Team Canada"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "Mosaic Life is proudly for Canadians, by Canadians.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Affordable"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "By skipping pricey broker commissions and taking insurance online, we\u2019re able to offer $1 million of coverage for as little as $1/day.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-lg-3 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Guaranteed rates"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "Your premiums are set for the term of your policy. Even if you get sick during your policy term, your premiums will not change.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Relevant"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "We launched Mosaic Life out of our own need for protection. We've reimagined how life insurance should work\u2014100% online, totally flexible, no brokers, simple.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Cancel anytime (with money-back guarantee)"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "You can cancel your policy at any time and for any reason. If you cancel in the first 30 days, we will give you a full refund of your premium.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-lg-3 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "No fees"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "Besides your monthly premium, there are no additional fees to obtain coverage.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Flexible"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "We offer a range of terms and coverage amounts to meet your specific needs. You can have up to $1 million in total coverage across as many policies as you would like.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-lg-3 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Insurance you can trust"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "We try to be honest, transparent, and helpful. Your privacy is important to us.")))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_sections__["b" /* SectionMain */], { sectionClassName: "mt-4 mt-md-6 section-lg" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-5 col-lg-4 text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_icons__["K" /* LogoFirstCanadian */], { className: "landing-section-logo landing-section-logo-fc" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-7 col-lg-8 mt-4 mt-md-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Mosaic Life policies are underwritten by First Canadian Insurance Corporation, a life insurer based in Edmonton that has provided protection to over 1 million Canadian families.  First Canadian has been around for over 30 years and is rated A (with stable outlook) by A.M. Best, the leading ratings agency for insurance companies."))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-center mt-4 mt-md-5" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-5 col-lg-4 text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: scorLogoSrc, alt: "The logo of SCOR (The Art & Science of Risk)", className: "landing-section-logo landing-section-logo-scor" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-7 col-lg-8 mt-4 mt-md-0 order-md-first" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Mosaic Life is also backed by SCOR, one of the world\u2019s largest reinsurers and a leader in the creation of innovative risk management solutions for insurance companies. SCOR has been around for almost 50 years and is rated A+ (with stable outlook) by A.M. Best.")))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: "mt-4 mt-md-6 section section-lg bg-secondary text-light" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__HomePageAssessmentBottom__["a" /* default */], null)))));
    };
    return RunningHomePage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        currentUser: state.auth.currentUser,
        referrerName: state.user.referrerName
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_7__auth_authActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_4__node_modules_redux__["bindActionCreators"])(actions, dispatch),
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(RunningHomePage)));


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-mosaic-life-inverse-no-tm.6cf76f86.svg";

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-running-room-inverse.222b6707.svg";

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_scroll__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_authActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HomePageAssessment__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HomePageAssessmentBottom__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_sections__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__HomeownersHomeFlipCard__ = __webpack_require__(453);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};















var scorLogoSrc = __webpack_require__(98);
var HomeonwersHomePage = /** @class */ (function (_super) {
    __extends(HomeonwersHomePage, _super);
    function HomeonwersHomePage(props) {
        var _this = _super.call(this, props) || this;
        _this.onAltCtaClick = function () {
            var topOffset = 15;
            var navbar = document.querySelector('.navbar-wrapper.fixed-top');
            if (navbar) {
                topOffset += navbar.clientHeight;
            }
            __WEBPACK_IMPORTED_MODULE_1_react_scroll__["scroller"].scrollTo('homePageAssessment', {
                duration: 300,
                smooth: true,
                offset: -topOffset
            });
        };
        _this.onAccordionClick = function (accordionOpenIndex) {
            if (_this.state.accordionOpenIndex === accordionOpenIndex) {
                _this.setState({ accordionOpenIndex: undefined });
            }
            else {
                _this.setState({ accordionOpenIndex: accordionOpenIndex });
            }
        };
        _this.state = {
            accordionOpenIndex: undefined,
        };
        return _this;
    }
    HomeonwersHomePage.prototype.componentWillMount = function () {
        document.body.classList.add('page-homeowners');
    };
    HomeonwersHomePage.prototype.componentDidMount = function () {
        if (this.props.currentUser.isAuthenticated) {
            if (this.props.currentUser.role !== undefined) {
                if (this.props.currentUser.role[0] !== 'Customer') {
                    if (this.props.currentUser.role.some(function (r) { return r === 'Adjudicator'; })) {
                        return this.props.history.push('/admin/adjudication');
                    }
                    else {
                        return this.props.history.push('/admin');
                    }
                }
                else if (!this.props.currentUser.hasBeenDirected) {
                    this.props.actions.doneDirect(this.props.currentUser);
                    return this.props.history.push('/user');
                }
            }
        }
        var referralCode = 'Homeowners';
        this.props.actions.setReferralCode(referralCode);
    };
    HomeonwersHomePage.prototype.componentWillUnmount = function () {
        document.body.classList.remove('page-homeowners');
    };
    HomeonwersHomePage.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_common__["b" /* Page */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { charSet: "utf-8" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "Simple. Direct. Affordable. Discover your life insurance options in just 10 minutes and apply " +
                        "for up to $1 million in coverage to protect your family and your mortgage." }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Mosaic Life - Simple & Afforadable Life Insurance | Homeowners")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("header", { className: "page-hero page-hero-homeowners page-hero-lg" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "page-hero-content" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-5 text-light d-flex flex-column justify-content-center" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "page-hero-title page-title-display mb-0 mb-md-2" }, "Term life insurance for Canadian homeowners"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0 page-hero-lead-lg max-read-width mt-1 mb-3 strong" }, "Protect your mortgage with a term policy in just 10 minutes."),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_buttons_Button__["a" /* default */], { className: "btn-primary btn-primary-inverse my-3 page-hero-cta-alt", onClick: this.onAltCtaClick },
                                        "Get started",
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_icons__["l" /* IconArrowDown */], { className: "ml-2" })))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 offset-md-1 mt-3 mt-md-0 px-0 d-flex flex-column justify-content-center" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_scroll__["Element"], { name: "homePageAssessment" }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_sections__["c" /* SectionRight */], { columns: 12, sectionClassName: "pr-0" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__HomePageAssessment__["a" /* default */], null))))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: "section-main my-4 my-md-6" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, "Mosaic Life: A Better Type of Insurance"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                            "Mosaic Life term insurance is a better way to protect your mortgage than the creditor insurance your lender offers.",
                            ' ',
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Check out the differences below:"))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__HomeownersHomeFlipCard__["a" /* default */], { title: "Lower Rates", icon: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_icons__["g" /* HomeownersIconLowerRates */], { className: "flip-icon-comparison" }), primaryChildren: "Mosaic Life is able to offer lower rates by skipping the expensive brokers and instead dealing directly with you. \n\t\t\t\t\t\t\t\tMosaic Life coverage starts as low as $6 per month (and your premium remain fixed for the entire term of your policy).", secondaryChildren: "For most people, creditor life insurance is more expensive than term life insurance.", isOpened: this.state.accordionOpenIndex === 0, onCollapseClick: function () { return _this.onAccordionClick(0); } }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__HomeownersHomeFlipCard__["a" /* default */], { title: "Fixed coverage amount", icon: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_icons__["c" /* HomeownersIconFixedAmount */], { className: "flip-icon-comparison" }), primaryChildren: "With Mosaic Life, your benefit amount doesn\u2019t decrease.", secondaryChildren: "With mortgage insurance, your benefit amount decreases as you pay down your mortgage (while your premium stays the same).", isOpened: this.state.accordionOpenIndex === 1, onCollapseClick: function () { return _this.onAccordionClick(1); } }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__HomeownersHomeFlipCard__["a" /* default */], { title: "You choose the beneficiary", icon: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_icons__["h" /* HomeownersIconPickBeneficiaries */], { className: "flip-icon-comparison" }), primaryChildren: "With Mosaic Life, you choose who receives the benefit (for example, your spouse or kids).", secondaryChildren: "With mortgage insurance, if you die, the benefit is paid directly to the mortgage lender. ", isOpened: this.state.accordionOpenIndex === 2, onCollapseClick: function () { return _this.onAccordionClick(2); } }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__HomeownersHomeFlipCard__["a" /* default */], { title: "Portable", icon: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_icons__["i" /* HomeownersIconPortable */], { className: "flip-icon-comparison" }), primaryChildren: "With Mosaic Life, your coverage remains in force if you switch mortgage lenders (or if you pay off your mortgage).", secondaryChildren: "With mortgage insurance, if you change your lender to get a better rate, you\u2019ll have to reapply for coverage \n\t\t\t\t\t\t\t\t(likely at a higher rate because you\u2019ll be older).", isOpened: this.state.accordionOpenIndex === 3, onCollapseClick: function () { return _this.onAccordionClick(3); } }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__HomeownersHomeFlipCard__["a" /* default */], { title: "Flexible", icon: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_icons__["d" /* HomeownersIconFlexible */], { className: "flip-icon-comparison" }), primaryChildren: "With Mosaic Life, it\u2019s easy to add or decrease coverage as your life circumstances change \n\t\t\t\t\t\t\t\t(e.g., if you have a kid or pay off the mortgage).", secondaryChildren: "With mortgage insurance, the maximum coverage you can have is your mortgage amount outstanding.", isOpened: this.state.accordionOpenIndex === 4, onCollapseClick: function () { return _this.onAccordionClick(4); } }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__HomeownersHomeFlipCard__["a" /* default */], { title: "Quick and easy", icon: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_icons__["j" /* HomeownersIconQuick */], { className: "flip-icon-comparison" }), primaryChildren: "With Mosaic Life, if you\u2019re generally healthy, you can get up to $1 million of coverage in just 10 minutes, entirely online.", secondaryChildren: "Mortgage insurance requires you to meet in person with your lender or broker, manually fill out paperwork, \n\t\t\t\t\t\t\t\tand possibly undergo a medical exam.", isOpened: this.state.accordionOpenIndex === 5, onCollapseClick: function () { return _this.onAccordionClick(5); } }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-4 mt-md-0 pt-md-6 landing-section" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "landing-section-img homeowners-section-img-01 landing-section-img-right" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_sections__["a" /* SectionLeft */], { columns: 8, sectionClassName: "section-lg" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "mb-3" }, "How Mosaic Life Works"),
                    "If you're young & healthy (the best time to buy life insurance), getting protection from Mosaic Life is simple:",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ol", { className: "custom-ol" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "custom-ol-content" },
                                "Choose a term and coverage amount (if you're unsure, ",
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "/quote/B/about-you" }, "we can help"),
                                ").")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "custom-ol-content" }, "Answer some quick lifestyle and health questions.")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "custom-ol-content" }, "Get an instant decision and sign up."))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Once you're covered, if you die during the term of your protection, your loved ones will receive your coverage amount."),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "You can apply for up to $1 million of coverage, and it's easy to add or cancel policies if your needs change. If you change your mind during the first 30 days, you can cancel your policy and get a full refund."),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_buttons_Button__["a" /* default */], { to: "/faq", className: "btn-outline-primary mt-3" }, "Learn more"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: "mt-4 mt-md-6 container d-none d-lg-block" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "mb-3" }, "Why Choose Mosaic Life"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row row-x-1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container", onTouchStart: function (e) { return e; } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Convenient and easy"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "Most insurers require you to provide blood and urine samples and can take weeks to issue a policy. With Mosaic Life, you can get coverage in 10 minutes just by answering some lifestyle and health questions online.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Direct"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "We\u2019ve cut out the middlemen to give you an experience that\u2019s free of hefty fees, commissions, and complexity.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-lg-3 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Team Canada"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "Mosaic Life is proudly for Canadians, by Canadians.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Affordable"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "By skipping pricey broker commissions and taking insurance online, we\u2019re able to offer $1 million of coverage for as little as $1/day.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-lg-3 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Guaranteed rates"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "Your premiums are set for the term of your policy. Even if you get sick during your policy term, your premiums will not change.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Relevant"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "We launched Mosaic Life out of our own need for protection. We've reimagined how life insurance should work\u2014100% online, totally flexible, no brokers, simple.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Cancel anytime (with money-back guarantee)"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "You can cancel your policy at any time and for any reason. If you cancel in the first 30 days, we will give you a full refund of your premium.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-lg-3 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "No fees"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "Besides your monthly premium, there are no additional fees to obtain coverage.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Flexible"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "We offer a range of terms and coverage amounts to meet your specific needs. You can have up to $1 million in total coverage across as many policies as you would like.")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-lg-3 mb-2 px-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "front" }, "Insurance you can trust"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back" }, "We try to be honest, transparent, and helpful. Your privacy is important to us.")))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_sections__["b" /* SectionMain */], { sectionClassName: "mt-4 mt-md-6 section-lg" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-5 col-lg-4 text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_icons__["K" /* LogoFirstCanadian */], { className: "landing-section-logo landing-section-logo-fc" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-7 col-lg-8 mt-4 mt-md-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Mosaic Life policies are underwritten by First Canadian Insurance Corporation, a life insurer based in Edmonton that has provided protection to over 1 million Canadian families.  First Canadian has been around for over 30 years and is rated A (with stable outlook) by A.M. Best, the leading ratings agency for insurance companies."))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-center mt-4 mt-md-5" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-5 col-lg-4 text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: scorLogoSrc, alt: "The logo of SCOR (The Art & Science of Risk)", className: "landing-section-logo landing-section-logo-scor" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-7 col-lg-8 mt-4 mt-md-0 order-md-first" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Mosaic Life is also backed by SCOR, one of the world\u2019s largest reinsurers and a leader in the creation of innovative risk management solutions for insurance companies. SCOR has been around for almost 50 years and is rated A+ (with stable outlook) by A.M. Best.")))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: "mt-4 mt-md-6 section section-lg bg-secondary text-light" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__HomePageAssessmentBottom__["a" /* default */], null)))));
    };
    return HomeonwersHomePage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        currentUser: state.auth.currentUser,
        referrerName: state.user.referrerName
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_7__auth_authActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_4__node_modules_redux__["bindActionCreators"])(actions, dispatch),
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["b" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(HomeonwersHomePage)));


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons__ = __webpack_require__(7);


var classNames = __webpack_require__(8);
var Collapse = __webpack_require__(454).Collapse;

var HomeownersHomeFlipCard = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-container flip-container-collapsible border-top shadow-none p-0" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_buttons__["a" /* Button */], { className: classNames('btn-block d-lg-none section shadow-none flip-collapse-toggler', { 'active': props.isOpened }), onClick: props.onCollapseClick },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "media align-items-center" },
                props.icon,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h4 mb-0 ml-3 media-body" }, props.title),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_icons__["r" /* IconChevronDown */], { className: "flip-collapse-toggler-icon text-secondary ml-2" }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Collapse, { isOpened: props.isOpened },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flipper flipper-vertical" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "front section shadow-none d-none d-lg-flex" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-center font-weight-bold" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg-4 text-secondary media text-left align-items-center" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-content-icon-wrapper" }, props.icon),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "mb-0 ml-4 media-body" }, props.title)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg text-center text-secondary large" },
                            "Mosaic Life",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                            "Term Insurance",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "icon-maple-leaf-abstract" })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg-auto large text-muted" }, "vs."),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg text-center text-muted large" },
                            "Creditor",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                            "Mortgage Insurance")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_icons__["f" /* HomeownersIconFlipUp */], { className: "flip-icon-marker" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "back section shadow-none" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg-4 align-self-center flip-content-icon-wrapper d-none d-lg-flex align-items-center" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flip-content-icon-wrapper" }, props.icon),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "mb-0 ml-4 flex-fill text-reset" }, props.title)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg media mb-3 mb-lg-0" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_icons__["a" /* HomeownersIconCheckOutline */], { className: "flip-icon-status" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-body ml-3" }, props.primaryChildren)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg media" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_icons__["b" /* HomeownersIconCrossOutline */], { className: "flip-icon-status" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "media-body ml-3" }, props.secondaryChildren))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_icons__["e" /* HomeownersIconFlipDown */], { className: "flip-icon-marker d-none d-lg-block" }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (HomeownersHomeFlipCard);


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(155),
    Collapse = _require.Collapse;

var _require2 = __webpack_require__(455),
    UnmountClosed = _require2.UnmountClosed;

UnmountClosed.Collapse = Collapse;
UnmountClosed.UnmountClosed = UnmountClosed;

module.exports = UnmountClosed;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnmountClosed = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Collapse = __webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnmountClosed = exports.UnmountClosed = function (_React$PureComponent) {
  _inherits(UnmountClosed, _React$PureComponent);

  function UnmountClosed(props) {
    _classCallCheck(this, UnmountClosed);

    var _this = _possibleConstructorReturn(this, (UnmountClosed.__proto__ || Object.getPrototypeOf(UnmountClosed)).call(this, props));

    _this.componentWillReceiveProps = function (_ref) {
      var isOpened = _ref.isOpened;

      if (!_this.props.isOpened && isOpened) {
        _this.setState({
          forceInitialAnimation: true,
          shouldUnmount: false
        });
      }
    };

    _this.onRest = function () {
      var _this$props = _this.props,
          isOpened = _this$props.isOpened,
          onRest = _this$props.onRest;


      if (!isOpened) {
        _this.setState({ shouldUnmount: true });
      }
      if (onRest) {
        onRest.apply(undefined, arguments);
      }
    };

    _this.state = {
      shouldUnmount: !_this.props.isOpened,
      forceInitialAnimation: !_this.props.isOpened
    };
    return _this;
  }

  _createClass(UnmountClosed, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpened = _props.isOpened,
          _onRest = _props.onRest,
          props = _objectWithoutProperties(_props, ['isOpened', 'onRest']);

      var _state = this.state,
          forceInitialAnimation = _state.forceInitialAnimation,
          shouldUnmount = _state.shouldUnmount;


      return shouldUnmount ? null : _react2.default.createElement(_Collapse.Collapse, _extends({
        forceInitialAnimation: forceInitialAnimation,
        isOpened: isOpened,
        onRest: this.onRest
      }, props));
    }
  }]);

  return UnmountClosed;
}(_react2.default.PureComponent);

UnmountClosed.propTypes = {
  isOpened: _propTypes2.default.bool.isRequired,
  onRest: _propTypes2.default.func
};

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_404Page__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__quotingActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__simple_SimpleWorkflow__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__advisory_AdvisoryWorkflow__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__bespoke_BespokeWorkflow__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__custom_CustomWorkflow__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__auth_authActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_settingsActions__ = __webpack_require__(99);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

















var QuotingPage = /** @class */ (function (_super) {
    __extends(QuotingPage, _super);
    function QuotingPage(props) {
        var _this = _super.call(this, props) || this;
        _this.setWorkflow = function (workflowParam) {
            var workflow = null;
            if (workflowParam === 'A') {
                workflow = __WEBPACK_IMPORTED_MODULE_8__simple_SimpleWorkflow__["a" /* default */];
            }
            else if (workflowParam === 'B') {
                workflow = __WEBPACK_IMPORTED_MODULE_9__advisory_AdvisoryWorkflow__["a" /* default */];
            }
            else if (workflowParam === 'C') {
                workflow = __WEBPACK_IMPORTED_MODULE_10__bespoke_BespokeWorkflow__["a" /* default */];
            }
            else if (workflowParam === 'Custom') {
                workflow = __WEBPACK_IMPORTED_MODULE_11__custom_CustomWorkflow__["a" /* default */];
            }
            _this.setState({ workflow: workflow });
        };
        _this.onUserChange = function (e) {
            var value = __WEBPACK_IMPORTED_MODULE_13__common_utils__["m" /* default */].parseValueFromEvent(e);
            var user = __assign({}, _this.props.user, (_a = {}, _a[e.target.name] = value, _a));
            _this.props.actions.setUser(user);
            // Set user's age based on birthdate
            if (e.target.name === 'birthDate') {
                var age = __WEBPACK_IMPORTED_MODULE_13__common_utils__["m" /* default */].getAgeRoundedFromBirthdate(e.target.value);
                var customerDetails = __assign({}, _this.props.customerDetails, { age: age });
                _this.props.actions.setCustomerDetails(customerDetails);
            }
            var _a;
        };
        _this.onCustomerDetailsChange = function (e) {
            if (e.target.type === 'text' && !e.target.validity.valid) {
                return;
            }
            var value = __WEBPACK_IMPORTED_MODULE_13__common_utils__["m" /* default */].parseValueFromEvent(e);
            var customerDetails = __assign({}, _this.props.customerDetails, (_a = {}, _a[e.target.name] = value, _a));
            _this.props.actions.setCustomerDetails(customerDetails);
            var _a;
        };
        _this.onCustomerDetailsNumberKeyUp = function (e) {
            var value = __WEBPACK_IMPORTED_MODULE_13__common_utils__["m" /* default */].formatNumberWithCommas(e.target.value);
            var customerDetails = __assign({}, _this.props.customerDetails, (_a = {}, _a[e.target.name] = value, _a));
            _this.props.actions.setCustomerDetails(customerDetails);
            var _a;
        };
        _this.onQuestionnairePaste = function (e) {
            e.preventDefault();
            var value = __WEBPACK_IMPORTED_MODULE_13__common_utils__["m" /* default */].formatNumberWithCommas(e.clipboardData.getData('Text'));
            var questionnaire = __assign({}, _this.props.questionnaire, (_a = {}, _a[e.target.name] = value, _a));
            _this.props.actions.setQuestionnaire(questionnaire);
            var _a;
        };
        _this.onQuestionnaireNumberKeyUp = function (e) {
            var value = __WEBPACK_IMPORTED_MODULE_13__common_utils__["m" /* default */].formatNumberWithCommas(e.target.value);
            var questionnaire = __assign({}, _this.props.questionnaire, (_a = {}, _a[e.target.name] = value, _a));
            _this.props.actions.setQuestionnaire(questionnaire);
            var _a;
        };
        _this.onQuestionnaireChange = function (e) {
            if (e.target.type === 'text' && !e.target.validity.valid) {
                return;
            }
            var value = __WEBPACK_IMPORTED_MODULE_13__common_utils__["m" /* default */].parseValueFromEvent(e);
            var questionnaire = __assign({}, _this.props.questionnaire, (_a = {}, _a[e.target.name] = value, _a));
            _this.props.actions.setQuestionnaire(questionnaire);
            // onblur doesn't work on safari or firefox on apple shit
            // so if this is a checkbox or radio save immediately rather than onblur
            if (_this.shouldSaveOnChangeRatherThanOnBlur(e.target.type)) {
                var formattedValue = _this.stringifyAnswerIfRequired(value);
                if (_this.shouldDebouncedUpdate(e.target.name)) {
                    _this.debounceUpdate(_this.props.customerPolicy.id, e.target.name, formattedValue);
                }
                else {
                    return _this.props.actions
                        .saveCustomerPolicyAnswer(_this.props.customerPolicy.id, e.target.name, formattedValue);
                }
            }
            else {
                return;
            }
            var _a;
        };
        _this.onQuestionnaireBlur = function (e) {
            // onblur doesn't work on safari or firefox on apple shit
            // so if this is a checkbox or radio the save has been handled on change rather than here
            if (!_this.shouldSaveOnChangeRatherThanOnBlur(e.target.type)) {
                var value = __WEBPACK_IMPORTED_MODULE_13__common_utils__["m" /* default */].parseValueFromEvent(e);
                var formattedValue = _this.stringifyAnswerIfRequired(value);
                return _this.props.actions.saveCustomerPolicyAnswer(_this.props.customerPolicy.id, e.target.name, formattedValue);
            }
            else {
                return;
            }
        };
        _this.shouldSaveOnChangeRatherThanOnBlur = function (targetType) {
            return (targetType === 'checkbox'
                || targetType === 'checkboxSerial'
                || targetType === 'radio'
                || targetType === 'custom');
        };
        // Note: the value is from TextInput but the event is being wrapped by other type events,
        // so comparing event types here doesn't really work.
        // Also even user is typing 'other values', the system is just updating the answer object,
        // since 'other values' is just property of the object 
        _this.shouldDebouncedUpdate = function (targetName) {
            return (targetName === 'cancer'
                || targetName === 'heartCirculatory'
                || targetName === 'neurological'
                || targetName === 'respiratory'
                || targetName === 'liver'
                || targetName === 'blood'
                || targetName === 'immuno'
                || targetName === 'head'
                || targetName === 'reproductive'
                || targetName === 'psychological');
        };
        _this.stringifyAnswerIfRequired = function (value) {
            if (typeof value === 'object') {
                return JSON.stringify(value);
            }
            else {
                return value;
            }
        };
        // tslint:disable-next-line
        _this.debounceUpdate = Object(__WEBPACK_IMPORTED_MODULE_14_lodash__["debounce"])(function (policyId, eventTargetName, jsonValue) {
            // tslint:disable-next-line
            return _this.props.actions.saveCustomerPolicyAnswer(policyId, eventTargetName, jsonValue);
        }, 500);
        _this.onCustomerPolicySelect = function (customerPolicy) {
            _this.props.actions.setSelectPlanOptionsEnabled(false);
            if (_this.props.customerPolicy.campaignCode) {
                customerPolicy.campaignCode = _this.props.customerPolicy.campaignCode;
            }
            _this.props.actions.setCustomerPolicy(customerPolicy);
            _this.saveAndRedirect("/quote/" + _this.props.match.params.workflow + "/enrollment/my-pledge");
        };
        _this.save = function () {
            return _this.props.actions.saveUser(_this.props.user)
                .then(function () {
                var customerDetails = __assign({}, _this.props.customerDetails, { customerId: _this.props.user.id });
                return _this.props.actions.saveCustomerDetails(customerDetails);
            })
                .then(function () { return _this.props.actions.saveCustomerFamilyList(_this.props.user.id, _this.props.customerFamilyList); })
                .then(function () {
                var referralCode = _this.props.referrals.referralCode;
                var customerPolicy = __assign({}, _this.props.customerPolicy, { customerId: _this.props.user.id });
                if (referralCode && !_this.props.customerPolicy.campaignCode) {
                    customerPolicy.campaignCode = referralCode;
                }
                return _this.props.actions.saveCustomerPolicy(customerPolicy);
            })
                .then(function () {
                // Save about you form fields to questionnaire
                var p1 = _this.props.actions
                    .saveCustomerPolicyAnswer(_this.props.customerPolicy.id, 'birthDate', _this.props.user.birthDate);
                var p2 = _this.props.actions
                    .saveCustomerPolicyAnswer(_this.props.customerPolicy.id, 'gender', _this.props.user.gender);
                // TODO: no isSmoker column in DB
                var p3 = _this.props.actions
                    .saveCustomerPolicyAnswer(_this.props.customerPolicy.id, 'isSmoker', _this.props.customerDetails.isSmoker);
                return Promise.all([p1, p2, p3]);
            });
        };
        _this.saveAndRedirect = function (url) {
            _this.save()
                .then(function () {
                _this.props.actions.setSelectPlanOptionsEnabled(true);
                _this.props.history.push(url);
            });
        };
        _this.state = {
            workflow: null
        };
        return _this;
    }
    QuotingPage.prototype.componentDidMount = function () {
        this.props.actions.fetchHeightWeightTable();
        // Set datepicker picked if birthdate already exists
        if (this.props.user.birthDate) {
            var age = __WEBPACK_IMPORTED_MODULE_13__common_utils__["m" /* default */].getAgeRoundedFromBirthdate(this.props.user.birthDate);
            var customerDetails = __assign({}, this.props.customerDetails, { age: age });
            this.props.actions.setCustomerDetails(customerDetails);
        }
        this.setWorkflow(this.props.match.params.workflow);
    };
    QuotingPage.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.match.params.workflow !== this.props.match.params.workflow ||
            nextProps.match.params.page !== this.props.match.params.page) {
            this.setWorkflow(nextProps.match.params.workflow);
        }
    };
    QuotingPage.prototype.render = function () {
        if (['a', 'b', 'c', 'custom'].indexOf(this.props.match.params.workflow.toLowerCase()) === -1) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_404Page__["a" /* default */], null);
        }
        var Workflow = this.state.workflow;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__components_common__["b" /* Page */], null, Workflow && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Workflow, __assign({}, this.props, { onUserChange: this.onUserChange, onCustomerDetailsChange: this.onCustomerDetailsChange, onCustomerDetailsNumberKeyUp: this.onCustomerDetailsNumberKeyUp, onQuestionnairePaste: this.onQuestionnairePaste, onCustomerPolicySelect: this.onCustomerPolicySelect, onQuestionnaireBlur: this.onQuestionnaireBlur, onQuestionnaireChange: this.onQuestionnaireChange, onQuestionnaireNumberKeyUp: this.onQuestionnaireNumberKeyUp, saveAndRedirect: this.saveAndRedirect })))));
    };
    return QuotingPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        user: state.user.user,
        referrals: state.user.referrals,
        customerDetails: state.quoting.customerDetails,
        customerFamilyList: state.quoting.customerFamilyList,
        customerPolicy: state.policy.customerPolicy,
        hwTable: state.quoting.hwTable,
        planOptions: state.policy.planOptions,
        paymentDetails: state.payment.details,
        questionnaire: state.policy.questionnaire,
        stripe: state.payment.stripe,
        assessment: state.quoting.assessment,
        currentUser: state.auth.currentUser,
        validReferral: state.quoting.validReferral,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_5__policy_policyActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__quotingActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__user_userActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__auth_authActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__common_settingsActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(QuotingPage)));


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sections__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkflowProgress__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SimpleAboutYouPage__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SimpleSelectYourPlanPage__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__ = __webpack_require__(63);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var SimpleWorkflow = function (props) {
    var Page = null;
    var activeStep = 0;
    if (props.match.params.page === 'about-you') {
        Page = __WEBPACK_IMPORTED_MODULE_4__SimpleAboutYouPage__["a" /* default */];
        activeStep = 0;
    }
    else if (props.match.params.page === 'select-your-policy') {
        Page = __WEBPACK_IMPORTED_MODULE_5__SimpleSelectYourPlanPage__["a" /* default */];
        activeStep = 1;
    }
    else if (props.match.params.page === 'enrollment') {
        Page = __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */];
        if (props.match.params.enrollmentPage === 'billing'
            || props.match.params.enrollmentPage === 'review'
            || props.match.params.enrollmentPage === 'beneficiary'
            || props.match.params.enrollmentPage === 'sign-up') {
            activeStep = 3;
        }
        else {
            activeStep = 2;
        }
    }
    else if (props.match.params.page == null) {
        if (props.customerDetails.age != null
            && props.user.gender != null
            && props.customerDetails.isSmoker != null) {
            props.history.replace("/quote/" + props.match.params.workflow + "/select-your-policy");
        }
        else {
            props.history.replace("/quote/" + props.match.params.workflow + "/about-you");
        }
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["c" /* PageContent */], { wrapperClassName: "mt-6", sectionClassName: "pt-0" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_sections__["b" /* SectionMain */], { sectionClassName: "section-sm section-extend-up bg-secondary text-light workflow-progress-wrapper", wrapperClassName: "mb-4 mb-md-5 px-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__WorkflowProgress__["a" /* default */], { buttonClassName: "btn-outline-light", steps: [
                        {
                            label: 'About you',
                            to: "/quote/" + props.match.params.workflow + "/about-you",
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 3
                        },
                        {
                            label: 'Select your policy',
                            to: "/quote/" + props.match.params.workflow + "/select-your-policy",
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 3
                        },
                        {
                            label: 'Apply for coverage',
                            onClick: function () { return props.saveAndRedirect("/quote/" + props.match.params.workflow + "/enrollment/my-pledge"); },
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 3
                        },
                        {
                            label: 'Review and billing',
                            onClick: function () { return props.saveAndRedirect("/quote/" + props.match.params.workflow + "/enrollment/review"); },
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 3
                        }
                    ], activeStep: activeStep })),
            Page !== null && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Page, __assign({}, props)))));
};
/* harmony default export */ __webpack_exports__["a"] = (SimpleWorkflow);


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AboutYou__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var SimpleAboutYouPage = /** @class */ (function (_super) {
    __extends(SimpleAboutYouPage, _super);
    function SimpleAboutYouPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errors = { age: {} };
        _this.validate = function () {
            // true means invalid
            return {
                age: __WEBPACK_IMPORTED_MODULE_6__common_utils__["k" /* Validation */].validateAge(_this.props.user.birthDate, _this.props.currentUser.isAuthenticated)
            };
        };
        _this.isNextDisabled = function () {
            if (_this.props.customerDetails.age == null
                || _this.props.user.gender == null
                || _this.props.customerDetails.isSmoker == null) {
                return true;
            }
            return _this.errors.age.hasError;
        };
        _this.next = function () {
            _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/select-your-policy");
        };
        return _this;
    }
    SimpleAboutYouPage.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__WorkflowStep__["a" /* default */], { title: "Before we begin, we'd like to get to know you better." },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms_Fieldset__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__AboutYou__["a" /* default */], __assign({}, this.props, { errors: this.errors }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons_Button__["a" /* default */], { onClick: this.next, className: "btn-primary", disabled: this.isNextDisabled() },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Select your policy"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["t" /* IconChevronRight */], null)))));
    };
    return SimpleAboutYouPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (SimpleAboutYouPage);


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PlanOptions__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_buttons_Button__ = __webpack_require__(16);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




var SimpleSelectYourPlanPage = /** @class */ (function (_super) {
    __extends(SimpleSelectYourPlanPage, _super);
    function SimpleSelectYourPlanPage(props) {
        var _this = _super.call(this, props) || this;
        _this.back = function () {
            _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/about-you");
        };
        _this.toCustomPolicy = function () {
            // const policy = this.props.planOptions[Math.floor(this.props.planOptions.length / 2)]; // set the middle option
            _this.props.actions.setCustomerPolicy(_this.props.planOptions);
            _this.props.history.push("/quote/Custom/select-your-policy");
        };
        _this.state = {
            isLoading: true
        };
        return _this;
    }
    SimpleSelectYourPlanPage.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props.user, gender = _a.gender, birthDate = _a.birthDate, id = _a.id;
        var _b = this.props.customerDetails, isSmoker = _b.isSmoker, age = _b.age;
        if (age == null || age < 18 || age > 65 || gender == null || isSmoker == null) {
            this.back();
        }
        else {
            var params = {
                gender: gender,
                smoking: isSmoker,
                birthdate: birthDate,
                userId: id
            };
            this.props.actions.fetchSimplePlanOptions(params)
                .then(function () { return _this.setState({ isLoading: false }); });
        }
    };
    SimpleSelectYourPlanPage.prototype.render = function () {
        if (this.props.planOptions.length > 0) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__WorkflowStep__["a" /* default */], { title: "We offer a range of protection products to meet your needs. Below are some popular options." },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__PlanOptions__["a" /* default */], __assign({}, this.props, { workflow: this.props.match.params.workflow, isLoading: this.state.isLoading, className: "text-center" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-5 text-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mx-auto max-read-width" }, "Need help deciding?"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons_Button__["a" /* default */], { to: "/quote/B/your-needs", className: "btn-outline-primary mb-4" }, "Use our calculator")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mx-auto max-read-width" }, "Need a different coverage amount or term?"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons_Button__["a" /* default */], { className: "btn-outline-primary", onClick: this.toCustomPolicy }, "Build a custom policy")))));
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__WorkflowStep__["a" /* default */], { title: "Sorry, we currently do not have any plans available for you." }));
        }
    };
    return SimpleSelectYourPlanPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (SimpleSelectYourPlanPage);


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons__ = __webpack_require__(7);

var classNames = __webpack_require__(8);

var QuotePlanDetails = function (_a) {
    var className = _a.className, children = _a.children, items = _a.items;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('quote-plan-details', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", { className: "d-block" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Coverage amount could support:")),
        items && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "mt-3 mb-0 list-unstyled" }, items.map(function (item, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "media", key: index },
            item.enabled ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_icons__["q" /* IconCheckCircle */], { className: "text-secondary" }) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_icons__["n" /* IconBlock */], { className: "disabled" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ml-2 media-body align-self-center" }, item.description))); })),
        children));
};
/* harmony default export */ __webpack_exports__["a"] = (QuotePlanDetails);


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_your_account_DisclaimerPage__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_your_account_BasicsPage__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__create_your_account_LifestylePage__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__create_your_account_ActivitiesPage__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__create_your_account_MedicalHistoryPage__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__billing_review_BillingReviewPage__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WorkflowProgress__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enrollment_SignUpPage__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__billing_review_OptionalBeneficiaryContainer__ = __webpack_require__(159);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};










var EnrollmentWorkflow = function (props) {
    var Page = null;
    var activeStep = 0;
    if (props.match.params.enrollmentPage === 'my-pledge') {
        Page = __WEBPACK_IMPORTED_MODULE_1__create_your_account_DisclaimerPage__["a" /* default */];
        activeStep = 0;
    }
    else if (props.match.params.enrollmentPage === 'basics') {
        Page = __WEBPACK_IMPORTED_MODULE_2__create_your_account_BasicsPage__["a" /* default */];
        activeStep = 1;
    }
    else if (props.match.params.enrollmentPage === 'lifestyle') {
        Page = __WEBPACK_IMPORTED_MODULE_3__create_your_account_LifestylePage__["a" /* default */];
        activeStep = 2;
    }
    else if (props.match.params.enrollmentPage === 'activities') {
        Page = __WEBPACK_IMPORTED_MODULE_4__create_your_account_ActivitiesPage__["a" /* default */];
        activeStep = 3;
    }
    else if (props.match.params.enrollmentPage === 'medical-history') {
        Page = __WEBPACK_IMPORTED_MODULE_5__create_your_account_MedicalHistoryPage__["a" /* default */];
        activeStep = 4;
    }
    else if (props.match.params.enrollmentPage === 'review') {
        Page = __WEBPACK_IMPORTED_MODULE_6__billing_review_BillingReviewPage__["a" /* default */];
        activeStep = 0;
    }
    else if (props.match.params.enrollmentPage === 'beneficiary') {
        Page = __WEBPACK_IMPORTED_MODULE_9__billing_review_OptionalBeneficiaryContainer__["a" /* default */];
        activeStep = 1;
    }
    else if (props.match.params.enrollmentPage === 'billing') {
        Page = __WEBPACK_IMPORTED_MODULE_6__billing_review_BillingReviewPage__["a" /* default */];
        activeStep = 2;
    }
    else if (props.match.params.enrollmentPage === 'sign-up') {
        Page = __WEBPACK_IMPORTED_MODULE_8__enrollment_SignUpPage__["a" /* default */];
        activeStep = 3;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        !(props.match.params.enrollmentPage === 'billing'
            || props.match.params.enrollmentPage === 'beneficiary'
            || props.match.params.enrollmentPage === 'review'
            || props.match.params.enrollmentPage === 'sign-up') && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__WorkflowProgress__["a" /* default */], { wrapperClassName: "mb-4 text-secondary enrollment-progress-bar", buttonClassName: "btn-outline-secondary", steps: [
                {
                    label: 'My Pledge',
                    to: "/quote/" + props.match.params.workflow + "/enrollment/my-pledge",
                    incomplete: false
                },
                {
                    label: 'Basics',
                    to: "/quote/" + props.match.params.workflow + "/enrollment/basics",
                    incomplete: false
                },
                {
                    label: 'Lifestyle',
                    to: "/quote/" + props.match.params.workflow + "/enrollment/lifestyle",
                    incomplete: false
                },
                {
                    label: 'Activities',
                    to: "/quote/" + props.match.params.workflow + "/enrollment/activities",
                    incomplete: false
                },
                {
                    label: 'Medical History',
                    to: "/quote/" + props.match.params.workflow + "/enrollment/medical-history",
                    incomplete: false
                }
            ], activeStep: activeStep })),
        (props.match.params.enrollmentPage === 'billing'
            || props.match.params.enrollmentPage === 'beneficiary'
            || props.match.params.enrollmentPage === 'review'
            || props.match.params.enrollmentPage === 'sign-up') && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__WorkflowProgress__["a" /* default */], { wrapperClassName: "mb-4 text-secondary enrollment-progress-bar", buttonClassName: "btn-outline-secondary", steps: [
                {
                    label: 'Review',
                    to: "/quote/" + props.match.params.workflow + "/enrollment/review",
                    incomplete: Page === __WEBPACK_IMPORTED_MODULE_8__enrollment_SignUpPage__["a" /* default */] && activeStep === 3
                },
                {
                    label: 'Beneficiaries',
                    // if user already filled up info on beneficiary page then display disbursement page instead
                    to: activeStep < 2 ? "/quote/" + props.match.params.workflow + "/enrollment/beneficiary" :
                        "/quote/" + props.match.params.workflow + "/enrollment/beneficiary#2",
                    incomplete: Page === __WEBPACK_IMPORTED_MODULE_8__enrollment_SignUpPage__["a" /* default */] && activeStep === 3
                },
                {
                    label: 'Billing',
                    to: "/quote/" + props.match.params.workflow + "/enrollment/billing",
                    incomplete: Page === __WEBPACK_IMPORTED_MODULE_8__enrollment_SignUpPage__["a" /* default */] && activeStep === 3
                },
                {
                    label: 'Sign Up',
                    to: "/quote/" + props.match.params.workflow + "/enrollment/sign-up",
                    incomplete: Page === __WEBPACK_IMPORTED_MODULE_8__enrollment_SignUpPage__["a" /* default */] && activeStep === 3
                }
            ], activeStep: activeStep })),
        Page !== null ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Page, __assign({}, props)) : null));
};
/* harmony default export */ __webpack_exports__["a"] = (EnrollmentWorkflow);


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DisclaimerForm__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_userAPI__ = __webpack_require__(81);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};









var DisclaimerPage = /** @class */ (function (_super) {
    __extends(DisclaimerPage, _super);
    function DisclaimerPage(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = { email: {} };
        _this.isNextDisabled = function () {
            if (!_this.props.questionnaire.declareTrue
                || !_this.props.user.firstName
                || !_this.props.user.lastName
                || !_this.props.user.email
                || !_this.props.user.phoneNumber
                || _this.state.isSaving) {
                return true;
            }
            return _this.errors.email.hasError;
        };
        _this.validate = function () {
            // true means invalid
            return {
                email: __WEBPACK_IMPORTED_MODULE_6__common_utils__["k" /* Validation */].validateEmail(_this.props.user.email),
            };
        };
        _this.save = function () {
            // call API directly here since we need the response from axios but not from store
            return __WEBPACK_IMPORTED_MODULE_8__user_userAPI__["a" /* default */].updateUserWithEmailChecker(_this.props.user)
                .then(function (returnedUser) {
                if (returnedUser.id === _this.props.user.id) {
                    var customerDetails = __assign({}, _this.props.customerDetails, { customerId: _this.props.user.id });
                    _this.props.actions.saveCustomerDetails(customerDetails);
                    return false;
                }
                else {
                    _this.props.history.push("/existing-account-found");
                    return true;
                }
            });
        };
        _this.back = function () {
            _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/select-your-policy");
        };
        _this.next = function () {
            _this.setState({ isSaving: true });
            _this.save()
                .then(function (redirected) {
                if (!redirected) {
                    _this.setState({ isSaving: false });
                    _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/basics");
                }
            });
        };
        _this.state = { isSaving: false };
        return _this;
    }
    DisclaimerPage.prototype.render = function () {
        this.errors = this.validate();
        var _a = this.props, className = _a.className, props = __rest(_a, ["className"]);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__WorkflowStep__["a" /* default */], { className: className, title: "Let's be honest." },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms_Fieldset__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DisclaimerForm__["a" /* default */], __assign({}, props, { errors: this.errors }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { onClick: this.back, className: "btn-outline-primary workflow-progress-action" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["s" /* IconChevronLeft */], null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2 d-none d-sm-inline-block" }, "Back")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { id: "nextBtnBasics", onClick: this.next, className: "btn-primary workflow-progress-action", disabled: this.isNextDisabled() },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Next"),
                    !this.state.isSaving && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["t" /* IconChevronRight */], null),
                    this.state.isSaving && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["f" /* Spinner */], null)))));
    };
    return DisclaimerPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DisclaimerPage);


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};







var DisclaimerForm = /** @class */ (function (_super) {
    __extends(DisclaimerForm, _super);
    function DisclaimerForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBlur = function (field) { return function (evt) {
            _this.setState({
                touched: __assign({}, _this.state.touched, (_a = {}, _a[field] = true, _a))
            });
            var _a;
        }; };
        _this.onPhoneKeyUp = function (e) {
            var phone = e.target.value;
            phone = phone
                .match(/\d*/g)
                .join('')
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
                .slice(1)
                .join('-')
                .replace(/-*$/g, '');
            var user = __assign({}, _this.props.user, (_a = {}, _a[e.target.name] = phone, _a));
            _this.props.actions.setUser(user);
            var _a;
        };
        _this.state = {
            touched: {
                email: false
            }
        };
        return _this;
    }
    // todo: make sure name gets saved under questionnaire.declareTrueName for auditing
    DisclaimerForm.prototype.render = function () {
        var props = __rest(this.props, []);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("fieldset", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "max-read-width mx-auto" }, "Most insurers require medical exams and bodily fluids before they give you coverage. We offer inexpensive life insurance with only a few quick questions. Why? Because Canadians are the most honest people we know!"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "max-read-width mx-auto mb-4" }, "So, please commit to answering the following questions truthfully and completely, and please don't send us anything wet in the mail!"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["b" /* Checkbox */], { name: "declareTrue", label: props.questions.declareTrue, checked: props.questionnaire.declareTrue, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, conditionalChildren: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire.declareTrue },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["n" /* TextInput */], { labelText: "First name", name: "firstName", onChange: this.props.onUserChange, value: this.props.user.firstName, className: "col-sm-6 mb-sm-2" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["n" /* TextInput */], { labelText: "Last name", name: "lastName", onChange: this.props.onUserChange, value: this.props.user.lastName, className: "col-sm-6 mb-sm-2" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["n" /* TextInput */], { labelText: "Email address", name: "email", className: "col-sm-12 mb-2", onBlur: this.handleBlur('email'), onChange: this.props.onUserChange, value: this.props.user.email, error: __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].shouldMarkError(this.props.errors.email, this.state.touched.email)
                                ? this.props.errors.email
                                : undefined }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["n" /* TextInput */], { labelText: "Phone Number", name: "phoneNumber", className: "col-sm-12 mb-2", onChange: this.props.onUserChange, onKeyUp: this.onPhoneKeyUp, value: this.props.user.phoneNumber }))), className: "form-group" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "max-read-width mx-auto mb-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null,
                    "By clicking next, you acknowledge and agree to our",
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */], { to: "/privacy", target: "_blank" }, "Privacy Policy"),
                    ' ',
                    "and",
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */], { to: "/terms", target: "_blank" }, "Terms of Use"),
                    "."))));
    };
    return DisclaimerForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        questions: state.question.questions,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(DisclaimerForm));


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BasicsForm__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var BasicsPage = /** @class */ (function (_super) {
    __extends(BasicsPage, _super);
    function BasicsPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onQuestionnaireHeightWeightBlur = function (e) {
            _this.props.onQuestionnaireBlur(e)
                .then(function () {
                var height = __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].getHeightInInches(_this.props.questionnaire.height, _this.props.questionnaire.heightUnit, _this.props.questionnaire.heightft);
                if (height === NaN) {
                    return;
                }
                var heightWeight = _this.props.hwTable.find(function (hw) { return hw.heightIn === height; });
                if (heightWeight === undefined) {
                    var minHeightIn_1 = Number.POSITIVE_INFINITY;
                    var maxHeightIn_1 = Number.NEGATIVE_INFINITY;
                    _this.props.hwTable.forEach(function (hw) {
                        if (minHeightIn_1 > hw.heightIn) {
                            minHeightIn_1 = hw.heightIn;
                        }
                        if (maxHeightIn_1 < hw.heightIn) {
                            maxHeightIn_1 = hw.heightIn;
                        }
                    });
                    if (height < minHeightIn_1) {
                        heightWeight = _this.props.hwTable.find(function (hw) { return hw.heightIn === minHeightIn_1; });
                    }
                    else if (height > maxHeightIn_1) {
                        heightWeight = _this.props.hwTable.find(function (hw) { return hw.heightIn === maxHeightIn_1; });
                    }
                    else {
                        return;
                    }
                }
                var maxWeightLoss = _this.props.questionnaire.weightUnit === 'lbs'
                    ? heightWeight.maxWeightLossLb
                    : heightWeight.maxWeightLossKg;
                var questionnaire = __assign({}, _this.props.questionnaire, { maxWeightLoss: maxWeightLoss });
                return _this.props.actions.setQuestionnaire(questionnaire);
            });
        };
        _this.save = function () {
            return _this.props.actions.saveUser(_this.props.user)
                .then(function () {
                var customerDetails = __assign({}, _this.props.customerDetails, { customerId: _this.props.user.id });
                return _this.props.actions.saveCustomerDetails(customerDetails);
            });
        };
        _this.back = function () {
            _this.save().then(function () {
                return _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/my-pledge");
            });
        };
        _this.next = function () {
            _this.props.actions.setQuestionnaireNavigationEnabled(false);
            _this.save()
                .then(function () {
                _this.props.actions.setQuestionnaireNavigationEnabled(true);
                _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/lifestyle");
            });
        };
        return _this;
    }
    BasicsPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__BasicsForm__["a" /* default */], __assign({}, this.props, { onQuestionnaireHeightWeightBlur: this.onQuestionnaireHeightWeightBlur, onQuestionnairePaste: this.props.onQuestionnairePaste, parentNext: this.next, parentPrev: this.back })));
    };
    return BasicsPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (BasicsPage);


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__basicQuestions_OtherQuestions__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__basicQuestions_Covid19Questions__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__basicQuestions_HeightQuestion__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__basicQuestions_WeightQuestion__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_settingsActions__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};












var BasicsForm = /** @class */ (function (_super) {
    __extends(BasicsForm, _super);
    function BasicsForm(props) {
        var _this = _super.call(this, props) || this;
        _this.lastStep = 4;
        _this.prevStep = function (e) {
            var currentStep = _this.state.currentStep;
            if (currentStep <= 1) {
                _this.props.parentPrev(e);
                return;
            }
            else {
                currentStep--;
                _this.setState(__assign({}, _this.state, { currentStep: currentStep }));
            }
        };
        _this.nextStep = function (e) {
            var currentStep = _this.state.currentStep;
            if (currentStep === _this.lastStep) {
                _this.props.parentNext(e);
                return;
            }
            else {
                currentStep++;
                _this.setState(__assign({}, _this.state, { currentStep: currentStep }));
            }
        };
        _this.nextStepOtherQuestions = function (e) {
            var currentStep = _this.state.currentStep;
            if (currentStep === 1 || currentStep === 2) {
                _this.props.actions.setQuestionnaireNavigationEnabled(false);
                _this.forceOtherQuestionsSave()
                    .then(function () { return _this.props.actions.fetchIsHardDeclined(_this.props.user.id, _this.props.customerPolicy.id); })
                    .then(function () {
                    if (_this.props.isHardDeclined.isDeclined) {
                        _this.props.actions.sendSoftDeclinedEmail(_this.props.user.id);
                        return _this.props.history.push("/quote/declined");
                    }
                    else {
                        var saveCustomerPolicyAnswer = _this.props.actions.saveCustomerPolicyAnswer;
                        var questionnaire = _this.props.questionnaire;
                        var policyId = _this.props.customerPolicy.id;
                        // Save the default questionnaire values first, otherwise they won't be saved unless user changes them.
                        var p1 = saveCustomerPolicyAnswer(policyId, 'heightUnit', questionnaire.heightUnit);
                        var p2 = saveCustomerPolicyAnswer(policyId, 'weightUnit', questionnaire.weightUnit);
                        Promise.all([p1, p2])
                            .then(function () { return _this.nextStep(e); });
                    }
                })
                    .then(function () { return _this.props.actions.setQuestionnaireNavigationEnabled(true); });
            }
            else {
                _this.nextStep(e);
            }
        };
        _this.forceOtherQuestionsSave = function () {
            var saveCustomerPolicyAnswer = _this.props.actions.saveCustomerPolicyAnswer;
            var questionnaire = _this.props.questionnaire;
            var policyId = _this.props.customerPolicy.id;
            var promises = [];
            promises.push(saveCustomerPolicyAnswer(policyId, 'isCanadian', questionnaire.isCanadian));
            if (questionnaire.isCanadian === 'true') {
                promises.push(saveCustomerPolicyAnswer(policyId, 'resideProvince', questionnaire.resideProvince));
            }
            promises.push(saveCustomerPolicyAnswer(policyId, 'hasBeenCancelled', questionnaire.hasBeenCancelled));
            promises.push(saveCustomerPolicyAnswer(policyId, 'pendingCoverage', questionnaire.pendingCoverage));
            if (questionnaire.pendingCoverage === 'true') {
                promises.push(saveCustomerPolicyAnswer(policyId, 'forcedCoverageAmount', questionnaire.forcedCoverageAmount));
                promises.push(saveCustomerPolicyAnswer(policyId, 'pendingCoverageAmount', questionnaire.pendingCoverageAmount));
                promises.push(saveCustomerPolicyAnswer(policyId, 'pendingCoverageReplace', questionnaire.pendingCoverageReplace));
            }
            return Promise.all(promises);
        };
        _this.state = {
            currentStep: _this.getStep()
        };
        return _this;
    }
    BasicsForm.prototype.getStep = function () {
        var step = parseInt(location.hash.replace('#', ''), 10);
        if (!isNaN(step)) {
            return step;
        }
        return 1;
    };
    BasicsForm.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.currentStep !== prevState.currentStep) {
            location.hash = this.state.currentStep.toString();
        }
    };
    BasicsForm.prototype.render = function () {
        var _a = this.props, questionnaire = _a.questionnaire, onQuestionnaireBlur = _a.onQuestionnaireBlur, onQuestionnaireChange = _a.onQuestionnaireChange, onQuestionnaireNumberKeyUp = _a.onQuestionnaireNumberKeyUp, onQuestionnaireHeightWeightBlur = _a.onQuestionnaireHeightWeightBlur, onQuestionnairePaste = _a.onQuestionnairePaste, user = _a.user;
        var currentQuestion = null;
        switch (this.state.currentStep) {
            case 1:
                currentQuestion =
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__basicQuestions_OtherQuestions__["a" /* default */], { questionnaire: questionnaire, onQuestionnaireBlur: onQuestionnaireBlur, onQuestionnaireChange: onQuestionnaireChange, onQuestionnaireNumberKeyUp: onQuestionnaireNumberKeyUp, onQuestionnairePaste: onQuestionnairePaste, nextStep: this.nextStepOtherQuestions, prevStep: this.prevStep, questions: this.props.questions }));
                break;
            case 2:
                currentQuestion =
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__basicQuestions_Covid19Questions__["a" /* default */], { questionnaire: questionnaire, onQuestionnaireBlur: onQuestionnaireBlur, onQuestionnaireChange: onQuestionnaireChange, onQuestionnaireNumberKeyUp: onQuestionnaireNumberKeyUp, onQuestionnairePaste: onQuestionnairePaste, nextStep: this.nextStepOtherQuestions, prevStep: this.prevStep, questions: this.props.questions }));
                break;
            case 3:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__basicQuestions_HeightQuestion__["a" /* default */], { user: user, questionnaire: questionnaire, questions: this.props.questions, onQuestionnaireBlur: onQuestionnaireBlur, onQuestionnaireChange: onQuestionnaireChange, nextStep: this.nextStep, prevStep: this.prevStep, onQuestionnaireHeightWeightBlur: onQuestionnaireHeightWeightBlur }));
                break;
            case 4:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__basicQuestions_WeightQuestion__["a" /* default */], { user: user, questionnaire: questionnaire, questions: this.props.questions, onQuestionnaireBlur: onQuestionnaireBlur, onQuestionnaireChange: onQuestionnaireChange, nextStep: this.nextStep, prevStep: this.prevStep, onQuestionnaireHeightWeightBlur: onQuestionnaireHeightWeightBlur }));
                break;
            default:
                currentQuestion = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null);
                break;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__WorkflowStep__["a" /* default */], { className: this.props.className, title: this.state.currentStep === 1 ? 'Great! Let\'s get started. First, the basics…' : '' },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms_Fieldset__["a" /* default */], null, currentQuestion)));
    };
    return BasicsForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        questions: state.question.questions,
        customerPolicy: state.policy.customerPolicy,
        isHardDeclined: state.policy.isHardDeclined,
        isSoftDeclined: state.policy.isSoftDeclined,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_9__policy_policyActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__common_settingsActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_11_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(BasicsForm));


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NextPreviousButtons__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);





var OtherQuestion = function (props) {
    var isNextDisabled = function () {
        var valid = true;
        if (props.questionnaire.isCanadian == null
            || props.questionnaire.hasBeenCancelled == null
            || props.questionnaire.pendingCoverage == null) {
            valid = false;
        }
        if (props.questionnaire.isCanadian && props.questionnaire.resideProvince == null) {
            valid = false;
        }
        if (props.questionnaire.pendingCoverage &&
            (!props.questionnaire.forcedCoverageAmount
                || !props.questionnaire.pendingCoverageAmount
                || props.questionnaire.pendingCoverageReplace == null)) {
            valid = false;
        }
        return !valid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { id: "isCanadian", labelText: props.questions.isCanadian, name: "isCanadian", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.isCanadian, className: "toggle-yes-no", conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire.isCanadian, className: "ml-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["g" /* DropdownInput */], { labelText: props.questions.resideProvince, name: "resideProvince", defaultOption: "-", options: props.provinces, onChange: props.onQuestionnaireChange, onBlur: props.onQuestionnaireBlur, value: props.questionnaire.resideProvince, className: "mb-2" }))) }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.hasBeenCancelled, name: "hasBeenCancelled", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.hasBeenCancelled, className: "toggle-yes-no" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.pendingCoverage, className: "mb-2 toggle-yes-no", name: "pendingCoverage", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.pendingCoverage, conditionalChildren: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire.pendingCoverage, className: "ml-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { labelText: props.questions.forcedCoverageAmount, name: "forcedCoverageAmount", value: props.questionnaire.forcedCoverageAmount, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, onKeyUp: props.onQuestionnaireNumberKeyUp, onPaste: props.onQuestionnairePaste, addOnBefore: "$" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { labelText: props.questions.pendingCoverageAmount, name: "pendingCoverageAmount", value: props.questionnaire.pendingCoverageAmount, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, onKeyUp: props.onQuestionnaireNumberKeyUp, onPaste: props.onQuestionnairePaste, addOnBefore: "$" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { className: "mb-2 toggle-yes-no", labelText: props.questions.pendingCoverageReplace, name: "pendingCoverageReplace", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.pendingCoverageReplace })) }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
function mapStateToProps(state, ownProps) {
    var provinces = state.pickList.items
        .filter(function (p) { return p.pickListTypeId === __WEBPACK_IMPORTED_MODULE_4__common_utils__["g" /* PickListType */].Provinces; })
        .map(function (p) {
        return { text: p.description, value: p.description };
    });
    provinces.sort(function (a, b) {
        if (a.text < b.text) {
            return -1;
        }
        if (a.text > b.text) {
            return 1;
        }
        return 0;
    });
    provinces.push({ text: 'International', value: 'International' });
    return { provinces: provinces };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(OtherQuestion));


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NextPreviousButtons__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms__ = __webpack_require__(5);




var Covid19Questions = function (props) {
    var isNextDisabled = function () {
        var valid = true;
        if (props.questionnaire.covidTestedPositive == null
            || props.questionnaire.covidLikeSymptoms == null
            || props.questionnaire.covidTravelledOutside == null
            || props.questionnaire.covidTravelWithAdvisory == null) {
            valid = false;
        }
        return !valid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.covidTestedPositive, name: "covidTestedPositive", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.covidTestedPositive, className: "toggle-yes-no" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.covidLikeSymptoms, name: "covidLikeSymptoms", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.covidLikeSymptoms, className: "toggle-yes-no" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.covidTravelledOutside, name: "covidTravelledOutside", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.covidTravelledOutside, className: "toggle-yes-no" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.covidTravelWithAdvisory, name: "covidTravelWithAdvisory", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.covidTravelWithAdvisory, className: "toggle-yes-no" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
function mapStateToProps(state, ownProps) {
    return state;
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Covid19Questions));


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);



var HeightQuestion = function (props) {
    var isNextDisabled = function () {
        return !props.questionnaire.height;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: props.questions.height, name: "height", pattern: "[0-9]*", max: props.questionnaire.heightUnit === 'in' ? 11 : undefined, value: props.questionnaire.height, onBlur: props.onQuestionnaireHeightWeightBlur, onChange: props.onQuestionnaireChange, className: "form-group-height", addOnBefore: props.questionnaire.heightUnit === 'in' ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { name: "heightft", pattern: "[0-9]*", max: 8, value: props.questionnaire.heightft, onBlur: props.onQuestionnaireHeightWeightBlur, onChange: props.onQuestionnaireChange, addOnAfter: "ft" })) : (undefined), addOnAfter: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["g" /* DropdownInput */], { name: "heightUnit", options: [{ text: 'in', value: 'in' }, { text: 'cm', value: 'cm' }], value: props.questionnaire.heightUnit, onBlur: props.onQuestionnaireHeightWeightBlur, onChange: props.onQuestionnaireChange }) }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
/* harmony default export */ __webpack_exports__["a"] = (HeightQuestion);


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms__ = __webpack_require__(5);




var WeightQuestion = function (props) {
    var isNextDisabled = function () {
        var valid = false;
        if (props.questionnaire.weight) {
            valid = true;
        }
        if (props.questionnaire.lostWeight) {
            if (!props.questionnaire.weightChange) {
                valid = false;
            }
            if (props.user.gender === 'male' && props.questionnaire.lostWeightWithoutComplications == null) {
                valid = false;
            }
            else if (props.user.gender === 'female' && props.questionnaire.lostWeightWithoutComplicationsFemale == null) {
                valid = false;
            }
        }
        else if (props.questionnaire.lostWeight == null) {
            valid = false;
        }
        return !valid;
    };
    var weightLossReasonQ = props.user.gender === 'female' ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.lostWeightWithoutComplicationsFemale, className: "mb-2 toggle-yes-no", name: "lostWeightWithoutComplicationsFemale", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.lostWeightWithoutComplicationsFemale })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.lostWeightWithoutComplications, className: "mb-2 toggle-yes-no", name: "lostWeightWithoutComplications", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.lostWeightWithoutComplications }));
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { labelText: props.questions.weight, name: "weight", pattern: "[0-9]*", value: props.questionnaire.weight, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, addOnAfter: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["g" /* DropdownInput */], { name: "weightUnit", options: [{ text: 'lbs', value: 'lbs' }, { text: 'kg', value: 'kg' }], value: props.questionnaire.weightUnit, 
                // in other components hwBlur should still be placed in onBlur; 
                onChange: function (e) { props.onQuestionnaireChange(e); props.onQuestionnaireHeightWeightBlur(e); } }) }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { labelText: __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatString(props.questions.lostWeight, props.questionnaire.maxWeightLoss, props.questionnaire.weightUnit), name: "lostWeight", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.lostWeight, className: "toggle-yes-no", conditionalChildren: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire.lostWeight, className: "ml-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { labelText: props.questions.weightChange, type: "number", name: "weightChange", value: props.questionnaire.weightChange, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, addOnAfter: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["g" /* DropdownInput */], { name: "weightUnit", options: [{ text: 'lbs', value: 'lbs' }, { text: 'kg', value: 'kg' }], value: props.questionnaire.weightUnit, disabled: true }) }),
                weightLossReasonQ) }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
/* harmony default export */ __webpack_exports__["a"] = (WeightQuestion);


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LifestyleForm__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var LifestylePage = /** @class */ (function (_super) {
    __extends(LifestylePage, _super);
    function LifestylePage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onOwnPetsTypesBlur = function (e) {
            return _this.props.actions
                .saveCustomerPolicyAnswer(_this.props.customerPolicy.id, 'ownPetsTypes', _this.props.questionnaire.ownPetsTypes);
        };
        _this.onOwnPetsTypesChange = function (e) {
            var value = __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].parseValueFromEvent(e);
            var ownPetsTypes = __assign({}, _this.props.questionnaire.ownPetsTypes, (_a = {}, _a[e.target.name] = value, _a));
            var questionnaire = __assign({}, _this.props.questionnaire, { ownPetsTypes: ownPetsTypes });
            _this.props.actions.setQuestionnaire(questionnaire);
            var _a;
        };
        _this.back = function () {
            _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/basics#3");
        };
        _this.next = function () {
            _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/activities");
        };
        return _this;
    }
    LifestylePage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__LifestyleForm__["a" /* default */], __assign({}, this.props, { onOwnPetsTypesBlur: this.onOwnPetsTypesBlur, onOwnPetsTypesChange: this.onOwnPetsTypesChange, parentNext: this.next, parentPrev: this.back })));
    };
    return LifestylePage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LifestylePage);


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lifestyleQuestions_occupationQuestion__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lifestyleQuestions_taxQuestion__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lifestyleQuestions_exerciseQuestion__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lifestyleQuestions_drivingQuestions__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lifestyleQuestions_criminalQuestion__ = __webpack_require__(476);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







// import PetsQuestion from './lifestyleQuestions/petsQuestion';


var LifestyleForm = /** @class */ (function (_super) {
    __extends(LifestyleForm, _super);
    function LifestyleForm(props) {
        var _this = _super.call(this, props) || this;
        _this.lastStep = 6;
        _this.prevStep = function (e) {
            var currentStep = _this.state.currentStep;
            if (currentStep <= 1) {
                _this.props.parentPrev(e);
                return;
            }
            else {
                currentStep--;
                _this.setState(__assign({}, _this.state, { currentStep: currentStep }));
            }
        };
        _this.nextStep = function (e) {
            var currentStep = _this.state.currentStep;
            if (currentStep === _this.lastStep) {
                _this.props.parentNext(e);
                return;
            }
            else {
                currentStep++;
                _this.setState(__assign({}, _this.state, { currentStep: currentStep }));
            }
        };
        _this.state = {
            currentStep: _this.getStep()
        };
        return _this;
    }
    LifestyleForm.prototype.getStep = function () {
        var step = parseInt(location.hash.replace('#', ''), 10);
        if (!isNaN(step)) {
            return step;
        }
        return 1;
    };
    LifestyleForm.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.currentStep !== prevState.currentStep) {
            location.hash = this.state.currentStep.toString();
        }
    };
    LifestyleForm.prototype.render = function () {
        var _a = this.props, questionnaire = _a.questionnaire, onQuestionnaireBlur = _a.onQuestionnaireBlur, onQuestionnaireChange = _a.onQuestionnaireChange, onQuestionnaireNumberKeyUp = _a.onQuestionnaireNumberKeyUp;
        var currentQuestion = null;
        switch (this.state.currentStep) {
            case 1:
                currentQuestion =
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__lifestyleQuestions_occupationQuestion__["a" /* default */], { questions: this.props.questions, questionnaire: questionnaire, onQuestionnaireBlur: onQuestionnaireBlur, onQuestionnaireChange: onQuestionnaireChange, nextStep: this.nextStep, prevStep: this.prevStep }));
                break;
            case 2:
                currentQuestion =
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__lifestyleQuestions_taxQuestion__["a" /* default */], { questions: this.props.questions, questionnaire: questionnaire, onQuestionnaireBlur: onQuestionnaireBlur, onQuestionnaireChange: onQuestionnaireChange, onQuestionnaireNumberKeyUp: onQuestionnaireNumberKeyUp, nextStep: this.nextStep, prevStep: this.prevStep }));
                break;
            case 3:
                currentQuestion =
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__lifestyleQuestions_exerciseQuestion__["a" /* default */], { questions: this.props.questions, questionnaire: questionnaire, onQuestionnaireBlur: onQuestionnaireBlur, onQuestionnaireChange: onQuestionnaireChange, nextStep: this.nextStep, prevStep: this.prevStep }));
                break;
            /*
            case 4:
                currentQuestion =
                    (
                        <PetsQuestion
                            questions={this.props.questions}
                            questionnaire={questionnaire}
                            onQuestionnaireBlur={onQuestionnaireBlur}
                            onQuestionnaireChange={onQuestionnaireChange}
                            onOwnPetsTypesBlur={onOwnPetsTypesBlur}
                            onOwnPetsTypesChange={onOwnPetsTypesChange}
                            nextStep={this.nextStep}
                            prevStep={this.prevStep}
                        />);
                break;
            */
            case 4:
                currentQuestion =
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__lifestyleQuestions_drivingQuestions__["a" /* default */], { questions: this.props.questions, questionnaire: questionnaire, onQuestionnaireBlur: onQuestionnaireBlur, onQuestionnaireChange: onQuestionnaireChange, nextStep: this.nextStep, prevStep: this.prevStep }));
                break;
            case 5:
            default:
                currentQuestion =
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__lifestyleQuestions_criminalQuestion__["a" /* default */], { questions: this.props.questions, questionnaire: questionnaire, onQuestionnaireBlur: onQuestionnaireBlur, onQuestionnaireChange: onQuestionnaireChange, nextStep: this.nextStep, prevStep: this.prevStep }));
                break;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__WorkflowStep__["a" /* default */], { className: this.props.className, title: this.state.currentStep === 1 ? 'We\'d now like to ask you about your day-to-day activities.' : '' },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms_Fieldset__["a" /* default */], null, currentQuestion)));
    };
    return LifestyleForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        questions: state.question.questions,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(LifestyleForm));


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);



var OccupationQuestion = function (props) {
    var isNextDisabled = function () {
        var valid = props.questionnaire.occupation !== undefined;
        if (props.questionnaire.occupation === 'Employed') {
            if (props.questionnaire.specificJob === undefined) {
                valid = false;
            }
            if (props.questionnaire.specificJob === 'occupationNoneOfTheAbove' &&
                props.questionnaire.jobDescription === undefined) {
                valid = false;
            }
        }
        if (props.questionnaire.occupation === 'Student') {
            if (props.questionnaire.fieldOfStudy === undefined) {
                valid = false;
            }
        }
        if (props.questionnaire.occupation === 'Unemployed') {
            if (props.questionnaire.reasonForUnemployment === undefined) {
                valid = false;
            }
            if (props.questionnaire.reasonForUnemployment === 'other' &&
                props.questionnaire.reasonForUnemploymentOtherValue === undefined) {
                valid = false;
            }
        }
        return !valid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["l" /* RadioGroup */], { title: props.questions.occupation, name: "occupation", radioOptions: [
                {
                    id: 'occupationEmployed',
                    label: "I'm employed",
                    value: 'Employed',
                    checked: props.questionnaire.occupation === 'Employed',
                    onBlur: props.onQuestionnaireBlur,
                    onChange: props.onQuestionnaireChange,
                    conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire.occupation === 'Employed', key: "occupationEmployed" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["l" /* RadioGroup */], { title: props.questions.specificJob, name: "specificJob", className: props.questionnaire.specificJob === 'occupationNoneOfTheAbove' ? '' : 'mb-2', radioOptions: [
                                {
                                    id: 'offshoreFisher',
                                    value: 'offshoreFisher',
                                    label: 'Offshore commercial fisher not coming ashore daily',
                                    checked: props.questionnaire.specificJob === 'offshoreFisher',
                                    onBlur: props.onQuestionnaireBlur,
                                    onChange: props.onQuestionnaireChange
                                },
                                {
                                    id: 'steelErector',
                                    value: 'steelErector',
                                    label: 'Steel erector or scaffolder working at heights over 40 feet',
                                    checked: props.questionnaire.specificJob === 'steelErector',
                                    onBlur: props.onQuestionnaireBlur,
                                    onChange: props.onQuestionnaireChange
                                },
                                {
                                    id: 'fallerOrLumberjack',
                                    value: 'fallerOrLumberjack',
                                    label: 'Faller or lumberjack',
                                    checked: props.questionnaire.specificJob === 'fallerOrLumberjack',
                                    onBlur: props.onQuestionnaireBlur,
                                    onChange: props.onQuestionnaireChange
                                },
                                {
                                    id: 'offshoreDriller',
                                    value: 'offshoreDriller',
                                    label: 'Offshore driller',
                                    checked: props.questionnaire.specificJob === 'offshoreDriller',
                                    onBlur: props.onQuestionnaireBlur,
                                    onChange: props.onQuestionnaireChange
                                },
                                {
                                    id: 'blaster',
                                    value: 'blaster',
                                    label: 'Blaster or explosive handler',
                                    checked: props.questionnaire.specificJob === 'blaster',
                                    onBlur: props.onQuestionnaireBlur,
                                    onChange: props.onQuestionnaireChange
                                },
                                {
                                    id: 'occupationNoneOfTheAbove',
                                    value: 'occupationNoneOfTheAbove',
                                    label: 'None of the above',
                                    checked: props.questionnaire.specificJob === 'occupationNoneOfTheAbove',
                                    onBlur: props.onQuestionnaireBlur,
                                    onChange: props.onQuestionnaireChange
                                }
                            ] }),
                        props.questionnaire.specificJob === 'occupationNoneOfTheAbove' && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["g" /* DropdownInput */], { labelText: props.questions.jobDescription, name: "jobDescription", value: props.questionnaire.jobDescription, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, defaultOption: "-", options: [
                                {
                                    value: 'Art, culture, recreation and sport',
                                    text: 'Art, culture, recreation and sport'
                                },
                                {
                                    value: 'Business, finance and administration',
                                    text: 'Business, finance and administration'
                                },
                                {
                                    value: 'Education, law and social, community and government services',
                                    text: 'Education, law and social, community and government services'
                                },
                                {
                                    value: 'Health',
                                    text: 'Health'
                                },
                                {
                                    value: 'Manufacturing and utilities',
                                    text: 'Manufacturing and utilities'
                                },
                                {
                                    value: 'Natural and applied sciences and related',
                                    text: 'Natural and applied sciences and related'
                                },
                                {
                                    value: 'Natural resources, agriculture and related production',
                                    text: 'Natural resources, agriculture and related production'
                                },
                                {
                                    value: 'Sales and service',
                                    text: 'Sales and service '
                                },
                                {
                                    value: 'Trades, transport and equipment operators and related',
                                    text: 'Trades, transport and equipment operators and related'
                                },
                                {
                                    value: 'Other',
                                    text: 'Other'
                                }
                            ], className: "mb-2" }))))
                },
                {
                    id: 'occupationStudent',
                    label: "I'm a student",
                    value: 'Student',
                    checked: props.questionnaire.occupation === 'Student',
                    onBlur: props.onQuestionnaireBlur,
                    onChange: props.onQuestionnaireChange,
                    conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire.occupation === 'Student' },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["g" /* DropdownInput */], { labelText: props.questions.fieldOfStudy, name: "fieldOfStudy", className: "mb-2", value: props.questionnaire.fieldOfStudy, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, defaultOption: "-", options: [
                                {
                                    value: 'Arts and humanities',
                                    text: 'Arts and humanities'
                                },
                                {
                                    value: 'Business and administration',
                                    text: 'Business and administration'
                                },
                                {
                                    value: 'Education and teaching',
                                    text: 'Education and teaching'
                                },
                                {
                                    value: 'Engineering and engineering technology',
                                    text: 'Engineering and engineering technology'
                                },
                                {
                                    value: 'Health care',
                                    text: 'Health care'
                                },
                                {
                                    value: 'Legal professions and studies',
                                    text: 'Legal professions and studies'
                                },
                                {
                                    value: 'Mathematics and computer and information science',
                                    text: 'Mathematics and computer and information science'
                                },
                                {
                                    value: 'Mechanics and repair, architecture, construction and precision production',
                                    text: 'Mechanics and repair, architecture, construction and precision production'
                                },
                                {
                                    value: 'Science and science technology',
                                    text: 'Science and science technology'
                                },
                                {
                                    value: 'Social and behavioural sciences',
                                    text: 'Social and behavioural sciences'
                                },
                                {
                                    value: 'Other trades, services, natural resources and conservation',
                                    text: 'Other trades, services, natural resources and conservation'
                                },
                                {
                                    value: 'Other',
                                    text: 'Other'
                                }
                            ] })))
                },
                {
                    id: 'occupationUnemployed',
                    label: "I'm unemployed",
                    value: 'Unemployed',
                    checked: props.questionnaire.occupation === 'Unemployed',
                    onBlur: props.onQuestionnaireBlur,
                    onChange: props.onQuestionnaireChange,
                    conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire.occupation === 'Unemployed' },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["l" /* RadioGroup */], { title: props.questions.reasonForUnemployment, name: "reasonForUnemployment", className: "mb-2", radioOptions: [
                                {
                                    id: 'reasonForUnemploymentParent',
                                    label: "I'm a parent or caregiver",
                                    value: 'parent',
                                    checked: props.questionnaire.reasonForUnemployment === 'parent',
                                    onBlur: props.onQuestionnaireBlur,
                                    onChange: props.onQuestionnaireChange
                                },
                                {
                                    id: 'reasonForUnemploymentDisabled',
                                    label: "I'm on disability or medical leave",
                                    value: 'disabledOrMedicalLeave',
                                    checked: props.questionnaire.reasonForUnemployment === 'disabledOrMedicalLeave',
                                    onBlur: props.onQuestionnaireBlur,
                                    onChange: props.onQuestionnaireChange
                                },
                                {
                                    id: 'reasonForUnemploymentSocialAssistance',
                                    label: "I'm on social assistance",
                                    value: 'socialAssistance',
                                    checked: props.questionnaire.reasonForUnemployment === 'socialAssistance',
                                    onBlur: props.onQuestionnaireBlur,
                                    onChange: props.onQuestionnaireChange
                                },
                                {
                                    id: 'reasonForUnemploymentCannotFindWork',
                                    label: "I can't find work",
                                    value: 'cannotFindWork',
                                    checked: props.questionnaire.reasonForUnemployment === 'cannotFindWork',
                                    onBlur: props.onQuestionnaireBlur,
                                    onChange: props.onQuestionnaireChange
                                },
                                {
                                    id: 'reasonForUnemploymentRetired',
                                    label: "I'm retired",
                                    value: 'retired',
                                    checked: props.questionnaire.reasonForUnemployment === 'retired',
                                    onBlur: props.onQuestionnaireBlur,
                                    onChange: props.onQuestionnaireChange
                                },
                                {
                                    id: 'reasonForUnemploymentOther',
                                    label: "Other",
                                    value: 'other',
                                    checked: props.questionnaire.reasonForUnemployment === 'other',
                                    onBlur: props.onQuestionnaireBlur,
                                    onChange: props.onQuestionnaireChange,
                                    conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { contentClassName: "mb-2", isOpen: props.questionnaire.reasonForUnemployment === 'other' },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Please specify", name: "reasonForUnemploymentOtherValue", value: props.questionnaire.reasonForUnemploymentOtherValue, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, className: "mb-0" })))
                                }
                            ] })))
                }
            ] }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
/* harmony default export */ __webpack_exports__["a"] = (OccupationQuestion);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);



var TaxQuestion = function (props) {
    var isNextDisabled = function () {
        var valid = false;
        // Using "truthyness"
        if (props.questionnaire.annualIncome && props.questionnaire.householdIncome) {
            valid = true;
        }
        return !valid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: props.questions.annualIncome, name: "annualIncome", type: "tel", addOnBefore: "$", value: props.questionnaire.annualIncome, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, onKeyUp: props.onQuestionnaireNumberKeyUp })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: props.questions.householdIncome, name: "householdIncome", type: "tel", addOnBefore: "$", value: props.questionnaire.householdIncome, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, onKeyUp: props.onQuestionnaireNumberKeyUp })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
/* harmony default export */ __webpack_exports__["a"] = (TaxQuestion);


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);



var ExerciseQuestion = function (props) {
    var isNextDisabled = function () {
        var valid = true;
        if (!props.questionnaire.exerciseFrequentlyHours) {
            valid = false;
        }
        return !valid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["g" /* DropdownInput */], { labelText: props.questions.exerciseFrequentlyHours, name: "exerciseFrequentlyHours", value: props.questionnaire.exerciseFrequentlyHours, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, defaultOption: "-", options: [
                    {
                        value: '0',
                        text: 'I rarely exercise'
                    },
                    {
                        value: '0-1',
                        text: 'Less than 1 hour'
                    },
                    {
                        value: '1-2',
                        text: '1-2 hours'
                    },
                    {
                        value: '2-3',
                        text: '2-3 hours'
                    },
                    {
                        value: '3-4',
                        text: '3-4 hours'
                    },
                    {
                        value: '4-5',
                        text: '4-5 hours'
                    },
                    {
                        value: '5-6',
                        text: '5-6 hours'
                    },
                    {
                        value: '6-7',
                        text: '6-7 hours'
                    },
                    {
                        value: '7+',
                        text: 'More than 7 hours'
                    }
                ] })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-2" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["d" /* CheckboxGroupSerialize */], { title: props.questions.favoriteActivities, onUpdate: props.onQuestionnaireChange, values: props.questionnaire.favoriteActivities, name: "favoriteActivities", checkOptions: [
                    {
                        name: 'Aerobics',
                        label: 'Aerobics'
                    },
                    {
                        name: 'Baseball or softball',
                        label: 'Baseball or softball'
                    },
                    {
                        name: 'Basketball',
                        label: 'Basketball'
                    },
                    {
                        name: 'Biking',
                        label: 'Biking'
                    },
                    {
                        name: 'Climbing, spelunking, or caving',
                        label: 'Climbing, spelunking, or caving'
                    },
                    {
                        name: 'Dancing',
                        label: 'Dancing'
                    },
                    {
                        name: 'Equestrian sports',
                        label: 'Equestrian sports'
                    },
                    {
                        name: 'Fencing',
                        label: 'Fencing'
                    },
                    {
                        name: 'Football',
                        label: 'Football'
                    },
                    {
                        name: 'Golfing',
                        label: 'Golfing'
                    },
                    {
                        name: 'Gymnastics',
                        label: 'Gymnastics'
                    },
                    {
                        name: 'Hiking',
                        label: 'Hiking'
                    },
                    {
                        name: 'Hockey',
                        label: 'Hockey'
                    },
                    {
                        name: 'Martial arts',
                        label: 'Martial arts'
                    },
                    {
                        name: 'Racquet sports',
                        label: 'Racquet sports'
                    },
                    {
                        name: 'Rowing',
                        label: 'Rowing'
                    },
                    {
                        name: 'Rugby',
                        label: 'Rugby'
                    },
                    {
                        name: 'Running, stair climbing, or elliptical machine',
                        label: 'Running, stair climbing, or elliptical machine'
                    },
                    {
                        name: 'Skating or rollerblading',
                        label: 'Skating or rollerblading'
                    },
                    {
                        name: 'Skiing or snowboarding',
                        label: 'Skiing or snowboarding'
                    },
                    {
                        name: 'Soccer',
                        label: 'Soccer'
                    },
                    {
                        name: 'Volleyball',
                        label: 'Volleyball'
                    },
                    {
                        name: 'Walking',
                        label: 'Walking'
                    },
                    {
                        name: 'Water sports',
                        label: 'Water sports (e.g., swimming, water polo)'
                    },
                    {
                        name: 'Weightlifting/strength training',
                        label: 'Weightlifting/strength training'
                    },
                    {
                        name: 'Wrestling',
                        label: 'Wrestling'
                    },
                    {
                        name: 'Yoga',
                        label: 'Yoga'
                    },
                    {
                        name: 'Other',
                        label: 'Other'
                    },
                ] })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
/* harmony default export */ __webpack_exports__["a"] = (ExerciseQuestion);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);





var DrivingQuestion = function (props) {
    var isNextDisabled = function () {
        var valid = (props.questionnaire.driversLicense !== undefined
            && props.questionnaire.speedingViolations !== undefined
            && props.questionnaire.impairedViolations !== undefined
            && props.questionnaire.otherViolations !== undefined
            && props.questionnaire.revokedLicense !== undefined);
        if (props.questionnaire.driversLicense === true) {
            if (props.questionnaire.driversLicenseProvince === undefined) {
                valid = false;
            }
        }
        if (props.questionnaire.speedingViolations === true) {
            if (props.questionnaire.speedingViolationsCount === undefined) {
                valid = false;
            }
        }
        if (props.questionnaire.otherViolations === true) {
            if (props.questionnaire.otherViolationsCount === undefined) {
                valid = false;
            }
        }
        return !valid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.driversLicense, name: "driversLicense", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.driversLicense, className: "toggle-yes-no", conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire.driversLicense, className: "ml-0" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["g" /* DropdownInput */], { labelText: props.questions.driversLicenseProvince, name: "driversLicenseProvince", defaultOption: "-", options: props.provinces, onChange: props.onQuestionnaireChange, onBlur: props.onQuestionnaireBlur, value: props.questionnaire.driversLicenseProvince, className: "mb-2" }))) })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.speedingViolations, name: "speedingViolations", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.speedingViolations, className: "toggle-yes-no", conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire.speedingViolations, className: "ml-0" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: props.questions.speedingViolationsCount, name: "speedingViolationsCount", pattern: "[0-9]*", value: props.questionnaire.speedingViolationsCount, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, className: "mb-2" }))) })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.impairedViolations, name: "impairedViolations", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.impairedViolations, className: "toggle-yes-no" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.otherViolations, name: "otherViolations", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.otherViolations, className: "toggle-yes-no", conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire.otherViolations, className: "ml-0" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: props.questions.otherViolationsCount, name: "otherViolationsCount", pattern: "[0-9]*", value: props.questionnaire.otherViolationsCount, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, className: "mb-2" }))) })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.revokedLicense, name: "revokedLicense", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.revokedLicense, className: "toggle-yes-no" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
function mapStateToProps(state, ownProps) {
    var provinces = state.pickList.items
        .filter(function (p) { return p.pickListTypeId === __WEBPACK_IMPORTED_MODULE_3__common_utils__["g" /* PickListType */].Provinces; })
        .map(function (p) {
        return { text: p.description, value: p.description };
    });
    provinces.sort(function (a, b) {
        if (a.text < b.text) {
            return -1;
        }
        if (a.text > b.text) {
            return 1;
        }
        return 0;
    });
    provinces.push({ text: 'International', value: 'International' });
    return { provinces: provinces };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps)(DrivingQuestion));


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);



var CriminalQuestion = function (props) {
    var isNextDisabled = function () {
        var valid = (props.questionnaire.criminalOffense !== undefined);
        return !valid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.criminalOffense, name: "criminalOffense", className: "toggle-yes-no", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.criminalOffense })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
/* harmony default export */ __webpack_exports__["a"] = (CriminalQuestion);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__policy_policyAPI__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActivitiesForm__ = __webpack_require__(478);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var ActivitiesPage = /** @class */ (function (_super) {
    __extends(ActivitiesPage, _super);
    function ActivitiesPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.saveForeignTravelList = function (foreignTravelList) {
            return _this.props.actions
                .saveCustomerPolicyAnswer(_this.props.customerPolicy.id, 'foreignTravelList', foreignTravelList);
        };
        _this.onForeignTravelAdd = function () {
            var foreignTravelList = _this.props.questionnaire.foreignTravelList.concat([__WEBPACK_IMPORTED_MODULE_1__policy_policyAPI__["e" /* defaultForeignTravel */]]);
            var questionnaire = __assign({}, _this.props.questionnaire, { foreignTravelList: foreignTravelList });
            _this.props.actions.setQuestionnaire(questionnaire);
            _this.saveForeignTravelList(foreignTravelList);
        };
        _this.onForeignTravelBlur = function (e) {
            // Save whole foreign travel list on blur
            return _this.saveForeignTravelList(_this.props.questionnaire.foreignTravelList);
        };
        _this.onForeignTravelChange = function (e, index) {
            var value = e.target.value;
            if (e.target.type === 'radio') {
                if (value === 'true') {
                    value = true;
                }
                else if (value === 'false') {
                    value = false;
                }
            }
            else if (e.target.type === 'checkbox') {
                value = e.target.checked;
            }
            var foreignTravel = __assign({}, _this.props.questionnaire.foreignTravelList[index], (_a = {}, _a[e.target.name] = value, _a));
            var foreignTravelList = _this.props.questionnaire.foreignTravelList.slice();
            foreignTravelList[index] = foreignTravel;
            var questionnaire = __assign({}, _this.props.questionnaire, { foreignTravelList: foreignTravelList });
            _this.props.actions.setQuestionnaire(questionnaire);
            var _a;
        };
        _this.onForeignTravelRemove = function (index) {
            var foreignTravelList = _this.props.questionnaire.foreignTravelList.slice();
            foreignTravelList.splice(index, 1);
            var questionnaire = __assign({}, _this.props.questionnaire, { foreignTravelList: foreignTravelList });
            _this.props.actions.setQuestionnaire(questionnaire);
            _this.saveForeignTravelList(foreignTravelList);
        };
        _this.isNextDisabled = function () {
            if (_this.props.questionnaire.abroad == null
                || _this.props.questionnaire.consumedAlcohol == null
                || _this.props.questionnaire.usedTobacco == null
                || _this.props.questionnaire.cannabis == null
                || _this.props.questionnaire.controlledSubstances == null
                || _this.props.questionnaire.substanceCounseling == null) {
                return true;
            }
            return false;
        };
        _this.save = function () {
            return _this.props.actions.saveUser(_this.props.user)
                .then(function () {
                var customerDetails = __assign({}, _this.props.customerDetails, { customerId: _this.props.user.id });
                return _this.props.actions.saveCustomerDetails(customerDetails);
            });
        };
        _this.back = function () {
            _this.save().then(function () {
                return _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/lifestyle#6");
            });
        };
        _this.next = function () {
            _this.props.actions.setQuestionnaireNavigationEnabled(false);
            _this.save()
                .then(function () {
                _this.props.actions.setQuestionnaireNavigationEnabled(true);
                _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/medical-history");
            });
        };
        return _this;
    }
    ActivitiesPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ActivitiesForm__["a" /* default */], __assign({}, this.props, { onForeignTravelAdd: this.onForeignTravelAdd, onForeignTravelBlur: this.onForeignTravelBlur, onForeignTravelChange: this.onForeignTravelChange, onForeignTravelRemove: this.onForeignTravelRemove, parentNext: this.next, parentPrev: this.back })));
    };
    return ActivitiesPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ActivitiesPage);


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__activitiesQuestions_ActivitiesQuestion__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__activitiesQuestions_OtherQuestions__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__activitiesQuestions_ForeignTravelQuestion__ = __webpack_require__(483);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var ActivitiesForm = /** @class */ (function (_super) {
    __extends(ActivitiesForm, _super);
    function ActivitiesForm(props) {
        var _this = _super.call(this, props) || this;
        _this.lastStep = 3;
        _this.prevStep = function (e) {
            var currentStep = _this.state.currentStep;
            if (currentStep <= 1) {
                _this.props.parentPrev(e);
                return;
            }
            else {
                currentStep--;
                _this.setState(__assign({}, _this.state, { currentStep: currentStep }));
            }
        };
        _this.nextStep = function (e) {
            var currentStep = _this.state.currentStep;
            if (currentStep === _this.lastStep) {
                _this.props.parentNext(e);
                return;
            }
            else {
                currentStep++;
                _this.setState(__assign({}, _this.state, { currentStep: currentStep }));
            }
        };
        _this.state = {
            currentStep: _this.getStep()
        };
        return _this;
    }
    ActivitiesForm.prototype.getStep = function () {
        var step = parseInt(location.hash.replace('#', ''), 10);
        if (!isNaN(step)) {
            return step;
        }
        return 1;
    };
    ActivitiesForm.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.currentStep !== prevState.currentStep) {
            location.hash = this.state.currentStep.toString();
        }
    };
    ActivitiesForm.prototype.render = function () {
        var _a = this.props, questions = _a.questions, questionnaire = _a.questionnaire, onQuestionnaireBlur = _a.onQuestionnaireBlur, onQuestionnaireChange = _a.onQuestionnaireChange, onForeignTravelRemove = _a.onForeignTravelRemove, onForeignTravelBlur = _a.onForeignTravelBlur, onForeignTravelChange = _a.onForeignTravelChange, onForeignTravelAdd = _a.onForeignTravelAdd;
        var currentQuestion = null;
        switch (this.state.currentStep) {
            case 1:
                currentQuestion =
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__activitiesQuestions_ActivitiesQuestion__["a" /* default */], { questions: questions, questionnaire: questionnaire, onQuestionnaireBlur: onQuestionnaireBlur, onQuestionnaireChange: onQuestionnaireChange, nextStep: this.nextStep, prevStep: this.prevStep }));
                break;
            case 2:
                currentQuestion =
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__activitiesQuestions_ForeignTravelQuestion__["a" /* default */], { questions: questions, questionnaire: questionnaire, onQuestionnaireBlur: onQuestionnaireBlur, onQuestionnaireChange: onQuestionnaireChange, nextStep: this.nextStep, prevStep: this.prevStep, onForeignTravelAdd: onForeignTravelAdd, onForeignTravelChange: onForeignTravelChange, onForeignTravelBlur: onForeignTravelBlur, onForeignTravelRemove: onForeignTravelRemove }));
                break;
            default:
            case 3:
                currentQuestion =
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__activitiesQuestions_OtherQuestions__["a" /* default */], { questions: questions, questionnaire: questionnaire, onQuestionnaireBlur: onQuestionnaireBlur, onQuestionnaireChange: onQuestionnaireChange, nextStep: this.nextStep, prevStep: this.prevStep }));
                break;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__WorkflowStep__["a" /* default */], { className: this.props.className, title: this.state.currentStep === 1 ? 'Next, we\'d like to know more about how you like to spend your time.' : '' },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms_Fieldset__["a" /* default */], null, currentQuestion)));
    };
    return ActivitiesForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        questions: state.question.questions,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(ActivitiesForm));


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__activitiesSubQuestions_AviationQuestions__ = __webpack_require__(480);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var ActivitiesQuestion = function (props) {
    var questionName = 'activities';
    var onChange = function (e) {
        if (e.target.type === 'text' && !e.target.validity.valid) {
            return;
        }
        var customEvent = createCustomQuestionEvent(e);
        props.onQuestionnaireChange(customEvent);
    };
    var onBlur = function (e) {
        var customEvent = createCustomQuestionEvent(e);
        props.onQuestionnaireBlur(customEvent);
    };
    var createCustomQuestionEvent = function (e) {
        var value = __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].parseValueFromEvent(e);
        var answer = __assign({}, props.questionnaire[questionName], (_a = {}, _a[e.target.name] = value, _a));
        if (e.target.name === 'activitiesNoneOfTheAbove' && value) {
            // user clicked none option, remove all other values
            answer = (_b = {},
                _b[e.target.name] = value,
                _b);
        }
        else {
            answer.activitiesNoneOfTheAbove = false;
            handleSubQuestions(e.target.name, answer);
        }
        var questionnaireEvent = {
            target: {
                name: questionName,
                value: answer,
                type: 'custom',
            }
        };
        return questionnaireEvent;
        var _a, _b;
    };
    var handleSubQuestions = function (name, answer) {
        if (name === 'aviation' && answer[name] !== true) {
            delete answer.aviationLicense;
            delete answer.aviationInstrumentRating;
            delete answer.aviationHoursExperience;
            delete answer.aviationHoursAnnually;
            delete answer.aviationAccidents;
        }
        else if (name === 'hangGliding' && answer[name] !== true) {
            delete answer.hangGlidingStunt;
        }
        else if (name === 'ultralightFlying' && answer[name] !== true) {
            delete answer.ultralightFlyingStunts;
        }
        else if (name === 'backcountrySkiing' && answer[name] !== true) {
            delete answer.heliSkiSnowboarding;
            delete answer.outOfBoundsSkiingSnowboarding;
            delete answer.backCountrySnowMobiling;
        }
        else if (name === 'mountainClimbing' && answer[name] !== true) {
            delete answer.mountainClimbingTall;
        }
        else if (name === 'skydivingActivities' && answer[name] !== true) {
            delete answer.skydiving;
            delete answer.skydivingOneTime;
            delete answer.wingsuitFlying;
            delete answer.parachuting;
            delete answer.parachutingOneTime;
            delete answer.skysurfing;
            delete answer.canopyPiloting;
            delete answer.skydivingExtreme;
        }
        else if (name === 'skydiving' && answer[name] !== true) {
            delete answer.skydivingOneTime;
        }
        else if (name === 'parachuting' && answer[name] !== true) {
            delete answer.parachutingOneTime;
        }
        else if (name === 'bungeeJumping' && answer[name] !== true) {
            delete answer.bungeeJumpingOneTime;
        }
    };
    var isNextDisabled = function () {
        var valid = (props.questionnaire[questionName].aviation === true
            || props.questionnaire[questionName].hangGliding === true
            || props.questionnaire[questionName].ultralightFlying === true
            || props.questionnaire[questionName].scubaDiving === true
            || props.questionnaire[questionName].backcountrySkiing === true
            || props.questionnaire[questionName].mountainClimbing === true
            || props.questionnaire[questionName].skydivingActivities === true
            || props.questionnaire[questionName].mountainClimbing === true
            || props.questionnaire[questionName].motorizedRacing === true
            || props.questionnaire[questionName].bungeeJumping === true
            || props.questionnaire[questionName].fightSports === true
            || props.questionnaire[questionName].activitiesNoneOfTheAbove === true);
        if (props.questionnaire[questionName].aviation === true) {
            if (props.questionnaire[questionName].aviationLicense === undefined ||
                props.questionnaire[questionName].aviationInstrumentRating === undefined ||
                !props.questionnaire[questionName].aviationHoursExperience ||
                !props.questionnaire[questionName].aviationHoursAnnually ||
                props.questionnaire[questionName].aviationAccidents === undefined) {
                valid = false;
            }
        }
        if (props.questionnaire[questionName].hangGliding === true) {
            if (props.questionnaire[questionName].hangGlidingStunt === undefined) {
                valid = false;
            }
        }
        if (props.questionnaire[questionName].ultralightFlying === true) {
            if (props.questionnaire[questionName].ultralightFlyingStunts === undefined) {
                valid = false;
            }
        }
        if (props.questionnaire[questionName].mountainClimbing === true) {
            if (props.questionnaire[questionName].mountainClimbingTall === undefined) {
                valid = false;
            }
        }
        if (props.questionnaire[questionName].skydivingActivities === true) {
            if (props.questionnaire[questionName].skydiving === true) {
                if (props.questionnaire[questionName].skydivingOneTime === undefined) {
                    valid = false;
                }
            }
            if (props.questionnaire[questionName].parachuting === true) {
                if (props.questionnaire[questionName].parachutingOneTime === undefined) {
                    valid = false;
                }
            }
            if (props.questionnaire[questionName].skydivingExtreme === undefined) {
                valid = false;
            }
        }
        if (props.questionnaire[questionName].bungeeJumping === true) {
            if (props.questionnaire[questionName].bungeeJumpingOneTime === undefined) {
                valid = false;
            }
        }
        return !valid;
    };
    if (props.questionnaire[questionName] === undefined) {
        props.questionnaire[questionName] = {};
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["c" /* CheckboxGroup */], { title: props.questions.activities, checkOptions: [
                {
                    name: 'aviation',
                    label: props.questions.aviation,
                    checked: props.questionnaire[questionName].aviation,
                    onBlur: onBlur,
                    onChange: onChange,
                    conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__activitiesSubQuestions_AviationQuestions__["a" /* default */], { questionnaire: props.questionnaire, questions: props.questions, onBlur: onBlur, onChange: onChange }))
                },
                {
                    name: 'hangGliding',
                    label: props.questions.hangGliding,
                    checked: props.questionnaire[questionName].hangGliding,
                    onBlur: onBlur,
                    onChange: onChange,
                    conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].hangGliding },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.hangGlidingStunt, className: "mb-2 toggle-yes-no", name: "hangGlidingStunt", onChildren: "Yes", offChildren: "No", onBlur: onBlur, onChange: onChange, checked: props.questionnaire[questionName].hangGlidingStunt })))
                },
                {
                    name: 'ultralightFlying',
                    label: props.questions.ultralightFlying,
                    checked: props.questionnaire[questionName].ultralightFlying,
                    onBlur: onBlur,
                    onChange: onChange,
                    conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].ultralightFlying },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.ultralightFlyingStunts, className: "mb-2 toggle-yes-no", name: "ultralightFlyingStunts", onChildren: "Yes", offChildren: "No", onBlur: onBlur, onChange: onChange, checked: props.questionnaire[questionName].ultralightFlyingStunts })))
                },
                {
                    name: 'scubaDiving',
                    label: props.questions.scubaDiving,
                    checked: props.questionnaire[questionName].scubaDiving,
                    onBlur: onBlur,
                    onChange: onChange
                },
                {
                    name: 'backcountrySkiing',
                    label: props.questions.backcountrySkiing,
                    checked: props.questionnaire[questionName].backcountrySkiing,
                    onBlur: onBlur,
                    onChange: onChange,
                    conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].backcountrySkiing },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["c" /* CheckboxGroup */], { name: "backcountrySkiingTypes", title: props.questions.backcountrySkiingTypes, checkOptions: [
                                {
                                    name: 'heliSkiSnowboarding',
                                    label: 'Heli-skiing or snowboarding',
                                    checked: props.questionnaire[questionName].heliSkiSnowboarding,
                                    onBlur: onBlur,
                                    onChange: onChange
                                },
                                {
                                    name: 'outOfBoundsSkiingSnowboarding',
                                    label: 'Out-of-bounds or backcountry skiing or snowboarding',
                                    checked: props.questionnaire[questionName].outOfBoundsSkiingSnowboarding,
                                    onBlur: onBlur,
                                    onChange: onChange
                                },
                                {
                                    name: 'backCountrySnowMobiling',
                                    label: 'Backcountry snowmobiling',
                                    checked: props.questionnaire[questionName].backCountrySnowMobiling,
                                    onBlur: onBlur,
                                    onChange: onChange
                                }
                            ], className: "mb-2" })))
                },
                {
                    name: 'mountainClimbing',
                    label: props.questions.mountainClimbing,
                    checked: props.questionnaire[questionName].mountainClimbing,
                    onBlur: onBlur,
                    onChange: onChange,
                    conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].mountainClimbing },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.mountainClimbingTall, className: "mb-2 toggle-yes-no", name: "mountainClimbingTall", onChildren: "Yes", offChildren: "No", onBlur: onBlur, onChange: onChange, checked: props.questionnaire[questionName].mountainClimbingTall })))
                },
                {
                    name: 'skydivingActivities',
                    label: props.questions.skydivingActivities,
                    checked: props.questionnaire[questionName].skydivingActivities,
                    onBlur: onBlur,
                    onChange: onChange,
                    conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].skydivingActivities },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["c" /* CheckboxGroup */], { name: "skydivingActivitiesTypes", title: props.questions.skydivingActivitiesTypes, checkOptions: [
                                {
                                    name: 'skydiving',
                                    label: 'Skydiving',
                                    checked: props.questionnaire[questionName].skydiving,
                                    onBlur: onBlur,
                                    onChange: onChange,
                                    conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].skydiving },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.skydivingOneTime, className: "mb-2 toggle-yes-no", name: "skydivingOneTime", onChildren: "Yes", offChildren: "No", onBlur: onBlur, onChange: onChange, checked: props.questionnaire[questionName].skydivingOneTime })))
                                },
                                {
                                    name: 'wingsuitFlying',
                                    label: 'Wingsuit flying',
                                    checked: props.questionnaire[questionName].wingsuitFlying,
                                    onBlur: onBlur,
                                    onChange: onChange
                                },
                                {
                                    name: 'parachuting',
                                    label: 'Parachuting',
                                    checked: props.questionnaire[questionName].parachuting,
                                    onBlur: onBlur,
                                    onChange: onChange,
                                    conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].parachuting },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.parachutingOneTime, className: "mb-2 toggle-yes-no", name: "parachutingOneTime", onChildren: "Yes", offChildren: "No", onBlur: onBlur, onChange: onChange, checked: props.questionnaire[questionName].parachutingOneTime })))
                                },
                                {
                                    name: 'skysurfing',
                                    label: 'Skysurfing',
                                    checked: props.questionnaire[questionName].skysurfing,
                                    onBlur: onBlur,
                                    onChange: onChange
                                },
                                {
                                    name: 'canopyPiloting',
                                    label: 'Canopy piloting',
                                    checked: props.questionnaire[questionName].canopyPiloting,
                                    onBlur: onBlur,
                                    onChange: onChange
                                }
                            ] }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.skydivingExtreme, className: "mb-2 toggle-yes-no", name: "skydivingExtreme", onChildren: "Yes", offChildren: "No", onBlur: onBlur, onChange: onChange, checked: props.questionnaire[questionName].skydivingExtreme })))
                },
                {
                    name: 'motorizedRacing',
                    label: props.questions.motorizedRacing,
                    checked: props.questionnaire[questionName].motorizedRacing,
                    onBlur: onBlur,
                    onChange: onChange
                },
                {
                    name: 'bungeeJumping',
                    label: props.questions.bungeeJumping,
                    checked: props.questionnaire[questionName].bungeeJumping,
                    onBlur: onBlur,
                    onChange: onChange,
                    conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].bungeeJumping },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.bungeeJumpingOneTime, className: "mb-2 toggle-yes-no", name: "bungeeJumpingOneTime", onChildren: "Yes", offChildren: "No", onBlur: onBlur, onChange: onChange, checked: props.questionnaire[questionName].bungeeJumpingOneTime })))
                },
                {
                    name: 'fightSports',
                    label: props.questions.fightSports,
                    checked: props.questionnaire[questionName].fightSports,
                    onBlur: onBlur,
                    onChange: onChange
                },
                {
                    name: 'activitiesNoneOfTheAbove',
                    label: 'None of the above',
                    checked: props.questionnaire[questionName].activitiesNoneOfTheAbove,
                    onBlur: onBlur,
                    onChange: onChange,
                    className: 'border-top pt-2'
                }
            ] }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
/* harmony default export */ __webpack_exports__["a"] = (ActivitiesQuestion);


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);


var AviationQuestions = function (props) {
    var questionName = 'activities';
    var onBlur = props.onBlur, onChange = props.onChange;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].aviation },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["l" /* RadioGroup */], { title: props.questions.aviationLicense, name: "aviationLicense", radioOptions: [
                {
                    id: 'private',
                    value: 'private',
                    label: 'Private',
                    checked: props.questionnaire[questionName].aviationLicense === 'private',
                    onBlur: onBlur,
                    onChange: onChange
                },
                {
                    id: 'commercial',
                    value: 'commercial',
                    label: 'Commercial',
                    checked: props.questionnaire[questionName].aviationLicense === 'commercial',
                    onBlur: onBlur,
                    onChange: onChange
                }
            ] }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.aviationInstrumentRating, className: "toggle-yes-no", name: "aviationInstrumentRating", onChildren: "Yes", offChildren: "No", onBlur: onBlur, onChange: onChange, checked: props.questionnaire[questionName].aviationInstrumentRating }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["j" /* Label */], null, props.questions.aviationHoursExperience),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { name: "aviationHoursExperience", className: "form-group-number", pattern: "[0-9]*", value: props.questionnaire[questionName].aviationHoursExperience, onBlur: onBlur, onChange: onChange })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["j" /* Label */], null, props.questions.aviationHoursAnnually),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { name: "aviationHoursAnnually", className: "form-group-number", pattern: "[0-9]*", value: props.questionnaire[questionName].aviationHoursAnnually, onBlur: onBlur, onChange: onChange })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.aviationAccidents, className: "toggle-yes-no mb-2", name: "aviationAccidents", onChildren: "Yes", offChildren: "No", onBlur: onBlur, onChange: onChange, checked: props.questionnaire[questionName].aviationAccidents })));
};
/* harmony default export */ __webpack_exports__["a"] = (AviationQuestions);


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AlchoholConsumptionQuestion__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms__ = __webpack_require__(5);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




var OtherQuestion = function (props) {
    var isNextDisabled = function () {
        var valid = !(props.questionnaire.abroad == null
            || props.questionnaire.consumedAlcohol == null
            || props.questionnaire.usedTobacco == null
            || props.questionnaire.cannabis == null
            || props.questionnaire.controlledSubstances == null
            || props.questionnaire.substanceCounseling == null);
        if (props.questionnaire.usedTobacco === true) {
            if (props.questionnaire.usedTobaccoLastUsed === undefined) {
                valid = false;
            }
            else if (!props.questionnaire.cigarettes
                && !props.questionnaire.cigarillos
                && !props.questionnaire.cigars
                && !props.questionnaire.chewingTobacco
                && !props.questionnaire.electronicCigarettes
                && !props.questionnaire.nicotineSubstitutes
                && !props.questionnaire.shisha
                && !props.questionnaire.pipes
                && !props.questionnaire.otherTobacco) {
                valid = false;
            }
            if (props.questionnaire.cigars === true) {
                if (!props.questionnaire.cigarCount) {
                    valid = false;
                }
            }
        }
        if (props.questionnaire.cannabis === true) {
            if (!props.questionnaire.cannabisCount) {
                valid = false;
            }
        }
        if (props.questionnaire.abroad === true) {
            if (props.questionnaire.foreignTravelList === undefined || props.questionnaire.foreignTravelList.length === 0) {
                valid = false;
            }
        }
        if (props.questionnaire.consumedAlcohol === true) {
            if (props.questionnaire.drinksPerWeekday === undefined
                || props.questionnaire.drinksPerWeekend === undefined
                || props.questionnaire.drinksPerSitting === undefined) {
                valid = false;
            }
        }
        if (props.questionnaire.otherViolations === true) {
            if (props.questionnaire.otherViolationsCount === undefined) {
                valid = false;
            }
        }
        return !valid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__AlchoholConsumptionQuestion__["a" /* default */], __assign({}, props)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.usedTobacco, name: "usedTobacco", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.usedTobacco, className: "toggle-yes-no", conditionalChildren: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire.usedTobacco, className: "ml-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["g" /* DropdownInput */], { labelText: props.questions.usedTobaccoLastUsed, name: "usedTobaccoLastUsed", value: props.questionnaire.usedTobaccoLastUsed, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, defaultOption: "Select ...", options: [
                        { value: 'withinThePastMonth', text: 'Within the past month' },
                        { value: 'withinThePast6Months', text: '1-6 months ago' },
                        { value: 'withinThePast12Months', text: '6-12 months ago' },
                        { value: 'withinThePast24Months', text: '12-24 months ago' }
                    ] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["c" /* CheckboxGroup */], { className: "mb-2", title: props.questions.usedTobaccoWhich, checkOptions: [
                        {
                            name: 'cigarettes',
                            label: props.questions.cigarettes,
                            checked: props.questionnaire.cigarettes,
                            onBlur: props.onQuestionnaireBlur,
                            onChange: props.onQuestionnaireChange
                        },
                        {
                            name: 'cigarillos',
                            label: props.questions.cigarillos,
                            checked: props.questionnaire.cigarillos,
                            onBlur: props.onQuestionnaireBlur,
                            onChange: props.onQuestionnaireChange
                        },
                        {
                            name: 'cigars',
                            label: props.questions.cigars,
                            checked: props.questionnaire.cigars,
                            onChange: props.onQuestionnaireChange,
                            conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire.cigars },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { labelText: props.questions.cigarCount, name: "cigarCount", pattern: "[0-9]*", value: props.questionnaire.cigarCount, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange })))
                        },
                        {
                            name: 'chewingTobacco',
                            label: props.questions.chewingTobacco,
                            checked: props.questionnaire.chewingTobacco,
                            onBlur: props.onQuestionnaireBlur,
                            onChange: props.onQuestionnaireChange
                        },
                        {
                            name: 'electronicCigarettes',
                            label: props.questions.electronicCigarettes,
                            checked: props.questionnaire.electronicCigarettes,
                            onChange: props.onQuestionnaireChange
                        },
                        {
                            name: 'nicotineSubstitutes',
                            label: props.questions.nicotineSubstitutes,
                            checked: props.questionnaire.nicotineSubstitutes,
                            onChange: props.onQuestionnaireChange
                        },
                        {
                            name: 'shisha',
                            label: props.questions.shisha,
                            checked: props.questionnaire.shisha,
                            onChange: props.onQuestionnaireChange
                        },
                        {
                            name: 'pipes',
                            label: props.questions.pipes,
                            checked: props.questionnaire.pipes,
                            onChange: props.onQuestionnaireChange
                        },
                        {
                            name: 'otherTobacco',
                            label: props.questions.otherTobacco,
                            checked: props.questionnaire.otherTobacco,
                            onChange: props.onQuestionnaireChange
                        }
                    ] })) }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.cannabis, name: "cannabis", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.cannabis, className: "toggle-yes-no", conditionalChildren: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire.cannabis, className: "ml-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-2" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["j" /* Label */], null, props.questions.cannabisCount),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { name: "cannabisCount", className: "form-group-number", pattern: "[0-9]*", value: props.questionnaire.cannabisCount, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text", dangerouslySetInnerHTML: { __html: props.questions.cannabisCountSpan } }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["g" /* DropdownInput */], { name: "cannabisCountSpan", options: [
                                { value: 'day', text: 'Day' },
                                { value: 'week', text: 'Week' },
                                { value: 'month', text: 'Month' },
                                { value: 'year', text: 'Year' }
                            ], value: props.questionnaire.cannabisCountSpan, onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange })))) }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.controlledSubstances, name: "controlledSubstances", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.controlledSubstances, className: "toggle-yes-no" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.substanceCounseling, name: "substanceCounseling", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.substanceCounseling, className: "toggle-yes-no" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
/* harmony default export */ __webpack_exports__["a"] = (OtherQuestion);


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var AlchoholConsumptionQuestion = /** @class */ (function (_super) {
    __extends(AlchoholConsumptionQuestion, _super);
    function AlchoholConsumptionQuestion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AlchoholConsumptionQuestion.prototype.render = function () {
        var _a = this.props, questions = _a.questions, questionnaire = _a.questionnaire, onQuestionnaireBlur = _a.onQuestionnaireBlur, onQuestionnaireChange = _a.onQuestionnaireChange;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["o" /* ToggleSwitch */], { labelText: questions.consumedAlcohol, name: "consumedAlcohol", onChildren: "Yes", offChildren: "No", onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange, checked: questionnaire.consumedAlcohol, className: "toggle-yes-no", conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: questionnaire.consumedAlcohol, className: "ml-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-0" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline-p" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline-p-text", dangerouslySetInnerHTML: { __html: questions.drinksStart } }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { name: "drinksPerWeekday", className: "form-group-number", pattern: "[0-9]*", value: questionnaire.drinksPerWeekday, onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline-p-text", dangerouslySetInnerHTML: { __html: questions.drinksPerWeekday } }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { name: "drinksPerWeekend", className: "form-group-number", pattern: "[0-9]*", value: questionnaire.drinksPerWeekend, onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline-p-text", dangerouslySetInnerHTML: { __html: questions.drinksPerWeekend } }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { name: "drinksPerSitting", className: "form-group-number", pattern: "[0-9]*", value: questionnaire.drinksPerSitting, onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline-p-text", dangerouslySetInnerHTML: { __html: questions.drinksPerSitting } }))))) }));
    };
    return AlchoholConsumptionQuestion;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AlchoholConsumptionQuestion);


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ForeignTravelList__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms__ = __webpack_require__(5);




var ForeignTravelQuestion = function (props) {
    var isNextDisabled = function () {
        var valid = !(props.questionnaire.abroad == null);
        if (props.questionnaire.abroad === true) {
            if (props.questionnaire.foreignTravelList === undefined || props.questionnaire.foreignTravelList.length === 0) {
                valid = false;
            }
            else {
                valid = valid && props.questionnaire.foreignTravelList.reduce(function (prev, curr) {
                    var validlocation = prev && (curr.abroadDuration !== null
                        && curr.abroadDuration !== ''
                        && curr.abroadLocation !== null
                        && curr.abroadLocation !== '');
                    if (curr.abroadLocation === 'Palestine' || curr.abroadLocation === 'Israel') {
                        validlocation = validlocation &&
                            (curr.abroadIsraelPalestine !== null && curr.abroadIsraelPalestine !== undefined);
                    }
                    return validlocation;
                }, true);
            }
        }
        return !valid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.abroad, name: "abroad", onChildren: "Yes", offChildren: "No", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, checked: props.questionnaire.abroad, className: "toggle-yes-no", conditionalChildren: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire.abroad, className: "ml-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ForeignTravelList__["a" /* default */], { foreignTravelList: props.questionnaire.foreignTravelList, onForeignTravelAdd: props.onForeignTravelAdd, onForeignTravelBlur: props.onForeignTravelBlur, onForeignTravelChange: props.onForeignTravelChange, onForeignTravelRemove: props.onForeignTravelRemove })) }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
/* harmony default export */ __webpack_exports__["a"] = (ForeignTravelQuestion);


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);




var ForeignTravelList = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("fieldset", null,
        props.foreignTravelList.map(function (foreignTravel, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: index, className: "row form-group-set enrollment-foreign-travel-item" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md enrollment-foreign-travel-item-fields" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["h" /* ForeignCountryDropdown */], { labelText: "Where?", id: "abroadLocation" + index, name: "abroadLocation", onBlur: props.onForeignTravelBlur, onChange: function (e) { return props.onForeignTravelChange(e, index); }, country: foreignTravel.abroadLocation, className: "mb-3" }),
                (foreignTravel.abroadLocation === 'Palestine' || foreignTravel.abroadLocation === 'Israel') && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["o" /* ToggleSwitch */], { labelText: "Does this include Gaza or the West Bank?", id: "abroadIsraelPalestine" + index, name: "abroadIsraelPalestine", onChildren: "Yes", offChildren: "No", onBlur: props.onForeignTravelBlur, onChange: function (e) { return props.onForeignTravelChange(e, index); }, checked: foreignTravel.abroadIsraelPalestine, className: "mb-3 toggle-yes-no" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["g" /* DropdownInput */], { labelText: "For how long?", name: "abroadDuration", value: foreignTravel.abroadDuration, onBlur: props.onForeignTravelBlur, onChange: function (e) { return props.onForeignTravelChange(e, index); }, defaultOption: "-", options: [
                        {
                            value: '0-4',
                            text: 'Less than 4 weeks'
                        },
                        {
                            value: '4-12',
                            text: '4-12 weeks'
                        },
                        {
                            value: '13-26',
                            text: '13-26 weeks'
                        },
                        {
                            value: '26+',
                            text: 'More than 26 weeks'
                        }
                    ], className: "mb-2" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-auto" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["a" /* Button */], { onClick: function () { return props.onForeignTravelRemove(index); }, className: "btn-icon btn-icon-primary px-0 form-group-set-remove" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["v" /* IconDelete */], null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle ml-2 d-sm-none" }, "Remove"))))); }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "enrollment-foreign-travel-item" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["a" /* Button */], { onClick: props.onForeignTravelAdd, className: "btn-outline-primary" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Add Country")))));
};
/* harmony default export */ __webpack_exports__["a"] = (ForeignTravelList);


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MedicalHistoryForm__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_authActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__quotingActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_settingsActions__ = __webpack_require__(99);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};








var MedicalHistoryPage = /** @class */ (function (_super) {
    __extends(MedicalHistoryPage, _super);
    function MedicalHistoryPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isNextDisabled = function () {
            if (_this.props.questionnaire.prescriptionPainkillers == null
                || _this.props.questionnaire.furtherExamination == null
                || _this.props.questionnaire.notConsultedDoctor == null
                || !_this.props.questionnaire.familyDiagnosis
                || !_this.props.questionnaire.familyKidneyDisease
                || !_this.props.questionnaire.cancer.isValid) {
                return true;
            }
            return false;
        };
        _this.save = function () {
            return _this.props.actions.saveUser(_this.props.user)
                .then(function () {
                var customerDetails = __assign({}, _this.props.customerDetails, { customerId: _this.props.user.id });
                return _this.props.actions.saveCustomerDetails(customerDetails);
            });
        };
        _this.back = function () {
            _this.save()
                .then(function () { return _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/activities#3"); });
        };
        _this.next = function () {
            window['dataLayer'].push({ event: 'questionnaireComplete' }); // tslint:disable-line
            _this.props.actions.setQuestionnaireNavigationEnabled(false);
            _this.save()
                .then(function () {
                _this.props.actions.setQuestionnaireNavigationEnabled(true);
                _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/review");
            });
        };
        return _this;
    }
    MedicalHistoryPage.prototype.render = function () {
        var _a = this.props, className = _a.className, props = __rest(_a, ["className"]);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MedicalHistoryForm__["a" /* default */], __assign({}, props, { parentNext: this.next, parentPrev: this.back })));
    };
    return MedicalHistoryPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        questions: state.question.questions,
        questionnaire: state.policy.questionnaire,
        user: state.user.user
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__auth_authActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__quotingActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__user_userActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__common_settingsActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(MedicalHistoryPage));


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__medicalQuestions_medicalQuestion1_CancerQuestion__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__medicalQuestions_medicalQuestion1_HeartAndCirculatoryQuestion__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__medicalQuestions_medicalQuestion1_NeurologicalQuestion__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__medicalQuestions_medicalQuestion1_RespiratoryQuestion__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__medicalQuestions_medicalQuestion1_LiverQuestion__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__medicalQuestions_medicalQuestion1_BloodQuestion__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__medicalQuestions_medicalQuestion1_ImmunologicalQuestion__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__medicalQuestions_medicalQuestion1_HeadQuestion__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__medicalQuestions_medicalQuestion2_ReproductiveQuestion__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__medicalQuestions_medicalQuestion2_PsychologicalQuestion__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__medicalQuestions_medicalQuestion3_MedicalQuestion3__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__medicalQuestions_medicalQuestion3_PainkillerQuestion__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__medicalQuestions_medicalQuestion5_FamilyHistory__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_forms_Fieldset__ = __webpack_require__(20);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
















var MedicalHistoryForm = /** @class */ (function (_super) {
    __extends(MedicalHistoryForm, _super);
    function MedicalHistoryForm(props) {
        var _this = _super.call(this, props) || this;
        _this.lastStep = 12;
        _this.prevStep = function (e) {
            var currentStep = _this.state.currentStep;
            if (currentStep <= 0) {
                _this.props.parentPrev(e);
                return;
            }
            else {
                currentStep--;
                _this.setState(__assign({}, _this.state, { currentStep: currentStep }));
            }
        };
        _this.nextStep = function (e) {
            var currentStep = _this.state.currentStep;
            if (currentStep === _this.lastStep) {
                _this.props.parentNext(e);
                return;
            }
            else {
                currentStep++;
                _this.setState(__assign({}, _this.state, { currentStep: currentStep }));
            }
        };
        _this.state = {
            currentStep: _this.getStep()
        };
        return _this;
    }
    MedicalHistoryForm.prototype.getStep = function () {
        var step = parseInt(location.hash.replace('#', ''), 10);
        if (!isNaN(step)) {
            return step;
        }
        return 0;
    };
    MedicalHistoryForm.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.currentStep !== prevState.currentStep) {
            location.hash = this.state.currentStep.toString();
        }
    };
    MedicalHistoryForm.prototype.render = function () {
        var _a = this.props, questions = _a.questions, questionnaire = _a.questionnaire, onQuestionnaireBlur = _a.onQuestionnaireBlur, onQuestionnaireChange = _a.onQuestionnaireChange;
        var gender = this.props.user.gender;
        var currentQuestion = null;
        var questionParameters = {
            questions: questions,
            questionnaire: questionnaire,
            onQuestionnaireBlur: onQuestionnaireBlur,
            onQuestionnaireChange: onQuestionnaireChange,
            nextStep: this.nextStep,
            prevStep: this.prevStep
        };
        switch (this.state.currentStep) {
            case 0:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__medicalQuestions_medicalQuestion1_CancerQuestion__["a" /* default */], __assign({}, questionParameters)));
                break;
            case 1:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__medicalQuestions_medicalQuestion1_HeartAndCirculatoryQuestion__["a" /* default */], __assign({}, questionParameters)));
                break;
            case 2:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__medicalQuestions_medicalQuestion1_NeurologicalQuestion__["a" /* default */], __assign({}, questionParameters)));
                break;
            case 3:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__medicalQuestions_medicalQuestion1_RespiratoryQuestion__["a" /* default */], __assign({}, questionParameters)));
                break;
            case 4:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__medicalQuestions_medicalQuestion1_LiverQuestion__["a" /* default */], __assign({}, questionParameters)));
                break;
            case 5:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__medicalQuestions_medicalQuestion1_BloodQuestion__["a" /* default */], __assign({}, questionParameters)));
                break;
            case 6:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__medicalQuestions_medicalQuestion1_ImmunologicalQuestion__["a" /* default */], __assign({}, questionParameters)));
                break;
            case 7:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__medicalQuestions_medicalQuestion1_HeadQuestion__["a" /* default */], __assign({}, questionParameters)));
                break;
            case 8:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__medicalQuestions_medicalQuestion2_ReproductiveQuestion__["a" /* default */], __assign({ gender: gender }, questionParameters)));
                break;
            case 9:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__medicalQuestions_medicalQuestion2_PsychologicalQuestion__["a" /* default */], __assign({}, questionParameters)));
                break;
            case 10:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__medicalQuestions_medicalQuestion3_MedicalQuestion3__["a" /* default */], __assign({ gender: gender }, questionParameters)));
                break;
            case 11:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__medicalQuestions_medicalQuestion3_PainkillerQuestion__["a" /* default */], __assign({}, questionParameters)));
                break;
            case 12:
            default:
                currentQuestion = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__medicalQuestions_medicalQuestion5_FamilyHistory__["a" /* default */], __assign({}, questionParameters)));
                break;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__WorkflowStep__["a" /* default */], { className: this.props.className, title: this.state.currentStep === 0 ? 'Finally, we\'d like to ask a few questions about your medical history.' : '' },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__components_forms_Fieldset__["a" /* default */], null, currentQuestion)));
    };
    return MedicalHistoryForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (MedicalHistoryForm);


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__ = __webpack_require__(14);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var CancerQuestion = /** @class */ (function (_super) {
    __extends(CancerQuestion, _super);
    function CancerQuestion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CancerQuestion.prototype.render = function () {
        var _a = this.props, questions = _a.questions, questionnaire = _a.questionnaire;
        var isNextDisabled = function () {
            return !questionnaire[questionName].isValid;
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-0" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["j" /* Label */], null, questions[questionName]),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section-base section-bordered mt-1 form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["c" /* CheckboxGroup */], { title: "Cancer, including:", className: "mb-2", checkOptions: [
                        {
                            name: 'cancer',
                            label: 'Any cancer or tumor except for basal cell carcinoma',
                            checked: questionnaire[questionName].cancer,
                            onBlur: this.props.onQuestionnaireBlur,
                            onChange: this.props.onQuestionnaireChange
                        },
                        {
                            name: 'tumor',
                            label: 'Any tumor or growth not yet diagnosed',
                            checked: questionnaire[questionName].tumor,
                            onBlur: this.props.onQuestionnaireBlur,
                            onChange: this.props.onQuestionnaireChange
                        },
                        {
                            name: 'dysplasticNeviSyndrome',
                            label: 'Dysplastic nevi syndrome',
                            checked: questionnaire[questionName].dysplasticNeviSyndrome,
                            onBlur: this.props.onQuestionnaireBlur,
                            onChange: this.props.onQuestionnaireChange
                        },
                        {
                            name: 'cancerOther',
                            label: 'Other',
                            checked: questionnaire[questionName].cancerOther,
                            onBlur: this.props.onQuestionnaireBlur,
                            onChange: this.props.onQuestionnaireChange,
                            conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: questionnaire[questionName].cancerOther },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Please specify:", name: "cancerOtherDetails", onBlur: this.props.onQuestionnaireBlur, onChange: this.props.onQuestionnaireChange, value: questionnaire[questionName].cancerOtherDetails, className: "mb-2" })))
                        },
                        {
                            name: 'cancerNone',
                            label: 'None of the above apply to me',
                            checked: questionnaire[questionName].cancerNone,
                            onBlur: this.props.onQuestionnaireBlur,
                            onChange: this.props.onQuestionnaireChange,
                            className: 'border-top pt-2'
                        },
                    ] })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__["a" /* default */], { nextStep: this.props.nextStep, prevStep: this.props.prevStep, isNextDisabled: isNextDisabled })));
    };
    return CancerQuestion;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var questionName = 'cancer';
var hocConfig = {
    questionName: questionName,
    otherName: 'cancerOther',
    otherDetailsName: 'cancerOtherDetails'
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__["a" /* default */])(CancerQuestion, hocConfig));


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__ = __webpack_require__(14);




var HeartAndCirculatoryQuestion = function (props) {
    var isNextDisabled = function () {
        return !props.questionnaire[questionName].isValid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-0" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["j" /* Label */], null, props.questions[questionName]),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section-base section-bordered mt-1 form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["c" /* CheckboxGroup */], { title: "Heart and circulatory system disorders, including:", className: "mb-2", checkOptions: [
                    {
                        name: 'elevatedCholesterol',
                        label: 'Elevated cholesterol or high blood pressure uncontrolled within the past 12 months',
                        checked: props.questionnaire[questionName].elevatedCholesterol,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'chestPain',
                        label: 'Chest pain or angina',
                        checked: props.questionnaire[questionName].chestPain,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'shortnessOfBreath',
                        label: 'Shortness of breath',
                        checked: props.questionnaire[questionName].shortnessOfBreath,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'heartAttack',
                        label: 'Heart attack (myocardial infarction)',
                        checked: props.questionnaire[questionName].heartAttack,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'coronaryArteryDisease',
                        label: 'Coronary artery disease or carotid artery disease',
                        checked: props.questionnaire[questionName].coronaryArteryDisease,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'aneurysm',
                        label: 'Aneurysm',
                        checked: props.questionnaire[questionName].aneurysm,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'valvularHeartDisease',
                        label: 'Valvular heart disease (e.g., mitral valve prolapse)',
                        checked: props.questionnaire[questionName].valvularHeartDisease,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'cardiomyopathy',
                        label: 'Cardiomyopathy',
                        checked: props.questionnaire[questionName].cardiomyopathy,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'congestiveHeartFailure',
                        label: 'Congestive heart failure',
                        checked: props.questionnaire[questionName].congestiveHeartFailure,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'bypassOrAngioplasty',
                        label: 'Bypass surgery or angioplasty',
                        checked: props.questionnaire[questionName].bypassOrAngioplasty,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'abnormalECG',
                        label: 'Abnormal ECG, cardiac stress test, or echocardiogram',
                        checked: props.questionnaire[questionName].abnormalECG,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'irregularPulse',
                        label: 'Irregular pulse',
                        checked: props.questionnaire[questionName].irregularPulse,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'heartMurmur',
                        label: 'Heart murmur',
                        checked: props.questionnaire[questionName].heartMurmur,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'pacemaker',
                        label: 'Pacemaker',
                        checked: props.questionnaire[questionName].pacemaker,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'peripheralVascularDisease',
                        label: 'Peripheral vascular disease',
                        checked: props.questionnaire[questionName].peripheralVascularDisease,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'bloodClot',
                        label: 'Blood clot, embolism or clotting disorder',
                        checked: props.questionnaire[questionName].bloodClot,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'heartDisorderOther',
                        label: 'Other',
                        checked: props.questionnaire[questionName].heartDisorderOther,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].heartDisorderOther },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Please specify:", name: "heartDisorderOtherDetails", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, value: props.questionnaire[questionName].heartDisorderOtherDetails, className: "mb-2" })))
                    },
                    {
                        name: questionName + "None",
                        label: 'None of the above apply to me',
                        checked: props.questionnaire[questionName][questionName + "None"],
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        className: 'border-top pt-2'
                    },
                ] })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
var questionName = 'heartCirculatory';
var hocConfig = {
    questionName: questionName,
    otherName: 'heartDisorderOther',
    otherDetailsName: 'heartDisorderOtherDetails'
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__["a" /* default */])(HeartAndCirculatoryQuestion, hocConfig));


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__ = __webpack_require__(14);




var NeurologicalQuestion = function (props) {
    var isNextDisabled = function () {
        return !props.questionnaire[questionName].isValid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-0" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["j" /* Label */], null, props.questions[questionName]),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section-base section-bordered mt-1 form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["c" /* CheckboxGroup */], { title: "Neurological disorders, including:", className: "mb-2", checkOptions: [
                    {
                        name: 'epilepsy',
                        label: 'Epilepsy or seizures with any episodes within the past 12 months',
                        checked: props.questionnaire[questionName].epilepsy,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'tremor',
                        label: 'Tremor',
                        checked: props.questionnaire[questionName].tremor,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'huntingtonsDisease',
                        label: "Huntington's disease",
                        checked: props.questionnaire[questionName].huntingtonsDisease,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'brainAneurysm',
                        label: 'Brain aneurysm',
                        checked: props.questionnaire[questionName].brainAneurysm,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'tia',
                        label: 'Transient ischemic attack (TIA)',
                        checked: props.questionnaire[questionName].tia,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'stroke',
                        label: 'Stroke',
                        checked: props.questionnaire[questionName].stroke,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'parkinsonsDisease',
                        label: "Parkinson's disease",
                        checked: props.questionnaire[questionName].parkinsonsDisease,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'als',
                        label: "Motor neuron disease (Lou Gehrig's disease or ALS)",
                        checked: props.questionnaire[questionName].als,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'alzheimersDisease',
                        label: "Alzheimer's disease",
                        checked: props.questionnaire[questionName].alzheimersDisease,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'cognitiveImpairment',
                        label: 'Cognitive impairment',
                        checked: props.questionnaire[questionName].cognitiveImpairment,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'dementia',
                        label: 'Dementia',
                        checked: props.questionnaire[questionName].dementia,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'multipleSclerosis',
                        label: 'Multiple sclerosis',
                        checked: props.questionnaire[questionName].multipleSclerosis,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'muscularDystrophy',
                        label: 'Muscular dystrophy',
                        checked: props.questionnaire[questionName].muscularDystrophy,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'lossOfBalance',
                        label: 'Loss of balance',
                        checked: props.questionnaire[questionName].lossOfBalance,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'lossOfSpeech',
                        label: 'Loss of speech',
                        checked: props.questionnaire[questionName].lossOfSpeech,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'cerebralPalsy',
                        label: 'Cerebral palsy',
                        checked: props.questionnaire[questionName].cerebralPalsy,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'downSyndrome',
                        label: 'Down syndrome',
                        checked: props.questionnaire[questionName].downSyndrome,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'autism',
                        label: 'Autism',
                        checked: props.questionnaire[questionName].autism,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'developmentalDisorder',
                        label: 'Developmental disorder',
                        checked: props.questionnaire[questionName].developmentalDisorder,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'muscleWeakness',
                        label: 'Muscle weakness, tingling, or numbness of the extremities',
                        checked: props.questionnaire[questionName].muscleWeakness,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'neurologicalDisorderOther',
                        label: 'Other',
                        checked: props.questionnaire[questionName].neurologicalDisorderOther,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].neurologicalDisorderOther },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Please specify:", name: "neurologicalDisorderOtherDetails", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, value: props.questionnaire[questionName].neurologicalDisorderOtherDetails, className: "mb-2" })))
                    },
                    {
                        name: 'neurologicalNone',
                        label: 'None of the above apply to me',
                        checked: props.questionnaire[questionName].neurologicalNone,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        className: 'border-top pt-2'
                    },
                ] })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
var questionName = 'neurological';
var hocConfig = {
    questionName: questionName,
    otherName: 'neurologicalDisorderOther',
    otherDetailsName: 'neurologicalDisorderOtherDetails'
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__["a" /* default */])(NeurologicalQuestion, hocConfig));


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__ = __webpack_require__(14);




var RespiratoryQuestion = function (props) {
    var isNextDisabled = function () {
        return !props.questionnaire[questionName].isValid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-0" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["j" /* Label */], null, props.questions[questionName]),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section-base section-bordered mt-1 form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["c" /* CheckboxGroup */], { title: "Respiratory disorders, including:", className: "mb-2", checkOptions: [
                    {
                        name: 'sleepApnea',
                        label: 'Sleep apnea for which you are not treated',
                        checked: props.questionnaire[questionName].sleepApnea,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'emphysema',
                        label: 'Emphysema',
                        checked: props.questionnaire[questionName].emphysema,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'tuberculosis',
                        label: 'Tuberculosis',
                        checked: props.questionnaire[questionName].tuberculosis,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'sarcoidosis',
                        label: 'Sarcoidosis',
                        checked: props.questionnaire[questionName].sarcoidosis,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'cysticFibrosis',
                        label: 'Cystic fibrosis',
                        checked: props.questionnaire[questionName].cysticFibrosis,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'asthma',
                        label: "Asthma requiring either a visit to the emergency room\n\t\t\t\t\t\t\t\tor the administration of oxygen within the past 12 months",
                        checked: props.questionnaire[questionName].asthma,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'copd',
                        label: 'Chronic obstructive pulmonary disease (COPD)',
                        checked: props.questionnaire[questionName].copd,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'respiratoryDisorderOther',
                        label: 'Other',
                        checked: props.questionnaire[questionName].respiratoryDisorderOther,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].respiratoryDisorderOther },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Please specify:", name: "respiratoryDisorderOtherDetails", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, value: props.questionnaire[questionName].respiratoryDisorderOtherDetails, className: "mb-2" })))
                    },
                    {
                        name: 'respiratoryNone',
                        label: 'None of the above apply to me',
                        checked: props.questionnaire[questionName].respiratoryNone,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        className: 'border-top pt-2'
                    },
                ] })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
var questionName = 'respiratory';
var hocConfig = {
    questionName: questionName,
    otherName: 'respiratoryDisorderOther',
    otherDetailsName: 'respiratoryDisorderOtherDetails'
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__["a" /* default */])(RespiratoryQuestion, hocConfig));


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__ = __webpack_require__(14);




var LiverQuestion = function (props) {
    var isNextDisabled = function () {
        return !props.questionnaire[questionName].isValid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-0" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["j" /* Label */], null, props.questions[questionName]),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section-base section-bordered mt-1 form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["c" /* CheckboxGroup */], { title: "Liver, stomach, bladder, kidney, or gastrointestinal disorders, including:", className: "mb-2", checkOptions: [
                    {
                        name: 'hepatitisBorC',
                        label: 'Hepatitis B or C',
                        checked: props.questionnaire[questionName].hepatitisBorC,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'cirrhosis',
                        label: 'Cirrhosis',
                        checked: props.questionnaire[questionName].cirrhosis,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'sclerosingCholangitis',
                        label: 'Sclerosing cholangitis',
                        checked: props.questionnaire[questionName].sclerosingCholangitis,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'crohnsDisease',
                        label: "Crohn\u2019s disease or ulcerative colitis with any flare-up within\n\t\t\t\t\t\t\t\tthe past 5 years or any continued use of oral steroid",
                        checked: props.questionnaire[questionName].crohnsDisease,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'bleedingRectum',
                        label: 'Rectal bleeding other than diagnosed as hemorrhoids',
                        checked: props.questionnaire[questionName].bleedingRectum,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'pancreatitis',
                        label: 'Pancreatitis',
                        checked: props.questionnaire[questionName].pancreatitis,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'chronicKidneyDisease',
                        label: 'Chronic kidney disease or nephritis',
                        checked: props.questionnaire[questionName].chronicKidneyDisease,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'bloodInUrine',
                        label: 'Blood or protein in urine',
                        checked: props.questionnaire[questionName].bloodInUrine,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'gastrointestinalDisorderOther',
                        label: 'Other',
                        checked: props.questionnaire[questionName].gastrointestinalDisorderOther,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].gastrointestinalDisorderOther },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Please specify:", name: "gastrointestinalDisorderOtherDetails", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, value: props.questionnaire[questionName].gastrointestinalDisorderOtherDetails, className: "mb-2" })))
                    },
                    {
                        name: 'liverNone',
                        label: 'None of the above apply to me',
                        checked: props.questionnaire[questionName].liverNone,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        className: 'border-top pt-2'
                    },
                ] })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
var questionName = 'liver';
var hocConfig = {
    questionName: questionName,
    otherName: 'gastrointestinalDisorderOther',
    otherDetailsName: 'gastrointestinalDisorderOtherDetails'
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__["a" /* default */])(LiverQuestion, hocConfig));


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__ = __webpack_require__(14);




var BloodQuestion = function (props) {
    var isNextDisabled = function () {
        return !props.questionnaire[questionName].isValid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-0" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["j" /* Label */], null, props.questions[questionName]),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section-base section-bordered mt-1 form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["c" /* CheckboxGroup */], { title: "Blood, glandular or endocrine system disorders, including:", className: "mb-2", checkOptions: [
                    {
                        name: 'diabetes',
                        label: 'Diabetes',
                        checked: props.questionnaire[questionName].diabetes,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'goiter',
                        label: 'Goiter or thyroid disorder other than hypothyroidism',
                        checked: props.questionnaire[questionName].goiter,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'anemia',
                        label: 'Anemia',
                        checked: props.questionnaire[questionName].anemia,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'bleedingDisorder',
                        label: 'Bleeding disorder',
                        checked: props.questionnaire[questionName].bleedingDisorder,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'hemophilia',
                        label: 'Hemophilia',
                        checked: props.questionnaire[questionName].hemophilia,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'sicklecell',
                        label: 'Sickle cell anemia',
                        checked: props.questionnaire[questionName].sicklecell,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'thalassemia',
                        label: 'Thalassemia',
                        checked: props.questionnaire[questionName].thalassemia,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'endocrineDisorderOther',
                        label: 'Other',
                        checked: props.questionnaire[questionName].endocrineDisorderOther,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].endocrineDisorderOther },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Please specify:", name: "endocrineDisorderOtherDetails", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, value: props.questionnaire[questionName].endocrineDisorderOtherDetails, className: "mb-2" })))
                    },
                    {
                        name: 'bloodNone',
                        label: 'None of the above apply to me',
                        checked: props.questionnaire[questionName].bloodNone,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        className: 'border-top pt-2'
                    },
                ] })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
var questionName = 'blood';
var hocConfig = {
    questionName: questionName,
    otherName: 'endocrineDisorderOther',
    otherDetailsName: 'endocrineDisorderOtherDetails'
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__["a" /* default */])(BloodQuestion, hocConfig));


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__ = __webpack_require__(14);




var ImmunologicalQuestion = function (props) {
    var isNextDisabled = function () {
        return !props.questionnaire[questionName].isValid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-0" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["j" /* Label */], null, props.questions[questionName]),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section-base section-bordered mt-1 form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["c" /* CheckboxGroup */], { title: "Immunological disorders, including:", className: "mb-2", checkOptions: [
                    {
                        name: 'aids',
                        label: 'Acquired immune deficiency syndrome (AIDS)',
                        checked: props.questionnaire[questionName].aids,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'arc',
                        label: 'AIDS related complex (ARC)',
                        checked: props.questionnaire[questionName].arc,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'hiv',
                        label: 'Human immunodeficiency virus (HIV)',
                        checked: props.questionnaire[questionName].hiv,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'immuneSystemDisorderOther',
                        label: 'Other',
                        checked: props.questionnaire[questionName].immuneSystemDisorderOther,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].immuneSystemDisorderOther },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Please specify:", name: "immuneSystemDisorderOtherDetails", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, value: props.questionnaire[questionName].immuneSystemDisorderOtherDetails, className: "mb-2" })))
                    },
                    {
                        name: 'immunoNone',
                        label: 'None of the above apply to me',
                        checked: props.questionnaire[questionName].immunoNone,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        className: 'border-top pt-2'
                    },
                ] })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
var questionName = 'immuno';
var hocConfig = {
    questionName: questionName,
    otherName: 'immuneSystemDisorderOther',
    otherDetailsName: 'immuneSystemDisorderOtherDetails'
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__["a" /* default */])(ImmunologicalQuestion, hocConfig));


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__ = __webpack_require__(14);




var HeadQuestion = function (props) {
    var isNextDisabled = function () {
        return !props.questionnaire[questionName].isValid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-0" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["j" /* Label */], null, props.questions[questionName]),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section-base section-bordered mt-1 form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["c" /* CheckboxGroup */], { title: "Head injury or musculoskeletal system disorders, including:", className: "mb-2", checkOptions: [
                    {
                        name: 'brainInjury',
                        label: 'Traumatic brain injury or post-concussion syndrome with ongoing symptoms',
                        checked: props.questionnaire[questionName].brainInjury,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'rheumatoidArthritis',
                        label: 'Rheumatoid arthritis',
                        checked: props.questionnaire[questionName].rheumatoidArthritis,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'ankylosingSpondylitis',
                        label: 'Ankylosing spondylitis',
                        checked: props.questionnaire[questionName].ankylosingSpondylitis,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'connectiveTissueDisease',
                        label: 'Connective tissue disease',
                        checked: props.questionnaire[questionName].connectiveTissueDisease,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'lupus',
                        label: 'Lupus',
                        checked: props.questionnaire[questionName].lupus,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'paralysis',
                        label: 'Paralysis',
                        checked: props.questionnaire[questionName].paralysis,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange
                    },
                    {
                        name: 'musculoskeletalDisorderOther',
                        label: 'Other',
                        checked: props.questionnaire[questionName].musculoskeletalDisorderOther,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].musculoskeletalDisorderOther },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Please specify:", name: "musculoskeletalDisorderOtherDetails", onBlur: props.onQuestionnaireBlur, onChange: props.onQuestionnaireChange, value: props.questionnaire[questionName].musculoskeletalDisorderOtherDetails, className: "mb-2" })))
                    },
                    {
                        name: 'headNone',
                        label: 'None of the above apply to me',
                        checked: props.questionnaire[questionName].headNone,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        className: 'border-top pt-2'
                    },
                ] })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
var questionName = 'head';
var hocConfig = {
    questionName: questionName,
    otherName: 'musculoskeletalDisorderOther',
    otherDetailsName: 'musculoskeletalDisorderOtherDetails'
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__["a" /* default */])(HeadQuestion, hocConfig));


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__ = __webpack_require__(14);




var ReproductiveQuestion = function (props) {
    var gender = props.gender, questionnaire = props.questionnaire, onQuestionnaireBlur = props.onQuestionnaireBlur, onQuestionnaireChange = props.onQuestionnaireChange;
    var isNextDisabled = function () {
        if (!props.questionnaire[questionName].isValid ||
            (props.questionnaire[questionName].abnormalMammogram &&
                props.questionnaire[questionName].abnormalMammogramRepeat == null) ||
            (props.questionnaire[questionName].breastImagingTestOrPAPTest &&
                props.questionnaire[questionName].breastImagingTestOrPAPTestRepeat == null) ||
            (props.questionnaire[questionName].abnormalPSATest &&
                props.questionnaire[questionName].abnormalPSATestRepeat == null)) {
            return true;
        }
        return false;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-0" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["j" /* Label */], null, props.questions[questionName]),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section-base section-bordered mt-1 form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["c" /* CheckboxGroup */], { title: "Reproductive system disorders, including:", className: "mb-2", checkOptions: [
                    {
                        name: 'abnormalMammogram',
                        label: 'Abnormal mammogram or breast imaging',
                        checked: questionnaire[questionName].abnormalMammogram,
                        onBlur: onQuestionnaireBlur,
                        onChange: onQuestionnaireChange,
                        conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].abnormalMammogram },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.abnormalMammogramRepeat, className: "mb-2 toggle-yes-no", name: "abnormalMammogramRepeat", onChildren: "Yes", offChildren: "No", onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange, checked: props.questionnaire[questionName].abnormalMammogramRepeat })))
                    },
                    gender === 'female' ?
                        {
                            name: 'breastImagingTestOrPAPTest',
                            label: 'Abnormal PAP test',
                            checked: questionnaire[questionName].breastImagingTestOrPAPTest,
                            onBlur: onQuestionnaireBlur,
                            onChange: onQuestionnaireChange,
                            conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].breastImagingTestOrPAPTest },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.breastImagingTestOrPAPTestRepeat, className: "mb-2 toggle-yes-no", name: "breastImagingTestOrPAPTestRepeat", onChildren: "Yes", offChildren: "No", onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange, checked: props.questionnaire[questionName].breastImagingTestOrPAPTestRepeat })))
                        } :
                        {
                            name: 'abnormalPSATest',
                            label: 'Abnormal prostate (PSA) test',
                            checked: questionnaire[questionName].abnormalPSATest,
                            onBlur: onQuestionnaireBlur,
                            onChange: onQuestionnaireChange,
                            conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: props.questionnaire[questionName].abnormalPSATest },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.abnormalPSATestRepeat, className: "mb-2 toggle-yes-no", name: "abnormalPSATestRepeat", onChildren: "Yes", offChildren: "No", onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange, checked: props.questionnaire[questionName].abnormalPSATestRepeat })))
                        },
                    {
                        name: 'abnormalBiopsy',
                        label: 'Abnormal biopsy',
                        checked: questionnaire[questionName].abnormalBiopsy,
                        onBlur: onQuestionnaireBlur,
                        onChange: onQuestionnaireChange
                    },
                    {
                        name: 'reproductiveDisorderOther',
                        label: 'Other',
                        checked: questionnaire[questionName].reproductiveDisorderOther,
                        onBlur: onQuestionnaireBlur,
                        onChange: onQuestionnaireChange,
                        conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: questionnaire[questionName].reproductiveDisorderOther },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Please specify:", name: "reproductiveDisorderOtherDetails", onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange, value: questionnaire[questionName].reproductiveDisorderOtherDetails, className: "mb-2" })))
                    },
                    {
                        name: 'reproductiveNone',
                        label: 'None of the above apply to me',
                        checked: questionnaire[questionName].reproductiveNone,
                        onBlur: onQuestionnaireBlur,
                        onChange: onQuestionnaireChange,
                        className: 'border-top pt-2'
                    },
                ] })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
var questionName = 'reproductive';
var hocConfig = {
    questionName: questionName,
    otherName: 'reproductiveDisorderOther',
    otherDetailsName: 'reproductiveDisorderOtherDetails'
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__["a" /* default */])(ReproductiveQuestion, hocConfig));


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__ = __webpack_require__(14);




var PsychologicalQuestion = function (props) {
    var questionnaire = props.questionnaire, onQuestionnaireBlur = props.onQuestionnaireBlur, onQuestionnaireChange = props.onQuestionnaireChange, questions = props.questions;
    var isNextDisabled = function () {
        return !props.questionnaire[questionName].isValid;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group mb-0" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["j" /* Label */], null, props.questions[questionName]),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "section-base section-bordered mt-1 form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["c" /* CheckboxGroup */], { title: "Psychological disorders, including:", checkOptions: [
                    {
                        name: 'bipolarDisease',
                        label: 'Bipolar disease',
                        checked: questionnaire[questionName].bipolarDisease,
                        onBlur: onQuestionnaireBlur,
                        onChange: onQuestionnaireChange
                    },
                    {
                        name: 'psychosis',
                        label: 'Psychosis or any psychotic episode',
                        checked: questionnaire[questionName].psychosis,
                        onBlur: onQuestionnaireBlur,
                        onChange: onQuestionnaireChange
                    },
                    {
                        name: 'depression',
                        label: questions.depression,
                        checked: questionnaire[questionName].depression,
                        onBlur: onQuestionnaireBlur,
                        onChange: onQuestionnaireChange
                    },
                    {
                        name: 'hospitalizedForAnyDepressiveIllness',
                        label: questions.hospitalizedForAnyDepressiveIllness,
                        checked: questionnaire[questionName].hospitalizedForAnyDepressiveIllness,
                        onBlur: onQuestionnaireBlur,
                        onChange: onQuestionnaireChange
                    },
                    {
                        name: 'fibromyalgiaOrChronicFatigueSyndrome',
                        label: questions.fibromyalgiaOrChronicFatigueSyndrome,
                        checked: questionnaire[questionName].fibromyalgiaOrChronicFatigueSyndrome,
                        onBlur: onQuestionnaireBlur,
                        onChange: onQuestionnaireChange
                    },
                    {
                        name: 'contemplatedSuicide',
                        label: 'Any contemplated or attempted suicide',
                        checked: questionnaire[questionName].contemplatedSuicide,
                        onBlur: onQuestionnaireBlur,
                        onChange: onQuestionnaireChange
                    },
                    {
                        name: 'psychologicalDisorderOther',
                        label: 'Other',
                        checked: questionnaire[questionName].psychologicalDisorderOther,
                        onBlur: onQuestionnaireBlur,
                        onChange: onQuestionnaireChange,
                        conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: questionnaire[questionName].psychologicalDisorderOther },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Please specify:", name: "psychologicalDisorderOtherDetails", onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange, value: questionnaire[questionName].psychologicalDisorderOtherDetails, className: "mb-2" })))
                    },
                    {
                        name: 'psychologicalNone',
                        label: 'None of the above apply to me',
                        checked: props.questionnaire[questionName].psychologicalNone,
                        onBlur: props.onQuestionnaireBlur,
                        onChange: props.onQuestionnaireChange,
                        className: 'border-top pt-2'
                    },
                ], className: "mb-2" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
var questionName = 'psychological';
var hocConfig = {
    questionName: questionName,
    otherName: 'psychologicalDisorderOther',
    otherDetailsName: 'psychologicalDisorderOtherDetails'
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__handleNoneOptionAndValidationHOC__["a" /* default */])(PsychologicalQuestion, hocConfig));


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NextPreviousButtons__ = __webpack_require__(14);



var MedicalQuestion3 = function (props) {
    var questions = props.questions, questionnaire = props.questionnaire, onQuestionnaireBlur = props.onQuestionnaireBlur, onQuestionnaireChange = props.onQuestionnaireChange, gender = props.gender;
    var isNextDisabled = function () {
        if (questionnaire.furtherExamination == null
            || (questionnaire.furtherExamination && gender === 'female' && questionnaire.furtherExaminationPregnancy == null)) {
            return true;
        }
        return questionnaire.notConsultedDoctor == null;
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["o" /* ToggleSwitch */], { labelText: questions.furtherExamination, name: "furtherExamination", onChildren: "Yes", offChildren: "No", onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange, checked: questionnaire.furtherExamination, className: "toggle-yes-no", conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: gender === 'female' && questionnaire.furtherExamination },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["o" /* ToggleSwitch */], { labelText: questions.furtherExaminationPregnancy, name: "furtherExaminationPregnancy", onChildren: "Yes", offChildren: "No", onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange, checked: questionnaire.furtherExaminationPregnancy, className: "mb-2 toggle-yes-no" }))) }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["o" /* ToggleSwitch */], { labelText: questions.notConsultedDoctor, name: "notConsultedDoctor", onChildren: "Yes", offChildren: "No", onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange, checked: questionnaire.notConsultedDoctor, className: "toggle-yes-no" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
/* harmony default export */ __webpack_exports__["a"] = (MedicalQuestion3);


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NextPreviousButtons__ = __webpack_require__(14);



var PainkillerQuestion = function (props) {
    var questions = props.questions, questionnaire = props.questionnaire, onQuestionnaireBlur = props.onQuestionnaireBlur, onQuestionnaireChange = props.onQuestionnaireChange;
    var isNextDisabled = function () {
        if (questionnaire.prescriptionPainkillers == null
            || (questionnaire.prescriptionPainkillers && questionnaire.prescriptionPainkillersOver6Months == null)) {
            return true;
        }
        else {
            return false;
        }
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["o" /* ToggleSwitch */], { labelText: questions.prescriptionPainkillers, name: "prescriptionPainkillers", onChildren: "Yes", offChildren: "No", onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange, checked: questionnaire.prescriptionPainkillers, className: "toggle-yes-no", conditionalChildren: (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["i" /* FormCheckConditional */], { isOpen: questionnaire.prescriptionPainkillers, className: "ml-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["o" /* ToggleSwitch */], { labelText: questions.prescriptionPainkillersOver6Months, name: "prescriptionPainkillersOver6Months", onChildren: "Yes", offChildren: "No", onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange, checked: questionnaire.prescriptionPainkillersOver6Months, className: "mb-2 toggle-yes-no" }))) }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
/* harmony default export */ __webpack_exports__["a"] = (PainkillerQuestion);


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NextPreviousButtons__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(1);




var MedicalQuestion5 = function (props) {
    var questionnaire = props.questionnaire, onQuestionnaireBlur = props.onQuestionnaireBlur, onQuestionnaireChange = props.onQuestionnaireChange;
    var isNextDisabled = function () {
        if (questionnaire.familyDiagnosis == null || questionnaire.familyKidneyDisease == null) {
            return true;
        }
        else {
            return false;
        }
    };
    var onUnknownBlur = function (e, name) {
        var value = __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].parseValueFromEvent(e);
        var questionnaireEvent = {
            target: {
                name: name,
                value: value ? 'Unknown' : null,
                type: 'custom'
            }
        };
        onQuestionnaireBlur(questionnaireEvent);
    };
    var onUnknownChange = function (e, name) {
        var value = __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].parseValueFromEvent(e);
        var questionnaireEvent = {
            target: {
                name: name,
                value: value ? 'Unknown' : null,
                type: 'custom'
            }
        };
        onQuestionnaireChange(questionnaireEvent);
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.familyDiagnosis, name: "familyDiagnosis", onChildren: "Yes", offChildren: "No", onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange, checked: questionnaire.familyDiagnosis, className: "toggle-yes-no" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["b" /* Checkbox */], { name: "familyDiagnosisUnknown", label: "I do not know my biological parents or siblings", value: "Unknown", checked: questionnaire.familyDiagnosis === 'Unknown', onBlur: function (e) { return onUnknownBlur(e, 'familyDiagnosis'); }, onChange: function (e) { return onUnknownChange(e, 'familyDiagnosis'); } })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["o" /* ToggleSwitch */], { labelText: props.questions.familyKidneyDisease, name: "familyKidneyDisease", onChildren: "Yes", offChildren: "No", onBlur: onQuestionnaireBlur, onChange: onQuestionnaireChange, checked: questionnaire.familyKidneyDisease, className: "toggle-yes-no" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["b" /* Checkbox */], { name: "familyKidneyDiseaseUnknown", label: "I do not know my biological parents or siblings", value: "Unknown", checked: questionnaire.familyKidneyDisease === 'Unknown', onBlur: function (e) { return onUnknownBlur(e, 'familyKidneyDisease'); }, onChange: function (e) { return onUnknownChange(e, 'familyKidneyDisease'); } })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__NextPreviousButtons__["a" /* default */], { nextStep: props.nextStep, prevStep: props.prevStep, isNextDisabled: isNextDisabled })));
};
/* harmony default export */ __webpack_exports__["a"] = (MedicalQuestion5);


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BillingPage__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReviewPage__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OptionalBeneficiaryContainer__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__payment_paymentActions__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__auth_authActions__ = __webpack_require__(17);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};











var BillingReviewPage = /** @class */ (function (_super) {
    __extends(BillingReviewPage, _super);
    function BillingReviewPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: true,
            isSoftDeclineChecking: true
        };
        _this.updatePolicy = function () {
            // updates the pending policy with today's date and ensures the correct rate after all questions are answered.
            var originalPremium = _this.props.customerPolicy.rate;
            return _this.props.actions.updatePolicy(_this.props.customerPolicy.id)
                .then(function () {
                if (_this.props.customerPolicy.rate > originalPremium) {
                    _this.props.actions.setPremiumChanged(true);
                }
                else {
                    _this.props.actions.setPremiumChanged(false);
                }
            });
        };
        return _this;
    }
    BillingReviewPage.prototype.componentDidMount = function () {
        var _this = this;
        this.props.actions.fetchIsSoftDeclined(this.props.user.id, this.props.customerPolicy.id)
            .then(this.updatePolicy)
            .then(function () {
            if (_this.props.isSoftDeclined.isDeclined) {
                return _this.props.history.push("/quote/declined");
            }
            else {
                // only show page if not declined, this prevents flashing the review page before redirecting.
                _this.setState({ isSoftDeclineChecking: false, isLoading: false });
            }
        })
            .catch(function () {
            return _this.props.history.push("/quote/declined");
        });
    };
    BillingReviewPage.prototype.render = function () {
        var _a = this.props, className = _a.className, props = __rest(_a, ["className"]);
        var congratsText = props.match.params.enrollmentPage !== 'billing' ?
            (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, "Your application has been approved!"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, "Details of your term life policy are as follows.")))
            : 'Please enter your payment details and click Enroll to begin your coverage.';
        return !this.state.isSoftDeclineChecking && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__WorkflowStep__["a" /* default */], { className: className, title: congratsText },
            props.match.params.enrollmentPage === 'review' &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ReviewPage__["a" /* default */], __assign({}, props, { hidden: false, isLoading: this.state.isLoading })),
            props.match.params.enrollmentPage === 'beneficiary' &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__OptionalBeneficiaryContainer__["a" /* default */], __assign({}, props, { hidden: false })),
            props.match.params.enrollmentPage === 'billing' &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__BillingPage__["a" /* default */], __assign({}, props, { hidden: false }))));
    };
    return BillingReviewPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        currentUser: state.auth.currentUser,
        customerDetails: state.quoting.customerDetails,
        premiumChanged: state.policy.premiumChanged,
        isSoftDeclined: state.policy.isSoftDeclined,
        referrals: state.user.referrals
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_7__user_userActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__policy_policyActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__payment_paymentActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__auth_authActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(BillingReviewPage));


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ga__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BillingForm__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









var BillingPage = /** @class */ (function (_super) {
    __extends(BillingPage, _super);
    function BillingPage(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = { mailingPostalCode: {}, billingPostalCode: {} };
        _this.save = function () {
            var user = __assign({}, _this.props.user);
            if (user.isSameAddress) {
                user.billingAddress = user.mailingAddress;
                user.billingCity = user.mailingCity;
                user.billingProvince = user.mailingProvince;
                user.billingPostalCode = user.mailingPostalCode;
                user.billingCountry = user.mailingCountry;
            }
            var p1 = _this.props.actions.saveUser(user);
            var p2 = _this.props.actions.saveCustomerPolicy(_this.props.customerPolicy);
            return Promise.all([p1, p2]);
        };
        _this.back = function () {
            _this.save()
                .then(function () {
                return _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/review");
            });
        };
        _this.enroll = function () {
            _this.setState({ isLoading: true });
            _this.save()
                .then(function () {
                var card = {
                    name: _this.props.paymentDetails.ccCardholderName,
                    address_line1: _this.props.user.billingAddress,
                    address_city: _this.props.user.billingCity,
                    address_state: _this.props.user.billingProvince,
                    address_zip: _this.props.user.billingPostalCode,
                };
                return _this.props.stripe.createToken(card);
            })
                .then(function (result) {
                if (result.error) {
                    throw (result.error.message);
                }
                else {
                    return result.token;
                }
            })
                .then(function (token) {
                var resetPasswordUrl = _this.props.actions.getResetPasswordUrlForEmail();
                return _this.props.actions.createNewCustomerSubscription(_this.props.user.id, _this.props.customerPolicy.id, token.id, _this.props.referrals.referralCode, false, resetPasswordUrl);
            })
                .then(function () { return _this.props.actions.approveAllBeneficiariesForCustomer({ id: _this.props.user.id, policyId: _this.props.customerPolicy.id }); })
                .then(function () { return _this.sendAnalyticsData(); })
                .then(function () { return _this.gotoSignup(); })
                .catch(function (errorMessage) {
                __WEBPACK_IMPORTED_MODULE_1_toastr__["error"](errorMessage);
                _this.setState({ isLoading: false });
            });
        };
        _this.sendAnalyticsData = function () {
            var user = {
                userId: _this.props.user.id,
                term: _this.props.customerPolicy.term,
                rate: _this.props.customerPolicy.rate,
                coverageAmount: _this.props.customerPolicy.coverageAmount,
                age: _this.props.customerDetails.age,
                gender: _this.props.user.gender,
                smoker: _this.props.customerDetails.isSmoker
            };
            __WEBPACK_IMPORTED_MODULE_2_react_ga__["event"]({
                category: 'User',
                action: 'signup',
                label: JSON.stringify(user)
            });
        };
        _this.gotoSignup = function () {
            _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/sign-up");
        };
        _this.isNextDisabled = function () {
            if (_this.state.isLoading) {
                return true;
            }
            if (_this.errors.mailingPostalCode.hasError ||
                (!_this.props.user.isSameAddress && _this.errors.billingPostalCode.hasError)) {
                return true;
            }
            return (!_this.state.card_number ||
                !_this.state.card_cvv ||
                !_this.state.card_expiry ||
                !_this.props.paymentDetails.ccCardholderName ||
                !_this.props.user.mailingAddress ||
                !_this.props.user.mailingCity ||
                !_this.props.user.mailingProvince ||
                !_this.props.user.mailingPostalCode ||
                !_this.props.user.mailingCountry ||
                (!_this.props.user.isSameAddress &&
                    (!_this.props.user.billingAddress ||
                        !_this.props.user.billingCity ||
                        !_this.props.user.billingProvince ||
                        !_this.props.user.billingPostalCode ||
                        !_this.props.user.billingCountry)) ||
                !_this.props.user.phoneNumber);
        };
        _this.validate = function () {
            // true means invalid
            return {
                mailingPostalCode: __WEBPACK_IMPORTED_MODULE_8__common_utils__["k" /* Validation */]
                    .validatePostalCode(_this.props.user.mailingPostalCode, 'Mailing postal code is not valid.'),
                billingPostalCode: __WEBPACK_IMPORTED_MODULE_8__common_utils__["k" /* Validation */]
                    .validatePostalCode(_this.props.user.billingPostalCode, 'Billing postal code is not valid.')
            };
        };
        _this.onStripeElementChange = function (element, name) {
            if (!element.empty && element.complete) {
                _this.setState((_a = {}, _a[name] = true, _a));
            }
            else {
                _this.setState((_b = {}, _b[name] = false, _b));
            }
            var _a, _b;
        };
        _this.onPhoneKeyUp = function (e) {
            var phone = e.target.value;
            phone = phone
                .match(/\d*/g)
                .join('')
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
                .slice(1)
                .join('-')
                .replace(/-*$/g, '');
            var user = __assign({}, _this.props.user, (_a = {}, _a[e.target.name] = phone, _a));
            _this.props.actions.setUser(user);
            var _a;
        };
        _this.onPolicyChange = function (e) {
            var value = __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].parseValueFromEvent(e);
            var customerPolicy = __assign({}, _this.props.customerPolicy, (_a = {}, _a[e.target.name] = value, _a));
            _this.props.actions.setCustomerPolicy(customerPolicy);
            var _a;
        };
        _this.isCustomer = function (roles) {
            if (!roles) {
                return false;
            }
            else {
                return roles.indexOf("Customer" /* Customer */) > -1 && roles.length === 1;
            }
        };
        _this.state = {
            card_number: false,
            card_cvv: false,
            card_expiry: false,
            isLoading: false
        };
        return _this;
    }
    BillingPage.prototype.componentDidMount = function () {
        // window.onpopstate = () => null;
    };
    BillingPage.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set", hidden: this.props.hidden },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms_Fieldset__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled d-lg-flex" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "mb-3 mb-lg-0 mr-lg-5 strong text-secondary" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Coverage"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "xlarge" },
                            __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].formatCurrency(this.props.customerPolicy.coverageAmount, 0),
                            " CAD")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "mb-3 mb-lg-0 mr-lg-5 strong text-secondary" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Term"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "xlarge" },
                            this.props.customerPolicy.term,
                            " years")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Monthly payment"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "xlarge" },
                            __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].formatCurrency(this.props.customerPolicy.rate, 2),
                            "/month"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { className: "text-primary font-weight-bold" }, "First two months free"))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__BillingForm__["a" /* default */], { actions: this.props.actions, paymentDetails: this.props.paymentDetails, user: this.props.user, customerPolicy: this.props.customerPolicy, onUserChange: this.props.onUserChange, onPolicyChange: this.onPolicyChange, onStripeElementChange: this.onStripeElementChange, onPhoneKeyUp: this.onPhoneKeyUp, errors: this.errors, isCustomer: this.isCustomer(this.props.currentUser.role) }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "small my-0" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null, "By clicking Enroll below, you agree that all statements you have made throughout this application are true."))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons_Button__["a" /* default */], { onClick: this.back, className: "btn-outline-primary workflow-progress-action" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_icons__["s" /* IconChevronLeft */], null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2 d-none d-sm-inline-block" }, "Back")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons_Button__["a" /* default */], { onClick: this.enroll, disabled: this.isNextDisabled(), className: "btn-primary workflow-progress-action" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Enroll"),
                    !this.state.isLoading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_icons__["p" /* IconCheck */], null),
                    this.state.isLoading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_common__["f" /* Spinner */], null)))));
    };
    return BillingPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (BillingPage);


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var stripeFieldStyles = {
    base: {
        color: '#333',
        fontFamily: '"Nunito Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: '16px',
        lineHeight: '1.5',
        '::placeholder': {
            color: 'rgba(51, 51, 51, 0.25)'
        }
    },
    invalid: {
        color: '#dc3545'
    }
};
var InjectedPaymentDetailsForm = /** @class */ (function (_super) {
    __extends(InjectedPaymentDetailsForm, _super);
    function InjectedPaymentDetailsForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onPaymentDetailsChange = function (e) {
            var details = __assign({}, _this.props.details, (_a = {}, _a[e.target.name] = e.target.value, _a));
            _this.props.actions.setPaymentDetails(details);
            var _a;
        };
        return _this;
    }
    InjectedPaymentDetailsForm.prototype.componentDidMount = function () {
        this.props.actions.setStripe(this.props.stripe);
    };
    InjectedPaymentDetailsForm.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("fieldset", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group col-sm-8" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["j" /* Label */], null, "Credit card number"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__["CardNumberElement"], { className: "form-control", style: stripeFieldStyles, onChange: this.props.onStripeElementChange ?
                            function (element) { return _this.props.onStripeElementChange(element, 'card_number'); } :
                            undefined })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group col-sm-4 mb-sm-2" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["j" /* Label */], null, "Expiry date"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__["CardExpiryElement"], { className: "form-control", style: stripeFieldStyles, onChange: this.props.onStripeElementChange ?
                            function (element) { return _this.props.onStripeElementChange(element, 'card_expiry'); } :
                            undefined })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group col-sm-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["j" /* Label */], null, "CVC"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__["CardCVCElement"], { className: "form-control", style: stripeFieldStyles, onChange: this.props.onStripeElementChange ?
                            function (element) { return _this.props.onStripeElementChange(element, 'card_cvv'); } :
                            undefined })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Cardholder's name", name: "ccCardholderName", onChange: this.onPaymentDetailsChange, value: this.props.details.ccCardholderName, className: "col-sm-8 mb-0" }))));
    };
    return InjectedPaymentDetailsForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_stripe_elements__["injectStripe"])(InjectedPaymentDetailsForm));


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__quoting_ValidateReferralCode__ = __webpack_require__(504);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var ReviewPage = /** @class */ (function (_super) {
    __extends(ReviewPage, _super);
    function ReviewPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.next = function () {
            _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/beneficiary");
        };
        return _this;
    }
    ReviewPage.prototype.componentWillMount = function () {
        history.pushState(null, '', location.href);
        window.onpopstate = function (e) {
            history.go(1);
        };
    };
    ReviewPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set", hidden: this.props.hidden },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms_Fieldset__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled d-lg-flex" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "mb-3 mb-lg-0 mr-lg-5 strong text-secondary" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Coverage"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "xlarge" },
                            __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatCurrency(this.props.customerPolicy.coverageAmount, 0),
                            " CAD")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "mb-3 mb-lg-0 mr-lg-5 strong text-secondary" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Term"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "xlarge" },
                            this.props.customerPolicy.term,
                            " years")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Monthly payment"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "xlarge" },
                            this.props.isLoading ? '-' : __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatCurrency(this.props.customerPolicy.rate, 2),
                            "/month"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { className: "text-primary font-weight-bold" }, "First two months free"))),
                this.props.premiumChanged &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "small mb-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null, "Your monthly premium has increased due to your answers to the questionnaire. Certain lifestyle activities carry greater risk of death, which results in a higher insurance premium.")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled mt-0" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        "Payment due: ",
                        __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatDateAsUTC(this.props.customerPolicy.effectiveDate, 'Do'),
                        " of every month"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        "Term duration:\u00A0",
                        __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatDateAsUTC(this.props.customerPolicy.effectiveDate, 'MMMM D, YYYY'),
                        " -\u00A0",
                        __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatDateAsUTC(this.props.customerPolicy.endDate, 'MMMM D, YYYY'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__quoting_ValidateReferralCode__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    "Here is a ",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "/Term Life Policy Sample.pdf", target: "_blank" }, "sample policy"),
                    ". A policy with your specific details will be provided upon payment."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, "Still thinking about it? Lock in your rate now with our money-back guarantee: if you cancel your policy within 30 days for any reason, we'll refund your payment."))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["a" /* Button */], { onClick: this.next, className: "btn-primary workflow-progress-action", disabled: this.props.isLoading },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Protect my family!"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["t" /* IconChevronRight */], null)))));
    };
    return ReviewPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ReviewPage);


/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quotingActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var ValidateReferralCode = /** @class */ (function (_super) {
    __extends(ValidateReferralCode, _super);
    function ValidateReferralCode(props) {
        var _this = _super.call(this, props) || this;
        _this.validateReferralDebounced = __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].debounce(function () {
            _this.validateReferral(_this.props.referrals.referralCode);
        });
        _this.onValidateReferral = function (e) {
            _this.props.actions.setReferralCode(e.target.value);
            _this.validateReferralDebounced();
        };
        _this.validateReferral = function (referralCode) {
            if (referralCode != null) {
                _this.props.actions.validateReferralCode(referralCode, _this.props.user.id);
            }
        };
        _this.state = {
            hasCampaignCode: false,
        };
        return _this;
    }
    ValidateReferralCode.prototype.componentDidMount = function () {
        this.validateReferral(this.props.referrals.referralCode);
        if (this.props.currentPolicy.campaignCode && this.props.currentPolicy.campaignCode.trim() !== '') {
            this.props.actions.setReferralCode(this.props.currentPolicy.campaignCode);
            this.setState({ hasCampaignCode: true });
        }
    };
    // referral code should be unavailable if customer already has active policy
    ValidateReferralCode.prototype.checkExistingPolicy = function () {
        var _this = this;
        return this.props.user.isAuthenticated ?
            this.props.policies.some(function (p) { return p.customerId === _this.props.user.userId &&
                p.isActive && p.statusId === __WEBPACK_IMPORTED_MODULE_7__common_utils__["h" /* PolicyStatus */].Active; }) : false;
    };
    ValidateReferralCode.prototype.render = function () {
        return (!this.props.user.isAuthenticated && !this.checkExistingPolicy() &&
            (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "py-3 border-top border-bottom" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg-7" }, "Do you have a referral code from a friend or your life partner? Please enter it here."),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg-5 mt-3 mt-lg-0 mb-2 position-relative" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["n" /* TextInput */], { name: "remaining", placeholder: "Enter your referral code", value: this.props.referrals.referralCode, onChange: this.onValidateReferral, className: "mb-0 enrollment-referral-field", disabled: this.state.hasCampaignCode }),
                        this.getReferralValidityMessage())))));
    };
    ValidateReferralCode.prototype.getReferralValidityMessage = function () {
        var msg;
        if (this.props.referrals.referralCode) {
            if (this.props.validReferral) {
                msg = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_icons__["p" /* IconCheck */], { className: "enrollment-referral-icon text-success" });
            }
            else {
                msg = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_icons__["z" /* IconErrorOutline */], { className: "enrollment-referral-icon text-danger" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Sorry, but the referral code you have entered is invalid")));
            }
        }
        return msg;
    };
    return ValidateReferralCode;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        validReferral: state.quoting.validReferral,
        referrals: state.user.referrals,
        user: state.user.user,
        policies: state.policy.policies,
        currentPolicy: state.policy.customerPolicy
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__quotingActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ValidateReferralCode);
/* harmony default export */ __webpack_exports__["a"] = (connector);


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__policy_policyAPI__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_toastr__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};











var OptionalBeneficiaryPage = /** @class */ (function (_super) {
    __extends(OptionalBeneficiaryPage, _super);
    function OptionalBeneficiaryPage(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = { birthDate: {}, email: {}, postalCode: {} };
        _this.saveBeneficiary = function (e) {
            var beneficiary = __assign({}, _this.props.customerPolicyBeneficiary, { customerId: _this.props.customer.id, customerPolicyId: _this.props.customerPolicy.id, disbursementPercent: 0 });
            // confusing part: the if statement here is checking the scenario that user clicks on next button accidently
            // now he/she still wants to go to disbursement page and incomplete beneficiary should not be saved
            if (!beneficiary.firstName || !beneficiary.lastName || !beneficiary.birthDate) {
                _this.props.hideSkipButton();
                return _this.props.actions.resetCustomerPolicyBeneficiary();
            }
            return _this.props.actions.saveCustomerPolicyBeneficiary(beneficiary)
                .then(function () { return _this.props.hideSkipButton(); })
                .then(function () { return _this.props.actions.resetCustomerPolicyBeneficiary(); })
                .then(function () { return __WEBPACK_IMPORTED_MODULE_10_toastr__["success"]('Beneficiary saved!'); });
        };
        _this.saveSingle = function (e) {
            _this.saveBeneficiary(e)
                .then(function () { return _this.props.actions.fetchCustomerPolicyBeneficiaries(_this.props.customer.id); })
                .then(function () {
                var filteredBeneficiaries = _this.props.pendingBeneficiaries
                    .filter(function (b) { return b.customerPolicyId === _this.props.customerPolicy.id; });
                _this.props.actions.setCustomerPolicyBeneficiaries(filteredBeneficiaries);
                if (_this.props.pendingBeneficiaries.some(function (b) { return b.isUnderage === true; })) {
                    var trustee = _this.props.pendingBeneficiaries.find(function (b) { return b.typeId === __WEBPACK_IMPORTED_MODULE_8__common_utils__["d" /* BeneficiaryTypes */].Trustee; });
                    if (trustee) {
                        _this.props.actions.setTrustee(trustee);
                    }
                    else {
                        var newTrustee = __WEBPACK_IMPORTED_MODULE_9__policy_policyAPI__["g" /* defaultTrustee */];
                        _this.props.actions.setTrustee(newTrustee);
                    }
                }
            })
                .then(function () { return _this.props.nextStep(e); });
        };
        _this.addMore = function (e) {
            _this.saveBeneficiary(e)
                .then(function () { return _this.props.actions.resetCustomerPolicyBeneficiary(); })
                .then(function () { return _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/enrollment/beneficiary"); });
        };
        _this.handleBlur = function (field) { return function (evt) {
            _this.setState({
                touched: __assign({}, _this.state.touched, (_a = {}, _a[field] = true, _a))
            });
            if (field === 'birthDate') {
                var underageChangeEvent = {
                    target: {
                        name: 'isUnderage',
                        value: __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].getAgeFromBirthdate(_this.props.customerPolicyBeneficiary.birthDate) < 18,
                        type: 'custom'
                    }
                };
                _this.onPolicyBeneficiaryChange(underageChangeEvent);
            }
            var _a;
        }; };
        _this.validate = function () {
            // true means invalid
            return {
                birthDate: __WEBPACK_IMPORTED_MODULE_8__common_utils__["k" /* Validation */].validateDate(_this.props.customerPolicyBeneficiary.birthDate),
                email: __WEBPACK_IMPORTED_MODULE_8__common_utils__["k" /* Validation */].validateEmail(_this.props.customerPolicyBeneficiary.email),
                postalCode: __WEBPACK_IMPORTED_MODULE_8__common_utils__["k" /* Validation */].validatePostalCode(_this.props.customerPolicyBeneficiary.postalCode)
            };
        };
        _this.isSubmitDisabled = function () {
            if (_this.errors.birthDate.hasError || _this.errors.email.hasError || _this.errors.postalCode.hasError) {
                return true;
            }
            var _a = _this.props.customerPolicyBeneficiary, firstName = _a.firstName, lastName = _a.lastName, birthDate = _a.birthDate;
            return !firstName || !lastName || !birthDate;
        };
        _this.hasPendingBeneficiaries = function () {
            return _this.props.pendingBeneficiaries.length > 0;
        };
        _this.onPolicyBeneficiaryChange = function (e) {
            var value = e.target.value;
            if (e.target.type === 'radio') {
                if (e.target.name === 'typeId') {
                    if (value === 'true') {
                        value = __WEBPACK_IMPORTED_MODULE_8__common_utils__["d" /* BeneficiaryTypes */].Primary;
                    }
                    else if (value === 'false') {
                        value = __WEBPACK_IMPORTED_MODULE_8__common_utils__["d" /* BeneficiaryTypes */].Contingent;
                    }
                }
                else {
                    if (value === 'true') {
                        value = true;
                    }
                    else if (value === 'false') {
                        value = false;
                    }
                }
            }
            var customerPolicyBeneficiary = __assign({}, _this.props.customerPolicyBeneficiary, (_a = {}, _a[e.target.name] = value, _a));
            _this.props.actions.setCustomerPolicyBeneficiary(customerPolicyBeneficiary);
            var _a;
        };
        _this.onRelationshipChange = function (e) {
            var value = e.target.value;
            var customerPolicyBeneficiary = __assign({}, _this.props.customerPolicyBeneficiary, (_a = {}, _a[e.target.name] = value, _a));
            if (e.target.value !== 'Other') {
                customerPolicyBeneficiary.relationshipOther = '';
            }
            _this.props.actions.setCustomerPolicyBeneficiary(customerPolicyBeneficiary);
            var _a;
        };
        _this.state = {
            touched: {
                birthDate: false,
                email: false,
                postalCode: false,
            },
            relationshipOther: '',
            isLoading: false
        };
        return _this;
    }
    OptionalBeneficiaryPage.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({ isLoading: true });
        this.props.actions.fetchCustomerPolicyBeneficiaries(this.props.customer.id)
            .then(function () { return _this.setState({ isLoading: false }); });
    };
    OptionalBeneficiaryPage.prototype.render = function () {
        this.errors = this.validate();
        var customer = __assign({}, this.props.customer);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set", hidden: this.props.hidden },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms_Fieldset__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Beneficiary info"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", { className: "form-fieldset-title" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, "What is a beneficiary ?")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "A beneficiary is the person or people that you determine should receive your life insurance payout if you die while the policy is in effect."),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "The section below allows you to designate one or more people as beneficiaries of your policy. By completing it, you\u2019re telling us that any proceeds should go directly to them.  Note that if you name multiple beneficiaries, you\u2019ll have to decide up front what portion of the proceeds should go to each person."),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We recommend that you complete this step.  If you decide to skip it, your beneficiary will be your estate."),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "You can always update your beneficiary designation in the future if things change.")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["n" /* TextInput */], { id: "beneficiaryFirstName", labelText: "First Name", name: "firstName", onChange: this.onPolicyBeneficiaryChange, value: this.props.customerPolicyBeneficiary.firstName, className: "col-md-6", required: true }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["n" /* TextInput */], { id: "beneficiaryLastName", labelText: "Last Name", name: "lastName", onChange: this.onPolicyBeneficiaryChange, value: this.props.customerPolicyBeneficiary.lastName, className: "col-md-6", required: true }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-daypicker col-md-12" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["a" /* BirthDatePicker */], { id: "beneficiaryDOB", labelText: "Birthdate", name: "birthDate", value: this.props.customerPolicyBeneficiary.birthDate, onBlur: this.handleBlur('birthDate'), onChange: this.onPolicyBeneficiaryChange, error: __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].shouldMarkError(this.errors.birthDate, this.state.touched.birthDate) ? this.errors.birthDate : undefined, required: true })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["g" /* DropdownInput */], { labelText: "Relationship", id: "relationship", name: "relationship", value: this.props.customerPolicyBeneficiary.relationship, defaultOption: "-", onChange: this.onRelationshipChange, options: [
                                {
                                    text: 'Spouse',
                                    value: 'Spouse'
                                },
                                {
                                    text: 'Child',
                                    value: 'Child'
                                },
                                {
                                    text: 'Grandchild',
                                    value: 'Grandchild'
                                },
                                {
                                    text: 'Parent',
                                    value: 'Parent'
                                },
                                {
                                    text: 'Sibling',
                                    value: 'Sibling'
                                },
                                {
                                    text: 'Other - specify',
                                    value: 'Other'
                                }
                            ], className: "col-md-6" }),
                        this.props.customerPolicyBeneficiary.relationship === 'Other' &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["n" /* TextInput */], { id: "relationshipOther", labelText: " ", name: "relationshipOther", onChange: this.onPolicyBeneficiaryChange, value: this.props.customerPolicyBeneficiary.relationshipOther, maxLength: 20, className: "col-md-6" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["n" /* TextInput */], { id: "beneficiaryEmail", labelText: "Beneficiary Email", name: "email", onBlur: this.handleBlur('email'), onChange: this.onPolicyBeneficiaryChange, value: this.props.customerPolicyBeneficiary.email, error: __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].shouldMarkError(this.errors.email, this.state.touched.email) ? this.errors.email : undefined, className: "col-md-12" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-auto form-group" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-1" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["j" /* Label */], { className: "mr-2 mb-0 strong" }, "Send Email Notification"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["i" /* TooltipModal */], { toggle: "What does this mean?", toggleClassName: "em btn-link-inline" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, "This is a sample of the email notification that will be sent to the beneficiary:"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                        "This email is to notify you that ",
                                        customer.firstName,
                                        " ",
                                        customer.lastName,
                                        " has purchased a life insurance policy and designated you as a beneficiary. ",
                                        customer.firstName,
                                        " requested that we notify you about the policy in the unfortunate event a claim needs to be submitted."),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                        "For your future reference, the policy number is ",
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, "xx-xxxxx"),
                                        ". We are not able to share any additional details regarding the policy."),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                        "To submit a claim, please visit ",
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "www.insuredbymosaic.ca/claims" }, "www.insuredbymosaic.ca/claims"),
                                        " or call us at ",
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, "1-855-643-6945"),
                                        "."),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Please note that beneficiary designations may change over time and we will not notify you if you have been removed as a beneficiary of the policy."),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Thanks,"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "The Mosaic Life Team"))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["o" /* ToggleSwitch */]
                            // labelText="Send notification"
                            , { 
                                // labelText="Send notification"
                                name: "shouldSendNotification", onChildren: "Yes", offChildren: "No", onChange: this.onPolicyBeneficiaryChange, checked: this.props.customerPolicyBeneficiary.shouldSendNotification, className: "mr-2 mb-0 toggle-button-wrap", disabled: __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].isEmpty(this.props.customerPolicyBeneficiary.email) })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-auto form-group" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-1" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["j" /* Label */], { className: "mr-2 mb-0 strong" }, "Revocability"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["i" /* TooltipModal */], { toggle: "What does this mean?", toggleClassName: "em btn-link-inline" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "If you designate a beneficiary as irrevocable, you cannot change (\"revoke\") the claim benefits of that beneficiary without their signature. If the irrevocable beneficiary is a minor, you cannot  change or revoke the beneficiary until minor reaches the age of majority."),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Note: In Quebec, the designation of a spouse is irrevocable unless you check the revocable box next to their name."))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["o" /* ToggleSwitch */], { name: "isRevocable", onChildren: "Revocable", offChildren: "Irrevocable", onChange: this.onPolicyBeneficiaryChange, checked: this.props.customerPolicyBeneficiary.isRevocable, className: "mr-2 mb-0 toggle-buttons-wrap" })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-auto form-group" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-1" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["j" /* Label */], { className: "mr-2 mb-0 strong" }, "Primary/Contingent"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["i" /* TooltipModal */], { toggle: "What does this mean?", toggleClassName: "em btn-link-inline" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "The primary beneficiary receives the benefits payable when the insured dies. If more than one primary beneficiary is appointed, proceeds will be payable as per the percentages you indicated. Note that the sum of percentages assigned to each beneficiary must total to 100%."),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "If multiple primary beneficiaries are designated, but no percentage allocation has been indicated, benefits will be paid out in equal shares. If no beneficiaries have been indicated, benefits from the insurance policy will be paid to the insured's estate."),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "In the event that all primary beneficiaries die before the insured, the contingent beneficiaries will receive the benefits payable when the insured dies."))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["o" /* ToggleSwitch */], { name: "typeId", onChildren: "Primary", offChildren: "Contingent", onChange: this.onPolicyBeneficiaryChange, checked: this.props.customerPolicyBeneficiary.typeId === __WEBPACK_IMPORTED_MODULE_8__common_utils__["d" /* BeneficiaryTypes */].Primary, className: "mr-2 mb-0 toggle-buttons-wrap" })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { className: "btn-primary mt-3 mr-3", onClick: this.addMore, disabled: this.isSubmitDisabled() },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Add Beneficiary")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { className: "btn-primary mt-3 mr-3", onClick: this.saveSingle, disabled: this.isSubmitDisabled() && !this.hasPendingBeneficiaries() },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Next"))))));
    };
    return OptionalBeneficiaryPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    var pendingBeneficiaries = state.policy.beneficiaries.pending
        .filter(function (bene) { return bene.customerPolicyId === state.policy.customerPolicy.id; })
        .sort(__WEBPACK_IMPORTED_MODULE_8__common_utils__["j" /* UtilsBeneficiaries */].sortPrimaryThenByName);
    return {
        customerPolicyBeneficiary: state.policy.customerPolicyBeneficiary,
        pendingBeneficiaries: pendingBeneficiaries
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_6__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(OptionalBeneficiaryPage));


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OptionalBeneficiaryDisbursementRow__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_toastr__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};











var OptionalBeneficiaryDisbursementPage = /** @class */ (function (_super) {
    __extends(OptionalBeneficiaryDisbursementPage, _super);
    function OptionalBeneficiaryDisbursementPage(props) {
        var _this = _super.call(this, props) || this;
        _this.onBeneficiaryDelete = function (beneficiary) {
            _this.setState({ isLoading: true });
            _this.props.actions.deleteBeneficiaryDuringSignUp(beneficiary.id)
                .then(function () { return _this.props.actions.fetchCustomerPolicyBeneficiaries(_this.props.customer.id); })
                .then(function () { return _this.setState({ isLoading: false }); });
        };
        _this.isUpdateDisabled = function () {
            return !__WEBPACK_IMPORTED_MODULE_5__common_utils__["j" /* UtilsBeneficiaries */].isDisbursementValid(_this.props.beneficiaries) ||
                _this.validateTrustee();
        };
        _this.updateDisbursement = function (e) {
            var beneficiaries = _this.props.beneficiaries.filter(function (b) { return b.typeId !== __WEBPACK_IMPORTED_MODULE_5__common_utils__["d" /* BeneficiaryTypes */].Trustee; });
            __WEBPACK_IMPORTED_MODULE_5__common_utils__["m" /* default */].forEachPromise(beneficiaries, _this.props.actions.saveCustomerPolicyBeneficiary)
                .then(function () {
                if (_this.props.beneficiaries.find(function (b) { return b.isUnderage === true; })) {
                    _this.saveTrustee();
                }
                __WEBPACK_IMPORTED_MODULE_10_toastr__["success"]('Beneficiary disbursement updated!');
            })
                .then(function () { return _this.props.actions.resetCustomerPolicyBeneficiary(); })
                .then(function () { return _this.props.nextStep(e); });
        };
        _this.onTrusteeChange = function (e) {
            var trustee = __assign({}, _this.props.trustee, (_a = {}, _a[e.target.name] = e.target.value, _a));
            _this.props.actions.setTrustee(trustee);
            var _a;
        };
        _this.saveTrustee = function () {
            var trustee = __assign({}, _this.props.trustee);
            trustee.customerId = _this.props.customer.id;
            trustee.customerPolicyId = _this.props.customerPolicy.id;
            _this.props.actions.saveCustomerPolicyBeneficiary(trustee);
        };
        // true means update button should be disabled
        _this.validateTrustee = function () {
            var result = false;
            if (!_this.props.beneficiaries.some(function (b) { return b.isUnderage === true; })) {
                return result;
            }
            else {
                if (!_this.props.trustee.firstName ||
                    !_this.props.trustee.lastName ||
                    !_this.props.trustee.email ||
                    _this.props.trustee.firstName.trim() === '' ||
                    _this.props.trustee.lastName.trim() === '' ||
                    _this.props.trustee.email.trim() === '') {
                    result = true;
                }
            }
            return result;
        };
        _this.state = {
            isLoading: false
        };
        return _this;
    }
    OptionalBeneficiaryDisbursementPage.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({
            isLoading: true
        });
        this.props.actions.fetchCustomerPolicyBeneficiaries(this.props.customer.id)
            .then(function () { return _this.setState({ isLoading: false }); });
    };
    OptionalBeneficiaryDisbursementPage.prototype.render = function () {
        var primaryBeneficiaries = this.props.beneficiaries.filter(function (b) { return b.typeId === __WEBPACK_IMPORTED_MODULE_5__common_utils__["d" /* BeneficiaryTypes */].Primary; });
        var contingentBeneficiaries = this.props.beneficiaries.filter(function (b) { return b.typeId === __WEBPACK_IMPORTED_MODULE_5__common_utils__["d" /* BeneficiaryTypes */].Contingent; });
        var _a = this.props, customerPolicy = _a.customerPolicy, beneficiaries = _a.beneficiaries, history = _a.history, match = _a.match, actions = _a.actions;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set", hidden: this.props.hidden },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms_Fieldset__["a" /* default */], null,
                primaryBeneficiaries.length > 0 &&
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__OptionalBeneficiaryDisbursementRow__["a" /* default */], { customerPolicy: customerPolicy, beneficiaries: beneficiaries, typedBeneficiaries: primaryBeneficiaries, onBeneficiaryDelete: this.onBeneficiaryDelete, goToExistingBeneficiary: this.props.goToExistingBeneficiary, history: history, match: match, actions: actions, className: "p-0 border-0" })),
                contingentBeneficiaries.length > 0 &&
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__OptionalBeneficiaryDisbursementRow__["a" /* default */], { customerPolicy: customerPolicy, beneficiaries: beneficiaries, typedBeneficiaries: contingentBeneficiaries, onBeneficiaryDelete: this.onBeneficiaryDelete, goToExistingBeneficiary: this.props.goToExistingBeneficiary, history: history, match: match, actions: actions, className: "p-0 border-0" })),
                this.props.beneficiaries.find(function (b) { return b.isUnderage === true; }) &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset content-set p-0 border-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customer-dashboard-plan-info" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "d-inline large" }, "Trustee")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-12 mb-0" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "mr-1" }, "Because one or more of your beneficiaries is underage, you must declare a trustee as part of your beneficiary designation."),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["i" /* TooltipModal */], { toggle: "Click here for more information.", toggleClassName: "btn-link-inline" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "This section only needs to be completed if you have appointed a minor as one of your beneficiaries. In the case you have a minor as a beneficiary, death benefits will not be paid directly to them, but instead to a trustee."),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "By completing this section you are appointing and authorizing the named person to act as a trustee for the beneficiaries and to receive any benefit payable to a beneficiary while the beneficiary is under the age of majority. These proceeds are to be used solely for the support, maintenance, education and benefit of such beneficiary at the discretion of the trustee."),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Note: In Quebec, death benefits due to a beneficiary, while a minor, will be paid to their parent(s) or legal guardian unless you have established a formal trust.")))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_forms__["n" /* TextInput */], { id: "trusteeFirstName", labelText: "First Name", name: "firstName", value: this.props.trustee.firstName, onChange: this.onTrusteeChange, className: "col-md-6", required: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_forms__["n" /* TextInput */], { id: "trusteeLastName", labelText: "Last Name", name: "lastName", value: this.props.trustee.lastName, onChange: this.onTrusteeChange, className: "col-md-6", required: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_forms__["n" /* TextInput */], { id: "trusteeEmail", labelText: "E-mail Address", name: "email", value: this.props.trustee.email, onChange: this.onTrusteeChange, className: "col-md-6", required: true }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_buttons__["a" /* Button */], { className: "btn-primary", disabled: this.isUpdateDisabled(), onClick: this.updateDisbursement }, "Save disbursement"))));
    };
    return OptionalBeneficiaryDisbursementPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    var pendingBeneficiaries = state.policy.beneficiaries.pending
        .filter(function (bene) { return bene.customerPolicyId === state.policy.customerPolicy.id; })
        .sort(__WEBPACK_IMPORTED_MODULE_5__common_utils__["j" /* UtilsBeneficiaries */].sortPrimaryThenByName);
    return {
        beneficiaries: pendingBeneficiaries,
        trustee: state.policy.trustee
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(OptionalBeneficiaryDisbursementPage));


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rheostat__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rheostat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rheostat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rheostat_css_slider_css__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rheostat_css_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rheostat_css_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rheostat_css_slider_horizontal_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rheostat_css_slider_horizontal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rheostat_css_slider_horizontal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__policy_policyActions__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var classNames = __webpack_require__(8);








var RheostatPit = function (_a) {
    var style = _a.style, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "rheostat-pit", style: style }, children));
};
var OptionalBeneficiariesDisbursementRow = /** @class */ (function (_super) {
    __extends(OptionalBeneficiariesDisbursementRow, _super);
    function OptionalBeneficiariesDisbursementRow(props) {
        var _this = _super.call(this, props) || this;
        _this.onDisbursementChange = function (e, beneficiary) {
            if (e.target.value > 100) {
                return;
            }
            var value = Math.min(100, e.target.value);
            var valuePct = value / 100;
            var newBeneficiary = __assign({}, beneficiary, (_a = {}, _a[e.target.name] = valuePct, _a));
            _this.props.actions.setCustomerPolicyBeneficiary(newBeneficiary);
            var _a;
        };
        _this.onValuesUpdated = function (publicState, beneficiary) {
            // Rheostat uses a values list to support multiple handles. Since we only have one handle, take the first index.
            var valuePct = publicState.values[0] / 100;
            var newBeneficiary = __assign({}, beneficiary, { disbursementPercent: valuePct });
            _this.props.actions.setCustomerPolicyBeneficiary(newBeneficiary);
        };
        _this.disburseEqually = function () {
            var numBeneficiaries = _this.props.typedBeneficiaries.length;
            var typeIndetifier = _this.props.typedBeneficiaries[0].typeId;
            var beneficiaries = _this.props.beneficiaries.map(function (beneficiary) {
                return beneficiary.typeId === typeIndetifier ? __assign({}, beneficiary, { disbursementPercent: 1 / numBeneficiaries }) : __assign({}, beneficiary);
            });
            _this.props.actions.setCustomerPolicyBeneficiaries(beneficiaries);
        };
        _this.getTotal = function () {
            var total = _this.props.typedBeneficiaries.reduce(function (a, b) { return a + parseFloat(b.disbursementPercent || 0); }, 0);
            return total;
        };
        return _this;
    }
    OptionalBeneficiariesDisbursementRow.prototype.render = function () {
        var _this = this;
        var title = __WEBPACK_IMPORTED_MODULE_9__common_utils__["m" /* default */].getPickListItemDescription(this.props.typedBeneficiaries[0].typeId);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-fieldset content-set', this.props.className) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customer-dashboard-plan-info" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "d-inline large" }, title),
                this.props.typedBeneficiaries.length > 0 && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-inline text-right" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_buttons__["a" /* Button */], { className: "btn-outline-secondary btn-sm", onClick: this.disburseEqually }, "Disburse equally")))),
            this.props.typedBeneficiaries.length > 0 ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "beneficiaries-disbursement" },
                this.props.typedBeneficiaries.map(function (beneficiary) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "beneficiary-disbursement-item", key: beneficiary.id },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-3 col-lg-2 mb-4 mb-md-0" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "beneficiary-name" }, beneficiary.name)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md mb-4 mb-md-0" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rheostat___default.a, { onValuesUpdated: function (publicState) { return _this.onValuesUpdated(publicState, beneficiary); }, orientation: "horizontal", pitComponent: RheostatPit, pitPoints: [25, 50, 75], snap: true, values: [(beneficiary.disbursementPercent || 0) * 100] })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-auto" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_forms__["n" /* TextInput */], { name: "disbursementPercent", id: "disbursement-" + beneficiary.id, value: Math.trunc((beneficiary.disbursementPercent || 0) * 100), onChange: function (e) { return _this.onDisbursementChange(e, beneficiary); }, addOnAfter: "%", className: "mb-0" })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_buttons__["b" /* IconButton */], { onClick: function () {
                                _this.props.actions.setCustomerPolicyBeneficiary(beneficiary);
                                _this.props.goToExistingBeneficiary();
                            }, title: "Edit beneficiary", className: "btn-icon-secondary btn-icon-td" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_icons__["x" /* IconEdit */], null)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_buttons__["b" /* IconButton */], { onClick: function () { return _this.props.onBeneficiaryDelete(beneficiary); }, title: "Delete beneficiary", className: "btn-icon-secondary btn-icon-td" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_icons__["v" /* IconDelete */], null))))); }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row mt-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-10 text-md-right" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "large" }, "Total (must be 100%):")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-2" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "large" },
                            Math.round(this.getTotal() * 100),
                            "%"))))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { className: "reduced-em" }, "No beneficiaries"))));
    };
    return OptionalBeneficiariesDisbursementRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state, props) {
    return {
        customerPolicy: state.policy.customerPolicy,
        beneficiaries: state.policy.beneficiaries.pending,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_10__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(OptionalBeneficiariesDisbursementRow));


/***/ }),
/* 508 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var KEYS = exports.KEYS = {
  DOWN: 40,
  END: 35,
  ESC: 27,
  HOME: 36,
  LEFT: 37,
  PAGE_DOWN: 34,
  PAGE_UP: 33,
  RIGHT: 39,
  UP: 38
};
var PERCENT_EMPTY = exports.PERCENT_EMPTY = 0;
var PERCENT_FULL = exports.PERCENT_FULL = 100;

/***/ }),
/* 509 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  getPosition: function () {
    function getPosition(value, min, max) {
      return (value - min) / (max - min) * 100;
    }

    return getPosition;
  }(),
  getValue: function () {
    function getValue(pos, min, max) {
      var decimal = pos / 100;

      if (pos === 0) {
        return min;
      } else if (pos === 100) {
        return max;
      }

      return Math.round((max - min) * decimal + min);
    }

    return getValue;
  }()
};

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_authActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};










var SignUpPage = /** @class */ (function (_super) {
    __extends(SignUpPage, _super);
    function SignUpPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.signUp = function () {
            _this.props.actions.signUp();
        };
        _this.renderSignUp = function () {
            var customerPolicy = _this.props.customerPolicy;
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__WorkflowStep__["a" /* default */], { title: "Congratulations! You just purchased life insurance!" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_forms_Fieldset__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                            "Your\u00A0",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "strong text-secondary" }, __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].formatCurrency(customerPolicy.coverageAmount, 0)),
                            " policy begins on\u00A0",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "strong text-secondary" }, __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].formatDateAsUTC(customerPolicy.effectiveDate, 'MMMM D, YYYY')),
                            " and will be in place for\u00A0",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "strong text-secondary" }, customerPolicy.term),
                            " years."),
                        customerPolicy.freeMonthTrial === 0 ?
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                "Your first monthly payment of\u00A0",
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "strong text-secondary" }, __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].formatCurrency(customerPolicy.rate, 2)),
                                " has been sucessfully processed.") :
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                "The first ",
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "strong text-secondary" }, customerPolicy.freeMonthTrial),
                                " ",
                                customerPolicy.freeMonthTrial > 1 ? 'months' : 'month',
                                " of your policy will be ",
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "strong text-secondary" }, "free"),
                                " and your first monthly payment of\u00A0",
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "strong text-secondary" }, __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].formatCurrency(customerPolicy.rate, 2)),
                                " will be processed on ",
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "strong text-secondary" }, __WEBPACK_IMPORTED_MODULE_9_moment__(customerPolicy.effectiveDate).add(customerPolicy.freeMonthTrial, 'M').utc().format('MMMM D, YYYY')),
                                "."),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Please check your e-mail for a link to your Mosaic Life online account, where you can review your coverages. Also, don't forget to set up your beneficiaries if you skipped it in previous section.")))));
        };
        _this.renderRedirect = function () {
            // make sure reset questionnaire before redirect, to ensure user won't be able to go back to existing policy
            _this.props.actions.resetQuestionnaire();
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["d" /* Redirect */], { to: "/user/dashboard" }));
        };
        return _this;
    }
    SignUpPage.prototype.componentDidMount = function () {
        this.props.actions.fetchCustomerPolicyFreeTrialMonths(this.props.user.id, this.props.customerPolicy.id);
    };
    SignUpPage.prototype.componentWillUnmount = function () {
        this.props.actions.resetCustomerPolicy();
    };
    SignUpPage.prototype.render = function () {
        var display = this.props.currentUser.isAuthenticated ? this.renderRedirect() : this.renderSignUp();
        return display;
    };
    return SignUpPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        currentUser: state.auth.currentUser,
        user: state.user.user
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__auth_authActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(SignUpPage));


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sections__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AdvisoryAboutYouPage__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdvisoryQuestionnairePage__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdvisorySelectYourPlanPage__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WorkflowProgress__ = __webpack_require__(45);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var AdvisoryWorkflow = function (props) {
    var Page = null;
    var activeStep = 0;
    if (props.match.params.page === 'about-you') {
        Page = __WEBPACK_IMPORTED_MODULE_3__AdvisoryAboutYouPage__["a" /* default */];
        activeStep = 0;
    }
    else if (props.match.params.page === 'your-needs') {
        Page = __WEBPACK_IMPORTED_MODULE_4__AdvisoryQuestionnairePage__["a" /* default */];
        activeStep = 1;
    }
    else if (props.match.params.page === 'select-your-policy') {
        Page = __WEBPACK_IMPORTED_MODULE_5__AdvisorySelectYourPlanPage__["a" /* default */];
        activeStep = 2;
    }
    else if (props.match.params.page === 'enrollment') {
        Page = __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */];
        if (props.match.params.enrollmentPage === 'billing'
            || props.match.params.enrollmentPage === 'review'
            || props.match.params.enrollmentPage === 'beneficiary'
            || props.match.params.enrollmentPage === 'sign-up') {
            activeStep = 4;
        }
        else {
            activeStep = 3;
        }
    }
    else if (props.match.params.page == null) {
        if (props.customerDetails.age != null
            && props.user.gender != null
            && props.customerDetails.isSmoker != null) {
            props.history.replace("/quote/" + props.match.params.workflow + "/your-needs");
        }
        else {
            props.history.replace("/quote/" + props.match.params.workflow + "/about-you");
        }
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["c" /* PageContent */], { wrapperClassName: "mt-6", sectionClassName: "pt-0" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_sections__["b" /* SectionMain */], { sectionClassName: "section-sm section-extend-up bg-secondary text-light workflow-progress-wrapper", wrapperClassName: "mb-4 mb-md-5 px-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__WorkflowProgress__["a" /* default */], { buttonClassName: "btn-outline-light", steps: [
                        {
                            label: 'About you',
                            to: "/quote/" + props.match.params.workflow + "/about-you",
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 4
                        },
                        {
                            label: 'Your needs',
                            to: "/quote/" + props.match.params.workflow + "/your-needs",
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 4
                        },
                        {
                            label: 'Select your policy',
                            to: "/quote/" + props.match.params.workflow + "/select-your-policy",
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 4
                        },
                        {
                            label: 'Apply for coverage',
                            onClick: function () { return props.saveAndRedirect("/quote/" + props.match.params.workflow + "/enrollment/my-pledge"); },
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 4
                        },
                        {
                            label: 'Review and billing',
                            onClick: function () { return props.saveAndRedirect("/quote/" + props.match.params.workflow + "/enrollment/review"); },
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 4
                        }
                    ], activeStep: activeStep })),
            Page !== null && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Page, __assign({}, props)))));
};
/* harmony default export */ __webpack_exports__["a"] = (AdvisoryWorkflow);


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AboutYou__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var AdvisoryAboutYouPage = /** @class */ (function (_super) {
    __extends(AdvisoryAboutYouPage, _super);
    function AdvisoryAboutYouPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errors = { age: {} };
        _this.validate = function () {
            // true means invalid
            return {
                age: __WEBPACK_IMPORTED_MODULE_6__common_utils__["k" /* Validation */].validateAge(_this.props.user.birthDate, _this.props.currentUser.isAuthenticated)
            };
        };
        _this.isNextDisabled = function () {
            if (_this.props.customerDetails.age == null
                || _this.props.user.gender == null
                || _this.props.customerDetails.isSmoker == null) {
                return true;
            }
            return _this.errors.age.hasError;
        };
        _this.next = function () {
            _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/your-needs");
        };
        return _this;
    }
    AdvisoryAboutYouPage.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__WorkflowStep__["a" /* default */], { title: "Before we begin, we'd like to get to know you better." },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms_Fieldset__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__AboutYou__["a" /* default */], __assign({}, this.props, { errors: this.errors }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons_Button__["a" /* default */], { onClick: this.next, className: "btn-primary workflow-progress-action", disabled: this.isNextDisabled() },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "algn-middle mx-2" }, "Questionnaire"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["t" /* IconChevronRight */], null)))));
    };
    return AdvisoryAboutYouPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AdvisoryAboutYouPage);


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__quotingAPI__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Questionnaire__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_Fieldset__ = __webpack_require__(20);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var AdvisoryQuestionnairePage = /** @class */ (function (_super) {
    __extends(AdvisoryQuestionnairePage, _super);
    function AdvisoryQuestionnairePage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onAssessmentChange = function (e) {
            var value = e.target.value;
            if (e.target.type === 'radio') {
                if (value === 'true') {
                    value = true;
                }
                else if (value === 'false') {
                    value = false;
                }
            }
            else if (e.target.type === 'checkbox') {
                value = e.target.checked;
            }
            var assessment = __assign({}, _this.props.assessment, (_a = {}, _a[e.target.name] = value, _a));
            _this.props.actions.setQuotingAssessment(assessment);
            var _a;
        };
        _this.onAssessmentChildrenChange = function (e) {
            var value = e.target.value.replace(/[^\d]/g, '');
            var numChildren = parseInt(value, 10) || 0;
            if (numChildren < 0 || numChildren > 100) {
                return;
            }
            var defaultChild = __assign({}, __WEBPACK_IMPORTED_MODULE_1__quotingAPI__["c" /* defaultCustomerFamily */]);
            var childrenAge = Array(numChildren).fill(null);
            var assessment = __assign({}, _this.props.assessment, (_a = {}, _a[e.target.name] = value, _a.childrenAge = childrenAge, _a));
            _this.props.actions.setQuotingAssessment(assessment);
            var customerFamilyList = Array(numChildren).fill(defaultChild);
            _this.props.actions.setCustomerFamilyList(customerFamilyList);
            var _a;
        };
        _this.onAssessmentChildChange = function (e, index) {
            var childAge = e.target.value.replace(/[^\d]/g, '');
            var childAgeInt = parseInt(childAge, 10) || 0;
            if (childAgeInt < 0) {
                return;
            }
            var childrenAge = _this.props.assessment.childrenAge.slice();
            childrenAge[index] = childAge;
            var assessment = __assign({}, _this.props.assessment, { childrenAge: childrenAge });
            _this.props.actions.setQuotingAssessment(assessment);
            var customerFamilyList = _this.props.customerFamilyList.map(function (family, i) {
                return __assign({}, family, { age: childrenAge[i] });
            });
            _this.props.actions.setCustomerFamilyList(customerFamilyList);
        };
        _this.back = function () {
            _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/about-you");
        };
        _this.isNextDisabled = function () {
            if (!_this.props.assessment.numChildren
                || !_this.props.customerDetails.mortgage
                || !_this.props.customerDetails.otherDebt
                || !_this.props.customerDetails.beneficiaryAmountPerYear
                || !_this.props.customerDetails.beneficiaryAmountTotalYears
                || !_this.props.customerDetails.savingsAmount
                || !_this.props.customerDetails.existingLifeInsurance) {
                return true;
            }
            return false;
        };
        _this.next = function () {
            _this.props.history.push("/quote/B/select-your-policy");
        };
        return _this;
    }
    AdvisoryQuestionnairePage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__WorkflowStep__["a" /* default */], { title: "Let\u2019s determine how much coverage you need." },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-5 text-center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mx-auto max-read-width" }, "Already know how much coverage you need?"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons_Button__["a" /* default */], { to: "/quote/Custom/select-your-policy", className: "btn-primary workflow-progress-action col-4" }, "Skip"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_forms_Fieldset__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Questionnaire__["a" /* default */], { assessment: this.props.assessment, customerDetails: this.props.customerDetails, onAssessmentChange: this.onAssessmentChange, onAssessmentChildrenChange: this.onAssessmentChildrenChange, onAssessmentChildChange: this.onAssessmentChildChange, onCustomerDetailsChange: this.props.onCustomerDetailsChange, onCustomerDetailsNumberKeyUp: this.props.onCustomerDetailsNumberKeyUp })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons_Button__["a" /* default */], { onClick: this.back, className: "btn-outline-primary workflow-progress-action" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_icons__["s" /* IconChevronLeft */], null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2 d-none d-sm-inline-block" }, "Back")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons_Button__["a" /* default */], { onClick: this.next, className: "btn-primary workflow-progress-action", disabled: this.isNextDisabled() },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Calculate my need"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_icons__["t" /* IconChevronRight */], null)))));
    };
    return AdvisoryQuestionnairePage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AdvisoryQuestionnairePage);


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);


var Questionnaire = function (props) {
    var childText = props.assessment.numChildren === '1' ? 'child' : 'children';
    var childIs = props.assessment.numChildren === '1' ? 'is' : 'are';
    var eachChildText = props.assessment.numChildren === '1' ? 'my' : 'each';
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("fieldset", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "I have"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { type: "number", name: "numChildren", className: "form-group-number-2", min: 0, onChange: props.onAssessmentChildrenChange, value: props.assessment.numChildren }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" },
                    childText,
                    " under 18."),
                props.assessment.numChildren > 0 && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" },
                    "My ",
                    childText,
                    " ",
                    childIs),
                props.assessment.childrenAge.map(function (childAge, index) {
                    return [
                        index > 0 &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: index + 'a', className: "form-group form-inline-text" }, index === props.assessment.childrenAge.length - 1 ?
                                props.assessment.childrenAge.length === 2 ? 'and' : ', and'
                                : ','),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { key: index + 'b', type: "number", id: "childAge" + index, name: "childAge" + index, className: "form-group-number-2", min: 0, onChange: function (e) { return props.onAssessmentChildChange(e, index); }, value: childAge })
                    ];
                }),
                props.assessment.numChildren > 0 && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "years old."))),
        props.assessment.numChildren > 0 &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "I plan to pay"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { name: "educationAmount", className: "mr-0 form-group-number-10", addOnBefore: "$", onChange: props.onCustomerDetailsChange, onKeyUp: props.onCustomerDetailsNumberKeyUp, value: props.customerDetails.educationAmount }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" },
                        "for ",
                        eachChildText,
                        " child's education."))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "My mortgage balance is around"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { name: "mortgage", className: "form-group-number-10", addOnBefore: "$", onChange: props.onCustomerDetailsChange, onKeyUp: props.onCustomerDetailsNumberKeyUp, value: props.customerDetails.mortgage }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group  form-inline-text" }, "and"))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "I have other debts of"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { name: "otherDebt", className: "mr-0 form-group-number-10", addOnBefore: "$", onChange: props.onCustomerDetailsChange, onKeyUp: props.onCustomerDetailsNumberKeyUp, value: props.customerDetails.otherDebt }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "."))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "If I die I want my beneficiaries to share"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { name: "beneficiaryAmountPerYear", addOnBefore: "$", className: "form-group-number-10", onChange: props.onCustomerDetailsChange, onKeyUp: props.onCustomerDetailsNumberKeyUp, value: props.customerDetails.beneficiaryAmountPerYear }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "per year for"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { name: "beneficiaryAmountTotalYears", className: "form-group-number", pattern: "[0-9]*", onChange: props.onCustomerDetailsChange, value: props.customerDetails.beneficiaryAmountTotalYears }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "years (excluding mortgage payments and saving for education)."))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-inline" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "I have approximately"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { name: "savingsAmount", addOnBefore: "$", className: "form-group-number-10", onChange: props.onCustomerDetailsChange, onKeyUp: props.onCustomerDetailsNumberKeyUp, value: props.customerDetails.savingsAmount }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "in savings and"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { name: "existingLifeInsurance", addOnBefore: "$", className: "form-group-number-10", onChange: props.onCustomerDetailsChange, onKeyUp: props.onCustomerDetailsNumberKeyUp, value: props.customerDetails.existingLifeInsurance }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-group form-inline-text" }, "in existing life insurance.")))));
};
/* harmony default export */ __webpack_exports__["a"] = (Questionnaire);


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rheostat_css_slider_css__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rheostat_css_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rheostat_css_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rheostat_css_slider_horizontal_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rheostat_css_slider_horizontal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rheostat_css_slider_horizontal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QuotePlan__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CalculatorExplanation__ = __webpack_require__(516);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};









var AdvisorySelectYourPlanPage = /** @class */ (function (_super) {
    __extends(AdvisorySelectYourPlanPage, _super);
    function AdvisorySelectYourPlanPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            rate: 0,
            isLoading: true,
            section0: {
                expanded: false
            },
            section1: {
                expanded: false
            }
        };
        _this.COVERAGE_MAX = 1000000;
        _this.COVERAGE_MIN = 25000;
        _this.COVERAGE_DEFAULT = Math.round((_this.COVERAGE_MAX - _this.COVERAGE_MIN) / 2 + _this.COVERAGE_MIN);
        _this.TERM_MAX = 65 - (_this.props.customerDetails.age || 0);
        _this.TERM_MIN = _this.props.currentUser.isAuthenticated ? 5 : 10;
        _this.TERM_DEFAULT = Math.round((_this.TERM_MAX - _this.TERM_MIN) / 2 + _this.TERM_MIN);
        _this.onCoverageUpdate = function (slider) {
            // Rheostat uses a values list to support multiple handles. Since we only have one handle, take the first index.
            var valuePct = slider.values[0] / 100;
            var customerPolicy = __assign({}, _this.props.customerPolicy, { coverageAmount: Math.round(_this.COVERAGE_MAX * valuePct) });
            _this.props.actions.setCustomerPolicy(customerPolicy);
        };
        _this.onTermUpdate = function (slider) {
            // Rheostat uses a values list to support multiple handles. Since we only have one handle, take the first index.
            var valuePct = slider.values[0] / 100;
            var customerPolicy = __assign({}, _this.props.customerPolicy, { term: Math.round(_this.TERM_MAX * valuePct) });
            _this.props.actions.setCustomerPolicy(customerPolicy);
        };
        _this.onSliderDragEnd = function () {
            _this.setState({ isLoading: true });
            var _a = _this.props.customerPolicy, coverageAmount = _a.coverageAmount, term = _a.term;
            var _b = _this.props.user, gender = _b.gender, id = _b.id;
            var age = _this.props.customerDetails.age;
            var params = {
                coverageAmount: coverageAmount,
                term: term,
                gender: gender,
                // birthdate: birthDate,
                age: age,
                customerDemographicDetailsJson: _this.props.customerDetails,
                childrenAge: _this.props.assessment.childrenAge.map(function (a) { return !a ? 0 : a; }).join(','),
                userId: id
            };
            _this.props.actions.fetchAdvisoryPlanOptions(params)
                .then(function () { return _this.setState({ isLoading: false }); });
        };
        _this.back = function () {
            _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/your-needs");
        };
        _this.next = function () {
            var customerPolicy = __assign({}, _this.props.customerPolicy, { rate: _this.state.rate });
            _this.props.onCustomerPolicySelect(customerPolicy);
        };
        _this.toCustomPolicy = function () {
            var policy = _this.props.planOptions[0];
            _this.props.actions.setCustomerPolicy(policy);
            _this.props.history.push("/quote/Custom/select-your-policy");
        };
        _this.onSectionToggle = function (section, expanded) {
            _this.setState((_a = {},
                _a[section] = __assign({}, _this.state[section], (_b = {}, _b[expanded] = !_this.state[section][expanded], _b)),
                _a));
            var _a, _b;
        };
        return _this;
    }
    AdvisorySelectYourPlanPage.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({ isLoading: true });
        var _a = this.props.user, gender = _a.gender, id = _a.id;
        var _b = this.props.customerDetails, isSmoker = _b.isSmoker, age = _b.age;
        if (age == null || age < 18 || age > 65 || gender == null || isSmoker == null) {
            this.props.history.replace("/quote/" + this.props.match.params.workflow + "/about-you");
        }
        else {
            var params = {
                gender: gender,
                age: age,
                customerDemographicDetailsJson: this.props.customerDetails,
                childrenAge: this.props.assessment.childrenAge.map(function (a) { return !a ? 0 : a; }).join(','),
                userId: id
            };
            this.props.actions.fetchAdvisoryPlanOptions(params)
                .then(function () {
                var _a = _this.props.planOptions[0], coverageAmount = _a.coverageAmount, term = _a.term, recommendationExceedsOfferLimit = _a.recommendationExceedsOfferLimit, exceedsTwoMillions = _a.exceedsTwoMillions, millionExpression = _a.millionExpression;
                var customerPolicy = __assign({}, _this.props.customerPolicy, { coverageAmount: coverageAmount || _this.COVERAGE_DEFAULT, term: term || _this.TERM_DEFAULT, recommendationExceedsOfferLimit: recommendationExceedsOfferLimit, exceedsTwoMillions: exceedsTwoMillions, millionExpression: millionExpression });
                _this.props.actions.setCustomerPolicy(customerPolicy);
                if (recommendationExceedsOfferLimit) {
                    _this.onSectionToggle('section0', 'expanded');
                }
                _this.setState({ isLoading: false });
            });
        }
    };
    AdvisorySelectYourPlanPage.prototype.render = function () {
        var _this = this;
        var props = __rest(this.props, []);
        // make sure the customer can have a policy within min term
        if (65 - this.TERM_MIN < this.props.customerDetails.age || this.props.planOptions.length === 0) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__WorkflowStep__["a" /* default */], { title: "Sorry, we currently do not have any plans available for you." }));
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__WorkflowStep__["a" /* default */], { title: "Based on your inputs, we recommend the following policy." },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "quote-plans text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__QuotePlan__["a" /* default */], { workflow: this.props.match.params.workflow, option: props.planOptions[0], onCustomerPolicySelect: this.props.onCustomerPolicySelect, isLoading: this.state.isLoading, actionChildren: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { className: "btn-link text-primary btn-block text-wrap", onClick: this.toCustomPolicy },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null, "Customize coverage amount or term")) })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null, "Rates may change based on lifestyle")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { className: "btn-link text-primary btn-block", onClick: function () { return _this.onSectionToggle('section0', 'expanded'); } },
                                this.state.section0.expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_icons__["k" /* IconAdd */], null),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "How we calculated this"))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_forms__["i" /* FormCheckConditional */], { isOpen: this.state.section0.expanded },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__CalculatorExplanation__["a" /* default */], { recommendationExceedsOfferLimit: this.props.customerPolicy.recommendationExceedsOfferLimit, exceedsTwoMillions: this.props.customerPolicy.exceedsTwoMillions, millionExpression: this.props.customerPolicy.millionExpression })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { className: "btn-link text-primary btn-block", onClick: function () { return _this.onSectionToggle('section1', 'expanded'); } },
                                this.state.section1.expanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_icons__["k" /* IconAdd */], null),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "View Legal Disclaimers"))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_forms__["i" /* FormCheckConditional */], { isOpen: this.state.section1.expanded },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0" }, "The results you received from this calculator are for your information only and are not intended to provide a detailed analysis of your life insurance needs.  We are not responsible for any losses or damages arising from errors or omissions in the analysis or your reliance on it.")))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { onClick: this.back, className: "btn-outline-primary workflow-progress-action" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_icons__["s" /* IconChevronLeft */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2 d-none d-sm-inline-block" }, "Back")))));
        }
    };
    return AdvisorySelectYourPlanPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AdvisorySelectYourPlanPage);


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons__ = __webpack_require__(7);


var CalculatorExplanation = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-md-center" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-sm-12 col-md-4 border text-center p-3" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Insurance Need"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0" }, "Includes your mortgage and other debts, inflation-adjusted education expenses, and income replacement needs.")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-sm-12 col-md-1 text-center my-auto" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_icons__["F" /* IconRemove */], null)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-sm-12 col-md-3 border text-center p-3" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Assets"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0" }, "Your savings and existing life insurance.")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-sm-12 col-md-1 text-center my-auto" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_icons__["y" /* IconEqual */], null))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-sm-12 col-md-3 border text-center p-3" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Coverage Amount"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0" }, "The amount of coverage you should buy, up to $1 million."))),
        (props.recommendationExceedsOfferLimit) && (!props.exceedsTwoMillions ?
            (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mt-4 mb-0" },
                "Your recommended coverage amount based on your inputs is $",
                props.millionExpression,
                " million. Mosaic Life can help you get most of the way there with a $1 million dollar policy.")) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mt-4 mb-0" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null,
                "Your recommended coverage amount based on your inputs is $",
                props.millionExpression,
                " millon. Mosaic Life only offers up to $1 million of coverage per individual.  "),
            "We would love for you to apply for coverage with us, though we totally get it if you want to look elsewhere.")))));
};
/* harmony default export */ __webpack_exports__["a"] = (CalculatorExplanation);


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sections__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkflowProgress__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BespokeAboutYouPage__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BespokeSelectYourPlanPage__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__ = __webpack_require__(63);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var BespokeWorkflow = function (props) {
    var Page = null;
    var activeStep = 0;
    if (props.match.params.page === 'about-you') {
        Page = __WEBPACK_IMPORTED_MODULE_4__BespokeAboutYouPage__["a" /* default */];
        activeStep = 0;
    }
    else if (props.match.params.page === 'select-your-policy') {
        Page = __WEBPACK_IMPORTED_MODULE_5__BespokeSelectYourPlanPage__["a" /* default */];
        activeStep = 1;
    }
    else if (props.match.params.page === 'enrollment') {
        Page = __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */];
        if (props.match.params.enrollmentPage === 'billing'
            || props.match.params.enrollmentPage === 'review'
            || props.match.params.enrollmentPage === 'beneficiary'
            || props.match.params.enrollmentPage === 'sign-up') {
            activeStep = 3;
        }
        else {
            activeStep = 2;
        }
    }
    else if (props.match.params.page == null) {
        if (props.customerDetails.age != null
            && props.user.gender != null
            && props.customerDetails.isSmoker != null) {
            props.history.replace("/quote/" + props.match.params.workflow + "/select-your-policy");
        }
        else {
            props.history.replace("/quote/" + props.match.params.workflow + "/about-you");
        }
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["c" /* PageContent */], { wrapperClassName: "mt-6", sectionClassName: "pt-0" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_sections__["b" /* SectionMain */], { sectionClassName: "section-sm section-extend-up bg-secondary text-light workflow-progress-wrapper", wrapperClassName: "mb-4 mb-md-5 px-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__WorkflowProgress__["a" /* default */], { buttonClassName: "btn-outline-light", steps: [
                        {
                            label: 'About you',
                            to: "/quote/" + props.match.params.workflow + "/about-you",
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 3
                        },
                        {
                            label: 'Select your policy',
                            to: "/quote/" + props.match.params.workflow + "/select-your-policy",
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 3
                        },
                        {
                            label: 'Apply for coverage',
                            onClick: function () { return props.saveAndRedirect("/quote/" + props.match.params.workflow + "/enrollment/my-pledge"); },
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 3
                        },
                        {
                            label: 'Review and billing',
                            onClick: function () { return props.saveAndRedirect("/quote/" + props.match.params.workflow + "/enrollment/review"); },
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 3
                        }
                    ], activeStep: activeStep })),
            Page !== null && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Page, __assign({}, props)))));
};
/* harmony default export */ __webpack_exports__["a"] = (BespokeWorkflow);


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AboutYou__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var BespokeAboutYouPage = /** @class */ (function (_super) {
    __extends(BespokeAboutYouPage, _super);
    function BespokeAboutYouPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errors = { age: {} };
        _this.validate = function () {
            // true means invalid
            return {
                age: __WEBPACK_IMPORTED_MODULE_6__common_utils__["k" /* Validation */].validateAge(_this.props.user.birthDate, _this.props.currentUser.isAuthenticated)
            };
        };
        _this.isNextDisabled = function () {
            if (_this.props.customerDetails.age == null
                || _this.props.user.gender == null
                || _this.props.customerDetails.isSmoker == null) {
                return true;
            }
            return _this.errors.age.hasError;
        };
        _this.next = function () {
            _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/select-your-policy");
        };
        return _this;
    }
    BespokeAboutYouPage.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__WorkflowStep__["a" /* default */], { title: "Before we begin, we'd like to get to know you better." },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms_Fieldset__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__AboutYou__["a" /* default */], __assign({}, this.props, { errors: this.errors }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { onClick: this.next, className: "btn-primary workflow-progress-action", disabled: this.isNextDisabled() },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Select your policy"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["t" /* IconChevronRight */], null)))));
    };
    return BespokeAboutYouPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (BespokeAboutYouPage);


/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QuoteSlider__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PlanOptions__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons_Button__ = __webpack_require__(16);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var BespokeSelectYourPlanPage = /** @class */ (function (_super) {
    __extends(BespokeSelectYourPlanPage, _super);
    function BespokeSelectYourPlanPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: true
        };
        _this.COVERAGE_MAX = 1000000;
        _this.COVERAGE_MIN = 25000;
        // private COVERAGE_DEFAULT = Math.round((this.COVERAGE_MAX - this.COVERAGE_MIN) / 2 + this.COVERAGE_MIN);
        _this.COVERAGE_DEFAULT = 500000;
        _this.onSliderDragEnd = function () {
            var _a = _this.props.user, gender = _a.gender, birthDate = _a.birthDate, id = _a.id;
            var isSmoker = _this.props.customerDetails.isSmoker;
            var coverageAmount = _this.props.customerPolicy.coverageAmount;
            var params = {
                coverageAmount: coverageAmount,
                gender: gender,
                smoking: isSmoker,
                birthdate: birthDate,
                userId: id
            };
            _this.props.actions.fetchBespokePlanOptions(params);
        };
        _this.onCoverageUpdate = function (slider) {
            // Rheostat uses a values list to support multiple handles. Since we only have one handle, take the first index.
            var valuePct = slider.values[0] / 100;
            var customerPolicy = __assign({}, _this.props.customerPolicy, { coverageAmount: Math.round(_this.COVERAGE_MAX * valuePct) });
            _this.props.actions.setCustomerPolicy(customerPolicy);
        };
        _this.back = function () {
            _this.props.history.push("/quote/" + _this.props.match.params.workflow + "/about-you");
        };
        return _this;
    }
    BespokeSelectYourPlanPage.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props.user, gender = _a.gender, birthDate = _a.birthDate, id = _a.id;
        var _b = this.props.customerDetails, isSmoker = _b.isSmoker, age = _b.age;
        if (age == null || age < 18 || age > 65 || gender == null || isSmoker == null) {
            this.back();
        }
        else {
            var customerPolicy = __assign({}, this.props.customerPolicy);
            if (this.props.customerPolicy.coverageAmount == null) {
                customerPolicy.coverageAmount = this.COVERAGE_DEFAULT;
                this.props.actions.setCustomerPolicy(customerPolicy);
            }
            var params = {
                coverageAmount: customerPolicy.coverageAmount,
                gender: gender,
                smoking: isSmoker,
                birthdate: birthDate,
                userId: id
            };
            this.props.actions.fetchBespokePlanOptions(params)
                .then(function () { return _this.setState({ isLoading: false }); });
        }
    };
    BespokeSelectYourPlanPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__WorkflowStep__["a" /* default */], { title: this.props.planOptions.length > 0
                ? 'Use the slider to pick a coverage amount that works for you and your family.'
                : 'Sorry, we currently do not have any plans available for you.' }, this.props.planOptions.length > 0 &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__QuoteSlider__["a" /* default */], { className: "mb-4", min: this.COVERAGE_MIN, max: this.COVERAGE_MAX, value: this.props.customerPolicy.coverageAmount, valuePrefix: "$", titleSuffix: "in coverage", onSliderDragEnd: this.onSliderDragEnd, onValuesUpdated: this.onCoverageUpdate }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__PlanOptions__["a" /* default */], __assign({}, this.props, { workflow: this.props.match.params.workflow, isLoading: this.state.isLoading, className: "text-center quote-plans-bespoke" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-5 text-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mx-auto max-read-width" }, "Need help deciding?"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons_Button__["a" /* default */], { to: "/quote/B/your-needs", className: "btn-outline-primary mb-4" }, "Use our calculator")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mx-auto max-read-width" }, "Need a different term?"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons_Button__["a" /* default */], { to: "/quote/Custom/select-your-policy", className: "btn-outline-primary" }, "Build a custom policy"))))));
    };
    return BespokeSelectYourPlanPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (BespokeSelectYourPlanPage);


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sections__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkflowProgress__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomAboutYouPage__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CustomSelectYourPlanPage__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__ = __webpack_require__(63);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var CustomWorkflow = function (props) {
    var Page = null;
    var activeStep = 0;
    if (props.match.params.page === 'about-you') {
        Page = __WEBPACK_IMPORTED_MODULE_4__CustomAboutYouPage__["a" /* default */];
        activeStep = 0;
    }
    else if (props.match.params.page === 'select-your-policy') {
        Page = __WEBPACK_IMPORTED_MODULE_5__CustomSelectYourPlanPage__["a" /* default */];
        activeStep = 1;
    }
    else if (props.match.params.page === 'enrollment') {
        Page = __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */];
        if (props.match.params.enrollmentPage === 'billing'
            || props.match.params.enrollmentPage === 'review'
            || props.match.params.enrollmentPage === 'beneficiary'
            || props.match.params.enrollmentPage === 'sign-up') {
            activeStep = 3;
        }
        else {
            activeStep = 2;
        }
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["c" /* PageContent */], { wrapperClassName: "mt-6", sectionClassName: "pt-0" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_sections__["b" /* SectionMain */], { sectionClassName: "section-sm section-extend-up bg-secondary text-light workflow-progress-wrapper", wrapperClassName: "mb-4 mb-md-5 px-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__WorkflowProgress__["a" /* default */], { buttonClassName: "btn-outline-light", steps: [
                        {
                            label: 'About you',
                            to: "/quote/" + props.match.params.workflow + "/about-you",
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 3
                        },
                        {
                            label: 'Select your policy',
                            to: "/quote/" + props.match.params.workflow + "/select-your-policy",
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 3
                        },
                        {
                            label: 'Apply for coverage',
                            onClick: function () { return props.saveAndRedirect("/quote/" + props.match.params.workflow + "/enrollment/my-pledge"); },
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 3
                        },
                        {
                            label: 'Review and billing',
                            onClick: function () { return props.saveAndRedirect("/quote/" + props.match.params.workflow + "/enrollment/review"); },
                            incomplete: Page === __WEBPACK_IMPORTED_MODULE_6__enrollment_EnrollmentPage__["a" /* default */] && activeStep === 3
                        }
                    ], activeStep: activeStep })),
            Page !== null && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Page, __assign({}, props)))));
};
/* harmony default export */ __webpack_exports__["a"] = (CustomWorkflow);


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkflowStep__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AboutYou__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var CustomAboutYouPage = /** @class */ (function (_super) {
    __extends(CustomAboutYouPage, _super);
    function CustomAboutYouPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errors = { age: {} };
        _this.validate = function () {
            // true means invalid
            return {
                age: __WEBPACK_IMPORTED_MODULE_6__common_utils__["k" /* Validation */].validateAge(_this.props.user.birthDate, _this.props.currentUser.isAuthenticated)
            };
        };
        _this.isNextDisabled = function () {
            if (_this.props.customerDetails.age == null
                || _this.props.user.gender == null
                || _this.props.customerDetails.isSmoker == null) {
                return true;
            }
            return _this.errors.age.hasError;
        };
        _this.next = function () {
            _this.props.history.push('/quote/Custom/select-your-policy');
        };
        return _this;
    }
    CustomAboutYouPage.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__WorkflowStep__["a" /* default */], { title: "Before we begin, we'd like to get to know you better." },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms_Fieldset__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__AboutYou__["a" /* default */], __assign({}, this.props, { errors: this.errors }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { onClick: this.next, className: "btn-primary workflow-progress-action", disabled: this.isNextDisabled() },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Select your policy"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_icons__["t" /* IconChevronRight */], null)))));
    };
    return CustomAboutYouPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CustomAboutYouPage);


/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quotingActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









var QuotingDeclined = /** @class */ (function (_super) {
    __extends(QuotingDeclined, _super);
    function QuotingDeclined() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            saving: false,
            showSaveMsg: false,
        };
        _this.onUserChange = function (e) {
            var user = __assign({}, _this.props.user, (_a = {}, _a[e.target.name] = e.target.value, _a));
            _this.props.actions.setUser(user);
            var _a;
        };
        _this.onPhoneKeyUp = function (e) {
            var phone = e.target.value;
            phone = phone
                .match(/\d*/g)
                .join('')
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
                .slice(1)
                .join('-')
                .replace(/-*$/g, '');
            var user = __assign({}, _this.props.user, (_a = {}, _a[e.target.name] = phone, _a));
            _this.props.actions.setUser(user);
            var _a;
        };
        _this.onSave = function () {
            _this.setState({ saving: true });
            var softDeclinedUser = __assign({}, _this.props.user);
            _this.props.actions.updateSoftDeclinedUser(softDeclinedUser, _this.props.customerPolicy.id)
                .then(function () { return _this.setState({ showSaveMsg: true, saving: false }); });
        };
        _this.onHardDeclineEmailSave = function () {
            _this.setState({ saving: true });
            var hardDeclinedQCUser = __assign({}, _this.props.user);
            _this.props.actions.saveUser(hardDeclinedQCUser)
                .then(function () { return _this.setState({ showSaveMsg: true, saving: false }); });
        };
        return _this;
    }
    QuotingDeclined.prototype.componentWillUnmount = function () {
        this.resetAllQuestionnaireData();
        this.props.history.push('/');
    };
    QuotingDeclined.prototype.resetAllQuestionnaireData = function () {
        this.props.actions.resetUser();
        this.props.actions.resetCustomerDetails();
        this.props.actions.resetQuestionnaire();
        this.props.actions.resetCustomerPolicy();
    };
    QuotingDeclined.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_common__["b" /* Page */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_common__["c" /* PageContent */], { sectionClassName: "text-center" }, this.props.isHardDeclined.isDeclined ?
                (this.props.isHardDeclined.isQCDeclined ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_common__["d" /* PageHeader */], { title: "Nous sommes désolés.", isCentered: true, className: "text-secondary" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lead mb-0" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Mosaic Life n\u2019est pas couramment disponible au Qu\u00E9bec. Nous travaillons vers l\u2019ouverture de notre site en fran\u00E7ais, ainsi que la traduction de notre police d\u2019assurance. Si vous d\u00E9sirez que nous vous laissions savoir quand nos produits seront disponibles au Qu\u00E9bec veuillez nous provenir votre adresse courriel ci-dessous."))),
                    this.state.showSaveMsg ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-8 col-lg-6 mx-auto" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "lead" }, "Merci.")))) :
                        (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-8 col-lg-6 mx-auto" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_forms__["n" /* TextInput */], { labelText: "Email", name: "email", onChange: this.onUserChange, value: this.props.user.email }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_buttons__["a" /* Button */], { onClick: this.onHardDeclineEmailSave, className: "btn-primary", disabled: this.state.saving },
                                    "Contactez moi",
                                    this.state.saving && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_common__["f" /* Spinner */], null))))))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_common__["d" /* PageHeader */], { title: "Sorry.", isCentered: true, className: "text-secondary" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lead mb-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Unfortunately, at this time, we are not able to provide you with a life insurance quote based on your answers to the  questionnaire."))))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_common__["d" /* PageHeader */], { title: "Let's speak.", isCentered: true, className: "text-secondary" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lead mb-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Based on your answers to the questionnaire, we need a bit more information from you in order to process your application.  Please enter your phone number and validate your email below and someone from Mosaic Life will contact you shortly."))),
                this.state.showSaveMsg ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-8 col-lg-6 mx-auto" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "lead" }, "Thanks. We'll contact you shortly.")))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-8 col-lg-6 mx-auto" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_forms__["n" /* TextInput */], { labelText: "Please enter your phone number", name: "phoneNumber", onChange: this.onUserChange, onKeyUp: this.onPhoneKeyUp, value: this.props.user.phoneNumber }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_forms__["n" /* TextInput */], { labelText: "Email", name: "email", onChange: this.onUserChange, value: this.props.user.email }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_buttons__["a" /* Button */], { onClick: this.onSave, className: "btn-primary", disabled: this.state.saving },
                            "Contact Me",
                            this.state.saving && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_common__["f" /* Spinner */], null))))))))));
    };
    return QuotingDeclined;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        user: state.user.user,
        customerPolicy: state.policy.customerPolicy,
        isHardDeclined: state.policy.isHardDeclined
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__quotingActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__user_userActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(QuotingDeclined));


/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__report_reportActions__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdminHomePageCell__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var AdminHomePage = /** @class */ (function (_super) {
    __extends(AdminHomePage, _super);
    function AdminHomePage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getLastMonth = function () {
            var months = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ];
            var lastMonth = new Date().getMonth() - 1;
            if (lastMonth < 0) {
                lastMonth = 11;
            }
            return months[lastMonth];
        };
        return _this;
    }
    AdminHomePage.prototype.componentDidMount = function () {
        this.props.actions.fetchCustomersCount();
        this.props.actions.fetchPoliciesCount();
        this.props.actions.fetchUnmailedPoliciesCount();
        this.props.actions.fetchFailedPaymentsCount();
        this.props.actions.fetchExpiringPoliciesCount();
        this.props.actions.fetchMissingBeneficiaryFormsCount();
        this.props.actions.fetchBouncedEmailsCount();
    };
    AdminHomePage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["b" /* Page */], { title: "Dashboard" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["c" /* PageContent */], { sectionClassName: "dashboard p-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "dashboard-row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__AdminHomePageCell__["a" /* default */], { className: "bg-secondary text-light admin-dashboard-cell-lg", title: "Customers", value: this.props.customersCount.total, subValue: this.props.customersCount.month + " in " + this.getLastMonth(), to: "/admin/reports/user-activity", linkLabel: "View activity" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__AdminHomePageCell__["a" /* default */], { className: "admin-dashboard-cell-lg dashboard-col", title: "Policies created", value: this.props.policiesCount.total, subValue: this.props.policiesCount.month + " in " + this.getLastMonth(), to: "/admin/reports/policies-created", linkLabel: "View policies" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__AdminHomePageCell__["a" /* default */], { className: "admin-dashboard-cell-lg dashboard-col", title: "Unmailed policies", value: this.props.unmailedPoliciesCount.total, subValue: this.props.unmailedPoliciesCount.month + " in " + this.getLastMonth(), to: "/admin/reports/policies-unmailed", linkLabel: "View unmailed policies" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "dashboard-row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__AdminHomePageCell__["a" /* default */], { className: "dashboard-col text-primary", title: "Policies expiring in 30 days", value: this.props.expiringPoliciesCount, to: "/admin/reports/policies-expiring", linkLabel: "View expiring policies" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__AdminHomePageCell__["a" /* default */], { className: "dashboard-col text-primary", title: "Failed payments", value: this.props.failedPaymentsCount, to: "/admin/reports/failed-payments", linkLabel: "View failed payments" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__AdminHomePageCell__["a" /* default */], { className: "dashboard-col text-primary", title: "Missing beneficiary forms", value: this.props.missingBeneficiaryFormsCount, to: "/admin/reports/missing-beneficiary-forms", linkLabel: "View customers" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__AdminHomePageCell__["a" /* default */], { className: "dashboard-col text-primary", title: "Bounced emails in the past 30 days", value: this.props.bouncedEmailsCount, to: "/admin/reports/bounced-emails", linkLabel: "View bounced emails" })))));
    };
    return AdminHomePage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        customersCount: state.report.customersCount,
        policiesCount: state.report.policiesCount,
        unmailedPoliciesCount: state.report.unmailedPoliciesCount,
        failedPaymentsCount: state.report.failedPaymentsCount,
        expiringPoliciesCount: state.report.expiringPoliciesCount,
        missingBeneficiaryFormsCount: state.report.missingBeneficiaryFormsCount,
        bouncedEmailsCount: state.report.bouncedEmailsCount,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__report_reportActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(AdminHomePage);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connector, ["Admin" /* Administrator */, "Agent" /* Agent */]));


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var apiUrl = "https://www.insuredbymosaic.ca/api";
var reportAPI = {
    fetchCustomersCount: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/customers/count.json")
            .then(function (resp) { return resp.data; });
    },
    fetchUserActivities: function (fromDate, toDate) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/user-activities/from/" + fromDate + "/to/" + toDate + ".json")
            .then(function (resp) { return resp.data; });
    },
    fetchPoliciesCount: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/policies/count.json")
            .then(function (resp) { return resp.data; });
    },
    fetchPolicies: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/policies.json")
            .then(function (resp) { return resp.data; });
    },
    fetchUnmailedPoliciesCount: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/unmailed-policies/count.json")
            .then(function (resp) { return resp.data; });
    },
    fetchUnmailedPolicies: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/unmailed-policies.json")
            .then(function (resp) { return resp.data; });
    },
    fetchFailedPaymentsCount: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/failed-payments/count.json")
            .then(function (resp) { return resp.data; });
    },
    fetchFailedPayments: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/failed-payments.json")
            .then(function (resp) { return resp.data; });
    },
    fetchExpiringPoliciesCount: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/expiring-policies/count.json")
            .then(function (resp) { return resp.data; });
    },
    fetchExpiringPolicies: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/expiring-policies.json")
            .then(function (resp) { return resp.data; });
    },
    fetchMissingBeneficiaryFormsCount: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/missing-beneficiary-forms/count.json")
            .then(function (resp) { return resp.data; });
    },
    fetchCustomersMissingBeneficiaryForms: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/missing-beneficiary-forms/customers.json")
            .then(function (resp) { return resp.data; });
    },
    fetchBouncedEmailsCount: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/bounced-emails/count.json")
            .then(function (resp) { return resp.data; });
    },
    fetchBouncedEmails: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/bounced-emails.json")
            .then(function (resp) { return resp.data; });
    },
    resolveBouncedEmail: function (id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/reports/bounced-emails/" + id + "/resolve")
            .then(function (resp) { return resp.data; });
    },
    fetchFinancialExport: function (fromDate, toDate) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/financial-export/from/" + fromDate + "/to/" + toDate + ".json")
            .then(function (resp) { return resp.data; });
    },
    fetchReferralReport: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/reports/referrals.json")
            .then(function (resp) { return resp.data; });
    },
};
/* harmony default export */ __webpack_exports__["a"] = (reportAPI);


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var classNames = __webpack_require__(8);

var AdminHomePageCell = /** @class */ (function (_super) {
    __extends(AdminHomePageCell, _super);
    function AdminHomePageCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdminHomePageCell.prototype.render = function () {
        var _a = this.props, className = _a.className, title = _a.title, value = _a.value, subValue = _a.subValue, to = _a.to, linkLabel = _a.linkLabel;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('dashboard-cell admin-dashboard-cell', className) },
            title && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "admin-dashboard-cell-title" }, title),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "admin-dashboard-cell-value" }, value !== undefined ? value : '-'),
            subValue && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "admin-dashboard-cell-subvalue" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null, subValue))),
            to && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: to, className: "admin-dashboard-cell-link arrow-link" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "arrow-link-content" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "arrow-link-label" }, linkLabel),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_icons__["m" /* IconArrowRight */], { className: "arrow-link-icon" }))))));
    };
    return AdminHomePageCell;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AdminHomePageCell);


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pickListActions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PickListTypeList__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var PickListTypeListPage = /** @class */ (function (_super) {
    __extends(PickListTypeListPage, _super);
    function PickListTypeListPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.EditPickList = function (pickListId) {
            _this.props.history.push("/admin/pick-lists/" + pickListId);
        };
        _this.DeletePickList = function (pickListId) {
            __WEBPACK_IMPORTED_MODULE_3_toastr__["error"]('NOT IMPLEMENTED');
        };
        return _this;
    }
    PickListTypeListPage.prototype.componentWillMount = function () {
        this.props.actions.getPickListTypes();
    };
    PickListTypeListPage.prototype.render = function () {
        var pickListTypes = this.props.pickListTypes;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], { title: "Pick list types" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: "Pick list types" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__PickListTypeList__["a" /* default */], { pickListTypes: pickListTypes, OnEdit: this.EditPickList, OnDelete: this.DeletePickList, history: this.props.history }))));
    };
    return PickListTypeListPage;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
function mapStateToProps(state) {
    return {
        pickListTypes: state.pickList.types
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__pickListActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var ConnectedPickListTypePage = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(PickListTypeListPage);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__auth_authComponents__["a" /* ensureUserHasRole */])(ConnectedPickListTypePage, ["Admin" /* Administrator */, "Agent" /* Agent */]));


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);




var PickListTypeList = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
            {
                accessor: 'id',
                show: false
            },
            {
                Header: 'Code',
                accessor: 'code'
            },
            {
                Header: 'Description',
                accessor: 'description'
            },
            {
                Header: 'Active',
                accessor: 'isActive',
                Cell: function (rowInfo) { return (rowInfo.row.isActive ? 'True' : 'False'); }
            },
            {
                Header: 'Actions',
                className: 'p-0 td-actions',
                width: 120,
                Cell: function (rowInfo) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["b" /* IconButton */], { onClick: function (e) {
                            e.stopPropagation(); // Prevent onClick conflict with tr onclick
                            props.OnEdit(rowInfo.row.id);
                        }, title: "Edit pick list type", className: "btn-icon-secondary btn-icon-td" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["x" /* IconEdit */], null)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["b" /* IconButton */], { onClick: function (e) {
                            e.stopPropagation(); // Prevent onClick conflict with tr onclick
                            props.OnDelete(rowInfo.row.id);
                        }, title: "Delete pick list type", className: "btn-icon-secondary btn-icon-td" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["v" /* IconDelete */], null)))); }
            }
        ], getTrProps: function (state, rowInfo, column) {
            return {
                className: 'tr interactive',
                onClick: function () { return props.OnEdit(rowInfo.row.id); }
            };
        }, data: props.pickListTypes, noDataText: "No picklists found" }));
};
/* harmony default export */ __webpack_exports__["a"] = (PickListTypeList);


/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pickListActions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PickListItemList__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PickListTypeForm__ = __webpack_require__(530);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var PickListItemListPage = /** @class */ (function (_super) {
    __extends(PickListItemListPage, _super);
    function PickListItemListPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: false
        };
        _this.savePickListType = function () {
            _this.setState({ isLoading: true });
            _this.props.actions
                .savePickListType(_this.props.pickListType)
                .then(function () { return _this.setState({ isLoading: false }); })
                .then(function () { return __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('PickList Type saved'); });
        };
        _this.onPickListItemEdit = function (pickListItemId) {
            _this.props.history.push("/admin/pick-lists/" + _this.props.match.params.pickListTypeId + "/" + pickListItemId);
        };
        _this.onPickListItemDelete = function (pickListItemId) {
            __WEBPACK_IMPORTED_MODULE_3_toastr__["error"]('NOT IMPLEMENTED');
        };
        _this.typeInputChange = function (e) {
            var pickListType = __assign({}, _this.props.pickListType, (_a = {}, _a[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value, _a));
            _this.props.actions.setPickListType(pickListType);
            var _a;
        };
        return _this;
    }
    PickListItemListPage.prototype.componentDidMount = function () {
        this.props.actions.getPickListType(this.props.match.params.pickListTypeId);
    };
    PickListItemListPage.prototype.render = function () {
        var _a = this.props, pickListType = _a.pickListType, pickListItems = _a.pickListItems;
        var title = pickListType ? pickListType.description + " items" : 'Pick list items';
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], { title: pickListType.description + " items" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: title, className: "page-header-sm" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset mb-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__PickListTypeForm__["a" /* default */], { pickListType: pickListType, isLoading: this.state.isLoading, handleInputChange: this.typeInputChange, handleSaveClick: this.savePickListType })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__PickListItemList__["a" /* default */], { pickListItems: pickListItems, onEdit: this.onPickListItemEdit, onDelete: this.onPickListItemDelete }))));
    };
    return PickListItemListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state, ownProps) {
    return {
        pickListType: state.pickList.type,
        pickListItems: state.pickList.items.filter(function (i) { return i.pickListTypeId === ownProps.match.params.pickListTypeId; })
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__pickListActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(PickListItemListPage));


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);




var PickListItemList = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
            {
                accessor: 'id',
                show: false
            },
            {
                Header: 'Code',
                accessor: 'code'
            },
            {
                Header: 'Description',
                accessor: 'description'
            },
            {
                Header: 'Active',
                accessor: 'isActive',
                Cell: function (rowInfo) { return (rowInfo.row.isActive ? 'True' : 'False'); }
            },
            {
                Header: 'Actions',
                className: 'p-0 td-actions',
                width: 120,
                Cell: function (rowInfo) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["b" /* IconButton */], { onClick: function (e) {
                            e.stopPropagation(); // Prevent onClick conflict with tr onclick
                            props.onEdit(rowInfo.row.id);
                        }, title: "Edit pick list item", className: "btn-icon-secondary btn-icon-td" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["x" /* IconEdit */], null)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["b" /* IconButton */], { onClick: function (e) {
                            e.stopPropagation(); // Prevent onClick conflict with tr onclick
                            props.onDelete(rowInfo.row.id);
                        }, title: "Delete pick list item", className: "btn-icon-secondary btn-icon-td" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["v" /* IconDelete */], null)))); }
            }
        ], getTrProps: function (state, rowInfo, column) {
            return {
                className: 'tr interactive',
                onClick: function () { return props.onEdit(rowInfo.row.id); }
            };
        }, data: props.pickListItems, noDataText: "No picklists found", sortable: true }));
};
/* harmony default export */ __webpack_exports__["a"] = (PickListItemList);


/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);



var PickListTypeForm = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: props.className },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-end" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { className: "col-lg-4 col-xl-6 mb-lg-0", labelText: "Description", name: "description", value: props.pickListType.description, placeholder: "Short description", onChange: props.handleInputChange }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["b" /* Checkbox */], { className: "col-xs-12 col-lg-auto mb-lg-0 single", label: '<strong>Active</strong>', name: "isActive", checked: props.pickListType.isActive, onChange: props.handleInputChange }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-xs-12 col-lg-auto ml-lg-3" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_buttons__["a" /* Button */], { className: "btn-primary", type: "button", disabled: props.isLoading, onClick: props.handleSaveClick }, "Save")))));
};
/* harmony default export */ __webpack_exports__["a"] = (PickListTypeForm);


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pickListActions__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PickListItemForm__ = __webpack_require__(532);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var PickListItemPage = /** @class */ (function (_super) {
    __extends(PickListItemPage, _super);
    function PickListItemPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: false
        };
        _this.onChange = function (e) {
            var pickListItem = __assign({}, _this.props.pickListItem, (_a = {}, _a[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value, _a));
            _this.props.actions.setPickListItem(pickListItem);
            var _a;
        };
        _this.onDelete = function (pickListItemId) {
            __WEBPACK_IMPORTED_MODULE_3_toastr__["error"]('NOT IMPLEMENTED');
        };
        _this.onSave = function () {
            _this.setState({ isLoading: true });
            _this.props.actions.savePickListItem(_this.props.pickListItem)
                .then(function () { return _this.setState({ isLoading: false }); })
                .then(function () {
                __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Pick List Item saved');
                _this.props.history.push("admin/pick-lists/" + _this.props.match.params.pickListItemId);
            });
        };
        return _this;
    }
    PickListItemPage.prototype.componentDidMount = function () {
        this.props.actions.getPickListItem(this.props.match.params.pickListItemId);
    };
    PickListItemPage.prototype.render = function () {
        var title = this.props.match.pickListItemId !== 'new'
            ? "Edit " + this.props.pickListItem.description
            : 'Add new pick list item';
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], { title: title },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: title }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__PickListItemForm__["a" /* default */], { pickListItem: this.props.pickListItem, onChange: this.onChange, onDelete: this.onDelete, onSave: this.onSave, isLoading: this.state.isLoading }))));
    };
    return PickListItemPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        pickListItem: state.pickList.item
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__pickListActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(PickListItemPage));


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);



var PickListItemForm = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: props.className },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Pick List Item"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-end" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Description", name: "description", onChange: props.onChange, value: props.pickListItem.description, placeholder: "Short description", className: "col-lg-4 col-xl-6 mb-lg-0" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["b" /* Checkbox */], { className: "col-xs-12 col-lg-auto mb-lg-0 single", label: '<strong>Active</strong>', name: "isActive", onChange: props.onChange, checked: props.pickListItem.isActive }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-xs-12 col-lg-auto ml-lg-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_buttons__["a" /* Button */], { className: "btn-primary", type: "button", disabled: props.isLoading, onClick: props.onSave }, "Save"))))));
};
/* harmony default export */ __webpack_exports__["a"] = (PickListItemForm);


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CustomerList__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Page__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};










var CustomerListPage = /** @class */ (function (_super) {
    __extends(CustomerListPage, _super);
    function CustomerListPage(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSearchDebounced = __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].debounce(function () { return _this.search(_this.state.searchterm); }, 200);
        _this.onSearch = function (e) {
            _this.setState({ searchterm: e.target.value }, function () {
                _this.handleSearchDebounced();
            });
        };
        _this.search = function (searchterm) {
            var value = searchterm.toLowerCase();
            var customers = _this.props.customers.filter(function (c) {
                var fullName = c.fullName || '';
                var email = c.email || '';
                return fullName.toLowerCase().startsWith(value) || email.toLowerCase().startsWith(value);
            });
            _this.setState({ customers: customers });
        };
        _this.onClickComplete = function () {
            if (_this.state.isLoading) {
                return;
            }
            if (!_this.state.showComplete) {
                _this.setState({ isLoading: true, showComplete: true });
                _this.props.actions
                    .fetchCustomers()
                    .then(function () { return _this.search(_this.state.searchterm); })
                    .then(function () { return _this.setState({ isLoading: false }); });
            }
        };
        _this.onClickProspects = function () {
            if (_this.state.isLoading) {
                return;
            }
            if (_this.state.showComplete) {
                _this.setState({ isLoading: true, showComplete: false });
                _this.props.actions
                    .fetchCustomers(true)
                    .then(function () { return _this.search(_this.state.searchterm); })
                    .then(function () { return _this.setState({ isLoading: false }); });
            }
        };
        _this.sortByEffectiveDate = function (policyA, policyB) {
            return policyA.effectiveDate > policyB.effectiveDate ? 1 : -1;
        };
        _this.generateCombinedStatus = function (customer) {
            if (customer.policies === undefined || customer.policies.length === 0 || customer.policies.some(function (p) { return p.isActive === true; })) {
                return ''; // only customer who has no active policy will be displayed in applicant list
            }
            var sortedPolicies = customer.policies.sort(_this.sortByEffectiveDate);
            var returnedStatus = '';
            var returnedCell;
            if (sortedPolicies && sortedPolicies.some(function (p) { return p.adjudicationStatusId !== undefined; })) {
                var adjudicationPolicies = sortedPolicies.filter(function (p) { return p.adjudicationStatusId !== undefined; });
                var declinedStatus = _this.generateDeclinedStatus(adjudicationPolicies[0], returnedStatus);
                var adjudicationStatus = _this.generateAdjudicationStatus(adjudicationPolicies[0], returnedStatus);
                returnedCell = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    declinedStatus,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null, adjudicationStatus)));
            }
            else {
                var declinedStatus = _this.generateDeclinedStatus(sortedPolicies[0], returnedStatus);
                returnedCell = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, declinedStatus));
            }
            return returnedCell;
        };
        _this.generateAdjudicationStatus = function (policy, statusText) {
            switch (policy.adjudicationStatusId) {
                case __WEBPACK_IMPORTED_MODULE_8__common_utils__["a" /* AdjudicationStatus */].Unreviewed:
                    statusText += '(Unreviewed)';
                    break;
                case __WEBPACK_IMPORTED_MODULE_8__common_utils__["a" /* AdjudicationStatus */].InProcess:
                    statusText += '(In Process)';
                    break;
                case __WEBPACK_IMPORTED_MODULE_8__common_utils__["a" /* AdjudicationStatus */].Rejected:
                    statusText += '(Rejected)';
                    break;
                default:
                    break;
            }
            return statusText;
        };
        _this.generateDeclinedStatus = function (policy, statusText) {
            if (policy.isSoftDeclined || policy.isHardDeclined) {
                statusText += policy.isSoftDeclined ? 'Soft Declined' : 'Hard Declined';
                return statusText;
            }
            else {
                switch (policy.statusId) {
                    case __WEBPACK_IMPORTED_MODULE_8__common_utils__["h" /* PolicyStatus */].Inactive:
                        statusText += 'Inactive';
                        break;
                    case __WEBPACK_IMPORTED_MODULE_8__common_utils__["h" /* PolicyStatus */].Canceled:
                        statusText += 'Canceled';
                        break;
                    default:
                        break;
                }
                return statusText;
            }
        };
        _this.shouldShowBoldRow = function (customer) {
            if (customer.policies && customer.policies.some(function (p) { return p.adjudicationStatusId !== undefined; })) {
                return true;
            }
            else {
                return false;
            }
        };
        _this.state = {
            customers: [],
            isLoading: true,
            searchterm: '',
            showComplete: true
        };
        return _this;
    }
    CustomerListPage.prototype.componentDidMount = function () {
        var _this = this;
        this.props.actions
            .fetchCustomers()
            .then(function () { return _this.setState({ customers: _this.props.customers, isLoading: false }); });
    };
    CustomerListPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_common_Page__["a" /* default */], { title: "Customers" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["d" /* PageHeader */], { title: "Customers" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__CustomerList__["a" /* default */], { customers: this.state.customers, history: this.props.history, isLoading: this.state.isLoading, searchterm: this.state.searchterm, onSearch: this.onSearch, onClickComplete: this.onClickComplete, onClickProspects: this.onClickProspects, showComplete: this.state.showComplete, setRedirectFromAdjudication: this.props.actions.setRedirectFromAdjudication, generateCombinedStatus: this.generateCombinedStatus, shouldShowBoldRow: this.shouldShowBoldRow }))));
    };
    return CustomerListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        customers: state.user.customers
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__user_userActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CustomerListPage);
var adminRoles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, adminRoles));


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};






var CustomerList = /** @class */ (function (_super) {
    __extends(CustomerList, _super);
    function CustomerList(props) {
        var _this = _super.call(this, props) || this;
        _this.onPageChange = function (pageIndex) {
            _this.setState({ page: pageIndex });
        };
        _this.state = {
            page: 0
        };
        return _this;
    }
    CustomerList.prototype.render = function () {
        var props = __rest(this.props, []);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "btn-group table-filters" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-filter" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons__["a" /* Button */], { className: "btn-outline-secondary btn-block" + (props.showComplete ? ' active' : ''), onClick: props.onClickComplete }, "Complete")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-filter" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons__["a" /* Button */], { className: "btn-outline-secondary btn-block" + (props.showComplete ? '' : ' active'), onClick: props.onClickProspects }, "Applications"))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { name: "search", placeholder: "Search", value: props.searchterm, onChange: props.onSearch, className: "m-0 table-search" })),
            props.isLoading ?
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["f" /* Spinner */], { className: "d-block mx-auto" })
                :
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                            {
                                accessor: 'id',
                                show: false
                            },
                            {
                                Header: 'Full Name',
                                accessor: 'fullName'
                            },
                            {
                                Header: 'Email',
                                accessor: 'email',
                                Cell: function (rowInfo) {
                                    if (!props.showComplete && rowInfo.original.email) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "mailto:" + rowInfo.original.email, onClick: function (e) { return e.stopPropagation(); } }, rowInfo.value);
                                    }
                                    else {
                                        return rowInfo.value;
                                    }
                                }
                            },
                            {
                                Header: 'Sign Up Date',
                                accessor: 'createdDate',
                                Cell: function (rowInfo) { return __WEBPACK_IMPORTED_MODULE_5__common_utils__["m" /* default */].formatDate(rowInfo.value); }
                            },
                            !props.showComplete ? {
                                Header: 'Status',
                                Cell: function (rowInfo) { return props.generateCombinedStatus(rowInfo.original); }
                            } : {
                                show: false
                            },
                            {
                                Header: 'Actions',
                                className: 'p-0 td-actions',
                                width: 100,
                                Cell: function (rowInfo) {
                                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons__["b" /* IconButton */], { title: "Edit customer", className: "btn-icon-secondary btn-icon-td", onClick: function (e) {
                                            e.stopPropagation(); // Prevent onClick conflict with tr onclick
                                            props.setRedirectFromAdjudication(false);
                                            if (rowInfo.original.stripeCustomerId) {
                                                return props.history.push("/admin/customers/" + rowInfo.row.id + "/details");
                                            }
                                            else {
                                                return props.history.push("/admin/prospects/" + rowInfo.original.id + "/details");
                                            }
                                        } },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_icons__["m" /* IconArrowRight */], null)));
                                }
                            }
                        ], data: props.customers, loading: props.isLoading, getTrProps: function (state, rowInfo, column) {
                            var className = "tr interactive" + ((!props.showComplete && props.shouldShowBoldRow(rowInfo.original)) ? " font-weight-bold" : "");
                            return {
                                className: className,
                                onClick: function () {
                                    props.setRedirectFromAdjudication(false);
                                    if (rowInfo.original.stripeCustomerId) {
                                        return props.history.push("/admin/customers/" + rowInfo.original.id + "/details");
                                    }
                                    else {
                                        return props.history.push("/admin/prospects/" + rowInfo.original.id + "/details");
                                    }
                                }
                            };
                        }, noDataText: "No customers found", onPageChange: this.onPageChange, page: this.state.page })));
    };
    return CustomerList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CustomerList);


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_paymentActions__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomerDetailsPage__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CustomerBillsPage__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CustomerPolicyPage__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CustomerBeneficiariesPage__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CustomerBeneficiariesDisbursementPage__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CustomerNotesPage__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CustomerReferralsPage__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_SecurityPage__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__payment_UpdatePaymentDetails__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

















var CustomerPage = /** @class */ (function (_super) {
    __extends(CustomerPage, _super);
    function CustomerPage(props) {
        var _this = _super.call(this, props) || this;
        _this.getTab = function (tabParam) {
            var tab = null;
            switch (tabParam) {
                case 'bills':
                    tab = __WEBPACK_IMPORTED_MODULE_8__CustomerBillsPage__["a" /* default */];
                    break;
                case 'payment-info':
                    tab = __WEBPACK_IMPORTED_MODULE_15__payment_UpdatePaymentDetails__["a" /* default */];
                    break;
                case 'policies':
                    tab = __WEBPACK_IMPORTED_MODULE_9__CustomerPolicyPage__["a" /* default */];
                    break;
                case 'beneficiaries':
                    tab = __WEBPACK_IMPORTED_MODULE_10__CustomerBeneficiariesPage__["a" /* default */];
                    break;
                // this page doesn't show in tab bar directly
                case 'beneficiaries-disbursement':
                    tab = __WEBPACK_IMPORTED_MODULE_11__CustomerBeneficiariesDisbursementPage__["a" /* default */];
                    break;
                case 'notes':
                    tab = __WEBPACK_IMPORTED_MODULE_12__CustomerNotesPage__["a" /* default */];
                    break;
                case 'security':
                    tab = __WEBPACK_IMPORTED_MODULE_14__common_SecurityPage__["a" /* default */];
                    break;
                case 'referrals':
                    tab = __WEBPACK_IMPORTED_MODULE_13__CustomerReferralsPage__["a" /* default */];
                    break;
                case 'details':
                default:
                    tab = __WEBPACK_IMPORTED_MODULE_7__CustomerDetailsPage__["a" /* default */];
                    break;
            }
            return tab;
        };
        _this.getTabProps = function (tabName, allProps) {
            var props;
            var actions = allProps.actions, history = allProps.history, match = allProps.match;
            var customer = allProps.customer;
            var currentUser = allProps.currentUser;
            switch (tabName) {
                case 'bills':
                    var payments = allProps.payments;
                    props = { actions: actions, history: history, match: match, payments: payments };
                    break;
                case 'payment-info':
                case 'policies':
                    props = { match: match, history: history };
                    break;
                case 'beneficiaries':
                case 'beneficiaries-disbursement':
                    var beneficiaries = allProps.beneficiaries, beneficiary = allProps.beneficiary, policies = allProps.policies;
                    props = { beneficiaries: beneficiaries, beneficiary: beneficiary, policies: policies, actions: actions, history: history, match: match };
                    break;
                case 'notes':
                    props = { customer: customer, history: history, match: match };
                    break;
                case 'security':
                    break;
                case 'details':
                default:// details page
                    props = { customer: customer, currentUser: currentUser, actions: actions, match: match };
            }
            return props;
        };
        _this.getTabTitle = function (tabParam) {
            var tabTitle = '';
            switch (tabParam) {
                case 'bills':
                    tabTitle = 'Bills';
                    break;
                case 'payment-info':
                    tabTitle = 'Payment info';
                    break;
                case 'policies':
                    tabTitle = 'Policies';
                    break;
                case 'beneficiaries':
                    tabTitle = 'Beneficiaries';
                    break;
                case 'notes':
                    tabTitle = 'Notes';
                    break;
                case 'security':
                    tabTitle = 'Manage Security';
                    break;
                case 'referrals':
                    tabTitle = 'Referrals';
                    break;
                case 'details':
                default:
                    tabTitle = 'Contact info';
                    break;
            }
            return tabTitle;
        };
        _this.state = {
            isLoading: true
        };
        return _this;
    }
    CustomerPage.prototype.componentDidMount = function () {
        var _this = this;
        this.props.actions.resetCustomerPolicy();
        this.props.actions
            .fetchUser(this.props.match.params.customerId)
            .then(function () { return _this.props.actions.fetchCustomerPayments(_this.props.match.params.customerId); })
            .then(function () { return _this.setState({ isLoading: false }); });
    };
    CustomerPage.prototype.render = function () {
        var Tab = this.getTab(this.props.match.params.tab);
        var tabTitle = this.getTabTitle(this.props.match.params.tab);
        var props = this.getTabProps(this.props.match.params.tab, this.props);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__components_common__["b" /* Page */], { title: this.props.customer.firstName + " " + this.props.customer.lastName + " - " + tabTitle },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__components_common__["d" /* PageHeader */], { className: "page-header-sm" + (this.state.isLoading ? ' loading' : '') },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "mb-0 has-loading-text" }, !this.state.isLoading && this.props.customer.firstName + " " + this.props.customer.lastName)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__components_common__["h" /* Tabs */], { tabs: [
                        {
                            label: 'Contact info',
                            to: "/admin/customers/" + this.props.match.params.customerId + "/details"
                        },
                        {
                            label: 'Bills',
                            to: "/admin/customers/" + this.props.match.params.customerId + "/bills"
                        },
                        {
                            label: 'Payment info',
                            to: "/admin/customers/" + this.props.match.params.customerId + "/payment-info"
                        },
                        {
                            label: 'Policies',
                            to: "/admin/customers/" + this.props.match.params.customerId + "/policies"
                        },
                        {
                            label: 'Beneficiaries',
                            to: "/admin/customers/" + this.props.match.params.customerId + "/beneficiaries"
                        },
                        {
                            label: 'Notes',
                            to: "/admin/customers/" + this.props.match.params.customerId + "/notes"
                        },
                        {
                            label: 'Referrals',
                            to: "/admin/customers/" + this.props.match.params.customerId + "/referrals"
                        },
                        {
                            label: 'Manage Security',
                            to: "/admin/customers/" + this.props.match.params.customerId + "/security"
                        }
                    ], match: this.props.match, disableDocTitle: true }),
                this.state.isLoading ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__components_common__["f" /* Spinner */], { className: "d-block mx-auto mt-4" })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tab, __assign({ className: "tab-content mt-4 mt-lg-3" }, props))))));
    };
    return CustomerPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        customer: state.user.user,
        payments: state.payment.payments,
        currentUser: state.auth.currentUser
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__payment_paymentActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__policy_policyActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CustomerPage);
var adminRoles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, adminRoles));


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payment_InvoiceDetails__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payment_PaymentHistoryList__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var CustomerBillsPage = /** @class */ (function (_super) {
    __extends(CustomerBillsPage, _super);
    function CustomerBillsPage(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSearchDebounced = __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].debounce(function () { _this.search(_this.state.searchterm); }, 200);
        _this.onSearch = function (e) {
            _this.setState({ searchterm: e.target.value }, function () {
                _this.handleSearchDebounced();
            });
        };
        _this.search = function (searchterm) {
            var value = searchterm.toLowerCase();
            var payments = _this.props.payments.filter(function (c) {
                var date = __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].formatDateAsUTC(c.date) || '';
                var stripeInvoiceNumber = c.stripeInvoiceNumber || '';
                return date.toLowerCase().startsWith(value) || stripeInvoiceNumber.toLowerCase().startsWith(value);
            });
            _this.setState({ payments: payments });
        };
        _this.sortPaymentHistory = function (a, b) {
            return (__WEBPACK_IMPORTED_MODULE_4_moment__(a.createdDate).utc()).isAfter(__WEBPACK_IMPORTED_MODULE_4_moment__(b.createdDate).utc()) ? -1 : 1;
        };
        _this.state = {
            payments: [],
            searchterm: ''
        };
        return _this;
    }
    CustomerBillsPage.prototype.componentDidMount = function () {
        var sortedPayments = this.props.payments.sort(this.sortPaymentHistory);
        this.setState({ payments: sortedPayments });
    };
    CustomerBillsPage.prototype.render = function () {
        if (this.props.match.params.pageId) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__payment_InvoiceDetails__["a" /* default */], __assign({ baseUrl: "/admin/customers/" + this.props.match.params.customerId + "/bills" }, this.props)));
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__payment_PaymentHistoryList__["a" /* default */], __assign({ baseUrl: "/admin/customers/" + this.props.match.params.customerId + "/bills" }, this.props, { payments: this.state.payments, searchterm: this.state.searchterm, onSearch: this.onSearch })));
        }
    };
    return CustomerBillsPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CustomerBillsPage);


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);





var CustomerPolicyList = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["a" /* DataTable */], { className: props.className, TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
            {
                accessor: 'id',
                show: false
            },
            {
                Header: 'Policy #',
                accessor: 'number',
            },
            {
                Header: 'Start Date',
                accessor: 'effectiveDate',
                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatDateAsUTC(row.value); }
            },
            {
                Header: 'End Date',
                accessor: 'endDate',
                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatDateAsUTC(row.value); }
            },
            {
                Header: 'Coverage Amount',
                accessor: 'coverageAmount',
                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatCurrency(row.value, 0); }
            },
            {
                Header: 'Status',
                accessor: 'statusId',
                Cell: function (row) {
                    if (row.value === __WEBPACK_IMPORTED_MODULE_4__common_utils__["h" /* PolicyStatus */].Active) {
                        return 'Active';
                    }
                    else if (row.value === __WEBPACK_IMPORTED_MODULE_4__common_utils__["h" /* PolicyStatus */].Inactive) {
                        return 'Inactive';
                    }
                    else if (row.value === __WEBPACK_IMPORTED_MODULE_4__common_utils__["h" /* PolicyStatus */].Canceled) {
                        return 'Canceled';
                    }
                    else {
                        return '';
                    }
                }
            },
            {
                Header: 'Actions',
                className: 'p-0 td-actions',
                width: 103,
                Cell: function (row) {
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["b" /* IconButton */], { title: "Edit policy", className: "btn-icon-secondary btn-icon-td", onClick: function (e) { return props.onRowClick(e, row.original); } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["x" /* IconEdit */], null)),
                        row.original.statusId !== __WEBPACK_IMPORTED_MODULE_4__common_utils__["h" /* PolicyStatus */].Inactive &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["b" /* IconButton */], { title: "Download policy", className: "btn-icon-secondary btn-icon-td", onClick: function (e) {
                                    e.stopPropagation(); // Prevent onClick conflict with tr onclick
                                    props.onDownloadClick(e, row.original);
                                } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["w" /* IconDownload */], null))));
                }
            }
        ], data: props.policies, getTrProps: function (state, rowInfo, column) {
            return { className: 'tr interactive', onClick: function (e) { return props.onRowClick(e, rowInfo.original); } };
        }, noDataText: "No policies found", loading: props.loading }));
};
/* harmony default export */ __webpack_exports__["a"] = (CustomerPolicyList);


/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);





var CustomerApplicationList = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["a" /* DataTable */], { className: props.className, TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
            {
                accessor: 'id',
                show: false
            },
            {
                Header: 'Application #',
                accessor: 'number',
            },
            {
                Header: 'Start Date',
                accessor: 'effectiveDate',
                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatDateAsUTC(row.value); }
            },
            {
                Header: 'End Date',
                accessor: 'endDate',
                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatDateAsUTC(row.value); }
            },
            {
                Header: 'Coverage Amount',
                accessor: 'coverageAmount',
                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatCurrency(row.value, 0); }
            },
            {
                Header: 'Status',
                accessor: 'statusId',
                Cell: function (row) {
                    if (row.value === __WEBPACK_IMPORTED_MODULE_4__common_utils__["h" /* PolicyStatus */].Active) {
                        return 'Active';
                    }
                    else if (row.value === __WEBPACK_IMPORTED_MODULE_4__common_utils__["h" /* PolicyStatus */].Inactive) {
                        return getInactiveDescription(row.original);
                    }
                    else if (row.value === __WEBPACK_IMPORTED_MODULE_4__common_utils__["h" /* PolicyStatus */].Canceled) {
                        return 'Canceled';
                    }
                    else {
                        return '';
                    }
                }
            },
            {
                Header: 'Actions',
                className: 'p-0 td-actions',
                width: 103,
                Cell: function (row) {
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["b" /* IconButton */], { title: "Edit application", className: "btn-icon-secondary btn-icon-td", onClick: function (e) { return props.onRowClick(e, row.original); } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["x" /* IconEdit */], null))));
                }
            }
        ], data: props.applications, getTrProps: function (state, rowInfo, column) {
            return { className: 'tr interactive', onClick: function (e) { return props.onRowClick(e, rowInfo.original); } };
        }, noDataText: "No applications found", loading: props.loading }));
    function getInactiveDescription(policy) {
        var description = policy.isSoftDeclined ? 'Soft Declined' : (policy.isHardDeclined ? 'Hard Declined' : 'Inactive');
        if (policy.adjudicationStatusId) {
            description += " - " + __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].getPickListItemDescription(policy.adjudicationStatusId);
        }
        return description;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (CustomerApplicationList);


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PolicyDetailsForm__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ApplicationDetailsForm__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__admin_customers_CustomerPolicyAnswersPage__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RejectPolicyModal__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__payment_paymentActions__ = __webpack_require__(32);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
















var PolicyDetails = /** @class */ (function (_super) {
    __extends(PolicyDetails, _super);
    function PolicyDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: true,
            overwriteRate: false,
            answerExpanded: false,
            isRejectPolicyModalOpen: false
        };
        _this.loadData = function () {
            var p1 = _this.props.actions.fetchCustomerPolicy(_this.props.match.params.customerId, _this.props.match.params.pageId);
            var p2 = _this.props.actions.fetchPolicyAnswer(_this.props.match.params.pageId);
            var p3 = _this.props.actions.fetchIsHardDeclined(_this.props.match.params.customerId, _this.props.match.params.pageId);
            Promise.all([p1, p2, p3])
                .then(function () { return _this.setState({ isLoading: false }); });
        };
        _this.onPolicyChange = function (e) {
            if (e.target.type === 'text' && !e.target.validity.valid) {
                return;
            }
            var customerPolicy = __assign({}, _this.props.customerPolicy, (_a = {}, _a[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value, _a));
            _this.props.actions.setCustomerPolicy(customerPolicy);
            var _a;
        };
        _this.onOverwirteChange = function (e) {
            if (e.target.checked === false) {
                var policyBeforeEdit = _this.props.policies.find(function (p) { return p.id === _this.props.match.params.pageId; });
                var customerPolicy = __assign({}, _this.props.customerPolicy, { rate: policyBeforeEdit.rate });
                _this.props.actions.setCustomerPolicy(customerPolicy);
            }
            _this.setState({ overwriteRate: e.target.checked });
        };
        _this.answerExpand = function () {
            _this.setState({ answerExpanded: !_this.state.answerExpanded });
        };
        _this.downloadQuestionnaireReport = function () {
            _this.setState({ isLoading: true });
            _this.props.actions.fetchQuestionnaireReport(_this.props.customer.id, _this.props.customerPolicy.id)
                .then(function () {
                var filename = _this.props.customerPolicy.statusId === __WEBPACK_IMPORTED_MODULE_12__common_utils__["h" /* PolicyStatus */].Inactive ? 'Application' : 'Policy';
                filename += _this.props.customerPolicy.number + "-QuestionnaireReport.csv";
                __WEBPACK_IMPORTED_MODULE_12__common_utils__["m" /* default */].downloadCsv(_this.props.questionnaireReport, filename, true);
                _this.setState({ isLoading: false });
            });
        };
        _this.canEdit = function () {
            return __WEBPACK_IMPORTED_MODULE_12__common_utils__["m" /* default */].isAuthorized(_this.props.currentUser.role, ["Admin" /* Administrator */]) &&
                _this.props.customerPolicy.statusId === __WEBPACK_IMPORTED_MODULE_12__common_utils__["h" /* PolicyStatus */].Active;
        };
        _this.canAdjudicate = function () {
            return _this.props.customerPolicy.isSoftDeclined &&
                _this.props.customerPolicy.adjudicationStatusId !== __WEBPACK_IMPORTED_MODULE_12__common_utils__["a" /* AdjudicationStatus */].Rejected;
        };
        _this.back = function () {
            if (!window.location.href.includes('prospects')) {
                return _this.props.history.push("/admin/customers/" + _this.props.match.params.customerId + "/policies");
            }
            else {
                return _this.props.history.push("/admin/prospects/" + _this.props.match.params.customerId + "/policies");
            }
        };
        _this.markAsInProcess = function () {
            var policy = __assign({}, _this.props.customerPolicy);
            policy.adjudicationStatusId = __WEBPACK_IMPORTED_MODULE_12__common_utils__["a" /* AdjudicationStatus */].InProcess;
            _this.props.actions.saveCustomerPolicy(policy)
                .then(function () {
                __WEBPACK_IMPORTED_MODULE_11_toastr__["success"]('Mark customer as in process');
            });
        };
        _this.openRejectPolicyModal = function () {
            _this.setState({ isRejectPolicyModalOpen: true });
        };
        _this.closeRejectPolicyModal = function () {
            _this.setState({ isRejectPolicyModalOpen: false });
        };
        _this.markAsDeclined = function (sendNotification) {
            var policy = __assign({}, _this.props.customerPolicy);
            policy.adjudicationStatusId = __WEBPACK_IMPORTED_MODULE_12__common_utils__["a" /* AdjudicationStatus */].Rejected;
            _this.props.actions.saveCustomerPolicy(policy)
                .then(function () {
                if (sendNotification) {
                    return _this.props.actions.sendSoftDeclinedEmail(_this.props.customer.id);
                }
                else {
                    return Promise.resolve();
                }
            })
                .then(function () {
                __WEBPACK_IMPORTED_MODULE_11_toastr__["success"]('Application has been declined');
                if (_this.props.redirectFromAdjudication) {
                    _this.props.history.push("/admin/adjudication");
                }
                else {
                    _this.props.history.push("/admin/customers");
                }
            });
        };
        _this.saveAndUpdatePaymentInfo = function () {
            if (_this.canAdjudicate()) {
                _this.setState({ isLoading: true });
                _this.props.actions.updateCustomerPlan(_this.props.customerPolicy, _this.state.overwriteRate)
                    .then(function () {
                    _this.setState({ isLoading: false });
                    _this.props.history.push("/admin/prospects/" + _this.props.match.params.customerId + "/" +
                        ("policies/" + _this.props.match.params.pageId + "/payment-update"));
                });
            }
        };
        _this.save = function () {
            if (_this.canEdit()) {
                _this.updateCustomerPlan();
            }
        };
        _this.updateCustomerPlan = function () {
            _this.setState({ isLoading: true });
            _this.props.actions.updateCustomerPlan(_this.props.customerPolicy, _this.state.overwriteRate).then(function () {
                _this.setState({ isLoading: false });
                __WEBPACK_IMPORTED_MODULE_11_toastr__["success"]('Policy updated!');
                if (!window.location.href.includes('prospects')) {
                    return _this.props.history.push("/admin/customers/" + _this.props.match.params.customerId + "/policies");
                }
                else {
                    return _this.props.history.push("/admin/prospects/" + _this.props.match.params.customerId + "/policies");
                }
            });
        };
        _this.cancelCustomerPlan = function () {
            if (window.confirm('Are you sure you want to cancel this policy?')) {
                _this.setState({ isLoading: true });
                _this.props.actions.deleteCustomerPolicy(_this.props.customer, _this.props.customerPolicy)
                    .then(function () {
                    _this.props.actions.sendCancelPolicyEmail(_this.props.customer.id, _this.props.customerPolicy.id);
                })
                    .then(function () {
                    _this.setState({ isLoading: false });
                    __WEBPACK_IMPORTED_MODULE_11_toastr__["success"]('Policy canceled!');
                    _this.props.history.push("/admin/customers/" + _this.props.match.params.customerId + "/policies");
                });
            }
        };
        _this.allDeclinedAnswerHasNotes = function () {
            var declinedAnswers = _this.props.answers.answerList.filter(function (a) { return a.isDeclined; });
            var count = 0;
            declinedAnswers.forEach(function (d) {
                if (_this.props.notes.some(function (n) { return n.answerId === d.id; })) {
                    count++;
                }
            });
            return count === declinedAnswers.length;
        };
        _this.updatePolicyPaperCopyStatus = function (policyId) {
            _this.setState({ isLoading: true });
            _this.props.actions.updatePolicyPaperCopyStatus(policyId)
                .then(function () { return _this.loadData(); })
                .then(function () { return _this.setState({ isLoading: false }); });
        };
        return _this;
    }
    PolicyDetails.prototype.componentDidMount = function () {
        this.loadData();
    };
    PolicyDetails.prototype.render = function () {
        var allowFormat = this.props.customerPolicy.statusId ? true : false;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: this.props.className },
            this.props.customerPolicy.statusId === __WEBPACK_IMPORTED_MODULE_12__common_utils__["h" /* PolicyStatus */].Inactive ?
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ApplicationDetailsForm__["a" /* default */], { application: this.props.customerPolicy, onPolicyChange: this.onPolicyChange, onOverwirteChange: this.onOverwirteChange, readOnly: !this.canAdjudicate(), isLoading: this.state.isLoading, overwriteRate: this.state.overwriteRate, isAdjudicator: __WEBPACK_IMPORTED_MODULE_12__common_utils__["m" /* default */].isAuthorized(this.props.currentUser.role, ["Adjudicator" /* Adjudicator */]) })
                :
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__PolicyDetailsForm__["a" /* default */], { customerPolicy: this.props.customerPolicy, onPolicyChange: this.onPolicyChange, onOverwriteChange: this.onOverwirteChange, downloadQuestionnaireReport: this.downloadQuestionnaireReport, readOnly: !this.canEdit(), isLoading: this.state.isLoading, overwriteRate: this.state.overwriteRate, updatePolicyPaperCopyStatus: this.updatePolicyPaperCopyStatus }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title mt-4 mb-0 border-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "faq-question-clickable" + (this.state.answerExpanded ? ' active' : ''), onClick: this.answerExpand },
                    this.state.answerExpanded ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_icons__["F" /* IconRemove */], null) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_icons__["k" /* IconAdd */], null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "faq-question-title" }, "Policy Questionnaire Answers"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_forms__["i" /* FormCheckConditional */], { className: "faq-question-answer", isOpen: this.state.answerExpanded },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__admin_customers_CustomerPolicyAnswersPage__["a" /* default */], { history: this.props.history, match: this.props.match, answers: this.props.answers, allowFormat: allowFormat })),
            this.props.customerPolicy.statusId === __WEBPACK_IMPORTED_MODULE_12__common_utils__["h" /* PolicyStatus */].Inactive ?
                (this.showAdjudicationControls(this.props.customerPolicy) &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options mt-4" },
                        this.props.customerPolicy.adjudicationStatusId &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_buttons__["a" /* Button */], { onClick: this.markAsInProcess, className: "btn-primary", disabled: this.state.isLoading ||
                                    this.props.customerPolicy.adjudicationStatusId === __WEBPACK_IMPORTED_MODULE_12__common_utils__["a" /* AdjudicationStatus */].InProcess ||
                                    this.props.customerPolicy.adjudicationStatusId === __WEBPACK_IMPORTED_MODULE_12__common_utils__["a" /* AdjudicationStatus */].Rejected },
                                "Set to 'In Process'",
                                this.state.isLoading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_common__["f" /* Spinner */], null)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ml-auto" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_buttons__["a" /* Button */], { onClick: this.saveAndUpdatePaymentInfo, className: "btn-secondary mr-2", disabled: this.state.isLoading || !this.allDeclinedAnswerHasNotes() },
                                "Activate Policy",
                                this.state.isLoading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_common__["f" /* Spinner */], null)),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_buttons__["a" /* Button */], { onClick: this.openRejectPolicyModal, className: "btn-primary", disabled: this.state.isLoading },
                                "Reject Policy",
                                this.state.isLoading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_common__["f" /* Spinner */], null))))) :
                (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options mt-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "btn-group table-filters" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-filter" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_buttons__["a" /* Button */], { onClick: this.save, className: "btn-primary", disabled: !this.canEdit() }, "Save"))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_buttons__["a" /* Button */], { className: "m-0 btn-outline-primary", onClick: this.cancelCustomerPlan, disabled: this.props.customerPolicy.statusId === __WEBPACK_IMPORTED_MODULE_12__common_utils__["h" /* PolicyStatus */].Canceled }, "Cancel policy"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__RejectPolicyModal__["a" /* default */], { isOpen: this.state.isRejectPolicyModalOpen, onRequestClose: this.closeRejectPolicyModal, markAsDeclined: this.markAsDeclined })));
    };
    PolicyDetails.prototype.showAdjudicationControls = function (customerPolicy) {
        return (!this.props.isHardDeclined.isDeclined || this.state.overwriteRate)
            && customerPolicy.adjudicationStatusId !== __WEBPACK_IMPORTED_MODULE_12__common_utils__["a" /* AdjudicationStatus */].Rejected;
    };
    return PolicyDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        customer: state.user.user,
        customerPolicy: state.policy.customerPolicy,
        questionnaireReport: state.policy.questionnaireReport,
        currentUser: state.auth.currentUser,
        answers: state.policy.answers,
        notes: state.user.notes,
        policies: state.policy.policies,
        isHardDeclined: state.policy.isHardDeclined,
        redirectFromAdjudication: state.policy.redirectFromAdjudication
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_14__policyActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__payment_paymentActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(PolicyDetails));


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(1);




var PolicyDetailsForm = function (props) {
    var isPremiumReadOnly = props.readOnly || !props.overwriteRate;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: props.className },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" },
                "Policy #: ",
                props.customerPolicy.number,
                " (",
                __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].getPickListItemDescription(props.customerPolicy.statusId),
                ")"),
            props.customerPolicy.receivePaperCopy &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_buttons__["a" /* Button */], { className: "btn-outline-secondary", disabled: props.customerPolicy.paperCopyMailed, onClick: function () { return props.updatePolicyPaperCopyStatus(props.customerPolicy.id); } }, !props.customerPolicy.paperCopyMailed ? 'Mark as paper copy mailed' : 'Paper copy mailed')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-top" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["f" /* DatePicker */], { labelText: "Start Date", name: "effectiveDate", onChange: props.onPolicyChange, value: props.customerPolicy.effectiveDate, className: "col-md-3", disabled: props.readOnly, error: __WEBPACK_IMPORTED_MODULE_3__common_utils__["k" /* Validation */].validateDate(props.customerPolicy.effectiveDate, 'YYYY-MM-DD', true) }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["f" /* DatePicker */], { labelText: "End Date", name: "endDate", onChange: props.onPolicyChange, value: props.customerPolicy.endDate, className: "col-md-3", disabled: true, error: __WEBPACK_IMPORTED_MODULE_3__common_utils__["k" /* Validation */].validateDate(props.customerPolicy.endDate, 'YYYY-MM-DD', true) }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Coverage Amount", name: "coverageAmount", pattern: "[0-9]*", onChange: props.onPolicyChange, value: props.readOnly ?
                        __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].formatCurrency(props.customerPolicy.coverageAmount, 0) : props.customerPolicy.coverageAmount, className: "col-md-4", disabled: props.readOnly })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Term", name: "term", pattern: "[0-9]*", onChange: props.onPolicyChange, value: props.customerPolicy.term, className: "col-md-3", disabled: props.readOnly, error: __WEBPACK_IMPORTED_MODULE_3__common_utils__["k" /* Validation */].validateTerm(props.customerPolicy.term) }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Premium Amount", name: "rate", pattern: "[0-9\.]*", onChange: props.onPolicyChange, value: isPremiumReadOnly ?
                        __WEBPACK_IMPORTED_MODULE_3__common_utils__["m" /* default */].formatCurrency(props.customerPolicy.rate) : props.customerPolicy.rate, className: "col-md-3", disabled: isPremiumReadOnly }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["b" /* Checkbox */], { label: "Overwrite Premium Rate", name: "overwriteRate", className: "col-md-3", onChange: props.onOverwriteChange, checked: props.overwriteRate, disabled: props.readOnly })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Code", name: "code", value: props.customerPolicy.campaignCode, className: "col-md-3", disabled: true })))));
};
/* harmony default export */ __webpack_exports__["a"] = (PolicyDetailsForm);


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(1);



var ApplicationDetailsForm = function (props) {
    var isPremiumReadOnly = props.readOnly || !props.overwriteRate;
    var softDeclinedHeader = props.application.isSoftDeclined ? ' - Soft Declined' : '';
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: props.className },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" },
                "Application #: ",
                props.application.number,
                " (",
                __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].getPickListItemDescription(props.application.statusId),
                ")",
                softDeclinedHeader,
                props.application.adjudicationStatusId && ' - ',
                __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].getPickListItemDescription(props.application.adjudicationStatusId))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-top" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["f" /* DatePicker */], { labelText: "Start Date", name: "effectiveDate", value: props.application.effectiveDate, className: "col-md-3", disabled: props.readOnly, onChange: props.onPolicyChange, error: __WEBPACK_IMPORTED_MODULE_2__common_utils__["k" /* Validation */].validateDate(props.application.effectiveDate, 'YYYY-MM-DD', true) }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["f" /* DatePicker */], { labelText: "End Date", name: "endDate", value: props.application.endDate, className: "col-md-3", disabled: true, onChange: props.onPolicyChange, error: __WEBPACK_IMPORTED_MODULE_2__common_utils__["k" /* Validation */].validateDate(props.application.endDate, 'YYYY-MM-DD', true) }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Coverage Amount", name: "coverageAmount", pattern: "[0-9]*", value: props.readOnly ?
                        __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatCurrency(props.application.coverageAmount, 0) : props.application.coverageAmount, className: "col-md-4", disabled: props.readOnly || props.isAdjudicator, onChange: props.onPolicyChange })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Term", name: "term", pattern: "[0-9]*", value: props.application.term, className: "col-md-3", disabled: props.readOnly || props.isAdjudicator, onChange: props.onPolicyChange, error: __WEBPACK_IMPORTED_MODULE_2__common_utils__["k" /* Validation */].validateTerm(props.application.term) }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Premium Amount", name: "rate", pattern: "[0-9\.]*", value: isPremiumReadOnly ?
                        __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].formatCurrency(props.application.rate) : props.application.rate, className: "col-md-3", disabled: isPremiumReadOnly, onChange: props.onPolicyChange }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["b" /* Checkbox */], { label: "Overwrite Premium Rate", name: "overwriteRate", className: "col-md-3", onChange: props.onOverwirteChange, checked: props.overwriteRate, disabled: props.readOnly })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Code", name: "code", value: props.application.campaignCode, className: "col-md-3", disabled: true })))));
};
/* harmony default export */ __webpack_exports__["a"] = (ApplicationDetailsForm);


/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CustomerPolicyAnswersDetails__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_PolicyAnswerModal__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









var CustomerPolicyAnswersPage = /** @class */ (function (_super) {
    __extends(CustomerPolicyAnswersPage, _super);
    function CustomerPolicyAnswersPage(props) {
        var _this = _super.call(this, props) || this;
        _this.loadData = function () {
            _this.props.actions.fetchCustomerNotes(_this.props.match.params.customerId);
        };
        _this.onRequestClose = function () {
            _this.setState({ isAnswerModalOpen: false });
        };
        _this.onRowClick = function (e, answerId) {
            e.stopPropagation();
            var clickedItem = _this.props.answers.answerList.find(function (a) { return a.id === answerId; });
            var note = _this.props.notes.find(function (n) { return n.answerId === answerId; });
            if (note) {
                _this.props.actions.setCustomerNote(note);
            }
            else {
                _this.props.actions.resetCustomerAnswerNote(_this.props.match.params.customerId, answerId);
            }
            _this.setState({ questionAnswerPair: clickedItem });
            _this.setState({ isAnswerModalOpen: true });
        };
        _this.onNoteChange = function (e) {
            var note = __assign({}, _this.props.note, (_a = {}, _a[e.target.name] = e.target.value, _a.customerId = _this.props.match.params.customerId, _a));
            _this.props.actions.setCustomerNote(note);
            var _a;
        };
        _this.onNoteSave = function () {
            var note = __assign({}, _this.props.note);
            if (note.notes === '') {
                __WEBPACK_IMPORTED_MODULE_5_toastr__["error"]('There\'s no content to save');
                return;
            }
            if (_this.props.match.params.customerId) {
                note.customerId = _this.props.match.params.customerId;
            }
            _this.setState({ isLoading: true });
            note.answerInfo = __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].getCategoryInfoByNoteAnswerId(note.answerId);
            _this.props.actions.saveCustomerNote(note)
                .then(function () {
                _this.loadData();
                _this.setState({ isAnswerModalOpen: false, isLoading: false });
            });
        };
        _this.state = {
            isLoading: false,
            isAnswerModalOpen: false,
            questionAnswerPair: {},
        };
        return _this;
    }
    CustomerPolicyAnswersPage.prototype.componentDidMount = function () {
        this.loadData();
    };
    CustomerPolicyAnswersPage.prototype.componentWillUnmount = function () {
        this.props.actions.resetCustomerPolicyAnswer();
    };
    CustomerPolicyAnswersPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__CustomerPolicyAnswersDetails__["a" /* default */], { history: this.props.history, answers: this.props.answers, isLoading: this.state.isLoading, onRowClick: this.onRowClick, questions: this.props.questions, allowFormat: this.props.allowFormat }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_PolicyAnswerModal__["a" /* default */], { isOpen: this.state.isAnswerModalOpen, onRequestClose: this.onRequestClose, declinedQuestionNames: this.props.answers.declinedQuesitonNames, questionAnswerPair: this.state.questionAnswerPair, questionAnswerPairNote: this.props.note, questions: this.props.questions, onNoteChange: this.onNoteChange, onNoteSave: this.onNoteSave, allowFormat: this.props.allowFormat })));
    };
    return CustomerPolicyAnswersPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        notes: state.user.notes,
        note: state.user.note,
        questions: state.question.questions
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_6__policy_policyActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CustomerPolicyAnswersPage));


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_icons__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};





var CustomerPolicyAnswersDetails = /** @class */ (function (_super) {
    __extends(CustomerPolicyAnswersDetails, _super);
    function CustomerPolicyAnswersDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.questionTextFormatter = function (categoryId, subCategoryId, questionText) {
            if (categoryId !== 12) {
                return categoryId + '.' + subCategoryId + ' ' + questionText;
            }
            else {
                switch (subCategoryId) {
                    case 1:
                        return categoryId + '.' + subCategoryId + ' History of cancer';
                    case 2:
                        return categoryId + '.' + subCategoryId + ' History of heart and circulatory system disorders';
                    case 3:
                        return categoryId + '.' + subCategoryId + ' History of neurological disorders';
                    case 4:
                        return categoryId + '.' + subCategoryId + ' History of respiratory Disorders';
                    case 5:
                        return categoryId + '.' + subCategoryId + ' History of liver, stomach, bladder, kidney, or gastrointestinal disorders';
                    case 6:
                        return categoryId + '.' + subCategoryId + ' History of blood, glandular or endocrine system disorders';
                    case 7:
                        return categoryId + '.' + subCategoryId + ' History of immunological disorders';
                    case 8:
                        return categoryId + '.' + subCategoryId + ' History of head injury or musculoskeletal system disorders';
                    case 9:
                        return categoryId + '.' + subCategoryId + ' History of reproductive system disorders';
                    case 13:
                        return categoryId + '.' + subCategoryId + ' History of psychological Disorders';
                    default:
                        return categoryId + '.' + subCategoryId + ' ' + questionText;
                }
            }
        };
        _this.answerFormatter = function (questionName, answer) {
            switch (questionName) {
                case 'activities':
                case 'abroad':
                case 'ownPetsTypes':
                case 'cancer':
                case 'heartCirculatory':
                case 'neurological':
                case 'respiratory':
                case 'liver':
                case 'blood':
                case 'immuno':
                case 'head':
                case 'reproductive':
                case 'psychological':
                case 'favoriteActivities':
                    return _this.formatObjectAnswer(answer, questionName);
                case 'specificJob':
                    switch (answer) {
                        case 'offshoreFisher':
                            return 'Offshore commercial fisher not coming ashore daily';
                        case 'steelErector':
                            return 'Steel erector or scaffolder working at heights over 40 feet</dd>';
                        case 'fallerOrLumberjack':
                            return 'Faller or lumberjack';
                        case 'offshoreDriller':
                            return 'Offshore driller';
                        case 'blaster':
                            return 'Blaster or explosive handler';
                        case 'occupationNoneOfTheAbove':
                            return 'None of listing selections';
                        default:
                            return;
                    }
                case 'reasonForUnemployment':
                    switch (answer) {
                        case 'parent':
                            return 'Parent or caregiver';
                        case 'disabledOrMedicalLeave':
                            return 'On disability or medical leave';
                        case 'socialAssistance':
                            return 'Social assistance';
                        case 'cannotFindWork':
                            return 'Cannot find work';
                        case 'retired':
                            return 'Retired';
                        case 'other':
                            return 'Other reason';
                        default:
                            return;
                    }
                case 'exerciseFrequentlyHours':
                    switch (answer) {
                        case '0':
                            return 'I rarely excercise';
                        case '0-1':
                            return 'Less than 1 hour';
                        case '1-2':
                            return '1-2 hours';
                        case '2-3':
                            return '2-3 hours';
                        case '3-4':
                            return '3-4 hours';
                        case '4-5':
                            return '4-5 hours';
                        case '5-6':
                            return '5-6 hours';
                        case '6-7':
                            return '6-7 hours';
                        case '7+':
                            return 'More than 7 hours';
                        default:
                            return;
                    }
                case 'usedTobaccoLastUsed':
                    switch (answer) {
                        case 'withinThePastMonth':
                            return 'Within the past month';
                        case 'withinThePast6Months':
                            return '1-6 months ago';
                        case 'withinThePast12Months':
                            return '6-12 months ago';
                        case 'withinThePast24Months':
                            return '12-24 months ago';
                        default:
                            return;
                    }
                default:
                    return _this.formatPlainTextAnswer(answer, questionName);
            }
        };
        _this.formatPlainTextAnswer = function (answer, questionName) {
            if (questionName === 'consumedAlcohol' && answer !== 'false') {
                return answer;
            }
            if (typeof answer === 'string') {
                var splitExpression = new RegExp('(^|\s)(?=[A-Z])');
                var formattedAnswer = answer.split(splitExpression).join(' ');
                return formattedAnswer.charAt(0).toUpperCase() + formattedAnswer.slice(1);
            }
            return answer;
        };
        // Note that formatObjectAnswer here is different from the one in PolicyAnswerModal,
        // since the answerValue passed from table row is ALWAYS string type
        _this.formatObjectAnswer = function (answer, questionName) {
            var answerObj = JSON.parse(answer);
            var answerString = '';
            switch (questionName) {
                case 'favoriteActivities':
                    answerObj.forEach(function (item) {
                        answerString += item + ';';
                    });
                    break;
                case 'abroad':
                    if (answer === 'false') {
                        answerString = 'None';
                    }
                    else {
                        answerObj.forEach(function (subObject) {
                            answerString += subObject.abroadLocation + ': ' + _this.formatAbroadDuration(subObject.abroadDuration);
                        });
                    }
                    break;
                default:
                    (Object.keys(answerObj)).forEach(function (key) {
                        if (key.includes('isValid')) {
                            return;
                        }
                        else if (key.includes('None')) {
                            if (answerObj[key] === true) {
                                answerString = 'None';
                                return;
                            }
                        }
                        else {
                            if (answerObj[key] === false) {
                                return;
                            }
                            answerString += _this.getQuestionTextByName(key, answerObj[key], answerObj) + ''
                                + ((typeof (answerObj[key]) !== 'boolean' && !_this.isMedicalOtherDetails(key)) ? answerObj[key] : '') +
                                (!_this.isMedicalOtherDetails(key) ? ';' : '');
                        }
                    });
                    break;
            }
            if (answerString[answerString.length - 1] === ';') {
                answerString = answerString.substring(0, answerString.length - 1);
            }
            return answerString;
        };
        _this.formatAbroadDuration = function (abroadDuration) {
            switch (abroadDuration) {
                case '0-4':
                    return 'Less than 4 weeks;';
                case '4-12':
                    return '4-12 weeks;';
                case '13-26':
                    return '13-26 weeks;';
                case '26+':
                    return 'More than 26 weeks;';
                default:
                    return;
            }
        };
        _this.isMedicalOtherDetails = function (questionName) {
            if (questionName === 'cancerOtherDetails' || questionName === 'heartDisorderOtherDetails' ||
                questionName === 'neurologicalDisorderOtherDetails' || questionName === 'respiratoryDisorderOtherDetails' ||
                questionName === 'gastrointestinalDisorderOtherDetails' || questionName === 'endocrineDisorderOtherDetails' ||
                questionName === 'immuneSystemDisorderOtherDetails' || questionName === 'musculoskeletalDisorderOtherDetails' ||
                questionName === 'reproductiveDisorderOtherDetails' || questionName === 'psychologicalDisorderOtherDetails') {
                return true;
            }
            return false;
        };
        _this.getQuestionTextByName = function (questionName, answerValue, answerObject) {
            var regex = /<.*?>/gi;
            var otherDetails = '';
            // the cancer one is actually a bug, better to fix it when we decide to change the way how we save answer into DB
            if (_this.props.questions[questionName] === undefined || questionName === 'cancer') {
                // handle all hard-coded question text here
                switch (questionName) {
                    // aviation
                    case 'heliSkiSnowboarding':
                        return 'Heli-skiing or snowboarding';
                    case 'outOfBoundsSkiingSnowboarding':
                        return 'Out-of-bounds or backcountry skiing or snowboarding';
                    case 'backCountrySnowMobiling':
                        return 'Backcountry snowmobiling';
                    case 'skydiving':
                        return 'Skydiving';
                    case 'wingsuitFlying':
                        return 'Wingsuit flying';
                    case 'parachuting':
                        return 'Parachuting';
                    case 'skysurfing':
                        return 'Skysurfing';
                    case 'canopyPiloting':
                        return 'Canopy piloting';
                    // pets
                    case 'dogs':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        return 'Dog(s)';
                    case 'cats':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        return 'Cat(s)';
                    case 'others':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        return 'Other(s)';
                    // cancer
                    case 'cancer':
                        return 'Any cancer or tumor except for basal cell carcinoma';
                    case 'tumor':
                        return 'Any tumor or growth not yet diagnosed';
                    case 'dysplasticNeviSyndrome':
                        return 'Dysplastic nevi syndrome';
                    case 'cancerOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'cancerOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // heart & circulatory
                    case 'elevatedCholesterol':
                        return 'Elevated cholesterol or high blood pressure uncontrolled within the past 12 months';
                    case 'chestPain':
                        return 'Chest pain or angina';
                    case 'shortnessOfBreath':
                        return 'Shortness of breath';
                    case 'heartAttack':
                        return 'Heart attack (myocardial infarction)';
                    case 'coronaryArteryDisease':
                        return 'Coronary artery disease or carotid artery disease';
                    case 'aneurysm':
                        return 'Aneurysm';
                    case 'valvularHeartDisease':
                        return 'Valvular heart disease (e.g., mitral valve prolapse)';
                    case 'cardiomyopathy':
                        return 'Cardiomyopathy';
                    case 'congestiveHeartFailure':
                        return 'Congestive heart failure';
                    case 'bypassOrAngioplasty':
                        return 'Bypass surgery or angioplasty';
                    case 'abnormalECG':
                        return 'Abnormal ECG, cardiac stress test, or echocardiogram';
                    case 'irregularPulse':
                        return 'Irregular pulse';
                    case 'heartMurmur':
                        return 'Heart murmur';
                    case 'pacemaker':
                        return 'Pacemaker';
                    case 'peripheralVascularDisease':
                        return 'Peripheral vascular disease';
                    case 'bloodClot':
                        return 'Blood clot, embolism or clotting disorder';
                    case 'heartDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'heartDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // neurological
                    case 'epilepsy':
                        return 'Epilepsy or seizures with any episodes within the past 12 months';
                    case 'tremor':
                        return 'Tremor';
                    case 'huntingtonsDisease':
                        return "Huntington's disease";
                    case 'brainAneurysm':
                        return 'Brain aneurysm';
                    case 'tia':
                        return 'Transient ischemic attack (TIA)';
                    case 'stroke':
                        return 'Stroke';
                    case 'parkinsonsDisease':
                        return "Parkinson's disease";
                    case 'als':
                        return "Motor neuron disease (Lou Gehrig's disease or ALS)";
                    case 'alzheimersDisease':
                        return "Alzheimer's disease";
                    case 'cognitiveImpairment':
                        return 'Cognitive impairment';
                    case 'dementia':
                        return 'Dementia';
                    case 'multipleSclerosis':
                        return 'Multiple sclerosis';
                    case 'muscularDystrophy':
                        return 'Muscular dystrophy';
                    case 'lossOfBalance':
                        return 'Loss of balance';
                    case 'lossOfSpeech':
                        return 'Loss of speech';
                    case 'cerebralPalsy':
                        return 'Cerebral palsy';
                    case 'downSyndrome':
                        return 'Down syndrome';
                    case 'autism':
                        return 'Autism';
                    case 'developmentalDisorder':
                        return 'Developmental disorder';
                    case 'muscleWeakness':
                        return 'Muscle weakness, tingling, or numbness of the extremities';
                    case 'neurologicalDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'neurologicalDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // respiratory
                    case 'sleepApnea':
                        return 'Sleep apnea for which you are not treated';
                    case 'emphysema':
                        return 'Emphysema';
                    case 'tuberculosis':
                        return 'Tuberculosis';
                    case 'sarcoidosis':
                        return 'Sarcoidosis';
                    case 'cysticFibrosis':
                        return 'Cystic fibrosis';
                    case 'asthma':
                        return "Asthma requiring either a visit to the emergency room\n\t\t\t\t\tor the administration of oxygen within the past 12 months";
                    case 'copd':
                        return 'Chronic obstructive pulmonary disease (COPD)';
                    case 'respiratoryDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'respiratoryDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // liver
                    case 'hepatitisBorC':
                        return 'Hepatitis B or C';
                    case 'cirrhosis':
                        return 'Cirrhosis';
                    case 'sclerosingCholangitis':
                        return 'Sclerosing cholangitis';
                    case 'crohnsDisease':
                        return "Crohn\u2019s disease or ulcerative colitis with any flare-up within\n\t\t\t\t\tthe past 5 years or any continued use of oral steroid";
                    case 'bleedingRectum':
                        return 'Rectal bleeding other than diagnosed as hemorrhoids';
                    case 'pancreatitis':
                        return 'Pancreatitis';
                    case 'chronicKidneyDisease':
                        return 'Chronic kidney disease or nephritis';
                    case 'bloodInUrine':
                        return 'Blood or protein in urine';
                    case 'gastrointestinalDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'gastrointestinalDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // blood
                    case 'diabetes':
                        return 'Diabetes';
                    case 'goiter':
                        return 'Goiter or thyroid disorder other than hypothyroidism';
                    case 'anemia':
                        return 'Anemia';
                    case 'bleedingDisorder':
                        return 'Bleeding disorder';
                    case 'hemophilia':
                        return 'Hemophilia';
                    case 'sicklecell':
                        return 'Sickle cell anemia';
                    case 'thalassemia':
                        return 'Thalassemia';
                    case 'endocrineDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'endocrineDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // immuno
                    case 'aids':
                        return 'Acquired immune deficiency syndrome (AIDS)';
                    case 'arc':
                        return 'AIDS related complex (ARC)';
                    case 'hiv':
                        return 'Human immunodeficiency virus (HIV)';
                    case 'immuneSystemDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'immuneSystemDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // head
                    case 'brainInjury':
                        return 'Traumatic brain injury or post-concussion syndrome with ongoing symptoms';
                    case 'rheumatoidArthritis':
                        return 'Rheumatoid arthritis';
                    case 'ankylosingSpondylitis':
                        return 'Ankylosing spondylitis';
                    case 'connectiveTissueDisease':
                        return 'Connective tissue disease';
                    case 'lupus':
                        return 'Lupus';
                    case 'paralysis':
                        return 'Paralysis';
                    case 'musculoskeletalDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'musculoskeletalDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // reproductive
                    case 'abnormalMammogram':
                        return 'Abnormal mammogram or breast imaging';
                    case 'breastImagingTestOrPAPTest':
                        return 'Abnormal PAP test';
                    case 'abnormalPSATest':
                        return 'Abnormal prostate (PSA) test';
                    case 'abnormalBiopsy':
                        return 'Abnormal biopsy';
                    case 'reproductiveDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'reproductiveDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // psychological
                    case 'bipolarDisease':
                        return 'Bipolar disease';
                    case 'psychosis':
                        return 'Psychosis or any psychotic episode';
                    case 'contemplatedSuicide':
                        return 'Any contemplated or attempted suicide';
                    case 'psychologicalDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'psychologicalDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    default:
                        return ''; // needs to return empty string here otherwise it shows undefined in table row
                }
            }
            return _this.props.questions[questionName].replace(regex, '');
        };
        return _this;
    }
    CustomerPolicyAnswersDetails.prototype.render = function () {
        var _this = this;
        var props = __rest(this.props, []);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                    {
                        Header: 'Question',
                        accessor: 'questionValue',
                        Cell: function (rowInfo) {
                            return _this.questionTextFormatter(rowInfo.original.categoryId, rowInfo.original.subCategoryId, rowInfo.value);
                        }
                    },
                    {
                        Header: 'Answer',
                        accessor: 'answer',
                        Cell: function (rowInfo) {
                            return props.allowFormat ? _this.answerFormatter(rowInfo.original.questionName, rowInfo.original.answer) : rowInfo.value;
                        }
                    },
                    {
                        Header: 'Notes',
                        accessor: 'id',
                        className: 'p-0 td-actions',
                        width: 100,
                        Cell: function (rowInfo) {
                            return (__WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].verifyAnswerHasNotes(rowInfo.value) &&
                                (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons__["b" /* IconButton */], { title: "Edit note", className: "btn-icon-secondary btn-icon-td" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_icons__["x" /* IconEdit */], null))));
                        }
                    }
                ], data: props.answers.answerList, loading: props.isLoading, getTrProps: function (state, rowInfo, column) {
                    if (rowInfo && rowInfo.row) {
                        return {
                            className: rowInfo.original.isDeclined ? 'tr interactive border border-danger' : 'tr interactive',
                            onClick: function (e) { return props.onRowClick(e, rowInfo.original.id); }
                        };
                    }
                    else {
                        return {
                            className: 'tr interactive',
                            onClick: function (e) { return props.onRowClick(e, rowInfo.original.id); }
                        };
                    }
                }, noDataText: "No answers found", defaultPageSize: 100 })));
    };
    return CustomerPolicyAnswersDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CustomerPolicyAnswersDetails);


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JsonAnswerDetails__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customers_QASubComponents_ActivitiesQuestionAnswer__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__customers_QASubComponents_ReproductiveQuestionAnswer__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var ANIM_DURATION = 300;
var PolicyAnswerModal = /** @class */ (function (_super) {
    __extends(PolicyAnswerModal, _super);
    function PolicyAnswerModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onAfterClose = function () {
            __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].enableBodyScrolling();
        };
        _this.renderComponentByQuestionName = function (questionAnswerPair) {
            if (_this.props.allowFormat === false) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, questionAnswerPair.answer));
            }
            var questionName = questionAnswerPair.questionName;
            var answer = questionAnswerPair.answer;
            switch (questionName) {
                case 'activities':
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__customers_QASubComponents_ActivitiesQuestionAnswer__["a" /* default */], { answer: answer, declinedQuestionNames: _this.props.declinedQuestionNames, questions: _this.props.questions }));
                case 'abroad':
                case 'ownPetsTypes':
                case 'cancer':
                case 'heartCirculatory':
                case 'neurological':
                case 'respiratory':
                case 'liver':
                case 'blood':
                case 'immuno':
                case 'head':
                case 'psychological':
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__JsonAnswerDetails__["a" /* default */], { answer: answer, questionName: questionName, declinedQuestionNames: _this.props.declinedQuestionNames }));
                case 'reproductive':
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__customers_QASubComponents_ReproductiveQuestionAnswer__["a" /* default */], { answer: answer, declinedQuestionNames: _this.props.declinedQuestionNames, questions: _this.props.questions }));
                case 'favoriteActivities':
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "mb-0" }, JSON.parse(questionAnswerPair.answer).map(function (item, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: index }, item));
                    })));
                // code below is for fixing the inconsistency between value on UI with value saved in DB
                case 'specificJob':
                    switch (answer) {
                        case 'offshoreFisher':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Offshore commercial fisher not coming ashore daily"));
                        case 'steelErector':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Steel erector or scaffolder working at heights over 40 feet"));
                        case 'fallerOrLumberjack':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Faller or lumberjack"));
                        case 'offshoreDriller':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Offshore driller"));
                        case 'blaster':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Blaster or explosive handler"));
                        case 'occupationNoneOfTheAbove':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "None of listing selections"));
                        default:
                            return;
                    }
                case 'reasonForUnemployment':
                    switch (answer) {
                        case 'parent':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Parent or caregiver"));
                        case 'disabledOrMedicalLeave':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "On disability or medical leave"));
                        case 'socialAssistance':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Social assistance"));
                        case 'cannotFindWork':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Cannot find work"));
                        case 'retired':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Retired"));
                        case 'other':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Other reason"));
                        default:
                            return;
                    }
                case 'exerciseFrequentlyHours':
                    switch (answer) {
                        case '0':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "I rarely excercise"));
                        case '0-1':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Less than 1 hour"));
                        case '1-2':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "1-2 hours"));
                        case '2-3':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "2-3 hours"));
                        case '3-4':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "3-4 hours"));
                        case '4-5':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "4-5 hours"));
                        case '5-6':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "5-6 hours"));
                        case '6-7':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "6-7 hours"));
                        case '7+':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "More than 7 hours"));
                        default:
                            return;
                    }
                case 'usedTobaccoLastUsed':
                    switch (answer) {
                        case 'withinThePastMonth':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Within the past month"));
                        case 'withinThePast6Months':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "1-6 months ago"));
                        case 'withinThePast12Months':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "6-12 months ago"));
                        case 'withinThePast24Months':
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "12-24 months ago"));
                        default:
                            return;
                    }
                default:
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, _this.formatAnswer(answer, questionName)));
            }
        };
        _this.formatAnswer = function (answer, questionName) {
            if (questionName === 'consumedAlcohol' && answer !== 'false') {
                return answer;
            }
            if (typeof answer === 'string') {
                var splitExpression = new RegExp('(^|\s)(?=[A-Z])');
                var formattedAnswer = answer.split(splitExpression).join(' ');
                return formattedAnswer.charAt(0).toUpperCase() + formattedAnswer.slice(1);
            }
            return answer;
        };
        // http://reactcommunity.org/react-modal/accessibility/#app-element
        __WEBPACK_IMPORTED_MODULE_1_react_modal__["setAppElement"]('#root');
        return _this;
    }
    PolicyAnswerModal.prototype.componentDidMount = function () {
        if (this.props.isOpen) {
            __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].disableBodyScrolling({ allBreakpoints: true });
        }
    };
    PolicyAnswerModal.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isOpen !== this.props.isOpen) {
            if (this.props.isOpen) {
                __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].disableBodyScrolling({ allBreakpoints: true });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].enableBodyScrolling();
            }
        }
    };
    PolicyAnswerModal.prototype.componentWillUnmount = function () {
        __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].enableBodyScrolling();
    };
    PolicyAnswerModal.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_modal__, { className: "ReactModal_Content section section-main" // Redefine className to remove inline styles
            , closeTimeoutMS: ANIM_DURATION, contentLabel: "TODO", isOpen: this.props.isOpen, overlayClassName: "ReactModal_Overlay" // Redefine className to remove inline styles
            , portalClassName: "ReactModal" // Redefine className to remove inline styles
            , shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true, onRequestClose: this.props.onRequestClose },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "mb-3" },
                "Question ",
                this.props.questionAnswerPair.categoryId,
                ".",
                this.props.questionAnswerPair.subCategoryId),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dl", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Question:"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, this.props.questionAnswerPair.questionValue),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Answer:"),
                this.renderComponentByQuestionName(this.props.questionAnswerPair)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["m" /* TextArea */], { labelText: "Notes", name: "notes", value: this.props.questionAnswerPairNote.notes, onChange: this.props.onNoteChange }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-flex justify-content-end" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons_Button__["a" /* default */], { className: "btn-secondary", onClick: this.props.onNoteSave }, "Save Notes"))));
    };
    return PolicyAnswerModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PolicyAnswerModal);


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var JsonAnswerDetails = /** @class */ (function (_super) {
    __extends(JsonAnswerDetails, _super);
    function JsonAnswerDetails(props) {
        var _this = _super.call(this, props) || this;
        _this.formatAbroadDuration = function (abroadDuration) {
            switch (abroadDuration) {
                case '0-4':
                    return 'Less than 4 weeks';
                case '4-12':
                    return '4-12 weeks';
                case '13-26':
                    return '13-26 weeks';
                case '26+':
                    return 'More than 26 weeks';
                default:
                    return;
            }
        };
        _this.isMedicalOtherDetails = function (questionName) {
            if (questionName === 'cancerOtherDetails' || questionName === 'heartDisorderOtherDetails' ||
                questionName === 'neurologicalDisorderOtherDetails' || questionName === 'respiratoryDisorderOtherDetails' ||
                questionName === 'gastrointestinalDisorderOtherDetails' || questionName === 'endocrineDisorderOtherDetails' ||
                questionName === 'immuneSystemDisorderOtherDetails' || questionName === 'musculoskeletalDisorderOtherDetails' ||
                questionName === 'reproductiveDisorderOtherDetails' || questionName === 'psychologicalDisorderOtherDetails') {
                return true;
            }
            return false;
        };
        _this.getQuestionTextByName = function (questionName, answerValue, answerObject) {
            var regex = /<.*?>/gi;
            var otherDetails = '';
            // the cancer one is actually a bug, better to fix it when we decide to change the way how we save answer into DB
            if (_this.props.questions[questionName] === undefined || questionName === 'cancer') {
                // handle all hard-coded question text here
                switch (questionName) {
                    // pets
                    case 'dogs':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        return 'Dog(s)';
                    case 'cats':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        return 'Cat(s)';
                    case 'others':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        return 'Other(s)';
                    // cancer
                    case 'cancer':
                        return 'Any cancer or tumor except for basal cell carcinoma';
                    case 'tumor':
                        return 'Any tumor or growth not yet diagnosed';
                    case 'dysplasticNeviSyndrome':
                        return 'Dysplastic nevi syndrome';
                    case 'cancerOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'cancerOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // heart & circulatory
                    case 'elevatedCholesterol':
                        return 'Elevated cholesterol or high blood pressure uncontrolled within the past 12 months';
                    case 'chestPain':
                        return 'Chest pain or angina';
                    case 'shortnessOfBreath':
                        return 'Shortness of breath';
                    case 'heartAttack':
                        return 'Heart attack (myocardial infarction)';
                    case 'coronaryArteryDisease':
                        return 'Coronary artery disease or carotid artery disease';
                    case 'aneurysm':
                        return 'Aneurysm';
                    case 'valvularHeartDisease':
                        return 'Valvular heart disease (e.g., mitral valve prolapse)';
                    case 'cardiomyopathy':
                        return 'Cardiomyopathy';
                    case 'congestiveHeartFailure':
                        return 'Congestive heart failure';
                    case 'bypassOrAngioplasty':
                        return 'Bypass surgery or angioplasty';
                    case 'abnormalECG':
                        return 'Abnormal ECG, cardiac stress test, or echocardiogram';
                    case 'irregularPulse':
                        return 'Irregular pulse';
                    case 'heartMurmur':
                        return 'Heart murmur';
                    case 'pacemaker':
                        return 'Pacemaker';
                    case 'peripheralVascularDisease':
                        return 'Peripheral vascular disease';
                    case 'bloodClot':
                        return 'Blood clot, embolism or clotting disorder';
                    case 'heartDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'heartDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // neurological
                    case 'epilepsy':
                        return 'Epilepsy or seizures with any episodes within the past 12 months';
                    case 'tremor':
                        return 'Tremor';
                    case 'huntingtonsDisease':
                        return "Huntington's disease";
                    case 'brainAneurysm':
                        return 'Brain aneurysm';
                    case 'tia':
                        return 'Transient ischemic attack (TIA)';
                    case 'stroke':
                        return 'Stroke';
                    case 'parkinsonsDisease':
                        return "Parkinson's disease";
                    case 'als':
                        return "Motor neuron disease (Lou Gehrig's disease or ALS)";
                    case 'alzheimersDisease':
                        return "Alzheimer's disease";
                    case 'cognitiveImpairment':
                        return 'Cognitive impairment';
                    case 'dementia':
                        return 'Dementia';
                    case 'multipleSclerosis':
                        return 'Multiple sclerosis';
                    case 'muscularDystrophy':
                        return 'Muscular dystrophy';
                    case 'lossOfBalance':
                        return 'Loss of balance';
                    case 'lossOfSpeech':
                        return 'Loss of speech';
                    case 'cerebralPalsy':
                        return 'Cerebral palsy';
                    case 'downSyndrome':
                        return 'Down syndrome';
                    case 'autism':
                        return 'Autism';
                    case 'developmentalDisorder':
                        return 'Developmental disorder';
                    case 'muscleWeakness':
                        return 'Muscle weakness, tingling, or numbness of the extremities';
                    case 'neurologicalDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'neurologicalDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // respiratory
                    case 'sleepApnea':
                        return 'Sleep apnea for which you are not treated';
                    case 'emphysema':
                        return 'Emphysema';
                    case 'tuberculosis':
                        return 'Tuberculosis';
                    case 'sarcoidosis':
                        return 'Sarcoidosis';
                    case 'cysticFibrosis':
                        return 'Cystic fibrosis';
                    case 'asthma':
                        return "Asthma requiring either a visit to the emergency room\n\t\t\t\t\tor the administration of oxygen within the past 12 months";
                    case 'copd':
                        return 'Chronic obstructive pulmonary disease (COPD)';
                    case 'respiratoryDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'respiratoryDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // liver
                    case 'hepatitisBorC':
                        return 'Hepatitis B or C';
                    case 'cirrhosis':
                        return 'Cirrhosis';
                    case 'sclerosingCholangitis':
                        return 'Sclerosing cholangitis';
                    case 'crohnsDisease':
                        return "Crohn\u2019s disease or ulcerative colitis with any flare-up within\n\t\t\t\t\tthe past 5 years or any continued use of oral steroid";
                    case 'bleedingRectum':
                        return 'Rectal bleeding other than diagnosed as hemorrhoids';
                    case 'pancreatitis':
                        return 'Pancreatitis';
                    case 'chronicKidneyDisease':
                        return 'Chronic kidney disease or nephritis';
                    case 'bloodInUrine':
                        return 'Blood or protein in urine';
                    case 'gastrointestinalDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'gastrointestinalDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // blood
                    case 'diabetes':
                        return 'Diabetes';
                    case 'goiter':
                        return 'Goiter or thyroid disorder other than hypothyroidism';
                    case 'anemia':
                        return 'Anemia';
                    case 'bleedingDisorder':
                        return 'Bleeding disorder';
                    case 'hemophilia':
                        return 'Hemophilia';
                    case 'sicklecell':
                        return 'Sickle cell anemia';
                    case 'thalassemia':
                        return 'Thalassemia';
                    case 'endocrineDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'endocrineDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // immuno
                    case 'aids':
                        return 'Acquired immune deficiency syndrome (AIDS)';
                    case 'arc':
                        return 'AIDS related complex (ARC)';
                    case 'hiv':
                        return 'Human immunodeficiency virus (HIV)';
                    case 'immuneSystemDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'immuneSystemDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // head
                    case 'brainInjury':
                        return 'Traumatic brain injury or post-concussion syndrome with ongoing symptoms';
                    case 'rheumatoidArthritis':
                        return 'Rheumatoid arthritis';
                    case 'ankylosingSpondylitis':
                        return 'Ankylosing spondylitis';
                    case 'connectiveTissueDisease':
                        return 'Connective tissue disease';
                    case 'lupus':
                        return 'Lupus';
                    case 'paralysis':
                        return 'Paralysis';
                    case 'musculoskeletalDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'musculoskeletalDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    // psychological
                    case 'bipolarDisease':
                        return 'Bipolar disease';
                    case 'psychosis':
                        return 'Psychosis or any psychotic episode';
                    case 'contemplatedSuicide':
                        return 'Any contemplated or attempted suicide';
                    case 'psychologicalDisorderOther':
                        if (typeof answerValue === 'boolean' && answerValue === false) {
                            return;
                        }
                        otherDetails = 'psychologicalDisorderOtherDetails';
                        return 'Other(' + answerObject[otherDetails] + ')';
                    default:
                        return;
                }
            }
            return _this.props.questions[questionName].replace(regex, '');
        };
        return _this;
    }
    JsonAnswerDetails.prototype.render = function () {
        var _this = this;
        var answerObject = JSON.parse(this.props.answer);
        return this.props.questionName === 'abroad' ?
            (answerObject !== false ? (answerObject.map(function (subObject, index) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { key: index, className: "mb-0" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null,
                            subObject.abroadLocation,
                            " - "),
                        _this.formatAbroadDuration(subObject.abroadDuration))));
            })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "em" }, "None"))) :
            (Object.keys(answerObject).map(function (key) {
                return (!key.includes('isValid') &&
                    (!key.includes('None') ?
                        (answerObject[key] !== false && !_this.isMedicalOtherDetails(key) &&
                            (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { key: key, className: "mb-0" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, _this.getQuestionTextByName(key, answerObject[key], answerObject)),
                                typeof answerObject[key] !== 'boolean' &&
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, typeof answerObject[key] !== 'boolean' && !_this.isMedicalOtherDetails(key) && answerObject[key])))) :
                        (answerObject[key] === true &&
                            (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: key }, "None")))));
            }));
    };
    return JsonAnswerDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        questions: state.question.questions
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(JsonAnswerDetails));


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ActivitiesQuestionAnswer = function (props) {
    var activitiesAnswer = JSON.parse(props.answer);
    var keyOfNone = 'activitiesNoneOfTheAbove';
    var noneActivity = activitiesAnswer[keyOfNone] === true;
    var aviation = 'aviation';
    var aviationLicense = 'aviationLicense';
    var aviationInstrumentRating = 'aviationInstrumentRating';
    var aviationHoursExperience = 'aviationHoursExperience';
    var aviationHoursAnnually = 'aviationHoursAnnually';
    var aviationAccidents = 'aviationAccidents';
    var hangGliding = 'hangGliding';
    var hangGlidingStunt = 'hangGlidingStunt';
    var ultralightFlying = 'ultralightFlying';
    var ultralightFlyingStunts = 'ultralightFlyingStunts';
    var scubaDiving = 'scubaDiving';
    var backcountrySkiing = 'backcountrySkiing';
    var heliSkiSnowboarding = 'heliSkiSnowboarding';
    var outOfBoundsSkiingSnowboarding = 'outOfBoundsSkiingSnowboarding';
    var backCountrySnowMobiling = 'backCountrySnowMobiling';
    var mountainClimbing = 'mountainClimbing';
    var mountainClimbingTall = 'mountainClimbingTall';
    var skydivingActivities = 'skydivingActivities';
    var skydiving = 'skydiving';
    var skydivingOneTime = 'skydivingOneTime';
    var wingsuitFlying = 'wingsuitFlying';
    var parachuting = 'parachuting';
    var parachutingOneTime = 'parachutingOneTime';
    var skysurfing = 'skysurfing';
    var canopyPiloting = 'canopyPiloting';
    var skydivingExtreme = 'skydivingExtreme';
    var motorizedRacing = 'motorizedRacing';
    var bungeeJumping = 'bungeeJumping';
    var bungeeJumpingOneTime = 'bungeeJumpingOneTime';
    var fightSports = 'fightSports';
    var causeDecline = function (questionName) {
        return props.declinedQuestionNames.some(function (d) { return d === questionName; });
    };
    // tslint:disable
    return noneActivity ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, "None")) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-2" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dl", null,
            activitiesAnswer[aviation] &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "font-weight-bold" }, "Private recreational or non-scheduled commercial aircraft aviation"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "border border-success" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(aviationLicense) ? "p-3 border border-danger border-top-overlap border-right-overlap border-left-overlap" : "border-bottom p-3" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "What type of license do you hold?"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[aviationLicense])),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(aviationInstrumentRating) ?
                                "p-3 border border-danger border-top-overlap border-right-overlap border-left-overlap" : "border-bottom p-3" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Do you have a valid Instrument Rating?"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[aviationInstrumentRating] ? 'Yes' : 'No')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(aviationHoursExperience) ?
                                "p-3 border border-danger border-top-overlap border-right-overlap border-left-overlap" : "border-bottom p-3" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "How many pilot-in-command hours of experience do you have?"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[aviationHoursExperience])),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(aviationHoursAnnually) ?
                                "p-3 border border-danger border-top-overlap border-right-overlap border-left-overlap" : "border-bottom p-3" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "How many hours do you typically fly annually?"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[aviationHoursAnnually])),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(aviationAccidents) ? "p-3 border border-danger border-overlap" : "border-bottom p-3" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Have you had any aviation accidents?"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[aviationAccidents] ? 'Yes' : 'No')))),
            activitiesAnswer[hangGliding] &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "font-weight-bold" }, "Hang-gliding"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(hangGlidingStunt) ? "p-3 border border-danger" : "p-3 border border-success" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Have you been or will you be stunt-flying or making record-setting attempts?"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[hangGlidingStunt] ? 'Yes' : 'No'))),
            activitiesAnswer[ultralightFlying] &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "font-weight-bold" }, "Ultra-light flying"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(ultralightFlyingStunts) ?
                            "p-3 border border-danger" : "p-3 border border-success" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Have you been or will you be piloting non-licensed aircraft, performing aerobatics or stunts, or making record-setting attempts?"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[ultralightFlyingStunts] ? 'Yes' : 'No'))),
            activitiesAnswer[scubaDiving] &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "font-weight-bold" }, "Scuba diving beyond 100 feet or specialized diving"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(scubaDiving) ? "p-3 border border-danger" : "border p-3" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[scubaDiving] ? 'Yes' : 'No'))),
            activitiesAnswer[backcountrySkiing] &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "font-weight-bold" }, "Heli-skiing or snowboarding, out-of-bounds or backcountry skiing or snowboarding, or backcountry snowmobiling"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "border border-success p-3" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "font-weight-bold" }, "Which activities, specifically?"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "border" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(heliSkiSnowboarding) ? "p-3 border border-danger border-top-overlap border-right-overlap border-left-overlap" : "border-bottom p-3" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Heli-skiing or snowboarding"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[heliSkiSnowboarding] ? 'Yes' : 'No')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(outOfBoundsSkiingSnowboarding) ?
                                    "p-3 border border-danger border-top-overlap border-left-overlap border-right-overlap" : "border-bottom p-3" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Out-of-bounds or backcountry skiing or snowboarding"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[outOfBoundsSkiingSnowboarding] ? 'Yes' : 'No')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(backCountrySnowMobiling) ?
                                    "p-3 border border-danger border-top-overlap border-left-overlap border-right-overlap" : "border-bottom p-3" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Backcountry snowmobiling"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[backCountrySnowMobiling] ? 'Yes' : 'No'))))),
            activitiesAnswer[mountainClimbing] &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "font-weight-bold" }, "Outdoor mountain climbing using technical equipment"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(mountainClimbingTall) ?
                            "p-3 border border-danger" : "p-3 border border-success" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Have you been or will you be climbing in the Himalayas or at an altitude above 6,000m or 19,700ft?"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[mountainClimbingTall] ? 'Yes' : 'No'))),
            activitiesAnswer[skydivingActivities] &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "font-weight-bold" }, "Skydiving, wingsuit flying, parachuting, skysurfing, or canopy piloting"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "border border-success p-3 pb-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Which activities, specifically?"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "border" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(skydiving) ? "p-3 border border-danger border-top-overlap border-right-overlap border-left-overlap" : "border-bottom p-3" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Skydiving"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[skydiving] ? 'Yes' : 'No'),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(skydivingOneTime) ? "mt-2 p-3 border border-danger border-top-overlap" : "border p-3 mt-2" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Was this a one-time occurrence in the past, with no intention of doing it again?"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[skydivingOneTime] ? 'Yes' : 'No'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(wingsuitFlying) ? "p-3 border border-danger border-top-overlap border-left-overlap border-right-overlap" : "border-bottom p-3" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Wingsuit flying"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[wingsuitFlying] ? 'Yes' : 'No')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(parachuting) ? "p-3 border border-danger border-top-overlap border-left-overlap border-right-overlap" : "border-bottom p-3" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Parachuting"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[parachuting] ? 'Yes' : 'No'),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(parachutingOneTime) ? "mt-2 border p-3 border-danger" : "border p-3 mt-2" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Was this a one-time occurrence in the past, with no intention of doing it again?"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[parachutingOneTime] ? 'Yes' : 'No'))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(skysurfing) ? "p-3 border border-danger border-top-overlap border-left-overlap border-right-overlap" : "border-bottom p-3" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Skysurfing"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[skysurfing] ? 'Yes' : 'No')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(canopyPiloting) ? "p-3 border border-danger border-top-overlap border-left-overlap border-right-overlap" : "border-bottom p-3" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Canopy piloting"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[canopyPiloting] ? 'Yes' : 'No')),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(skydivingExtreme) ? "p-3 border border-danger border-overlap" : "border-bottom p-3" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Have you been or will you be making record-setting attempts?"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[skydivingExtreme] ? 'Yes' : 'No'))))),
            activitiesAnswer[motorizedRacing] &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "font-weight-bold" }, "Motorized racing (e.g., car, motorcycle, motorboat, or snowmobile)"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "p-3 border" }, activitiesAnswer[motorizedRacing] ? 'Yes' : 'No')),
            activitiesAnswer[bungeeJumping] &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "font-weight-bold" }, "Bungee jumping"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(bungeeJumpingOneTime) ?
                            "p-3 border border-danger" : "p-3 border border-success" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dt", null, "Was this a one-time occurrence in the past, with no intention of doing it again?"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[bungeeJumpingOneTime] ? 'Yes' : 'No'))),
            activitiesAnswer[fightSports] &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "font-weight-bold" }, "Competitive fight sports (e.g., mixed martial arts, boxing, muay thai, etc.) above the amateur level"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: causeDecline(fightSports) ? "p-3 border border-danger" : "border p-3" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, activitiesAnswer[fightSports] ? 'Yes' : 'No'))))));
};
/* harmony default export */ __webpack_exports__["a"] = (ActivitiesQuestionAnswer);


/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ReproductiveQuestionAnswer = function (props) {
    var reproductiveAnswer = JSON.parse(props.answer);
    var noneKey = 'reproductiveNone';
    var displayNone = reproductiveAnswer[noneKey];
    var abnormalMammogram = 'abnormalMammogram';
    var abnormalMammogramRepeat = 'abnormalMammogramRepeat';
    var breastImagingTestOrPAPTest = 'breastImagingTestOrPAPTest';
    var breastImagingTestOrPAPTestRepeat = 'breastImagingTestOrPAPTestRepeat';
    var abnormalPSATest = 'abnormalPSATest';
    var abnormalPSATestRepeat = 'abnormalPSATestRepeat';
    var abnormalBiopsy = 'abnormalBiopsy';
    var reproductiveDisorderOther = 'reproductiveDisorderOther';
    var reproductiveDisorderOtherDetails = 'reproductiveDisorderOtherDetails';
    return displayNone ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, "None")) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        reproductiveAnswer[abnormalMammogram] &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Abnormal mammogram or breast imaging"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "border border-success" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", { className: "ml-2" }, "Since the original abnormal test, have you had a repeat test that produced normal results?"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", { className: "ml-2" }, reproductiveAnswer[abnormalMammogramRepeat] ? 'Yes' : 'No'))),
        reproductiveAnswer[breastImagingTestOrPAPTest] &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Abnormal PAP test"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "border border-success" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", { className: "ml-2" }, "Since the original abnormal test, have you had a repeat test that produced normal results?"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", { className: "ml-2" }, reproductiveAnswer[breastImagingTestOrPAPTestRepeat] ? 'Yes' : 'No'))),
        reproductiveAnswer[abnormalPSATest] &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Abnormal prostate (PSA) test"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "border border-success" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", { className: "ml-2" }, "Since the original abnormal test, have you had a repeat test that produced normal results?"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", { className: "ml-2" }, reproductiveAnswer[abnormalPSATestRepeat] ? 'Yes' : 'No'))),
        reproductiveAnswer[abnormalBiopsy] &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null, "Abnormal biopsy")),
        reproductiveAnswer[reproductiveDisorderOther] &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("dd", null,
                    "Other(",
                    reproductiveAnswer[reproductiveDisorderOtherDetails],
                    ")"))));
};
/* harmony default export */ __webpack_exports__["a"] = (ReproductiveQuestionAnswer);


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var ANIM_DURATION = 300;
var RejectPolicyModal = /** @class */ (function (_super) {
    __extends(RejectPolicyModal, _super);
    function RejectPolicyModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onAfterClose = function () {
            __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].enableBodyScrolling();
        };
        // http://reactcommunity.org/react-modal/accessibility/#app-element
        __WEBPACK_IMPORTED_MODULE_1_react_modal__["setAppElement"]('#root');
        return _this;
    }
    RejectPolicyModal.prototype.componentDidMount = function () {
        if (this.props.isOpen) {
            __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].disableBodyScrolling({ allBreakpoints: true });
        }
    };
    RejectPolicyModal.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isOpen !== this.props.isOpen) {
            if (this.props.isOpen) {
                __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].disableBodyScrolling({ allBreakpoints: true });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].enableBodyScrolling();
            }
        }
    };
    RejectPolicyModal.prototype.componentWillUnmount = function () {
        __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].enableBodyScrolling();
    };
    RejectPolicyModal.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_modal__, { className: "ReactModal_Content section section-main" // Redefine className to remove inline styles
            , closeTimeoutMS: ANIM_DURATION, contentLabel: "TODO", isOpen: this.props.isOpen, overlayClassName: "ReactModal_Overlay" // Redefine className to remove inline styles
            , portalClassName: "ReactModal" // Redefine className to remove inline styles
            , shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Do you want to send the customer a notification email?"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3 d-flex flex-column flex-sm-row justify-content-sm-end" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons_Button__["a" /* default */], { className: "btn-secondary order-last order-sm-first", onClick: function () { return _this.props.markAsDeclined(true); } }, "Send Notification"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons_Button__["a" /* default */], { className: "btn-outline-secondary ml-sm-3", onClick: function () { return _this.props.markAsDeclined(false); } }, "Without Sending Notification")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn btn-icon ReactModal__Close", onClick: this.props.onRequestClose },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["u" /* IconClose */], null))));
    };
    return RejectPolicyModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (RejectPolicyModal);


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__policy_policyAPI__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__policy_PolicyBeneficiariesList__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__policy_PolicyBeneficiaryContainer__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_forms_FileUpload__ = __webpack_require__(169);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};














var CustomerBeneficiariesPage = /** @class */ (function (_super) {
    __extends(CustomerBeneficiariesPage, _super);
    function CustomerBeneficiariesPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: true,
            isChangingStatus: new Set(),
            policiesWithConfirmedBeneficiaries: [],
            policiesWithPendingBeneficiaries: [],
            showingEdit: false,
            isDeleting: false,
        };
        _this.loadData = function () {
            var p1 = _this.props.actions.fetchCustomerPolicies(_this.props.match.params.customerId);
            var p2 = _this.props.actions.fetchCustomerPolicyBeneficiaries(_this.props.match.params.customerId);
            return Promise.all([p1, p2])
                .then(function () {
                var currentPolicyIds = new Set();
                _this.props.currentBeneficiaries.forEach(function (beneficiary) {
                    currentPolicyIds.add(beneficiary.customerPolicyId);
                });
                var pendingPolicyIds = new Set();
                _this.props.pendingBeneficiaries.forEach(function (beneficiary) {
                    pendingPolicyIds.add(beneficiary.customerPolicyId);
                });
                var policiesWithConfirmedBeneficiaries = _this.props.policies.filter(function (p) { return currentPolicyIds.has(p.id); });
                var policiesWithPendingBeneficiaries = _this.props.policies.filter(function (p) { return pendingPolicyIds.has(p.id); });
                _this.setState({
                    policiesWithConfirmedBeneficiaries: policiesWithConfirmedBeneficiaries,
                    policiesWithPendingBeneficiaries: policiesWithPendingBeneficiaries,
                    isLoading: false
                });
            });
        };
        _this.checkIfNeededAndReloadData = function () {
            // if we just came back from a beneficiary edit, reload the data in case something changed.		
            if (!_this.props.match.params.pageId && _this.state.showingEdit) {
                _this.setState({ showingEdit: false });
                _this.loadData();
            }
        };
        _this.onEdit = function (row) {
            _this.setState({ showingEdit: true });
            _this.props.history.push("/admin/customers/" + _this.props.match.params.customerId + "/beneficiaries/" + row.id);
        };
        _this.onDelete = function (row) {
            if (_this.state.isDeleting === true) {
                return;
            }
            _this.setState({ isDeleting: true });
            _this.props.actions.deleteCustomerPolicyBeneficiary(row.id, row.statusId)
                .then(function () {
                if (_this.props.deleteSucceed) {
                    __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Beneficiary deleted!');
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_toastr__["error"]('Each policy requires at least one beneficiary');
                }
                _this.props.actions.fetchCustomerPolicyBeneficiaries(_this.props.match.params.customerId);
            })
                .then(function () {
                _this.setState({ isDeleting: false });
                _this.loadData();
            });
        };
        _this.onPolicyChange = function (policy, e) {
            policy.beneficiariesStatus = e.target.value;
            _this.props.actions.setCustomerPolicies(policy);
        };
        _this.savePolicyStatus = function (policy) {
            _this.setIsChangingStatus(policy.id.toString(), false);
            _this.props.actions.saveAdminCustomerPolicy(policy)
                .then(function () {
                __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Policy Status Saved!');
                _this.loadData();
            });
        };
        _this.setIsChangingStatus = function (policyId, isChanging) {
            var isChangingStatus = new Set(_this.state.isChangingStatus);
            if (isChanging) {
                isChangingStatus.add(policyId);
            }
            else {
                isChangingStatus.delete(policyId);
            }
            _this.setState({ isChangingStatus: isChangingStatus });
        };
        _this.onManageDisbursement = function (beneficiaries, policy, isCurrent) {
            _this.props.actions.setCustomerPolicy(policy);
            var filteredBeneficiaries = [];
            if (!isCurrent) {
                filteredBeneficiaries = _this.props.pendingBeneficiaries
                    .filter(function (b) { return b.customerPolicyId === policy.id; });
                _this.props.actions.setCustomerPolicyBeneficiaries(filteredBeneficiaries);
            }
            else {
                filteredBeneficiaries = _this.props.currentBeneficiaries
                    .filter(function (b) { return b.customerPolicyId === policy.id; });
                _this.props.actions.setCustomerPolicyBeneficiaries(filteredBeneficiaries);
            }
            if (filteredBeneficiaries.some(function (b) { return b.isUnderage === true; })) {
                var trustee = filteredBeneficiaries.find(function (b) { return b.typeId === __WEBPACK_IMPORTED_MODULE_12__common_utils__["d" /* BeneficiaryTypes */].Trustee; });
                if (trustee) {
                    _this.props.actions.setTrustee(trustee);
                }
                else {
                    var newTrustee = __WEBPACK_IMPORTED_MODULE_5__policy_policyAPI__["g" /* defaultTrustee */];
                    _this.props.actions.setTrustee(newTrustee);
                }
            }
            _this.props.history.push("/admin/customers/" + _this.props.match.params.customerId + "/beneficiaries-disbursement");
        };
        _this.validatePercentage = function (policy) {
            var policyBeneficiaries = _this.props.pendingBeneficiaries.filter(function (b) { return b.customerPolicyId === policy.id; });
            return __WEBPACK_IMPORTED_MODULE_12__common_utils__["j" /* UtilsBeneficiaries */].isDisbursementValid(policyBeneficiaries);
        };
        _this.onUpload = function (file, customerId, policy) {
            var sendBeneficiaryNotification = _this.props.actions.sendBeneficiaryNotification;
            __WEBPACK_IMPORTED_MODULE_5__policy_policyAPI__["a" /* default */].uploadSignedBeneficiaryDocumentUrl(customerId, policy.id, file)
                .then(function () {
                var updatedPolicy = __assign({}, policy, { beneficiariesStatus: __WEBPACK_IMPORTED_MODULE_12__common_utils__["c" /* BeneficiaryStatus */].Confirmed });
                return _this.props.actions.saveAdminCustomerPolicy(updatedPolicy);
            })
                .then(function () { return _this.props.actions.sendBeneficiaryUploadedConfirmation(customerId, policy.id); })
                .then(function () {
                var beneficiaries = _this.props.pendingBeneficiaries.filter(function (pb) { return pb.customerPolicyId === policy.id; });
                beneficiaries.reduce(function (promise, beneficiary) {
                    if (beneficiary.shouldSendNotification) {
                        return promise.then(function () {
                            return sendBeneficiaryNotification(customerId, beneficiary.id);
                        });
                    }
                }, Promise.resolve());
            })
                .then(function () { return _this.loadData(); })
                .then(function () { return __WEBPACK_IMPORTED_MODULE_3_toastr__["info"]('Document uploaded and policy beneficiaries marked confirmed.'); })
                .catch(function () {
                __WEBPACK_IMPORTED_MODULE_3_toastr__["error"]('There was an issue confirming and uploading the beneficiaries.  Please contact support');
            });
        };
        _this.onDownloadFileClicked = function (customerId, policyId) {
            __WEBPACK_IMPORTED_MODULE_5__policy_policyAPI__["a" /* default */].fetchSignedBeneficiaryDocumentUrl(customerId, policyId)
                .then(function (url) {
                window.open(url);
            });
        };
        _this.renderList = function () {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: _this.props.className },
                _this.renderCurrentPoliciesList(),
                _this.renderPendingPoliciesList(),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions mt-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_buttons__["a" /* Button */], { to: "/admin/customers/" + _this.props.match.params.customerId + "/beneficiaries/new", className: "btn-outline-primary workflow-progress-action" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Add a beneficiary"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_icons__["k" /* IconAdd */], null)))));
        };
        _this.renderCurrentPoliciesList = function () {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-4" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, "Current"),
                _this.renderPoliciesList(_this.state.policiesWithConfirmedBeneficiaries, _this.props.currentBeneficiaries, true)));
        };
        _this.renderPendingPoliciesList = function () {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, "Pending"),
                _this.renderPoliciesList(_this.state.policiesWithPendingBeneficiaries, _this.props.pendingBeneficiaries)));
        };
        _this.renderPoliciesList = function (policies, beneficiaries, isCurrent) {
            if (isCurrent === void 0) { isCurrent = false; }
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled mb-0 customer-dashboard-plans" }, policies.length > 0 ? (policies.map(function (policy) {
                // disable editing on current policy beneficiaries that have pending changes
                var readOnly = isCurrent
                    && _this.props.pendingBeneficiaries.filter(function (b) { return b.customerPolicyId === policy.id; }).length > 0;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: policy.id, className: "customer-dashboard-plan" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customer-dashboard-plan-info" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "d-inline large" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null,
                                "Policy ",
                                policy.number,
                                "\u00A0"),
                            _this.state.isChangingStatus.has(policy.id) && !isCurrent
                                ?
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_forms__["g" /* DropdownInput */], { name: "beneficiariesStatus", defaultOption: '-', options: [
                                                {
                                                    text: 'Pending paperwork',
                                                    value: __WEBPACK_IMPORTED_MODULE_12__common_utils__["c" /* BeneficiaryStatus */].PendingPaperwork
                                                },
                                                {
                                                    text: 'Pending receipt',
                                                    value: __WEBPACK_IMPORTED_MODULE_12__common_utils__["c" /* BeneficiaryStatus */].PendingReceipt
                                                },
                                                {
                                                    text: 'Confirmed',
                                                    value: __WEBPACK_IMPORTED_MODULE_12__common_utils__["c" /* BeneficiaryStatus */].Confirmed
                                                }
                                            ], onChange: function (e) { return _this.onPolicyChange(policy, e); }, className: "d-inline-block", value: policy.beneficiariesStatus }),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_buttons__["a" /* Button */], { className: "btn-link text-secondary small", disabled: !_this.validatePercentage(policy), onClick: function () { return _this.savePolicyStatus(policy); } }, "save"),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_buttons__["a" /* Button */], { className: "btn-link text-secondary small", onClick: function () { return _this.setIsChangingStatus(policy.id, false); } }, "cancel"))
                                :
                                    _this.renderStatus(policy, isCurrent)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "d-inline" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_buttons__["a" /* Button */], { className: "btn-outline-primary", disabled: readOnly, onClick: function () { return _this.onManageDisbursement(_this.props.pendingBeneficiaries, policy, isCurrent); } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { className: "align-middle mx-2" }, "Manage disbursement")))),
                    _this.renderBeneficiaryList(beneficiaries, policy.id, readOnly),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, !isCurrent &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "d-inline" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_forms_FileUpload__["a" /* default */], { label: "Upload Signed Form & Confirm", onDrop: function (file) { _this.onUpload(file, _this.props.match.params.customerId, policy); }, disabled: !_this.validatePercentage(policy) })))));
            })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { className: "reduced-em" }, "No policies")))));
        };
        _this.renderBeneficiaryList = function (beneficiaries, policyId, readOnly) {
            var filteredBeneficiaries = beneficiaries
                .filter(function (b) { return b.customerPolicyId === policyId && b.typeId !== __WEBPACK_IMPORTED_MODULE_12__common_utils__["d" /* BeneficiaryTypes */].Trustee; });
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__policy_PolicyBeneficiariesList__["a" /* default */], { beneficiaries: filteredBeneficiaries, onEdit: _this.onEdit, onDelete: _this.onDelete, loading: _this.state.isLoading, readOnly: readOnly })));
        };
        _this.renderStatus = function (policy, isCurrent) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, isCurrent ? '' :
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                    __WEBPACK_IMPORTED_MODULE_12__common_utils__["m" /* default */].getPickListItemDescription(policy.beneficiariesStatus),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_buttons__["a" /* Button */], { className: "btn-link text-secondary small", onClick: function () { return _this.setIsChangingStatus(policy.id, true); } }, "change"))));
        };
        _this.renderForm = function () {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__policy_PolicyBeneficiaryContainer__["a" /* default */], { baseUrl: "/admin/customers/" + _this.props.match.params.customerId, history: _this.props.history, match: _this.props.match }));
        };
        return _this;
    }
    CustomerBeneficiariesPage.prototype.componentDidMount = function () {
        this.loadData();
    };
    CustomerBeneficiariesPage.prototype.render = function () {
        this.checkIfNeededAndReloadData();
        if (this.props.match.params.pageId) {
            return this.renderForm();
        }
        else {
            return this.renderList();
        }
    };
    return CustomerBeneficiariesPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    var currentBeneficiaries = state.policy.beneficiaries.current
        .sort(__WEBPACK_IMPORTED_MODULE_12__common_utils__["j" /* UtilsBeneficiaries */].sortPrimaryThenByName);
    var pendingBeneficiaries = state.policy.beneficiaries.pending
        .sort(__WEBPACK_IMPORTED_MODULE_12__common_utils__["j" /* UtilsBeneficiaries */].sortPrimaryThenByName);
    return {
        currentBeneficiaries: currentBeneficiaries,
        pendingBeneficiaries: pendingBeneficiaries,
        policies: state.policy.policies,
        deleteSucceed: state.policy.deleteSucceed,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CustomerBeneficiariesPage);
var adminRoles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, adminRoles));


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var PolicyBeneficiaryForm = /** @class */ (function (_super) {
    __extends(PolicyBeneficiaryForm, _super);
    function PolicyBeneficiaryForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errors = { birthDate: {}, email: {}, postalCode: {} };
        _this.state = {
            touched: {
                birthDate: false,
                email: false,
                postalCode: false,
            },
            relationshipOther: ''
        };
        _this.onChange = function (e) {
            var value = __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].parseValueFromEvent(e);
            _this.setState((_a = {}, _a[e.target.name] = value, _a));
            var _a;
        };
        _this.handleBlur = function (field) { return function (evt) {
            _this.setState({
                touched: __assign({}, _this.state.touched, (_a = {}, _a[field] = true, _a))
            });
            if (field === 'birthDate') {
                var underageChangeEvent = {
                    target: {
                        name: 'isUnderage',
                        value: __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].getAgeFromBirthdate(_this.props.customerPolicyBeneficiary.birthDate) < 18,
                        type: 'custom'
                    }
                };
                _this.props.onPolicyBeneficiaryChange(underageChangeEvent);
            }
            var _a;
        }; };
        _this.validate = function () {
            // true means invalid
            return {
                birthDate: __WEBPACK_IMPORTED_MODULE_4__common_utils__["k" /* Validation */].validateDate(_this.props.customerPolicyBeneficiary.birthDate),
                email: __WEBPACK_IMPORTED_MODULE_4__common_utils__["k" /* Validation */].validateEmail(_this.props.customerPolicyBeneficiary.email),
                postalCode: __WEBPACK_IMPORTED_MODULE_4__common_utils__["k" /* Validation */].validatePostalCode(_this.props.customerPolicyBeneficiary.postalCode)
            };
        };
        _this.isSubmitDisabled = function () {
            if (_this.errors.birthDate.hasError || _this.errors.email.hasError || _this.errors.postalCode.hasError) {
                return true;
            }
            var _a = _this.props.customerPolicyBeneficiary, firstName = _a.firstName, lastName = _a.lastName, birthDate = _a.birthDate, customerPolicyId = _a.customerPolicyId;
            return !firstName || !lastName || !birthDate || !customerPolicyId;
        };
        return _this;
    }
    PolicyBeneficiaryForm.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: this.props.className },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Beneficiary info"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { id: "beneficiaryFirstName", labelText: "First Name", name: "firstName", onChange: this.props.onPolicyBeneficiaryChange, value: this.props.customerPolicyBeneficiary.firstName, className: "col-md-4", required: true }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { id: "beneficiaryLastName", labelText: "Last Name", name: "lastName", onChange: this.props.onPolicyBeneficiaryChange, value: this.props.customerPolicyBeneficiary.lastName, className: "col-md-4", required: true }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-daypicker-responsive col-md-4" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["a" /* BirthDatePicker */], { id: "beneficiaryDOB", labelText: "Birthdate", name: "birthDate", value: this.props.customerPolicyBeneficiary.birthDate, onBlur: this.handleBlur('birthDate'), onChange: this.props.onPolicyBeneficiaryChange, error: __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].shouldMarkError(this.errors.birthDate, this.state.touched.birthDate) ? this.errors.birthDate : undefined, required: true })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { id: "beneficiaryEmail", labelText: "Beneficiary Email", name: "email", onBlur: this.handleBlur('email'), onChange: this.props.onPolicyBeneficiaryChange, value: this.props.customerPolicyBeneficiary.email, error: __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].shouldMarkError(this.errors.email, this.state.touched.email) ? this.errors.email : undefined, className: "col-md-6" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { labelText: "Send notification", name: "shouldSendNotification", onChildren: "Yes", offChildren: "No", onChange: this.props.onPolicyBeneficiaryChange, checked: this.props.customerPolicyBeneficiary.shouldSendNotification, className: "col-md-4 toggle-yes-no", disabled: __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].isEmpty(this.props.customerPolicyBeneficiary.email) }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["g" /* DropdownInput */], { labelText: "Relationship", id: "relationship", name: "relationship", value: this.props.customerPolicyBeneficiary.relationship, defaultOption: "-", onChange: this.props.onRelationshipChange, options: [
                            {
                                text: 'Spouse',
                                value: 'Spouse'
                            },
                            {
                                text: 'Child',
                                value: 'Child'
                            },
                            {
                                text: 'Grandchild',
                                value: 'Grandchild'
                            },
                            {
                                text: 'Parent',
                                value: 'Parent'
                            },
                            {
                                text: 'Sibling',
                                value: 'Sibling'
                            },
                            {
                                text: 'Other - specify',
                                value: 'Other'
                            }
                        ], className: "col-md-3" }),
                    this.props.customerPolicyBeneficiary.relationship === 'Other' &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { id: "relationshipOther", labelText: " ", name: "relationshipOther", onChange: this.props.onPolicyBeneficiaryChange, value: this.props.customerPolicyBeneficiary.relationshipOther, maxLength: 20, className: "col-md-2" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-auto form-group" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-1" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["j" /* Label */], { className: "mr-2 mb-0 strong" }, "Revocability"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common__["i" /* TooltipModal */], { toggle: "What does this mean?", toggleClassName: "em btn-link-inline" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "If you designate a beneficiary as irrevocable, you cannot change (\"revoke\") the claim benefits of that beneficiary without their signature. If the irrevocable beneficiary is a minor, you cannot  change or revoke the beneficiary until minor reaches the age of majority."),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Note: In Quebec, the designation of a spouse is irrevocable unless you check the revocable box next to their name."))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { name: "isRevocable", onChildren: "Revocable", offChildren: "Irrevocable", onChange: this.props.onPolicyBeneficiaryChange, checked: this.props.customerPolicyBeneficiary.isRevocable, className: "mr-2 mb-0 toggle-buttons-wrap" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-auto form-group" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-1" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["j" /* Label */], { className: "mr-2 mb-0 strong" }, "Primary/Contingent"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common__["i" /* TooltipModal */], { toggle: "What does this mean?", toggleClassName: "em btn-link-inline" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "The primary beneficiary receives the benefits payable when the insured dies. If more than one primary beneficiary is appointed, proceeds will be payable as per the percentages you indicated. Note that the sum of percentages assigned to each beneficiary must total to 100%."),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "If multiple primary beneficiaries are designated, but no percentage allocation has been indicated, benefits will be paid out in equal shares. If no beneficiaries have been indicated, benefits from the insurance policy will be paid to the insured's estate."),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "In the event that all primary beneficiaries die before the insured, the contingent beneficiaries will receive the benefits payable when the insured dies."))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["o" /* ToggleSwitch */], { name: "typeId", onChildren: "Primary", offChildren: "Contingent", onChange: this.props.onPolicyBeneficiaryChange, checked: this.props.customerPolicyBeneficiary.typeId === __WEBPACK_IMPORTED_MODULE_4__common_utils__["d" /* BeneficiaryTypes */].Primary, className: "mr-2 mb-0 toggle-buttons-wrap" })))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title mt-4" }, "Contact info"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { id: "beneficiaryAddress", labelText: "Address", name: "address", onChange: this.props.onPolicyBeneficiaryChange, value: this.props.customerPolicyBeneficiary.address, className: "col-md-12" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { id: "beneficiaryCity", labelText: "City", name: "city", onChange: this.props.onPolicyBeneficiaryChange, value: this.props.customerPolicyBeneficiary.city, className: "col-md-6" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["k" /* ProvinceDropdown */], { id: "beneficiaryProvince", labelText: "Province", name: "province", onChange: this.props.onPolicyBeneficiaryChange, province: this.props.customerPolicyBeneficiary.province, className: "col-sm-6 mb-sm-2" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Postal code", name: "postalCode", onBlur: this.handleBlur('postalCode'), onChange: this.props.onPolicyBeneficiaryChange, value: this.props.customerPolicyBeneficiary.postalCode, className: "col-sm-6", error: __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].shouldMarkError(this.errors.postalCode, this.state.touched.postalCode)
                            ? this.errors.postalCode
                            : undefined }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["e" /* CountryDropdown */], { id: "beneficiaryCountry", labelText: "Country", name: "country", onChange: this.props.onPolicyBeneficiaryChange, country: this.props.customerPolicyBeneficiary.country, className: "col-sm-6 mb-2" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title mt-4" }, "Policy"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["g" /* DropdownInput */], { id: "beneficiaryPolicyNumber", labelText: "Policy #", name: "customerPolicyId", value: this.props.customerPolicyBeneficiary.customerPolicyId, defaultOption: "-", onChange: this.props.onPolicyBeneficiaryChange, options: this.props.policies.map(function (policy) {
                            return { text: policy.number, value: policy.id };
                        }), className: "col-md-6 mb-2", required: true }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_buttons__["a" /* Button */], { id: this.props.customerPolicyBeneficiary.id ? 'updateBeneficiaryBtn' : "addBeneficiaryBtn", onClick: this.props.save, className: "btn-primary mt-3 mr-3", disabled: this.isSubmitDisabled() }, this.props.customerPolicyBeneficiary.id ? 'Update beneficiary' : 'Add beneficiary'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", { className: "d-sm-none" }),
                !(this.props.customerPolicyBeneficiary.id) &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_buttons__["a" /* Button */], { id: "saveAndAddAnotherBtn", onClick: this.props.saveAndAdd, className: "btn-primary mr-3 mt-3", disabled: this.isSubmitDisabled() }, "Save and Add Another"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", { className: "d-sm-none" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_buttons__["a" /* Button */], { onClick: this.props.cancel, className: "btn-outline-primary mr-3 mt-3" }, "Cancel"))));
    };
    return PolicyBeneficiaryForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PolicyBeneficiaryForm);


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CustomerBeneficiariesDisbursementRow__ = __webpack_require__(552);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};












var PolicyBeneficiariesDisbursementPage = /** @class */ (function (_super) {
    __extends(PolicyBeneficiariesDisbursementPage, _super);
    function PolicyBeneficiariesDisbursementPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isUpdateDisabled = function () {
            return !__WEBPACK_IMPORTED_MODULE_10__common_utils__["j" /* UtilsBeneficiaries */].isDisbursementValid(_this.props.beneficiaries) || _this.validateTrustee();
        };
        _this.updateDisbursement = function () {
            var beneficiaries = _this.props.beneficiaries.filter(function (b) { return b.typeId !== __WEBPACK_IMPORTED_MODULE_10__common_utils__["d" /* BeneficiaryTypes */].Trustee; });
            __WEBPACK_IMPORTED_MODULE_10__common_utils__["m" /* default */].forEachPromise(beneficiaries, _this.props.actions.saveCustomerPolicyBeneficiary).then(function () {
                if (_this.props.beneficiaries.find(function (b) { return b.isUnderage === true; })) {
                    _this.saveTrustee();
                }
                __WEBPACK_IMPORTED_MODULE_8_toastr__["success"]('Beneficiary disbursement updated!');
                _this.props.history.push("/admin/customers/" + _this.props.match.params.customerId + "/beneficiaries");
            });
        };
        _this.onTrusteeChange = function (e) {
            var trustee = __assign({}, _this.props.trustee, (_a = {}, _a[e.target.name] = e.target.value, _a));
            _this.props.actions.setTrustee(trustee);
            var _a;
        };
        _this.saveTrustee = function () {
            var trustee = __assign({}, _this.props.trustee);
            trustee.customerId = _this.props.match.params.customerId;
            trustee.customerPolicyId = _this.props.customerPolicy.id;
            _this.props.actions.saveCustomerPolicyBeneficiary(trustee);
        };
        // true means update button should be disabled
        _this.validateTrustee = function () {
            var result = false;
            if (!_this.props.beneficiaries.some(function (b) { return b.isUnderage === true; })) {
                return result;
            }
            else {
                if (!_this.props.trustee.firstName ||
                    !_this.props.trustee.lastName ||
                    !_this.props.trustee.email ||
                    _this.props.trustee.firstName.trim() === '' ||
                    _this.props.trustee.lastName.trim() === '' ||
                    _this.props.trustee.email.trim() === '') {
                    result = true;
                }
            }
            return result;
        };
        _this.cancelManagement = function () {
            _this.props.history.push("/admin/customers/" + _this.props.match.params.customerId + "/beneficiaries");
        };
        return _this;
    }
    PolicyBeneficiariesDisbursementPage.prototype.componentDidMount = function () {
        var _this = this;
        var filteredBeneficiaries = this.props.beneficiaries
            .filter(function (b) { return b.customerPolicyId === _this.props.customerPolicy.id; });
        this.props.actions.setCustomerPolicyBeneficiaries(filteredBeneficiaries);
    };
    PolicyBeneficiariesDisbursementPage.prototype.render = function () {
        var primaryBeneficiaries = this.props.beneficiaries.filter(function (b) { return b.typeId === __WEBPACK_IMPORTED_MODULE_10__common_utils__["d" /* BeneficiaryTypes */].Primary; });
        var contingentBeneficiaries = this.props.beneficiaries.filter(function (b) { return b.typeId === __WEBPACK_IMPORTED_MODULE_10__common_utils__["d" /* BeneficiaryTypes */].Contingent; });
        var _a = this.props, customerPolicy = _a.customerPolicy, beneficiaries = _a.beneficiaries, history = _a.history, match = _a.match, actions = _a.actions;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["b" /* Page */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["d" /* PageHeader */], { title: "Adjust your beneficiary disbursement" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customer-dashboard-plan-info" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "d-inline large" },
                        "Policy ",
                        this.props.customerPolicy.number)),
                primaryBeneficiaries.length > 0 &&
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__CustomerBeneficiariesDisbursementRow__["a" /* default */], { customerPolicy: customerPolicy, beneficiaries: beneficiaries, typedBeneficiaries: primaryBeneficiaries, history: history, match: match, actions: actions })),
                contingentBeneficiaries.length > 0 &&
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__CustomerBeneficiariesDisbursementRow__["a" /* default */], { customerPolicy: customerPolicy, beneficiaries: beneficiaries, typedBeneficiaries: contingentBeneficiaries, history: history, match: match, actions: actions })),
                this.props.beneficiaries.find(function (b) { return b.isUnderage === true; }) &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset content-set" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customer-dashboard-plan-info" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "d-inline large" }, "Trustee")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_forms__["n" /* TextInput */], { id: "trusteeFirstName", labelText: "First Name", name: "firstName", value: this.props.trustee.firstName, onChange: this.onTrusteeChange, className: "col-md-6", required: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_forms__["n" /* TextInput */], { id: "trusteeLastName", labelText: "Last Name", name: "lastName", value: this.props.trustee.lastName, onChange: this.onTrusteeChange, className: "col-md-6", required: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_forms__["n" /* TextInput */], { id: "trusteeEmail", labelText: "E-mail Address", name: "email", value: this.props.trustee.email, onChange: this.onTrusteeChange, className: "col-md-6", required: true }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-md-right mt-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { className: "btn-outline-primary col-md-2 mr-3", onClick: this.cancelManagement }, "Cancel"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { to: "/admin/customers/" + this.props.match.params.customerId + "/beneficiaries/new", className: "btn-outline-primary mr-3", disabled: this.isUpdateDisabled() },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Add a beneficiary"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_icons__["k" /* IconAdd */], null)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { className: "btn-primary", disabled: this.isUpdateDisabled(), onClick: this.updateDisbursement }, "Save and Update")))));
    };
    return PolicyBeneficiariesDisbursementPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state, props) {
    return {
        beneficiaries: state.policy.beneficiaries.pending,
        customerPolicy: state.policy.customerPolicy,
        trustee: state.policy.trustee
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(PolicyBeneficiariesDisbursementPage);
var adminRoles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, adminRoles));


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rheostat__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rheostat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rheostat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rheostat_css_slider_css__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rheostat_css_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rheostat_css_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rheostat_css_slider_horizontal_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rheostat_css_slider_horizontal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rheostat_css_slider_horizontal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__policy_policyActions__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};










var RheostatPit = function (_a) {
    var style = _a.style, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "rheostat-pit", style: style }, children));
};
var CustomerBeneficiariesDisbursementRow = /** @class */ (function (_super) {
    __extends(CustomerBeneficiariesDisbursementRow, _super);
    function CustomerBeneficiariesDisbursementRow(props) {
        var _this = _super.call(this, props) || this;
        _this.onDisbursementChange = function (e, beneficiary) {
            if (e.target.value > 100) {
                return;
            }
            var value = Math.min(100, e.target.value);
            var valuePct = value / 100;
            var newBeneficiary = __assign({}, beneficiary, (_a = {}, _a[e.target.name] = valuePct, _a));
            _this.props.actions.setCustomerPolicyBeneficiary(newBeneficiary);
            var _a;
        };
        _this.onValuesUpdated = function (publicState, beneficiary) {
            // Rheostat uses a values list to support multiple handles. Since we only have one handle, take the first index.
            var valuePct = publicState.values[0] / 100;
            var newBeneficiary = __assign({}, beneficiary, { disbursementPercent: valuePct });
            _this.props.actions.setCustomerPolicyBeneficiary(newBeneficiary);
        };
        _this.disburseEqually = function () {
            var numBeneficiaries = _this.props.typedBeneficiaries.length;
            var typeIndetifier = _this.props.typedBeneficiaries[0].typeId;
            var beneficiaries = _this.props.beneficiaries.map(function (beneficiary) {
                return beneficiary.typeId === typeIndetifier ? __assign({}, beneficiary, { disbursementPercent: 1 / numBeneficiaries }) : __assign({}, beneficiary);
            });
            _this.props.actions.setCustomerPolicyBeneficiaries(beneficiaries);
        };
        _this.getTotal = function () {
            var total = _this.props.typedBeneficiaries.reduce(function (a, b) { return a + parseFloat(b.disbursementPercent || 0); }, 0);
            return total;
        };
        return _this;
    }
    CustomerBeneficiariesDisbursementRow.prototype.render = function () {
        var _this = this;
        var title = __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].getPickListItemDescription(this.props.typedBeneficiaries[0].typeId);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset content-set" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customer-dashboard-plan-info" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "d-inline large" }, title),
                this.props.typedBeneficiaries.length > 0 && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-inline text-right" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_buttons__["a" /* Button */], { className: "btn-outline-secondary btn-sm", onClick: this.disburseEqually }, "Disburse equally")))),
            this.props.typedBeneficiaries.length > 0 ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "beneficiaries-disbursement" },
                this.props.typedBeneficiaries.map(function (beneficiary) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "beneficiary-disbursement-item", key: beneficiary.id },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-3 col-lg-2 mb-4 mb-md-0" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "beneficiary-name" }, beneficiary.name)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-lg-8 mb-4 mb-md-0" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rheostat___default.a, { onValuesUpdated: function (publicState) { return _this.onValuesUpdated(publicState, beneficiary); }, orientation: "horizontal", pitComponent: RheostatPit, pitPoints: [25, 50, 75], snap: true, values: [(beneficiary.disbursementPercent || 0) * 100] })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-3 col-lg-2" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_forms__["n" /* TextInput */], { name: "disbursementPercent", id: "disbursement-" + beneficiary.id, value: Math.trunc((beneficiary.disbursementPercent || 0) * 100), onChange: function (e) { return _this.onDisbursementChange(e, beneficiary); }, addOnAfter: "%", className: "mb-0" }))))); }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row mt-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-10 text-md-right" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "large" }, "Total (must be 100%):")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-2" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "large" },
                            Math.round(this.getTotal() * 100),
                            "%"))))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { className: "reduced-em" }, "No beneficiaries"))));
    };
    return CustomerBeneficiariesDisbursementRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state, props) {
    return {
        customerPolicy: state.policy.customerPolicy,
        beneficiaries: state.policy.beneficiaries.pending,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_9__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CustomerBeneficiariesDisbursementRow));


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};





var CustomerNotesList = /** @class */ (function (_super) {
    __extends(CustomerNotesList, _super);
    function CustomerNotesList(props) {
        var _this = _super.call(this, props) || this;
        _this.onPageChange = function (pageIndex) {
            _this.setState({ page: pageIndex });
        };
        _this.state = {
            page: 0
        };
        return _this;
    }
    CustomerNotesList.prototype.render = function () {
        var props = __rest(this.props, []);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                {
                    accessor: 'id',
                    show: false
                },
                {
                    Header: 'Date',
                    accessor: 'createdDate',
                    maxWidth: 200,
                    Cell: function (rowInfo) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatDate(rowInfo.value); }
                },
                {
                    Header: 'Last Modified By',
                    accessor: 'changedBy'
                },
                {
                    Header: 'Question Category',
                    accessor: 'answerInfo'
                },
                {
                    Header: 'Notes',
                    accessor: 'notes',
                    getProps: function (state, rowInfo, column) {
                        return {
                            style: {
                                whiteSpace: 'normal'
                            }
                        };
                    }
                },
                {
                    Header: 'Actions',
                    className: 'p-0 td-actions',
                    width: 100,
                    Cell: function (rowInfo) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["b" /* IconButton */], { title: "Edit note", className: "btn-icon-secondary btn-icon-td", onClick: function (e) {
                                e.stopPropagation(); // Prevent onClick conflict with tr onclick
                                if (window.location.href.includes('prospects')) {
                                    return props.history.push("/admin/prospects/" + rowInfo.original.customerId + "/notes/" + rowInfo.original.id);
                                }
                                else {
                                    return props.history.push("/admin/customers/" + rowInfo.original.customerId + "/notes/" + rowInfo.original.id);
                                }
                            } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["x" /* IconEdit */], null)));
                    }
                }
            ], data: props.notes, getTrProps: function (state, rowInfo, column) {
                return {
                    className: 'tr interactive',
                    onClick: function (e) {
                        if (window.location.href.includes('prospects')) {
                            return props.history.push("/admin/prospects/" + rowInfo.original.customerId + "/notes/" + rowInfo.original.id);
                        }
                        else {
                            return props.history.push("/admin/customers/" + rowInfo.original.customerId + "/notes/" + rowInfo.original.id);
                        }
                    }
                };
            }, noDataText: "No notes found", onPageChange: this.onPageChange, page: this.state.page }));
    };
    return CustomerNotesList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CustomerNotesList);


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);




var CustomerNotesListOptions = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "btn-group table-filters" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-filter" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_buttons__["a" /* Button */], { className: "btn-outline-primary", onClick: props.addNotes },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Add a note"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["k" /* IconAdd */], null)))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { name: "search", placeholder: "Search", value: props.searchterm, onChange: props.onSearch, className: "m-0 table-search" })));
};
/* harmony default export */ __webpack_exports__["a"] = (CustomerNotesListOptions);


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CustomerNoteDetailsForm__ = __webpack_require__(556);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var CustomerNoteDetails = /** @class */ (function (_super) {
    __extends(CustomerNoteDetails, _super);
    function CustomerNoteDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            var note = __assign({}, _this.props.note, (_a = {}, _a[e.target.name] = e.target.value, _a.customerId = _this.props.match.params.customerId, _a));
            _this.props.actions.setCustomerNote(note);
            var _a;
        };
        _this.onSave = function () {
            // tslint:disable-next-line
            console.log(_this.props.match.params.customerId);
            var note = __assign({}, _this.props.note);
            if (!note.customerId) {
                note.customerId = _this.props.match.params.customerId;
            }
            _this.props.actions.saveCustomerNote(note)
                .then(function () {
                __WEBPACK_IMPORTED_MODULE_1_toastr__["success"]('Saved');
                if (!window.location.href.includes('prospects')) {
                    return _this.props.history.push("/admin/customers/" + _this.props.match.params.customerId + "/notes");
                }
                else {
                    return _this.props.history.push("/admin/prospects/" + _this.props.match.params.customerId + "/notes");
                }
            });
        };
        return _this;
    }
    CustomerNoteDetails.prototype.componentDidMount = function () {
        if (this.props.match.params.pageId && this.props.match.params.pageId !== 'new') {
            this.props.actions.fetchCustomerNote(this.props.match.params.customerId, this.props.match.params.pageId);
        }
        else {
            this.props.actions.resetCustomerNote(this.props.match.params.customerId);
        }
    };
    CustomerNoteDetails.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: this.props.className },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__CustomerNoteDetailsForm__["a" /* default */], { note: this.props.note, onChange: this.onChange, onSave: this.onSave })));
    };
    return CustomerNoteDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        notes: state.user.notes,
        note: state.user.note
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CustomerNoteDetails));


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);



var CustomerNoteDetailsForm = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: props.className },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, props.note.id ? 'Update note' : 'Add a note'),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["m" /* TextArea */], { labelText: "Notes", name: "notes", onChange: props.onChange, value: props.note.notes, className: "col-md-12" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["a" /* Button */], { onClick: props.onSave, className: "btn-primary mt-4" }, "Save"))));
};
/* harmony default export */ __webpack_exports__["a"] = (CustomerNoteDetailsForm);


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var classNames = __webpack_require__(8);






var CustomerReferrals = /** @class */ (function (_super) {
    __extends(CustomerReferrals, _super);
    function CustomerReferrals() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            inputBalance: 0
        };
        _this.updateReferralBalance = function () {
            _this.props.actions.setCustomerReferralBalance(_this.state.inputBalance)
                .then(function () { return _this.props.actions.updateReferralBalance(_this.props.match.params.customerId, _this.props.referrals.referralBalance)
                .then(function () { return __WEBPACK_IMPORTED_MODULE_1_toastr__["success"]('Current Balance Updated'); }); });
        };
        _this.updateRemainingReferrals = function () {
            _this.props.actions.updateRemainingReferrals(_this.props.match.params.customerId, _this.props.referrals.remainingReferrals)
                .then(function () { return __WEBPACK_IMPORTED_MODULE_1_toastr__["success"]('Remaining Referrals Updated'); });
        };
        _this.onReferralBalanceChange = function (e) {
            _this.setState({ inputBalance: e.target.value });
        };
        _this.onRemainingReferralsChange = function (e) {
            _this.props.actions.setCustomerRemainingReferrals(e.target.value);
        };
        _this.updateReferralEnabled = function () {
            _this.props.actions.updateCustomerReferralEnabled(_this.props.match.params.customerId)
                .then(function () {
                __WEBPACK_IMPORTED_MODULE_1_toastr__["success"]('Referral Availability Updated!');
            });
        };
        _this.generateNewReferralCode = function () {
            _this.props.actions.generateNewReferralCode(_this.props.match.params.customerId);
        };
        _this.isAdminOrAgent = function (roles) {
            if (!roles) {
                return false;
            }
            else {
                return roles.indexOf("Admin" /* Administrator */) > -1 || roles.indexOf("Agent" /* Agent */) > -1;
            }
        };
        _this.isAdmin = function (roles) {
            if (!roles) {
                return false;
            }
            else {
                return roles.indexOf("Admin" /* Administrator */) > -1;
            }
        };
        return _this;
    }
    CustomerReferrals.prototype.componentDidMount = function () {
        this.props.actions.clearReferrals();
        this.props.actions.fetchReferrals(this.props.match.params.customerId);
    };
    CustomerReferrals.prototype.render = function () {
        var _this = this;
        var _a = this.props.referrals, referralCode = _a.referralCode, spousalReferralCode = _a.spousalReferralCode, referralBalance = _a.referralBalance, remainingReferrals = _a.remainingReferrals;
        var referees = this.props.referrals.referees || [];
        var referralCount = referees.filter(function (r) { return !r.isSpousalReferralUsed; }).length;
        var referralControlDisplay = this.props.referrals.referralEnabled ?
            'Peer Referral Enabled' : 'Peer Referral Disabled';
        var referralControlText = this.props.referrals.referralEnabled ? 'Disable Peer Referral' : 'Enable Peer Referral';
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames(this.props.className) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Referral Summary"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "col-md-auto list-unstyled mb-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            "Health Score: ",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, this.props.customer.healthScore || 0),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                "\u2014",
                                referralControlDisplay)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            "Peer Referral Code: ",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "mr-2" }, referralCode || '-')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            "Spousal Referral Code: ",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "mr-2" }, spousalReferralCode || '-'),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null,
                                ' ',
                                "(",
                                this.props.referrals.isSpousalReferralUsed ? 'Used' : 'Unused',
                                ")")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            "Current Balance: ",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatCurrency(referralBalance || 0.00)),
                            ' ',
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null,
                                "(",
                                __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatCurrency(this.props.referrals.paidReferral),
                                " Paid,",
                                __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatCurrency(this.props.referrals.pendingReferral),
                                ' ',
                                " Pending)"))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-auto d-flex align-items-center mt-3 mt-md-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["a" /* Button */], { onClick: this.updateReferralEnabled, className: "btn-outline-primary" }, referralControlText)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-auto d-flex align-items-center mt-3 mt-md-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["a" /* Button */], { onClick: function () {
                                if (window.confirm('Are you sure generating a new code will invalidate the existing one.')) {
                                    _this.generateNewReferralCode();
                                }
                            }, className: "btn-outline-primary" }, "Generate New Code")),
                    this.isAdmin(this.props.currentUser.role) &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-auto mt-3" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_forms__["n" /* TextInput */], { type: "number", name: "currentBalance", value: this.state.inputBalance, onChange: this.onReferralBalanceChange, className: "col-md-auto mb-0" }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-auto mt-3 mt-md-0" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["a" /* Button */], { onClick: this.updateReferralBalance, className: "btn-outline-primary" }, "Update Current Balance")))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "mt-4 form-fieldset-title" }, "Referrals"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-end mb-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_forms__["n" /* TextInput */], { type: "number", name: "remaining", value: remainingReferrals, onChange: this.onRemainingReferralsChange, className: "col-md-auto mb-0", addOnAfter: "Remaining (-1 means infinite)" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-auto mt-3 mt-md-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["a" /* Button */], { onClick: this.updateRemainingReferrals, className: "btn-primary" }, "Update")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-auto ml-md-auto order-first order-md-3" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-control-plaintext" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, referralCount),
                            " Peer Referrals"))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                        {
                            accessor: 'userId',
                            show: false
                        },
                        {
                            Header: 'Full Name',
                            accessor: 'fullName'
                        },
                        {
                            Header: 'Date Accepted',
                            accessor: 'referralDate',
                            Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatDate(row.value); }
                        },
                        {
                            Header: 'Amount',
                            accessor: 'referralAmount',
                            Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatCurrency(row.value); }
                        },
                        {
                            Header: 'Referral Status',
                            accessor: 'referralStatus'
                        }
                    ], data: referees, noDataText: "No referrals found" }))));
    };
    return CustomerReferrals;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state, ownProps) {
    return {
        referrals: state.user.referrals,
        currentUser: state.auth.currentUser
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps)(CustomerReferrals);
var adminRoles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, adminRoles));


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var CardDetails = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: props.className },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null,
                props.card.brand,
                " ending in ",
                props.card.last4)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            "Expires: ",
            props.card.expirationMonth,
            "/",
            props.card.expirationYear),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            "Cardholder's name: ",
            props.card.name)));
};
/* harmony default export */ __webpack_exports__["a"] = (CardDetails);


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CustomerDetailsPage__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomerPolicyPage__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CustomerNotesPage__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};










var ProspectPage = /** @class */ (function (_super) {
    __extends(ProspectPage, _super);
    function ProspectPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: true
        };
        _this.getTab = function (tabParam) {
            var tab = null;
            switch (tabParam) {
                case 'policies':
                    tab = __WEBPACK_IMPORTED_MODULE_7__CustomerPolicyPage__["a" /* default */];
                    break;
                case 'notes':
                    tab = __WEBPACK_IMPORTED_MODULE_8__CustomerNotesPage__["a" /* default */];
                    break;
                case 'details':
                default:
                    tab = __WEBPACK_IMPORTED_MODULE_6__CustomerDetailsPage__["a" /* default */];
                    break;
            }
            return tab;
        };
        _this.getTabProps = function (tabName, allProps) {
            var props;
            var actions = allProps.actions, history = allProps.history, match = allProps.match;
            var customer = allProps.customer;
            var currentUser = allProps.currentUser;
            switch (tabName) {
                case 'policies':
                    props = { match: match, history: history, currentUser: currentUser };
                    break;
                case 'notes':
                    props = { customer: customer, history: history, currentUser: currentUser, match: match };
                    break;
                case 'details':
                default:// details page
                    props = { customer: customer, currentUser: currentUser, actions: actions, match: match };
            }
            return props;
        };
        _this.getTabTitle = function (tabParam) {
            var tabTitle = '';
            switch (tabParam) {
                case 'policies':
                    tabTitle = 'Applications';
                    break;
                case 'notes':
                    tabTitle = 'Notes';
                    break;
                case 'details':
                default:
                    tabTitle = 'Contact info';
                    break;
            }
            return tabTitle;
        };
        return _this;
    }
    ProspectPage.prototype.componentDidMount = function () {
        var _this = this;
        this.props.actions.resetCustomerPolicy();
        this.props.actions
            .fetchUser(this.props.match.params.customerId)
            .then(function () { return _this.setState({ isLoading: false }); });
    };
    ProspectPage.prototype.render = function () {
        var Tab = this.getTab(this.props.match.params.tab);
        var tabTitle = this.getTabTitle(this.props.match.params.tab);
        var props = this.getTabProps(this.props.match.params.tab, this.props);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_common__["b" /* Page */], { title: this.props.customer.firstName + " " + this.props.customer.lastName + " - " + tabTitle },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_common__["d" /* PageHeader */], { className: "page-header-sm" + (this.state.isLoading ? ' loading' : '') },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "mb-0 has-loading-text" }, !this.state.isLoading && this.props.customer.firstName + " " + this.props.customer.lastName)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_common__["h" /* Tabs */], { tabs: [
                        {
                            label: 'Contact info',
                            to: "/admin/prospects/" + this.props.match.params.customerId + "/details"
                        },
                        {
                            label: 'Applications',
                            to: "/admin/prospects/" + this.props.match.params.customerId + "/policies"
                        },
                        {
                            label: 'Notes',
                            to: "/admin/prospects/" + this.props.match.params.customerId + "/notes"
                        }
                    ], match: this.props.match, disableDocTitle: true }),
                this.state.isLoading ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_common__["f" /* Spinner */], { className: "d-block mx-auto mt-4" })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tab, __assign({ className: "tab-content mt-4 mt-lg-3" }, props))))));
    };
    return ProspectPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        customer: state.user.user,
        currentUser: state.auth.currentUser
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__policy_policyActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ProspectPage);
var adminRoles = ["Admin" /* Administrator */, "Agent" /* Agent */, "Adjudicator" /* Adjudicator */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, adminRoles));


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StaffListOptions__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaffList__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









var StaffListPage = /** @class */ (function (_super) {
    __extends(StaffListPage, _super);
    function StaffListPage(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSearchDebounced = __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].debounce(function () { return _this.search(_this.state.searchterm); }, 200);
        _this.addStaff = function () {
            _this.props.actions.resetUser();
            _this.props.history.push("/admin/staff/new");
        };
        _this.onSearch = function (e) {
            _this.setState({ searchterm: e.target.value }, function () {
                _this.handleSearchDebounced();
            });
        };
        _this.search = function (searchterm) {
            var value = searchterm.toLowerCase();
            var admins = _this.props.admins.filter(function (c) {
                var fullName = c.fullName || '';
                var email = c.email || '';
                return fullName.toLowerCase().startsWith(value) || email.toLowerCase().startsWith(value);
            });
            _this.setState({ admins: admins });
        };
        _this.state = {
            admins: [],
            isLoading: true,
            searchterm: ''
        };
        return _this;
    }
    StaffListPage.prototype.componentDidMount = function () {
        var _this = this;
        this.props.actions.fetchAdmins().then(function () { return _this.setState({ admins: _this.props.admins, isLoading: false }); });
    };
    StaffListPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_common__["b" /* Page */], { title: "Staff" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_common__["d" /* PageHeader */], { title: "Staff" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__StaffListOptions__["a" /* default */], { addStaff: this.addStaff, searchterm: this.state.searchterm, onSearch: this.onSearch }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__StaffList__["a" /* default */], { admins: this.state.admins, history: this.props.history, isLoading: this.state.isLoading })))));
    };
    return StaffListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        admins: state.user.admins
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(StaffListPage);
var adminRoles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, adminRoles));


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);




var StaffListOptions = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "btn-group table-filters" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-filter" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_buttons__["a" /* Button */], { className: "btn-outline-primary", onClick: props.addStaff },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Add a staff"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["k" /* IconAdd */], null)))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { name: "search", placeholder: "Search", value: props.searchterm, onChange: props.onSearch, className: "m-0 table-search" })));
};
/* harmony default export */ __webpack_exports__["a"] = (StaffListOptions);


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var StaffList = /** @class */ (function (_super) {
    __extends(StaffList, _super);
    function StaffList(props) {
        var _this = _super.call(this, props) || this;
        _this.onPageChange = function (pageIndex) {
            _this.setState({ page: pageIndex });
        };
        _this.state = {
            page: 0
        };
        return _this;
    }
    StaffList.prototype.render = function () {
        var props = __rest(this.props, []);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                {
                    Header: 'Employee Id',
                    accessor: 'id'
                },
                {
                    Header: 'Full Name',
                    accessor: 'fullName'
                },
                {
                    Header: 'Email',
                    accessor: 'email'
                },
                {
                    Header: 'Actions',
                    className: 'p-0 td-actions',
                    width: 100,
                    Cell: function (rowInfo) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["b" /* IconButton */], { title: "Edit staff", className: "btn-icon-secondary btn-icon-td", onClick: function (e) {
                                e.stopPropagation(); // Prevent onClick conflict with tr onclick
                                props.history.push("/admin/staff/" + rowInfo.row.id + "/details");
                            } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["m" /* IconArrowRight */], null)));
                    }
                }
            ], data: props.admins, loading: props.isLoading, getTrProps: function (state, rowInfo, column) {
                return {
                    className: 'tr interactive',
                    onClick: function () {
                        props.history.push("/admin/staff/" + rowInfo.row.id + "/details");
                    }
                };
            }, noDataText: "No staff found", onPageChange: this.onPageChange, page: this.state.page }));
    };
    return StaffList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (StaffList);


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaffDetailsPage__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_SecurityPage__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var StaffPage = /** @class */ (function (_super) {
    __extends(StaffPage, _super);
    function StaffPage(props) {
        var _this = _super.call(this, props) || this;
        _this.getTab = function (tabParam) {
            var tab = null;
            switch (tabParam) {
                case 'security':
                    tab = __WEBPACK_IMPORTED_MODULE_6__common_SecurityPage__["a" /* default */];
                    break;
                case 'details':
                default:
                    tab = __WEBPACK_IMPORTED_MODULE_5__StaffDetailsPage__["a" /* default */];
                    break;
            }
            return tab;
        };
        _this.getTabTitle = function (tabParam) {
            var tabTitle = '';
            switch (tabParam) {
                case 'security':
                    tabTitle = 'Manage Security';
                    break;
                case 'details':
                default:
                    tabTitle = 'Contact info';
                    break;
            }
            return tabTitle;
        };
        _this.renderNewStaffPage = function () {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["b" /* Page */], { title: "Add new staff" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["c" /* PageContent */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["d" /* PageHeader */], { title: "Add new staff" }),
                    _this.state.isLoading ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["f" /* Spinner */], { className: "d-block mx-auto mt-4" })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__StaffDetailsPage__["a" /* default */], __assign({ saveRedirect: "/admin/staff", className: "tab-content mt-4 mt-lg-3" }, _this.props))))));
        };
        _this.renderExistingStaffPage = function () {
            var Tab = _this.getTab(_this.props.match.params.tab);
            var tabTitle = _this.getTabTitle(_this.props.match.params.tab);
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["b" /* Page */], { title: _this.props.user.firstName + " " + _this.props.user.lastName + " - " + tabTitle },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["c" /* PageContent */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["d" /* PageHeader */], { className: "page-header-sm" + (_this.state.isLoading ? ' loading' : '') },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "mb-0 has-loading-text" }, !_this.state.isLoading && _this.props.user.firstName + " " + _this.props.user.lastName)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["h" /* Tabs */], { tabs: [
                            {
                                label: 'Contact info',
                                to: "/admin/staff/" + _this.props.match.params.userId + "/details"
                            },
                            {
                                label: 'Manage Security',
                                to: "/admin/staff/" + _this.props.match.params.userId + "/security"
                            }
                        ], match: _this.props.match, disableDocTitle: true }),
                    _this.state.isLoading ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["f" /* Spinner */], { className: "d-block mx-auto mt-4" })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tab, __assign({ className: "tab-content mt-4 mt-lg-3" }, _this.props))))));
        };
        _this.state = {
            isLoading: true
        };
        return _this;
    }
    StaffPage.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.match.params.userId === 'new') {
            this.setState({ isLoading: false });
        }
        else {
            this.props.actions.fetchUser(this.props.match.params.userId).then(function () { return _this.setState({ isLoading: false }); });
        }
    };
    StaffPage.prototype.render = function () {
        if (this.props.match.params.userId === 'new') {
            return this.renderNewStaffPage();
        }
        else {
            return this.renderExistingStaffPage();
        }
    };
    return StaffPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        user: state.user.user
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(StaffPage);
var adminRoles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, adminRoles));


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StaffDetailsForm__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var StaffDetailsPage = /** @class */ (function (_super) {
    __extends(StaffDetailsPage, _super);
    function StaffDetailsPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errors = {
            email: {},
            mailingPostalCode: {},
            billingPostalCode: {}
        };
        _this.onUserChange = function (e) {
            var user = __assign({}, _this.props.user, (_a = {}, _a[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value, _a));
            _this.props.actions.setUser(user);
            var _a;
        };
        _this.validate = function () {
            // true means invalid
            return {
                email: __WEBPACK_IMPORTED_MODULE_4__common_utils__["k" /* Validation */].validateEmail(_this.props.user.email),
                mailingPostalCode: __WEBPACK_IMPORTED_MODULE_4__common_utils__["k" /* Validation */]
                    .validatePostalCode(_this.props.user.mailingPostalCode, 'Mailing postal code is not valid.'),
                billingPostalCode: __WEBPACK_IMPORTED_MODULE_4__common_utils__["k" /* Validation */]
                    .validatePostalCode(_this.props.user.billingPostalCode, 'Billing postal code is not valid.')
            };
        };
        _this.save = function () {
            var user = __assign({}, _this.props.user);
            if (user.isSameAddress) {
                user.billingAddress = user.mailingAddress;
                user.billingCity = user.mailingCity;
                user.billingProvince = user.mailingProvince;
                user.billingPostalCode = user.mailingPostalCode;
                user.billingCountry = user.mailingCountry;
            }
            _this.props.actions.saveStaff(user)
                .then(function () {
                __WEBPACK_IMPORTED_MODULE_1_toastr__["success"]('Saved!');
                if (_this.props.saveRedirect) {
                    _this.props.history.push(_this.props.saveRedirect);
                }
            });
        };
        _this.isSaveDisabled = function () {
            if (_this.errors.email.hasError ||
                _this.errors.mailingPostalCode.hasError ||
                (!_this.props.user.isSameAddress && _this.errors.billingPostalCode.hasError)) {
                return true;
            }
            return false;
        };
        return _this;
    }
    StaffDetailsPage.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: this.props.className },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__StaffDetailsForm__["a" /* default */], { user: this.props.user, onUserChange: this.onUserChange, errors: this.errors }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons_Button__["a" /* default */], { onClick: this.save, disabled: this.isSaveDisabled(), className: "btn-primary mt-4" }, "Save")));
    };
    return StaffDetailsPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (StaffDetailsPage);


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var StaffDetailsForm = /** @class */ (function (_super) {
    __extends(StaffDetailsForm, _super);
    function StaffDetailsForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBlur = function (field) { return function (evt) {
            _this.setState({
                touched: __assign({}, _this.state.touched, (_a = {}, _a[field] = true, _a))
            });
            var _a;
        }; };
        _this.state = {
            touched: {
                email: false
            }
        };
        return _this;
    }
    StaffDetailsForm.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: this.props.className },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Contact Information"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "First Name", name: "firstName", onChange: this.props.onUserChange, value: this.props.user.firstName, className: "col-md-6" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Last Name", name: "lastName", onChange: this.props.onUserChange, value: this.props.user.lastName, className: "col-md-6" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Email", name: "email", onBlur: this.handleBlur('email'), onChange: this.props.onUserChange, value: this.props.user.email, className: "col-md-6 mb-md-2", error: __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].shouldMarkError(this.props.errors.email, this.state.touched.email)
                            ? this.props.errors.email
                            : undefined }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_forms__["n" /* TextInput */], { labelText: "Employee ID", name: "id", value: this.props.user.id, className: "col-md-6", disabled: true })))));
    };
    return StaffDetailsForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (StaffDetailsForm);


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_icons__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};





var GroupListPage = /** @class */ (function (_super) {
    __extends(GroupListPage, _super);
    function GroupListPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupListPage.prototype.render = function () {
        var props = __rest(this.props, []);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["b" /* Page */], { title: "Groups" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["d" /* PageHeader */], { title: "Groups", className: "page-header-sm" }),
                props.groups &&
                    props.groups.length > 0 && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 col-lg-4" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { name: "search", placeholder: "Search", className: "m-0" })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                        {
                            accessor: 'id',
                            show: false
                        },
                        {
                            Header: 'Group name',
                            accessor: 'name'
                        },
                        {
                            Header: 'Actions',
                            className: 'p-0 td-actions',
                            Cell: function (rowInfo) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons__["b" /* IconButton */], { title: "View rate table", className: "btn-icon-secondary btn-icon-td", onClick: function (e) {
                                    e.stopPropagation(); // Prevent onClick conflict with tr onclick
                                    props.history.push("/admin/group/" + rowInfo.row.id);
                                } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_icons__["x" /* IconEdit */], null))); }
                        }
                    ], getTrProps: function (state, rowInfo, column) {
                        return {
                            className: 'tr interactive',
                            onClick: function () { return props.history.push("/admin/group/" + rowInfo.row.id); }
                        };
                    }, data: props.groups, noDataText: "No groups found" }))));
    };
    return GroupListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (GroupListPage);


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var GroupDetailPage = /** @class */ (function (_super) {
    __extends(GroupDetailPage, _super);
    function GroupDetailPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupDetailPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["b" /* Page */], { title: "Group X" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["d" /* PageHeader */], { title: "Group X Details", className: "page-header-sm" }),
                "Content goes here")));
    };
    return GroupDetailPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (GroupDetailPage);


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__adjudication_AdjudicationList__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_userActions__ = __webpack_require__(11);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







// import Button from '../../components/buttons/Button';



var AdjudicationListPage = /** @class */ (function (_super) {
    __extends(AdjudicationListPage, _super);
    function AdjudicationListPage(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSearchDebounced = __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].debounce(function () { return _this.search(_this.state.searchterm); }, 200);
        _this.loadData = function () {
            _this.setState({ isLoading: true });
            _this.props.actions.fetchSoftDeclinedCustomers()
                .then(function () {
                var displayCustomers = _this.props.softDeclinedCustomers
                    .filter(function (c) { return c.customerPolicy.adjudicationStatusId !== __WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* AdjudicationStatus */].Rejected; });
                _this.setState({ isLoading: false, softDeclinedCustomers: displayCustomers });
            });
        };
        _this.onSearch = function (e) {
            _this.setState({ searchterm: e.target.value }, function () {
                _this.handleSearchDebounced();
            });
        };
        _this.search = function (searchterm) {
            var value = searchterm.toLowerCase();
            var displayCustomers = _this.props.softDeclinedCustomers
                .filter(function (c) { return c.customerPolicy.adjudicationStatusId !== __WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* AdjudicationStatus */].Rejected; });
            var softDeclinedCustomers = displayCustomers.filter(function (c) {
                var fullName = c.fullName || '';
                var email = c.email || '';
                return fullName.toLowerCase().startsWith(value) || email.toLowerCase().startsWith(value);
            });
            _this.setState({ softDeclinedCustomers: softDeclinedCustomers });
        };
        _this.onAddNotesClick = function (e, userId) {
            e.stopPropagation();
            _this.props.history.push("/admin/prospects/" + userId + "/notes");
        };
        _this.state = {
            isLoading: true,
            searchterm: '',
            softDeclinedCustomers: []
        };
        return _this;
    }
    AdjudicationListPage.prototype.componentDidMount = function () {
        this.loadData();
    };
    /*
    clearQueue = () => {
        this.setState({ isLoading: true });
        this.props.actions.clearAdjudicationQueue()
        .then(() => this.loadData())
        .then(() => toastr.success('Adjudication queue cleared'))
        .then(() => this.setState({ isLoading: false }));
    }
    */
    AdjudicationListPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], { title: "Soft Declined Customers" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: "Soft Declined Customers" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row mb-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-sm-4" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_forms__["n" /* TextInput */], { name: "search", placeholder: "Search", value: this.state.searchterm, onChange: this.onSearch, className: "mb-3 mb-sm-0 table-search" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__adjudication_AdjudicationList__["a" /* default */], { softDeclinedCustomers: this.state.softDeclinedCustomers, history: this.props.history, isLoading: this.state.isLoading, onAddNotesClick: this.onAddNotesClick, setRedirectFromAdjudication: this.props.actions.setRedirectFromAdjudication }))));
    };
    return AdjudicationListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        softDeclinedCustomers: state.user.softDeclinedCustomers
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_8__policy_policyActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(AdjudicationListPage);
var adminRoles = ["Admin" /* Administrator */, "Agent" /* Agent */, "Adjudicator" /* Adjudicator */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, adminRoles));


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};





var AdjudicationList = /** @class */ (function (_super) {
    __extends(AdjudicationList, _super);
    function AdjudicationList(props) {
        var _this = _super.call(this, props) || this;
        _this.onPageChange = function (pageIndex) {
            _this.setState({ page: pageIndex });
        };
        _this.state = {
            page: 0
        };
        return _this;
    }
    AdjudicationList.prototype.render = function () {
        var props = __rest(this.props, []);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                    {
                        accessor: 'id',
                        show: false
                    },
                    {
                        Header: 'Full Name',
                        accessor: 'fullName'
                    },
                    {
                        Header: 'Policy Number',
                        accessor: 'customerPolicy.number'
                    },
                    {
                        Header: 'Email',
                        accessor: 'email',
                        Cell: function (rowInfo) {
                            if (rowInfo.original.email) {
                                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "mailto:" + rowInfo.original.email, onClick: function (e) { return e.stopPropagation(); } }, rowInfo.value);
                            }
                            else {
                                return rowInfo.value;
                            }
                        }
                    },
                    {
                        Header: 'Created Date',
                        accessor: 'createdDate',
                        Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatDateAsUTC(row.value); }
                    },
                    {
                        Header: 'Status',
                        accessor: 'customerPolicy.adjudicationStatusId',
                        Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].getPickListItemDescription(row.value); }
                    },
                    {
                        Header: 'Actions',
                        className: 'p-0 td-actions',
                        width: 120,
                        Cell: function (rowInfo) {
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["b" /* IconButton */], { title: "Add Notes", className: "btn-icon-secondary btn-icon-td", onClick: function (e) {
                                        props.setRedirectFromAdjudication(true);
                                        props.onAddNotesClick(e, rowInfo.row.id);
                                    } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["x" /* IconEdit */], null))));
                        }
                    }
                ], data: props.softDeclinedCustomers, loading: props.isLoading, getTrProps: function (state, rowInfo, column) {
                    return {
                        className: 'tr interactive',
                        onClick: function () {
                            props.setRedirectFromAdjudication(true);
                            return props.history.push("/admin/prospects/" + rowInfo.original.id + "/details");
                        }
                    };
                }, noDataText: "No customers found", onPageChange: this.onPageChange, page: this.state.page })));
    };
    return AdjudicationList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AdjudicationList);


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_ga__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__quoting_enrollment_billing_review_BillingForm__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__admin_common_AdminValidateReferralCode__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__auth_authActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__payment_paymentActions__ = __webpack_require__(32);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
















var CustomerApplicationPaymentPage = /** @class */ (function (_super) {
    __extends(CustomerApplicationPaymentPage, _super);
    function CustomerApplicationPaymentPage(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = { mailingPostalCode: {}, billingPostalCode: {} };
        _this.save = function () {
            var user = __assign({}, _this.props.user);
            if (user.isSameAddress) {
                user.billingAddress = user.mailingAddress;
                user.billingCity = user.mailingCity;
                user.billingProvince = user.mailingProvince;
                user.billingPostalCode = user.mailingPostalCode;
                user.billingCountry = user.mailingCountry;
            }
            var p1 = _this.props.actions.saveUser(user);
            var p2 = _this.props.actions.saveCustomerPolicy(_this.props.customerPolicy);
            return Promise.all([p1, p2]);
        };
        _this.enroll = function () {
            _this.setState({ isLoading: true });
            _this.save()
                .then(function () {
                var card = {
                    name: _this.props.paymentDetails.ccCardholderName,
                    address_line1: _this.props.user.billingAddress,
                    address_city: _this.props.user.billingCity,
                    address_state: _this.props.user.billingProvince,
                    address_zip: _this.props.user.billingPostalCode,
                };
                return _this.props.stripe.createToken(card);
            })
                .then(function (result) {
                if (result.error) {
                    throw (result.error.message);
                }
                else {
                    return result.token;
                }
            })
                .then(function (token) {
                var resetPasswordUrl = _this.props.actions.getResetPasswordUrlForEmail();
                // true means skip decline checker on server side
                _this.props.actions.createNewCustomerSubscription(_this.props.user.id, _this.props.customerPolicy.id, token.id, _this.props.referrals.referralCode, true, resetPasswordUrl)
                    .then(function () { return _this.sendAnalyticsData(); })
                    .then(function () { return _this.redirect(); });
            })
                .catch(function (errorMessage) {
                __WEBPACK_IMPORTED_MODULE_3_toastr__["error"](errorMessage);
                _this.setState({ isLoading: false });
            });
        };
        _this.sendAnalyticsData = function () {
            var user = {
                userId: _this.props.user.id,
                term: _this.props.customerPolicy.term,
                rate: _this.props.customerPolicy.rate,
                coverageAmount: _this.props.customerPolicy.coverageAmount,
                age: __WEBPACK_IMPORTED_MODULE_11__common_utils__["m" /* default */].getAgeFromBirthdate(_this.props.user.birthDate),
                gender: _this.props.user.gender,
                smoker: _this.props.answers.find(function (a) { return a.questionName === 'isSmoker'; }).answer === 'True'
            };
            __WEBPACK_IMPORTED_MODULE_4_react_ga__["event"]({
                category: 'User',
                action: 'signup',
                label: JSON.stringify(user)
            });
        };
        _this.redirect = function () {
            _this.setState({ isLoading: false });
            __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Policy Activated Successfully');
            if (_this.props.redirectFromAdjudication) {
                return _this.props.history.push("/admin/adjudication");
            }
            else {
                return _this.props.history.push("/admin/customers");
            }
        };
        _this.isNextDisabled = function () {
            if (_this.state.isLoading) {
                return true;
            }
            if (_this.errors.mailingPostalCode.hasError ||
                (!_this.props.user.isSameAddress && _this.errors.billingPostalCode.hasError)) {
                return true;
            }
            return (!_this.state.card_number ||
                !_this.state.card_cvv ||
                !_this.state.card_expiry ||
                !_this.props.paymentDetails.ccCardholderName ||
                !_this.props.user.mailingAddress ||
                !_this.props.user.mailingCity ||
                !_this.props.user.mailingProvince ||
                !_this.props.user.mailingPostalCode ||
                !_this.props.user.mailingCountry ||
                (!_this.props.user.isSameAddress &&
                    (!_this.props.user.billingAddress ||
                        !_this.props.user.billingCity ||
                        !_this.props.user.billingProvince ||
                        !_this.props.user.billingPostalCode ||
                        !_this.props.user.billingCountry)) ||
                !_this.props.user.phoneNumber);
        };
        _this.validate = function () {
            // true means invalid
            return {
                mailingPostalCode: __WEBPACK_IMPORTED_MODULE_11__common_utils__["k" /* Validation */]
                    .validatePostalCode(_this.props.user.mailingPostalCode, 'Mailing postal code is not valid.'),
                billingPostalCode: __WEBPACK_IMPORTED_MODULE_11__common_utils__["k" /* Validation */]
                    .validatePostalCode(_this.props.user.billingPostalCode, 'Billing postal code is not valid.')
            };
        };
        _this.onStripeElementChange = function (element, name) {
            if (!element.empty && element.complete) {
                _this.setState((_a = {}, _a[name] = true, _a));
            }
            else {
                _this.setState((_b = {}, _b[name] = false, _b));
            }
            var _a, _b;
        };
        _this.onPhoneKeyUp = function (e) {
            var phone = e.target.value;
            phone = phone
                .match(/\d*/g)
                .join('')
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
                .slice(1)
                .join('-')
                .replace(/-*$/g, '');
            var user = __assign({}, _this.props.user, (_a = {}, _a[e.target.name] = phone, _a));
            _this.props.actions.setUser(user);
            var _a;
        };
        _this.onUserChange = function (e) {
            var user = __assign({}, _this.props.user, (_a = {}, _a[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value, _a));
            _this.props.actions.setUser(user);
            var _a;
        };
        _this.onPolicyChange = function (e) {
            var value = __WEBPACK_IMPORTED_MODULE_11__common_utils__["m" /* default */].parseValueFromEvent(e);
            var customerPolicy = __assign({}, _this.props.customerPolicy, (_a = {}, _a[e.target.name] = value, _a));
            _this.props.actions.setCustomerPolicy(customerPolicy);
            var _a;
        };
        _this.back = function (e) {
            _this.props.history
                .push("/admin/prospects/" + _this.props.match.params.customerId + "/policies/" + _this.props.match.params.pageId);
        };
        _this.isCustomer = function (roles) {
            if (!roles) {
                return false;
            }
            else {
                return roles.indexOf("Customer" /* Customer */) > -1 && roles.length === 1;
            }
        };
        _this.state = {
            card_number: false,
            card_cvv: false,
            card_expiry: false,
            isLoading: false
        };
        return _this;
    }
    CustomerApplicationPaymentPage.prototype.componentDidMount = function () {
        var _this = this;
        // window.onpopstate = () => null;
        this.setState({ isLoading: true });
        // the reason it needs to fetch answer again is that answers gets reset when answerPage unmount
        this.props.actions.fetchPolicyAnswer(this.props.customerPolicy.id)
            .then(function () { return _this.setState({ isLoading: false }); });
    };
    CustomerApplicationPaymentPage.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_common__["b" /* Page */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set", hidden: false },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("fieldset", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Policy summary"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled d-lg-flex mb-0" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "mb-3 mb-lg-0 mr-lg-5 strong text-secondary" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Coverage"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "xlarge" },
                                        __WEBPACK_IMPORTED_MODULE_11__common_utils__["m" /* default */].formatCurrency(this.props.customerPolicy.coverageAmount, 0),
                                        " CAD")),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "mb-3 mb-lg-0 mr-lg-5 strong text-secondary" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Term"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "xlarge" },
                                        this.props.customerPolicy.term,
                                        " years")),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Monthly payment"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "xlarge" },
                                        __WEBPACK_IMPORTED_MODULE_11__common_utils__["m" /* default */].formatCurrency(this.props.customerPolicy.rate, 2),
                                        "/month"))))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__admin_common_AdminValidateReferralCode__["a" /* default */], null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("fieldset", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Billing Information"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__quoting_enrollment_billing_review_BillingForm__["a" /* default */], { actions: this.props.actions, paymentDetails: this.props.paymentDetails, user: this.props.user, customerPolicy: this.props.customerPolicy, onUserChange: this.onUserChange, onPolicyChange: this.onPolicyChange, onStripeElementChange: this.onStripeElementChange, onPhoneKeyUp: this.onPhoneKeyUp, errors: this.errors, isCustomer: this.isCustomer(this.props.currentUser.role) }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons_Button__["a" /* default */], { onClick: this.back, className: "btn-outline-primary workflow-progress-action", disabled: this.state.isLoading },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Go Back")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons_Button__["a" /* default */], { onClick: this.enroll, disabled: this.isNextDisabled(), className: "btn-primary workflow-progress-action" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Activate Policy"),
                            !this.state.isLoading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_icons__["p" /* IconCheck */], null),
                            this.state.isLoading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_common__["f" /* Spinner */], null)))))));
    };
    return CustomerApplicationPaymentPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        referrals: state.user.referrals,
        user: state.user.user,
        customerPolicy: state.policy.customerPolicy,
        answers: state.policy.answers.answerList,
        stripe: state.payment.stripe,
        paymentDetails: state.payment.details,
        currentUser: state.auth.currentUser,
        redirectFromAdjudication: state.policy.redirectFromAdjudication
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_13__user_userActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__policy_policyActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__payment_paymentActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__auth_authActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CustomerApplicationPaymentPage);
var adminRoles = ["Admin" /* Administrator */, "Agent" /* Agent */, "Adjudicator" /* Adjudicator */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, adminRoles));


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quoting_quotingActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var AdminValidateReferralCode = /** @class */ (function (_super) {
    __extends(AdminValidateReferralCode, _super);
    function AdminValidateReferralCode(props) {
        var _this = _super.call(this, props) || this;
        _this.validateReferralDebounced = __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].debounce(function () {
            _this.validateReferral(_this.props.referrals.referralCode);
        });
        _this.onValidateReferral = function (e) {
            _this.props.actions.setReferralCode(e.target.value);
            _this.validateReferralDebounced();
        };
        _this.validateReferral = function (referralCode) {
            if (referralCode != null) {
                _this.props.actions.validateReferralCode(referralCode, _this.props.user.id);
            }
        };
        return _this;
    }
    AdminValidateReferralCode.prototype.componentDidMount = function () {
        this.validateReferral(this.props.referrals.referralCode);
    };
    AdminValidateReferralCode.prototype.checkExistingPolicy = function () {
        var _this = this;
        return this.props.policies.some(function (p) { return p.customerId === _this.props.user.userId &&
            p.isActive && p.statusId === __WEBPACK_IMPORTED_MODULE_7__common_utils__["h" /* PolicyStatus */].Active; });
    };
    AdminValidateReferralCode.prototype.render = function () {
        return (!this.checkExistingPolicy() &&
            (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-4" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Referral code"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-lg-8 form-group mb-0" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["j" /* Label */], null, "Enter customer's referral code here if he or she has one"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "position-relative" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_forms__["n" /* TextInput */], { name: "remaining", placeholder: "Enter referral code", value: this.props.referrals.referralCode, onChange: this.onValidateReferral, className: "mb-0 enrollment-referral-field" }),
                                this.getReferralValidityMessage())))))));
    };
    AdminValidateReferralCode.prototype.getReferralValidityMessage = function () {
        var msg;
        if (this.props.referrals.referralCode) {
            if (this.props.validReferral) {
                msg = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_icons__["p" /* IconCheck */], { className: "enrollment-referral-icon text-success" });
            }
            else {
                msg = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-1" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_icons__["z" /* IconErrorOutline */], { className: "enrollment-referral-icon flush-right text-danger" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "text-danger" }, "The referral code is invalid")));
            }
        }
        return msg;
    };
    return AdminValidateReferralCode;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        validReferral: state.quoting.validReferral,
        referrals: state.user.referrals,
        user: state.user.user,
        policies: state.policy.policies
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__quoting_quotingActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(AdminValidateReferralCode);
/* harmony default export */ __webpack_exports__["a"] = (connector);


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__report_reportActions__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var ReferralsPage = /** @class */ (function (_super) {
    __extends(ReferralsPage, _super);
    function ReferralsPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.download = function () {
            _this.props.actions.fetchReferralReport().then(function () {
                var formattedReferrals = _this.formatData(_this.props.referrals);
                __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].downloadCsv(formattedReferrals, 'Referrals.csv');
            });
        };
        _this.formatData = function (referrals) {
            var formattedReferrals = referrals.map(function (r) {
                return {
                    Customer: r.customerName,
                    Referred: r.referredName,
                    Date: __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatDate(r.date),
                    Amount: __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatCurrency(r.amount),
                    ReferralStatus: r.referralStatus
                };
            });
            return formattedReferrals;
        };
        return _this;
    }
    ReferralsPage.prototype.componentDidMount = function () {
        this.props.actions.fetchReferralReport();
    };
    ReferralsPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], { title: "Referrals" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: "Referrals" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set" },
                    this.props.referrals.length > 0 &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "btn-group table-filters" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-filter" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { className: "btn-outline-primary", onClick: this.download },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Download"))))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                            {
                                Header: 'Customer',
                                accessor: 'customerName'
                            },
                            {
                                Header: 'Referred',
                                accessor: 'referredName'
                            },
                            {
                                Header: 'Date',
                                accessor: 'date',
                                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatDate(row.value); }
                            },
                            {
                                Header: 'Amount',
                                accessor: 'amount',
                                Cell: function (row) { return "" + __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatCurrency(row.value); }
                            },
                            {
                                Header: 'Referral Status',
                                accessor: 'referralStatus'
                            }
                        ], getTrProps: function (state, rowInfo, column) {
                            return {
                                className: 'tr'
                            };
                        }, data: this.props.referrals, noDataText: "No referrals", resizable: true })))));
    };
    return ReferralsPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        referrals: state.report.referrals
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__report_reportActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ReferralsPage);
var roles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, roles));


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__report_reportActions__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









var FinancialExportPage = /** @class */ (function (_super) {
    __extends(FinancialExportPage, _super);
    function FinancialExportPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            fromDate: undefined,
            toDate: undefined
        };
        _this.onFilterChange = function (e) {
            _this.setState((_a = {}, _a[e.target.name] = e.target.value, _a));
            var _a;
        };
        _this.download = function () {
            _this.props.actions.fetchFinancialExport(_this.state.fromDate, _this.state.toDate).then(function () {
                var formattedFinancials = _this.formatData(_this.props.financials);
                __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].downloadCsv(formattedFinancials, 'FinancialExport.csv');
            });
        };
        _this.formatData = function (financials) {
            var formattedFinancials = financials.map(function (f) {
                return {
                    UserId: f.userId,
                    Name: f.name,
                    HasSpouse: f.hasSpouse,
                    Mortgage: __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatCurrency(f.mortgage),
                    OtherDebt: __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatCurrency(f.otherDebt),
                    BeneficiaryAmountPerYear: f.beneficiaryAmountPerYear,
                    BeneficiaryAmountTotalYears: f.beneficiaryAmountTotalYears,
                    SavingsAmount: __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatCurrency(f.savingsAmount),
                    IsSmoker: f.isSmoker,
                    Age: f.age,
                    PolicyNumber: f.policyNumber,
                    EffectiveDate: __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatDateAsUTC(f.effectiveDate),
                    EndDate: __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatDateAsUTC(f.endDate),
                    CoverageAmount: __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatCurrency(f.coverageAmount),
                    Rate: __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatCurrency(f.rate),
                    Term: f.term,
                    Status: __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].getPickListItemDescription(f.statusId)
                };
            });
            return formattedFinancials;
        };
        return _this;
    }
    FinancialExportPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], { title: "Financial export" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: "Financial export", className: "page-header-sm" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Report Filters"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset mb-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_forms__["a" /* BirthDatePicker */], { className: "col-sm-6 col-lg-3", labelText: "From", name: "fromDate", placeholder: "YYYY-MM-DD", value: this.state.fromDate, onChange: this.onFilterChange, required: true }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_forms__["a" /* BirthDatePicker */], { className: "col-sm-6 col-lg-3", labelText: "To", name: "toDate", placeholder: "YYYY-MM-DD", value: this.state.toDate, onChange: this.onFilterChange, required: true })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row col-sm-12" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { className: "btn-primary", onClick: this.download, disabled: this.state.fromDate == null || this.state.toDate == null },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Download")))))));
    };
    return FinancialExportPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        financials: state.report.financials
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__report_reportActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(FinancialExportPage);
var roles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, roles));


/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__report_reportActions__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









var UserActivityPage = /** @class */ (function (_super) {
    __extends(UserActivityPage, _super);
    function UserActivityPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            fromDate: undefined,
            toDate: undefined
        };
        _this.onFilterChange = function (e) {
            _this.setState((_a = {}, _a[e.target.name] = e.target.value, _a));
            var _a;
        };
        // not called by anywhere??
        _this.preview = function () {
            _this.props.actions.fetchUserActivities(_this.state.fromDate, _this.state.toDate);
        };
        _this.download = function () {
            _this.props.actions.fetchUserActivities(_this.state.fromDate, _this.state.toDate)
                .then(function () {
                var formattedUsers = _this.formatData(_this.props.users);
                __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].downloadCsv(formattedUsers, 'UserActivity.csv');
            });
        };
        _this.formatData = function (users) {
            var formattedUsers = users.map(function (u) {
                var policies = u.policies ? u.policies.map(function (p) { return p.number; }) : [];
                return _a = {
                        Name: u.fullName,
                        Email: u.email
                    },
                    _a['Sex'] = __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatFirstUpperCase(u.gender),
                    _a.Birthdate = __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatDate(u.birthDate),
                    _a['Sign up date'] = __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatDate(u.createdDate),
                    _a.Policies = policies,
                    _a;
                var _a;
            });
            return formattedUsers;
        };
        return _this;
    }
    UserActivityPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], { title: "User activity" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: "User activity" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Report Filters"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset mb-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_forms__["a" /* BirthDatePicker */], { className: "col-sm-6 col-lg-3", labelText: "From", name: "fromDate", placeholder: "YYYY-MM-DD", value: this.state.fromDate, onChange: this.onFilterChange, required: true }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_forms__["a" /* BirthDatePicker */], { className: "col-sm-6 col-lg-3", labelText: "To", name: "toDate", placeholder: "YYYY-MM-DD", value: this.state.toDate, onChange: this.onFilterChange, required: true })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row col-sm-12" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { className: "btn-primary", onClick: this.download, disabled: this.state.fromDate === null || this.state.toDate === null ||
                                !this.state.fromDate || !this.state.toDate },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Download")))))));
    };
    return UserActivityPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        users: state.report.users,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__report_reportActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(UserActivityPage);
var roles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, roles));


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__report_reportActions__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};









var FailedPaymentsListPage = /** @class */ (function (_super) {
    __extends(FailedPaymentsListPage, _super);
    function FailedPaymentsListPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.download = function () {
            var formattedPayments = _this.formatData(_this.props.failedPayments);
            __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].downloadCsv(formattedPayments, 'FailedPayments.csv');
        };
        _this.formatData = function (failedPayments) {
            var formattedPayments = failedPayments.map(function (p) {
                return _a = {
                        Date: __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatDate(p.date)
                    },
                    _a['Invoice #'] = p.stripeInvoiceNumber,
                    _a.Amount = __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatCurrency(p.amount),
                    _a;
                var _a;
            });
            return formattedPayments;
        };
        return _this;
    }
    FailedPaymentsListPage.prototype.componentDidMount = function () {
        this.props.actions.fetchFailedPayments();
    };
    FailedPaymentsListPage.prototype.render = function () {
        var props = __rest(this.props, []);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["b" /* Page */], { title: "Failed payments" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["c" /* PageContent */], { sectionClassName: "section-lg" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["d" /* PageHeader */], { title: "Failed Payments" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set" },
                    props.failedPayments.length > 0 &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "btn-group table-filters" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-filter" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { className: "btn-outline-primary", onClick: this.download },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Download"))))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                            {
                                accessor: 'id',
                                show: false
                            },
                            {
                                Header: 'Date',
                                accessor: 'date',
                                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatDate(row.value); }
                            },
                            {
                                Header: 'Invoice #',
                                accessor: 'stripeInvoiceNumber'
                            },
                            {
                                Header: 'Amount',
                                accessor: 'amount',
                                Cell: function (row) { return "" + __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatCurrency(row.value); }
                            },
                            {
                                Header: 'Actions',
                                className: 'p-0 td-actions',
                                Cell: function (row) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["b" /* IconButton */], { title: "View payment", className: "btn-icon-secondary btn-icon-td", onClick: function (e) {
                                        e.stopPropagation(); // Prevent onClick conflict with tr onclick
                                        props.history.push("/admin/reports/failed-payments/" + row.original.stripeInvoiceNumber);
                                    } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_icons__["m" /* IconArrowRight */], null))); }
                            }
                        ], getTrProps: function (state, rowInfo, column) {
                            return {
                                className: 'tr interactive',
                                onClick: function () { return props.history.push("/admin/reports/failed-payments/" + rowInfo.row.stripeInvoiceNumber); }
                            };
                        }, data: props.failedPayments, noDataText: "No failed payments" })))));
    };
    return FailedPaymentsListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        failedPayments: state.report.failedPayments
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__report_reportActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(FailedPaymentsListPage);
var roles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, roles));


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__payment_paymentActions__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FailedPaymentDetails__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FailedPaymentUserDetails__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__payment_PaymentDetailsForm__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};












var FailedPaymentDetailsPage = /** @class */ (function (_super) {
    __extends(FailedPaymentDetailsPage, _super);
    function FailedPaymentDetailsPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isPaymentLoading: false
        };
        _this.makePayment = function () {
            _this.setState({ isPaymentLoading: true });
            _this.props.stripe
                .createToken({ name: _this.props.details.ccCardholderName })
                .then(function (result) {
                if (result.error) {
                    __WEBPACK_IMPORTED_MODULE_3_toastr__["error"](result.error.message);
                }
                else {
                    // Send the token to server
                    return _this.props.actions.payInvoice(_this.props.payment.stripeInvoiceId, result.token).then(function () {
                        __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Payment sent!');
                    });
                }
            })
                .then(function () { return _this.setState({ isPaymentLoading: false }); });
        };
        return _this;
    }
    FailedPaymentDetailsPage.prototype.componentDidMount = function () {
        var _this = this;
        this.props.actions
            .fetchPayment(this.props.match.params.id)
            .then(function () { return _this.props.actions.fetchUserByPolicyId(_this.props.payment.policyId); });
    };
    FailedPaymentDetailsPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_common__["b" /* Page */], { title: "Failed payments" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_common__["d" /* PageHeader */], { title: "Failed payments", className: "page-header-sm" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__FailedPaymentDetails__["a" /* default */], { className: "col-md-6 mb-4", payment: this.props.payment }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__FailedPaymentUserDetails__["a" /* default */], { className: "col-md-6", user: this.props.user })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__payment_PaymentDetailsForm__["a" /* default */], { actions: this.props.actions, details: this.props.details })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_buttons__["a" /* Button */], { className: "btn-primary mt-4", type: "button", onClick: this.makePayment, disabled: this.state.isPaymentLoading }, "Retry payment"))));
    };
    return FailedPaymentDetailsPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        details: state.payment.details,
        payment: state.payment.payment,
        stripe: state.payment.stripe,
        user: state.user.user
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__payment_paymentActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(FailedPaymentDetailsPage);
var roles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, roles));


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__(1);


var FailedPaymentDetails = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: props.className },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Payment Details"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled mb-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Date:"),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_1__common_utils__["m" /* default */].formatDate(props.payment.date)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Invoice #:"),
                    " ",
                    props.payment.stripeInvoiceNumber),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Amount:"),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_1__common_utils__["m" /* default */].formatCurrency(props.payment.amount)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Status:"),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_1__common_utils__["m" /* default */].getPickListItemDescription(props.payment.statusId))))));
};
/* harmony default export */ __webpack_exports__["a"] = (FailedPaymentDetails);


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var FailedPaymentUserDetails = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: props.className },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Customer Details"),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled mb-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Name:"),
                    " ",
                    props.user.fullName),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Email:"),
                    " ",
                    props.user.email),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Phone:"),
                    " ",
                    props.user.phoneNumber || '-'),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Stripe customer id:"),
                    " ",
                    props.user.stripeCustomerId)))));
};
/* harmony default export */ __webpack_exports__["a"] = (FailedPaymentUserDetails);


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__report_reportActions__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MissingBeneficiaryFormsList__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var MissingBeneficiaryFormsListPage = /** @class */ (function (_super) {
    __extends(MissingBeneficiaryFormsListPage, _super);
    function MissingBeneficiaryFormsListPage(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSearchDebounced = __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].debounce(function () { _this.search(_this.state.searchterm); }, 200);
        _this.onSearch = function (e) {
            _this.setState({ searchterm: e.target.value }, function () {
                _this.handleSearchDebounced();
            });
        };
        _this.search = function (searchterm) {
            var value = searchterm.toLowerCase();
            var customers = _this.props.customers.filter(function (c) {
                var fullName = c.fullName || '';
                var email = c.email || '';
                return fullName.toLowerCase().startsWith(value) || email.toLowerCase().startsWith(value);
            });
            _this.setState({ customers: customers });
        };
        _this.download = function () {
            var formattedCustomers = _this.formatData(_this.props.customers);
            __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].downloadCsv(formattedCustomers, 'MissingBeneficiaryForms.csv');
        };
        _this.formatData = function (customers) {
            var formattedCustomers = customers.map(function (c) {
                return {
                    Name: c.fullName,
                    Email: c.email
                };
            });
            return formattedCustomers;
        };
        _this.state = {
            customers: [],
            isLoading: true,
            searchterm: ''
        };
        return _this;
    }
    MissingBeneficiaryFormsListPage.prototype.componentDidMount = function () {
        var _this = this;
        this.props.actions
            .fetchCustomersMissingBeneficiaryForms()
            .then(function () { return _this.setState({ customers: _this.props.customers, isLoading: false }); });
    };
    MissingBeneficiaryFormsListPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], { title: "Customers missing beneficiary forms" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: "Customers Missing beneficiary forms" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__MissingBeneficiaryFormsList__["a" /* default */], { customers: this.state.customers, history: this.props.history, searchterm: this.state.searchterm, onSearch: this.onSearch, download: this.download }))));
    };
    return MissingBeneficiaryFormsListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        customers: state.user.customers
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__report_reportActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(MissingBeneficiaryFormsListPage);
var roles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, roles));


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_icons__ = __webpack_require__(7);





var MissingBeneficiaryFormsList = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { name: "search", placeholder: "Search", value: props.searchterm, onChange: props.onSearch, className: "m-0 table-search" }),
            props.customers.length > 0 &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "btn-group table-filters" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-filter" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons__["a" /* Button */], { className: "btn-outline-primary", onClick: props.download },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Download")))))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                {
                    accessor: 'id',
                    show: false
                },
                {
                    Header: 'Full Name',
                    accessor: 'fullName'
                },
                {
                    Header: 'Email',
                    accessor: 'email'
                },
                {
                    Header: 'Actions',
                    className: 'p-0 td-actions',
                    width: 100,
                    Cell: function (rowInfo) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons__["b" /* IconButton */], { title: "Edit customer", className: "btn-icon-secondary btn-icon-td", onClick: function (e) {
                            e.stopPropagation(); // Prevent onClick conflict with tr onclick
                            props.history.push("/admin/customers/" + rowInfo.row.id);
                        } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_icons__["m" /* IconArrowRight */], null))); }
                }
            ], data: props.customers, getTrProps: function (state, rowInfo, column) {
                return {
                    className: 'tr interactive',
                    onClick: function () {
                        props.history.push("/admin/customers/" + rowInfo.row.id);
                    }
                };
            }, noDataText: "No customers found" })));
};
/* harmony default export */ __webpack_exports__["a"] = (MissingBeneficiaryFormsList);


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__report_reportActions__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};








var CreatedPoliciesListPage = /** @class */ (function (_super) {
    __extends(CreatedPoliciesListPage, _super);
    function CreatedPoliciesListPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.download = function () {
            var formattedPolicies = _this.formatData(_this.props.policies);
            __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].downloadCsv(formattedPolicies, 'PoliciesCreated.csv');
        };
        _this.formatData = function (policies) {
            var formattedPolicies = policies.map(function (p) {
                return _a = {},
                    _a['Policy #'] = p.number,
                    _a.Customer = p.customer ? p.customer.fullName : '',
                    _a['Effective Date'] = __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatDateAsUTC(p.effectiveDate),
                    _a['Expiry Date'] = __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatDateAsUTC(p.endDate),
                    _a['Coverage Amount'] = __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatCurrency(p.coverageAmount, 0),
                    _a.Term = p.term,
                    _a;
                var _a;
            });
            return formattedPolicies;
        };
        return _this;
    }
    CreatedPoliciesListPage.prototype.componentDidMount = function () {
        this.props.actions.fetchPolicies();
    };
    CreatedPoliciesListPage.prototype.render = function () {
        var props = __rest(this.props, []);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], { title: "Policies created" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: "Policies created" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set" },
                    props.policies.length > 0 &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "btn-group table-filters" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-filter" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { className: "btn-outline-primary", onClick: this.download },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Download"))))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                            {
                                accessor: 'id',
                                show: false
                            },
                            {
                                Header: 'Policy #',
                                accessor: 'number'
                            },
                            {
                                Header: 'Customer',
                                accessor: 'customer.fullName'
                            },
                            {
                                Header: 'Effective Date',
                                accessor: 'effectiveDate',
                                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatDate(row.value); }
                            },
                            {
                                Header: 'Expiry Date',
                                accessor: 'endDate',
                                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatDate(row.value); }
                            },
                            {
                                Header: 'Coverage Amount',
                                accessor: 'coverageAmount',
                                Cell: function (row) { return "" + __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatCurrency(row.value, 0); }
                            },
                            {
                                Header: 'Term',
                                accessor: 'term'
                            }
                        ], getTrProps: function (state, rowInfo, column) {
                            return {
                                className: 'tr'
                            };
                        }, data: props.policies, noDataText: "No policies created", resizable: true })))));
    };
    return CreatedPoliciesListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        policies: state.policy.policies
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__report_reportActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CreatedPoliciesListPage);
var roles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, roles));


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__report_reportActions__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};








var UnmailedPoliciesListPage = /** @class */ (function (_super) {
    __extends(UnmailedPoliciesListPage, _super);
    function UnmailedPoliciesListPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.download = function () {
            var formattedPolicies = _this.formatData(_this.props.unmailedPolicies);
            __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].downloadCsv(formattedPolicies, 'PoliciesUnmailed.csv');
        };
        _this.formatData = function (policies) {
            var formattedPolicies = policies.map(function (p) {
                return _a = {},
                    _a['Policy #'] = p.number,
                    _a.Customer = p.customer ? p.customer.fullName : '',
                    _a['Effective Date'] = __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatDateAsUTC(p.effectiveDate),
                    _a['Expiry Date'] = __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatDateAsUTC(p.endDate),
                    _a['Coverage Amount'] = __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatCurrency(p.coverageAmount, 0),
                    _a.Term = p.term,
                    _a;
                var _a;
            });
            return formattedPolicies;
        };
        return _this;
    }
    UnmailedPoliciesListPage.prototype.componentDidMount = function () {
        this.props.actions.fetchUnmailedPolicies();
    };
    UnmailedPoliciesListPage.prototype.render = function () {
        var props = __rest(this.props, []);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], { title: "Unmailed Policies" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: "Unmailed Policies" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set" },
                    props.unmailedPolicies.length > 0 &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "btn-group table-filters" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-filter" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { className: "btn-outline-primary", onClick: this.download },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Download"))))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                            {
                                accessor: 'id',
                                show: false
                            },
                            {
                                Header: 'Policy #',
                                accessor: 'number'
                            },
                            {
                                Header: 'Customer',
                                accessor: 'customer.fullName'
                            },
                            {
                                Header: 'Effective Date',
                                accessor: 'effectiveDate',
                                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatDate(row.value); }
                            },
                            {
                                Header: 'Expiry Date',
                                accessor: 'endDate',
                                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatDate(row.value); }
                            },
                            {
                                Header: 'Coverage Amount',
                                accessor: 'coverageAmount',
                                Cell: function (row) { return "" + __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatCurrency(row.value, 0); }
                            },
                            {
                                Header: 'Term',
                                accessor: 'term'
                            }
                        ], getTrProps: function (state, rowInfo, column) {
                            return {
                                className: 'tr'
                            };
                        }, data: props.unmailedPolicies, noDataText: "No unmailed policies", resizable: true })))));
    };
    return UnmailedPoliciesListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        unmailedPolicies: state.report.unmailedPolicies
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__report_reportActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(UnmailedPoliciesListPage);
var roles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, roles));


/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__report_reportActions__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};








var ExpiringPoliciesListPage = /** @class */ (function (_super) {
    __extends(ExpiringPoliciesListPage, _super);
    function ExpiringPoliciesListPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.download = function () {
            var formattedPolicies = _this.formatData(_this.props.policies);
            __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].downloadCsv(formattedPolicies, 'PoliciesExpiring.csv');
        };
        _this.formatData = function (policies) {
            var formattedPolicies = policies.map(function (p) {
                return _a = {},
                    _a['Policy #'] = p.number,
                    _a.Customer = p.customer ? p.customer.fullName : '',
                    _a['Effective Date'] = __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatDateAsUTC(p.effectiveDate),
                    _a['Expiry Date'] = __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatDateAsUTC(p.endDate),
                    _a['Coverage Amount'] = __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatCurrency(p.coverageAmount, 0),
                    _a.Term = p.term,
                    _a;
                var _a;
            });
            return formattedPolicies;
        };
        return _this;
    }
    ExpiringPoliciesListPage.prototype.componentDidMount = function () {
        this.props.actions.fetchExpiringPolicies();
    };
    ExpiringPoliciesListPage.prototype.render = function () {
        var props = __rest(this.props, []);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], { title: "Expiring policies" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: "Policies expiring in 30 days", className: "page-header-sm" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set" },
                    props.policies.length > 0 &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "btn-group table-filters" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-filter" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { className: "btn-outline-primary", onClick: this.download },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Download"))))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                            {
                                accessor: 'id',
                                show: false
                            },
                            {
                                Header: 'Policy #',
                                accessor: 'number'
                            },
                            {
                                Header: 'Customer',
                                accessor: 'customer.fullName'
                            },
                            {
                                Header: 'Effective Date',
                                accessor: 'effectiveDate',
                                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatDateAsUTC(row.value); }
                            },
                            {
                                Header: 'Expiry Date',
                                accessor: 'endDate',
                                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatDateAsUTC(row.value); }
                            },
                            {
                                Header: 'Coverage Amount',
                                accessor: 'coverageAmount',
                                Cell: function (row) { return "" + __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatCurrency(row.value, 0); }
                            },
                            {
                                Header: 'Term',
                                accessor: 'term'
                            }
                        ], getTrProps: function (state, rowInfo, column) {
                            return {
                                className: 'tr'
                            };
                        }, data: props.policies, noDataText: "No expiring policies" })))));
    };
    return ExpiringPoliciesListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        policies: state.report.expiringPolicies
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__report_reportActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ExpiringPoliciesListPage);
var roles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, roles));


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__report_reportActions__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};








var BouncedEmailsListPage = /** @class */ (function (_super) {
    __extends(BouncedEmailsListPage, _super);
    function BouncedEmailsListPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentIdLoading: ''
        };
        _this.download = function () {
            var formattedEmails = _this.formatData(_this.props.bouncedEmails);
            __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].downloadCsv(formattedEmails, 'BouncedEmails.csv');
        };
        _this.formatData = function (bouncedEmails) {
            var formattedEmails = bouncedEmails.map(function (e) {
                return {
                    Date: __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatUnixDate(e.timestamp, 'lll'),
                    Email: e.email,
                    Reason: e.reason,
                    Status: e.statusId === __WEBPACK_IMPORTED_MODULE_6__common_utils__["e" /* BouncedEmailStatus */].Unresolved ? 'Unresolved' : 'Resolved'
                };
            });
            return formattedEmails;
        };
        _this.markResolved = function (id) {
            _this.setState({ currentIdLoading: id });
            _this.props.actions.resolveBouncedEmail(id).then(function () { return _this.setState({ currentIdLoading: '' }); });
        };
        return _this;
    }
    BouncedEmailsListPage.prototype.componentDidMount = function () {
        this.props.actions.fetchBouncedEmails();
    };
    BouncedEmailsListPage.prototype.render = function () {
        var _this = this;
        var props = __rest(this.props, []);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], { title: "Bounced emails" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: "Bounced emails in the past 30 days" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "content-set" },
                    props.bouncedEmails.length > 0 &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-options" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "btn-group table-filters" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "table-filter" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { className: "btn-outline-primary", onClick: this.download },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Download"))))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["a" /* DataTable */], { TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
                            {
                                Header: 'Date',
                                accessor: 'timestamp',
                                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].formatUnixDate(row.value, 'lll'); }
                            },
                            {
                                Header: 'Email',
                                accessor: 'email'
                            },
                            {
                                Header: 'Reason',
                                accessor: 'reason'
                            },
                            {
                                Header: 'Status',
                                className: 'p-0 td-actions',
                                accessor: 'statusId',
                                Cell: function (row) {
                                    if (row.value === __WEBPACK_IMPORTED_MODULE_6__common_utils__["e" /* BouncedEmailStatus */].Unresolved) {
                                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { className: "btn-primary btn-td", type: "button", onClick: function () { return _this.markResolved(row.original.id); }, disabled: _this.state.currentIdLoading === row.original.id }, "Mark as resolved"));
                                    }
                                    else {
                                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { className: "btn-secondary btn-td", type: "button", disabled: true }, "Resolved"));
                                    }
                                }
                            }
                        ], getTrProps: function (state, rowInfo, column) {
                            return {
                                className: 'tr'
                            };
                        }, data: props.bouncedEmails, noDataText: "No bounced emails", resizable: true })))));
    };
    return BouncedEmailsListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        bouncedEmails: state.report.bouncedEmails
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__report_reportActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(BouncedEmailsListPage);
var roles = ["Admin" /* Administrator */, "Agent" /* Agent */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__auth_authComponents__["b" /* ensureUserHasRoleAdminSite */])(connectedPage, roles));


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__referral_FriendReferral__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__referral_SpouseReferral__ = __webpack_require__(587);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};










var ReferPage = /** @class */ (function (_super) {
    __extends(ReferPage, _super);
    function ReferPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: true,
            isSubmitting: false,
            isSubmittingSpousal: false,
        };
        _this.isSpousalInviteDisabled = function () {
            var referees = _this.props.referrals.referees || [];
            var hasAlreadyReferredSpouse = referees.some(function (referral) {
                return referral.isSpousalReferralUsed != null && referral.isSpousalReferralUsed;
            });
            return _this.state.isLoading ||
                _this.state.isSubmittingSpousal ||
                hasAlreadyReferredSpouse ||
                _this.props.referrals.isSpousalReferralUsed;
        };
        _this.onSpousalInvite = function (spousalName, spousalEmail, resetForm) {
            _this.setState({ isSubmittingSpousal: true });
            _this.props.actions.sendSpousalReferralInviteEmail(_this.props.currentUser.id, spousalName, spousalEmail)
                .then(function () {
                _this.setState({ isSubmittingSpousal: false });
                resetForm();
                __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Invite sent');
            });
        };
        _this.isInviteDisabled = function () {
            return _this.state.isLoading ||
                _this.state.isSubmitting ||
                !_this.props.referrals.referralEnabled ||
                _this.props.referrals.remainingReferrals === 0;
        };
        _this.onInvite = function (name, email, resetForm) {
            _this.setState({ isSubmitting: true });
            _this.props.actions.sendReferralInviteEmail(_this.props.currentUser.id, name, email)
                .then(function () {
                _this.setState({ isSubmitting: false });
                resetForm();
                __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Invite sent');
            });
        };
        return _this;
    }
    ReferPage.prototype.componentDidMount = function () {
        var _this = this;
        this.props.actions.fetchReferrals(this.props.currentUser.id)
            .then(function () { return _this.setState({
            isLoading: false,
        }); });
    };
    ReferPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], { title: "Referral" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: "Referral" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "border border-success px-3 py-4 text-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 text-dark" },
                        "Referral Balance: ",
                        __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatCurrency(this.props.referrals.referralBalance)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "d-block" },
                            __WEBPACK_IMPORTED_MODULE_7__common_utils__["m" /* default */].formatCurrency(this.props.referrals.paidReferral),
                            " paid out")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small", null, "Please note that credit for any referrals you may have made will be added to your account 31 days after the referred user has activated his or her policy.")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-flex col-md mt-4" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__referral_SpouseReferral__["a" /* default */], { referrals: this.props.referrals, currentUser: this.props.currentUser, onSpousalInvite: this.onSpousalInvite, disabled: this.isSpousalInviteDisabled(), isSubmittingSpousal: this.state.isSubmittingSpousal, fullFormWidth: this.props.referrals.referralEnabled })),
                    this.props.referrals.referralEnabled &&
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-flex col-md mt-4" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__referral_FriendReferral__["a" /* default */], { referrals: this.props.referrals, currentUser: this.props.currentUser, onInvite: this.onInvite, disabled: this.isInviteDisabled(), isSubmitting: this.state.isSubmitting, fullFormWidth: true }))))));
    };
    return ReferPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        currentUser: state.auth.currentUser,
        referrals: state.user.referrals
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var ConnectedReferPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ReferPage);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__auth_authComponents__["a" /* ensureUserHasRole */])(ConnectedReferPage, ["Customer" /* Customer */]));


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var FriendReferral = /** @class */ (function (_super) {
    __extends(FriendReferral, _super);
    function FriendReferral() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errors = { email: {} };
        _this.state = {
            name: '',
            email: '',
            touched: {
                email: false
            }
        };
        _this.handleBlur = function (field) { return function (evt) {
            _this.setState({
                touched: __assign({}, _this.state.touched, (_a = {}, _a[field] = true, _a))
            });
            var _a;
        }; };
        _this.validate = function () {
            // true means invalid
            return {
                email: __WEBPACK_IMPORTED_MODULE_2__common_utils__["k" /* Validation */].validateEmail(_this.state.email)
            };
        };
        _this.isInviteDisabled = function () {
            return !_this.state.name ||
                !_this.state.email ||
                _this.errors.email.hasError ||
                _this.state.email === _this.props.currentUser.email;
        };
        _this.resetForm = function () {
            _this.setState({ name: '', email: '', touched: { email: false } });
        };
        return _this;
    }
    FriendReferral.prototype.render = function () {
        var _this = this;
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "border px-3 py-4 p-lg-4 d-flex flex-column justify-content-center w-100" },
            this.props.referrals.remainingReferrals !== undefined && this.props.referrals.remainingReferrals > 0 ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Refer a friend and you each get a credit of up to $25!")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    "(",
                    this.props.referrals.remainingReferrals,
                    this.props.referrals.remainingReferrals === 1 ? ' referral' : ' referrals',
                    " left to claim) Your code is: ",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, this.props.referrals.referralCode || '-')))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0 text-center" },
                "All friend referrals have been claimed. Call us at ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "tel:1-855-643-6945" }, "1-855-643-6945"),
                " or ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: "/contact-us" }, "contact us"),
                ' ',
                "to see if you are eligible for more referrals.")),
            this.props.referrals.remainingReferrals !== undefined && this.props.referrals.remainingReferrals > 0 ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { labelText: "Name", name: "name", placeholder: "John Smith", value: this.state.name, onChange: function (e) { return _this.setState({ name: e.target.value }); }, className: this.props.fullFormWidth ? 'col-12' : 'col-md-4 mb-md-0 ml-md-auto' }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { labelText: "Email", name: "email", placeholder: "john@example.com", value: this.state.email, onBlur: this.handleBlur('email'), onChange: function (e) { return _this.setState({ email: e.target.value }); }, className: this.props.fullFormWidth ? 'col-12' : 'col-md-4 mb-md-0', error: __WEBPACK_IMPORTED_MODULE_2__common_utils__["m" /* default */].shouldMarkError(this.errors.email, this.state.touched.email) ? this.errors.email : undefined }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: this.props.fullFormWidth ? 'col-12' : 'col-md-auto align-self-end mr-md-auto' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_buttons__["a" /* Button */], { className: "btn-primary", onClick: function () { return _this.props.onInvite(_this.state.name, _this.state.email, _this.resetForm); }, disabled: this.props.disabled || this.isInviteDisabled() },
                        "Send Invite",
                        this.props.isSubmitting && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["f" /* Spinner */], null))))) : ('')));
    };
    return FriendReferral;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FriendReferral);


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var SpouseReferral = /** @class */ (function (_super) {
    __extends(SpouseReferral, _super);
    function SpouseReferral() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errors = { spousalEmail: {} };
        _this.state = {
            spousalName: _this.props.referrals.referredSpouseName ? _this.props.referrals.referredSpouseName : '',
            spousalEmail: _this.props.referrals.referredSpouseEmail ? _this.props.referrals.referredSpouseEmail : '',
            touched: {
                spousalEmail: false
            }
        };
        _this.handleBlur = function (field) { return function (evt) {
            _this.setState({
                touched: __assign({}, _this.state.touched, (_a = {}, _a[field] = true, _a))
            });
            var _a;
        }; };
        _this.validate = function () {
            // true means invalid
            return {
                spousalEmail: __WEBPACK_IMPORTED_MODULE_1__common_utils__["k" /* Validation */].validateEmail(_this.state.spousalEmail)
            };
        };
        _this.isSpousalInviteDisabled = function () {
            return !_this.state.spousalName ||
                !_this.state.spousalEmail ||
                _this.errors.spousalEmail.hasError ||
                _this.state.spousalEmail === _this.props.currentUser.email;
        };
        _this.resetForm = function () {
            _this.setState({ spousalName: '', spousalEmail: '', touched: { spousalEmail: false } });
        };
        _this.renderReferralForm = function () {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Refer your life partner and you each get up to $120 credit!")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                        "Your code is: ",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, _this.props.referrals.spousalReferralCode || '-'))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Name", name: "spousalName", placeholder: "John Smith", value: _this.state.spousalName, onChange: function (e) { return _this.setState({ spousalName: e.target.value }); }, className: _this.props.fullFormWidth ? 'col-12' : 'col-md-4 mb-md-0 ml-md-auto' }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms__["n" /* TextInput */], { labelText: "Email", name: "spousalEmail", placeholder: "john@example.com", value: _this.state.spousalEmail, onBlur: _this.handleBlur('spousalEmail'), onChange: function (e) { return _this.setState({ spousalEmail: e.target.value }); }, className: _this.props.fullFormWidth ? 'col-12' : 'col-md-4 mb-md-0', error: __WEBPACK_IMPORTED_MODULE_1__common_utils__["m" /* default */].shouldMarkError(_this.errors.spousalEmail, _this.state.touched.spousalEmail) ?
                            _this.errors.spousalEmail : undefined }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: _this.props.fullFormWidth ? 'col-12' : 'col-md-auto align-self-end mr-md-auto' },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_buttons__["a" /* Button */], { className: "btn-primary", onClick: function () { return _this.props.onSpousalInvite(_this.state.spousalName, _this.state.spousalEmail, _this.resetForm); }, disabled: _this.props.disabled || _this.isSpousalInviteDisabled() },
                            "Send Invite",
                            _this.props.isSubmittingSpousal && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["f" /* Spinner */], null))))));
        };
        _this.renderReferralComplete = function () {
            if (_this.props.referrals.statusId === __WEBPACK_IMPORTED_MODULE_1__common_utils__["i" /* ReferralStatus */].PolicyCancelled) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0 text-center" }, "Your life partner has cancelled the policy."));
            }
            else if (_this.props.referrals.statusId === __WEBPACK_IMPORTED_MODULE_1__common_utils__["i" /* ReferralStatus */].ReferralApproved) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0 text-center" }, "Your life partner referral credit has been claimed.  You and your life partner each received a $120 credit."));
            }
            else {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0 text-center" }, "Your life partner referral credit has been claimed. You and your life partner will each receive a $120 credit 31 days after the referred person signed up."));
            }
        };
        return _this;
    }
    SpouseReferral.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "border px-3 py-4 p-lg-4 d-flex flex-column justify-content-center w-100" }, !this.props.referrals.isSpousalReferralUsed ? this.renderReferralForm() : this.renderReferralComplete()));
    };
    return SpouseReferral;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (SpouseReferral);


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__policy_PolicyList__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var PoliciesPage = /** @class */ (function (_super) {
    __extends(PoliciesPage, _super);
    function PoliciesPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: true
        };
        _this.onDownloadClick = function (e, row) {
            e.stopPropagation(); // make sure to stop click propogation or the row click kicks in
            _this.props.actions.fetchCustomerPolicyDocumentUrl(_this.props.match.params.userId, row.id)
                .then(function () {
                window.open(_this.props.tempPolicyDocumentUrl);
            });
        };
        return _this;
    }
    PoliciesPage.prototype.componentDidMount = function () {
        var _this = this;
        this.props.actions.fetchCustomerPolicies(this.props.match.params.userId)
            .then(function () { return _this.setState({ loading: false }); });
    };
    PoliciesPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], { title: "Policies" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: "Your policies" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__policy_PolicyList__["a" /* default */], { policies: this.props.policies, onDownloadClick: this.onDownloadClick, loading: this.state.loading }))));
    };
    return PoliciesPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        policies: state.policy.policies,
        tempPolicyDocumentUrl: state.policy.tempPolicyDocumentUrl,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var ConnectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(PoliciesPage);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__auth_authComponents__["a" /* ensureUserHasRole */])(ConnectedPage, ["Customer" /* Customer */]));


/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);





var PolicyList = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["a" /* DataTable */], { className: props.className, TableComponent: function (p) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["g" /* Table */], { isDataTable: true }, p.children); }, columns: [
            {
                accessor: 'id',
                show: false
            },
            {
                Header: 'Policy #',
                accessor: 'number'
            },
            {
                Header: 'Start Date',
                accessor: 'effectiveDate',
                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatDateAsUTC(row.value); }
            },
            {
                Header: 'End Date',
                accessor: 'endDate',
                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatDateAsUTC(row.value); }
            },
            {
                Header: 'Coverage Amount',
                accessor: 'coverageAmount',
                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatCurrency(row.value, 0); }
            },
            {
                Header: 'Premium',
                accessor: 'rate',
                Cell: function (row) { return __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatCurrency(row.value) + '/Monthly'; }
            },
            {
                Header: 'Status',
                accessor: 'statusId',
                Cell: function (row) {
                    if (row.value === __WEBPACK_IMPORTED_MODULE_4__common_utils__["h" /* PolicyStatus */].Active) {
                        return 'Active';
                    }
                    else if (row.value === __WEBPACK_IMPORTED_MODULE_4__common_utils__["h" /* PolicyStatus */].Inactive) {
                        return 'Inactive';
                    }
                    else if (row.value === __WEBPACK_IMPORTED_MODULE_4__common_utils__["h" /* PolicyStatus */].Canceled) {
                        return 'Canceled';
                    }
                    else {
                        return '';
                    }
                }
            },
            {
                Header: 'Actions',
                className: 'p-0 td-actions',
                width: 103,
                Cell: function (row) {
                    if (row.original.isActive) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons__["b" /* IconButton */], { title: "Download policy", className: "btn-icon-secondary btn-icon-td", onClick: function (e) { props.onDownloadClick(e, row.original); } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["w" /* IconDownload */], null))));
                    }
                    else {
                        return null;
                    }
                }
            }
        ], data: props.policies, getTrProps: function (state, rowInfo, column) {
            return { className: 'tr' };
        }, noDataText: "No policies found", showPagination: false, loading: props.loading }));
};
/* harmony default export */ __webpack_exports__["a"] = (PolicyList);


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PolicyBeneficiaryContainer__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var PolicyBeneficiaryPage = /** @class */ (function (_super) {
    __extends(PolicyBeneficiaryPage, _super);
    function PolicyBeneficiaryPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PolicyBeneficiaryPage.prototype.render = function () {
        var title = this.props.match.params.beneficiaryId === 'new' ? 'Add a beneficiary' : 'Update beneficiary';
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_common__["b" /* Page */], { title: title },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_common__["d" /* PageHeader */], { title: title, className: "page-header-sm" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__PolicyBeneficiaryContainer__["a" /* default */], __assign({}, this.props)))));
    };
    return PolicyBeneficiaryPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PolicyBeneficiaryPage);


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PolicyBeneficiariesDisbursementRow__ = __webpack_require__(592);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};












var PolicyBeneficiariesDisbursementPage = /** @class */ (function (_super) {
    __extends(PolicyBeneficiariesDisbursementPage, _super);
    function PolicyBeneficiariesDisbursementPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isUpdateDisabled = function () {
            return !__WEBPACK_IMPORTED_MODULE_9__common_utils__["j" /* UtilsBeneficiaries */].isDisbursementValid(_this.props.beneficiaries) ||
                _this.validateTrustee();
        };
        _this.updateDisbursement = function () {
            var beneficiaries = _this.props.beneficiaries.filter(function (b) { return b.typeId !== __WEBPACK_IMPORTED_MODULE_9__common_utils__["d" /* BeneficiaryTypes */].Trustee; });
            __WEBPACK_IMPORTED_MODULE_9__common_utils__["m" /* default */].forEachPromise(beneficiaries, _this.props.actions.saveCustomerPolicyBeneficiary).then(function () {
                if (_this.props.beneficiaries.find(function (b) { return b.isUnderage === true; })) {
                    _this.saveTrustee();
                }
                __WEBPACK_IMPORTED_MODULE_8_toastr__["success"]('Beneficiary disbursement updated!');
                _this.props.history.push("/user/" + _this.props.match.params.userId + "/beneficiaries");
            });
        };
        _this.cancelManagement = function () {
            _this.props.history.push("/user/" + _this.props.match.params.userId + "/beneficiaries");
        };
        _this.onTrusteeChange = function (e) {
            var trustee = __assign({}, _this.props.trustee, (_a = {}, _a[e.target.name] = e.target.value, _a));
            _this.props.actions.setTrustee(trustee);
            var _a;
        };
        _this.saveTrustee = function () {
            var trustee = __assign({}, _this.props.trustee);
            trustee.customerId = _this.props.match.params.userId;
            trustee.customerPolicyId = _this.props.customerPolicy.id;
            _this.props.actions.saveCustomerPolicyBeneficiary(trustee);
        };
        // true means update button should be disabled
        _this.validateTrustee = function () {
            var result = false;
            if (!_this.props.beneficiaries.some(function (b) { return b.isUnderage === true; })) {
                return result;
            }
            else {
                if (!_this.props.trustee.firstName ||
                    !_this.props.trustee.lastName ||
                    !_this.props.trustee.email ||
                    _this.props.trustee.firstName.trim() === '' ||
                    _this.props.trustee.lastName.trim() === '' ||
                    _this.props.trustee.email.trim() === '') {
                    result = true;
                }
            }
            return result;
        };
        return _this;
    }
    PolicyBeneficiariesDisbursementPage.prototype.render = function () {
        var primaryBeneficiaries = this.props.beneficiaries.filter(function (b) { return b.typeId === __WEBPACK_IMPORTED_MODULE_9__common_utils__["d" /* BeneficiaryTypes */].Primary; });
        var contingentBeneficiaries = this.props.beneficiaries.filter(function (b) { return b.typeId === __WEBPACK_IMPORTED_MODULE_9__common_utils__["d" /* BeneficiaryTypes */].Contingent; });
        var _a = this.props, customerPolicy = _a.customerPolicy, beneficiaries = _a.beneficiaries, history = _a.history, match = _a.match, actions = _a.actions;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["b" /* Page */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["d" /* PageHeader */], { title: "Adjust your beneficiary disbursement" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customer-dashboard-plan-info" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "d-inline large" },
                        "Policy ",
                        this.props.customerPolicy.number)),
                primaryBeneficiaries.length > 0 &&
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__PolicyBeneficiariesDisbursementRow__["a" /* default */], { customerPolicy: customerPolicy, beneficiaries: beneficiaries, typedBeneficiaries: primaryBeneficiaries, history: history, match: match, actions: actions })),
                contingentBeneficiaries.length > 0 &&
                    (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__PolicyBeneficiariesDisbursementRow__["a" /* default */], { customerPolicy: customerPolicy, beneficiaries: beneficiaries, typedBeneficiaries: contingentBeneficiaries, history: history, match: match, actions: actions })),
                this.props.beneficiaries.find(function (b) { return b.isUnderage === true; }) &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset content-set" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customer-dashboard-plan-info" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "d-inline large" }, "Trustee")),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-12 mb-0" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "mr-1" }, "Because one or more of your beneficiaries is underage, you must declare a trustee as part of your beneficiary designation."),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["i" /* TooltipModal */], { toggle: "Click here for more information.", toggleClassName: "btn-link-inline" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "This section only needs to be completed if you have appointed a minor as one of your beneficiaries. In the case you have a minor as a beneficiary, death benefits will not be paid directly to them, but instead to a trustee."),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "By completing this section you are appointing and authorizing the named person to act as a trustee for the beneficiaries and to receive any benefit payable to a beneficiary while the beneficiary is under the age of majority. These proceeds are to be used solely for the support, maintenance, education and benefit of such beneficiary at the discretion of the trustee."),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Note: In Quebec, death benefits due to a beneficiary, while a minor, will be paid to their parent(s) or legal guardian unless you have established a formal trust.")))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_forms__["n" /* TextInput */], { id: "trusteeFirstName", labelText: "First Name", name: "firstName", value: this.props.trustee.firstName, onChange: this.onTrusteeChange, className: "col-md-6", required: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_forms__["n" /* TextInput */], { id: "trusteeLastName", labelText: "Last Name", name: "lastName", value: this.props.trustee.lastName, onChange: this.onTrusteeChange, className: "col-md-6", required: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_forms__["n" /* TextInput */], { id: "trusteeEmail", labelText: "E-mail Address", name: "email", value: this.props.trustee.email, onChange: this.onTrusteeChange, className: "col-md-6", required: true }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-md-right mt-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { className: "btn-outline-primary col-md-2 mr-3", onClick: this.cancelManagement }, "Cancel"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { to: "/user/" + this.props.match.params.userId + "/beneficiaries/new", className: "btn-outline-primary mr-3", disabled: this.isUpdateDisabled() },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Add a beneficiary"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_icons__["k" /* IconAdd */], null)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { className: "btn-primary", disabled: this.isUpdateDisabled(), onClick: this.updateDisbursement }, "Save and Update")))));
    };
    return PolicyBeneficiariesDisbursementPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state, props) {
    return {
        beneficiaries: state.policy.beneficiaries.pending,
        customerPolicy: state.policy.customerPolicy,
        trustee: state.policy.trustee
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(PolicyBeneficiariesDisbursementPage));


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rheostat__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rheostat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rheostat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rheostat_css_slider_css__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rheostat_css_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rheostat_css_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rheostat_css_slider_horizontal_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rheostat_css_slider_horizontal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rheostat_css_slider_horizontal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__policy_policyActions__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var classNames = __webpack_require__(8);







var RheostatPit = function (_a) {
    var style = _a.style, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "rheostat-pit", style: style }, children));
};
var PolicyBeneficiariesDisbursementRow = /** @class */ (function (_super) {
    __extends(PolicyBeneficiariesDisbursementRow, _super);
    function PolicyBeneficiariesDisbursementRow(props) {
        var _this = _super.call(this, props) || this;
        _this.onDisbursementChange = function (e, beneficiary) {
            if (e.target.value > 100) {
                return;
            }
            var value = Math.min(100, e.target.value);
            var valuePct = value / 100;
            var newBeneficiary = __assign({}, beneficiary, (_a = {}, _a[e.target.name] = valuePct, _a));
            _this.props.actions.setCustomerPolicyBeneficiary(newBeneficiary);
            var _a;
        };
        _this.onValuesUpdated = function (publicState, beneficiary) {
            // Rheostat uses a values list to support multiple handles. Since we only have one handle, take the first index.
            var valuePct = publicState.values[0] / 100;
            var newBeneficiary = __assign({}, beneficiary, { disbursementPercent: valuePct });
            _this.props.actions.setCustomerPolicyBeneficiary(newBeneficiary);
        };
        _this.disburseEqually = function () {
            var numBeneficiaries = _this.props.typedBeneficiaries.length;
            var typeIndetifier = _this.props.typedBeneficiaries[0].typeId;
            var beneficiaries = _this.props.beneficiaries.map(function (beneficiary) {
                return beneficiary.typeId === typeIndetifier ? __assign({}, beneficiary, { disbursementPercent: 1 / numBeneficiaries }) : __assign({}, beneficiary);
            });
            _this.props.actions.setCustomerPolicyBeneficiaries(beneficiaries);
        };
        _this.getTotal = function () {
            var total = _this.props.typedBeneficiaries.reduce(function (a, b) { return a + parseFloat(b.disbursementPercent || 0); }, 0);
            return total;
        };
        return _this;
    }
    PolicyBeneficiariesDisbursementRow.prototype.render = function () {
        var _this = this;
        var title = __WEBPACK_IMPORTED_MODULE_8__common_utils__["m" /* default */].getPickListItemDescription(this.props.typedBeneficiaries[0].typeId);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('form-fieldset content-set', this.props.className) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customer-dashboard-plan-info" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "d-inline large" }, title),
                this.props.typedBeneficiaries.length > 0 && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-inline text-right" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_buttons__["a" /* Button */], { className: "btn-outline-secondary btn-sm", onClick: this.disburseEqually }, "Disburse equally")))),
            this.props.typedBeneficiaries.length > 0 ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "beneficiaries-disbursement" },
                this.props.typedBeneficiaries.map(function (beneficiary) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "beneficiary-disbursement-item", key: beneficiary.id },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row align-items-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-3 col-lg-2 mb-4 mb-md-0" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "beneficiary-name" }, beneficiary.name)),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md mb-4 mb-md-0" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rheostat___default.a, { onValuesUpdated: function (publicState) { return _this.onValuesUpdated(publicState, beneficiary); }, orientation: "horizontal", pitComponent: RheostatPit, pitPoints: [25, 50, 75], snap: true, values: [(beneficiary.disbursementPercent || 0) * 100] })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-auto" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_forms__["n" /* TextInput */], { name: "disbursementPercent", id: "disbursement-" + beneficiary.id, value: Math.trunc((beneficiary.disbursementPercent || 0) * 100), onChange: function (e) { return _this.onDisbursementChange(e, beneficiary); }, addOnAfter: "%", className: "mb-0" }))))); }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row mt-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-10 text-md-right" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "large" }, "Total (must be 100%):")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-2" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "large" },
                            Math.round(this.getTotal() * 100),
                            "%"))))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { className: "reduced-em" }, "No beneficiaries"))));
    };
    return PolicyBeneficiariesDisbursementRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state, props) {
    return {
        customerPolicy: state.policy.customerPolicy,
        beneficiaries: state.policy.beneficiaries.pending,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_9__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(PolicyBeneficiariesDisbursementRow));


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__policy_policyAPI__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__policy_PolicyBeneficiariesList__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};












var BeneficiariesPage = /** @class */ (function (_super) {
    __extends(BeneficiariesPage, _super);
    function BeneficiariesPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            policiesWithConfirmedBeneficiaries: [],
            policiesWithPendingBeneficiaries: [],
            loading: true,
            isDeleting: false,
        };
        _this.loadData = function () {
            var userId = _this.props.match.params.userId;
            var p1 = _this.props.actions.fetchCustomerPolicies(userId);
            var p2 = _this.props.actions.fetchCustomerPolicyBeneficiaries(userId);
            Promise.all([p1, p2])
                .then(function () {
                var currentPolicyIds = new Set();
                _this.props.currentBeneficiaries.forEach(function (beneficiary) {
                    currentPolicyIds.add(beneficiary.customerPolicyId);
                });
                var pendingPolicyIds = new Set();
                _this.props.pendingBeneficiaries.forEach(function (beneficiary) {
                    pendingPolicyIds.add(beneficiary.customerPolicyId);
                });
                var policiesWithConfirmedBeneficiaries = _this.props.policies.filter(function (p) { return currentPolicyIds.has(p.id); });
                var policiesWithPendingBeneficiaries = _this.props.policies.filter(function (p) { return pendingPolicyIds.has(p.id); });
                _this.setState({
                    policiesWithConfirmedBeneficiaries: policiesWithConfirmedBeneficiaries,
                    policiesWithPendingBeneficiaries: policiesWithPendingBeneficiaries,
                    loading: false
                });
            });
        };
        _this.onEdit = function (row) {
            var policy = _this.props.policies.find(function (p) { return p.id === row.customerPolicyId; });
            _this.props.actions.setCustomerPolicy(policy);
            _this.props.history.push("/user/" + _this.props.match.params.userId + "/beneficiaries/" + row.id);
        };
        _this.onDelete = function (row) {
            if (_this.state.isDeleting === true) {
                return;
            }
            _this.setState({ isDeleting: true });
            _this.props.actions.deleteCustomerPolicyBeneficiary(row.id, row.statusId)
                .then(function () {
                if (_this.props.deleteSucceed) {
                    __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Beneficiary deleted!');
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_toastr__["error"]('Each policy requires at least one beneficiary');
                }
                _this.props.actions.fetchCustomerPolicyBeneficiaries(_this.props.match.params.userId);
            })
                .then(function () {
                _this.setState({ isDeleting: false });
                _this.loadData();
            });
        };
        _this.onDownloadSignedForm = function (customerId, policyId) {
            __WEBPACK_IMPORTED_MODULE_5__policy_policyAPI__["a" /* default */].fetchSignedBeneficiaryDocumentUrl(customerId, policyId)
                .then(function (url) {
                window.open(url);
            });
        };
        _this.onDownloadForm = function (policyId, policy) {
            if (!_this.validatePercentage(policy)) {
                __WEBPACK_IMPORTED_MODULE_3_toastr__["error"]('Before you are able to download the beneficiary form, ' +
                    'adjust your disbursements so they sum to 100%.');
                return;
            }
            var pendingPrimaryIds = _this.props.pendingBeneficiaries
                .filter(function (b) { return b.typeId === __WEBPACK_IMPORTED_MODULE_11__common_utils__["d" /* BeneficiaryTypes */].Primary && b.customerPolicyId === policyId; }).map(function (b) { return b.id; });
            var tooBigMessage = 'Please <a href="/contact-us">contact support</a> for a document to sign.';
            var tooBigToastOptions = { timeOut: 0, extendedTimeOut: 0 };
            // There are only 4 rows for primary beneficiaries in the pdf.
            if (pendingPrimaryIds.length > 4) {
                __WEBPACK_IMPORTED_MODULE_3_toastr__["info"](tooBigMessage, '', tooBigToastOptions);
                return;
            }
            var pendingContingentIds = _this.props.pendingBeneficiaries
                .filter(function (b) { return b.typeId === __WEBPACK_IMPORTED_MODULE_11__common_utils__["d" /* BeneficiaryTypes */].Contingent && b.customerPolicyId === policyId; }).map(function (b) { return b.id; });
            // There are only 4 rows for contingent beneficiaries in the pdf.
            if (pendingContingentIds.length > 4) {
                __WEBPACK_IMPORTED_MODULE_3_toastr__["info"](tooBigMessage, '', tooBigToastOptions);
                return;
            }
            _this.props.actions.fetchCustomerPolicyBeneficiaryForm(_this.props.match.params.userId, policyId, '1')
                .then(function () { return _this.loadData(); });
        };
        _this.validatePercentage = function (policy) {
            var policyBeneficiaries = _this.props.pendingBeneficiaries.filter(function (b) { return b.customerPolicyId === policy.id; });
            return __WEBPACK_IMPORTED_MODULE_11__common_utils__["j" /* UtilsBeneficiaries */].isDisbursementValid(policyBeneficiaries);
        };
        _this.onManageDisbursement = function (beneficiaries, policy, isCurrent) {
            _this.props.actions.setCustomerPolicy(policy);
            var filteredBeneficiaries = [];
            if (!isCurrent) {
                filteredBeneficiaries = _this.props.pendingBeneficiaries
                    .filter(function (b) { return b.customerPolicyId === policy.id; });
                _this.props.actions.setCustomerPolicyBeneficiaries(filteredBeneficiaries);
            }
            else {
                filteredBeneficiaries = _this.props.currentBeneficiaries
                    .filter(function (b) { return b.customerPolicyId === policy.id; });
                _this.props.actions.setCustomerPolicyBeneficiaries(filteredBeneficiaries);
            }
            if (filteredBeneficiaries.some(function (b) { return b.isUnderage === true; })) {
                var trustee = filteredBeneficiaries.find(function (b) { return b.typeId === __WEBPACK_IMPORTED_MODULE_11__common_utils__["d" /* BeneficiaryTypes */].Trustee; });
                if (trustee) {
                    _this.props.actions.setTrustee(trustee);
                }
                else {
                    var newTrustee = __WEBPACK_IMPORTED_MODULE_5__policy_policyAPI__["g" /* defaultTrustee */];
                    _this.props.actions.setTrustee(newTrustee);
                }
            }
            _this.props.history.push("/user/" + _this.props.match.params.userId + "/beneficiaries-disbursement");
        };
        _this.renderCurrentPoliciesList = function () {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-4" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, "Current"),
                _this.renderPoliciesList(_this.state.policiesWithConfirmedBeneficiaries, _this.props.currentBeneficiaries, true)));
        };
        _this.renderPendingPoliciesList = function () {
            return _this.props.pendingBeneficiaries.length > 0 && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, "Pending"),
                _this.renderPoliciesList(_this.state.policiesWithPendingBeneficiaries, _this.props.pendingBeneficiaries)));
        };
        _this.renderPoliciesList = function (policies, beneficiaries, isCurrent) {
            if (isCurrent === void 0) { isCurrent = false; }
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled mb-0 customer-dashboard-plans" }, policies.length > 0 ? (policies.map(function (policy) {
                // disable editing on current policy beneficiaries that have pending changes
                var readOnly = isCurrent
                    && _this.props.pendingBeneficiaries.filter(function (b) { return b.customerPolicyId === policy.id; }).length > 0;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: policy.id, className: "customer-dashboard-plan" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customer-dashboard-plan-info" },
                        _this.renderPolicyHeader(policy, isCurrent),
                        beneficiaries.filter(function (b) { return b.customerPolicyId === policy.id; }).length > 0 &&
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "d-inline" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_buttons__["a" /* Button */], { className: "btn-outline-primary", disabled: readOnly, onClick: function () { return _this.onManageDisbursement(beneficiaries, policy, isCurrent); } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Manage disbursement")))),
                    _this.renderBeneficiaryList(beneficiaries, policy.id, readOnly)));
            })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { className: "reduced-em" }, "None confirmed")))));
        };
        _this.renderBeneficiaryList = function (beneficiaries, policyId, readOnly) {
            var filteredBeneficiaries = beneficiaries
                .filter(function (b) { return b.customerPolicyId === policyId && b.typeId !== __WEBPACK_IMPORTED_MODULE_11__common_utils__["d" /* BeneficiaryTypes */].Trustee; });
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__policy_PolicyBeneficiariesList__["a" /* default */], { beneficiaries: filteredBeneficiaries, onEdit: _this.onEdit, onDelete: _this.onDelete, loading: _this.state.loading, readOnly: readOnly }));
        };
        _this.renderPolicyHeader = function (policy, isCurrent) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "d-inline large" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null,
                    "Policy ",
                    policy.number,
                    " ",
                    !isCurrent && ('(' + __WEBPACK_IMPORTED_MODULE_11__common_utils__["m" /* default */].getPickListItemDescription(policy.beneficiariesStatus) + ')')),
                isCurrent ? '' :
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_buttons__["a" /* Button */], { className: "btn-outline-secondary ml-2", onClick: function () { return _this.onDownloadForm(policy.id, policy); } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null, "Print Beneficiary Form")))));
        };
        return _this;
    }
    BeneficiariesPage.prototype.componentDidMount = function () {
        this.loadData();
    };
    BeneficiariesPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["b" /* Page */], { title: "Beneficiaries" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["d" /* PageHeader */], { title: "Your beneficiaries" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "To designate or change your beneficiaries, please complete the beneficiary designation form and mail us a signed copy. Once we receive the form, it will be effective from the date signed, provided we have not yet paid a death benefit."),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "If we have not received a beneficiary designation form from you, the beneficiary of your policy will be your estate."))),
                this.renderCurrentPoliciesList(),
                this.renderPendingPoliciesList(),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "workflow-progress-actions mt-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_buttons__["a" /* Button */], { to: "/user/" + this.props.match.params.userId + "/beneficiaries/new", className: "btn-outline-primary workflow-progress-action" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mx-2" }, "Add a beneficiary"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_icons__["k" /* IconAdd */], null))))));
    };
    return BeneficiariesPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state, props) {
    var currentBeneficiaries = state.policy.beneficiaries.current
        .sort(__WEBPACK_IMPORTED_MODULE_11__common_utils__["j" /* UtilsBeneficiaries */].sortPrimaryThenByName);
    var pendingBeneficiaries = state.policy.beneficiaries.pending
        .sort(__WEBPACK_IMPORTED_MODULE_11__common_utils__["j" /* UtilsBeneficiaries */].sortPrimaryThenByName);
    return {
        currentBeneficiaries: currentBeneficiaries,
        pendingBeneficiaries: pendingBeneficiaries,
        policies: state.policy.policies,
        deleteSucceed: state.policy.deleteSucceed,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var ConnectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(BeneficiariesPage);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__auth_authComponents__["a" /* ensureUserHasRole */])(ConnectedPage, ["Customer" /* Customer */]));


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_paymentActions__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__payment_InvoiceDetails__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__payment_PaymentHistoryList__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__payment_UpdatePaymentDetails__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};










var TransactionsPage = /** @class */ (function (_super) {
    __extends(TransactionsPage, _super);
    function TransactionsPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTab = function (tabParam) {
            var tab = null;
            if (tabParam === 'payment-info') {
                tab = __WEBPACK_IMPORTED_MODULE_8__payment_UpdatePaymentDetails__["a" /* default */];
            }
            else if (tabParam === 'view-bills' && _this.props.match.params.invoiceNumber) {
                tab = __WEBPACK_IMPORTED_MODULE_6__payment_InvoiceDetails__["a" /* default */];
            }
            else {
                tab = __WEBPACK_IMPORTED_MODULE_7__payment_PaymentHistoryList__["a" /* default */];
            }
            return tab;
        };
        return _this;
    }
    TransactionsPage.prototype.componentDidMount = function () {
        var _this = this;
        this.props.actions
            .fetchUser(this.props.match.params.userId)
            .then(function () { return _this.props.actions.fetchCustomerPayments(_this.props.match.params.userId); });
    };
    TransactionsPage.prototype.render = function () {
        var _a = this.props, className = _a.className, props = __rest(_a, ["className"]);
        var Tab = this.getTab(this.props.match.params.tab);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["b" /* Page */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["d" /* PageHeader */], { title: "Billing" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_common__["h" /* Tabs */], { className: "no-print", tabs: [
                        {
                            label: 'Your bills',
                            to: "/user/" + this.props.match.params.userId + "/billing/view-bills"
                        },
                        {
                            label: 'Update your payment info',
                            to: "/user/" + this.props.match.params.userId + "/billing/payment-info"
                        }
                    ], match: this.props.match }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tab, __assign({ className: "tab-content" }, props)))));
    };
    return TransactionsPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        payments: state.payment.payments,
        customer: state.user.user
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__payment_paymentActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var ConnectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(TransactionsPage);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__auth_authComponents__["a" /* ensureUserHasRole */])(ConnectedPage, ["Customer" /* Customer */]));


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserDetailsForm__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__auth_authComponents__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};










var ProfilePage = /** @class */ (function (_super) {
    __extends(ProfilePage, _super);
    function ProfilePage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errors = {
            email: {},
            mailingPostalCode: {},
            billingPostalCode: {}
        };
        _this.onUserChange = function (e) {
            var user = __assign({}, _this.props.user, (_a = {}, _a[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value, _a));
            _this.props.actions.setUser(user);
            var _a;
        };
        _this.validate = function () {
            // true means invalid
            return {
                email: __WEBPACK_IMPORTED_MODULE_8__common_utils__["k" /* Validation */].validateEmail(_this.props.user.email),
                mailingPostalCode: __WEBPACK_IMPORTED_MODULE_8__common_utils__["k" /* Validation */]
                    .validatePostalCode(_this.props.user.mailingPostalCode, 'Mailing postal code is not valid.'),
                billingPostalCode: __WEBPACK_IMPORTED_MODULE_8__common_utils__["k" /* Validation */]
                    .validatePostalCode(_this.props.user.billingPostalCode, 'Billing postal code is not valid.')
            };
        };
        _this.save = function () {
            var user = __assign({}, _this.props.user);
            if (user.isSameAddress) {
                user.billingAddress = user.mailingAddress;
                user.billingCity = user.mailingCity;
                user.billingProvince = user.mailingProvince;
                user.billingPostalCode = user.mailingPostalCode;
                user.billingCountry = user.mailingCountry;
            }
            var proms = [];
            proms.push(_this.props.actions.saveUser(user));
            if (_this.state.originalEmail !== user.email) {
                proms.push(_this.props.actions.updateStripeCustomerEmail(user.stripeCustomerId, user.email));
                _this.setState({ originalEmail: user.email });
            }
            Promise.all(proms).then(function () {
                __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Saved!');
            });
        };
        _this.isSaveDisabled = function () {
            if (_this.errors.email.hasError ||
                _this.errors.mailingPostalCode.hasError ||
                (!_this.props.user.isSameAddress && _this.errors.billingPostalCode.hasError) ||
                !_this.props.user.firstName || !_this.props.user.lastName ||
                !_this.props.user.email || !_this.props.user.mailingAddress ||
                !_this.props.user.mailingCity || !_this.props.user.mailingProvince ||
                !_this.props.user.mailingPostalCode || !_this.props.user.mailingCountry ||
                (!_this.props.user.isSameAddress && !_this.props.user.billingAddress ||
                    !_this.props.user.billingCity || !_this.props.user.billingProvince ||
                    !_this.props.user.billingPostalCode || !_this.props.user.billingCountry)) {
                return true;
            }
            return false;
        };
        return _this;
    }
    ProfilePage.prototype.componentDidMount = function () {
        var _this = this;
        this.props.actions.fetchUser(this.props.match.params.userId)
            .then(function () { return _this.setState({ originalEmail: _this.props.user.email }); });
    };
    ProfilePage.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_common__["b" /* Page */], { title: "Profile" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_common__["d" /* PageHeader */], { title: "Your profile" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__UserDetailsForm__["a" /* default */], __assign({}, this.props, { onUserChange: this.onUserChange, errors: this.errors })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_buttons__["a" /* Button */], { onClick: this.save, disabled: this.isSaveDisabled(), className: "btn-primary mt-4" }, "Save"))));
    };
    return ProfilePage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        user: state.user.user,
        currentUser: state.auth.currentUser
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var ConnectedPage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ProfilePage);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__auth_authComponents__["a" /* ensureUserHasRole */])(ConnectedPage, ["Customer" /* Customer */]));


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__payment_paymentActions__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FirstTimeModal__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__auth_authComponents__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ReferralSection__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__auth_authActions__ = __webpack_require__(17);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
















var UserHomePage = /** @class */ (function (_super) {
    __extends(UserHomePage, _super);
    function UserHomePage(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFirstTimeLogin = function () {
            if (!_this.props.currentUser.hasSignedIn) {
                _this.props.actions.setCurrentUserhasSignedIn(true);
                _this.setState({ isFirstTimeModalOpen: true });
            }
        };
        _this.onCloseFirstTimeModal = function () {
            _this.setState({ isFirstTimeModalOpen: false });
        };
        _this.renderBeneficiaryList = function (confirmedBeneficiaries, pendingBeneficiaries, policyId) {
            // currenly only display primary beneficiaries in user dashboard page
            var filteredConfirmed = confirmedBeneficiaries
                .filter(function (b) { return b.customerPolicyId === policyId && b.typeId === __WEBPACK_IMPORTED_MODULE_4__common_utils__["d" /* BeneficiaryTypes */].Primary; });
            var filteredPending = pendingBeneficiaries
                .filter(function (b) { return b.customerPolicyId === policyId && b.typeId === __WEBPACK_IMPORTED_MODULE_4__common_utils__["d" /* BeneficiaryTypes */].Primary; });
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, filteredConfirmed && filteredConfirmed.length > 0 ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "p-3 mt-3 ml-4 border" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customer-dashboard-plan-info" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "large" }, "Beneficiaries (Confirmed):"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */], { to: "/user/" + _this.props.user.id + "/beneficiaries", className: "btn btn-link px-0 arrow-link" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "arrow-link-content" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "arrow-link-label" }, "Edit beneficiaries"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_icons__["m" /* IconArrowRight */], { className: "arrow-link-icon" })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null, filteredConfirmed.map(function (beneficiary) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: beneficiary.id },
                        beneficiary.name,
                        " (",
                        __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].toPercent(beneficiary.disbursementPercent),
                        ")");
                })),
                (filteredPending && filteredPending.length > 0) && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { className: "reduced-em" }, "You have pending changes. This list will be updated once all beneficiaries have been confirmed."))))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "p-3 mt-3 ml-4 border border-warning" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customer-dashboard-plan-info" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "large" },
                        "Beneficiaries (",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Pending"),
                        "):"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */], { to: "/user/" + _this.props.user.id + "/beneficiaries", className: "btn btn-link px-0 arrow-link" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "arrow-link-content" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "arrow-link-label" }, "Edit beneficiaries"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_icons__["m" /* IconArrowRight */], { className: "arrow-link-icon" })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null, (filteredPending && filteredPending.length) > 0 ? (filteredPending.map(function (beneficiary) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: beneficiary.id },
                        beneficiary.name,
                        " (",
                        __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].toPercent(beneficiary.disbursementPercent),
                        ")");
                })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { className: "reduced-em" }, "No beneficiaries"))))))));
        };
        _this.onDownload = function (userId, policyId) {
            _this.props.actions.fetchCustomerPolicyDocumentUrl(userId, policyId).then(function () {
                window.open(_this.props.tempPolicyDocumentUrl);
            });
        };
        _this.state = {
            isFirstTimeModalOpen: false,
            isLoading: true
        };
        return _this;
    }
    UserHomePage.prototype.componentDidMount = function () {
        var _this = this;
        var userId = this.props.currentUser.id;
        var p1 = this.props.actions.fetchUser(userId);
        var p2 = this.props.actions.fetchCustomerPayments(userId);
        var p3 = this.props.actions.fetchCustomerPolicies(userId).then(function () {
            var totalCoverage = _this.props.policies.reduce(function (total, policy) { return total + (policy.coverageAmount || 0); }, 0);
            _this.setState({ totalCoverage: totalCoverage });
        });
        var p4 = this.props.actions.fetchCustomerPolicyBeneficiaries(userId);
        var p5 = this.props.actions.fetchCustomerUpcomingInvoice(userId);
        Promise.all([p1, p2, p3, p4, p5])
            .then(function () {
            _this.handleFirstTimeLogin();
            return _this.setState({ isLoading: false });
        });
    };
    UserHomePage.prototype.render = function () {
        var _this = this;
        var _a = this.props, policies = _a.policies, currentBeneficiaries = _a.currentBeneficiaries, pendingBeneficiaries = _a.pendingBeneficiaries;
        return !this.state.isLoading && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_common__["b" /* Page */], { title: "Dashboard" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_common__["c" /* PageContent */], { sectionClassName: "dashboard-row p-0" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "dashboard-col dashboard-cell customer-dashboard-col-main content-set content-set-lg" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("header", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", null,
                            "Total coverage: ",
                            this.state.totalCoverage ? __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatCurrency(this.state.totalCoverage, 0) : '-')),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customer-dashboard-plans-wrapper content-set content-set-lg" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled mb-0 customer-dashboard-plans" }, policies.length > 0 ? (policies.map(function (policy) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: policy.id, className: "customer-dashboard-plan" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "customer-dashboard-plan-info" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "d-inline large" },
                                    "Policy ",
                                    policy.number,
                                    ": ",
                                    __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].formatCurrency(policy.coverageAmount, 0)),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "d-inline" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_buttons__["a" /* Button */], { onClick: function () { return _this.onDownload(_this.props.user.id, policy.id); }, className: "btn-link px-0 arrow-link" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "arrow-link-label" }, "Download policy"),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_icons__["m" /* IconArrowRight */], { className: "arrow-link-icon" })))),
                            _this.renderBeneficiaryList(currentBeneficiaries, pendingBeneficiaries, policy.id))); })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { className: "reduced-em" }, "No policies")))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "workflow-progress-actions text-left" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "d-block d-md-inline" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_buttons__["a" /* Button */], { to: "/quote/A/about-you", className: "btn-outline-primary btn-icon-wrap workflow-progress-action" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mr-2" }, "Add a policy"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_icons__["k" /* IconAdd */], null)))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "dashboard-col dashboard-col-center customer-dashboard-col" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "dashboard-row dashboard-cell dashboard-cell-flex justify-content-start" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mt-4" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_buttons__["a" /* Button */], { to: "/user/" + this.props.user.id + "/billing/view-bills", className: "btn-outline-secondary btn-icon-wrap" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mr-2" }, "View your bills"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_icons__["m" /* IconArrowRight */], null))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_buttons__["a" /* Button */], { to: "/user/" + this.props.user.id + "/billing/payment-info", className: "btn-outline-secondary btn-icon-wrap" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "align-middle mr-2" }, "Update your payment info"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_icons__["m" /* IconArrowRight */], null)))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__ReferralSection__["a" /* default */], null))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__FirstTimeModal__["a" /* default */], { userId: this.props.user.id, isOpen: this.state.isFirstTimeModalOpen, onRequestClose: this.onCloseFirstTimeModal })));
    };
    return UserHomePage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        user: state.user.user,
        payments: state.payment.payments,
        policies: state.policy.policies,
        tempPolicyDocumentUrl: state.policy.tempPolicyDocumentUrl,
        currentBeneficiaries: state.policy.beneficiaries.current,
        pendingBeneficiaries: state.policy.beneficiaries.pending,
        invoice: state.payment.invoice,
        currentUser: state.auth.currentUser
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_5__payment_paymentActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__policy_policyActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__userActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__auth_authActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
var connectedUserHomePage = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(UserHomePage);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__auth_authComponents__["a" /* ensureUserHasRole */])(connectedUserHomePage, ["Customer" /* Customer */]));


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons_Button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var ANIM_DURATION = 300;
var FirstTimeModal = /** @class */ (function (_super) {
    __extends(FirstTimeModal, _super);
    function FirstTimeModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onAfterClose = function () {
            __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].enableBodyScrolling();
        };
        // http://reactcommunity.org/react-modal/accessibility/#app-element
        __WEBPACK_IMPORTED_MODULE_1_react_modal__["setAppElement"]('#root');
        return _this;
    }
    FirstTimeModal.prototype.componentDidMount = function () {
        if (this.props.isOpen) {
            __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].disableBodyScrolling({ allBreakpoints: true });
        }
    };
    FirstTimeModal.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isOpen !== this.props.isOpen) {
            if (this.props.isOpen) {
                __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].disableBodyScrolling({ allBreakpoints: true });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].enableBodyScrolling();
            }
        }
    };
    FirstTimeModal.prototype.componentWillUnmount = function () {
        __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].enableBodyScrolling();
    };
    FirstTimeModal.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_modal__, { className: "ReactModal_Content section section-main" // Redefine className to remove inline styles
            , closeTimeoutMS: ANIM_DURATION, contentLabel: "TODO", isOpen: this.props.isOpen, overlayClassName: "ReactModal_Overlay" // Redefine className to remove inline styles
            , portalClassName: "ReactModal" // Redefine className to remove inline styles
            , shouldCloseOnEsc: false, shouldCloseOnOverlayClick: false },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "mb-3" }, "Welcome"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Tell you friends about Mosaic Life and you could each receive up to $120 if they sign up"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-3 d-flex flex-column flex-sm-row justify-content-sm-end" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons_Button__["a" /* default */], { className: "btn-outline-secondary order-last order-sm-first", onClick: this.props.onRequestClose }, "Maybe later"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_buttons_Button__["a" /* default */], { className: "btn-secondary ml-sm-3", to: "/user/" + this.props.userId + "/refer" },
                    "Refer someone",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_icons__["m" /* IconArrowRight */], { className: "d-none d-sm-inline-block ml-2" })))));
    };
    return FirstTimeModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FirstTimeModal);


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var ReferralSection = /** @class */ (function (_super) {
    __extends(ReferralSection, _super);
    function ReferralSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReferralSection.prototype.componentDidMount = function () {
        this.props.actions.fetchReferrals(this.props.currentUser.id);
    };
    ReferralSection.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "dashboard-row dashboard-cell dashboard-cell-flex" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                "Referral Balance: ",
                __WEBPACK_IMPORTED_MODULE_5__common_utils__["m" /* default */].formatCurrency(this.props.referrals.referralBalance)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], { to: "/user/" + this.props.currentUser.id + "/refer" }, "Refer someone and you each receive credit towards the next payment!")))));
    };
    return ReferralSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        currentUser: state.auth.currentUser,
        referrals: state.user.referrals
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_4__userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ReferralSection));


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_commonActions__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ClaimForm__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common__ = __webpack_require__(3);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var MakeAClaimPage = /** @class */ (function (_super) {
    __extends(MakeAClaimPage, _super);
    function MakeAClaimPage(props) {
        var _this = _super.call(this, props) || this;
        _this.getInitialState = function () {
            return {
                form: {
                    name: '',
                    phone: '',
                    email: '',
                    policyNumber: '',
                    deceasedName: '',
                    comments: ''
                },
                loading: false
            };
        };
        _this.onFormChange = function (e) {
            var form = __assign({}, _this.state.form, (_a = {}, _a[e.target.name] = e.target.value, _a));
            _this.setState({ form: form });
            var _a;
        };
        _this.onPhoneKeyUp = function (e) {
            var phone = e.target.value;
            phone = phone
                .match(/\d*/g)
                .join('')
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
                .slice(1)
                .join('-')
                .replace(/-*$/g, '');
            var form = __assign({}, _this.state.form, { phone: phone });
            _this.setState({ form: form });
        };
        _this.onSubmit = function () {
            _this.setState({ loading: true });
            _this.props.actions.fileAClaim(_this.state.form)
                .then(function () {
                _this.setState(_this.getInitialState());
                __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Your form has been sent! We will contact you as soon as we can.');
            });
        };
        _this.state = _this.getInitialState();
        return _this;
    }
    MakeAClaimPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["b" /* Page */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_helmet__["Helmet"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { charSet: "utf-8" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "If you need to make a life insurance claim, fill out our quick easy to use form and Mosaic Life will help you promptly. " }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Make a Claim | Mosaic Life")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-4" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["d" /* PageHeader */], { title: "Make a Claim" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We're sorry for your loss."),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Please fill out the form below and we will contact you shortly to begin the claim process. We aim to respond within 1 business day."),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                        "If you have questions about a claim, call us at ",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "tel:1-855-643-6945" }, "1-855-643-6945"),
                        ".")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ClaimForm__["a" /* default */], { loading: this.state.loading, form: this.state.form, onFormChange: this.onFormChange, onPhoneKeyUp: this.onPhoneKeyUp, onSubmit: this.onSubmit }))));
    };
    return MakeAClaimPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_5__common_commonActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(null, mapDispatchToProps)(MakeAClaimPage));


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var apiUrl = "https://www.insuredbymosaic.ca/api";
var commonAPI = {
    contactUs: function (form) {
        var data = __assign({}, form);
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/contact-us", data)
            .then(function (response) { return response.data; });
    },
    fileAClaim: function (form) {
        var data = __assign({}, form);
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/file-a-claim", data)
            .then(function (response) { return response.data; });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (commonAPI);


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var classNames = __webpack_require__(8);




var ClaimForm = /** @class */ (function (_super) {
    __extends(ClaimForm, _super);
    function ClaimForm(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = { email: {} };
        _this.handleBlur = function (field) { return function (evt) {
            _this.setState({
                touched: __assign({}, _this.state.touched, (_a = {}, _a[field] = true, _a))
            });
            var _a;
        }; };
        _this.isSubmitDisabled = function () {
            if (!_this.props.form.name || !_this.props.form.phone || !_this.props.form.deceasedName) {
                return true;
            }
            if (_this.props.form.email !== '') {
                var errors = _this.validate();
                return errors.email.hasError;
            }
            if (_this.props.loading) {
                return true;
            }
            return false;
        };
        _this.validate = function () {
            // true means invalid
            return {
                email: __WEBPACK_IMPORTED_MODULE_4__common_utils__["k" /* Validation */].validateEmail(_this.props.form.email)
            };
        };
        _this.state = {
            touched: {
                email: false
            }
        };
        return _this;
    }
    ClaimForm.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames('', this.props.className) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title" }, "Your contact info"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { id: "claimantName", labelText: "Your name", name: "name", onChange: this.props.onFormChange, value: this.props.form.name, className: "col-md-6", required: true }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { id: "claimantPhone", labelText: "Phone", name: "phone", onChange: this.props.onFormChange, onKeyUp: this.props.onPhoneKeyUp, value: this.props.form.phone, className: "col-md-6", required: true }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { id: "claimantEmail", labelText: "Email", name: "email", onBlur: this.handleBlur('email'), onChange: this.props.onFormChange, value: this.props.form.email, className: "col-md-12 mb-2", error: __WEBPACK_IMPORTED_MODULE_4__common_utils__["m" /* default */].shouldMarkError(this.errors.email, this.state.touched.email) ? this.errors.email : undefined }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title mt-4" }, "Policy info"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { id: "claimPolicyNumber", labelText: "Policy #", name: "policyNumber", onChange: this.props.onFormChange, value: this.props.form.policyNumber, className: "col-md-6 mb-md-2" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { id: "claimDeceasedName", labelText: "Name of insured", name: "deceasedName", onChange: this.props.onFormChange, value: this.props.form.deceasedName, className: "col-md-6 mb-2", required: true }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "form-fieldset-title mt-4" }, "Additional info"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["m" /* TextArea */], { id: "claimComments", labelText: "Comments", name: "comments", onChange: this.props.onFormChange, value: this.props.form.comments, className: "mb-2" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_buttons__["a" /* Button */], { onClick: this.props.onSubmit, className: "btn-primary mt-4", disabled: this.isSubmitDisabled() },
                "Begin claim process ",
                this.props.loading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_common__["f" /* Spinner */], null))));
    };
    return ClaimForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ClaimForm);


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_Fieldset__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var ResetPasswordPage = /** @class */ (function (_super) {
    __extends(ResetPasswordPage, _super);
    function ResetPasswordPage(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.validate = function () {
            return {
                password: { hasError: _this.state.password.length < 8, message: 'Minimum 8 characters required.' },
                passwordVerification: {
                    hasError: _this.state.passwordVerification !== _this.state.password,
                    message: 'Passwords do not match.'
                }
            };
        };
        _this.onBlur = function (field) { return function (evt) {
            _this.setState({
                touched: __assign({}, _this.state.touched, (_a = {}, _a[field] = true, _a))
            });
            var _a;
        }; };
        _this.onChange = function (e) {
            _this.setState((_a = {}, _a[e.target.name] = e.target.value, _a));
            var _a;
        };
        _this.submit = function () {
            __WEBPACK_IMPORTED_MODULE_1_toastr__["info"]('Not yet implemented!');
        };
        _this.isSubmitDisabled = function () {
            var errors = _this.validate();
            return errors.password.hasError || errors.passwordVerification.hasError;
        };
        _this.state = {
            password: '',
            passwordVerification: '',
            touched: {
                password: false,
                passwordVerification: false
            }
        };
        return _this;
    }
    ResetPasswordPage.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["b" /* Page */], { title: "Reset Password" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["d" /* PageHeader */], { title: "Reset your password", isCentered: true }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__components_forms_Fieldset__["a" /* default */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { labelText: "Password", type: "password", name: "password", onBlur: this.onBlur('password'), onChange: this.onChange, value: this.state.password, required: true, error: __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].shouldMarkError(this.errors.password, this.state.touched.password)
                            ? this.errors.password
                            : undefined }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_forms__["n" /* TextInput */], { labelText: "Re-enter your password", type: "password", name: "passwordVerification", onBlur: this.onBlur('passwordVerification'), onChange: this.onChange, value: this.state.passwordVerification, required: true, className: "mb-0", error: __WEBPACK_IMPORTED_MODULE_6__common_utils__["m" /* default */].shouldMarkError(this.errors.passwordVerification, this.state.touched.passwordVerification)
                            ? this.errors.passwordVerification
                            : undefined }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { className: "btn-primary", onClick: this.submit, disabled: this.isSubmitDisabled() }, "Submit")))));
    };
    return ResetPasswordPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ResetPasswordPage);


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sections__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__landing_HomePageAssessment__ = __webpack_require__(43);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var ReferralLinkPage = /** @class */ (function (_super) {
    __extends(ReferralLinkPage, _super);
    function ReferralLinkPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReferralLinkPage.prototype.componentDidMount = function () {
        var _this = this;
        var referralCode = this.props.match.params.referralCode;
        this.props.actions.fetchReferrerNameByReferralCode(referralCode)
            .then(function () {
            if (_this.props.referrerName === '') {
                // if the referral code was invalid, redirect to home page
                _this.props.history.replace('/');
            }
            else {
                _this.props.actions.setReferralCode(referralCode);
            }
        });
    };
    ReferralLinkPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["b" /* Page */], { title: "" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("header", { className: "page-hero page-hero-lg" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "page-hero-content" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-5 text-light d-flex flex-column justify-content-center" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "page-hero-title page-title-display" }, "Welcome"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0 lead max-read-width" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, this.props.referrerName),
                                    " has invited you to join Mosaic Life. Sign up today and you and ",
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, this.props.referrerName),
                                    " will each receive a ",
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "$25"),
                                    " credit after your first month.")),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 offset-md-1 mt-5 mt-md-0 pl-0 d-flex flex-column justify-content-center" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_sections__["c" /* SectionRight */], { columns: 12 },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__landing_HomePageAssessment__["a" /* default */], null)))))))));
    };
    return ReferralLinkPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        user: state.user.user,
        referrerName: state.user.referrerName
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ReferralLinkPage));


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sections__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__landing_HomePageAssessment__ = __webpack_require__(43);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var SpousalReferralLinkPage = /** @class */ (function (_super) {
    __extends(SpousalReferralLinkPage, _super);
    function SpousalReferralLinkPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpousalReferralLinkPage.prototype.componentDidMount = function () {
        var _this = this;
        var spousalReferralCode = this.props.match.params.spousalReferralCode;
        this.props.actions.fetchReferrerNameBySpousalReferralCode(spousalReferralCode)
            .then(function () {
            if (_this.props.referrerName === '') {
                // if the referral code was invalid, redirect to home page
                _this.props.history.replace('/');
            }
            else {
                _this.props.actions.setReferralCode(spousalReferralCode);
            }
        });
    };
    SpousalReferralLinkPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["b" /* Page */], { title: "" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("header", { className: "page-hero page-hero-lg" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "page-hero-content" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-5 text-light d-flex flex-column justify-content-center" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "page-hero-title page-title-display" }, "Welcome"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0 lead max-read-width" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, this.props.referrerName),
                                    " has invited you to join Mosaic Life. Sign up today and you and ",
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, this.props.referrerName),
                                    " will each receive a ",
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "$120"),
                                    " credit after your first month.")),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6 offset-md-1 mt-5 mt-md-0 pl-0 d-flex flex-column justify-content-center" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_sections__["c" /* SectionRight */], { columns: 12 },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__landing_HomePageAssessment__["a" /* default */], null)))))))));
    };
    return SpousalReferralLinkPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        user: state.user.user,
        referrerName: state.user.referrerName
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_3__user_userActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(SpousalReferralLinkPage));


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sections__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_authActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms_FileUpload__ = __webpack_require__(169);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









var MarkPage = /** @class */ (function (_super) {
    __extends(MarkPage, _super);
    function MarkPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.authAPIClick = function (e) {
            var apiUrl = "https://www.insuredbymosaic.ca/api";
            console.log(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers);
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(apiUrl + "/helloAuth")
                .then(function (response) {
                console.log(response.data);
            });
        };
        _this.customerAPIClick = function (e) {
            var apiUrl = "https://www.insuredbymosaic.ca/api";
            console.log(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers);
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(apiUrl + "/helloAuth/customeronly")
                .then(function (response) {
                console.log(response.data);
            });
        };
        _this.adminAPIClick = function (e) {
            var apiUrl = "https://www.insuredbymosaic.ca/api";
            console.log(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers);
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(apiUrl + "/helloAuth/adminonly")
                .then(function (response) {
                console.log(response.data);
            });
        };
        _this.logOut = function (e) {
            _this.props.actions.logout()
                .then(function () { return _this.props.history.push("/quote/success"); });
        };
        _this.refreshToken = function (e) {
            // this.props.actions.refreshToken()
            // .then((response: any) => {
            // 	console.log(response);
            // });
            console.log('could not get a refresh token to work');
        };
        _this.onUpload = function (file) {
            console.log(file);
        };
        return _this;
    }
    MarkPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common__["b" /* Page */], { title: "Pick list types" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common__["d" /* PageHeader */], { title: "Mark Test Page", className: "page-header-sm" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_sections__["b" /* SectionMain */], { sectionClassName: "section-lg" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { onClick: this.authAPIClick }, "Auth API"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { onClick: this.customerAPIClick }, "Customer Only API"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { onClick: this.adminAPIClick }, "Admin Only API"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { onClick: this.logOut }, "Logout"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_buttons__["a" /* Button */], { onClick: this.refreshToken }, "Refresh Token"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_forms_FileUpload__["a" /* default */], { label: "Upload Signed Form", onDrop: this.onUpload }))));
    };
    return MarkPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        auth: state.auth
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_7__auth_authActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_6_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(MarkPage));


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_toastr__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonActions__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};










var ContactUsPage = /** @class */ (function (_super) {
    __extends(ContactUsPage, _super);
    function ContactUsPage(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = { email: {} };
        _this.getInitialState = function () {
            return {
                form: {
                    name: '',
                    email: '',
                    phone: '',
                    message: '',
                    preferredCommunication: ''
                },
                touched: {
                    email: false
                },
                loading: false
            };
        };
        _this.handleBlur = function (field) { return function (evt) {
            _this.setState({
                touched: __assign({}, _this.state.touched, (_a = {}, _a[field] = true, _a))
            });
            var _a;
        }; };
        _this.onFormChange = function (e) {
            var value = e.target.value;
            if (e.target.type === 'radio') {
                if (value === 'true') {
                    value = 'email';
                }
                else if (value === 'false') {
                    value = 'phone';
                }
            }
            var form = __assign({}, _this.state.form, (_a = {}, _a[e.target.name] = value, _a));
            _this.setState({ form: form });
            var _a;
        };
        _this.onPhoneKeyUp = function (e) {
            var phone = e.target.value;
            phone = phone
                .match(/\d*/g)
                .join('')
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
                .slice(1)
                .join('-')
                .replace(/-*$/g, '');
            var form = __assign({}, _this.state.form, { phone: phone });
            _this.setState({ form: form });
        };
        _this.isSubmitDisabled = function () {
            var form = _this.state.form;
            if (!form.name || !form.preferredCommunication || !form.message) {
                return true;
            }
            if (form.preferredCommunication === 'email' && !form.email) {
                return true;
            }
            if (form.preferredCommunication === 'phone' && !form.phone) {
                return true;
            }
            if (form.email !== '') {
                return _this.errors.email.hasError;
            }
            if (_this.state.loading) {
                return true;
            }
            return false;
        };
        _this.onSubmit = function () {
            _this.setState({ loading: true });
            _this.props.actions.contactUs(_this.state.form)
                .then(function () {
                _this.setState(_this.getInitialState());
                __WEBPACK_IMPORTED_MODULE_4_toastr__["success"]('Your message has been sent! We will contact you as soon as we can.');
            });
        };
        _this.validate = function () {
            // true means invalid
            return {
                email: __WEBPACK_IMPORTED_MODULE_9__common_utils__["k" /* Validation */].validateEmail(_this.state.form.email)
            };
        };
        _this.redirectToComplaints = function () {
            _this.props.history.push("/complaints");
        };
        _this.state = _this.getInitialState();
        return _this;
    }
    ContactUsPage.prototype.render = function () {
        this.errors = this.validate();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["b" /* Page */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_helmet__["Helmet"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { charSet: "utf-8" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "If you have questions about life insurance, contact Mosaic Life by phone or fill out our contact form and we'll be glad to help." }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Contact Us | Mosaic Life")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["c" /* PageContent */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["e" /* PageHeaderFullWidth */], { title: "Contact Us" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We\u2019re taking insurance online but we\u2019re not robots.  Please drop us a line if you have any questions.")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-fieldset" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_forms__["n" /* TextInput */], { id: "name", labelText: "Name", name: "name", onChange: this.onFormChange, value: this.state.form.name, className: "col-md-6" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_forms__["o" /* ToggleSwitch */], { labelText: "Preferred Communication", id: "preferredCommunication", name: "preferredCommunication", onChildren: "Email", offChildren: "Phone", onChange: this.onFormChange, checked: this.state.form.preferredCommunication === '' ?
                                undefined : this.state.form.preferredCommunication === 'email', className: "col-md-6 toggle-do-donot" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_forms__["n" /* TextInput */], { id: "email", labelText: "Email", name: "email", onBlur: this.handleBlur('email'), onChange: this.onFormChange, value: this.state.form.email, className: "col-md-6", error: __WEBPACK_IMPORTED_MODULE_9__common_utils__["m" /* default */].shouldMarkError(this.errors.email, this.state.touched.email) ? this.errors.email : undefined }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_forms__["n" /* TextInput */], { id: "phone", labelText: "Phone", name: "phone", onChange: this.onFormChange, onKeyUp: this.onPhoneKeyUp, value: this.state.form.phone, className: "col-md-6" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_forms__["m" /* TextArea */], { id: "message", labelText: "Message", name: "message", onChange: this.onFormChange, value: this.state.form.message, className: "col-md-12" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_buttons__["a" /* Button */], { onClick: this.onSubmit, className: "btn-primary mt-4", disabled: this.isSubmitDisabled() },
                    "Submit ",
                    this.state.loading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_common__["f" /* Spinner */], null)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_buttons__["a" /* Button */], { className: "float-right mt-4 btn btn-link", onClick: this.redirectToComplaints }, "Have a complaint?"))));
    };
    return ContactUsPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_5__commonActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(null, mapDispatchToProps)(ContactUsPage));


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);



var TermsPage = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["b" /* Page */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { charSet: "utf-8" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "A description of Mosaic Life's Terms of Use policies." }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Terms of Use | Mosaic Life")),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["c" /* PageContent */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["d" /* PageHeader */], { title: "Terms & Conditions" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Acceptance Of Conditions"),
                " - By accessing and browsing this web site, visitors accept, without limitation or qualification, the Terms and Conditions contained below and all applicable laws. First Canadian Group of Companies (First Canadian Insurance Corporation, Millennium Insurance Corporation, Data Gathering Service Inc. and Platinum Tire and Rim Protection Inc.) may at any time revise these Terms and Conditions by updating this posting. Visitors agree to be bound by such revisions, and should periodically revisit this page to review the current Terms and Conditions."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Information Accuracy"),
                " - Although the contents of this website are believed to be reliable when posted, First Canadian Group of Companies cannot guarantee this information to be current, accurate or complete. The information is subject to modification and updating from time to time without notice. Prior to acting upon any of this information, please contact your independent financial advisor to verify its accuracy."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Web Site Content"),
                " - The information on this website does not constitute an offer to buy or sell products or services and is not intended to provide professional advice including, without limitation, financial, legal, accounting or tax advice. The information should not be relied upon in this regard. Please contact your independent financial advisor for assistance."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Product Availability"),
                " - The products and services referred to on this website may not be available in all geographic regions. First Canadian Group of Companies products and services are only available in provinces and territories of Canada and other jurisdictions in accordance with the local law and where they may be legally offered for sale. All products and services are subject to the terms, conditions and limitations of the applicable agreements."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Trademarks And Copyright"),
                " - All contents of this web site are the copyright of First Canadian Group of Companies and are protected under the copyright laws of Canada and other countries. All rights reserved. In addition, certain information on this web site may be copyrighted by others. The information on this web site shall only be copied for personal use and may not be reproduced, or distributed for any other purpose in whole or in part without the prior written permission of First Canadian Group of Companies. Any infringement of First Canadian Group of Companies rights will result in appropriate legal action."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Hypertext Links"),
                " - This web site may facilitate access by hypertext links to other worldwide web sites. These hypertext links are entirely independent of this web site and shall NOT in any manner be construed as any reflection on or any affiliation with or endorsement of such site or entity or its respective products, services or contributions to this web site. First Canadian Group of Companies has not reviewed the content linked to. The right to reproduce and use the content linked to is (1) subject to the conditions that the respective owners may impose, and (2) is at your own risk."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Privacy And Security"),
                " - First Canadian Group of Companies attempts to maintain security efforts which are consistent with standard industry practice in Canada. However, complete privacy, confidentiality and security are not yet possible over the Internet. Therefore, First Canadian Group of Companies shall not be responsible or liable for any harm or loss, which may be suffered by any party, resulting from the use, communication or transmission of any information, including private, confidential or sensitive information to or from this web site."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "E-mail"),
                " - First Canadian Group of Companies will not accept transactions or instructions by Internet E-Mail messages, unless otherwise specified. However, questions of a general nature or inquiries may be communicated by E-Mail messages. First Canadian Group of Companies discourages customers from sending confidential and personal information by Internet E-Mail messages, as the security of these messages cannot be guaranteed. Any person who chooses to send a message by E-Mail does so at his or her own risk and First Canadian Group of Companies will not be held responsible for any damages or losses incurred as a result. Any communication transmitted to us by electronic mail, regular post or otherwise becomes the property of First Canadian Group of Companies or its affiliates and may be used for any purpose. First Canadian Group of Companies is free to use any idea contained in any communication sent to us for any purpose whatsoever, including, but not limited to, developing, manufacturing and marketing products using such information."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Liability"),
                " - First Canadian Group of Companies, its officers, directors, employees or any persons associated with the creation of this web site, are NOT responsible in any manner whatsoever for any harm, loss or damage that may arise in connection with or through the use of this web site including, without limitation, any direct, indirect, special, third party or consequential damages, howsoever caused. By accessing and browsing this web site, visitors agree that the laws of Alberta and Canada apply to any issue that might arise with First Canadian Group of Companies regarding this site, and to settle such dispute in the courts of Alberta."))));
};
/* harmony default export */ __webpack_exports__["a"] = (TermsPage);


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);



var PrivacyPolicyPage = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["b" /* Page */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { charSet: "utf-8" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: "Mosaic Life's Privacy Policy protects the data of our customers who purchase life insurance through our website." }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, "Privacy Policy | Mosaic Life")),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["c" /* PageContent */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("header", { className: "page-header mb-4 mb-md-5'" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "page-header-title" }, "Privacy Policy"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mb-0" }, "We are committed to maintaining the security, confidentiality and accuracy of all personal information under our control. As part of this commitment, we have established the following TEN PRIVACY PRINCIPLES that govern our information handling practices:")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 mt-4" }, "Principle 1 - Accountability"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We are responsible for personal information under our control and we have designated one or more persons who are accountable for our compliance with the privacy principles."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 mt-4" }, "Principle 2 - Identifying Purposes for Collection of Personal Information"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We identify the purposes for which personal information is collected at or before the time the information is collected."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 mt-4" }, "Principle 3 - Obtaining Consent for Collection, Use, or Disclosure of Personal Information"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We obtain the customer's consent to the collection, use or disclosure of personal information unless consent is not required by law."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 mt-4" }, "Principle 4 - Limiting Collection of Personal Information"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We limit the collection of personal information to that which is necessary for the purposes identified. We only collect personal information by fair and lawful means."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 mt-4" }, "Principle 5 - Limiting Use, Disclosure and Retention of Personal Information"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We do not use or disclose personal information for purposes other than those for which it was collected, except with the consent of the individual or as permitted by law. We retain personal information only as long as is necessary and in accordance with statutory requirements."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 mt-4" }, "Principle 6 - Accuracy of Personal Information"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Personal information is maintained in as accurate and up to date a form as is necessary to fulfill the purposes for which it is to be used."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 mt-4" }, "Principle 7 - Safeguarding Personal Information"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We protect personal information with appropriate security safeguards in accordance with legislated requirements."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 mt-4" }, "Principle 8 - Openness Concerning Protocol and Practices"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "We make information available to our individual customers and employees concerning the policies and practices that apply to the management of their personal information."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 mt-4" }, "Principle 9 - Customer and Employee Access to Personal Information"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Upon request, individual customers and employees will be informed of the existence, use and disclosure of their personal information, and be given access to it. Individual customers and employees may verify the accuracy and completeness of their information, and may request that the information be amended where appropriate."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 mt-4" }, "Principle 10 - Handling Customer Complaints and Suggestions"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Individual customers or employees may direct any questions or inquiries with respect to the privacy principles outlined above or about our practices to our Corporate Privacy Officer."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 mt-4" }, "Personal Information Practices"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "What personal information is collected:"),
                " The personal information we ask for depends on the nature of the service or product requested and is limited to the information needed to process that request or to provide better service. This refers to personal information contained in applications for insurance protection and information required to process claims made by policyholders, all of which can include personal medical and financial information. We seek to balance the company's need to use such information for reasonable business purposes and individuals' right to privacy in respect of their personal information."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "How personal information is collected:"),
                " Most of the information we collect comes directly from the customer or indirectly from a third party. If a third party requires consent to disclose information, a signed Information Release form is obtained from the customer. If information is being collected by telephone, the call may be recorded and/or monitored. Telephone call recordings are used for quality assurance, training, and to establish a record of the information you provide. If you are not comfortable with having your telephone calls recorded, you have the option of communicating with us in writing. This communication should also request that we respond to you in writing."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "How personal information is used:"),
                " We use personal information to communicate, to deliver products and services you have requested, and to provide information about additional products and services that we believe might be of benefit and interest to you."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Disclosing personal information to outside parties:"),
                " We are required to keep your personal information confidential at all times, except under the following circumstances:"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "When authorized by the party in question; or"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, "When required or otherwise authorized by law. This occurs when medical or security reasons may make it impossible or impractical to seek consent, such as during an investigation of a potential breach of contract, detection of fraud, and/or law enforcement purposes, where seeking consent may be inappropriate when the individual is a minor, seriously ill or otherwise incapacitated.")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Safeguarding information:"),
                " We maintain security standards to ensure that all personal information is protected against unauthorized access, unauthorized disclosure, misuse, or inappropriate alteration."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Accessing and amending information:"),
                " All individual customers have the right to access, verify and amend the personal information held by us. At any time you may withdraw this authorization, or vary (limit) the consent given. When such action is taken, it is our responsibility to explain the implications of such withdrawal, or variation, which may include termination of the insurance protection, or the inability to complete business transactions. To submit a request for access to personal information, customers are asked to contact our Corporate Privacy Officer."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Questions, concerns and complaints:"),
                " If there are any questions about our Privacy Protocol or concerns or complaints about privacy, confidentiality, or our information handling practices, our customers are advised to please contact our Corporate Privacy Officer. If you are not satisfied with the response you receive, you may contact the Information & Privacy Commissioner of Alberta."))));
};
/* harmony default export */ __webpack_exports__["a"] = (PrivacyPolicyPage);


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(21);



var ComplaintsPage = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["b" /* Page */], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["c" /* PageContent */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_common__["d" /* PageHeader */], { title: "HOW TO FILE A COMPLAINT" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 border-bottom text-uppercase" }, "Introduction"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Taking care of our customers is our highest priority. If you think we\u2019ve gotten something wrong, please let us know by following the steps below. We promise to handle your complaint in a professional and courteous manner, guided by the following principles:"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "list-unstyled ml-3 ml-md-4" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "mb-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "text-uppercase mr-2" }, "Culture."),
                    "We welcome your feedback as a way to make sure we take care of our customers. If we\u2019ve dropped the ball, we\u2019ll put things right, and we\u2019ll make sure we do better next time."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "mb-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "text-uppercase mr-2" }, "Accountablity."),
                    "We want to be open and honest when accounting for our decisions and actions."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: "mb-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "text-uppercase mr-2" }, "Procedure."),
                    "We will investigate your complaint thoroughly and fairly according to the procedure set out in this document. Our decision will be based on the available facts and evidence, and it will be made objectively and fairly, without undue delay."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", { className: "text-uppercase mr-2" }, "Put it right."),
                    "Sometimes we get it wrong. When we do, we will take steps to put things right in a fair and proportionate manner. Sometimes we will owe you an apology. And sometimes we must change our procedures, improve employee training, or revise an earlier decision.")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Please feel free to call us at any time at 1-855-643-6945. Most customers resolve their concerns this way."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "If you are dissatisfied with the response, please take the steps explained below."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 border-bottom text-uppercase mt-5" }, "Step 1. Write Us"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "If your concern has not been resolved with a phone call, please write a letter to us explaining your concern and how you would like us to resolve it.  In order to help us address your concern quickly, please include any information and documentation you think is relevant. Our decision will be made based on the available facts and evidence."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table", { className: "ml-3 ml-md-4 mb-3" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", { className: "text-uppercase align-top pr-2" }, "Write:"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-12 pb-2" }, "First Canadian Insurance Corporation - Mosaic Life"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-12 pb-2" }, "320 Sioux Road Sherwood Park, AB T8A 3X6"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-12" }, "ATTENTION: Complaints Administration"))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Your complaint will be forwarded to the appropriate manager, who will review the issue and respond promptly in writing."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "If you are dissatisfied with the response, please take Step 2: Contact the Complaints Ombudsman."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 border-bottom text-uppercase mt-5" }, "Step 2. Contact the complaints ombudsman"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "If your concern has not been resolved by writing us, please contact First Canadian\u2019s Complaints Ombudsman. The Complaints Ombudsman provides a fresh set of eyes to review your file, and will ensure every attempt has been made to reach a fair and equitable solution."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table", { className: "ml-3 ml-md-4 mb-3" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", { className: "text-uppercase align-top pr-2 pb-3" }, "Email:"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "pb-3" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "mailto:ombudsman@firstcanadian.ca" }, "ombudsman@firstcanadian.ca"))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", { className: "text-uppercase align-top pr-2" }, "Write:"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-12 pb-2" }, "First Canadian Insurance Corporation - Mosaic Life"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-12 pb-2" }, "320 Sioux Road Sherwood Park, AB T8A 3X6"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-12" }, "ATTENTION: Complaints Ombudsman"))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Please send your request in writing, explaining your concern, the history of your complaint, and how you would like us to resolve it. The Complaints Ombudsman will respond in writing within 30 days."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "h4 border-bottom text-uppercase mt-5" }, "Step 3. Contact the appropriate external agency"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "If you are not satisfied with our complaint resolution process, assistance and information is available through the national Ombudservice for life and health insurance companies."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table", { className: "ml-3 ml-md-4 mb-3" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", { className: "text-uppercase align-top pr-2 pb-3" }, "Write:"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "row pb-3" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-12 pb-2" }, "OmbudService for Life and Health Insurance (OLHI)"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-12 pb-2" }, "401 Bay Street, PO Box 7"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-12" }, "Toronto, Ontario M5H 2Y4"))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", { className: "text-uppercase align-top pr-2 pb-3" }, "Website:"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: "pb-3" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */], { to: "www.olhi.ca" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h6", { className: "mb-0" }, "www.olhi.ca")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", { className: "text-uppercase align-top pr-2" }, "Phone:"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "tel:1-888-295-8112" }, "1-888-295-8112"))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "border-top mt-5 pt-3" }, "As a provincially licensed and regulated insurance company, we are subject to the Insurance Act and Regulations of each province and territory.  Government regulatory bodies in each jurisdiction oversee the activities of insurance companies and provide assistance to consumers who may have inquiries or concerns."))));
};
/* harmony default export */ __webpack_exports__["a"] = (ComplaintsPage);


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ga__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__quoting_quotingActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__policy_policyActions__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_utils__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};










var qs = __webpack_require__(89);
var CampaignUnbouncePage = /** @class */ (function (_super) {
    __extends(CampaignUnbouncePage, _super);
    function CampaignUnbouncePage(props) {
        var _this = _super.call(this, props) || this;
        _this.getQuote = function () {
            var abTestIndex = __WEBPACK_IMPORTED_MODULE_9__common_utils__["m" /* default */].getABTestOptimizeIndex();
            __WEBPACK_IMPORTED_MODULE_5_react_ga__["set"]({ 'exp': "Szj9gW87RKe5Yo5GErN82A." + abTestIndex });
            var url = __WEBPACK_IMPORTED_MODULE_9__common_utils__["m" /* default */].getABTestWorkflowUrl(abTestIndex, _this.props.customerDetails.age, _this.props.user.gender);
            _this.props.history.push(url);
        };
        return _this;
    }
    CampaignUnbouncePage.prototype.componentWillMount = function () {
        this.props.actions.resetUser();
        this.props.actions.resetCustomerDetails();
        this.props.actions.resetCustomerPolicy();
    };
    CampaignUnbouncePage.prototype.componentDidMount = function () {
        var _this = this;
        var queryString = this.props.location.search[0] === '?'
            ? this.props.location.search.slice(1)
            : this.props.location.search;
        var parsed = qs.parse(queryString);
        var campaignCode = parsed.code;
        var birthdate = parsed.birthdate;
        var sex = parsed.sex.toLowerCase();
        var isSmoker = parsed.smoker === '1';
        var user = __assign({}, this.props.user, { birthdate: birthdate, gender: sex });
        this.props.actions.saveUser(user)
            .then(function () {
            var age = __WEBPACK_IMPORTED_MODULE_9__common_utils__["m" /* default */].getAgeRoundedFromBirthdate(birthdate);
            var customerDetails = __assign({}, _this.props.customerDetails, { age: age,
                isSmoker: isSmoker, customerId: _this.props.user.id });
            return _this.props.actions.saveCustomerDetails(customerDetails);
        })
            .then(function () {
            var customerPolicy = __assign({}, _this.props.customerPolicy, { campaignCode: campaignCode, customerId: _this.props.user.id });
            return _this.props.actions.setCustomerPolicy(customerPolicy);
        })
            .then(function () { return _this.getQuote(); });
    };
    CampaignUnbouncePage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "navbar-account" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common_index__["b" /* Page */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common_index__["c" /* PageContent */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common_index__["d" /* PageHeader */], { isCentered: true, className: "page-header-sm", title: "Creating new application..." }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-4 text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["f" /* Spinner */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mt-3" }, "One moment, please."))))));
    };
    return CampaignUnbouncePage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        user: state.user.user,
        customerDetails: state.quoting.customerDetails,
        customerPolicy: state.policy.customerPolicy,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_6__quoting_quotingActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__user_userActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CampaignUnbouncePage));


/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__quoting_quotingActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_userActions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__policy_policyActions__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var qs = __webpack_require__(89);
var CampaignPage = /** @class */ (function (_super) {
    __extends(CampaignPage, _super);
    function CampaignPage(props) {
        return _super.call(this, props) || this;
    }
    CampaignPage.prototype.componentWillMount = function () {
        this.props.actions.resetUser();
        this.props.actions.resetCustomerDetails();
        this.props.actions.resetCustomerPolicy();
    };
    CampaignPage.prototype.componentDidMount = function () {
        var queryString = this.props.location.search[0] === '?'
            ? this.props.location.search.slice(1)
            : this.props.location.search;
        var parsed = qs.parse(queryString);
        var campaignCode = parsed.code;
        var newPartialPolicy = __assign({}, this.props.customerPolicy, { campaignCode: campaignCode });
        this.props.actions.setCustomerPolicy(newPartialPolicy);
        this.props.history.push('/');
    };
    CampaignPage.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "navbar-account" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common_index__["b" /* Page */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common_index__["c" /* PageContent */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_common_index__["d" /* PageHeader */], { isCentered: true, className: "page-header-sm", title: "Registering your code..." }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mt-4 text-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common__["f" /* Spinner */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "mt-3" }, "One moment, please."))))));
    };
    return CampaignPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        customerPolicy: state.policy.customerPolicy,
    };
}
function mapDispatchToProps(dispatch) {
    var actions = __assign({}, __WEBPACK_IMPORTED_MODULE_5__quoting_quotingActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__user_userActions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__policy_policyActions__["a" /* default */]);
    return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(actions, dispatch)
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CampaignPage));


/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_ga__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_ga__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


__WEBPACK_IMPORTED_MODULE_1_react_ga__["initialize"]("UA-69603114-5", { debug:  false ? true : false });
// GoogleAnalytics.plugin.require(process.env.REACT_APP_GOOGLE_OPTIMIZE_ID!, null);
var withTracker = function (WrappedComponent, options) {
    if (options === void 0) { options = {}; }
    var trackPage = function (page) {
        __WEBPACK_IMPORTED_MODULE_1_react_ga__["set"](__assign({ page: page }, options));
        __WEBPACK_IMPORTED_MODULE_1_react_ga__["pageview"](page);
    };
    var HOC = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.componentDidMount = function () {
            var page = this.props.location.pathname;
            trackPage(page);
        };
        class_1.prototype.componentWillReceiveProps = function (nextProps) {
            var currentPage = this.props.location.pathname;
            var nextPage = nextProps.location.pathname;
            if (currentPage !== nextPage) {
                trackPage(nextPage);
            }
        };
        class_1.prototype.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrappedComponent, __assign({}, this.props));
        };
        return class_1;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
    return HOC;
};
/* harmony default export */ __webpack_exports__["a"] = (withTracker);


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__questionAPI__ = __webpack_require__(615);


var questionActions = {
    getQuestions: function () {
        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1__questionAPI__["a" /* default */].getQuestions()
                .then(function (questions) {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["a" /* default */].FETCH_QUESTION_SUCCESS, questions: questions });
            });
        };
    },
};
/* harmony default export */ __webpack_exports__["a"] = (questionActions);


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var apiUrl = "https://www.insuredbymosaic.ca/api";
var questionAPI = {
    getQuestions: function () {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl + "/questions")
            .then(function (response) { return response.data; });
    },
};
/* harmony default export */ __webpack_exports__["a"] = (questionAPI);


/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
// tslint:disable:no-console
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the 'N+1' visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function register() {
    if ("production" === 'production' && 'serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        var publicUrl = new URL("", window.location.toString());
        if (publicUrl.origin !== window.location.origin) {
            // Our service worker won't work if PUBLIC_URL is on a different origin
            // from what our page is served on. This might happen if a CDN is used to
            // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
            return;
        }
        window.addEventListener('load', function () {
            var swUrl = "" + "/service-worker.js";
            if (!isLocalhost) {
                // Is not local host. Just register service worker
                registerValidSW(swUrl);
            }
            else {
                // This is running on localhost. Lets check if a service worker still exists or not.
                checkValidServiceWorker(swUrl);
            }
        });
    }
}
function registerValidSW(swUrl) {
    navigator.serviceWorker
        .register(swUrl)
        .then(function (registration) {
        registration.onupdatefound = function () {
            var installingWorker = registration.installing;
            if (installingWorker) {
                installingWorker.onstatechange = function () {
                    if (installingWorker.state === 'installed') {
                        if (navigator.serviceWorker.controller) {
                            // At this point, the old content will have been purged and
                            // the fresh content will have been added to the cache.
                            // It's the perfect time to display a 'New content is
                            // available; please refresh.' message in your web app.
                            console.log('New content is available; please refresh.');
                        }
                        else {
                            // At this point, everything has been precached.
                            // It's the perfect time to display a
                            // 'Content is cached for offline use.' message.
                            console.log('Content is cached for offline use.');
                        }
                    }
                };
            }
        };
    })
        .catch(function (error) {
        console.error('Error during service worker registration:', error);
    });
}
function checkValidServiceWorker(swUrl) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl)
        .then(function (response) {
        // Ensure service worker exists, and that we really are getting a JS file.
        if (response.status === 404 ||
            response.headers.get('content-type').indexOf('javascript') === -1) {
            // No service worker found. Probably a different app. Reload the page.
            navigator.serviceWorker.ready.then(function (registration) {
                registration.unregister().then(function () {
                    window.location.reload();
                });
            });
        }
        else {
            // Service worker found. Proceed as normal.
            registerValidSW(swUrl);
        }
    })
        .catch(function () {
        console.log('No internet connection found. App is running in offline mode.');
    });
}
function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(function (registration) {
            registration.unregister();
        });
    }
}


/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.2ac8e24c.js